(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea7a1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea7a1"] = parcelRequire;
}
parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $7dd1ddf6834435ca$export$5a759dc7a1cfb72a; }, function (v) { return $7dd1ddf6834435ca$export$5a759dc7a1cfb72a = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRequire.register("kSiIs", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.33
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.33", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /yabrowser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                // Ordered by popularity
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    "Mac OS"
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    "Chromium OS"
                ],
                VERSION
            ],
            [
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _ua = ua || (typeof window1 !== UNDEF_TYPE && window1.navigator && window1.navigator.userAgent ? window1.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});


const $fcd1c60f8fc0ad60$export$5fc3fe49cf93aaa9 = "c681bf9d7a6e1a6fdce9f826a09437705c51dbeb";
const $fcd1c60f8fc0ad60$export$ee5b30255ab7b6db = "https://apps.apple.com/us/app/rnib-eyeware/id6621244084";
const $fcd1c60f8fc0ad60$export$8010d791a4b24240 = "https://play.google.com/store/apps/details?id=com.rnibcharity.eyeware2";


const $4862ecea332fa5ed$var$inGameUI = document.querySelector(".ui");
const $4862ecea332fa5ed$var$externalLinkConfirmButton = document?.querySelector(".external-site-confirm-button");
const $4862ecea332fa5ed$var$homepageElement = $4862ecea332fa5ed$var$inGameUI?.querySelector("#homepage");
const $4862ecea332fa5ed$var$main = $4862ecea332fa5ed$var$inGameUI?.querySelector("#main");
const $4862ecea332fa5ed$var$eyeConditionsContainer = $4862ecea332fa5ed$var$main?.querySelector(".eye-conditions-container");
const $4862ecea332fa5ed$var$selectEyeConditionButton = $4862ecea332fa5ed$var$homepageElement?.querySelector(".select-eye-condition");
const $4862ecea332fa5ed$var$findOutMoreButton = $4862ecea332fa5ed$var$homepageElement?.querySelector("#find-out-more-button");
const $4862ecea332fa5ed$var$surveyButton = $4862ecea332fa5ed$var$homepageElement?.querySelector(".survey");
const $4862ecea332fa5ed$var$appleButton = $4862ecea332fa5ed$var$homepageElement?.querySelector(".apple_store_button");
const $4862ecea332fa5ed$var$googleButton = $4862ecea332fa5ed$var$homepageElement?.querySelector(".google_play_button");
const $4862ecea332fa5ed$var$donateButton = $4862ecea332fa5ed$var$homepageElement?.querySelector("#donate-button");
const $4862ecea332fa5ed$var$homeButton = $4862ecea332fa5ed$var$main?.querySelector("#main-ui-home-button");
const $4862ecea332fa5ed$var$externalSite = document?.querySelector("#external-site");
const $4862ecea332fa5ed$var$homeButtonContainer = document?.querySelector(".home__button-container");
const $4862ecea332fa5ed$var$ui = document?.querySelector(".ui");
const $4862ecea332fa5ed$export$74ba1212fd768fa5 = ()=>{
    $4862ecea332fa5ed$var$selectEyeConditionButton?.addEventListener("click", ()=>{
        if ($4862ecea332fa5ed$var$homeButtonContainer != null) $4862ecea332fa5ed$var$homeButtonContainer.classList.add("alignStart");
        $4862ecea332fa5ed$var$main?.classList.remove("space-between");
        $4862ecea332fa5ed$var$eyeConditionsContainer?.classList.remove("hidden");
        $4862ecea332fa5ed$var$homeButton?.classList.remove("hidden");
        $4862ecea332fa5ed$var$homepageElement?.classList.remove("active");
        $4862ecea332fa5ed$var$main?.classList.add("active");
    });
    $4862ecea332fa5ed$var$findOutMoreButton?.addEventListener("click", ()=>{
        $4862ecea332fa5ed$var$externalLinkConfirmButton?.setAttribute("data-href", "https://www.rnib.org.uk/about-us/");
        $4862ecea332fa5ed$var$externalLinkConfirmButton.id = "external-site-confirm-find-more";
        $4862ecea332fa5ed$var$externalSite.style.display = "flex";
        $4862ecea332fa5ed$var$ui.style.display = "none";
    });
    $4862ecea332fa5ed$var$surveyButton?.addEventListener("click", ()=>{
        $4862ecea332fa5ed$var$externalLinkConfirmButton?.setAttribute("data-href", "https://forms.office.com/e/9KHusTbN15");
        $4862ecea332fa5ed$var$externalLinkConfirmButton.id = "external-site-confirm-survey";
        $4862ecea332fa5ed$var$externalSite.style.display = "flex";
        $4862ecea332fa5ed$var$ui.style.display = "none";
    });
    $4862ecea332fa5ed$var$appleButton?.addEventListener("click", ()=>{
        $4862ecea332fa5ed$var$externalLinkConfirmButton?.setAttribute("data-href", (0, $fcd1c60f8fc0ad60$export$ee5b30255ab7b6db));
        $4862ecea332fa5ed$var$externalLinkConfirmButton.id = "external-site-confirm-apple";
        $4862ecea332fa5ed$var$ui.style.display = "none";
        $4862ecea332fa5ed$var$externalSite.style.display = "flex";
    });
    $4862ecea332fa5ed$var$googleButton?.addEventListener("click", ()=>{
        $4862ecea332fa5ed$var$externalLinkConfirmButton?.setAttribute("data-href", (0, $fcd1c60f8fc0ad60$export$8010d791a4b24240));
        $4862ecea332fa5ed$var$externalLinkConfirmButton.id = "external-site-confirm-android";
        $4862ecea332fa5ed$var$ui.style.display = "none";
        $4862ecea332fa5ed$var$externalSite.style.display = "flex";
    });
    $4862ecea332fa5ed$var$donateButton?.addEventListener("click", ()=>{
        $4862ecea332fa5ed$var$externalLinkConfirmButton?.setAttribute("data-href", "https://www.rnib.org.uk/get-involved/donate/");
        $4862ecea332fa5ed$var$externalLinkConfirmButton.id = "external-site-confirm-donate";
        $4862ecea332fa5ed$var$ui.style.display = "none";
        $4862ecea332fa5ed$var$externalSite.style.display = "flex";
    });
};
var $4862ecea332fa5ed$export$2e2bcd8739ae039 = $4862ecea332fa5ed$export$74ba1212fd768fa5;


var $a3048f9fc66af22b$exports = {};
$a3048f9fc66af22b$exports = JSON.parse('{"eye-conditions":[{"tagName":"20/20 Vision","name":"none","id":0,"desc":"","scaleType":"sliding","hidden":false},{"tagName":"Age Related Macular degeneration - wet","name":"armd-wet","id":1,"desc":"Age-related macular degeneration (AMD) affects a tiny part of the retina at the back of your eye, called the macula.  Although this condition doesn’t cause total loss of vision, it  can cause issues with central, detailed vision. AMD is the leading cause of sight loss for over 65s.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/age-related-macular-degeneration-amd/"},{"tagName":"Age Related Macular degeneration - dry","name":"armd-dry","id":2,"desc":"Age-related macular degeneration (AMD) affects a tiny part of the retina at the back of your eye, called the macula.  Although this condition doesn’t cause total loss of vision, it  can cause issues with central, detailed vision.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/age-related-macular-degeneration-amd/"},{"tagName":"Retinitis pigmentosa","name":"retinitis-pigmentosa","id":3,"desc":"Retinitis Pigmentosa (RP) denotes a group of progressive eye diseases that affect the retina.Over time, people with RP will gradually lose their peripheral vision causing a tunnel vision effect.  As time progresses RP will also affect central vision.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/retinitis-pigmentosa/"},{"tagName":"Glaucoma","name":"glaucoma","id":4,"desc":"Glaucoma is a common eye condition where the optic nerve, which connects the eye to the brain, becomes damaged usually due to high pressure within the eye. Initially affecting peripheral vision, it eventually progresses to central vision and can result in total loss of vision.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/glaucoma/"},{"tagName":"Diabetic retinopathy","name":"diabetic-retinopathy","id":5,"desc":"Diabetic retinopathy is an eye condition that can cause vision loss and blindness in people who have diabetes. It affects blood vessels in the retina and can affect peripheral vision as it progresses.  It is the second most common cause of sight loss for working age people.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/retinitis-pigmentosa/"},{"tagName":"Hemianopia","name":"hemianopia","id":6,"desc":"Hemianopia is most commonly caused by stroke.The most common form of this is a loss of half of one\'s visual field in both eyes, although strokes can cause differing loss of vision as well as difficulty in visual processing.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/stroke-related-eye-conditions/"},{"tagName":"Cataracts","name":"cataracts","desc":"Cataracts occur when the lens inside your eye becomes cloudy. Naturally it is crystal clear but as you get older it becomes less clear and often becomes slightly brown in colour. This results in blurring, haze/ scattered light and dazzle in bright light.  It is very common as we get older but can be treated with surgery for the majority of cases.","id":7,"scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/cataracts/"},{"tagName":"Colour Blindness","name":"color-blindness","id":8,"desc":"Colour vision deficiency - can be inhertied (most common) or acquired (caused by another condition/medication). Inherited CVD - most common is red/green deficiency, does not get better/worse with age. Most forms do not affect eye\'s ability to see detail. Usually colour blindness is inherited and not progressive. Some people acquire colour vision loss due to medication or eye conditions. People with macular conditions often have acquired loss of colour vision. ","scaleType":"options","hidden":false,"options":[{"name":"Deuteranopia","tagName":"deuteranopia","desc":"Deuteranopia is colour blindness resulting from insensitivity to green light, causing confusion of greens, reds, and yellows."},{"name":"Protanopia","tagName":"protanopia","desc":"Protanopia is colour blindness resulting from insensitivity to red light, causing confusion of greens, reds, and yellows. It is hereditary, and is the most common form of colour blindness"},{"name":"Tritanopia","tagName":"tritanopia","desc":"Tritanopia is a rare form of colour blindness resulting from insensitivity to blue light, causing confusion of greens and blues."},{"name":"Monochromacy (Achromatopsia)","tagName":"achromatopsia","desc":"Monochromacy is a lack of all colour detecting cells in the eye."}]}]}');


const $85a5f587c2a7b3b2$export$2c10387ab05da0ac = new Event("rnib:focuson", {
    bubbles: true,
    cancelable: true
});
const $85a5f587c2a7b3b2$export$e6bc4b45455ea7e7 = new Event("rnib:focusout", {
    bubbles: true,
    cancelable: true
});
const $85a5f587c2a7b3b2$export$957026111206bdf8 = new Event("rnib:click", {
    bubbles: true,
    cancelable: true
});
const $85a5f587c2a7b3b2$export$9a8f25c467234dda = new Event("rnib:refocus", {
    bubbles: true,
    cancelable: true
});
const $85a5f587c2a7b3b2$export$68d5264cfe134b94 = ()=>{
    const event = new Event("rnib:end-task", {
        bubbles: true,
        cancelable: true
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$c0498f458a5d334d = ()=>{
    const event = new Event("rnib:continue-task", {
        bubbles: true,
        cancelable: true
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$c5c93d23325f795e = (eyeCondition, severityLevel)=>{
    const event = new CustomEvent("rnib:condition", {
        detail: {
            condition: eyeCondition,
            severity: severityLevel
        }
    });
    document?.dispatchEvent(event);
};



const $6ecf5ecb3c0f2fcb$var$appleButton = document?.querySelector(".download__apple_store_button");
const $6ecf5ecb3c0f2fcb$var$googleButton = document?.querySelector(".download__google_play_button");
const $6ecf5ecb3c0f2fcb$var$externalLinkConfirmButton = document?.querySelector(".external-site-confirm-button");
const $6ecf5ecb3c0f2fcb$var$externalSite = document?.querySelector("#external-site");
const $6ecf5ecb3c0f2fcb$var$ui = document?.querySelector(".ui");
const $6ecf5ecb3c0f2fcb$var$downloadPage = document?.querySelector(".download");
const $6ecf5ecb3c0f2fcb$var$closeButton = document?.querySelector(".download__close-button");
function $6ecf5ecb3c0f2fcb$export$d46da6602b462e4a() {
    $6ecf5ecb3c0f2fcb$var$downloadPage.style.display = "flex";
    $6ecf5ecb3c0f2fcb$var$ui.style.display = "none";
}
$6ecf5ecb3c0f2fcb$var$closeButton?.addEventListener("click", ()=>{
    $6ecf5ecb3c0f2fcb$var$downloadPage.style.display = "none";
    $6ecf5ecb3c0f2fcb$var$ui.style.display = "flex";
});
$6ecf5ecb3c0f2fcb$var$appleButton?.addEventListener("click", ()=>{
    $6ecf5ecb3c0f2fcb$var$externalLinkConfirmButton?.setAttribute("data-href", (0, $fcd1c60f8fc0ad60$export$ee5b30255ab7b6db));
    $6ecf5ecb3c0f2fcb$var$downloadPage.style.display = "none";
    $6ecf5ecb3c0f2fcb$var$externalSite.style.display = "flex";
});
$6ecf5ecb3c0f2fcb$var$googleButton?.addEventListener("click", ()=>{
    $6ecf5ecb3c0f2fcb$var$externalLinkConfirmButton?.setAttribute("data-href", (0, $fcd1c60f8fc0ad60$export$8010d791a4b24240));
    $6ecf5ecb3c0f2fcb$var$downloadPage.style.display = "none";
    $6ecf5ecb3c0f2fcb$var$externalSite.style.display = "flex";
});


const $55e0309f06c0860d$var$eyeConditions = (0, (/*@__PURE__*/$parcel$interopDefault($a3048f9fc66af22b$exports)))["eye-conditions"];
const $55e0309f06c0860d$var$inGameUI = document.querySelector(".ui");
const $55e0309f06c0860d$var$homepageElement = $55e0309f06c0860d$var$inGameUI?.querySelector("#homepage");
const $55e0309f06c0860d$var$main = $55e0309f06c0860d$var$inGameUI?.querySelector("#main");
const $55e0309f06c0860d$var$eyeConditionsContainer = $55e0309f06c0860d$var$main?.querySelector(".eye-conditions-container");
const $55e0309f06c0860d$var$severityScaleContainer = $55e0309f06c0860d$var$main?.querySelector(".severity-scale-container");
const $55e0309f06c0860d$var$severityScaleHeader = $55e0309f06c0860d$var$severityScaleContainer?.querySelector(".severity-scale__header");
const $55e0309f06c0860d$var$severityScaleFooter = $55e0309f06c0860d$var$severityScaleContainer?.querySelector(".severity-scale__footer");
const $55e0309f06c0860d$var$floatingSeverityScaleButtons = $55e0309f06c0860d$var$inGameUI?.querySelectorAll("#floating-severity-scale button");
const $55e0309f06c0860d$var$colorBlindnessGrid = $55e0309f06c0860d$var$severityScaleContainer?.querySelector(".color-blindness-grid");
const $55e0309f06c0860d$var$severityScale = $55e0309f06c0860d$var$severityScaleContainer?.querySelector(".severity-scale");
const $55e0309f06c0860d$var$severityScaleButtons = $55e0309f06c0860d$var$severityScale?.querySelectorAll("button");
const $55e0309f06c0860d$var$floatingSeverityScale = $55e0309f06c0860d$var$inGameUI?.querySelector("#floating-severity-scale");
const $55e0309f06c0860d$var$eyeConditionsGrid = $55e0309f06c0860d$var$main?.querySelector(".eye-conditions-grid");
const $55e0309f06c0860d$var$toolTip = $55e0309f06c0860d$var$main?.querySelector("#tooltip-main-button");
const $55e0309f06c0860d$var$toolTipExpandButton = $55e0309f06c0860d$var$main?.querySelector("#tooltip-expand-button");
const $55e0309f06c0860d$var$rnibInformation = $55e0309f06c0860d$var$main?.querySelector(".rnib-expanded-info");
const $55e0309f06c0860d$var$rnibInformationInner = $55e0309f06c0860d$var$main?.querySelector(".rnib-expanded-info span");
const $55e0309f06c0860d$var$severityScaleToolTip = $55e0309f06c0860d$var$main?.querySelector("#severity-scale-tooltip");
const $55e0309f06c0860d$var$homeButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-home-button");
const $55e0309f06c0860d$var$collapseButton = $55e0309f06c0860d$var$main?.querySelector("#tooltip-collapse-button");
const $55e0309f06c0860d$var$eyeConditionButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-eye-condition-button");
const $55e0309f06c0860d$var$prevButton = $55e0309f06c0860d$var$main?.querySelector(".navigation--arrow.left");
const $55e0309f06c0860d$var$nextButton = $55e0309f06c0860d$var$main?.querySelector(".navigation--arrow.right");
const $55e0309f06c0860d$var$homeButtonContainer = document?.querySelector(".home__button-container");
let $55e0309f06c0860d$var$buttonPages = [];
let $55e0309f06c0860d$var$currentPage = 0;
let $55e0309f06c0860d$var$conditionsViewed = 0;
let $55e0309f06c0860d$var$downloadPageOpened = false;
/* Functions */ const $55e0309f06c0860d$var$clearButtonContainer = ()=>{
    $55e0309f06c0860d$var$homeButton?.classList.add("hidden");
    $55e0309f06c0860d$var$eyeConditionButton?.classList.add("hidden");
    $55e0309f06c0860d$var$floatingSeverityScale?.classList.remove("ar-mode");
};
const $55e0309f06c0860d$var$updateSeverityScalesButtonsIds = (condition)=>{
    $55e0309f06c0860d$var$severityScaleButtons.forEach((button)=>button.id = `${condition}-severity-level-${button.dataset.severity}`);
    $55e0309f06c0860d$var$floatingSeverityScaleButtons.forEach((button)=>button.id = `${condition}-severity-level-${button.dataset.severity}`);
};
const $55e0309f06c0860d$var$generateEyeConditionButtons = async ()=>{
    if (!$55e0309f06c0860d$var$eyeConditionsGrid) return;
    $55e0309f06c0860d$var$eyeConditions?.forEach((eyeCondition, index)=>{
        const buttonElement = document.createElement("button");
        buttonElement.ariaLabel = eyeCondition.tagName + ", scrollable grid" + (index + 1) + "of " + $55e0309f06c0860d$var$eyeConditions.length;
        buttonElement.setAttribute("aria-describedby", "tooltip-main-button");
        buttonElement.setAttribute("data-type", eyeCondition.name);
        buttonElement.setAttribute("data-id", `${index}`);
        buttonElement.classList.add("cta");
        if (eyeCondition.hidden) buttonElement.classList.add("hidden");
        buttonElement.innerHTML = eyeCondition.tagName;
        buttonElement?.addEventListener("click", ()=>{
            if ($55e0309f06c0860d$var$homeButtonContainer != null) $55e0309f06c0860d$var$homeButtonContainer.classList.remove("alignStart");
            if ($55e0309f06c0860d$var$severityScaleToolTip) $55e0309f06c0860d$var$severityScaleToolTip.innerHTML = eyeCondition.tagName.toUpperCase();
            if (!$55e0309f06c0860d$var$downloadPageOpened) $55e0309f06c0860d$var$conditionsViewed++;
            const eyeConditionType = buttonElement.dataset.type;
            if (!eyeConditionType || !$55e0309f06c0860d$var$toolTip) return;
            $55e0309f06c0860d$var$eyeConditionButton?.classList.remove("hidden");
            $55e0309f06c0860d$var$updateSeverityScalesButtonsIds(eyeConditionType);
            if (eyeConditionType === "color-blindness") {
                $55e0309f06c0860d$var$eyeConditionsContainer?.classList.add("hidden");
                $55e0309f06c0860d$var$colorBlindnessGrid?.classList.remove("hidden");
                $55e0309f06c0860d$var$severityScale?.classList.add("hidden");
                $55e0309f06c0860d$var$severityScaleHeader?.classList.add("hidden");
                $55e0309f06c0860d$var$severityScaleFooter?.classList.add("hidden");
                $55e0309f06c0860d$var$severityScale.removeAttribute("data-eye-condition");
                $55e0309f06c0860d$var$severityScaleContainer?.classList.remove("hidden");
                $55e0309f06c0860d$var$toolTip?.classList.add("unclickable");
                $55e0309f06c0860d$var$toolTip?.classList.add("hidden");
            } else if (eyeConditionType === "none" || eyeConditionType === "hemianopia") {
                (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(eyeConditionType, 3);
                $55e0309f06c0860d$var$eyeConditionsContainer?.classList.add("hidden");
                $55e0309f06c0860d$var$colorBlindnessGrid?.classList.add("hidden");
                $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
                $55e0309f06c0860d$var$main?.classList.add("space-between");
                //floatingSeverityScale?.classList.add("ar-mode");
                if (eyeConditionType === "none") {
                    $55e0309f06c0860d$var$toolTip.innerHTML = "20/20 VISION";
                    $55e0309f06c0860d$var$toolTip.classList.add("unclickable");
                } else $55e0309f06c0860d$var$toolTip?.classList.remove("unclickable");
            } else {
                $55e0309f06c0860d$var$eyeConditionsContainer?.classList.add("hidden");
                $55e0309f06c0860d$var$colorBlindnessGrid?.classList.add("hidden");
                $55e0309f06c0860d$var$severityScale?.classList.remove("hidden");
                $55e0309f06c0860d$var$severityScaleContainer?.classList.remove("hidden");
                $55e0309f06c0860d$var$severityScaleHeader?.classList.remove("hidden");
                $55e0309f06c0860d$var$severityScaleFooter?.classList.remove("hidden");
                $55e0309f06c0860d$var$severityScale.setAttribute("data-eye-condition", eyeConditionType);
                $55e0309f06c0860d$var$toolTip?.classList.add("hidden");
                $55e0309f06c0860d$var$toolTip?.classList.remove("unclickable");
            }
        });
        $55e0309f06c0860d$var$eyeConditionsGrid?.appendChild(buttonElement);
    });
    const colorBlindnessList = $55e0309f06c0860d$var$eyeConditions.find((object)=>object.tagName === "Colour Blindness");
    const colorBlindnessOptions = colorBlindnessList?.options;
    if (colorBlindnessOptions) colorBlindnessOptions.forEach((option, index)=>{
        const buttonElement = document.createElement("button");
        buttonElement.ariaLabel = option.tagName + ", grid" + (index + 1) + "of " + colorBlindnessOptions.length;
        buttonElement.setAttribute("aria-describedby", "severity-scale-tooltip");
        buttonElement.setAttribute("data-type", option.tagName);
        buttonElement.setAttribute("data-info", option.desc);
        buttonElement.setAttribute("data-id", `${index}`);
        buttonElement.classList.add("cta");
        buttonElement.innerHTML = option.tagName;
        buttonElement.addEventListener("click", ()=>{
            if ($55e0309f06c0860d$var$toolTip && $55e0309f06c0860d$var$rnibInformationInner) {
                $55e0309f06c0860d$var$resetTooltip();
                //floatingSeverityScale?.classList.add("ar-mode");
                $55e0309f06c0860d$var$toolTip.classList.remove("unclickable");
                $55e0309f06c0860d$var$toolTip.innerHTML = option.name;
                $55e0309f06c0860d$var$rnibInformationInner.innerHTML = option.desc;
                $55e0309f06c0860d$var$toolTip.classList.remove("hidden");
            }
            $55e0309f06c0860d$var$main?.classList.add("space-between");
            $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
            (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(option.tagName, 5);
        });
        $55e0309f06c0860d$var$colorBlindnessGrid?.appendChild(buttonElement);
    });
    const pagesLength = Math.ceil($55e0309f06c0860d$var$eyeConditions.length / 6);
    if (pagesLength < 2) return $55e0309f06c0860d$var$eyeConditionsGrid;
    // Pagination
    for(let j = 0; j < pagesLength; j++){
        const page = document.createElement("div");
        for(let i = 0; i < 6; i++)if ($55e0309f06c0860d$var$eyeConditionsGrid.children[0]) page.appendChild($55e0309f06c0860d$var$eyeConditionsGrid.children[0]);
        $55e0309f06c0860d$var$buttonPages.push(page);
    }
    $55e0309f06c0860d$var$buttonPages.forEach((page)=>{
        $55e0309f06c0860d$var$eyeConditionsGrid.appendChild(page);
    });
    return $55e0309f06c0860d$var$eyeConditionsGrid;
};
const $55e0309f06c0860d$var$resetTooltip = ()=>{
    if (!$55e0309f06c0860d$var$toolTip || !$55e0309f06c0860d$var$rnibInformation || !$55e0309f06c0860d$var$rnibInformationInner) return;
    // Reset Tooltip
    $55e0309f06c0860d$var$toolTip.classList.remove("hidden");
    $55e0309f06c0860d$var$toolTip.classList.add("unclickable");
    $55e0309f06c0860d$var$toolTip.innerHTML = "Scroll down for more<br/>eye conditions";
    $55e0309f06c0860d$var$rnibInformation.classList.add("hidden");
    $55e0309f06c0860d$var$toolTip.classList.remove("expanded-info");
    $55e0309f06c0860d$var$rnibInformationInner.innerHTML = "";
    $55e0309f06c0860d$var$main?.classList.remove("space-between");
};
const $55e0309f06c0860d$export$861edd1ccea2f746 = ()=>{
    $55e0309f06c0860d$var$generateEyeConditionButtons().then(()=>{
        $55e0309f06c0860d$var$floatingSeverityScaleButtons?.forEach((severityScaleButton)=>{
            severityScaleButton?.addEventListener("click", ()=>{
                $55e0309f06c0860d$var$floatingSeverityScaleButtons?.forEach((severityScaleButton)=>{
                    severityScaleButton.classList.remove("selected");
                    if (severityScaleButton.ariaLabel) severityScaleButton.ariaLabel = severityScaleButton.ariaLabel.replace("; selected", "");
                });
                severityScaleButton.classList.add("selected");
                severityScaleButton.ariaLabel += "; selected";
                const eyeConditionData = $55e0309f06c0860d$var$severityScale?.dataset.eyeCondition;
                const severityLevelData = Number(severityScaleButton.dataset.severity);
                if (!eyeConditionData || !severityLevelData) return;
                (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(eyeConditionData, severityLevelData);
            });
        });
        $55e0309f06c0860d$var$severityScaleButtons?.forEach((severityScaleButton)=>{
            severityScaleButton?.addEventListener("click", ()=>{
                const eyeConditionData = $55e0309f06c0860d$var$severityScale?.dataset.eyeCondition;
                const severityLevelData = Number(severityScaleButton.dataset.severity);
                $55e0309f06c0860d$var$floatingSeverityScaleButtons?.forEach((severityScaleButton, index)=>{
                    severityScaleButton.classList.remove("selected");
                    if (severityScaleButton.ariaLabel) severityScaleButton.ariaLabel = severityScaleButton.ariaLabel.replace("; selected", "");
                    if (index == severityLevelData - 1) {
                        severityScaleButton.classList.add("selected");
                        severityScaleButton.ariaLabel += "; selected";
                    }
                });
                if (!eyeConditionData || !severityLevelData) return;
                $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
                $55e0309f06c0860d$var$main?.classList.add("space-between");
                (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(eyeConditionData, severityLevelData);
                $55e0309f06c0860d$var$floatingSeverityScale?.classList.add("ar-mode");
                $55e0309f06c0860d$var$severityScaleHeader?.focus();
                $55e0309f06c0860d$var$toolTip?.classList.remove("hidden");
            });
        });
        if ($55e0309f06c0860d$var$inGameUI && $55e0309f06c0860d$var$prevButton && $55e0309f06c0860d$var$nextButton) setTimeout(()=>document.querySelectorAll(".eye-conditions-grid > div").forEach((page)=>{
                page.style.width = `${$55e0309f06c0860d$var$inGameUI?.clientWidth - 80}px`;
            }), 300);
    });
    window.addEventListener("resize", ()=>{
        if ($55e0309f06c0860d$var$inGameUI && $55e0309f06c0860d$var$prevButton && $55e0309f06c0860d$var$nextButton) setTimeout(()=>$55e0309f06c0860d$var$buttonPages.forEach((page)=>{
                page.style.width = `${$55e0309f06c0860d$var$inGameUI?.clientWidth - 80}px`;
            }), 300);
    });
    $55e0309f06c0860d$var$homeButton?.addEventListener("click", ()=>{
        if (!$55e0309f06c0860d$var$downloadPageOpened) {
            if ($55e0309f06c0860d$var$conditionsViewed > 1) {
                (0, $6ecf5ecb3c0f2fcb$export$d46da6602b462e4a)();
                $55e0309f06c0860d$var$downloadPageOpened = true;
            }
        }
        if ($55e0309f06c0860d$var$homeButtonContainer != null) $55e0309f06c0860d$var$homeButtonContainer.classList.add("alignStart");
        $55e0309f06c0860d$var$toolTip?.classList.remove("hidden");
        $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
        $55e0309f06c0860d$var$eyeConditionsContainer?.classList.remove("hidden");
        $55e0309f06c0860d$var$clearButtonContainer();
        $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$resetTooltip();
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        $55e0309f06c0860d$var$homepageElement?.classList.add("active");
        $55e0309f06c0860d$var$main?.classList.remove("active");
    });
    $55e0309f06c0860d$var$prevButton?.addEventListener("click", ()=>{
        if ($55e0309f06c0860d$var$currentPage > 0) {
            $55e0309f06c0860d$var$currentPage--;
            $55e0309f06c0860d$var$eyeConditionsGrid.scrollTo({
                //behavior: orientation === "portrait" ? "smooth" : "auto",
                behavior: "smooth",
                left: $55e0309f06c0860d$var$buttonPages[$55e0309f06c0860d$var$currentPage].clientWidth * $55e0309f06c0860d$var$currentPage
            });
        }
    // onPageUpdate();
    });
    $55e0309f06c0860d$var$nextButton?.addEventListener("click", ()=>{
        if ($55e0309f06c0860d$var$currentPage + 1 < $55e0309f06c0860d$var$buttonPages.length) {
            $55e0309f06c0860d$var$currentPage++;
            $55e0309f06c0860d$var$eyeConditionsGrid.scrollTo({
                behavior: "smooth",
                left: $55e0309f06c0860d$var$buttonPages[$55e0309f06c0860d$var$currentPage].clientWidth * $55e0309f06c0860d$var$currentPage
            });
        }
    });
    $55e0309f06c0860d$var$eyeConditionButton?.addEventListener("click", ()=>{
        if ($55e0309f06c0860d$var$homeButtonContainer != null) $55e0309f06c0860d$var$homeButtonContainer.classList.add("alignStart");
        if (!$55e0309f06c0860d$var$downloadPageOpened) {
            if ($55e0309f06c0860d$var$conditionsViewed > 1) {
                (0, $6ecf5ecb3c0f2fcb$export$d46da6602b462e4a)();
                $55e0309f06c0860d$var$downloadPageOpened = true;
            }
        }
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        $55e0309f06c0860d$var$clearButtonContainer();
        $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$eyeConditionsContainer?.classList.remove("hidden");
        $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
        $55e0309f06c0860d$var$resetTooltip();
    });
    $55e0309f06c0860d$var$collapseButton?.addEventListener("click", ()=>{
        $55e0309f06c0860d$var$toolTip?.classList.remove("expanded-info");
        $55e0309f06c0860d$var$rnibInformation?.classList.add("hidden");
        if (!$55e0309f06c0860d$var$main.classList.contains("space-between")) $55e0309f06c0860d$var$severityScaleContainer?.classList.remove("hidden");
    });
    $55e0309f06c0860d$var$toolTip?.addEventListener("click", ()=>{
        toggleTooltip();
    });
    $55e0309f06c0860d$var$toolTipExpandButton?.addEventListener("click", ()=>{
        toggleTooltip();
    });
    const toggleTooltip = ()=>{
        if (!$55e0309f06c0860d$var$rnibInformation || !$55e0309f06c0860d$var$toolTip) return;
        if (!$55e0309f06c0860d$var$toolTip.classList.contains("unclickable")) {
            if ($55e0309f06c0860d$var$toolTip.classList.contains("expanded-info")) {
                $55e0309f06c0860d$var$toolTip.classList.remove("expanded-info");
                $55e0309f06c0860d$var$rnibInformation.classList.add("hidden");
            // severityScaleContainer?.classList.remove("hidden");
            } else {
                $55e0309f06c0860d$var$toolTip.classList.add("expanded-info");
                $55e0309f06c0860d$var$rnibInformation.classList.remove("hidden");
            // severityScaleContainer?.classList.add("hidden");
            }
        }
    };
    document.addEventListener("rnib:condition", (e)=>{
        const currenteyecondition = e.detail.condition;
        if (!currenteyecondition || currenteyecondition === "none") return;
        const givenEyeCondition = (0, (/*@__PURE__*/$parcel$interopDefault($a3048f9fc66af22b$exports)))["eye-conditions"].find((eyeconditiondata)=>eyeconditiondata.name === currenteyecondition);
        if ($55e0309f06c0860d$var$rnibInformationInner && $55e0309f06c0860d$var$toolTip && currenteyecondition && givenEyeCondition && $55e0309f06c0860d$var$severityScaleToolTip) {
            $55e0309f06c0860d$var$toolTip.innerHTML = givenEyeCondition.tagName.toUpperCase();
            $55e0309f06c0860d$var$severityScaleToolTip.innerHTML = givenEyeCondition.tagName.toUpperCase();
            $55e0309f06c0860d$var$rnibInformationInner.innerHTML = givenEyeCondition.desc;
            $55e0309f06c0860d$var$toolTip.dispatchEvent((0, $85a5f587c2a7b3b2$export$957026111206bdf8));
        }
    });
};
var $55e0309f06c0860d$export$2e2bcd8739ae039 = $55e0309f06c0860d$export$861edd1ccea2f746;


const $d6688360c12ddbaa$var$externalPage = document?.querySelector("#external-site");
const $d6688360c12ddbaa$var$ui = document?.querySelector(".ui");
const $d6688360c12ddbaa$var$backButton = document?.querySelector("#external-site-back-button");
const $d6688360c12ddbaa$var$confirmButton = document?.querySelector(".external-site-confirm-button");
const $d6688360c12ddbaa$var$downloadPage = document?.querySelector(".download");
let $d6688360c12ddbaa$export$385972cd6b54c3e1 = "homepage";
const $d6688360c12ddbaa$var$ExternalLink = ()=>{
    if (!$d6688360c12ddbaa$var$confirmButton) return;
    $d6688360c12ddbaa$var$confirmButton.addEventListener("click", ()=>{
        const currentLink = $d6688360c12ddbaa$var$confirmButton.getAttribute("data-href");
        if (currentLink) window.open(currentLink, "_blank");
        $d6688360c12ddbaa$var$confirmButton?.classList.add("active");
    });
    $d6688360c12ddbaa$var$backButton?.addEventListener("click", ()=>{
        $d6688360c12ddbaa$var$externalPage.style.display = "none";
        $d6688360c12ddbaa$var$ui.style.display = "flex";
        $d6688360c12ddbaa$var$downloadPage.style.display = "none";
        $d6688360c12ddbaa$var$ui.style.display = "flex";
    });
};
var $d6688360c12ddbaa$export$2e2bcd8739ae039 = $d6688360c12ddbaa$var$ExternalLink;


const $a642add612de9339$export$cfe22dfecf9d0243 = ()=>{
    (0, $4862ecea332fa5ed$export$2e2bcd8739ae039)();
    (0, $55e0309f06c0860d$export$2e2bcd8739ae039)();
    (0, $d6688360c12ddbaa$export$2e2bcd8739ae039)();
};
var $a642add612de9339$export$2e2bcd8739ae039 = $a642add612de9339$export$cfe22dfecf9d0243;



var $0147bee01cff6558$exports = {};

$parcel$export($0147bee01cff6558$exports, "REVISION", function () { return $0147bee01cff6558$export$3545e07a80636437; });
$parcel$export($0147bee01cff6558$exports, "MOUSE", function () { return $0147bee01cff6558$export$7177b3e430c2d7ca; });
$parcel$export($0147bee01cff6558$exports, "TOUCH", function () { return $0147bee01cff6558$export$d46bd3ead7cc759b; });
$parcel$export($0147bee01cff6558$exports, "CullFaceNone", function () { return $0147bee01cff6558$export$3237e1f2c1ea1f44; });
$parcel$export($0147bee01cff6558$exports, "CullFaceBack", function () { return $0147bee01cff6558$export$b9a7b4fc5cb15f9b; });
$parcel$export($0147bee01cff6558$exports, "CullFaceFront", function () { return $0147bee01cff6558$export$b8058bcc7037d3f3; });
$parcel$export($0147bee01cff6558$exports, "CullFaceFrontBack", function () { return $0147bee01cff6558$export$f24be24dcddeac0d; });
$parcel$export($0147bee01cff6558$exports, "BasicShadowMap", function () { return $0147bee01cff6558$export$346307dbae2b7447; });
$parcel$export($0147bee01cff6558$exports, "PCFShadowMap", function () { return $0147bee01cff6558$export$5813f879eee7cd88; });
$parcel$export($0147bee01cff6558$exports, "PCFSoftShadowMap", function () { return $0147bee01cff6558$export$a47c4b43a1be34f0; });
$parcel$export($0147bee01cff6558$exports, "VSMShadowMap", function () { return $0147bee01cff6558$export$896ae1ade6c829c4; });
$parcel$export($0147bee01cff6558$exports, "FrontSide", function () { return $0147bee01cff6558$export$2ede184fc2998901; });
$parcel$export($0147bee01cff6558$exports, "BackSide", function () { return $0147bee01cff6558$export$d9f0486e75b5ace; });
$parcel$export($0147bee01cff6558$exports, "DoubleSide", function () { return $0147bee01cff6558$export$3b296b6f144d5b03; });
$parcel$export($0147bee01cff6558$exports, "FlatShading", function () { return $0147bee01cff6558$export$a62047d29c96d8ff; });
$parcel$export($0147bee01cff6558$exports, "SmoothShading", function () { return $0147bee01cff6558$export$fadb74c06a7f490; });
$parcel$export($0147bee01cff6558$exports, "NoBlending", function () { return $0147bee01cff6558$export$63b8d6b580fc65ba; });
$parcel$export($0147bee01cff6558$exports, "NormalBlending", function () { return $0147bee01cff6558$export$5b29a26d96ee6af0; });
$parcel$export($0147bee01cff6558$exports, "AdditiveBlending", function () { return $0147bee01cff6558$export$777d8f9551c2216b; });
$parcel$export($0147bee01cff6558$exports, "SubtractiveBlending", function () { return $0147bee01cff6558$export$cdfa06f868e2e467; });
$parcel$export($0147bee01cff6558$exports, "MultiplyBlending", function () { return $0147bee01cff6558$export$4138e1c684b46a20; });
$parcel$export($0147bee01cff6558$exports, "CustomBlending", function () { return $0147bee01cff6558$export$eda4864c68df1fa2; });
$parcel$export($0147bee01cff6558$exports, "AddEquation", function () { return $0147bee01cff6558$export$20183a0484ce21a0; });
$parcel$export($0147bee01cff6558$exports, "SubtractEquation", function () { return $0147bee01cff6558$export$73e0df5177988548; });
$parcel$export($0147bee01cff6558$exports, "ReverseSubtractEquation", function () { return $0147bee01cff6558$export$28e582859cbec660; });
$parcel$export($0147bee01cff6558$exports, "MinEquation", function () { return $0147bee01cff6558$export$c8c1508da8d0600c; });
$parcel$export($0147bee01cff6558$exports, "MaxEquation", function () { return $0147bee01cff6558$export$99948c02fb51055f; });
$parcel$export($0147bee01cff6558$exports, "ZeroFactor", function () { return $0147bee01cff6558$export$2110f05edf778d3d; });
$parcel$export($0147bee01cff6558$exports, "OneFactor", function () { return $0147bee01cff6558$export$8805bad65e24940e; });
$parcel$export($0147bee01cff6558$exports, "SrcColorFactor", function () { return $0147bee01cff6558$export$7fbe15b28d28cf52; });
$parcel$export($0147bee01cff6558$exports, "OneMinusSrcColorFactor", function () { return $0147bee01cff6558$export$947829af9f2c17f6; });
$parcel$export($0147bee01cff6558$exports, "SrcAlphaFactor", function () { return $0147bee01cff6558$export$d5773124e86cf28c; });
$parcel$export($0147bee01cff6558$exports, "OneMinusSrcAlphaFactor", function () { return $0147bee01cff6558$export$11d468cc7f19e971; });
$parcel$export($0147bee01cff6558$exports, "DstAlphaFactor", function () { return $0147bee01cff6558$export$a78aed1ca2a87192; });
$parcel$export($0147bee01cff6558$exports, "OneMinusDstAlphaFactor", function () { return $0147bee01cff6558$export$5d0fe17fd8773bac; });
$parcel$export($0147bee01cff6558$exports, "DstColorFactor", function () { return $0147bee01cff6558$export$ef5f2dd8ffac5574; });
$parcel$export($0147bee01cff6558$exports, "OneMinusDstColorFactor", function () { return $0147bee01cff6558$export$56b85b2686ab16; });
$parcel$export($0147bee01cff6558$exports, "SrcAlphaSaturateFactor", function () { return $0147bee01cff6558$export$c05e2a1fc8609506; });
$parcel$export($0147bee01cff6558$exports, "NeverDepth", function () { return $0147bee01cff6558$export$69025ce147cee220; });
$parcel$export($0147bee01cff6558$exports, "AlwaysDepth", function () { return $0147bee01cff6558$export$7182eb52ea3b3f04; });
$parcel$export($0147bee01cff6558$exports, "LessDepth", function () { return $0147bee01cff6558$export$eedccec66ab7ebe; });
$parcel$export($0147bee01cff6558$exports, "LessEqualDepth", function () { return $0147bee01cff6558$export$296f78a0b892f81a; });
$parcel$export($0147bee01cff6558$exports, "EqualDepth", function () { return $0147bee01cff6558$export$a60d398fc7b7590e; });
$parcel$export($0147bee01cff6558$exports, "GreaterEqualDepth", function () { return $0147bee01cff6558$export$7d7234c1240a1fc4; });
$parcel$export($0147bee01cff6558$exports, "GreaterDepth", function () { return $0147bee01cff6558$export$c5e2c52991f30937; });
$parcel$export($0147bee01cff6558$exports, "NotEqualDepth", function () { return $0147bee01cff6558$export$2f843afa843d8916; });
$parcel$export($0147bee01cff6558$exports, "MultiplyOperation", function () { return $0147bee01cff6558$export$e50ac29801f1774d; });
$parcel$export($0147bee01cff6558$exports, "MixOperation", function () { return $0147bee01cff6558$export$9f9d94f963c85479; });
$parcel$export($0147bee01cff6558$exports, "AddOperation", function () { return $0147bee01cff6558$export$e641dc52bc3494aa; });
$parcel$export($0147bee01cff6558$exports, "NoToneMapping", function () { return $0147bee01cff6558$export$9fcb6b4294603b2; });
$parcel$export($0147bee01cff6558$exports, "LinearToneMapping", function () { return $0147bee01cff6558$export$98f52c2a46c598ca; });
$parcel$export($0147bee01cff6558$exports, "ReinhardToneMapping", function () { return $0147bee01cff6558$export$74b25e54b3bcd548; });
$parcel$export($0147bee01cff6558$exports, "CineonToneMapping", function () { return $0147bee01cff6558$export$932b3dd283d4a366; });
$parcel$export($0147bee01cff6558$exports, "ACESFilmicToneMapping", function () { return $0147bee01cff6558$export$a0d98fe6d7e4af64; });
$parcel$export($0147bee01cff6558$exports, "CustomToneMapping", function () { return $0147bee01cff6558$export$2c7b09c1e9abfb5e; });
$parcel$export($0147bee01cff6558$exports, "UVMapping", function () { return $0147bee01cff6558$export$1beec6768cbb3d2d; });
$parcel$export($0147bee01cff6558$exports, "CubeReflectionMapping", function () { return $0147bee01cff6558$export$8759762a6477f2c4; });
$parcel$export($0147bee01cff6558$exports, "CubeRefractionMapping", function () { return $0147bee01cff6558$export$dc59f8aed047f61d; });
$parcel$export($0147bee01cff6558$exports, "EquirectangularReflectionMapping", function () { return $0147bee01cff6558$export$d64030b316d3b087; });
$parcel$export($0147bee01cff6558$exports, "EquirectangularRefractionMapping", function () { return $0147bee01cff6558$export$ee99d97d46898098; });
$parcel$export($0147bee01cff6558$exports, "CubeUVReflectionMapping", function () { return $0147bee01cff6558$export$dbf3e70ff37af79; });
$parcel$export($0147bee01cff6558$exports, "CubeUVRefractionMapping", function () { return $0147bee01cff6558$export$76a9f4355364345c; });
$parcel$export($0147bee01cff6558$exports, "RepeatWrapping", function () { return $0147bee01cff6558$export$533346c8e8dac0f5; });
$parcel$export($0147bee01cff6558$exports, "ClampToEdgeWrapping", function () { return $0147bee01cff6558$export$9d9334239a5a5e06; });
$parcel$export($0147bee01cff6558$exports, "MirroredRepeatWrapping", function () { return $0147bee01cff6558$export$c7e7c00b14f51a4f; });
$parcel$export($0147bee01cff6558$exports, "NearestFilter", function () { return $0147bee01cff6558$export$727aa5ec3fe39bf0; });
$parcel$export($0147bee01cff6558$exports, "NearestMipmapNearestFilter", function () { return $0147bee01cff6558$export$d129e38cf6feaa8c; });
$parcel$export($0147bee01cff6558$exports, "NearestMipMapNearestFilter", function () { return $0147bee01cff6558$export$14a4936464a36496; });
$parcel$export($0147bee01cff6558$exports, "NearestMipmapLinearFilter", function () { return $0147bee01cff6558$export$d2327c1afe5bfdf2; });
$parcel$export($0147bee01cff6558$exports, "NearestMipMapLinearFilter", function () { return $0147bee01cff6558$export$cbc5b7f5647595d8; });
$parcel$export($0147bee01cff6558$exports, "LinearFilter", function () { return $0147bee01cff6558$export$8a72f490b25c56c8; });
$parcel$export($0147bee01cff6558$exports, "LinearMipmapNearestFilter", function () { return $0147bee01cff6558$export$19a719f377145a13; });
$parcel$export($0147bee01cff6558$exports, "LinearMipMapNearestFilter", function () { return $0147bee01cff6558$export$dbe96bee3fe9dbf0; });
$parcel$export($0147bee01cff6558$exports, "LinearMipmapLinearFilter", function () { return $0147bee01cff6558$export$5d8599b6a933fb1b; });
$parcel$export($0147bee01cff6558$exports, "LinearMipMapLinearFilter", function () { return $0147bee01cff6558$export$90d80f1e3506775f; });
$parcel$export($0147bee01cff6558$exports, "UnsignedByteType", function () { return $0147bee01cff6558$export$2e8ce08d3f6f5e10; });
$parcel$export($0147bee01cff6558$exports, "ByteType", function () { return $0147bee01cff6558$export$545fce0311a9796a; });
$parcel$export($0147bee01cff6558$exports, "ShortType", function () { return $0147bee01cff6558$export$88572337f312435f; });
$parcel$export($0147bee01cff6558$exports, "UnsignedShortType", function () { return $0147bee01cff6558$export$c63dc51868b06a9d; });
$parcel$export($0147bee01cff6558$exports, "IntType", function () { return $0147bee01cff6558$export$5c612977753abe2; });
$parcel$export($0147bee01cff6558$exports, "UnsignedIntType", function () { return $0147bee01cff6558$export$c3c7fc4518ebba96; });
$parcel$export($0147bee01cff6558$exports, "FloatType", function () { return $0147bee01cff6558$export$f6d331659b644596; });
$parcel$export($0147bee01cff6558$exports, "HalfFloatType", function () { return $0147bee01cff6558$export$2697304443f382bc; });
$parcel$export($0147bee01cff6558$exports, "UnsignedShort4444Type", function () { return $0147bee01cff6558$export$b3969b01faf587f2; });
$parcel$export($0147bee01cff6558$exports, "UnsignedShort5551Type", function () { return $0147bee01cff6558$export$18886f8ae33e90de; });
$parcel$export($0147bee01cff6558$exports, "UnsignedInt248Type", function () { return $0147bee01cff6558$export$6c8ea339bfab1301; });
$parcel$export($0147bee01cff6558$exports, "AlphaFormat", function () { return $0147bee01cff6558$export$988473390501ed4b; });
$parcel$export($0147bee01cff6558$exports, "RGBAFormat", function () { return $0147bee01cff6558$export$3f8bb04b555a363c; });
$parcel$export($0147bee01cff6558$exports, "LuminanceFormat", function () { return $0147bee01cff6558$export$cc09ccbf6d1ed449; });
$parcel$export($0147bee01cff6558$exports, "LuminanceAlphaFormat", function () { return $0147bee01cff6558$export$9053a81c4a69c289; });
$parcel$export($0147bee01cff6558$exports, "DepthFormat", function () { return $0147bee01cff6558$export$c1b6b5136be58045; });
$parcel$export($0147bee01cff6558$exports, "DepthStencilFormat", function () { return $0147bee01cff6558$export$1e113ac2d0905829; });
$parcel$export($0147bee01cff6558$exports, "RedFormat", function () { return $0147bee01cff6558$export$4e041a7967d15c4b; });
$parcel$export($0147bee01cff6558$exports, "RedIntegerFormat", function () { return $0147bee01cff6558$export$aa92e870a709d190; });
$parcel$export($0147bee01cff6558$exports, "RGFormat", function () { return $0147bee01cff6558$export$6cdf0b461c7ce8a0; });
$parcel$export($0147bee01cff6558$exports, "RGIntegerFormat", function () { return $0147bee01cff6558$export$1ba1c45f9f77d4d7; });
$parcel$export($0147bee01cff6558$exports, "RGBAIntegerFormat", function () { return $0147bee01cff6558$export$c200e7d26f592f21; });
$parcel$export($0147bee01cff6558$exports, "RGB_S3TC_DXT1_Format", function () { return $0147bee01cff6558$export$21d1799c6d552fc0; });
$parcel$export($0147bee01cff6558$exports, "RGBA_S3TC_DXT1_Format", function () { return $0147bee01cff6558$export$afa304c3e981b668; });
$parcel$export($0147bee01cff6558$exports, "RGBA_S3TC_DXT3_Format", function () { return $0147bee01cff6558$export$d2a1a68024a3e56c; });
$parcel$export($0147bee01cff6558$exports, "RGBA_S3TC_DXT5_Format", function () { return $0147bee01cff6558$export$9a79c424327dacf9; });
$parcel$export($0147bee01cff6558$exports, "RGB_PVRTC_4BPPV1_Format", function () { return $0147bee01cff6558$export$19ada9bbb1af3573; });
$parcel$export($0147bee01cff6558$exports, "RGB_PVRTC_2BPPV1_Format", function () { return $0147bee01cff6558$export$d0f0355bb3d948e4; });
$parcel$export($0147bee01cff6558$exports, "RGBA_PVRTC_4BPPV1_Format", function () { return $0147bee01cff6558$export$b82296714358084c; });
$parcel$export($0147bee01cff6558$exports, "RGBA_PVRTC_2BPPV1_Format", function () { return $0147bee01cff6558$export$b71692456c47b6c3; });
$parcel$export($0147bee01cff6558$exports, "RGB_ETC1_Format", function () { return $0147bee01cff6558$export$6ab91af2d757aee7; });
$parcel$export($0147bee01cff6558$exports, "RGB_ETC2_Format", function () { return $0147bee01cff6558$export$7800993ef8106a6a; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ETC2_EAC_Format", function () { return $0147bee01cff6558$export$23ed8300a860e7d8; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_4x4_Format", function () { return $0147bee01cff6558$export$dc5570b4a2b92d48; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_5x4_Format", function () { return $0147bee01cff6558$export$68880cd325f8b2fb; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_5x5_Format", function () { return $0147bee01cff6558$export$7d2c0be323373d95; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_6x5_Format", function () { return $0147bee01cff6558$export$22b52da301fc3a3e; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_6x6_Format", function () { return $0147bee01cff6558$export$c009e2cb4a66485e; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_8x5_Format", function () { return $0147bee01cff6558$export$118fff5afa255b63; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_8x6_Format", function () { return $0147bee01cff6558$export$120713c829ae0667; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_8x8_Format", function () { return $0147bee01cff6558$export$c79eeabbf53313e9; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_10x5_Format", function () { return $0147bee01cff6558$export$443cf6567cdd6424; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_10x6_Format", function () { return $0147bee01cff6558$export$6573984fc9840780; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_10x8_Format", function () { return $0147bee01cff6558$export$e7aee563f30091de; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_10x10_Format", function () { return $0147bee01cff6558$export$2eb8634622ddeab7; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_12x10_Format", function () { return $0147bee01cff6558$export$202b1ce7b5d25742; });
$parcel$export($0147bee01cff6558$exports, "RGBA_ASTC_12x12_Format", function () { return $0147bee01cff6558$export$18ab77abd087e467; });
$parcel$export($0147bee01cff6558$exports, "RGBA_BPTC_Format", function () { return $0147bee01cff6558$export$ce40b115e188bc81; });
$parcel$export($0147bee01cff6558$exports, "LoopOnce", function () { return $0147bee01cff6558$export$d62fdc9d1b1cccad; });
$parcel$export($0147bee01cff6558$exports, "LoopRepeat", function () { return $0147bee01cff6558$export$dfaf4422ce096e29; });
$parcel$export($0147bee01cff6558$exports, "LoopPingPong", function () { return $0147bee01cff6558$export$f8f6f2041b78e210; });
$parcel$export($0147bee01cff6558$exports, "InterpolateDiscrete", function () { return $0147bee01cff6558$export$995b32462a65e855; });
$parcel$export($0147bee01cff6558$exports, "InterpolateLinear", function () { return $0147bee01cff6558$export$30fac1aace31cf4d; });
$parcel$export($0147bee01cff6558$exports, "InterpolateSmooth", function () { return $0147bee01cff6558$export$198b11ff4c72bb30; });
$parcel$export($0147bee01cff6558$exports, "ZeroCurvatureEnding", function () { return $0147bee01cff6558$export$7f795934b84ab523; });
$parcel$export($0147bee01cff6558$exports, "ZeroSlopeEnding", function () { return $0147bee01cff6558$export$24a4ccb5099273b5; });
$parcel$export($0147bee01cff6558$exports, "WrapAroundEnding", function () { return $0147bee01cff6558$export$8e8c3ecdcd8e1fee; });
$parcel$export($0147bee01cff6558$exports, "NormalAnimationBlendMode", function () { return $0147bee01cff6558$export$bcfbbdcf8de7f8cd; });
$parcel$export($0147bee01cff6558$exports, "AdditiveAnimationBlendMode", function () { return $0147bee01cff6558$export$d875e029ef558d3; });
$parcel$export($0147bee01cff6558$exports, "TrianglesDrawMode", function () { return $0147bee01cff6558$export$4c28c87c2dc84758; });
$parcel$export($0147bee01cff6558$exports, "TriangleStripDrawMode", function () { return $0147bee01cff6558$export$b23a071aa286eb29; });
$parcel$export($0147bee01cff6558$exports, "TriangleFanDrawMode", function () { return $0147bee01cff6558$export$f0d8293634f88842; });
$parcel$export($0147bee01cff6558$exports, "LinearEncoding", function () { return $0147bee01cff6558$export$7207336e4151a112; });
$parcel$export($0147bee01cff6558$exports, "sRGBEncoding", function () { return $0147bee01cff6558$export$f32388edbb32674; });
$parcel$export($0147bee01cff6558$exports, "BasicDepthPacking", function () { return $0147bee01cff6558$export$deeb383078690b50; });
$parcel$export($0147bee01cff6558$exports, "RGBADepthPacking", function () { return $0147bee01cff6558$export$8f910f4c4f73df11; });
$parcel$export($0147bee01cff6558$exports, "TangentSpaceNormalMap", function () { return $0147bee01cff6558$export$2852a58ebdac27b8; });
$parcel$export($0147bee01cff6558$exports, "ObjectSpaceNormalMap", function () { return $0147bee01cff6558$export$9990ad26f9db5b2c; });
$parcel$export($0147bee01cff6558$exports, "ZeroStencilOp", function () { return $0147bee01cff6558$export$69433f11f42d5527; });
$parcel$export($0147bee01cff6558$exports, "KeepStencilOp", function () { return $0147bee01cff6558$export$9f542ae4b5baca34; });
$parcel$export($0147bee01cff6558$exports, "ReplaceStencilOp", function () { return $0147bee01cff6558$export$8a4f28336ef203d3; });
$parcel$export($0147bee01cff6558$exports, "IncrementStencilOp", function () { return $0147bee01cff6558$export$2928c0231297c036; });
$parcel$export($0147bee01cff6558$exports, "DecrementStencilOp", function () { return $0147bee01cff6558$export$c0e9611c8a15f9a8; });
$parcel$export($0147bee01cff6558$exports, "IncrementWrapStencilOp", function () { return $0147bee01cff6558$export$9c2c08927385dcc4; });
$parcel$export($0147bee01cff6558$exports, "DecrementWrapStencilOp", function () { return $0147bee01cff6558$export$7c74ea00fa1315e6; });
$parcel$export($0147bee01cff6558$exports, "InvertStencilOp", function () { return $0147bee01cff6558$export$22e2e5726612443; });
$parcel$export($0147bee01cff6558$exports, "NeverStencilFunc", function () { return $0147bee01cff6558$export$1343870698229224; });
$parcel$export($0147bee01cff6558$exports, "LessStencilFunc", function () { return $0147bee01cff6558$export$8e1d8ed281997fa6; });
$parcel$export($0147bee01cff6558$exports, "EqualStencilFunc", function () { return $0147bee01cff6558$export$55648a1cde8329a7; });
$parcel$export($0147bee01cff6558$exports, "LessEqualStencilFunc", function () { return $0147bee01cff6558$export$2dff107857e6aca2; });
$parcel$export($0147bee01cff6558$exports, "GreaterStencilFunc", function () { return $0147bee01cff6558$export$6f93765ab2f451a2; });
$parcel$export($0147bee01cff6558$exports, "NotEqualStencilFunc", function () { return $0147bee01cff6558$export$6f3fb2d2440f2b76; });
$parcel$export($0147bee01cff6558$exports, "GreaterEqualStencilFunc", function () { return $0147bee01cff6558$export$4119cf7b4c98fd5a; });
$parcel$export($0147bee01cff6558$exports, "AlwaysStencilFunc", function () { return $0147bee01cff6558$export$14cf96713ddd97a8; });
$parcel$export($0147bee01cff6558$exports, "StaticDrawUsage", function () { return $0147bee01cff6558$export$763e8360f4d7f77d; });
$parcel$export($0147bee01cff6558$exports, "DynamicDrawUsage", function () { return $0147bee01cff6558$export$8505d14ac8546ca; });
$parcel$export($0147bee01cff6558$exports, "StreamDrawUsage", function () { return $0147bee01cff6558$export$721e63549e51d81e; });
$parcel$export($0147bee01cff6558$exports, "StaticReadUsage", function () { return $0147bee01cff6558$export$415731dc4f48e299; });
$parcel$export($0147bee01cff6558$exports, "DynamicReadUsage", function () { return $0147bee01cff6558$export$9e809946455f13bc; });
$parcel$export($0147bee01cff6558$exports, "StreamReadUsage", function () { return $0147bee01cff6558$export$2ed9499a35b5f832; });
$parcel$export($0147bee01cff6558$exports, "StaticCopyUsage", function () { return $0147bee01cff6558$export$32ab2503ea19469a; });
$parcel$export($0147bee01cff6558$exports, "DynamicCopyUsage", function () { return $0147bee01cff6558$export$ab4022c2c3f86315; });
$parcel$export($0147bee01cff6558$exports, "StreamCopyUsage", function () { return $0147bee01cff6558$export$ba7f1db36a76a970; });
$parcel$export($0147bee01cff6558$exports, "GLSL1", function () { return $0147bee01cff6558$export$43600cc67fabd9f; });
$parcel$export($0147bee01cff6558$exports, "GLSL3", function () { return $0147bee01cff6558$export$f63012db5506e7dd; });
$parcel$export($0147bee01cff6558$exports, "_SRGBAFormat", function () { return $0147bee01cff6558$export$ca1dce8b5e1de74d; });
$parcel$export($0147bee01cff6558$exports, "EventDispatcher", function () { return $0147bee01cff6558$export$ec8b666c5fe2c75a; });
$parcel$export($0147bee01cff6558$exports, "Math", function () { return $0147bee01cff6558$export$380958644dbbc22b; });
$parcel$export($0147bee01cff6558$exports, "Vector2", function () { return $0147bee01cff6558$export$c977b3e384af9ae1; });
$parcel$export($0147bee01cff6558$exports, "Matrix3", function () { return $0147bee01cff6558$export$8ff26dafa08918; });
$parcel$export($0147bee01cff6558$exports, "Color", function () { return $0147bee01cff6558$export$892596cec99bc70e; });
$parcel$export($0147bee01cff6558$exports, "ImageUtils", function () { return $0147bee01cff6558$export$698882cf06df44aa; });
$parcel$export($0147bee01cff6558$exports, "Texture", function () { return $0147bee01cff6558$export$5431306cf43de24a; });
$parcel$export($0147bee01cff6558$exports, "Vector4", function () { return $0147bee01cff6558$export$fa7daccca11cdbe3; });
$parcel$export($0147bee01cff6558$exports, "WebGLRenderTarget", function () { return $0147bee01cff6558$export$3c052beb2e51e23f; });
$parcel$export($0147bee01cff6558$exports, "WebGLMultipleRenderTargets", function () { return $0147bee01cff6558$export$bd934554fb721730; });
$parcel$export($0147bee01cff6558$exports, "WebGLMultisampleRenderTarget", function () { return $0147bee01cff6558$export$cb2022643d3c928d; });
$parcel$export($0147bee01cff6558$exports, "Quaternion", function () { return $0147bee01cff6558$export$23d6a54f0bbc85a3; });
$parcel$export($0147bee01cff6558$exports, "Vector3", function () { return $0147bee01cff6558$export$64b5c384219d3699; });
$parcel$export($0147bee01cff6558$exports, "Box3", function () { return $0147bee01cff6558$export$6f7d5a9418ab2aa3; });
$parcel$export($0147bee01cff6558$exports, "Sphere", function () { return $0147bee01cff6558$export$805e8b72413ccaba; });
$parcel$export($0147bee01cff6558$exports, "Ray", function () { return $0147bee01cff6558$export$a186db52eed6d40e; });
$parcel$export($0147bee01cff6558$exports, "Matrix4", function () { return $0147bee01cff6558$export$2ae72fc923e5eb5; });
$parcel$export($0147bee01cff6558$exports, "Euler", function () { return $0147bee01cff6558$export$d93cc409a0768c5f; });
$parcel$export($0147bee01cff6558$exports, "Layers", function () { return $0147bee01cff6558$export$89312ce47c0ca777; });
$parcel$export($0147bee01cff6558$exports, "Object3D", function () { return $0147bee01cff6558$export$e4dd07dff30cc924; });
$parcel$export($0147bee01cff6558$exports, "Triangle", function () { return $0147bee01cff6558$export$5a465592bfe74b48; });
$parcel$export($0147bee01cff6558$exports, "Material", function () { return $0147bee01cff6558$export$a2d8b23205c25948; });
$parcel$export($0147bee01cff6558$exports, "MeshBasicMaterial", function () { return $0147bee01cff6558$export$55cbcc9b622fe1f5; });
$parcel$export($0147bee01cff6558$exports, "BufferAttribute", function () { return $0147bee01cff6558$export$8dea267bd6bde117; });
$parcel$export($0147bee01cff6558$exports, "Int8BufferAttribute", function () { return $0147bee01cff6558$export$f9ff2d6a20248cbf; });
$parcel$export($0147bee01cff6558$exports, "Uint8BufferAttribute", function () { return $0147bee01cff6558$export$cacc90cf35d11cdd; });
$parcel$export($0147bee01cff6558$exports, "Uint8ClampedBufferAttribute", function () { return $0147bee01cff6558$export$baaa85a1a812c157; });
$parcel$export($0147bee01cff6558$exports, "Int16BufferAttribute", function () { return $0147bee01cff6558$export$2b755a102ccdcefe; });
$parcel$export($0147bee01cff6558$exports, "Uint16BufferAttribute", function () { return $0147bee01cff6558$export$640a853f68025f2e; });
$parcel$export($0147bee01cff6558$exports, "Int32BufferAttribute", function () { return $0147bee01cff6558$export$46b369aed2968a0a; });
$parcel$export($0147bee01cff6558$exports, "Uint32BufferAttribute", function () { return $0147bee01cff6558$export$7eb8c9fa25cd5bd6; });
$parcel$export($0147bee01cff6558$exports, "Float16BufferAttribute", function () { return $0147bee01cff6558$export$dbd3698c64958d69; });
$parcel$export($0147bee01cff6558$exports, "Float32BufferAttribute", function () { return $0147bee01cff6558$export$cbe7a62641830ebd; });
$parcel$export($0147bee01cff6558$exports, "Float64BufferAttribute", function () { return $0147bee01cff6558$export$9e0ade74842adbb8; });
$parcel$export($0147bee01cff6558$exports, "BufferGeometry", function () { return $0147bee01cff6558$export$b7be63a67df8959; });
$parcel$export($0147bee01cff6558$exports, "Mesh", function () { return $0147bee01cff6558$export$e176487c05830cc5; });
$parcel$export($0147bee01cff6558$exports, "BoxBufferGeometry", function () { return $0147bee01cff6558$export$ab3456a079aa7d80; });
$parcel$export($0147bee01cff6558$exports, "UniformsUtils", function () { return $0147bee01cff6558$export$d8ecdf8615bfea69; });
$parcel$export($0147bee01cff6558$exports, "ShaderMaterial", function () { return $0147bee01cff6558$export$83c7d75d550a8b0d; });
$parcel$export($0147bee01cff6558$exports, "Camera", function () { return $0147bee01cff6558$export$79f141de891a5fed; });
$parcel$export($0147bee01cff6558$exports, "PerspectiveCamera", function () { return $0147bee01cff6558$export$74e4ae24825f68d7; });
$parcel$export($0147bee01cff6558$exports, "CubeCamera", function () { return $0147bee01cff6558$export$d0cdd0bd804995de; });
$parcel$export($0147bee01cff6558$exports, "CubeTexture", function () { return $0147bee01cff6558$export$ee2e5a18258a4049; });
$parcel$export($0147bee01cff6558$exports, "WebGLCubeRenderTarget", function () { return $0147bee01cff6558$export$ac386671d651941e; });
$parcel$export($0147bee01cff6558$exports, "Plane", function () { return $0147bee01cff6558$export$7ff5ac152ef991b0; });
$parcel$export($0147bee01cff6558$exports, "Frustum", function () { return $0147bee01cff6558$export$35efe6f4c85463d2; });
$parcel$export($0147bee01cff6558$exports, "PlaneBufferGeometry", function () { return $0147bee01cff6558$export$e789a11a194ca4e0; });
$parcel$export($0147bee01cff6558$exports, "ShaderChunk", function () { return $0147bee01cff6558$export$955f9f2e84c43c8b; });
$parcel$export($0147bee01cff6558$exports, "UniformsLib", function () { return $0147bee01cff6558$export$6643083551874bf5; });
$parcel$export($0147bee01cff6558$exports, "ShaderLib", function () { return $0147bee01cff6558$export$bee4a7d47f8f5014; });
$parcel$export($0147bee01cff6558$exports, "OrthographicCamera", function () { return $0147bee01cff6558$export$9ebf355ee4ed261b; });
$parcel$export($0147bee01cff6558$exports, "RawShaderMaterial", function () { return $0147bee01cff6558$export$21c421a2e1df9d22; });
$parcel$export($0147bee01cff6558$exports, "PMREMGenerator", function () { return $0147bee01cff6558$export$6add42717753e221; });
$parcel$export($0147bee01cff6558$exports, "DataTexture2DArray", function () { return $0147bee01cff6558$export$e38bf4541665bbbd; });
$parcel$export($0147bee01cff6558$exports, "DataTexture3D", function () { return $0147bee01cff6558$export$ef03cdc98340bab4; });
$parcel$export($0147bee01cff6558$exports, "MeshDepthMaterial", function () { return $0147bee01cff6558$export$2698c22ec13825db; });
$parcel$export($0147bee01cff6558$exports, "MeshDistanceMaterial", function () { return $0147bee01cff6558$export$33e187ed002f2a19; });
$parcel$export($0147bee01cff6558$exports, "WebGLUtils", function () { return $0147bee01cff6558$export$ddaebcad857649a8; });
$parcel$export($0147bee01cff6558$exports, "ArrayCamera", function () { return $0147bee01cff6558$export$56b937d9e5581166; });
$parcel$export($0147bee01cff6558$exports, "Group", function () { return $0147bee01cff6558$export$eb2fcfdbd7ba97d4; });
$parcel$export($0147bee01cff6558$exports, "DepthTexture", function () { return $0147bee01cff6558$export$fc830aa069cc8c2f; });
$parcel$export($0147bee01cff6558$exports, "WebGLRenderer", function () { return $0147bee01cff6558$export$f6cc00ef28d7cf97; });
$parcel$export($0147bee01cff6558$exports, "WebGL1Renderer", function () { return $0147bee01cff6558$export$a2f65229194348f9; });
$parcel$export($0147bee01cff6558$exports, "FogExp2", function () { return $0147bee01cff6558$export$6f1519f023b8d0f6; });
$parcel$export($0147bee01cff6558$exports, "Fog", function () { return $0147bee01cff6558$export$3c890837b09508d4; });
$parcel$export($0147bee01cff6558$exports, "Scene", function () { return $0147bee01cff6558$export$38af1803e3442a7f; });
$parcel$export($0147bee01cff6558$exports, "InterleavedBuffer", function () { return $0147bee01cff6558$export$3d5cd879f108f53f; });
$parcel$export($0147bee01cff6558$exports, "InterleavedBufferAttribute", function () { return $0147bee01cff6558$export$920b6d07334599c7; });
$parcel$export($0147bee01cff6558$exports, "SpriteMaterial", function () { return $0147bee01cff6558$export$5ec7dd1c6994bf8e; });
$parcel$export($0147bee01cff6558$exports, "Sprite", function () { return $0147bee01cff6558$export$3075603db8e6204c; });
$parcel$export($0147bee01cff6558$exports, "LOD", function () { return $0147bee01cff6558$export$112e7237be0c5f30; });
$parcel$export($0147bee01cff6558$exports, "SkinnedMesh", function () { return $0147bee01cff6558$export$b303577035157ecf; });
$parcel$export($0147bee01cff6558$exports, "Bone", function () { return $0147bee01cff6558$export$b127726e56765aa4; });
$parcel$export($0147bee01cff6558$exports, "DataTexture", function () { return $0147bee01cff6558$export$b691f601014eabe1; });
$parcel$export($0147bee01cff6558$exports, "Skeleton", function () { return $0147bee01cff6558$export$8f31e4c4a37b8e9c; });
$parcel$export($0147bee01cff6558$exports, "InstancedBufferAttribute", function () { return $0147bee01cff6558$export$32ea87a8b54d744a; });
$parcel$export($0147bee01cff6558$exports, "InstancedMesh", function () { return $0147bee01cff6558$export$f3c979c331175ad7; });
$parcel$export($0147bee01cff6558$exports, "LineBasicMaterial", function () { return $0147bee01cff6558$export$fbaaa33907730a0c; });
$parcel$export($0147bee01cff6558$exports, "Line", function () { return $0147bee01cff6558$export$17d680238e50603e; });
$parcel$export($0147bee01cff6558$exports, "LineSegments", function () { return $0147bee01cff6558$export$ff1ed10fedfdd604; });
$parcel$export($0147bee01cff6558$exports, "LineLoop", function () { return $0147bee01cff6558$export$f85a24d745e4f17d; });
$parcel$export($0147bee01cff6558$exports, "PointsMaterial", function () { return $0147bee01cff6558$export$a178c45366ce5d6b; });
$parcel$export($0147bee01cff6558$exports, "Points", function () { return $0147bee01cff6558$export$1c787534cb11aa3e; });
$parcel$export($0147bee01cff6558$exports, "VideoTexture", function () { return $0147bee01cff6558$export$6e09d1edf8d5a25c; });
$parcel$export($0147bee01cff6558$exports, "FramebufferTexture", function () { return $0147bee01cff6558$export$9270d786f73ce6fe; });
$parcel$export($0147bee01cff6558$exports, "CompressedTexture", function () { return $0147bee01cff6558$export$3466bac9141a5cc4; });
$parcel$export($0147bee01cff6558$exports, "CanvasTexture", function () { return $0147bee01cff6558$export$f7189e49152d1c13; });
$parcel$export($0147bee01cff6558$exports, "CircleBufferGeometry", function () { return $0147bee01cff6558$export$3f74fe60decf7462; });
$parcel$export($0147bee01cff6558$exports, "CylinderBufferGeometry", function () { return $0147bee01cff6558$export$d4345c83207d7c68; });
$parcel$export($0147bee01cff6558$exports, "ConeBufferGeometry", function () { return $0147bee01cff6558$export$59d971120dc8b6e7; });
$parcel$export($0147bee01cff6558$exports, "PolyhedronBufferGeometry", function () { return $0147bee01cff6558$export$38789b531813345c; });
$parcel$export($0147bee01cff6558$exports, "DodecahedronBufferGeometry", function () { return $0147bee01cff6558$export$37cd4e52cce48c4c; });
$parcel$export($0147bee01cff6558$exports, "EdgesGeometry", function () { return $0147bee01cff6558$export$4730b1542707547f; });
$parcel$export($0147bee01cff6558$exports, "Curve", function () { return $0147bee01cff6558$export$b0e83c3ef8d2db1; });
$parcel$export($0147bee01cff6558$exports, "EllipseCurve", function () { return $0147bee01cff6558$export$3f87a931616cde04; });
$parcel$export($0147bee01cff6558$exports, "ArcCurve", function () { return $0147bee01cff6558$export$b1eedc9aab6300e8; });
$parcel$export($0147bee01cff6558$exports, "CatmullRomCurve3", function () { return $0147bee01cff6558$export$b9146b27c24b744c; });
$parcel$export($0147bee01cff6558$exports, "CubicBezierCurve", function () { return $0147bee01cff6558$export$e36650d36468bb39; });
$parcel$export($0147bee01cff6558$exports, "CubicBezierCurve3", function () { return $0147bee01cff6558$export$13d5f1c9525f246c; });
$parcel$export($0147bee01cff6558$exports, "LineCurve", function () { return $0147bee01cff6558$export$ab2e07e76531a47e; });
$parcel$export($0147bee01cff6558$exports, "LineCurve3", function () { return $0147bee01cff6558$export$1fdfd9d9cf487600; });
$parcel$export($0147bee01cff6558$exports, "QuadraticBezierCurve", function () { return $0147bee01cff6558$export$5938c4ee491a43ad; });
$parcel$export($0147bee01cff6558$exports, "QuadraticBezierCurve3", function () { return $0147bee01cff6558$export$bf3f4c7e459f90fc; });
$parcel$export($0147bee01cff6558$exports, "SplineCurve", function () { return $0147bee01cff6558$export$d3bdd77da77afc1b; });
$parcel$export($0147bee01cff6558$exports, "CurvePath", function () { return $0147bee01cff6558$export$4aaf9b66af1bbf2c; });
$parcel$export($0147bee01cff6558$exports, "Path", function () { return $0147bee01cff6558$export$4b2950bdac9b6ee9; });
$parcel$export($0147bee01cff6558$exports, "Shape", function () { return $0147bee01cff6558$export$6428a7f2611ef1fa; });
$parcel$export($0147bee01cff6558$exports, "ShapeUtils", function () { return $0147bee01cff6558$export$96bdf6d9c66d7ba8; });
$parcel$export($0147bee01cff6558$exports, "ExtrudeBufferGeometry", function () { return $0147bee01cff6558$export$91836d01b9f75a58; });
$parcel$export($0147bee01cff6558$exports, "IcosahedronBufferGeometry", function () { return $0147bee01cff6558$export$731fd4feef063ea2; });
$parcel$export($0147bee01cff6558$exports, "LatheBufferGeometry", function () { return $0147bee01cff6558$export$dc3e1273c1dd9240; });
$parcel$export($0147bee01cff6558$exports, "OctahedronBufferGeometry", function () { return $0147bee01cff6558$export$8e05fc91596f4752; });
$parcel$export($0147bee01cff6558$exports, "RingBufferGeometry", function () { return $0147bee01cff6558$export$ee8b85b34b7d9cad; });
$parcel$export($0147bee01cff6558$exports, "ShapeBufferGeometry", function () { return $0147bee01cff6558$export$233afc324766bed8; });
$parcel$export($0147bee01cff6558$exports, "SphereBufferGeometry", function () { return $0147bee01cff6558$export$d5d06a966fec4192; });
$parcel$export($0147bee01cff6558$exports, "TetrahedronBufferGeometry", function () { return $0147bee01cff6558$export$369e08f62a796c65; });
$parcel$export($0147bee01cff6558$exports, "TorusBufferGeometry", function () { return $0147bee01cff6558$export$19d55f905fa4f2cb; });
$parcel$export($0147bee01cff6558$exports, "TorusKnotBufferGeometry", function () { return $0147bee01cff6558$export$2b32466f4274fe5c; });
$parcel$export($0147bee01cff6558$exports, "TubeBufferGeometry", function () { return $0147bee01cff6558$export$d97a193ce44e691b; });
$parcel$export($0147bee01cff6558$exports, "WireframeGeometry", function () { return $0147bee01cff6558$export$4b739da06d24892b; });
$parcel$export($0147bee01cff6558$exports, "ShadowMaterial", function () { return $0147bee01cff6558$export$e8564da406055a3; });
$parcel$export($0147bee01cff6558$exports, "MeshStandardMaterial", function () { return $0147bee01cff6558$export$f2980790215acccd; });
$parcel$export($0147bee01cff6558$exports, "MeshPhysicalMaterial", function () { return $0147bee01cff6558$export$28d04986c4269c9f; });
$parcel$export($0147bee01cff6558$exports, "MeshPhongMaterial", function () { return $0147bee01cff6558$export$24c72f71cbaf0678; });
$parcel$export($0147bee01cff6558$exports, "MeshToonMaterial", function () { return $0147bee01cff6558$export$df893cf97e765622; });
$parcel$export($0147bee01cff6558$exports, "MeshNormalMaterial", function () { return $0147bee01cff6558$export$bfe8c0a091f41ae7; });
$parcel$export($0147bee01cff6558$exports, "MeshLambertMaterial", function () { return $0147bee01cff6558$export$5023a9a8114806b8; });
$parcel$export($0147bee01cff6558$exports, "MeshMatcapMaterial", function () { return $0147bee01cff6558$export$6f5fef6235ec12ee; });
$parcel$export($0147bee01cff6558$exports, "LineDashedMaterial", function () { return $0147bee01cff6558$export$327886a3efaeaebe; });
$parcel$export($0147bee01cff6558$exports, "AnimationUtils", function () { return $0147bee01cff6558$export$7ee8caa573e71ad1; });
$parcel$export($0147bee01cff6558$exports, "Interpolant", function () { return $0147bee01cff6558$export$b558baee9c0f72d3; });
$parcel$export($0147bee01cff6558$exports, "CubicInterpolant", function () { return $0147bee01cff6558$export$3646682e7a3959; });
$parcel$export($0147bee01cff6558$exports, "LinearInterpolant", function () { return $0147bee01cff6558$export$a8e6009059f51e1a; });
$parcel$export($0147bee01cff6558$exports, "DiscreteInterpolant", function () { return $0147bee01cff6558$export$fb9758ef7ef8d5cc; });
$parcel$export($0147bee01cff6558$exports, "KeyframeTrack", function () { return $0147bee01cff6558$export$b0e479f45b7006d6; });
$parcel$export($0147bee01cff6558$exports, "BooleanKeyframeTrack", function () { return $0147bee01cff6558$export$d3a344b98cf0b775; });
$parcel$export($0147bee01cff6558$exports, "ColorKeyframeTrack", function () { return $0147bee01cff6558$export$83444c5d885347d8; });
$parcel$export($0147bee01cff6558$exports, "NumberKeyframeTrack", function () { return $0147bee01cff6558$export$d45f0d1a4d9a9314; });
$parcel$export($0147bee01cff6558$exports, "QuaternionLinearInterpolant", function () { return $0147bee01cff6558$export$2db1cfb7923d931e; });
$parcel$export($0147bee01cff6558$exports, "QuaternionKeyframeTrack", function () { return $0147bee01cff6558$export$b8043f12b5aafbd7; });
$parcel$export($0147bee01cff6558$exports, "StringKeyframeTrack", function () { return $0147bee01cff6558$export$6ce41d4f3a8df9cd; });
$parcel$export($0147bee01cff6558$exports, "VectorKeyframeTrack", function () { return $0147bee01cff6558$export$5ce2dcb4cc9f2bff; });
$parcel$export($0147bee01cff6558$exports, "AnimationClip", function () { return $0147bee01cff6558$export$d942c706bf23829c; });
$parcel$export($0147bee01cff6558$exports, "Cache", function () { return $0147bee01cff6558$export$94affb487e701bf2; });
$parcel$export($0147bee01cff6558$exports, "LoadingManager", function () { return $0147bee01cff6558$export$99cc795e99919eed; });
$parcel$export($0147bee01cff6558$exports, "DefaultLoadingManager", function () { return $0147bee01cff6558$export$b033c3f9a95c6a16; });
$parcel$export($0147bee01cff6558$exports, "Loader", function () { return $0147bee01cff6558$export$3b0d6d7590275603; });
$parcel$export($0147bee01cff6558$exports, "FileLoader", function () { return $0147bee01cff6558$export$98435a25b5cf7b2b; });
$parcel$export($0147bee01cff6558$exports, "AnimationLoader", function () { return $0147bee01cff6558$export$29711c7e14f61db; });
$parcel$export($0147bee01cff6558$exports, "CompressedTextureLoader", function () { return $0147bee01cff6558$export$bd73ce947a280350; });
$parcel$export($0147bee01cff6558$exports, "ImageLoader", function () { return $0147bee01cff6558$export$8905ce1c7a2464a1; });
$parcel$export($0147bee01cff6558$exports, "CubeTextureLoader", function () { return $0147bee01cff6558$export$2ec114afc2cf6308; });
$parcel$export($0147bee01cff6558$exports, "DataTextureLoader", function () { return $0147bee01cff6558$export$792d8a18f2c55855; });
$parcel$export($0147bee01cff6558$exports, "TextureLoader", function () { return $0147bee01cff6558$export$fd1bfc71f64c538c; });
$parcel$export($0147bee01cff6558$exports, "Light", function () { return $0147bee01cff6558$export$6ecadb6ed240d696; });
$parcel$export($0147bee01cff6558$exports, "HemisphereLight", function () { return $0147bee01cff6558$export$8d474f55edbb9624; });
$parcel$export($0147bee01cff6558$exports, "SpotLight", function () { return $0147bee01cff6558$export$81495cbb73897362; });
$parcel$export($0147bee01cff6558$exports, "PointLight", function () { return $0147bee01cff6558$export$4c9c1cb3f0b6f455; });
$parcel$export($0147bee01cff6558$exports, "DirectionalLight", function () { return $0147bee01cff6558$export$3fea33cc9972c868; });
$parcel$export($0147bee01cff6558$exports, "AmbientLight", function () { return $0147bee01cff6558$export$af279bfef9ec2c96; });
$parcel$export($0147bee01cff6558$exports, "RectAreaLight", function () { return $0147bee01cff6558$export$61db2d908bbd2429; });
$parcel$export($0147bee01cff6558$exports, "SphericalHarmonics3", function () { return $0147bee01cff6558$export$ba61ce607e1f405a; });
$parcel$export($0147bee01cff6558$exports, "LightProbe", function () { return $0147bee01cff6558$export$e7ef036e309b38d2; });
$parcel$export($0147bee01cff6558$exports, "MaterialLoader", function () { return $0147bee01cff6558$export$3bd6d323353dcf96; });
$parcel$export($0147bee01cff6558$exports, "LoaderUtils", function () { return $0147bee01cff6558$export$b5d2dc08d867e41a; });
$parcel$export($0147bee01cff6558$exports, "InstancedBufferGeometry", function () { return $0147bee01cff6558$export$231f009cbe414146; });
$parcel$export($0147bee01cff6558$exports, "BufferGeometryLoader", function () { return $0147bee01cff6558$export$dc275bb96327833a; });
$parcel$export($0147bee01cff6558$exports, "ObjectLoader", function () { return $0147bee01cff6558$export$40110c8505c5ad19; });
$parcel$export($0147bee01cff6558$exports, "ImageBitmapLoader", function () { return $0147bee01cff6558$export$52286b55c4a9b51f; });
$parcel$export($0147bee01cff6558$exports, "AudioContext", function () { return $0147bee01cff6558$export$fcbc63750ec2a81f; });
$parcel$export($0147bee01cff6558$exports, "AudioLoader", function () { return $0147bee01cff6558$export$d8d5fccfbf47714e; });
$parcel$export($0147bee01cff6558$exports, "HemisphereLightProbe", function () { return $0147bee01cff6558$export$2f22dadc8bc42820; });
$parcel$export($0147bee01cff6558$exports, "AmbientLightProbe", function () { return $0147bee01cff6558$export$afe310a21c86023d; });
$parcel$export($0147bee01cff6558$exports, "StereoCamera", function () { return $0147bee01cff6558$export$bc7f73a1065bee0c; });
$parcel$export($0147bee01cff6558$exports, "Clock", function () { return $0147bee01cff6558$export$9735c82c4bae3302; });
$parcel$export($0147bee01cff6558$exports, "AudioListener", function () { return $0147bee01cff6558$export$8a1b810c6fde8951; });
$parcel$export($0147bee01cff6558$exports, "Audio", function () { return $0147bee01cff6558$export$153755f98d9861de; });
$parcel$export($0147bee01cff6558$exports, "PositionalAudio", function () { return $0147bee01cff6558$export$4b3e397ef1832507; });
$parcel$export($0147bee01cff6558$exports, "AudioAnalyser", function () { return $0147bee01cff6558$export$d47da1ef3d382827; });
$parcel$export($0147bee01cff6558$exports, "PropertyMixer", function () { return $0147bee01cff6558$export$dfe0af1ca1acb78a; });
$parcel$export($0147bee01cff6558$exports, "PropertyBinding", function () { return $0147bee01cff6558$export$7bf70fcf9f891893; });
$parcel$export($0147bee01cff6558$exports, "AnimationObjectGroup", function () { return $0147bee01cff6558$export$30619c2afd3f34db; });
$parcel$export($0147bee01cff6558$exports, "AnimationMixer", function () { return $0147bee01cff6558$export$fbd77e5aefaa0102; });
$parcel$export($0147bee01cff6558$exports, "Uniform", function () { return $0147bee01cff6558$export$2947cebfe91c02f8; });
$parcel$export($0147bee01cff6558$exports, "InstancedInterleavedBuffer", function () { return $0147bee01cff6558$export$25ec0e1af1389358; });
$parcel$export($0147bee01cff6558$exports, "GLBufferAttribute", function () { return $0147bee01cff6558$export$6b7339ae8dbddf73; });
$parcel$export($0147bee01cff6558$exports, "Raycaster", function () { return $0147bee01cff6558$export$8b7aaceff00bd2f; });
$parcel$export($0147bee01cff6558$exports, "Spherical", function () { return $0147bee01cff6558$export$d712cd887b4a00f7; });
$parcel$export($0147bee01cff6558$exports, "Cylindrical", function () { return $0147bee01cff6558$export$287165bb2177f4fd; });
$parcel$export($0147bee01cff6558$exports, "Box2", function () { return $0147bee01cff6558$export$60f553fa130f08b0; });
$parcel$export($0147bee01cff6558$exports, "Line3", function () { return $0147bee01cff6558$export$e0ba6359f1954fd3; });
$parcel$export($0147bee01cff6558$exports, "SpotLightHelper", function () { return $0147bee01cff6558$export$4b14638ffdd81e68; });
$parcel$export($0147bee01cff6558$exports, "SkeletonHelper", function () { return $0147bee01cff6558$export$5277df3c9e732259; });
$parcel$export($0147bee01cff6558$exports, "PointLightHelper", function () { return $0147bee01cff6558$export$9a9291685b9e4023; });
$parcel$export($0147bee01cff6558$exports, "HemisphereLightHelper", function () { return $0147bee01cff6558$export$8dca15f13f4f8172; });
$parcel$export($0147bee01cff6558$exports, "GridHelper", function () { return $0147bee01cff6558$export$3875d39926561055; });
$parcel$export($0147bee01cff6558$exports, "PolarGridHelper", function () { return $0147bee01cff6558$export$361430a10f533cd3; });
$parcel$export($0147bee01cff6558$exports, "DirectionalLightHelper", function () { return $0147bee01cff6558$export$f8e434dc14203e7d; });
$parcel$export($0147bee01cff6558$exports, "CameraHelper", function () { return $0147bee01cff6558$export$ed8e93f853cd795; });
$parcel$export($0147bee01cff6558$exports, "BoxHelper", function () { return $0147bee01cff6558$export$38a664cc862a6a9d; });
$parcel$export($0147bee01cff6558$exports, "Box3Helper", function () { return $0147bee01cff6558$export$ce39f4bb96c9a290; });
$parcel$export($0147bee01cff6558$exports, "PlaneHelper", function () { return $0147bee01cff6558$export$a34fe8156c66e5d7; });
$parcel$export($0147bee01cff6558$exports, "ArrowHelper", function () { return $0147bee01cff6558$export$a3008e7bd8d2cbe7; });
$parcel$export($0147bee01cff6558$exports, "AxesHelper", function () { return $0147bee01cff6558$export$6c8303f35b8578fd; });
$parcel$export($0147bee01cff6558$exports, "ShapePath", function () { return $0147bee01cff6558$export$148534a3c727230b; });
$parcel$export($0147bee01cff6558$exports, "DataUtils", function () { return $0147bee01cff6558$export$11ce8b759162cc80; });
$parcel$export($0147bee01cff6558$exports, "LineStrip", function () { return $0147bee01cff6558$export$195910b613d3dbcb; });
$parcel$export($0147bee01cff6558$exports, "LinePieces", function () { return $0147bee01cff6558$export$c8a71586e494fb81; });
$parcel$export($0147bee01cff6558$exports, "NoColors", function () { return $0147bee01cff6558$export$1a5c46edbdc9a5b7; });
$parcel$export($0147bee01cff6558$exports, "FaceColors", function () { return $0147bee01cff6558$export$617e978cc3201d85; });
$parcel$export($0147bee01cff6558$exports, "VertexColors", function () { return $0147bee01cff6558$export$969ede3d37172881; });
$parcel$export($0147bee01cff6558$exports, "MeshFaceMaterial", function () { return $0147bee01cff6558$export$8f0d8c869214e38a; });
$parcel$export($0147bee01cff6558$exports, "MultiMaterial", function () { return $0147bee01cff6558$export$4f1842f7cdf61f78; });
$parcel$export($0147bee01cff6558$exports, "PointCloud", function () { return $0147bee01cff6558$export$5c812f854e08d33d; });
$parcel$export($0147bee01cff6558$exports, "Particle", function () { return $0147bee01cff6558$export$c36c68baa13912a5; });
$parcel$export($0147bee01cff6558$exports, "ParticleSystem", function () { return $0147bee01cff6558$export$f219b6a0e4bb0b6d; });
$parcel$export($0147bee01cff6558$exports, "PointCloudMaterial", function () { return $0147bee01cff6558$export$29121d9ccd2f757a; });
$parcel$export($0147bee01cff6558$exports, "ParticleBasicMaterial", function () { return $0147bee01cff6558$export$ffa02580217a1c8; });
$parcel$export($0147bee01cff6558$exports, "ParticleSystemMaterial", function () { return $0147bee01cff6558$export$cb1306c614c86e6b; });
$parcel$export($0147bee01cff6558$exports, "Vertex", function () { return $0147bee01cff6558$export$3e8a3cc8713efbec; });
$parcel$export($0147bee01cff6558$exports, "DynamicBufferAttribute", function () { return $0147bee01cff6558$export$189ab5ea9d161e81; });
$parcel$export($0147bee01cff6558$exports, "Int8Attribute", function () { return $0147bee01cff6558$export$e0ae4f0a1804ea11; });
$parcel$export($0147bee01cff6558$exports, "Uint8Attribute", function () { return $0147bee01cff6558$export$a0d192e03a5b32f5; });
$parcel$export($0147bee01cff6558$exports, "Uint8ClampedAttribute", function () { return $0147bee01cff6558$export$8ca743ab36552bfa; });
$parcel$export($0147bee01cff6558$exports, "Int16Attribute", function () { return $0147bee01cff6558$export$5d9757676aad9dab; });
$parcel$export($0147bee01cff6558$exports, "Uint16Attribute", function () { return $0147bee01cff6558$export$ed102ffd14092320; });
$parcel$export($0147bee01cff6558$exports, "Int32Attribute", function () { return $0147bee01cff6558$export$6acc479034658f15; });
$parcel$export($0147bee01cff6558$exports, "Uint32Attribute", function () { return $0147bee01cff6558$export$53474877d6e539b9; });
$parcel$export($0147bee01cff6558$exports, "Float32Attribute", function () { return $0147bee01cff6558$export$377af6eadc8006c3; });
$parcel$export($0147bee01cff6558$exports, "Float64Attribute", function () { return $0147bee01cff6558$export$b9212d1a67b6f081; });
$parcel$export($0147bee01cff6558$exports, "AxisHelper", function () { return $0147bee01cff6558$export$46c1eaab6b8d1e23; });
$parcel$export($0147bee01cff6558$exports, "BoundingBoxHelper", function () { return $0147bee01cff6558$export$3c24c67720a2146c; });
$parcel$export($0147bee01cff6558$exports, "EdgesHelper", function () { return $0147bee01cff6558$export$e341a90264c62d4c; });
$parcel$export($0147bee01cff6558$exports, "WireframeHelper", function () { return $0147bee01cff6558$export$72d033539c529f13; });
$parcel$export($0147bee01cff6558$exports, "XHRLoader", function () { return $0147bee01cff6558$export$c8b77178c5db4e0d; });
$parcel$export($0147bee01cff6558$exports, "BinaryTextureLoader", function () { return $0147bee01cff6558$export$58c7c1107fc658f9; });
$parcel$export($0147bee01cff6558$exports, "WebGLRenderTargetCube", function () { return $0147bee01cff6558$export$689069929abfa262; });
$parcel$export($0147bee01cff6558$exports, "CanvasRenderer", function () { return $0147bee01cff6558$export$7adc20298958481a; });
$parcel$export($0147bee01cff6558$exports, "JSONLoader", function () { return $0147bee01cff6558$export$8e85bca5826c4696; });
$parcel$export($0147bee01cff6558$exports, "SceneUtils", function () { return $0147bee01cff6558$export$a8351e0de8b3fd78; });
$parcel$export($0147bee01cff6558$exports, "LensFlare", function () { return $0147bee01cff6558$export$3f909fba4d49fe3d; });
$parcel$export($0147bee01cff6558$exports, "ParametricGeometry", function () { return $0147bee01cff6558$export$8f6f2b4b16d33f; });
$parcel$export($0147bee01cff6558$exports, "TextGeometry", function () { return $0147bee01cff6558$export$684b774b4473ba5f; });
$parcel$export($0147bee01cff6558$exports, "FontLoader", function () { return $0147bee01cff6558$export$812303d6cad736b3; });
$parcel$export($0147bee01cff6558$exports, "Font", function () { return $0147bee01cff6558$export$89abf52a030e56ee; });
$parcel$export($0147bee01cff6558$exports, "ImmediateRenderObject", function () { return $0147bee01cff6558$export$960665a8431ecff6; });
$parcel$export($0147bee01cff6558$exports, "BoxGeometry", function () { return $0147bee01cff6558$export$ab3456a079aa7d80; });
$parcel$export($0147bee01cff6558$exports, "CircleGeometry", function () { return $0147bee01cff6558$export$3f74fe60decf7462; });
$parcel$export($0147bee01cff6558$exports, "ConeGeometry", function () { return $0147bee01cff6558$export$59d971120dc8b6e7; });
$parcel$export($0147bee01cff6558$exports, "CylinderGeometry", function () { return $0147bee01cff6558$export$d4345c83207d7c68; });
$parcel$export($0147bee01cff6558$exports, "DodecahedronGeometry", function () { return $0147bee01cff6558$export$37cd4e52cce48c4c; });
$parcel$export($0147bee01cff6558$exports, "ExtrudeGeometry", function () { return $0147bee01cff6558$export$91836d01b9f75a58; });
$parcel$export($0147bee01cff6558$exports, "IcosahedronGeometry", function () { return $0147bee01cff6558$export$731fd4feef063ea2; });
$parcel$export($0147bee01cff6558$exports, "LatheGeometry", function () { return $0147bee01cff6558$export$dc3e1273c1dd9240; });
$parcel$export($0147bee01cff6558$exports, "MathUtils", function () { return $0147bee01cff6558$export$380958644dbbc22b; });
$parcel$export($0147bee01cff6558$exports, "OctahedronGeometry", function () { return $0147bee01cff6558$export$8e05fc91596f4752; });
$parcel$export($0147bee01cff6558$exports, "PlaneGeometry", function () { return $0147bee01cff6558$export$e789a11a194ca4e0; });
$parcel$export($0147bee01cff6558$exports, "PolyhedronGeometry", function () { return $0147bee01cff6558$export$38789b531813345c; });
$parcel$export($0147bee01cff6558$exports, "RingGeometry", function () { return $0147bee01cff6558$export$ee8b85b34b7d9cad; });
$parcel$export($0147bee01cff6558$exports, "ShapeGeometry", function () { return $0147bee01cff6558$export$233afc324766bed8; });
$parcel$export($0147bee01cff6558$exports, "SphereGeometry", function () { return $0147bee01cff6558$export$d5d06a966fec4192; });
$parcel$export($0147bee01cff6558$exports, "TetrahedronGeometry", function () { return $0147bee01cff6558$export$369e08f62a796c65; });
$parcel$export($0147bee01cff6558$exports, "TorusGeometry", function () { return $0147bee01cff6558$export$19d55f905fa4f2cb; });
$parcel$export($0147bee01cff6558$exports, "TorusKnotGeometry", function () { return $0147bee01cff6558$export$2b32466f4274fe5c; });
$parcel$export($0147bee01cff6558$exports, "TubeGeometry", function () { return $0147bee01cff6558$export$d97a193ce44e691b; });
/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $0147bee01cff6558$export$3545e07a80636437 = "137";
const $0147bee01cff6558$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $0147bee01cff6558$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $0147bee01cff6558$export$3237e1f2c1ea1f44 = 0;
const $0147bee01cff6558$export$b9a7b4fc5cb15f9b = 1;
const $0147bee01cff6558$export$b8058bcc7037d3f3 = 2;
const $0147bee01cff6558$export$f24be24dcddeac0d = 3;
const $0147bee01cff6558$export$346307dbae2b7447 = 0;
const $0147bee01cff6558$export$5813f879eee7cd88 = 1;
const $0147bee01cff6558$export$a47c4b43a1be34f0 = 2;
const $0147bee01cff6558$export$896ae1ade6c829c4 = 3;
const $0147bee01cff6558$export$2ede184fc2998901 = 0;
const $0147bee01cff6558$export$d9f0486e75b5ace = 1;
const $0147bee01cff6558$export$3b296b6f144d5b03 = 2;
const $0147bee01cff6558$export$a62047d29c96d8ff = 1;
const $0147bee01cff6558$export$fadb74c06a7f490 = 2;
const $0147bee01cff6558$export$63b8d6b580fc65ba = 0;
const $0147bee01cff6558$export$5b29a26d96ee6af0 = 1;
const $0147bee01cff6558$export$777d8f9551c2216b = 2;
const $0147bee01cff6558$export$cdfa06f868e2e467 = 3;
const $0147bee01cff6558$export$4138e1c684b46a20 = 4;
const $0147bee01cff6558$export$eda4864c68df1fa2 = 5;
const $0147bee01cff6558$export$20183a0484ce21a0 = 100;
const $0147bee01cff6558$export$73e0df5177988548 = 101;
const $0147bee01cff6558$export$28e582859cbec660 = 102;
const $0147bee01cff6558$export$c8c1508da8d0600c = 103;
const $0147bee01cff6558$export$99948c02fb51055f = 104;
const $0147bee01cff6558$export$2110f05edf778d3d = 200;
const $0147bee01cff6558$export$8805bad65e24940e = 201;
const $0147bee01cff6558$export$7fbe15b28d28cf52 = 202;
const $0147bee01cff6558$export$947829af9f2c17f6 = 203;
const $0147bee01cff6558$export$d5773124e86cf28c = 204;
const $0147bee01cff6558$export$11d468cc7f19e971 = 205;
const $0147bee01cff6558$export$a78aed1ca2a87192 = 206;
const $0147bee01cff6558$export$5d0fe17fd8773bac = 207;
const $0147bee01cff6558$export$ef5f2dd8ffac5574 = 208;
const $0147bee01cff6558$export$56b85b2686ab16 = 209;
const $0147bee01cff6558$export$c05e2a1fc8609506 = 210;
const $0147bee01cff6558$export$69025ce147cee220 = 0;
const $0147bee01cff6558$export$7182eb52ea3b3f04 = 1;
const $0147bee01cff6558$export$eedccec66ab7ebe = 2;
const $0147bee01cff6558$export$296f78a0b892f81a = 3;
const $0147bee01cff6558$export$a60d398fc7b7590e = 4;
const $0147bee01cff6558$export$7d7234c1240a1fc4 = 5;
const $0147bee01cff6558$export$c5e2c52991f30937 = 6;
const $0147bee01cff6558$export$2f843afa843d8916 = 7;
const $0147bee01cff6558$export$e50ac29801f1774d = 0;
const $0147bee01cff6558$export$9f9d94f963c85479 = 1;
const $0147bee01cff6558$export$e641dc52bc3494aa = 2;
const $0147bee01cff6558$export$9fcb6b4294603b2 = 0;
const $0147bee01cff6558$export$98f52c2a46c598ca = 1;
const $0147bee01cff6558$export$74b25e54b3bcd548 = 2;
const $0147bee01cff6558$export$932b3dd283d4a366 = 3;
const $0147bee01cff6558$export$a0d98fe6d7e4af64 = 4;
const $0147bee01cff6558$export$2c7b09c1e9abfb5e = 5;
const $0147bee01cff6558$export$1beec6768cbb3d2d = 300;
const $0147bee01cff6558$export$8759762a6477f2c4 = 301;
const $0147bee01cff6558$export$dc59f8aed047f61d = 302;
const $0147bee01cff6558$export$d64030b316d3b087 = 303;
const $0147bee01cff6558$export$ee99d97d46898098 = 304;
const $0147bee01cff6558$export$dbf3e70ff37af79 = 306;
const $0147bee01cff6558$export$76a9f4355364345c = 307;
const $0147bee01cff6558$export$533346c8e8dac0f5 = 1000;
const $0147bee01cff6558$export$9d9334239a5a5e06 = 1001;
const $0147bee01cff6558$export$c7e7c00b14f51a4f = 1002;
const $0147bee01cff6558$export$727aa5ec3fe39bf0 = 1003;
const $0147bee01cff6558$export$d129e38cf6feaa8c = 1004;
const $0147bee01cff6558$export$14a4936464a36496 = 1004;
const $0147bee01cff6558$export$d2327c1afe5bfdf2 = 1005;
const $0147bee01cff6558$export$cbc5b7f5647595d8 = 1005;
const $0147bee01cff6558$export$8a72f490b25c56c8 = 1006;
const $0147bee01cff6558$export$19a719f377145a13 = 1007;
const $0147bee01cff6558$export$dbe96bee3fe9dbf0 = 1007;
const $0147bee01cff6558$export$5d8599b6a933fb1b = 1008;
const $0147bee01cff6558$export$90d80f1e3506775f = 1008;
const $0147bee01cff6558$export$2e8ce08d3f6f5e10 = 1009;
const $0147bee01cff6558$export$545fce0311a9796a = 1010;
const $0147bee01cff6558$export$88572337f312435f = 1011;
const $0147bee01cff6558$export$c63dc51868b06a9d = 1012;
const $0147bee01cff6558$export$5c612977753abe2 = 1013;
const $0147bee01cff6558$export$c3c7fc4518ebba96 = 1014;
const $0147bee01cff6558$export$f6d331659b644596 = 1015;
const $0147bee01cff6558$export$2697304443f382bc = 1016;
const $0147bee01cff6558$export$b3969b01faf587f2 = 1017;
const $0147bee01cff6558$export$18886f8ae33e90de = 1018;
const $0147bee01cff6558$export$6c8ea339bfab1301 = 1020;
const $0147bee01cff6558$export$988473390501ed4b = 1021;
const $0147bee01cff6558$export$3f8bb04b555a363c = 1023;
const $0147bee01cff6558$export$cc09ccbf6d1ed449 = 1024;
const $0147bee01cff6558$export$9053a81c4a69c289 = 1025;
const $0147bee01cff6558$export$c1b6b5136be58045 = 1026;
const $0147bee01cff6558$export$1e113ac2d0905829 = 1027;
const $0147bee01cff6558$export$4e041a7967d15c4b = 1028;
const $0147bee01cff6558$export$aa92e870a709d190 = 1029;
const $0147bee01cff6558$export$6cdf0b461c7ce8a0 = 1030;
const $0147bee01cff6558$export$1ba1c45f9f77d4d7 = 1031;
const $0147bee01cff6558$export$c200e7d26f592f21 = 1033;
const $0147bee01cff6558$export$21d1799c6d552fc0 = 33776;
const $0147bee01cff6558$export$afa304c3e981b668 = 33777;
const $0147bee01cff6558$export$d2a1a68024a3e56c = 33778;
const $0147bee01cff6558$export$9a79c424327dacf9 = 33779;
const $0147bee01cff6558$export$19ada9bbb1af3573 = 35840;
const $0147bee01cff6558$export$d0f0355bb3d948e4 = 35841;
const $0147bee01cff6558$export$b82296714358084c = 35842;
const $0147bee01cff6558$export$b71692456c47b6c3 = 35843;
const $0147bee01cff6558$export$6ab91af2d757aee7 = 36196;
const $0147bee01cff6558$export$7800993ef8106a6a = 37492;
const $0147bee01cff6558$export$23ed8300a860e7d8 = 37496;
const $0147bee01cff6558$export$dc5570b4a2b92d48 = 37808;
const $0147bee01cff6558$export$68880cd325f8b2fb = 37809;
const $0147bee01cff6558$export$7d2c0be323373d95 = 37810;
const $0147bee01cff6558$export$22b52da301fc3a3e = 37811;
const $0147bee01cff6558$export$c009e2cb4a66485e = 37812;
const $0147bee01cff6558$export$118fff5afa255b63 = 37813;
const $0147bee01cff6558$export$120713c829ae0667 = 37814;
const $0147bee01cff6558$export$c79eeabbf53313e9 = 37815;
const $0147bee01cff6558$export$443cf6567cdd6424 = 37816;
const $0147bee01cff6558$export$6573984fc9840780 = 37817;
const $0147bee01cff6558$export$e7aee563f30091de = 37818;
const $0147bee01cff6558$export$2eb8634622ddeab7 = 37819;
const $0147bee01cff6558$export$202b1ce7b5d25742 = 37820;
const $0147bee01cff6558$export$18ab77abd087e467 = 37821;
const $0147bee01cff6558$export$ce40b115e188bc81 = 36492;
const $0147bee01cff6558$export$d62fdc9d1b1cccad = 2200;
const $0147bee01cff6558$export$dfaf4422ce096e29 = 2201;
const $0147bee01cff6558$export$f8f6f2041b78e210 = 2202;
const $0147bee01cff6558$export$995b32462a65e855 = 2300;
const $0147bee01cff6558$export$30fac1aace31cf4d = 2301;
const $0147bee01cff6558$export$198b11ff4c72bb30 = 2302;
const $0147bee01cff6558$export$7f795934b84ab523 = 2400;
const $0147bee01cff6558$export$24a4ccb5099273b5 = 2401;
const $0147bee01cff6558$export$8e8c3ecdcd8e1fee = 2402;
const $0147bee01cff6558$export$bcfbbdcf8de7f8cd = 2500;
const $0147bee01cff6558$export$d875e029ef558d3 = 2501;
const $0147bee01cff6558$export$4c28c87c2dc84758 = 0;
const $0147bee01cff6558$export$b23a071aa286eb29 = 1;
const $0147bee01cff6558$export$f0d8293634f88842 = 2;
const $0147bee01cff6558$export$7207336e4151a112 = 3000;
const $0147bee01cff6558$export$f32388edbb32674 = 3001;
const $0147bee01cff6558$export$deeb383078690b50 = 3200;
const $0147bee01cff6558$export$8f910f4c4f73df11 = 3201;
const $0147bee01cff6558$export$2852a58ebdac27b8 = 0;
const $0147bee01cff6558$export$9990ad26f9db5b2c = 1;
const $0147bee01cff6558$export$69433f11f42d5527 = 0;
const $0147bee01cff6558$export$9f542ae4b5baca34 = 7680;
const $0147bee01cff6558$export$8a4f28336ef203d3 = 7681;
const $0147bee01cff6558$export$2928c0231297c036 = 7682;
const $0147bee01cff6558$export$c0e9611c8a15f9a8 = 7683;
const $0147bee01cff6558$export$9c2c08927385dcc4 = 34055;
const $0147bee01cff6558$export$7c74ea00fa1315e6 = 34056;
const $0147bee01cff6558$export$22e2e5726612443 = 5386;
const $0147bee01cff6558$export$1343870698229224 = 512;
const $0147bee01cff6558$export$8e1d8ed281997fa6 = 513;
const $0147bee01cff6558$export$55648a1cde8329a7 = 514;
const $0147bee01cff6558$export$2dff107857e6aca2 = 515;
const $0147bee01cff6558$export$6f93765ab2f451a2 = 516;
const $0147bee01cff6558$export$6f3fb2d2440f2b76 = 517;
const $0147bee01cff6558$export$4119cf7b4c98fd5a = 518;
const $0147bee01cff6558$export$14cf96713ddd97a8 = 519;
const $0147bee01cff6558$export$763e8360f4d7f77d = 35044;
const $0147bee01cff6558$export$8505d14ac8546ca = 35048;
const $0147bee01cff6558$export$721e63549e51d81e = 35040;
const $0147bee01cff6558$export$415731dc4f48e299 = 35045;
const $0147bee01cff6558$export$9e809946455f13bc = 35049;
const $0147bee01cff6558$export$2ed9499a35b5f832 = 35041;
const $0147bee01cff6558$export$32ab2503ea19469a = 35046;
const $0147bee01cff6558$export$ab4022c2c3f86315 = 35050;
const $0147bee01cff6558$export$ba7f1db36a76a970 = 35042;
const $0147bee01cff6558$export$43600cc67fabd9f = "100";
const $0147bee01cff6558$export$f63012db5506e7dd = "300 es";
const $0147bee01cff6558$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $0147bee01cff6558$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $0147bee01cff6558$var$_lut = [];
for(let i = 0; i < 256; i++)$0147bee01cff6558$var$_lut[i] = (i < 16 ? "0" : "") + i.toString(16);
let $0147bee01cff6558$var$_seed = 1234567;
const $0147bee01cff6558$var$DEG2RAD = Math.PI / 180;
const $0147bee01cff6558$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $0147bee01cff6558$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $0147bee01cff6558$var$_lut[d0 & 0xff] + $0147bee01cff6558$var$_lut[d0 >> 8 & 0xff] + $0147bee01cff6558$var$_lut[d0 >> 16 & 0xff] + $0147bee01cff6558$var$_lut[d0 >> 24 & 0xff] + "-" + $0147bee01cff6558$var$_lut[d1 & 0xff] + $0147bee01cff6558$var$_lut[d1 >> 8 & 0xff] + "-" + $0147bee01cff6558$var$_lut[d1 >> 16 & 0x0f | 0x40] + $0147bee01cff6558$var$_lut[d1 >> 24 & 0xff] + "-" + $0147bee01cff6558$var$_lut[d2 & 0x3f | 0x80] + $0147bee01cff6558$var$_lut[d2 >> 8 & 0xff] + "-" + $0147bee01cff6558$var$_lut[d2 >> 16 & 0xff] + $0147bee01cff6558$var$_lut[d2 >> 24 & 0xff] + $0147bee01cff6558$var$_lut[d3 & 0xff] + $0147bee01cff6558$var$_lut[d3 >> 8 & 0xff] + $0147bee01cff6558$var$_lut[d3 >> 16 & 0xff] + $0147bee01cff6558$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
function $0147bee01cff6558$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidian modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $0147bee01cff6558$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $0147bee01cff6558$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $0147bee01cff6558$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $0147bee01cff6558$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $0147bee01cff6558$var$damp(x, y, lambda, dt) {
    return $0147bee01cff6558$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $0147bee01cff6558$var$pingpong(x, length = 1) {
    return length - Math.abs($0147bee01cff6558$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $0147bee01cff6558$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $0147bee01cff6558$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $0147bee01cff6558$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $0147bee01cff6558$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $0147bee01cff6558$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $0147bee01cff6558$var$seededRandom(s) {
    if (s !== undefined) $0147bee01cff6558$var$_seed = s % 2147483647;
    // Park-Miller algorithm
    $0147bee01cff6558$var$_seed = $0147bee01cff6558$var$_seed * 16807 % 2147483647;
    return ($0147bee01cff6558$var$_seed - 1) / 2147483646;
}
function $0147bee01cff6558$var$degToRad(degrees) {
    return degrees * $0147bee01cff6558$var$DEG2RAD;
}
function $0147bee01cff6558$var$radToDeg(radians) {
    return radians * $0147bee01cff6558$var$RAD2DEG;
}
function $0147bee01cff6558$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $0147bee01cff6558$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $0147bee01cff6558$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $0147bee01cff6558$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
var $0147bee01cff6558$export$380958644dbbc22b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $0147bee01cff6558$var$DEG2RAD,
    RAD2DEG: $0147bee01cff6558$var$RAD2DEG,
    generateUUID: $0147bee01cff6558$var$generateUUID,
    clamp: $0147bee01cff6558$var$clamp,
    euclideanModulo: $0147bee01cff6558$var$euclideanModulo,
    mapLinear: $0147bee01cff6558$var$mapLinear,
    inverseLerp: $0147bee01cff6558$var$inverseLerp,
    lerp: $0147bee01cff6558$var$lerp,
    damp: $0147bee01cff6558$var$damp,
    pingpong: $0147bee01cff6558$var$pingpong,
    smoothstep: $0147bee01cff6558$var$smoothstep,
    smootherstep: $0147bee01cff6558$var$smootherstep,
    randInt: $0147bee01cff6558$var$randInt,
    randFloat: $0147bee01cff6558$var$randFloat,
    randFloatSpread: $0147bee01cff6558$var$randFloatSpread,
    seededRandom: $0147bee01cff6558$var$seededRandom,
    degToRad: $0147bee01cff6558$var$degToRad,
    radToDeg: $0147bee01cff6558$var$radToDeg,
    isPowerOfTwo: $0147bee01cff6558$var$isPowerOfTwo,
    ceilPowerOfTwo: $0147bee01cff6558$var$ceilPowerOfTwo,
    floorPowerOfTwo: $0147bee01cff6558$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $0147bee01cff6558$var$setQuaternionFromProperEuler
});
class $0147bee01cff6558$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
$0147bee01cff6558$export$c977b3e384af9ae1.prototype.isVector2 = true;
class $0147bee01cff6558$export$8ff26dafa08918 {
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
$0147bee01cff6558$export$8ff26dafa08918.prototype.isMatrix3 = true;
function $0147bee01cff6558$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] > 65535) return true;
    }
    return false;
}
const $0147bee01cff6558$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $0147bee01cff6558$var$getTypedArray(type, buffer) {
    return new $0147bee01cff6558$var$TYPED_ARRAYS[type](buffer);
}
function $0147bee01cff6558$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
const $0147bee01cff6558$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $0147bee01cff6558$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $0147bee01cff6558$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $0147bee01cff6558$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $0147bee01cff6558$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $0147bee01cff6558$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
class $0147bee01cff6558$export$892596cec99bc70e {
    constructor(r, g, b){
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === "number") this.setHex(value);
        else if (typeof value === "string") this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        return this;
    }
    setRGB(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
        return this;
    }
    setHSL(h, s, l) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $0147bee01cff6558$var$euclideanModulo(h, 1);
        s = $0147bee01cff6558$var$clamp(s, 0, 1);
        l = $0147bee01cff6558$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $0147bee01cff6558$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $0147bee01cff6558$var$hue2rgb(q, p, h);
            this.b = $0147bee01cff6558$var$hue2rgb(q, p, h - 1 / 3);
        }
        return this;
    }
    setStyle(style) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseInt(color[2], 10) / 100;
                        const l = parseInt(color[3], 10) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style);
        return this;
    }
    setColorName(style) {
        // color keywords
        const hex = $0147bee01cff6558$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $0147bee01cff6558$var$SRGBToLinear(color.r);
        this.g = $0147bee01cff6558$var$SRGBToLinear(color.g);
        this.b = $0147bee01cff6558$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $0147bee01cff6558$var$LinearToSRGB(color.r);
        this.g = $0147bee01cff6558$var$LinearToSRGB(color.g);
        this.b = $0147bee01cff6558$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex() {
        return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
    }
    getHexString() {
        return ("000000" + this.getHex().toString(16)).slice(-6);
    }
    getHSL(target) {
        // h,s,l ranges are in 0.0 - 1.0
        const r = this.r, g = this.g, b = this.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getStyle() {
        return "rgb(" + (this.r * 255 | 0) + "," + (this.g * 255 | 0) + "," + (this.b * 255 | 0) + ")";
    }
    offsetHSL(h, s, l) {
        this.getHSL($0147bee01cff6558$var$_hslA);
        $0147bee01cff6558$var$_hslA.h += h;
        $0147bee01cff6558$var$_hslA.s += s;
        $0147bee01cff6558$var$_hslA.l += l;
        this.setHSL($0147bee01cff6558$var$_hslA.h, $0147bee01cff6558$var$_hslA.s, $0147bee01cff6558$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($0147bee01cff6558$var$_hslA);
        color.getHSL($0147bee01cff6558$var$_hslB);
        const h = $0147bee01cff6558$var$lerp($0147bee01cff6558$var$_hslA.h, $0147bee01cff6558$var$_hslB.h, alpha);
        const s = $0147bee01cff6558$var$lerp($0147bee01cff6558$var$_hslA.s, $0147bee01cff6558$var$_hslB.s, alpha);
        const l = $0147bee01cff6558$var$lerp($0147bee01cff6558$var$_hslA.l, $0147bee01cff6558$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        if (attribute.normalized === true) {
            // assuming Uint8Array
            this.r /= 255;
            this.g /= 255;
            this.b /= 255;
        }
        return this;
    }
    toJSON() {
        return this.getHex();
    }
}
$0147bee01cff6558$export$892596cec99bc70e.NAMES = $0147bee01cff6558$var$_colorKeywords;
$0147bee01cff6558$export$892596cec99bc70e.prototype.isColor = true;
$0147bee01cff6558$export$892596cec99bc70e.prototype.r = 1;
$0147bee01cff6558$export$892596cec99bc70e.prototype.g = 1;
$0147bee01cff6558$export$892596cec99bc70e.prototype.b = 1;
let $0147bee01cff6558$var$_canvas;
class $0147bee01cff6558$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($0147bee01cff6558$var$_canvas === undefined) $0147bee01cff6558$var$_canvas = $0147bee01cff6558$var$createElementNS("canvas");
            $0147bee01cff6558$var$_canvas.width = image.width;
            $0147bee01cff6558$var$_canvas.height = image.height;
            const context = $0147bee01cff6558$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $0147bee01cff6558$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $0147bee01cff6558$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $0147bee01cff6558$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($0147bee01cff6558$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $0147bee01cff6558$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
let $0147bee01cff6558$var$textureId = 0;
class $0147bee01cff6558$export$5431306cf43de24a extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(image = $0147bee01cff6558$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $0147bee01cff6558$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $0147bee01cff6558$export$9d9334239a5a5e06, wrapT = $0147bee01cff6558$export$9d9334239a5a5e06, magFilter = $0147bee01cff6558$export$8a72f490b25c56c8, minFilter = $0147bee01cff6558$export$5d8599b6a933fb1b, format = $0147bee01cff6558$export$3f8bb04b555a363c, type = $0147bee01cff6558$export$2e8ce08d3f6f5e10, anisotropy = 1, encoding = $0147bee01cff6558$export$7207336e4151a112){
        super();
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$textureId++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.name = "";
        this.image = image;
        this.mipmaps = [];
        this.mapping = mapping;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.center = new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $0147bee01cff6558$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        this.encoding = encoding;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.image = source.image;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (this.image !== undefined) {
            // TODO: Move to THREE.Image
            const image = this.image;
            if (image.uuid === undefined) image.uuid = $0147bee01cff6558$var$generateUUID(); // UGH
            if (!isRootObject && meta.images[image.uuid] === undefined) {
                let url;
                if (Array.isArray(image)) {
                    // process array of images e.g. CubeTexture
                    url = [];
                    for(let i = 0, l = image.length; i < l; i++)// check cube texture with data textures
                    if (image[i].isDataTexture) url.push($0147bee01cff6558$var$serializeImage(image[i].image));
                    else url.push($0147bee01cff6558$var$serializeImage(image[i]));
                } else // process single image
                url = $0147bee01cff6558$var$serializeImage(image);
                meta.images[image.uuid] = {
                    uuid: image.uuid,
                    url: url
                };
            }
            output.image = image.uuid;
        }
        if (JSON.stringify(this.userData) !== "{}") output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $0147bee01cff6558$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $0147bee01cff6558$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $0147bee01cff6558$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $0147bee01cff6558$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $0147bee01cff6558$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $0147bee01cff6558$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $0147bee01cff6558$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
$0147bee01cff6558$export$5431306cf43de24a.DEFAULT_IMAGE = undefined;
$0147bee01cff6558$export$5431306cf43de24a.DEFAULT_MAPPING = $0147bee01cff6558$export$1beec6768cbb3d2d;
$0147bee01cff6558$export$5431306cf43de24a.prototype.isTexture = true;
function $0147bee01cff6558$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $0147bee01cff6558$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.prototype.slice.call(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
class $0147bee01cff6558$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
$0147bee01cff6558$export$fa7daccca11cdbe3.prototype.isVector4 = true;
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $0147bee01cff6558$export$3c052beb2e51e23f extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(width, height, options = {}){
        super();
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, width, height);
        this.texture = new $0147bee01cff6558$export$5431306cf43de24a(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.isRenderTargetTexture = true;
        this.texture.image = {
            width: width,
            height: height,
            depth: 1
        };
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
    }
    setTexture(texture) {
        texture.image = {
            width: this.width,
            height: this.height,
            depth: this.depth
        };
        this.texture = texture;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        // ensure image object is not shared, see #20328
        this.texture.image = Object.assign({}, source.texture.image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$0147bee01cff6558$export$3c052beb2e51e23f.prototype.isWebGLRenderTarget = true;
class $0147bee01cff6558$export$bd934554fb721730 extends $0147bee01cff6558$export$3c052beb2e51e23f {
    constructor(width, height, count){
        super(width, height);
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++)this.texture[i] = texture.clone();
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.set(0, 0, this.width, this.height);
        this.scissor.set(0, 0, this.width, this.height);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++)this.texture[i] = source.texture[i].clone();
        return this;
    }
}
$0147bee01cff6558$export$bd934554fb721730.prototype.isWebGLMultipleRenderTargets = true;
class $0147bee01cff6558$export$cb2022643d3c928d extends $0147bee01cff6558$export$3c052beb2e51e23f {
    constructor(width, height, options = {}){
        super(width, height, options);
        this.samples = 4;
        this.ignoreDepthForMultisampleCopy = options.ignoreDepth !== undefined ? options.ignoreDepth : true;
        this.useRenderToTexture = options.useRenderToTexture !== undefined ? options.useRenderToTexture : false;
        this.useRenderbuffer = this.useRenderToTexture === false;
    }
    copy(source) {
        super.copy.call(this, source);
        this.samples = source.samples;
        this.useRenderToTexture = source.useRenderToTexture;
        this.useRenderbuffer = source.useRenderbuffer;
        return this;
    }
}
$0147bee01cff6558$export$cb2022643d3c928d.prototype.isWebGLMultisampleRenderTarget = true;
class $0147bee01cff6558$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerp(qa, qb, qm, t) {
        console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.");
        return qm.slerpQuaternions(qa, qb, t);
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($0147bee01cff6558$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q, p) {
        if (p !== undefined) {
            console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.");
            return this.multiplyQuaternions(q, p);
        }
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
$0147bee01cff6558$export$23d6a54f0bbc85a3.prototype.isQuaternion = true;
class $0147bee01cff6558$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.");
            return this.multiplyVectors(v, w);
        }
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
        return this.applyQuaternion($0147bee01cff6558$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($0147bee01cff6558$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.");
            return this.crossVectors(v, w);
        }
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $0147bee01cff6558$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($0147bee01cff6558$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($0147bee01cff6558$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($0147bee01cff6558$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
$0147bee01cff6558$export$64b5c384219d3699.prototype.isVector3 = true;
const $0147bee01cff6558$var$_vector$c = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_quaternion$4 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
class $0147bee01cff6558$export$6f7d5a9418ab2aa3 {
    constructor(min = new $0147bee01cff6558$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $0147bee01cff6558$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $0147bee01cff6558$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (precise && geometry.attributes != undefined && geometry.attributes.position !== undefined) {
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count; i < l; i++){
                    $0147bee01cff6558$var$_vector$b.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                    this.expandByPoint($0147bee01cff6558$var$_vector$b);
                }
            } else {
                if (geometry.boundingBox === null) geometry.computeBoundingBox();
                $0147bee01cff6558$var$_box$3.copy(geometry.boundingBox);
                $0147bee01cff6558$var$_box$3.applyMatrix4(object.matrixWorld);
                this.union($0147bee01cff6558$var$_box$3);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $0147bee01cff6558$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $0147bee01cff6558$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($0147bee01cff6558$var$_center);
        $0147bee01cff6558$var$_extents.subVectors(this.max, $0147bee01cff6558$var$_center);
        // translate triangle to aabb origin
        $0147bee01cff6558$var$_v0$2.subVectors(triangle.a, $0147bee01cff6558$var$_center);
        $0147bee01cff6558$var$_v1$7.subVectors(triangle.b, $0147bee01cff6558$var$_center);
        $0147bee01cff6558$var$_v2$3.subVectors(triangle.c, $0147bee01cff6558$var$_center);
        // compute edge vectors for triangle
        $0147bee01cff6558$var$_f0.subVectors($0147bee01cff6558$var$_v1$7, $0147bee01cff6558$var$_v0$2);
        $0147bee01cff6558$var$_f1.subVectors($0147bee01cff6558$var$_v2$3, $0147bee01cff6558$var$_v1$7);
        $0147bee01cff6558$var$_f2.subVectors($0147bee01cff6558$var$_v0$2, $0147bee01cff6558$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$0147bee01cff6558$var$_f0.z,
            $0147bee01cff6558$var$_f0.y,
            0,
            -$0147bee01cff6558$var$_f1.z,
            $0147bee01cff6558$var$_f1.y,
            0,
            -$0147bee01cff6558$var$_f2.z,
            $0147bee01cff6558$var$_f2.y,
            $0147bee01cff6558$var$_f0.z,
            0,
            -$0147bee01cff6558$var$_f0.x,
            $0147bee01cff6558$var$_f1.z,
            0,
            -$0147bee01cff6558$var$_f1.x,
            $0147bee01cff6558$var$_f2.z,
            0,
            -$0147bee01cff6558$var$_f2.x,
            -$0147bee01cff6558$var$_f0.y,
            $0147bee01cff6558$var$_f0.x,
            0,
            -$0147bee01cff6558$var$_f1.y,
            $0147bee01cff6558$var$_f1.x,
            0,
            -$0147bee01cff6558$var$_f2.y,
            $0147bee01cff6558$var$_f2.x,
            0
        ];
        if (!$0147bee01cff6558$var$satForAxes(axes, $0147bee01cff6558$var$_v0$2, $0147bee01cff6558$var$_v1$7, $0147bee01cff6558$var$_v2$3, $0147bee01cff6558$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$0147bee01cff6558$var$satForAxes(axes, $0147bee01cff6558$var$_v0$2, $0147bee01cff6558$var$_v1$7, $0147bee01cff6558$var$_v2$3, $0147bee01cff6558$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $0147bee01cff6558$var$_triangleNormal.crossVectors($0147bee01cff6558$var$_f0, $0147bee01cff6558$var$_f1);
        axes = [
            $0147bee01cff6558$var$_triangleNormal.x,
            $0147bee01cff6558$var$_triangleNormal.y,
            $0147bee01cff6558$var$_triangleNormal.z
        ];
        return $0147bee01cff6558$var$satForAxes(axes, $0147bee01cff6558$var$_v0$2, $0147bee01cff6558$var$_v1$7, $0147bee01cff6558$var$_v2$3, $0147bee01cff6558$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $0147bee01cff6558$var$_vector$b.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        this.getCenter(target.center);
        target.radius = this.getSize($0147bee01cff6558$var$_vector$b).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $0147bee01cff6558$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $0147bee01cff6558$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $0147bee01cff6558$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $0147bee01cff6558$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $0147bee01cff6558$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $0147bee01cff6558$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $0147bee01cff6558$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $0147bee01cff6558$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($0147bee01cff6558$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
$0147bee01cff6558$export$6f7d5a9418ab2aa3.prototype.isBox3 = true;
const $0147bee01cff6558$var$_points = [
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699()
];
const $0147bee01cff6558$var$_vector$b = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_box$3 = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $0147bee01cff6558$var$_v0$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v1$7 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2$3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
// triangle edge vectors
const $0147bee01cff6558$var$_f0 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_f1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_f2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_center = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_extents = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_triangleNormal = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_testAxis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
function $0147bee01cff6558$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $0147bee01cff6558$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the seperating axis
        const r = extents.x * Math.abs($0147bee01cff6558$var$_testAxis.x) + extents.y * Math.abs($0147bee01cff6558$var$_testAxis.y) + extents.z * Math.abs($0147bee01cff6558$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the seperating axis
        const p0 = v0.dot($0147bee01cff6558$var$_testAxis);
        const p1 = v1.dot($0147bee01cff6558$var$_testAxis);
        const p2 = v2.dot($0147bee01cff6558$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is seperating and we can exit
        return false;
    }
    return true;
}
const $0147bee01cff6558$var$_box$2 = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
const $0147bee01cff6558$var$_v1$6 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_toFarthestPoint = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_toPoint = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$805e8b72413ccaba {
    constructor(center = new $0147bee01cff6558$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $0147bee01cff6558$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
        $0147bee01cff6558$var$_toPoint.subVectors(point, this.center);
        const lengthSq = $0147bee01cff6558$var$_toPoint.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            const length = Math.sqrt(lengthSq);
            const missingRadiusHalf = (length - this.radius) * 0.5;
            // Nudge this sphere towards the target point. Add half the missing distance to radius,
            // and the other half to position. This gives a tighter enclosure, instead of if
            // the whole missing distance were just added to radius.
            this.center.add($0147bee01cff6558$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
            this.radius += missingRadiusHalf;
        }
        return this;
    }
    union(sphere) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
        // To enclose another sphere into this sphere, we only need to enclose two points:
        // 1) Enclose the farthest point on the other sphere into this sphere.
        // 2) Enclose the opposite point of the farthest point into this sphere.
        if (this.center.equals(sphere.center) === true) $0147bee01cff6558$var$_toFarthestPoint.set(0, 0, 1).multiplyScalar(sphere.radius);
        else $0147bee01cff6558$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
        this.expandByPoint($0147bee01cff6558$var$_v1$6.copy(sphere.center).add($0147bee01cff6558$var$_toFarthestPoint));
        this.expandByPoint($0147bee01cff6558$var$_v1$6.copy(sphere.center).sub($0147bee01cff6558$var$_toFarthestPoint));
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0147bee01cff6558$var$_vector$a = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_segCenter = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_segDir = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_diff = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_edge1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_edge2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_normal$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$a186db52eed6d40e {
    constructor(origin = new $0147bee01cff6558$export$64b5c384219d3699(), direction = new $0147bee01cff6558$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $0147bee01cff6558$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $0147bee01cff6558$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $0147bee01cff6558$var$_vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return $0147bee01cff6558$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $0147bee01cff6558$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $0147bee01cff6558$var$_segDir.copy(v1).sub(v0).normalize();
        $0147bee01cff6558$var$_diff.copy(this.origin).sub($0147bee01cff6558$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($0147bee01cff6558$var$_segDir);
        const b0 = $0147bee01cff6558$var$_diff.dot(this.direction);
        const b1 = -$0147bee01cff6558$var$_diff.dot($0147bee01cff6558$var$_segDir);
        const c = $0147bee01cff6558$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($0147bee01cff6558$var$_segDir).multiplyScalar(s1).add($0147bee01cff6558$var$_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $0147bee01cff6558$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $0147bee01cff6558$var$_vector$a.dot(this.direction);
        const d2 = $0147bee01cff6558$var$_vector$a.dot($0147bee01cff6558$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $0147bee01cff6558$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $0147bee01cff6558$var$_edge1.subVectors(b, a);
        $0147bee01cff6558$var$_edge2.subVectors(c, a);
        $0147bee01cff6558$var$_normal$1.crossVectors($0147bee01cff6558$var$_edge1, $0147bee01cff6558$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($0147bee01cff6558$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $0147bee01cff6558$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($0147bee01cff6558$var$_edge2.crossVectors($0147bee01cff6558$var$_diff, $0147bee01cff6558$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($0147bee01cff6558$var$_edge1.cross($0147bee01cff6558$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $0147bee01cff6558$var$_diff.dot($0147bee01cff6558$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0147bee01cff6558$export$2ae72fc923e5eb5 {
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $0147bee01cff6558$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $0147bee01cff6558$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $0147bee01cff6558$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $0147bee01cff6558$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($0147bee01cff6558$var$_zero, q, $0147bee01cff6558$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $0147bee01cff6558$var$_z.subVectors(eye, target);
        if ($0147bee01cff6558$var$_z.lengthSq() === 0) // eye and target are in the same position
        $0147bee01cff6558$var$_z.z = 1;
        $0147bee01cff6558$var$_z.normalize();
        $0147bee01cff6558$var$_x.crossVectors(up, $0147bee01cff6558$var$_z);
        if ($0147bee01cff6558$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $0147bee01cff6558$var$_z.x += 0.0001;
            else $0147bee01cff6558$var$_z.z += 0.0001;
            $0147bee01cff6558$var$_z.normalize();
            $0147bee01cff6558$var$_x.crossVectors(up, $0147bee01cff6558$var$_z);
        }
        $0147bee01cff6558$var$_x.normalize();
        $0147bee01cff6558$var$_y.crossVectors($0147bee01cff6558$var$_z, $0147bee01cff6558$var$_x);
        te[0] = $0147bee01cff6558$var$_x.x;
        te[4] = $0147bee01cff6558$var$_y.x;
        te[8] = $0147bee01cff6558$var$_z.x;
        te[1] = $0147bee01cff6558$var$_x.y;
        te[5] = $0147bee01cff6558$var$_y.y;
        te[9] = $0147bee01cff6558$var$_z.y;
        te[2] = $0147bee01cff6558$var$_x.z;
        te[6] = $0147bee01cff6558$var$_y.z;
        te[10] = $0147bee01cff6558$var$_z.z;
        return this;
    }
    multiply(m, n) {
        if (n !== undefined) {
            console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.");
            return this.multiplyMatrices(m, n);
        }
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $0147bee01cff6558$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $0147bee01cff6558$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $0147bee01cff6558$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $0147bee01cff6558$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $0147bee01cff6558$var$_m1$2.elements[0] *= invSX;
        $0147bee01cff6558$var$_m1$2.elements[1] *= invSX;
        $0147bee01cff6558$var$_m1$2.elements[2] *= invSX;
        $0147bee01cff6558$var$_m1$2.elements[4] *= invSY;
        $0147bee01cff6558$var$_m1$2.elements[5] *= invSY;
        $0147bee01cff6558$var$_m1$2.elements[6] *= invSY;
        $0147bee01cff6558$var$_m1$2.elements[8] *= invSZ;
        $0147bee01cff6558$var$_m1$2.elements[9] *= invSZ;
        $0147bee01cff6558$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($0147bee01cff6558$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        if (far === undefined) console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
const $0147bee01cff6558$var$_v1$5 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_m1$2 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_zero = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 0);
const $0147bee01cff6558$var$_one = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(1, 1, 1);
const $0147bee01cff6558$var$_x = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_y = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_z = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_matrix$1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_quaternion$3 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
class $0147bee01cff6558$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $0147bee01cff6558$export$d93cc409a0768c5f.DefaultOrder){
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($0147bee01cff6558$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$0147bee01cff6558$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($0147bee01cff6558$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$0147bee01cff6558$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($0147bee01cff6558$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$0147bee01cff6558$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $0147bee01cff6558$var$_matrix$1.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($0147bee01cff6558$var$_matrix$1, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $0147bee01cff6558$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($0147bee01cff6558$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    toVector3(optionalResult) {
        if (optionalResult) return optionalResult.set(this._x, this._y, this._z);
        else return new $0147bee01cff6558$export$64b5c384219d3699(this._x, this._y, this._z);
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
$0147bee01cff6558$export$d93cc409a0768c5f.prototype.isEuler = true;
$0147bee01cff6558$export$d93cc409a0768c5f.DefaultOrder = "XYZ";
$0147bee01cff6558$export$d93cc409a0768c5f.RotationOrders = [
    "XYZ",
    "YZX",
    "ZXY",
    "XZY",
    "YXZ",
    "ZYX"
];
class $0147bee01cff6558$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $0147bee01cff6558$var$_object3DId = 0;
const $0147bee01cff6558$var$_v1$4 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_q1 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
const $0147bee01cff6558$var$_m1$1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_target = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_position$3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_scale$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_quaternion$2 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
const $0147bee01cff6558$var$_xAxis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(1, 0, 0);
const $0147bee01cff6558$var$_yAxis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0);
const $0147bee01cff6558$var$_zAxis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1);
const $0147bee01cff6558$var$_addedEvent = {
    type: "added"
};
const $0147bee01cff6558$var$_removedEvent = {
    type: "removed"
};
class $0147bee01cff6558$export$e4dd07dff30cc924 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$_object3DId++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $0147bee01cff6558$export$e4dd07dff30cc924.DefaultUp.clone();
        const position = new $0147bee01cff6558$export$64b5c384219d3699();
        const rotation = new $0147bee01cff6558$export$d93cc409a0768c5f();
        const quaternion = new $0147bee01cff6558$export$23d6a54f0bbc85a3();
        const scale = new $0147bee01cff6558$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $0147bee01cff6558$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $0147bee01cff6558$export$8ff26dafa08918()
            }
        });
        this.matrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.matrixWorld = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $0147bee01cff6558$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate;
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $0147bee01cff6558$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $0147bee01cff6558$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($0147bee01cff6558$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $0147bee01cff6558$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($0147bee01cff6558$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($0147bee01cff6558$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($0147bee01cff6558$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($0147bee01cff6558$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $0147bee01cff6558$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($0147bee01cff6558$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($0147bee01cff6558$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($0147bee01cff6558$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($0147bee01cff6558$var$_zAxis, distance);
    }
    localToWorld(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        return vector.applyMatrix4($0147bee01cff6558$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $0147bee01cff6558$var$_target.copy(x);
        else $0147bee01cff6558$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $0147bee01cff6558$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $0147bee01cff6558$var$_m1$1.lookAt($0147bee01cff6558$var$_position$3, $0147bee01cff6558$var$_target, this.up);
        else $0147bee01cff6558$var$_m1$1.lookAt($0147bee01cff6558$var$_target, $0147bee01cff6558$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($0147bee01cff6558$var$_m1$1);
        if (parent) {
            $0147bee01cff6558$var$_m1$1.extractRotation(parent.matrixWorld);
            $0147bee01cff6558$var$_q1.setFromRotationMatrix($0147bee01cff6558$var$_m1$1);
            this.quaternion.premultiply($0147bee01cff6558$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($0147bee01cff6558$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($0147bee01cff6558$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($0147bee01cff6558$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $0147bee01cff6558$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $0147bee01cff6558$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($0147bee01cff6558$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($0147bee01cff6558$var$_position$3, target, $0147bee01cff6558$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($0147bee01cff6558$var$_position$3, $0147bee01cff6558$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {}
            };
            output.metadata = {
                version: 4.5,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== "{}") object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$0147bee01cff6558$export$e4dd07dff30cc924.DefaultUp = new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0);
$0147bee01cff6558$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate = true;
$0147bee01cff6558$export$e4dd07dff30cc924.prototype.isObject3D = true;
const $0147bee01cff6558$var$_v0$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v1$3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v3$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vab = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vac = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vbc = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vap = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vbp = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vcp = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$5a465592bfe74b48 {
    constructor(a = new $0147bee01cff6558$export$64b5c384219d3699(), b = new $0147bee01cff6558$export$64b5c384219d3699(), c = new $0147bee01cff6558$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $0147bee01cff6558$var$_v0$1.subVectors(a, b);
        target.cross($0147bee01cff6558$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $0147bee01cff6558$var$_v0$1.subVectors(c, a);
        $0147bee01cff6558$var$_v1$3.subVectors(b, a);
        $0147bee01cff6558$var$_v2$2.subVectors(point, a);
        const dot00 = $0147bee01cff6558$var$_v0$1.dot($0147bee01cff6558$var$_v0$1);
        const dot01 = $0147bee01cff6558$var$_v0$1.dot($0147bee01cff6558$var$_v1$3);
        const dot02 = $0147bee01cff6558$var$_v0$1.dot($0147bee01cff6558$var$_v2$2);
        const dot11 = $0147bee01cff6558$var$_v1$3.dot($0147bee01cff6558$var$_v1$3);
        const dot12 = $0147bee01cff6558$var$_v1$3.dot($0147bee01cff6558$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $0147bee01cff6558$var$_v3$1);
        return $0147bee01cff6558$var$_v3$1.x >= 0 && $0147bee01cff6558$var$_v3$1.y >= 0 && $0147bee01cff6558$var$_v3$1.x + $0147bee01cff6558$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, $0147bee01cff6558$var$_v3$1);
        target.set(0, 0);
        target.addScaledVector(uv1, $0147bee01cff6558$var$_v3$1.x);
        target.addScaledVector(uv2, $0147bee01cff6558$var$_v3$1.y);
        target.addScaledVector(uv3, $0147bee01cff6558$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $0147bee01cff6558$var$_v0$1.subVectors(c, b);
        $0147bee01cff6558$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $0147bee01cff6558$var$_v0$1.cross($0147bee01cff6558$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $0147bee01cff6558$var$_v0$1.subVectors(this.c, this.b);
        $0147bee01cff6558$var$_v1$3.subVectors(this.a, this.b);
        return $0147bee01cff6558$var$_v0$1.cross($0147bee01cff6558$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $0147bee01cff6558$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $0147bee01cff6558$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return $0147bee01cff6558$export$5a465592bfe74b48.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return $0147bee01cff6558$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $0147bee01cff6558$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $0147bee01cff6558$var$_vab.subVectors(b, a);
        $0147bee01cff6558$var$_vac.subVectors(c, a);
        $0147bee01cff6558$var$_vap.subVectors(p, a);
        const d1 = $0147bee01cff6558$var$_vab.dot($0147bee01cff6558$var$_vap);
        const d2 = $0147bee01cff6558$var$_vac.dot($0147bee01cff6558$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $0147bee01cff6558$var$_vbp.subVectors(p, b);
        const d3 = $0147bee01cff6558$var$_vab.dot($0147bee01cff6558$var$_vbp);
        const d4 = $0147bee01cff6558$var$_vac.dot($0147bee01cff6558$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($0147bee01cff6558$var$_vab, v);
        }
        $0147bee01cff6558$var$_vcp.subVectors(p, c);
        const d5 = $0147bee01cff6558$var$_vab.dot($0147bee01cff6558$var$_vcp);
        const d6 = $0147bee01cff6558$var$_vac.dot($0147bee01cff6558$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($0147bee01cff6558$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $0147bee01cff6558$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($0147bee01cff6558$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($0147bee01cff6558$var$_vab, v).addScaledVector($0147bee01cff6558$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $0147bee01cff6558$var$materialId = 0;
class $0147bee01cff6558$export$a2d8b23205c25948 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$materialId++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.fog = true;
        this.blending = $0147bee01cff6558$export$5b29a26d96ee6af0;
        this.side = $0147bee01cff6558$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $0147bee01cff6558$export$d5773124e86cf28c;
        this.blendDst = $0147bee01cff6558$export$11d468cc7f19e971;
        this.blendEquation = $0147bee01cff6558$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $0147bee01cff6558$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $0147bee01cff6558$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $0147bee01cff6558$export$9f542ae4b5baca34;
        this.stencilZFail = $0147bee01cff6558$export$9f542ae4b5baca34;
        this.stencilZPass = $0147bee01cff6558$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.alphaWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn("THREE.Material: '" + key + "' parameter is undefined.");
                continue;
            }
            // for backward compatability if shading is set in the constructor
            if (key === "shading") {
                console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
                this.flatShading = newValue === $0147bee01cff6558$export$a62047d29c96d8ff ? true : false;
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn("THREE." + this.type + ": '" + key + "' is not a property of this material.");
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRoot = meta === undefined || typeof meta === "string";
        if (isRoot) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $0147bee01cff6558$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $0147bee01cff6558$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.alphaWrite = this.alphaWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (JSON.stringify(this.userData) !== "{}") data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.fog = source.fog;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.alphaWrite = source.alphaWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
$0147bee01cff6558$export$a2d8b23205c25948.prototype.isMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 * }
 */ class $0147bee01cff6558$export$55cbcc9b622fe1f5 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshBasicMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0147bee01cff6558$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        return this;
    }
}
$0147bee01cff6558$export$55cbcc9b622fe1f5.prototype.isMeshBasicMaterial = true;
const $0147bee01cff6558$var$_vector$9 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vector2$1 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
class $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized === true;
        this.usage = $0147bee01cff6558$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    copyColorsArray(colors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = colors.length; i < l; i++){
            let color = colors[i];
            if (color === undefined) {
                console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", i);
                color = new $0147bee01cff6558$export$892596cec99bc70e();
            }
            array[offset++] = color.r;
            array[offset++] = color.g;
            array[offset++] = color.b;
        }
        return this;
    }
    copyVector2sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", i);
                vector = new $0147bee01cff6558$export$c977b3e384af9ae1();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
        }
        return this;
    }
    copyVector3sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", i);
                vector = new $0147bee01cff6558$export$64b5c384219d3699();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
        }
        return this;
    }
    copyVector4sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", i);
                vector = new $0147bee01cff6558$export$fa7daccca11cdbe3();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
            array[offset++] = vector.w;
        }
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector2$1.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $0147bee01cff6558$var$_vector2$1.x, $0147bee01cff6558$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$9.fromBufferAttribute(this, i);
            $0147bee01cff6558$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$9.x, $0147bee01cff6558$var$_vector$9.y, $0147bee01cff6558$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$9.x = this.getX(i);
            $0147bee01cff6558$var$_vector$9.y = this.getY(i);
            $0147bee01cff6558$var$_vector$9.z = this.getZ(i);
            $0147bee01cff6558$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$9.x, $0147bee01cff6558$var$_vector$9.y, $0147bee01cff6558$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$9.x = this.getX(i);
            $0147bee01cff6558$var$_vector$9.y = this.getY(i);
            $0147bee01cff6558$var$_vector$9.z = this.getZ(i);
            $0147bee01cff6558$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$9.x, $0147bee01cff6558$var$_vector$9.y, $0147bee01cff6558$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$9.x = this.getX(i);
            $0147bee01cff6558$var$_vector$9.y = this.getY(i);
            $0147bee01cff6558$var$_vector$9.z = this.getZ(i);
            $0147bee01cff6558$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$9.x, $0147bee01cff6558$var$_vector$9.y, $0147bee01cff6558$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        return this.array[index * this.itemSize];
    }
    setX(index, x) {
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        return this.array[index * this.itemSize + 1];
    }
    setY(index, y) {
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        return this.array[index * this.itemSize + 2];
    }
    setZ(index, z) {
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        return this.array[index * this.itemSize + 3];
    }
    setW(index, w) {
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.prototype.slice.call(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $0147bee01cff6558$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
$0147bee01cff6558$export$8dea267bd6bde117.prototype.isBufferAttribute = true;
//
class $0147bee01cff6558$export$f9ff2d6a20248cbf extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$cacc90cf35d11cdd extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$baaa85a1a812c157 extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$2b755a102ccdcefe extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$640a853f68025f2e extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$46b369aed2968a0a extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$7eb8c9fa25cd5bd6 extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$dbd3698c64958d69 extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
$0147bee01cff6558$export$dbd3698c64958d69.prototype.isFloat16BufferAttribute = true;
class $0147bee01cff6558$export$cbe7a62641830ebd extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $0147bee01cff6558$export$9e0ade74842adbb8 extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $0147bee01cff6558$var$_id$1 = 0;
const $0147bee01cff6558$var$_m1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_obj = /*@__PURE__*/ new $0147bee01cff6558$export$e4dd07dff30cc924();
const $0147bee01cff6558$var$_offset = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_box$1 = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
const $0147bee01cff6558$var$_boxMorphTargets = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
const $0147bee01cff6558$var$_vector$8 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$b7be63a67df8959 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $0147bee01cff6558$var$_id$1++
        });
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($0147bee01cff6558$var$arrayNeedsUint32(index) ? $0147bee01cff6558$export$7eb8c9fa25cd5bd6 : $0147bee01cff6558$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $0147bee01cff6558$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $0147bee01cff6558$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $0147bee01cff6558$var$_m1.makeRotationX(angle);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $0147bee01cff6558$var$_m1.makeRotationY(angle);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $0147bee01cff6558$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $0147bee01cff6558$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $0147bee01cff6558$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($0147bee01cff6558$var$_m1);
        return this;
    }
    lookAt(vector) {
        $0147bee01cff6558$var$_obj.lookAt(vector);
        $0147bee01cff6558$var$_obj.updateMatrix();
        this.applyMatrix4($0147bee01cff6558$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($0147bee01cff6558$var$_offset).negate();
        this.translate($0147bee01cff6558$var$_offset.x, $0147bee01cff6558$var$_offset.y, $0147bee01cff6558$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $0147bee01cff6558$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $0147bee01cff6558$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $0147bee01cff6558$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $0147bee01cff6558$var$_vector$8.addVectors(this.boundingBox.min, $0147bee01cff6558$var$_box$1.min);
                    this.boundingBox.expandByPoint($0147bee01cff6558$var$_vector$8);
                    $0147bee01cff6558$var$_vector$8.addVectors(this.boundingBox.max, $0147bee01cff6558$var$_box$1.max);
                    this.boundingBox.expandByPoint($0147bee01cff6558$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($0147bee01cff6558$var$_box$1.min);
                    this.boundingBox.expandByPoint($0147bee01cff6558$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $0147bee01cff6558$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $0147bee01cff6558$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $0147bee01cff6558$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $0147bee01cff6558$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $0147bee01cff6558$var$_vector$8.addVectors($0147bee01cff6558$var$_box$1.min, $0147bee01cff6558$var$_boxMorphTargets.min);
                    $0147bee01cff6558$var$_box$1.expandByPoint($0147bee01cff6558$var$_vector$8);
                    $0147bee01cff6558$var$_vector$8.addVectors($0147bee01cff6558$var$_box$1.max, $0147bee01cff6558$var$_boxMorphTargets.max);
                    $0147bee01cff6558$var$_box$1.expandByPoint($0147bee01cff6558$var$_vector$8);
                } else {
                    $0147bee01cff6558$var$_box$1.expandByPoint($0147bee01cff6558$var$_boxMorphTargets.min);
                    $0147bee01cff6558$var$_box$1.expandByPoint($0147bee01cff6558$var$_boxMorphTargets.max);
                }
            }
            $0147bee01cff6558$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $0147bee01cff6558$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($0147bee01cff6558$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $0147bee01cff6558$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $0147bee01cff6558$var$_offset.fromBufferAttribute(position, j);
                        $0147bee01cff6558$var$_vector$8.add($0147bee01cff6558$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($0147bee01cff6558$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (attributes.tangent === undefined) this.setAttribute("tangent", new $0147bee01cff6558$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = attributes.tangent.array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $0147bee01cff6558$export$64b5c384219d3699();
            tan2[i] = new $0147bee01cff6558$export$64b5c384219d3699();
        }
        const vA = new $0147bee01cff6558$export$64b5c384219d3699(), vB = new $0147bee01cff6558$export$64b5c384219d3699(), vC = new $0147bee01cff6558$export$64b5c384219d3699(), uvA = new $0147bee01cff6558$export$c977b3e384af9ae1(), uvB = new $0147bee01cff6558$export$c977b3e384af9ae1(), uvC = new $0147bee01cff6558$export$c977b3e384af9ae1(), sdir = new $0147bee01cff6558$export$64b5c384219d3699(), tdir = new $0147bee01cff6558$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $0147bee01cff6558$export$64b5c384219d3699(), tmp2 = new $0147bee01cff6558$export$64b5c384219d3699();
        const n = new $0147bee01cff6558$export$64b5c384219d3699(), n2 = new $0147bee01cff6558$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $0147bee01cff6558$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $0147bee01cff6558$export$64b5c384219d3699(), pB = new $0147bee01cff6558$export$64b5c384219d3699(), pC = new $0147bee01cff6558$export$64b5c384219d3699();
            const nA = new $0147bee01cff6558$export$64b5c384219d3699(), nB = new $0147bee01cff6558$export$64b5c384219d3699(), nC = new $0147bee01cff6558$export$64b5c384219d3699();
            const cb = new $0147bee01cff6558$export$64b5c384219d3699(), ab = new $0147bee01cff6558$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge(geometry, offset) {
        if (!(geometry && geometry.isBufferGeometry)) {
            console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", geometry);
            return;
        }
        if (offset === undefined) {
            offset = 0;
            console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
        }
        const attributes = this.attributes;
        for(const key in attributes){
            if (geometry.attributes[key] === undefined) continue;
            const attribute1 = attributes[key];
            const attributeArray1 = attribute1.array;
            const attribute2 = geometry.attributes[key];
            const attributeArray2 = attribute2.array;
            const attributeOffset = attribute2.itemSize * offset;
            const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
            for(let i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
        }
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $0147bee01cff6558$var$_vector$8.fromBufferAttribute(normals, i);
            $0147bee01cff6558$var$_vector$8.normalize();
            normals.setXYZ(i, $0147bee01cff6558$var$_vector$8.x, $0147bee01cff6558$var$_vector$8.y, $0147bee01cff6558$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $0147bee01cff6558$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $0147bee01cff6558$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        // geometry generator parameters
        if (source.parameters !== undefined) this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$0147bee01cff6558$export$b7be63a67df8959.prototype.isBufferGeometry = true;
const $0147bee01cff6558$var$_inverseMatrix$2 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_ray$2 = /*@__PURE__*/ new $0147bee01cff6558$export$a186db52eed6d40e();
const $0147bee01cff6558$var$_sphere$3 = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
const $0147bee01cff6558$var$_vA$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vB$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vC$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_tempA = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_tempB = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_tempC = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_morphA = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_morphB = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_morphC = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_uvA$1 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_uvB$1 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_uvC$1 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_intersectionPoint = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_intersectionPointWorld = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$e176487c05830cc5 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(geometry = new $0147bee01cff6558$export$b7be63a67df8959(), material = new $0147bee01cff6558$export$55cbcc9b622fe1f5()){
        super();
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere$3.copy(geometry.boundingSphere);
        $0147bee01cff6558$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($0147bee01cff6558$var$_sphere$3) === false) return;
        //
        $0147bee01cff6558$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $0147bee01cff6558$var$_ray$2.copy(raycaster.ray).applyMatrix4($0147bee01cff6558$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($0147bee01cff6558$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const position = geometry.attributes.position;
            const morphPosition = geometry.morphAttributes.position;
            const morphTargetsRelative = geometry.morphTargetsRelative;
            const uv = geometry.attributes.uv;
            const uv2 = geometry.attributes.uv2;
            const groups = geometry.groups;
            const drawRange = geometry.drawRange;
            if (index !== null) {
                // indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = index.getX(j);
                        const b = index.getX(j + 1);
                        const c = index.getX(j + 2);
                        intersection = $0147bee01cff6558$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $0147bee01cff6558$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = index.getX(i);
                        const b = index.getX(i + 1);
                        const c = index.getX(i + 2);
                        intersection = $0147bee01cff6558$var$checkBufferGeometryIntersection(this, material, raycaster, $0147bee01cff6558$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            } else if (position !== undefined) {
                // non-indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = j;
                        const b = j + 1;
                        const c = j + 2;
                        intersection = $0147bee01cff6558$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $0147bee01cff6558$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(position.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = i;
                        const b = i + 1;
                        const c = i + 2;
                        intersection = $0147bee01cff6558$var$checkBufferGeometryIntersection(this, material, raycaster, $0147bee01cff6558$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            }
        } else if (geometry.isGeometry) console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
}
$0147bee01cff6558$export$e176487c05830cc5.prototype.isMesh = true;
function $0147bee01cff6558$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== $0147bee01cff6558$export$3b296b6f144d5b03, point);
    if (intersect === null) return null;
    $0147bee01cff6558$var$_intersectionPointWorld.copy(point);
    $0147bee01cff6558$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($0147bee01cff6558$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $0147bee01cff6558$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $0147bee01cff6558$var$checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    $0147bee01cff6558$var$_vA$1.fromBufferAttribute(position, a);
    $0147bee01cff6558$var$_vB$1.fromBufferAttribute(position, b);
    $0147bee01cff6558$var$_vC$1.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (morphPosition && morphInfluences) {
        $0147bee01cff6558$var$_morphA.set(0, 0, 0);
        $0147bee01cff6558$var$_morphB.set(0, 0, 0);
        $0147bee01cff6558$var$_morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            $0147bee01cff6558$var$_tempA.fromBufferAttribute(morphAttribute, a);
            $0147bee01cff6558$var$_tempB.fromBufferAttribute(morphAttribute, b);
            $0147bee01cff6558$var$_tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                $0147bee01cff6558$var$_morphA.addScaledVector($0147bee01cff6558$var$_tempA, influence);
                $0147bee01cff6558$var$_morphB.addScaledVector($0147bee01cff6558$var$_tempB, influence);
                $0147bee01cff6558$var$_morphC.addScaledVector($0147bee01cff6558$var$_tempC, influence);
            } else {
                $0147bee01cff6558$var$_morphA.addScaledVector($0147bee01cff6558$var$_tempA.sub($0147bee01cff6558$var$_vA$1), influence);
                $0147bee01cff6558$var$_morphB.addScaledVector($0147bee01cff6558$var$_tempB.sub($0147bee01cff6558$var$_vB$1), influence);
                $0147bee01cff6558$var$_morphC.addScaledVector($0147bee01cff6558$var$_tempC.sub($0147bee01cff6558$var$_vC$1), influence);
            }
        }
        $0147bee01cff6558$var$_vA$1.add($0147bee01cff6558$var$_morphA);
        $0147bee01cff6558$var$_vB$1.add($0147bee01cff6558$var$_morphB);
        $0147bee01cff6558$var$_vC$1.add($0147bee01cff6558$var$_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, $0147bee01cff6558$var$_vA$1);
        object.boneTransform(b, $0147bee01cff6558$var$_vB$1);
        object.boneTransform(c, $0147bee01cff6558$var$_vC$1);
    }
    const intersection = $0147bee01cff6558$var$checkIntersection(object, material, raycaster, ray, $0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, $0147bee01cff6558$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $0147bee01cff6558$var$_uvA$1.fromBufferAttribute(uv, a);
            $0147bee01cff6558$var$_uvB$1.fromBufferAttribute(uv, b);
            $0147bee01cff6558$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $0147bee01cff6558$export$5a465592bfe74b48.getUV($0147bee01cff6558$var$_intersectionPoint, $0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, $0147bee01cff6558$var$_uvA$1, $0147bee01cff6558$var$_uvB$1, $0147bee01cff6558$var$_uvC$1, new $0147bee01cff6558$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $0147bee01cff6558$var$_uvA$1.fromBufferAttribute(uv2, a);
            $0147bee01cff6558$var$_uvB$1.fromBufferAttribute(uv2, b);
            $0147bee01cff6558$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $0147bee01cff6558$export$5a465592bfe74b48.getUV($0147bee01cff6558$var$_intersectionPoint, $0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, $0147bee01cff6558$var$_uvA$1, $0147bee01cff6558$var$_uvB$1, $0147bee01cff6558$var$_uvC$1, new $0147bee01cff6558$export$c977b3e384af9ae1());
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $0147bee01cff6558$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $0147bee01cff6558$export$5a465592bfe74b48.getNormal($0147bee01cff6558$var$_vA$1, $0147bee01cff6558$var$_vB$1, $0147bee01cff6558$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $0147bee01cff6558$export$ab3456a079aa7d80 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $0147bee01cff6558$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$ab3456a079aa7d80(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $0147bee01cff6558$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $0147bee01cff6558$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $0147bee01cff6558$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
// Legacy
const $0147bee01cff6558$export$d8ecdf8615bfea69 = {
    clone: $0147bee01cff6558$var$cloneUniforms,
    merge: $0147bee01cff6558$var$mergeUniforms
};
var $0147bee01cff6558$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $0147bee01cff6558$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>
 * }
 */ class $0147bee01cff6558$export$83c7d75d550a8b0d extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.vertexShader = $0147bee01cff6558$var$default_vertex;
        this.fragmentShader = $0147bee01cff6558$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv2": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) {
            if (parameters.attributes !== undefined) console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.");
            this.setValues(parameters);
        }
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $0147bee01cff6558$var$cloneUniforms(source.uniforms);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
$0147bee01cff6558$export$83c7d75d550a8b0d.prototype.isShaderMaterial = true;
class $0147bee01cff6558$export$79f141de891a5fed extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Camera";
        this.matrixWorldInverse = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $0147bee01cff6558$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
$0147bee01cff6558$export$79f141de891a5fed.prototype.isCamera = true;
class $0147bee01cff6558$export$74e4ae24825f68d7 extends $0147bee01cff6558$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $0147bee01cff6558$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($0147bee01cff6558$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $0147bee01cff6558$var$RAD2DEG * 2 * Math.atan(Math.tan($0147bee01cff6558$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($0147bee01cff6558$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
$0147bee01cff6558$export$74e4ae24825f68d7.prototype.isPerspectiveCamera = true;
const $0147bee01cff6558$var$fov = 90, $0147bee01cff6558$var$aspect = 1;
class $0147bee01cff6558$export$d0cdd0bd804995de extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        if (renderTarget.isWebGLCubeRenderTarget !== true) {
            console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
            return;
        }
        this.renderTarget = renderTarget;
        const cameraPX = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(new $0147bee01cff6558$export$64b5c384219d3699(1, 0, 0));
        this.add(cameraPX);
        const cameraNX = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(new $0147bee01cff6558$export$64b5c384219d3699(-1, 0, 0));
        this.add(cameraNX);
        const cameraPY = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0));
        this.add(cameraPY);
        const cameraNY = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(new $0147bee01cff6558$export$64b5c384219d3699(0, -1, 0));
        this.add(cameraNY);
        const cameraPZ = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1));
        this.add(cameraPZ);
        const cameraNZ = new $0147bee01cff6558$export$74e4ae24825f68d7($0147bee01cff6558$var$fov, $0147bee01cff6558$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(new $0147bee01cff6558$export$64b5c384219d3699(0, 0, -1));
        this.add(cameraNZ);
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentXrEnabled = renderer.xr.enabled;
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $0147bee01cff6558$export$ee2e5a18258a4049 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $0147bee01cff6558$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
$0147bee01cff6558$export$ee2e5a18258a4049.prototype.isCubeTexture = true;
class $0147bee01cff6558$export$ac386671d651941e extends $0147bee01cff6558$export$3c052beb2e51e23f {
    constructor(size, options, dummy){
        if (Number.isInteger(options)) {
            console.warn("THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )");
            options = dummy;
        }
        super(size, size, options);
        options = options || {};
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture = new $0147bee01cff6558$export$ee2e5a18258a4049(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.format = $0147bee01cff6558$export$3f8bb04b555a363c; // see #18859
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $0147bee01cff6558$export$ab3456a079aa7d80(5, 5, 5);
        const material = new $0147bee01cff6558$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $0147bee01cff6558$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $0147bee01cff6558$export$d9f0486e75b5ace,
            blending: $0147bee01cff6558$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $0147bee01cff6558$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $0147bee01cff6558$export$5d8599b6a933fb1b) texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
        const camera = new $0147bee01cff6558$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
$0147bee01cff6558$export$ac386671d651941e.prototype.isWebGLCubeRenderTarget = true;
const $0147bee01cff6558$var$_vector1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vector2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_normalMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$8ff26dafa08918();
class $0147bee01cff6558$export$7ff5ac152ef991b0 {
    constructor(normal = new $0147bee01cff6558$export$64b5c384219d3699(1, 0, 0), constant = 0){
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $0147bee01cff6558$var$_vector1.subVectors(c, b).cross($0147bee01cff6558$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        const direction = line.delta($0147bee01cff6558$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $0147bee01cff6558$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($0147bee01cff6558$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
$0147bee01cff6558$export$7ff5ac152ef991b0.prototype.isPlane = true;
const $0147bee01cff6558$var$_sphere$2 = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
const $0147bee01cff6558$var$_vector$7 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$35efe6f4c85463d2 {
    constructor(p0 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p1 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p2 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p3 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p4 = new $0147bee01cff6558$export$7ff5ac152ef991b0(), p5 = new $0147bee01cff6558$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere($0147bee01cff6558$var$_sphere$2);
    }
    intersectsSprite(sprite) {
        $0147bee01cff6558$var$_sphere$2.center.set(0, 0, 0);
        $0147bee01cff6558$var$_sphere$2.radius = 0.7071067811865476;
        $0147bee01cff6558$var$_sphere$2.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($0147bee01cff6558$var$_sphere$2);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $0147bee01cff6558$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $0147bee01cff6558$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $0147bee01cff6558$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($0147bee01cff6558$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $0147bee01cff6558$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $0147bee01cff6558$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type = 5126;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Float64Array) console.warn("THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.");
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else console.warn("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $0147bee01cff6558$export$e789a11a194ca4e0 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$e789a11a194ca4e0(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $0147bee01cff6558$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var $0147bee01cff6558$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $0147bee01cff6558$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $0147bee01cff6558$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $0147bee01cff6558$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $0147bee01cff6558$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $0147bee01cff6558$var$begin_vertex = "vec3 transformed = vec3( position );";
var $0147bee01cff6558$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $0147bee01cff6558$var$bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif";
var $0147bee01cff6558$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vUv );\n		vec2 dSTdy = dFdy( vUv );\n		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n		vec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $0147bee01cff6558$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $0147bee01cff6558$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $0147bee01cff6558$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $0147bee01cff6558$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $0147bee01cff6558$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $0147bee01cff6558$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $0147bee01cff6558$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $0147bee01cff6558$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $0147bee01cff6558$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n	vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n	return dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}";
var $0147bee01cff6558$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_maxMipLevel 8.0\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_maxTileSize 256.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		float texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n		vec2 uv = getUV( direction, face ) * ( faceSize - 1.0 ) + 0.5;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		if ( mipInt < cubeUV_maxMipLevel ) {\n			uv.y += 2.0 * cubeUV_maxTileSize;\n		}\n		uv.y += filterInt * 2.0 * cubeUV_minTileSize;\n		uv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n		uv *= texelSize;\n		return texture2D( envMap, uv ).rgb;\n	}\n	#define r0 1.0\n	#define v0 0.339\n	#define m0 - 2.0\n	#define r1 0.8\n	#define v1 0.276\n	#define m1 - 1.0\n	#define r4 0.4\n	#define v4 0.046\n	#define m4 2.0\n	#define r5 0.305\n	#define v5 0.016\n	#define m5 3.0\n	#define r6 0.21\n	#define v6 0.0038\n	#define m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= r1 ) {\n			mip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n		} else if ( roughness >= r4 ) {\n			mip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n		} else if ( roughness >= r5 ) {\n			mip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n		} else if ( roughness >= r6 ) {\n			mip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $0147bee01cff6558$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $0147bee01cff6558$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $0147bee01cff6558$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var $0147bee01cff6558$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $0147bee01cff6558$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $0147bee01cff6558$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $0147bee01cff6558$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $0147bee01cff6558$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $0147bee01cff6558$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $0147bee01cff6558$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $0147bee01cff6558$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $0147bee01cff6558$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $0147bee01cff6558$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $0147bee01cff6558$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $0147bee01cff6558$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $0147bee01cff6558$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $0147bee01cff6558$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		return ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n	#endif\n}";
var $0147bee01cff6558$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		lightMapIrradiance *= PI;\n	#endif\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $0147bee01cff6558$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $0147bee01cff6558$var$lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n	vLightBack = vec3( 0.0 );\n	vIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n	vIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n	vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		getPointLightInfo( pointLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		getSpotLightInfo( spotLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n		vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		#ifdef DOUBLE_SIDED\n			vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif";
var $0147bee01cff6558$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#else\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $0147bee01cff6558$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	#ifdef ENVMAP_MODE_REFRACTION\n		uniform float refractionRatio;\n	#endif\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 reflectVec;\n			#ifdef ENVMAP_MODE_REFLECTION\n				reflectVec = reflect( - viewDir, normal );\n				reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			#else\n				reflectVec = refract( - viewDir, normal, refractionRatio );\n			#endif\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n#endif";
var $0147bee01cff6558$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $0147bee01cff6558$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )	(0)";
var $0147bee01cff6558$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $0147bee01cff6558$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )	(0)";
var $0147bee01cff6558$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	#ifdef SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULARINTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n		#endif\n		#ifdef USE_SPECULARCOLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEENCOLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEENROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n	#endif\n#endif";
var $0147bee01cff6558$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	vec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	vec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $0147bee01cff6558$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $0147bee01cff6558$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			lightMapIrradiance *= PI;\n		#endif\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $0147bee01cff6558$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $0147bee01cff6558$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $0147bee01cff6558$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $0147bee01cff6558$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $0147bee01cff6558$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $0147bee01cff6558$var$map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var $0147bee01cff6558$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $0147bee01cff6558$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $0147bee01cff6558$var$map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	uniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $0147bee01cff6558$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $0147bee01cff6558$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $0147bee01cff6558$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1, 2 ) * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $0147bee01cff6558$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform vec2 morphTargetsTextureSize;\n		vec3 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset, const in int stride ) {\n			float texelIndex = float( vertexIndex * stride + offset );\n			float y = floor( texelIndex / morphTargetsTextureSize.x );\n			float x = texelIndex - y * morphTargetsTextureSize.x;\n			vec3 morphUV = vec3( ( x + 0.5 ) / morphTargetsTextureSize.x, y / morphTargetsTextureSize.y, morphTargetIndex );\n			return texture( morphTargetsTexture, morphUV ).xyz;\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $0147bee01cff6558$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			#ifndef USE_MORPHNORMALS\n				if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0, 1 ) * morphTargetInfluences[ i ];\n			#else\n				if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0, 2 ) * morphTargetInfluences[ i ];\n			#endif\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $0147bee01cff6558$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n	vec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	#ifdef USE_TANGENT\n		vec3 tangent = normalize( vTangent );\n		vec3 bitangent = normalize( vBitangent );\n		#ifdef DOUBLE_SIDED\n			tangent = tangent * faceDirection;\n			bitangent = bitangent * faceDirection;\n		#endif\n		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n			mat3 vTBN = mat3( tangent, bitangent, normal );\n		#endif\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $0147bee01cff6558$var$normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	#ifdef USE_TANGENT\n		normal = normalize( vTBN * mapN );\n	#else\n		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n	#endif\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $0147bee01cff6558$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $0147bee01cff6558$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $0147bee01cff6558$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $0147bee01cff6558$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n		vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n		vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n		vec2 st0 = dFdx( vUv.st );\n		vec2 st1 = dFdy( vUv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n	}\n#endif";
var $0147bee01cff6558$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $0147bee01cff6558$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	#ifdef USE_TANGENT\n		clearcoatNormal = normalize( vTBN * clearcoatMapN );\n	#else\n		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n	#endif\n#endif";
var $0147bee01cff6558$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif";
var $0147bee01cff6558$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $0147bee01cff6558$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n	return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var $0147bee01cff6558$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $0147bee01cff6558$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $0147bee01cff6558$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $0147bee01cff6558$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $0147bee01cff6558$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $0147bee01cff6558$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $0147bee01cff6558$var$shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n		bool inFrustum = all( inFrustumVec );\n		bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n		bool frustumTest = all( frustumTestVec );\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $0147bee01cff6558$var$shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $0147bee01cff6558$var$shadowmap_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		vec4 shadowWorldPosition;\n	#endif\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n		vSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n#endif";
var $0147bee01cff6558$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $0147bee01cff6558$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $0147bee01cff6558$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	#ifdef BONE_TEXTURE\n		uniform highp sampler2D boneTexture;\n		uniform int boneTextureSize;\n		mat4 getBoneMatrix( const in float i ) {\n			float j = i * 4.0;\n			float x = mod( j, float( boneTextureSize ) );\n			float y = floor( j / float( boneTextureSize ) );\n			float dx = 1.0 / float( boneTextureSize );\n			float dy = 1.0 / float( boneTextureSize );\n			y = dy * ( y + 0.5 );\n			vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n			vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n			vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n			vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n			mat4 bone = mat4( v1, v2, v3, v4 );\n			return bone;\n		}\n	#else\n		uniform mat4 boneMatrices[ MAX_BONES ];\n		mat4 getBoneMatrix( const in float i ) {\n			mat4 bone = boneMatrices[ int(i) ];\n			return bone;\n		}\n	#endif\n#endif";
var $0147bee01cff6558$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $0147bee01cff6558$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $0147bee01cff6558$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $0147bee01cff6558$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $0147bee01cff6558$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $0147bee01cff6558$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $0147bee01cff6558$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	float transmissionAlpha = 1.0;\n	float transmissionFactor = transmission;\n	float thicknessFactor = thickness;\n	#ifdef USE_TRANSMISSIONMAP\n		transmissionFactor *= texture2D( transmissionMap, vUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		thicknessFactor *= texture2D( thicknessMap, vUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmission = getIBLVolumeRefraction(\n		n, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n		attenuationColor, attenuationDistance );\n	totalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n	transmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif";
var $0147bee01cff6558$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		#ifdef TEXTURE_LOD_EXT\n			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#else\n			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#endif\n	}\n	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( attenuationDistance == 0.0 ) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n	}\n#endif";
var $0147bee01cff6558$var$uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n	varying vec2 vUv;\n#endif";
var $0147bee01cff6558$var$uv_pars_vertex = "#ifdef USE_UV\n	#ifdef UVS_VERTEX_ONLY\n		vec2 vUv;\n	#else\n		varying vec2 vUv;\n	#endif\n	uniform mat3 uvTransform;\n#endif";
var $0147bee01cff6558$var$uv_vertex = "#ifdef USE_UV\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var $0147bee01cff6558$var$uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	varying vec2 vUv2;\n#endif";
var $0147bee01cff6558$var$uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	attribute vec2 uv2;\n	varying vec2 vUv2;\n	uniform mat3 uv2Transform;\n#endif";
var $0147bee01cff6558$var$uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var $0147bee01cff6558$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $0147bee01cff6558$var$vertex$g = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $0147bee01cff6558$var$fragment$g = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n	gl_FragColor = texture2D( t2D, vUv );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $0147bee01cff6558$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $0147bee01cff6558$var$fragment$f = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	vec3 vReflect = vWorldDirection;\n	#include <envmap_fragment>\n	gl_FragColor = envColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $0147bee01cff6558$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $0147bee01cff6558$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $0147bee01cff6558$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $0147bee01cff6558$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $0147bee01cff6558$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $0147bee01cff6558$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $0147bee01cff6558$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $0147bee01cff6558$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$9 = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <lights_lambert_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$9 = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <emissivemap_fragment>\n	#ifdef DOUBLE_SIDED\n		reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n	#else\n		reflectedLight.indirectDiffuse += vIndirectFront;\n	#endif\n	#include <lightmap_fragment>\n	reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n	#ifdef DOUBLE_SIDED\n		reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n	#else\n		reflectedLight.directDiffuse = vLightFront;\n	#endif\n	reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $0147bee01cff6558$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $0147bee01cff6558$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}";
const $0147bee01cff6558$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $0147bee01cff6558$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULARINTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n	#ifdef USE_SPECULARCOLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEENCOLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEENROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0147bee01cff6558$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $0147bee01cff6558$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $0147bee01cff6558$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $0147bee01cff6558$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $0147bee01cff6558$export$955f9f2e84c43c8b = {
    alphamap_fragment: $0147bee01cff6558$var$alphamap_fragment,
    alphamap_pars_fragment: $0147bee01cff6558$var$alphamap_pars_fragment,
    alphatest_fragment: $0147bee01cff6558$var$alphatest_fragment,
    alphatest_pars_fragment: $0147bee01cff6558$var$alphatest_pars_fragment,
    aomap_fragment: $0147bee01cff6558$var$aomap_fragment,
    aomap_pars_fragment: $0147bee01cff6558$var$aomap_pars_fragment,
    begin_vertex: $0147bee01cff6558$var$begin_vertex,
    beginnormal_vertex: $0147bee01cff6558$var$beginnormal_vertex,
    bsdfs: $0147bee01cff6558$var$bsdfs,
    bumpmap_pars_fragment: $0147bee01cff6558$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $0147bee01cff6558$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $0147bee01cff6558$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $0147bee01cff6558$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $0147bee01cff6558$var$clipping_planes_vertex,
    color_fragment: $0147bee01cff6558$var$color_fragment,
    color_pars_fragment: $0147bee01cff6558$var$color_pars_fragment,
    color_pars_vertex: $0147bee01cff6558$var$color_pars_vertex,
    color_vertex: $0147bee01cff6558$var$color_vertex,
    common: $0147bee01cff6558$var$common,
    cube_uv_reflection_fragment: $0147bee01cff6558$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $0147bee01cff6558$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $0147bee01cff6558$var$displacementmap_pars_vertex,
    displacementmap_vertex: $0147bee01cff6558$var$displacementmap_vertex,
    emissivemap_fragment: $0147bee01cff6558$var$emissivemap_fragment,
    emissivemap_pars_fragment: $0147bee01cff6558$var$emissivemap_pars_fragment,
    encodings_fragment: $0147bee01cff6558$var$encodings_fragment,
    encodings_pars_fragment: $0147bee01cff6558$var$encodings_pars_fragment,
    envmap_fragment: $0147bee01cff6558$var$envmap_fragment,
    envmap_common_pars_fragment: $0147bee01cff6558$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $0147bee01cff6558$var$envmap_pars_fragment,
    envmap_pars_vertex: $0147bee01cff6558$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $0147bee01cff6558$var$envmap_physical_pars_fragment,
    envmap_vertex: $0147bee01cff6558$var$envmap_vertex,
    fog_vertex: $0147bee01cff6558$var$fog_vertex,
    fog_pars_vertex: $0147bee01cff6558$var$fog_pars_vertex,
    fog_fragment: $0147bee01cff6558$var$fog_fragment,
    fog_pars_fragment: $0147bee01cff6558$var$fog_pars_fragment,
    gradientmap_pars_fragment: $0147bee01cff6558$var$gradientmap_pars_fragment,
    lightmap_fragment: $0147bee01cff6558$var$lightmap_fragment,
    lightmap_pars_fragment: $0147bee01cff6558$var$lightmap_pars_fragment,
    lights_lambert_vertex: $0147bee01cff6558$var$lights_lambert_vertex,
    lights_pars_begin: $0147bee01cff6558$var$lights_pars_begin,
    lights_toon_fragment: $0147bee01cff6558$var$lights_toon_fragment,
    lights_toon_pars_fragment: $0147bee01cff6558$var$lights_toon_pars_fragment,
    lights_phong_fragment: $0147bee01cff6558$var$lights_phong_fragment,
    lights_phong_pars_fragment: $0147bee01cff6558$var$lights_phong_pars_fragment,
    lights_physical_fragment: $0147bee01cff6558$var$lights_physical_fragment,
    lights_physical_pars_fragment: $0147bee01cff6558$var$lights_physical_pars_fragment,
    lights_fragment_begin: $0147bee01cff6558$var$lights_fragment_begin,
    lights_fragment_maps: $0147bee01cff6558$var$lights_fragment_maps,
    lights_fragment_end: $0147bee01cff6558$var$lights_fragment_end,
    logdepthbuf_fragment: $0147bee01cff6558$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $0147bee01cff6558$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $0147bee01cff6558$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $0147bee01cff6558$var$logdepthbuf_vertex,
    map_fragment: $0147bee01cff6558$var$map_fragment,
    map_pars_fragment: $0147bee01cff6558$var$map_pars_fragment,
    map_particle_fragment: $0147bee01cff6558$var$map_particle_fragment,
    map_particle_pars_fragment: $0147bee01cff6558$var$map_particle_pars_fragment,
    metalnessmap_fragment: $0147bee01cff6558$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $0147bee01cff6558$var$metalnessmap_pars_fragment,
    morphnormal_vertex: $0147bee01cff6558$var$morphnormal_vertex,
    morphtarget_pars_vertex: $0147bee01cff6558$var$morphtarget_pars_vertex,
    morphtarget_vertex: $0147bee01cff6558$var$morphtarget_vertex,
    normal_fragment_begin: $0147bee01cff6558$var$normal_fragment_begin,
    normal_fragment_maps: $0147bee01cff6558$var$normal_fragment_maps,
    normal_pars_fragment: $0147bee01cff6558$var$normal_pars_fragment,
    normal_pars_vertex: $0147bee01cff6558$var$normal_pars_vertex,
    normal_vertex: $0147bee01cff6558$var$normal_vertex,
    normalmap_pars_fragment: $0147bee01cff6558$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $0147bee01cff6558$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $0147bee01cff6558$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $0147bee01cff6558$var$clearcoat_pars_fragment,
    output_fragment: $0147bee01cff6558$var$output_fragment,
    packing: $0147bee01cff6558$var$packing,
    premultiplied_alpha_fragment: $0147bee01cff6558$var$premultiplied_alpha_fragment,
    project_vertex: $0147bee01cff6558$var$project_vertex,
    dithering_fragment: $0147bee01cff6558$var$dithering_fragment,
    dithering_pars_fragment: $0147bee01cff6558$var$dithering_pars_fragment,
    roughnessmap_fragment: $0147bee01cff6558$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $0147bee01cff6558$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $0147bee01cff6558$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $0147bee01cff6558$var$shadowmap_pars_vertex,
    shadowmap_vertex: $0147bee01cff6558$var$shadowmap_vertex,
    shadowmask_pars_fragment: $0147bee01cff6558$var$shadowmask_pars_fragment,
    skinbase_vertex: $0147bee01cff6558$var$skinbase_vertex,
    skinning_pars_vertex: $0147bee01cff6558$var$skinning_pars_vertex,
    skinning_vertex: $0147bee01cff6558$var$skinning_vertex,
    skinnormal_vertex: $0147bee01cff6558$var$skinnormal_vertex,
    specularmap_fragment: $0147bee01cff6558$var$specularmap_fragment,
    specularmap_pars_fragment: $0147bee01cff6558$var$specularmap_pars_fragment,
    tonemapping_fragment: $0147bee01cff6558$var$tonemapping_fragment,
    tonemapping_pars_fragment: $0147bee01cff6558$var$tonemapping_pars_fragment,
    transmission_fragment: $0147bee01cff6558$var$transmission_fragment,
    transmission_pars_fragment: $0147bee01cff6558$var$transmission_pars_fragment,
    uv_pars_fragment: $0147bee01cff6558$var$uv_pars_fragment,
    uv_pars_vertex: $0147bee01cff6558$var$uv_pars_vertex,
    uv_vertex: $0147bee01cff6558$var$uv_vertex,
    uv2_pars_fragment: $0147bee01cff6558$var$uv2_pars_fragment,
    uv2_pars_vertex: $0147bee01cff6558$var$uv2_pars_vertex,
    uv2_vertex: $0147bee01cff6558$var$uv2_vertex,
    worldpos_vertex: $0147bee01cff6558$var$worldpos_vertex,
    background_vert: $0147bee01cff6558$var$vertex$g,
    background_frag: $0147bee01cff6558$var$fragment$g,
    cube_vert: $0147bee01cff6558$var$vertex$f,
    cube_frag: $0147bee01cff6558$var$fragment$f,
    depth_vert: $0147bee01cff6558$var$vertex$e,
    depth_frag: $0147bee01cff6558$var$fragment$e,
    distanceRGBA_vert: $0147bee01cff6558$var$vertex$d,
    distanceRGBA_frag: $0147bee01cff6558$var$fragment$d,
    equirect_vert: $0147bee01cff6558$var$vertex$c,
    equirect_frag: $0147bee01cff6558$var$fragment$c,
    linedashed_vert: $0147bee01cff6558$var$vertex$b,
    linedashed_frag: $0147bee01cff6558$var$fragment$b,
    meshbasic_vert: $0147bee01cff6558$var$vertex$a,
    meshbasic_frag: $0147bee01cff6558$var$fragment$a,
    meshlambert_vert: $0147bee01cff6558$var$vertex$9,
    meshlambert_frag: $0147bee01cff6558$var$fragment$9,
    meshmatcap_vert: $0147bee01cff6558$var$vertex$8,
    meshmatcap_frag: $0147bee01cff6558$var$fragment$8,
    meshnormal_vert: $0147bee01cff6558$var$vertex$7,
    meshnormal_frag: $0147bee01cff6558$var$fragment$7,
    meshphong_vert: $0147bee01cff6558$var$vertex$6,
    meshphong_frag: $0147bee01cff6558$var$fragment$6,
    meshphysical_vert: $0147bee01cff6558$var$vertex$5,
    meshphysical_frag: $0147bee01cff6558$var$fragment$5,
    meshtoon_vert: $0147bee01cff6558$var$vertex$4,
    meshtoon_frag: $0147bee01cff6558$var$fragment$4,
    points_vert: $0147bee01cff6558$var$vertex$3,
    points_frag: $0147bee01cff6558$var$fragment$3,
    shadow_vert: $0147bee01cff6558$var$vertex$2,
    shadow_frag: $0147bee01cff6558$var$fragment$2,
    sprite_vert: $0147bee01cff6558$var$vertex$1,
    sprite_frag: $0147bee01cff6558$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $0147bee01cff6558$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: new $0147bee01cff6558$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new $0147bee01cff6558$export$8ff26dafa08918()
        },
        uv2Transform: {
            value: new $0147bee01cff6558$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: new $0147bee01cff6558$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new $0147bee01cff6558$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $0147bee01cff6558$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: new $0147bee01cff6558$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $0147bee01cff6558$export$8ff26dafa08918()
        }
    }
};
const $0147bee01cff6558$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.specularmap,
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.fog
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.specularmap,
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.emissivemap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            $0147bee01cff6558$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.specularmap,
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.emissivemap,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            $0147bee01cff6558$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: new $0147bee01cff6558$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.emissivemap,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.roughnessmap,
            $0147bee01cff6558$export$6643083551874bf5.metalnessmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            $0147bee01cff6558$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.aomap,
            $0147bee01cff6558$export$6643083551874bf5.lightmap,
            $0147bee01cff6558$export$6643083551874bf5.emissivemap,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.gradientmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            $0147bee01cff6558$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.points,
            $0147bee01cff6558$export$6643083551874bf5.fog
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.bumpmap,
            $0147bee01cff6558$export$6643083551874bf5.normalmap,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.sprite,
            $0147bee01cff6558$export$6643083551874bf5.fog
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $0147bee01cff6558$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.background_frag
    },
    /* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */ cube: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.common,
            $0147bee01cff6558$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: new $0147bee01cff6558$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: $0147bee01cff6558$var$mergeUniforms([
            $0147bee01cff6558$export$6643083551874bf5.lights,
            $0147bee01cff6558$export$6643083551874bf5.fog,
            {
                color: {
                    value: new $0147bee01cff6558$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.shadow_frag
    }
};
$0147bee01cff6558$export$bee4a7d47f8f5014.physical = {
    uniforms: $0147bee01cff6558$var$mergeUniforms([
        $0147bee01cff6558$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new $0147bee01cff6558$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $0147bee01cff6558$export$892596cec99bc70e(0x000000)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: new $0147bee01cff6558$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $0147bee01cff6558$export$955f9f2e84c43c8b.meshphysical_frag
};
function $0147bee01cff6558$var$WebGLBackground(renderer, cubemaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === "additive") background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $0147bee01cff6558$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$ab3456a079aa7d80(1, 1, 1), new $0147bee01cff6558$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $0147bee01cff6558$var$cloneUniforms($0147bee01cff6558$export$bee4a7d47f8f5014.cube.uniforms),
                    vertexShader: $0147bee01cff6558$export$bee4a7d47f8f5014.cube.vertexShader,
                    fragmentShader: $0147bee01cff6558$export$bee4a7d47f8f5014.cube.fragmentShader,
                    side: $0147bee01cff6558$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$e789a11a194ca4e0(2, 2), new $0147bee01cff6558$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $0147bee01cff6558$var$cloneUniforms($0147bee01cff6558$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $0147bee01cff6558$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $0147bee01cff6558$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $0147bee01cff6558$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $0147bee01cff6558$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(geometry, index);
            if (updateBuffers) saveCache(geometry, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (object.isInstancedMesh === true) updateBuffers = true;
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers) {
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(geometry, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in geometryAttributes){
            const cachedAttribute = cachedAttributes[key];
            const geometryAttribute = geometryAttributes[key];
            if (cachedAttribute === undefined) return true;
            if (cachedAttribute.attribute !== geometryAttribute) return true;
            if (cachedAttribute.data !== geometryAttribute.data) return true;
            attributesNum++;
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(geometry, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in attributes){
            const attribute = attributes[key];
            const data = {};
            data.attribute = attribute;
            if (attribute.data) data.data = attribute.data;
            cache[key] = data;
            attributesNum++;
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data && data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatilibity
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $0147bee01cff6558$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $0147bee01cff6558$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== "undefined" && gl instanceof WebGL2ComputeRenderingContext;
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $0147bee01cff6558$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $0147bee01cff6558$export$7ff5ac152ef991b0(), viewNormalMatrix = new $0147bee01cff6558$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $0147bee01cff6558$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $0147bee01cff6558$export$d64030b316d3b087) texture.mapping = $0147bee01cff6558$export$8759762a6477f2c4;
        else if (mapping === $0147bee01cff6558$export$ee99d97d46898098) texture.mapping = $0147bee01cff6558$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $0147bee01cff6558$export$d64030b316d3b087 || mapping === $0147bee01cff6558$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $0147bee01cff6558$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $0147bee01cff6558$export$9ebf355ee4ed261b extends $0147bee01cff6558$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
$0147bee01cff6558$export$9ebf355ee4ed261b.prototype.isOrthographicCamera = true;
class $0147bee01cff6558$export$21c421a2e1df9d22 extends $0147bee01cff6558$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.type = "RawShaderMaterial";
    }
}
$0147bee01cff6558$export$21c421a2e1df9d22.prototype.isRawShaderMaterial = true;
const $0147bee01cff6558$var$LOD_MIN = 4;
const $0147bee01cff6558$var$LOD_MAX = 8;
const $0147bee01cff6558$var$SIZE_MAX = Math.pow(2, $0147bee01cff6558$var$LOD_MAX);
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $0147bee01cff6558$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
const $0147bee01cff6558$var$TOTAL_LODS = $0147bee01cff6558$var$LOD_MAX - $0147bee01cff6558$var$LOD_MIN + 1 + $0147bee01cff6558$var$EXTRA_LOD_SIGMA.length;
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $0147bee01cff6558$var$MAX_SAMPLES = 20;
const $0147bee01cff6558$var$_flatCamera = /*@__PURE__*/ new $0147bee01cff6558$export$9ebf355ee4ed261b();
const { _lodPlanes: $0147bee01cff6558$var$_lodPlanes, _sizeLods: $0147bee01cff6558$var$_sizeLods, _sigmas: $0147bee01cff6558$var$_sigmas } = /*@__PURE__*/ $0147bee01cff6558$var$_createPlanes();
const $0147bee01cff6558$var$_clearColor = /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e();
let $0147bee01cff6558$var$_oldTarget = null;
// Golden Ratio
const $0147bee01cff6558$var$PHI = (1 + Math.sqrt(5)) / 2;
const $0147bee01cff6558$var$INV_PHI = 1 / $0147bee01cff6558$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $0147bee01cff6558$var$_axisDirections = [
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, $0147bee01cff6558$var$PHI, $0147bee01cff6558$var$INV_PHI),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(0, $0147bee01cff6558$var$PHI, -$0147bee01cff6558$var$INV_PHI),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699($0147bee01cff6558$var$INV_PHI, 0, $0147bee01cff6558$var$PHI),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(-$0147bee01cff6558$var$INV_PHI, 0, $0147bee01cff6558$var$PHI),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699($0147bee01cff6558$var$PHI, $0147bee01cff6558$var$INV_PHI, 0),
    /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699(-$0147bee01cff6558$var$PHI, $0147bee01cff6558$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $0147bee01cff6558$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._blurMaterial = $0147bee01cff6558$var$_getBlurShader($0147bee01cff6558$var$MAX_SAMPLES);
        this._equirectShader = null;
        this._cubemapShader = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $0147bee01cff6558$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets();
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapShader === null) {
            this._cubemapShader = $0147bee01cff6558$var$_getCubemapShader();
            this._compileMaterial(this._cubemapShader);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectShader === null) {
            this._equirectShader = $0147bee01cff6558$var$_getEquirectShader();
            this._compileMaterial(this._equirectShader);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        if (this._cubemapShader !== null) this._cubemapShader.dispose();
        if (this._equirectShader !== null) this._equirectShader.dispose();
        for(let i = 0; i < $0147bee01cff6558$var$_lodPlanes.length; i++)$0147bee01cff6558$var$_lodPlanes[i].dispose();
    }
    // private interface
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($0147bee01cff6558$var$_oldTarget);
        outputTarget.scissorTest = false;
        $0147bee01cff6558$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        $0147bee01cff6558$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets(texture);
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets(texture) {
        const params = {
            magFilter: $0147bee01cff6558$export$8a72f490b25c56c8,
            minFilter: $0147bee01cff6558$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $0147bee01cff6558$export$2697304443f382bc,
            format: $0147bee01cff6558$export$3f8bb04b555a363c,
            encoding: $0147bee01cff6558$export$7207336e4151a112,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $0147bee01cff6558$var$_createRenderTarget(params);
        cubeUVRenderTarget.depthBuffer = texture ? false : true;
        if (this._pingPongRenderTarget === null) this._pingPongRenderTarget = $0147bee01cff6558$var$_createRenderTarget(params);
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $0147bee01cff6558$export$e176487c05830cc5($0147bee01cff6558$var$_lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $0147bee01cff6558$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $0147bee01cff6558$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($0147bee01cff6558$var$_clearColor);
        renderer.toneMapping = $0147bee01cff6558$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $0147bee01cff6558$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $0147bee01cff6558$export$e176487c05830cc5(new $0147bee01cff6558$export$ab3456a079aa7d80(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($0147bee01cff6558$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            $0147bee01cff6558$var$_setViewport(cubeUVRenderTarget, col * $0147bee01cff6558$var$SIZE_MAX, i > 2 ? $0147bee01cff6558$var$SIZE_MAX : 0, $0147bee01cff6558$var$SIZE_MAX, $0147bee01cff6558$var$SIZE_MAX);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $0147bee01cff6558$export$8759762a6477f2c4 || texture.mapping === $0147bee01cff6558$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapShader === null) this._cubemapShader = $0147bee01cff6558$var$_getCubemapShader();
            this._cubemapShader.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectShader === null) this._equirectShader = $0147bee01cff6558$var$_getEquirectShader();
        const material = isCubeTexture ? this._cubemapShader : this._equirectShader;
        const mesh = new $0147bee01cff6558$export$e176487c05830cc5($0147bee01cff6558$var$_lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        if (!isCubeTexture) uniforms["texelSize"].value.set(1.0 / texture.image.width, 1.0 / texture.image.height);
        $0147bee01cff6558$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * $0147bee01cff6558$var$SIZE_MAX, 2 * $0147bee01cff6558$var$SIZE_MAX);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $0147bee01cff6558$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < $0147bee01cff6558$var$TOTAL_LODS; i++){
            const sigma = Math.sqrt($0147bee01cff6558$var$_sigmas[i] * $0147bee01cff6558$var$_sigmas[i] - $0147bee01cff6558$var$_sigmas[i - 1] * $0147bee01cff6558$var$_sigmas[i - 1]);
            const poleAxis = $0147bee01cff6558$var$_axisDirections[(i - 1) % $0147bee01cff6558$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $0147bee01cff6558$export$e176487c05830cc5($0147bee01cff6558$var$_lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = $0147bee01cff6558$var$_sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $0147bee01cff6558$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $0147bee01cff6558$var$MAX_SAMPLES;
        if (samples > $0147bee01cff6558$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$0147bee01cff6558$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $0147bee01cff6558$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = $0147bee01cff6558$var$LOD_MAX - lodIn;
        const outputSize = $0147bee01cff6558$var$_sizeLods[lodOut];
        const x = 3 * Math.max(0, $0147bee01cff6558$var$SIZE_MAX - 2 * outputSize);
        const y = (lodOut === 0 ? 0 : 2 * $0147bee01cff6558$var$SIZE_MAX) + 2 * outputSize * (lodOut > $0147bee01cff6558$var$LOD_MAX - $0147bee01cff6558$var$LOD_MIN ? lodOut - $0147bee01cff6558$var$LOD_MAX + $0147bee01cff6558$var$LOD_MIN : 0);
        $0147bee01cff6558$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $0147bee01cff6558$var$_flatCamera);
    }
}
function $0147bee01cff6558$var$_createPlanes() {
    const _lodPlanes = [];
    const _sizeLods = [];
    const _sigmas = [];
    let lod = $0147bee01cff6558$var$LOD_MAX;
    for(let i = 0; i < $0147bee01cff6558$var$TOTAL_LODS; i++){
        const sizeLod = Math.pow(2, lod);
        _sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > $0147bee01cff6558$var$LOD_MAX - $0147bee01cff6558$var$LOD_MIN) sigma = $0147bee01cff6558$var$EXTRA_LOD_SIGMA[i - $0147bee01cff6558$var$LOD_MAX + $0147bee01cff6558$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        _sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 1);
        const min = -texelSize / 2;
        const max = 1 + texelSize / 2;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $0147bee01cff6558$export$b7be63a67df8959();
        planes.setAttribute("position", new $0147bee01cff6558$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $0147bee01cff6558$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $0147bee01cff6558$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        _lodPlanes.push(planes);
        if (lod > $0147bee01cff6558$var$LOD_MIN) lod--;
    }
    return {
        _lodPlanes: _lodPlanes,
        _sizeLods: _sizeLods,
        _sigmas: _sigmas
    };
}
function $0147bee01cff6558$var$_createRenderTarget(params) {
    const cubeUVRenderTarget = new $0147bee01cff6558$export$3c052beb2e51e23f(3 * $0147bee01cff6558$var$SIZE_MAX, 3 * $0147bee01cff6558$var$SIZE_MAX, params);
    cubeUVRenderTarget.texture.mapping = $0147bee01cff6558$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $0147bee01cff6558$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $0147bee01cff6558$var$_getBlurShader(maxSamples) {
    const weights = new Float32Array(maxSamples);
    const poleAxis = new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $0147bee01cff6558$export$21c421a2e1df9d22({
        name: "SphericalGaussianBlur",
        defines: {
            "n": maxSamples
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $0147bee01cff6558$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $0147bee01cff6558$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $0147bee01cff6558$var$_getEquirectShader() {
    const texelSize = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
    const shaderMaterial = new $0147bee01cff6558$export$21c421a2e1df9d22({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "texelSize": {
                value: texelSize
            }
        },
        vertexShader: $0147bee01cff6558$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform vec2 texelSize;

			#include <common>

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				vec2 f = fract( uv / texelSize - 0.5 );
				uv -= f * texelSize;
				vec3 tl = texture2D ( envMap, uv ).rgb;
				uv.x += texelSize.x;
				vec3 tr = texture2D ( envMap, uv ).rgb;
				uv.y += texelSize.y;
				vec3 br = texture2D ( envMap, uv ).rgb;
				uv.x -= texelSize.x;
				vec3 bl = texture2D ( envMap, uv ).rgb;

				vec3 tm = mix( tl, tr, f.x );
				vec3 bm = mix( bl, br, f.x );
				gl_FragColor.rgb = mix( tm, bm, f.y );

			}
		`,
        blending: $0147bee01cff6558$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $0147bee01cff6558$var$_getCubemapShader() {
    const shaderMaterial = new $0147bee01cff6558$export$21c421a2e1df9d22({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $0147bee01cff6558$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $0147bee01cff6558$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $0147bee01cff6558$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute vec3 position;
		attribute vec2 uv;
		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $0147bee01cff6558$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $0147bee01cff6558$export$d64030b316d3b087 || mapping === $0147bee01cff6558$export$ee99d97d46898098;
            const isCubeMap = mapping === $0147bee01cff6558$export$8759762a6477f2c4 || mapping === $0147bee01cff6558$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $0147bee01cff6558$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $0147bee01cff6558$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $0147bee01cff6558$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($0147bee01cff6558$var$arrayNeedsUint32(indices) ? $0147bee01cff6558$export$7eb8c9fa25cd5bd6 : $0147bee01cff6558$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $0147bee01cff6558$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $0147bee01cff6558$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
class $0147bee01cff6558$export$e38bf4541665bbbd extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.minFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.wrapR = $0147bee01cff6558$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
$0147bee01cff6558$export$e38bf4541665bbbd.prototype.isDataTexture2DArray = true;
function $0147bee01cff6558$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $0147bee01cff6558$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $0147bee01cff6558$var$denormalize(morph, attribute) {
    let denominator = 1;
    const array = attribute.isInterleavedBufferAttribute ? attribute.data.array : attribute.array;
    if (array instanceof Int8Array) denominator = 127;
    else if (array instanceof Int16Array) denominator = 32767;
    else if (array instanceof Int32Array) denominator = 2147483647;
    else console.error("THREE.WebGLMorphtargets: Unsupported morph attribute data type: ", array);
    morph.divideScalar(denominator);
}
function $0147bee01cff6558$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $0147bee01cff6558$export$64b5c384219d3699();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const numberOfMorphTargets = geometry.morphAttributes.position.length;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== numberOfMorphTargets) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const morphTargets = geometry.morphAttributes.position;
                const morphNormals = geometry.morphAttributes.normal || [];
                const numberOfVertices = geometry.attributes.position.count;
                const numberOfVertexData = hasMorphNormals === true ? 2 : 1; // (v,n) vs. (v)
                let width = numberOfVertices * numberOfVertexData;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * numberOfMorphTargets);
                const texture = new $0147bee01cff6558$export$e38bf4541665bbbd(buffer, width, height, numberOfMorphTargets);
                texture.format = $0147bee01cff6558$export$3f8bb04b555a363c; // using RGBA since RGB might be emulated (and is thus slower)
                texture.type = $0147bee01cff6558$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = numberOfVertexData * 4;
                for(let i = 0; i < numberOfMorphTargets; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        morph.fromBufferAttribute(morphTarget, j);
                        if (morphTarget.normalized === true) $0147bee01cff6558$var$denormalize(morph, morphTarget);
                        const stride = j * vertexDataStride;
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            if (morphNormal.normalized === true) $0147bee01cff6558$var$denormalize(morph, morphNormal);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                    }
                }
                entry = {
                    count: numberOfMorphTargets,
                    texture: texture,
                    size: new $0147bee01cff6558$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($0147bee01cff6558$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($0147bee01cff6558$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $0147bee01cff6558$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
class $0147bee01cff6558$export$ef03cdc98340bab4 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.minFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.wrapR = $0147bee01cff6558$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
$0147bee01cff6558$export$ef03cdc98340bab4.prototype.isDataTexture3D = true;
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $0147bee01cff6558$var$emptyTexture = new $0147bee01cff6558$export$5431306cf43de24a();
const $0147bee01cff6558$var$emptyTexture2dArray = new $0147bee01cff6558$export$e38bf4541665bbbd();
const $0147bee01cff6558$var$emptyTexture3d = new $0147bee01cff6558$export$ef03cdc98340bab4();
const $0147bee01cff6558$var$emptyCubeTexture = new $0147bee01cff6558$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $0147bee01cff6558$var$arrayCacheF32 = [];
const $0147bee01cff6558$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $0147bee01cff6558$var$mat4array = new Float32Array(16);
const $0147bee01cff6558$var$mat3array = new Float32Array(9);
const $0147bee01cff6558$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $0147bee01cff6558$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $0147bee01cff6558$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $0147bee01cff6558$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $0147bee01cff6558$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $0147bee01cff6558$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $0147bee01cff6558$var$allocTexUnits(textures, n) {
    let r = $0147bee01cff6558$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $0147bee01cff6558$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $0147bee01cff6558$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $0147bee01cff6558$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
function $0147bee01cff6558$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
function $0147bee01cff6558$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $0147bee01cff6558$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, elements)) return;
        $0147bee01cff6558$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $0147bee01cff6558$var$mat2array);
        $0147bee01cff6558$var$copyArray(cache, elements);
    }
}
function $0147bee01cff6558$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, elements)) return;
        $0147bee01cff6558$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $0147bee01cff6558$var$mat3array);
        $0147bee01cff6558$var$copyArray(cache, elements);
    }
}
function $0147bee01cff6558$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $0147bee01cff6558$var$copyArray(cache, v);
    } else {
        if ($0147bee01cff6558$var$arraysEqual(cache, elements)) return;
        $0147bee01cff6558$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $0147bee01cff6558$var$mat4array);
        $0147bee01cff6558$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $0147bee01cff6558$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array)
function $0147bee01cff6558$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    $0147bee01cff6558$var$copyArray(cache, v);
}
function $0147bee01cff6558$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    $0147bee01cff6558$var$copyArray(cache, v);
}
function $0147bee01cff6558$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    $0147bee01cff6558$var$copyArray(cache, v);
}
// Single unsigned integer
function $0147bee01cff6558$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array)
function $0147bee01cff6558$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    $0147bee01cff6558$var$copyArray(cache, v);
}
function $0147bee01cff6558$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    $0147bee01cff6558$var$copyArray(cache, v);
}
function $0147bee01cff6558$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if ($0147bee01cff6558$var$arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    $0147bee01cff6558$var$copyArray(cache, v);
}
// Single texture (2D / Cube)
function $0147bee01cff6558$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTexture2D(v || $0147bee01cff6558$var$emptyTexture, unit);
}
function $0147bee01cff6558$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $0147bee01cff6558$var$emptyTexture3d, unit);
}
function $0147bee01cff6558$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTextureCube(v || $0147bee01cff6558$var$emptyCubeTexture, unit);
}
function $0147bee01cff6558$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $0147bee01cff6558$var$emptyTexture2dArray, unit);
}
// Helper to pick the right setter for the singular case
function $0147bee01cff6558$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $0147bee01cff6558$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $0147bee01cff6558$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $0147bee01cff6558$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $0147bee01cff6558$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $0147bee01cff6558$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $0147bee01cff6558$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $0147bee01cff6558$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $0147bee01cff6558$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $0147bee01cff6558$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $0147bee01cff6558$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $0147bee01cff6558$var$setValueV4i; // _VEC4
        case 0x1405:
            return $0147bee01cff6558$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $0147bee01cff6558$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $0147bee01cff6558$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $0147bee01cff6558$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $0147bee01cff6558$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $0147bee01cff6558$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $0147bee01cff6558$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $0147bee01cff6558$var$setValueT2DArray1;
    }
}
// Array of scalars
function $0147bee01cff6558$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $0147bee01cff6558$var$setValueV2fArray(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $0147bee01cff6558$var$setValueV3fArray(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $0147bee01cff6558$var$setValueV4fArray(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $0147bee01cff6558$var$setValueM2Array(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $0147bee01cff6558$var$setValueM3Array(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $0147bee01cff6558$var$setValueM4Array(gl, v) {
    const data = $0147bee01cff6558$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $0147bee01cff6558$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $0147bee01cff6558$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $0147bee01cff6558$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $0147bee01cff6558$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $0147bee01cff6558$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $0147bee01cff6558$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $0147bee01cff6558$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $0147bee01cff6558$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $0147bee01cff6558$var$setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = $0147bee01cff6558$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTexture2D(v[i] || $0147bee01cff6558$var$emptyTexture, units[i]);
}
function $0147bee01cff6558$var$setValueT3DArray(gl, v, textures) {
    const n = v.length;
    const units = $0147bee01cff6558$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $0147bee01cff6558$var$emptyTexture3d, units[i]);
}
function $0147bee01cff6558$var$setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = $0147bee01cff6558$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTextureCube(v[i] || $0147bee01cff6558$var$emptyCubeTexture, units[i]);
}
function $0147bee01cff6558$var$setValueT2DArrayArray(gl, v, textures) {
    const n = v.length;
    const units = $0147bee01cff6558$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $0147bee01cff6558$var$emptyTexture2dArray, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $0147bee01cff6558$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $0147bee01cff6558$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $0147bee01cff6558$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $0147bee01cff6558$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $0147bee01cff6558$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $0147bee01cff6558$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $0147bee01cff6558$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $0147bee01cff6558$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $0147bee01cff6558$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $0147bee01cff6558$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $0147bee01cff6558$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $0147bee01cff6558$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $0147bee01cff6558$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $0147bee01cff6558$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $0147bee01cff6558$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $0147bee01cff6558$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $0147bee01cff6558$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $0147bee01cff6558$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $0147bee01cff6558$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $0147bee01cff6558$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
function $0147bee01cff6558$var$SingleUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.setValue = $0147bee01cff6558$var$getSingularSetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
function $0147bee01cff6558$var$PureArrayUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.size = activeInfo.size;
    this.setValue = $0147bee01cff6558$var$getPureArraySetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
$0147bee01cff6558$var$PureArrayUniform.prototype.updateCache = function(data) {
    const cache = this.cache;
    if (data instanceof Float32Array && cache.length !== data.length) this.cache = new Float32Array(data.length);
    $0147bee01cff6558$var$copyArray(cache, data);
};
function $0147bee01cff6558$var$StructuredUniform(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
}
$0147bee01cff6558$var$StructuredUniform.prototype.setValue = function(gl, value, textures) {
    const seq = this.seq;
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        u.setValue(gl, value[u.id], textures);
    }
};
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $0147bee01cff6558$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $0147bee01cff6558$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $0147bee01cff6558$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $0147bee01cff6558$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $0147bee01cff6558$var$RePathPart.exec(path), matchEnd = $0147bee01cff6558$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $0147bee01cff6558$var$addUniform(container, subscript === undefined ? new $0147bee01cff6558$var$SingleUniform(id, activeInfo, addr) : new $0147bee01cff6558$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $0147bee01cff6558$var$StructuredUniform(id);
                $0147bee01cff6558$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
function $0147bee01cff6558$var$WebGLUniforms(gl, program) {
    this.seq = [];
    this.map = {};
    const n = gl.getProgramParameter(program, 35718);
    for(let i = 0; i < n; ++i){
        const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
        $0147bee01cff6558$var$parseUniform(info, addr, this);
    }
}
$0147bee01cff6558$var$WebGLUniforms.prototype.setValue = function(gl, name, value, textures) {
    const u = this.map[name];
    if (u !== undefined) u.setValue(gl, value, textures);
};
$0147bee01cff6558$var$WebGLUniforms.prototype.setOptional = function(gl, object, name) {
    const v = object[name];
    if (v !== undefined) this.setValue(gl, name, v);
};
// Static interface
$0147bee01cff6558$var$WebGLUniforms.upload = function(gl, seq, values, textures) {
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i], v = values[u.id];
        if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
        u.setValue(gl, v.value, textures);
    }
};
$0147bee01cff6558$var$WebGLUniforms.seqWithValue = function(seq, values) {
    const r = [];
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        if (u.id in values) r.push(u);
    }
    return r;
};
function $0147bee01cff6558$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $0147bee01cff6558$var$programIdCount = 0;
function $0147bee01cff6558$var$addLineNumbers(string) {
    const lines = string.split("\n");
    for(let i = 0; i < lines.length; i++)lines[i] = i + 1 + ": " + lines[i];
    return lines.join("\n");
}
function $0147bee01cff6558$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $0147bee01cff6558$export$7207336e4151a112:
            return [
                "Linear",
                "( value )"
            ];
        case $0147bee01cff6558$export$f32388edbb32674:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported encoding:", encoding);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $0147bee01cff6558$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    // --enable-privileged-webgl-extension
    // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
    return type.toUpperCase() + "\n\n" + errors + "\n\n" + $0147bee01cff6558$var$addLineNumbers(gl.getShaderSource(shader));
}
function $0147bee01cff6558$var$getTexelEncodingFunction(functionName, encoding) {
    const components = $0147bee01cff6558$var$getEncodingComponents(encoding);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $0147bee01cff6558$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $0147bee01cff6558$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $0147bee01cff6558$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $0147bee01cff6558$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $0147bee01cff6558$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $0147bee01cff6558$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $0147bee01cff6558$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
}
function $0147bee01cff6558$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $0147bee01cff6558$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === 35674) locationSize = 2;
        if (info.type === 35675) locationSize = 3;
        if (info.type === 35676) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $0147bee01cff6558$var$filterEmptyLine(string) {
    return string !== "";
}
function $0147bee01cff6558$var$replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $0147bee01cff6558$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $0147bee01cff6558$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $0147bee01cff6558$var$resolveIncludes(string) {
    return string.replace($0147bee01cff6558$var$includePattern, $0147bee01cff6558$var$includeReplacer);
}
function $0147bee01cff6558$var$includeReplacer(match, include) {
    const string = $0147bee01cff6558$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error("Can not resolve #include <" + include + ">");
    return $0147bee01cff6558$var$resolveIncludes(string);
}
// Unroll Loops
const $0147bee01cff6558$var$deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const $0147bee01cff6558$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $0147bee01cff6558$var$unrollLoops(string) {
    return string.replace($0147bee01cff6558$var$unrollLoopPattern, $0147bee01cff6558$var$loopReplacer).replace($0147bee01cff6558$var$deprecatedUnrollLoopPattern, $0147bee01cff6558$var$deprecatedLoopReplacer);
}
function $0147bee01cff6558$var$deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.");
    return $0147bee01cff6558$var$loopReplacer(match, start, end, snippet);
}
function $0147bee01cff6558$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $0147bee01cff6558$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $0147bee01cff6558$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $0147bee01cff6558$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $0147bee01cff6558$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $0147bee01cff6558$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $0147bee01cff6558$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $0147bee01cff6558$export$8759762a6477f2c4:
        case $0147bee01cff6558$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $0147bee01cff6558$export$dbf3e70ff37af79:
        case $0147bee01cff6558$export$76a9f4355364345c:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $0147bee01cff6558$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $0147bee01cff6558$export$dc59f8aed047f61d:
        case $0147bee01cff6558$export$76a9f4355364345c:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $0147bee01cff6558$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $0147bee01cff6558$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $0147bee01cff6558$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $0147bee01cff6558$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $0147bee01cff6558$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $0147bee01cff6558$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $0147bee01cff6558$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $0147bee01cff6558$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $0147bee01cff6558$var$generateEnvMapBlendingDefine(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $0147bee01cff6558$var$generateExtensions(parameters);
    const customDefines = $0147bee01cff6558$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $0147bee01cff6558$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
            "#define MAX_BONES " + parameters.maxBones,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
            parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.displacementMap && parameters.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs ? "#define USE_UV" : "",
            parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.useVertexTexture ? "#define BONE_TEXTURE" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphTargets && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargets && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $0147bee01cff6558$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
            parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs ? "#define USE_UV" : "",
            parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? "#define TEXTURE_LOD_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $0147bee01cff6558$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $0147bee01cff6558$export$9fcb6b4294603b2 ? $0147bee01cff6558$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $0147bee01cff6558$export$9fcb6b4294603b2 ? $0147bee01cff6558$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.alphaWrite ? "" : "#define OPAQUE",
            $0147bee01cff6558$export$955f9f2e84c43c8b["encodings_pars_fragment"],
            $0147bee01cff6558$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputEncoding),
            parameters.depthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($0147bee01cff6558$var$filterEmptyLine).join("\n");
    }
    vertexShader = $0147bee01cff6558$var$resolveIncludes(vertexShader);
    vertexShader = $0147bee01cff6558$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $0147bee01cff6558$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $0147bee01cff6558$var$resolveIncludes(fragmentShader);
    fragmentShader = $0147bee01cff6558$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $0147bee01cff6558$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $0147bee01cff6558$var$unrollLoops(vertexShader);
    fragmentShader = $0147bee01cff6558$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $0147bee01cff6558$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $0147bee01cff6558$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $0147bee01cff6558$var$WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = $0147bee01cff6558$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = $0147bee01cff6558$var$getShaderErrors(gl, glVertexShader, "vertex");
            const fragmentErrors = $0147bee01cff6558$var$getShaderErrors(gl, glFragmentShader, "fragment");
            console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, 35715) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $0147bee01cff6558$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $0147bee01cff6558$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $0147bee01cff6558$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $0147bee01cff6558$var$_id = 0;
class $0147bee01cff6558$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        if (cache.has(material) === false) cache.set(material, new Set());
        return cache.get(material);
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        if (cache.has(code) === false) {
            const stage = new $0147bee01cff6558$var$WebGLShaderStage();
            cache.set(code, stage);
        }
        return cache.get(code);
    }
}
class $0147bee01cff6558$var$WebGLShaderStage {
    constructor(){
        this.id = $0147bee01cff6558$var$_id++;
        this.usedTimes = 0;
    }
}
function $0147bee01cff6558$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $0147bee01cff6558$export$89312ce47c0ca777();
    const _customShaders = new $0147bee01cff6558$var$WebGLShaderCache();
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const floatVertexTextures = capabilities.floatVertexTextures;
    const maxVertexUniforms = capabilities.maxVertexUniforms;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getMaxBones(object) {
        const skeleton = object.skeleton;
        const bones = skeleton.bones;
        if (floatVertexTextures) return 1024;
        else {
            // default for when object is not specified
            // ( for example when prebuilding shader to be used with multiple objects )
            //
            //  - leave some extra space for other uniforms
            //  - limit here is ANGLE's 254 max uniform vectors
            //    (up to 54 should be safe)
            const nVertexUniforms = maxVertexUniforms;
            const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
            const maxBones = Math.min(nVertexMatrices, bones.length);
            if (maxBones < bones.length) {
                console.warn("THREE.WebGLRenderer: Skeleton has " + bones.length + " bones. This GPU supports " + maxBones + ".");
                return 0;
            }
            return maxBones;
        }
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        const maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $0147bee01cff6558$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const useAlphaTest = material.alphaTest > 0;
        const useClearcoat = material.clearcoat > 0;
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : $0147bee01cff6558$export$7207336e4151a112,
            map: !!material.map,
            matcap: !!material.matcap,
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapCubeUV: !!envMap && (envMap.mapping === $0147bee01cff6558$export$dbf3e70ff37af79 || envMap.mapping === $0147bee01cff6558$export$76a9f4355364345c),
            lightMap: !!material.lightMap,
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === $0147bee01cff6558$export$9990ad26f9db5b2c,
            tangentSpaceNormalMap: material.normalMapType === $0147bee01cff6558$export$2852a58ebdac27b8,
            decodeVideoTexture: !!material.map && material.map.isVideoTexture === true && material.map.encoding === $0147bee01cff6558$export$f32388edbb32674,
            clearcoat: useClearcoat,
            clearcoatMap: useClearcoat && !!material.clearcoatMap,
            clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            specularIntensityMap: !!material.specularIntensityMap,
            specularColorMap: !!material.specularColorMap,
            alphaMap: !!material.alphaMap,
            alphaTest: useAlphaTest,
            alphaWrite: material.alphaWrite || material.transparent,
            gradientMap: !!material.gradientMap,
            sheen: material.sheen > 0,
            sheenColorMap: !!material.sheenColorMap,
            sheenRoughnessMap: !!material.sheenRoughnessMap,
            transmission: material.transmission > 0,
            transmissionMap: !!material.transmissionMap,
            thicknessMap: !!material.thicknessMap,
            combine: material.combine,
            vertexTangents: !!material.normalMap && !!object.geometry && !!object.geometry.attributes.tangent,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!object.geometry && !!object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || !!material.sheenColorMap || !!material.sheenRoughnessMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || material.sheen > 0 || !!material.sheenColorMap || !!material.sheenRoughnessMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog,
            fogExp2: fog && fog.isFogExp2,
            flatShading: !!material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true && maxBones > 0,
            maxBones: maxBones,
            useVertexTexture: floatVertexTextures,
            morphTargets: !!object.geometry && !!object.geometry.morphAttributes.position,
            morphNormals: !!object.geometry && !!object.geometry.morphAttributes.normal,
            morphTargetsCount: !!object.geometry && !!object.geometry.morphAttributes.position ? object.geometry.morphAttributes.position.length : 0,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $0147bee01cff6558$export$9fcb6b4294603b2,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $0147bee01cff6558$export$3b296b6f144d5b03,
            flipSided: material.side === $0147bee01cff6558$export$d9f0486e75b5ace,
            depthPacking: material.depthPacking !== undefined ? material.depthPacking : false,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputEncoding);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputEncoding);
        array.push(parameters.envMapMode);
        array.push(parameters.combine);
        array.push(parameters.vertexUvs);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.maxBones);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.alphaWrite);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.map) _programLayers.enable(4);
        if (parameters.matcap) _programLayers.enable(5);
        if (parameters.envMap) _programLayers.enable(6);
        if (parameters.envMapCubeUV) _programLayers.enable(7);
        if (parameters.lightMap) _programLayers.enable(8);
        if (parameters.aoMap) _programLayers.enable(9);
        if (parameters.emissiveMap) _programLayers.enable(10);
        if (parameters.bumpMap) _programLayers.enable(11);
        if (parameters.normalMap) _programLayers.enable(12);
        if (parameters.objectSpaceNormalMap) _programLayers.enable(13);
        if (parameters.tangentSpaceNormalMap) _programLayers.enable(14);
        if (parameters.clearcoat) _programLayers.enable(15);
        if (parameters.clearcoatMap) _programLayers.enable(16);
        if (parameters.clearcoatRoughnessMap) _programLayers.enable(17);
        if (parameters.clearcoatNormalMap) _programLayers.enable(18);
        if (parameters.displacementMap) _programLayers.enable(19);
        if (parameters.specularMap) _programLayers.enable(20);
        if (parameters.roughnessMap) _programLayers.enable(21);
        if (parameters.metalnessMap) _programLayers.enable(22);
        if (parameters.gradientMap) _programLayers.enable(23);
        if (parameters.alphaMap) _programLayers.enable(24);
        if (parameters.alphaTest) _programLayers.enable(25);
        if (parameters.vertexColors) _programLayers.enable(26);
        if (parameters.vertexAlphas) _programLayers.enable(27);
        if (parameters.vertexUvs) _programLayers.enable(28);
        if (parameters.vertexTangents) _programLayers.enable(29);
        if (parameters.uvsVertexOnly) _programLayers.enable(30);
        if (parameters.fog) _programLayers.enable(31);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.useFog) _programLayers.enable(0);
        if (parameters.flatShading) _programLayers.enable(1);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(2);
        if (parameters.skinning) _programLayers.enable(3);
        if (parameters.useVertexTexture) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.premultipliedAlpha) _programLayers.enable(7);
        if (parameters.shadowMapEnabled) _programLayers.enable(8);
        if (parameters.physicallyCorrectLights) _programLayers.enable(9);
        if (parameters.doubleSided) _programLayers.enable(10);
        if (parameters.flipSided) _programLayers.enable(11);
        if (parameters.depthPacking) _programLayers.enable(12);
        if (parameters.dithering) _programLayers.enable(13);
        if (parameters.specularIntensityMap) _programLayers.enable(14);
        if (parameters.specularColorMap) _programLayers.enable(15);
        if (parameters.transmission) _programLayers.enable(16);
        if (parameters.transmissionMap) _programLayers.enable(17);
        if (parameters.thicknessMap) _programLayers.enable(18);
        if (parameters.sheen) _programLayers.enable(19);
        if (parameters.sheenColorMap) _programLayers.enable(20);
        if (parameters.sheenRoughnessMap) _programLayers.enable(21);
        if (parameters.decodeVideoTexture) _programLayers.enable(22);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $0147bee01cff6558$export$bee4a7d47f8f5014[shaderID];
            uniforms = $0147bee01cff6558$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $0147bee01cff6558$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $0147bee01cff6558$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $0147bee01cff6558$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $0147bee01cff6558$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $0147bee01cff6558$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $0147bee01cff6558$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $0147bee01cff6558$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        let list;
        if (lists.has(scene) === false) {
            list = new $0147bee01cff6558$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= lists.get(scene).length) {
            list = new $0147bee01cff6558$var$WebGLRenderList();
            lists.get(scene).push(list);
        } else list = lists.get(scene)[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $0147bee01cff6558$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $0147bee01cff6558$export$64b5c384219d3699(),
                        color: new $0147bee01cff6558$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $0147bee01cff6558$export$64b5c384219d3699(),
                        direction: new $0147bee01cff6558$export$64b5c384219d3699(),
                        color: new $0147bee01cff6558$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $0147bee01cff6558$export$64b5c384219d3699(),
                        color: new $0147bee01cff6558$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $0147bee01cff6558$export$64b5c384219d3699(),
                        skyColor: new $0147bee01cff6558$export$892596cec99bc70e(),
                        groundColor: new $0147bee01cff6558$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $0147bee01cff6558$export$892596cec99bc70e(),
                        position: new $0147bee01cff6558$export$64b5c384219d3699(),
                        halfWidth: new $0147bee01cff6558$export$64b5c384219d3699(),
                        halfHeight: new $0147bee01cff6558$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $0147bee01cff6558$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0147bee01cff6558$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0147bee01cff6558$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0147bee01cff6558$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $0147bee01cff6558$var$nextVersion = 0;
function $0147bee01cff6558$var$shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function $0147bee01cff6558$var$WebGLLights(extensions, capabilities) {
    const cache = new $0147bee01cff6558$var$UniformsCache();
    const shadowCache = $0147bee01cff6558$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $0147bee01cff6558$export$64b5c384219d3699());
    const vector3 = new $0147bee01cff6558$export$64b5c384219d3699();
    const matrix4 = new $0147bee01cff6558$export$2ae72fc923e5eb5();
    const matrix42 = new $0147bee01cff6558$export$2ae72fc923e5eb5();
    function setup(lights, physicallyCorrectLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        lights.sort($0147bee01cff6558$var$shadowCastingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms;
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $0147bee01cff6558$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $0147bee01cff6558$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $0147bee01cff6558$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $0147bee01cff6558$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $0147bee01cff6558$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $0147bee01cff6558$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = $0147bee01cff6558$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                uniforms.direction.normalize();
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $0147bee01cff6558$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $0147bee01cff6558$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(physicallyCorrectLights) {
        lights.setup(lightsArray, physicallyCorrectLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $0147bee01cff6558$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        let renderState;
        if (renderStates.has(scene) === false) {
            renderState = new $0147bee01cff6558$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new $0147bee01cff6558$var$WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
/**
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */ class $0147bee01cff6558$export$2698c22ec13825db extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshDepthMaterial";
        this.depthPacking = $0147bee01cff6558$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
$0147bee01cff6558$export$2698c22ec13825db.prototype.isMeshDepthMaterial = true;
/**
 * parameters = {
 *
 *  referencePosition: <float>,
 *  nearDistance: <float>,
 *  farDistance: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>
 *
 * }
 */ class $0147bee01cff6558$export$33e187ed002f2a19 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshDistanceMaterial";
        this.referencePosition = new $0147bee01cff6558$export$64b5c384219d3699();
        this.nearDistance = 1;
        this.farDistance = 1000;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.fog = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.referencePosition.copy(source.referencePosition);
        this.nearDistance = source.nearDistance;
        this.farDistance = source.farDistance;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
$0147bee01cff6558$export$33e187ed002f2a19.prototype.isMeshDistanceMaterial = true;
const $0147bee01cff6558$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $0147bee01cff6558$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $0147bee01cff6558$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $0147bee01cff6558$export$35efe6f4c85463d2();
    const _shadowMapSize = new $0147bee01cff6558$export$c977b3e384af9ae1(), _viewportSize = new $0147bee01cff6558$export$c977b3e384af9ae1(), _viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3(), _depthMaterial = new $0147bee01cff6558$export$2698c22ec13825db({
        depthPacking: $0147bee01cff6558$export$8f910f4c4f73df11
    }), _distanceMaterial = new $0147bee01cff6558$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        0: $0147bee01cff6558$export$d9f0486e75b5ace,
        1: $0147bee01cff6558$export$2ede184fc2998901,
        2: $0147bee01cff6558$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $0147bee01cff6558$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $0147bee01cff6558$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $0147bee01cff6558$var$vertex,
        fragmentShader: $0147bee01cff6558$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $0147bee01cff6558$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $0147bee01cff6558$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $0147bee01cff6558$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $0147bee01cff6558$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($0147bee01cff6558$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null && !shadow.isPointLightShadow && this.type === $0147bee01cff6558$export$896ae1ade6c829c4) {
                const pars = {
                    minFilter: $0147bee01cff6558$export$8a72f490b25c56c8,
                    magFilter: $0147bee01cff6558$export$8a72f490b25c56c8,
                    format: $0147bee01cff6558$export$3f8bb04b555a363c
                };
                shadow.map = new $0147bee01cff6558$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.mapPass = new $0147bee01cff6558$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.camera.updateProjectionMatrix();
            }
            if (shadow.map === null) {
                const pars = {
                    minFilter: $0147bee01cff6558$export$727aa5ec3fe39bf0,
                    magFilter: $0147bee01cff6558$export$727aa5ec3fe39bf0,
                    format: $0147bee01cff6558$export$3f8bb04b555a363c
                };
                shadow.map = new $0147bee01cff6558$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (!shadow.isPointLightShadow && this.type === $0147bee01cff6558$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $0147bee01cff6558$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $0147bee01cff6558$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $0147bee01cff6558$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case $0147bee01cff6558$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $0147bee01cff6558$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $0147bee01cff6558$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $0147bee01cff6558$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $0147bee01cff6558$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $0147bee01cff6558$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $0147bee01cff6558$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $0147bee01cff6558$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(3088);
    const viewportParam = gl.getParameter(2978);
    const currentScissor = new $0147bee01cff6558$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $0147bee01cff6558$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($0147bee01cff6558$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($0147bee01cff6558$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($0147bee01cff6558$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = 36064 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== 36064) {
                drawBuffers[0] = 36064;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== 1029) {
            drawBuffers[0] = 1029;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$0147bee01cff6558$export$20183a0484ce21a0]: 32774,
        [$0147bee01cff6558$export$73e0df5177988548]: 32778,
        [$0147bee01cff6558$export$28e582859cbec660]: 32779
    };
    if (isWebGL2) {
        equationToGL[$0147bee01cff6558$export$c8c1508da8d0600c] = 32775;
        equationToGL[$0147bee01cff6558$export$99948c02fb51055f] = 32776;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$0147bee01cff6558$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$0147bee01cff6558$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$0147bee01cff6558$export$2110f05edf778d3d]: 0,
        [$0147bee01cff6558$export$8805bad65e24940e]: 1,
        [$0147bee01cff6558$export$7fbe15b28d28cf52]: 768,
        [$0147bee01cff6558$export$d5773124e86cf28c]: 770,
        [$0147bee01cff6558$export$c05e2a1fc8609506]: 776,
        [$0147bee01cff6558$export$ef5f2dd8ffac5574]: 774,
        [$0147bee01cff6558$export$a78aed1ca2a87192]: 772,
        [$0147bee01cff6558$export$947829af9f2c17f6]: 769,
        [$0147bee01cff6558$export$11d468cc7f19e971]: 771,
        [$0147bee01cff6558$export$56b85b2686ab16]: 775,
        [$0147bee01cff6558$export$5d0fe17fd8773bac]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $0147bee01cff6558$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $0147bee01cff6558$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $0147bee01cff6558$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $0147bee01cff6558$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $0147bee01cff6558$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $0147bee01cff6558$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $0147bee01cff6558$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $0147bee01cff6558$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $0147bee01cff6558$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $0147bee01cff6558$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $0147bee01cff6558$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $0147bee01cff6558$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $0147bee01cff6558$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $0147bee01cff6558$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $0147bee01cff6558$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        let flipSided = material.side === $0147bee01cff6558$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $0147bee01cff6558$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($0147bee01cff6558$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $0147bee01cff6558$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $0147bee01cff6558$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $0147bee01cff6558$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $0147bee01cff6558$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const hasMultisampledRenderToTexture = extensions.has("WEBGL_multisampled_render_to_texture");
    const MultisampledRenderToTextureExtension = hasMultisampledRenderToTexture ? extensions.get("WEBGL_multisampled_render_to_texture") : undefined;
    const _videoTextures = new WeakMap();
    let _canvas;
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : $0147bee01cff6558$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $0147bee01cff6558$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $0147bee01cff6558$var$isPowerOfTwo(image.width) && $0147bee01cff6558$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $0147bee01cff6558$export$9d9334239a5a5e06 || texture.wrapT !== $0147bee01cff6558$export$9d9334239a5a5e06 || texture.minFilter !== $0147bee01cff6558$export$727aa5ec3fe39bf0 && texture.minFilter !== $0147bee01cff6558$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $0147bee01cff6558$export$727aa5ec3fe39bf0 && texture.minFilter !== $0147bee01cff6558$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, encoding, isVideoTexture = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 33319) {
            if (glType === 5126) internalFormat = 33328;
            if (glType === 5131) internalFormat = 33327;
            if (glType === 5121) internalFormat = 33323;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = encoding === $0147bee01cff6558$export$f32388edbb32674 && isVideoTexture === false ? 35907 : 32856;
            if (glType === 32819) internalFormat = 32854;
            if (glType === 32820) internalFormat = 32855;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $0147bee01cff6558$export$727aa5ec3fe39bf0 && texture.minFilter !== $0147bee01cff6558$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $0147bee01cff6558$export$727aa5ec3fe39bf0 || f === $0147bee01cff6558$export$d129e38cf6feaa8c || f === $0147bee01cff6558$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
        info.memory.textures--;
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        _gl.deleteTexture(textureProperties.__webglTexture);
        properties.remove(texture);
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (!renderTarget) return;
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === undefined) console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [$0147bee01cff6558$export$533346c8e8dac0f5]: 10497,
        [$0147bee01cff6558$export$9d9334239a5a5e06]: 33071,
        [$0147bee01cff6558$export$c7e7c00b14f51a4f]: 33648
    };
    const filterToGL = {
        [$0147bee01cff6558$export$727aa5ec3fe39bf0]: 9728,
        [$0147bee01cff6558$export$d129e38cf6feaa8c]: 9984,
        [$0147bee01cff6558$export$d2327c1afe5bfdf2]: 9986,
        [$0147bee01cff6558$export$8a72f490b25c56c8]: 9729,
        [$0147bee01cff6558$export$19a719f377145a13]: 9985,
        [$0147bee01cff6558$export$5d8599b6a933fb1b]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $0147bee01cff6558$export$9d9334239a5a5e06 || texture.wrapT !== $0147bee01cff6558$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $0147bee01cff6558$export$727aa5ec3fe39bf0 && texture.minFilter !== $0147bee01cff6558$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.type === $0147bee01cff6558$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $0147bee01cff6558$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
            textureProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataTexture2DArray) textureType = 35866;
        if (texture.isDataTexture3D) textureType = 32879;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
        let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
        image = verifyColorSpace(texture, image);
        const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding);
        let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
        setTextureParameters(textureType, texture, supportsMips);
        let mipmap;
        const mipmaps = texture.mipmaps;
        const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
        const allocateMemory = textureProperties.__version === undefined;
        const levels = getMipLevels(texture, image, supportsMips);
        if (texture.isDepthTexture) {
            // populate depth texture with dummy data
            glInternalFormat = 6402;
            if (isWebGL2) {
                if (texture.type === $0147bee01cff6558$export$f6d331659b644596) glInternalFormat = 36012;
                else if (texture.type === $0147bee01cff6558$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                else if (texture.type === $0147bee01cff6558$export$6c8ea339bfab1301) glInternalFormat = 35056;
                else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
            } else if (texture.type === $0147bee01cff6558$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
            // validation checks for WebGL 1
            if (texture.format === $0147bee01cff6558$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
            // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
            // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
            {
                if (texture.type !== $0147bee01cff6558$export$c63dc51868b06a9d && texture.type !== $0147bee01cff6558$export$c3c7fc4518ebba96) {
                    console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                    texture.type = $0147bee01cff6558$export$c63dc51868b06a9d;
                    glType = utils.convert(texture.type);
                }
            }
            if (texture.format === $0147bee01cff6558$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                // Depth stencil textures need the DEPTH_STENCIL internal format
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                glInternalFormat = 34041;
                // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                if (texture.type !== $0147bee01cff6558$export$6c8ea339bfab1301) {
                    console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                    texture.type = $0147bee01cff6558$export$6c8ea339bfab1301;
                    glType = utils.convert(texture.type);
                }
            }
            //
            if (useTexStorage && allocateMemory) state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
            else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else if (texture.isDataTexture) {
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    if (useTexStorage) state.texSubImage2D(3553, 0, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                    else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
                texture.generateMipmaps = false;
            } else if (useTexStorage) {
                if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
            } else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
        } else if (texture.isCompressedTexture) {
            if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                if (texture.format !== $0147bee01cff6558$export$3f8bb04b555a363c) {
                    if (glFormat !== null) {
                        if (useTexStorage) state.compressedTexSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                        else state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                    } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                } else if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
        } else if (texture.isDataTexture2DArray) {
            if (useTexStorage) {
                if (allocateMemory) state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
                state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
            } else state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        } else if (texture.isDataTexture3D) {
            if (useTexStorage) {
                if (allocateMemory) state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
                state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
            } else state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        } else if (texture.isFramebufferTexture) {
            if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
            else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else {
            // regular Texture (image, video, canvas)
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, glFormat, glType, mipmap);
                    else state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
                }
                texture.generateMipmaps = false;
            } else if (useTexStorage) {
                if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
            } else state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        const isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
        const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
        const cubeImage = [];
        for(let i = 0; i < 6; i++){
            if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
            else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
            cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
        }
        const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
        const allocateMemory = textureProperties.__version === undefined;
        let levels = getMipLevels(texture, image, supportsMips);
        setTextureParameters(34067, texture, supportsMips);
        let mipmaps;
        if (isCompressed) {
            if (useTexStorage && allocateMemory) state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
            for(let i = 0; i < 6; i++){
                mipmaps = cubeImage[i].mipmaps;
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    if (texture.format !== $0147bee01cff6558$export$3f8bb04b555a363c) {
                        if (glFormat !== null) {
                            if (useTexStorage) state.compressedTexSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                            else state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                    } else if (useTexStorage) state.texSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                    else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            }
        } else {
            mipmaps = texture.mipmaps;
            if (useTexStorage && allocateMemory) {
                // TODO: Uniformly handle mipmap definitions
                // Normal textures and compressed cube textures define base level + mips with their mipmap array
                // Uncompressed cube textures use their mipmap array only for mips (no base level)
                if (mipmaps.length > 0) levels++;
                state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
            }
            for(let i = 0; i < 6; i++)if (isDataTexture) {
                if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                else state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    const mipmapImage = mipmap.image[i].image;
                    if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                    else state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                }
            } else {
                if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                else state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                    else state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                }
            }
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
        generateMipmap(34067);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.encoding);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(36160, framebuffer);
        if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample || renderTarget.useRenderToTexture) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $0147bee01cff6558$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $0147bee01cff6558$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && renderTarget.useRenderbuffer) _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.renderbufferStorageMultisampleEXT(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            // Use the first texture for MRT so far
            const texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
            const glFormat = utils.convert(texture.format, texture.encoding);
            const glType = utils.convert(texture.type);
            const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && renderTarget.useRenderbuffer) _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $0147bee01cff6558$export$c1b6b5136be58045) {
            if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $0147bee01cff6558$export$1e113ac2d0905829) {
            if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const isRenderTarget3D = texture.isDataTexture3D || texture.isDataTexture2DArray;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            } else if (renderTarget.useRenderbuffer) {
                if (isWebGL2) {
                    renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                    renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
                    const glFormat = utils.convert(texture.format, texture.encoding);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
                    _gl.bindRenderbuffer(36161, null);
                    if (renderTarget.depthBuffer) {
                        renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                        setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                    }
                    state.bindFramebuffer(36160, null);
                } else console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553);
            }
            state.unbindTexture();
        } else {
            let glTextureType = 3553;
            if (isRenderTarget3D) {
                // Render targets containing layers, i.e: Texture 3D and 2d arrays
                if (isWebGL2) {
                    const isTexture3D = texture.isDataTexture3D;
                    glTextureType = isTexture3D ? 32879 : 35866;
                } else console.warn("THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.useRenderbuffer) {
            if (isWebGL2) {
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = 16384;
                const invalidationArray = [
                    36064
                ];
                const depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                if (!renderTarget.ignoreDepthForMultisampleCopy) {
                    if (renderTarget.depthBuffer) mask |= 256;
                    if (renderTarget.stencilBuffer) mask |= 1024;
                }
                const renderTargetProperties = properties.get(renderTarget);
                state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
                if (renderTarget.ignoreDepthForMultisampleCopy) {
                    _gl.invalidateFramebuffer(36008, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(36009, [
                        depthStyle
                    ]);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                _gl.invalidateFramebuffer(36008, invalidationArray);
                state.bindFramebuffer(36008, null);
                state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
            } else console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return isWebGL2 && (renderTarget.useRenderbuffer || renderTarget.useRenderToTexture) ? Math.min(maxSamples, renderTarget.samples) : 0;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const encoding = texture.encoding;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $0147bee01cff6558$export$ca1dce8b5e1de74d) return image;
        if (encoding !== $0147bee01cff6558$export$7207336e4151a112) {
            // sRGB
            if (encoding === $0147bee01cff6558$export$f32388edbb32674) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $0147bee01cff6558$export$3f8bb04b555a363c) {
                        texture.format = $0147bee01cff6558$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $0147bee01cff6558$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $0147bee01cff6558$export$3f8bb04b555a363c || type !== $0147bee01cff6558$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture encoding:", encoding);
        }
        return image;
    }
    // backwards compatibility
    let warnedTexture2D = false;
    let warnedTextureCube = false;
    function safeSetTexture2D(texture, slot) {
        if (texture && texture.isWebGLRenderTarget) {
            if (warnedTexture2D === false) {
                console.warn("THREE.WebGLTextures.safeSetTexture2D: don't use render targets as textures. Use their .texture property instead.");
                warnedTexture2D = true;
            }
            texture = texture.texture;
        }
        setTexture2D(texture, slot);
    }
    function safeSetTextureCube(texture, slot) {
        if (texture && texture.isWebGLCubeRenderTarget) {
            if (warnedTextureCube === false) {
                console.warn("THREE.WebGLTextures.safeSetTextureCube: don't use cube render targets as textures. Use their .texture property instead.");
                warnedTextureCube = true;
            }
            texture = texture.texture;
        }
        setTextureCube(texture, slot);
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.safeSetTexture2D = safeSetTexture2D;
    this.safeSetTextureCube = safeSetTextureCube;
}
function $0147bee01cff6558$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, encoding = null) {
        let extension;
        if (p === $0147bee01cff6558$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $0147bee01cff6558$export$b3969b01faf587f2) return 32819;
        if (p === $0147bee01cff6558$export$18886f8ae33e90de) return 32820;
        if (p === $0147bee01cff6558$export$545fce0311a9796a) return 5120;
        if (p === $0147bee01cff6558$export$88572337f312435f) return 5122;
        if (p === $0147bee01cff6558$export$c63dc51868b06a9d) return 5123;
        if (p === $0147bee01cff6558$export$5c612977753abe2) return 5124;
        if (p === $0147bee01cff6558$export$c3c7fc4518ebba96) return 5125;
        if (p === $0147bee01cff6558$export$f6d331659b644596) return 5126;
        if (p === $0147bee01cff6558$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $0147bee01cff6558$export$988473390501ed4b) return 6406;
        if (p === $0147bee01cff6558$export$3f8bb04b555a363c) return 6408;
        if (p === $0147bee01cff6558$export$cc09ccbf6d1ed449) return 6409;
        if (p === $0147bee01cff6558$export$9053a81c4a69c289) return 6410;
        if (p === $0147bee01cff6558$export$c1b6b5136be58045) return 6402;
        if (p === $0147bee01cff6558$export$1e113ac2d0905829) return 34041;
        if (p === $0147bee01cff6558$export$4e041a7967d15c4b) return 6403;
        // WebGL 1 sRGB fallback
        if (p === $0147bee01cff6558$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $0147bee01cff6558$export$aa92e870a709d190) return 36244;
        if (p === $0147bee01cff6558$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $0147bee01cff6558$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $0147bee01cff6558$export$c200e7d26f592f21) return 36249;
        // S3TC
        if (p === $0147bee01cff6558$export$21d1799c6d552fc0 || p === $0147bee01cff6558$export$afa304c3e981b668 || p === $0147bee01cff6558$export$d2a1a68024a3e56c || p === $0147bee01cff6558$export$9a79c424327dacf9) {
            if (encoding === $0147bee01cff6558$export$f32388edbb32674) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $0147bee01cff6558$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $0147bee01cff6558$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $0147bee01cff6558$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $0147bee01cff6558$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $0147bee01cff6558$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $0147bee01cff6558$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $0147bee01cff6558$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $0147bee01cff6558$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $0147bee01cff6558$export$19ada9bbb1af3573 || p === $0147bee01cff6558$export$d0f0355bb3d948e4 || p === $0147bee01cff6558$export$b82296714358084c || p === $0147bee01cff6558$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $0147bee01cff6558$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $0147bee01cff6558$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $0147bee01cff6558$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $0147bee01cff6558$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $0147bee01cff6558$export$7800993ef8106a6a || p === $0147bee01cff6558$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$7800993ef8106a6a) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $0147bee01cff6558$export$23ed8300a860e7d8) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $0147bee01cff6558$export$dc5570b4a2b92d48 || p === $0147bee01cff6558$export$68880cd325f8b2fb || p === $0147bee01cff6558$export$7d2c0be323373d95 || p === $0147bee01cff6558$export$22b52da301fc3a3e || p === $0147bee01cff6558$export$c009e2cb4a66485e || p === $0147bee01cff6558$export$118fff5afa255b63 || p === $0147bee01cff6558$export$120713c829ae0667 || p === $0147bee01cff6558$export$c79eeabbf53313e9 || p === $0147bee01cff6558$export$443cf6567cdd6424 || p === $0147bee01cff6558$export$6573984fc9840780 || p === $0147bee01cff6558$export$e7aee563f30091de || p === $0147bee01cff6558$export$2eb8634622ddeab7 || p === $0147bee01cff6558$export$202b1ce7b5d25742 || p === $0147bee01cff6558$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$dc5570b4a2b92d48) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $0147bee01cff6558$export$68880cd325f8b2fb) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $0147bee01cff6558$export$7d2c0be323373d95) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $0147bee01cff6558$export$22b52da301fc3a3e) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $0147bee01cff6558$export$c009e2cb4a66485e) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $0147bee01cff6558$export$118fff5afa255b63) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $0147bee01cff6558$export$120713c829ae0667) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $0147bee01cff6558$export$c79eeabbf53313e9) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $0147bee01cff6558$export$443cf6567cdd6424) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $0147bee01cff6558$export$6573984fc9840780) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $0147bee01cff6558$export$e7aee563f30091de) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $0147bee01cff6558$export$2eb8634622ddeab7) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $0147bee01cff6558$export$202b1ce7b5d25742) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $0147bee01cff6558$export$18ab77abd087e467) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $0147bee01cff6558$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $0147bee01cff6558$export$ce40b115e188bc81) return encoding === $0147bee01cff6558$export$f32388edbb32674 ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        //
        if (p === $0147bee01cff6558$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
    }
    return {
        convert: convert
    };
}
class $0147bee01cff6558$export$56b937d9e5581166 extends $0147bee01cff6558$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.cameras = array;
    }
}
$0147bee01cff6558$export$56b937d9e5581166.prototype.isArrayCamera = true;
class $0147bee01cff6558$export$eb2fcfdbd7ba97d4 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Group";
    }
}
$0147bee01cff6558$export$eb2fcfdbd7ba97d4.prototype.isGroup = true;
const $0147bee01cff6558$var$_moveEvent = {
    type: "move"
};
class $0147bee01cff6558$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $0147bee01cff6558$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $0147bee01cff6558$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $0147bee01cff6558$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $0147bee01cff6558$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($0147bee01cff6558$var$_moveEvent);
                }
            }
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    if (hand.joints[inputjoint.jointName] === undefined) {
                        // The transform of this joint will be updated with the joint pose on each frame
                        const joint = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
                        joint.matrixAutoUpdate = false;
                        joint.visible = false;
                        hand.joints[inputjoint.jointName] = joint;
                        // ??
                        hand.add(joint);
                    }
                    const joint = hand.joints[inputjoint.jointName];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
}
class $0147bee01cff6558$export$fc830aa069cc8c2f extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $0147bee01cff6558$export$c1b6b5136be58045;
        if (format !== $0147bee01cff6558$export$c1b6b5136be58045 && format !== $0147bee01cff6558$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $0147bee01cff6558$export$c1b6b5136be58045) type = $0147bee01cff6558$export$c63dc51868b06a9d;
        if (type === undefined && format === $0147bee01cff6558$export$1e113ac2d0905829) type = $0147bee01cff6558$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
$0147bee01cff6558$export$fc830aa069cc8c2f.prototype.isDepthTexture = true;
class $0147bee01cff6558$var$WebXRManager extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        const hasMultisampledRenderToTexture = renderer.extensions.has("WEBGL_multisampled_render_to_texture");
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let isMultisample = false;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const inputSourcesMap = new Map();
        //
        const cameraL = new $0147bee01cff6558$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        const cameraR = new $0147bee01cff6558$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $0147bee01cff6558$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0147bee01cff6558$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0147bee01cff6558$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0147bee01cff6558$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controller = inputSourcesMap.get(event.inputSource);
            if (controller) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        }
        function onSessionEnd() {
            inputSourcesMap.forEach(function(controller, inputSource) {
                controller.disconnect(inputSource);
            });
            inputSourcesMap.clear();
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return referenceSpace;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: attributes.alpha,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $0147bee01cff6558$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $0147bee01cff6558$export$3f8bb04b555a363c,
                        type: $0147bee01cff6558$export$2e8ce08d3f6f5e10,
                        encoding: renderer.outputEncoding
                    });
                } else {
                    isMultisample = attributes.antialias;
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? 35056 : 33190;
                        depthFormat = attributes.stencil ? $0147bee01cff6558$export$1e113ac2d0905829 : $0147bee01cff6558$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $0147bee01cff6558$export$6c8ea339bfab1301 : $0147bee01cff6558$export$c63dc51868b06a9d;
                    }
                    const projectionlayerInit = {
                        colorFormat: renderer.outputEncoding === $0147bee01cff6558$export$f32388edbb32674 ? 35907 : 32856,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    if (isMultisample) newRenderTarget = new $0147bee01cff6558$export$cb2022643d3c928d(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $0147bee01cff6558$export$3f8bb04b555a363c,
                        type: $0147bee01cff6558$export$2e8ce08d3f6f5e10,
                        depthTexture: new $0147bee01cff6558$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        ignoreDepth: glProjLayer.ignoreDepthValues,
                        useRenderToTexture: hasMultisampledRenderToTexture,
                        encoding: renderer.outputEncoding
                    });
                    else newRenderTarget = new $0147bee01cff6558$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $0147bee01cff6558$export$3f8bb04b555a363c,
                        type: $0147bee01cff6558$export$2e8ce08d3f6f5e10,
                        depthTexture: new $0147bee01cff6558$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        ignoreDepth: glProjLayer.ignoreDepthValues,
                        encoding: renderer.outputEncoding
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                // Set foveation to maximum.
                this.setFoveation(1.0);
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function onInputSourcesChange(event) {
            const inputSources = session.inputSources;
            // Assign inputSources to available controllers
            for(let i = 0; i < controllers.length; i++)inputSourcesMap.set(inputSources[i], controllers[i]);
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const controller = inputSourcesMap.get(inputSource);
                if (controller) {
                    controller.dispatchEvent({
                        type: "disconnected",
                        data: inputSource
                    });
                    inputSourcesMap.delete(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                const controller = inputSourcesMap.get(inputSource);
                if (controller) controller.dispatchEvent({
                    type: "connected",
                    data: inputSource
                });
            }
        }
        //
        const cameraLPos = new $0147bee01cff6558$export$64b5c384219d3699();
        const cameraRPos = new $0147bee01cff6558$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
            // update user camera and its children
            camera.position.copy(cameraVR.position);
            camera.quaternion.copy(cameraVR.quaternion);
            camera.scale.copy(cameraVR.scale);
            camera.matrix.copy(cameraVR.matrix);
            camera.matrixWorld.copy(cameraVR.matrixWorld);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        };
        this.getCamera = function() {
            return cameraVR;
        };
        this.getFoveation = function() {
            if (glProjLayer !== null) return glProjLayer.fixedFoveation;
            if (glBaseLayer !== null) return glBaseLayer.fixedFoveation;
            return undefined;
        };
        this.setFoveation = function(foveation) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            if (glProjLayer !== null) glProjLayer.fixedFoveation = foveation;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = foveation;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    const camera = cameras[i];
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) cameraVR.matrix.copy(camera.matrix);
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            const inputSources = session.inputSources;
            for(let i = 0; i < controllers.length; i++){
                const controller = controllers[i];
                const inputSource = inputSources[i];
                controller.update(inputSource, frame, referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            xrFrame = null;
        }
        const animation = new $0147bee01cff6558$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $0147bee01cff6558$var$WebGLMaterials(properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsLambert(uniforms, material);
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
            else refreshUniformsStandard(uniforms, material);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDepth(uniforms, material);
        } else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsNormal(uniforms, material);
        } else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        // 13. specular intensity map
        // 14. specular tint map
        // 15. transmission map
        // 16. thickness map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        else if (material.specularIntensityMap) uvScaleMap = material.specularIntensityMap;
        else if (material.specularColorMap) uvScaleMap = material.specularColorMap;
        else if (material.transmissionMap) uvScaleMap = material.transmissionMap;
        else if (material.thicknessMap) uvScaleMap = material.thicknessMap;
        else if (material.sheenColorMap) uvScaleMap = material.sheenColorMap;
        else if (material.sheenRoughnessMap) uvScaleMap = material.sheenRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsLambert(uniforms, material) {
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        refreshUniformsStandard(uniforms, material);
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) uniforms.sheenColorMap.value = material.sheenColorMap;
            if (material.sheenRoughnessMap) uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
            if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) uniforms.thicknessMap.value = material.thicknessMap;
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularIntensityMap) uniforms.specularIntensityMap.value = material.specularIntensityMap;
        if (material.specularColorMap) uniforms.specularColorMap.value = material.specularColorMap;
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDepth(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDistance(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    function refreshUniformsNormal(uniforms, material) {
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0147bee01cff6558$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $0147bee01cff6558$var$createCanvasElement() {
    const canvas = $0147bee01cff6558$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
function $0147bee01cff6558$export$f6cc00ef28d7cf97(parameters = {}) {
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : $0147bee01cff6558$var$createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _alpha = parameters.alpha !== undefined ? parameters.alpha : false, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : "default", _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its list and state isolated from the parent render call.
    const renderListStack = [];
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.outputEncoding = $0147bee01cff6558$export$7207336e4151a112;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = $0147bee01cff6558$export$9fcb6b4294603b2;
    this.toneMappingExposure = 1.0;
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new $0147bee01cff6558$export$fa7daccca11cdbe3();
    const _currentScissor = new $0147bee01cff6558$export$fa7daccca11cdbe3();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, _width, _height);
    const _scissor = new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, _width, _height);
    let _scissorTest = false;
    // frustum
    const _frustum = new $0147bee01cff6558$export$35efe6f4c85463d2();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // transmission
    let _transmissionRenderTarget = null;
    // camera matrices cache
    const _projScreenMatrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
    const _vector3 = new $0147bee01cff6558$export$64b5c384219d3699();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: true,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // OffscreenCanvas does not have setAttribute, see #22811
        if ("setAttribute" in _canvas) _canvas.setAttribute("data-engine", `three.js r${$0147bee01cff6558$export$3545e07a80636437}`);
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener("webglcontextlost", onContextLost, false);
        _canvas.addEventListener("webglcontextrestored", onContextRestore, false);
        if (_gl === null) {
            const contextNames = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                else throw new Error("Error creating WebGL context.");
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                "rangeMin": 1,
                "rangeMax": 1,
                "precision": 1
            };
        };
    } catch (error) {
        console.error("THREE.WebGLRenderer: " + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates;
    function initGLContext() {
        extensions = new $0147bee01cff6558$var$WebGLExtensions(_gl);
        capabilities = new $0147bee01cff6558$var$WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new $0147bee01cff6558$export$ddaebcad857649a8(_gl, extensions, capabilities);
        state = new $0147bee01cff6558$var$WebGLState(_gl, extensions, capabilities);
        info = new $0147bee01cff6558$var$WebGLInfo(_gl);
        properties = new $0147bee01cff6558$var$WebGLProperties();
        textures = new $0147bee01cff6558$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new $0147bee01cff6558$var$WebGLCubeMaps(_this);
        cubeuvmaps = new $0147bee01cff6558$var$WebGLCubeUVMaps(_this);
        attributes = new $0147bee01cff6558$var$WebGLAttributes(_gl, capabilities);
        bindingStates = new $0147bee01cff6558$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new $0147bee01cff6558$var$WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new $0147bee01cff6558$var$WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new $0147bee01cff6558$var$WebGLMorphtargets(_gl, capabilities, textures);
        clipping = new $0147bee01cff6558$var$WebGLClipping(properties);
        programCache = new $0147bee01cff6558$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
        materials = new $0147bee01cff6558$var$WebGLMaterials(properties);
        renderLists = new $0147bee01cff6558$var$WebGLRenderLists();
        renderStates = new $0147bee01cff6558$var$WebGLRenderStates(extensions, capabilities);
        background = new $0147bee01cff6558$var$WebGLBackground(_this, cubemaps, state, objects, _alpha, _premultipliedAlpha);
        shadowMap = new $0147bee01cff6558$var$WebGLShadowMap(_this, objects, capabilities);
        bufferRenderer = new $0147bee01cff6558$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new $0147bee01cff6558$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new $0147bee01cff6558$var$WebXRManager(_this, _gl);
    this.xr = xr;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + "px";
            _canvas.style.height = height + "px";
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color, depth, stencil) {
        let bits = 0;
        if (color === undefined || color) bits |= 16384;
        if (depth === undefined || depth) bits |= 256;
        if (stencil === undefined || stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener("webglcontextlost", onContextLost, false);
        _canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        cubeuvmaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        programCache.dispose();
        xr.dispose();
        xr.removeEventListener("sessionstart", onXRSessionStart);
        xr.removeEventListener("sessionend", onXRSessionEnd);
        if (_transmissionRenderTarget) {
            _transmissionRenderTarget.dispose();
            _transmissionRenderTarget = null;
        }
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log("THREE.WebGLRenderer: Context Lost.");
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log("THREE.WebGLRenderer: Context Restored.");
        _isContextLost = false;
        const infoAutoReset = info.autoReset;
        const shadowMapEnabled = shadowMap.enabled;
        const shadowMapAutoUpdate = shadowMap.autoUpdate;
        const shadowMapNeedsUpdate = shadowMap.needsUpdate;
        const shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener("dispose", onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
        const programs = properties.get(material).programs;
        if (programs !== undefined) {
            programs.forEach(function(program) {
                programCache.releaseProgram(program);
            });
            if (material.isShaderMaterial) programCache.releaseShaderCache(material);
        }
    }
    // Buffer rendering
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, geometry, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    getProgram(material2, scene, object);
                }
                else getProgram(material, scene, object);
            }
        });
        renderStateStack.pop();
        currentRenderState = null;
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
        animation.stop();
    }
    function onXRSessionEnd() {
        animation.start();
    }
    const animation = new $0147bee01cff6558$var$WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof window !== "undefined") animation.setContext(window);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener("sessionstart", onXRSessionStart);
    xr.addEventListener("sessionend", onXRSessionEnd);
    // Rendering
    this.render = function(scene, camera) {
        if (camera !== undefined && camera.isCamera !== true) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
        }
        if (_isContextLost === true) return;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        //
        background.render(currentRenderList, scene);
        // render scene
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        if (camera.isArrayCamera) {
            const cameras = camera.cameras;
            for(let i = 0, l = cameras.length; i < l; i++){
                const camera2 = cameras[i];
                renderScene(currentRenderList, scene, camera2, camera2.viewport);
            }
        } else renderScene(currentRenderList, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
        }
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
        // _gl.finish();
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        renderListStack.pop();
        if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
        else currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderScene(currentRenderList, scene, camera, viewport) {
        const opaqueObjects = currentRenderList.opaque;
        const transmissiveObjects = currentRenderList.transmissive;
        const transparentObjects = currentRenderList.transparent;
        currentRenderState.setupLightsView(camera);
        if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, scene, camera);
        if (viewport) state.viewport(_currentViewport.copy(viewport));
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
    }
    function renderTransmissionPass(opaqueObjects, scene, camera) {
        if (_transmissionRenderTarget === null) {
            const needsAntialias = _antialias === true && capabilities.isWebGL2 === true;
            const renderTargetType = needsAntialias ? $0147bee01cff6558$export$cb2022643d3c928d : $0147bee01cff6558$export$3c052beb2e51e23f;
            _transmissionRenderTarget = new renderTargetType(1024, 1024, {
                generateMipmaps: true,
                type: utils.convert($0147bee01cff6558$export$2697304443f382bc) !== null ? $0147bee01cff6558$export$2697304443f382bc : $0147bee01cff6558$export$2e8ce08d3f6f5e10,
                minFilter: $0147bee01cff6558$export$5d8599b6a933fb1b,
                magFilter: $0147bee01cff6558$export$727aa5ec3fe39bf0,
                wrapS: $0147bee01cff6558$export$9d9334239a5a5e06,
                wrapT: $0147bee01cff6558$export$9d9334239a5a5e06,
                useRenderToTexture: extensions.has("WEBGL_multisampled_render_to_texture")
            });
        }
        const currentRenderTarget = _this.getRenderTarget();
        _this.setRenderTarget(_transmissionRenderTarget);
        _this.clear();
        // Turn off the features which can affect the frag color for opaque objects pass.
        // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
        const currentToneMapping = _this.toneMapping;
        _this.toneMapping = $0147bee01cff6558$export$9fcb6b4294603b2;
        renderObjects(opaqueObjects, scene, camera);
        _this.toneMapping = currentToneMapping;
        textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
        textures.updateRenderTargetMipmap(_transmissionRenderTarget);
        _this.setRenderTarget(currentRenderTarget);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        material.onBeforeRender(_this, scene, camera, geometry, object, group);
        if (material.transparent === true && material.side === $0147bee01cff6558$export$3b296b6f144d5b03) {
            material.side = $0147bee01cff6558$export$d9f0486e75b5ace;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $0147bee01cff6558$export$2ede184fc2998901;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $0147bee01cff6558$export$3b296b6f144d5b03;
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let programs = materialProperties.programs;
        // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
        if (programs === undefined) {
            // new material
            material.addEventListener("dispose", onMaterialDispose);
            programs = new Map();
            materialProperties.programs = programs;
        }
        let program = programs.get(programCacheKey);
        if (program !== undefined) // early out if program and light state is identical
        {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                updateCommonMaterialProperties(material, parameters);
                return program;
            }
        } else {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBuild(object, parameters, _this);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters.uniforms;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
        updateCommonMaterialProperties(material, parameters);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = program.getUniforms();
        const uniformsList = $0147bee01cff6558$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = uniformsList;
        return program;
    }
    function updateCommonMaterialProperties(material, parameters) {
        const materialProperties = properties.get(material);
        materialProperties.outputEncoding = parameters.outputEncoding;
        materialProperties.instancing = parameters.instancing;
        materialProperties.skinning = parameters.skinning;
        materialProperties.morphTargets = parameters.morphTargets;
        materialProperties.morphNormals = parameters.morphNormals;
        materialProperties.morphTargetsCount = parameters.morphTargetsCount;
        materialProperties.numClippingPlanes = parameters.numClippingPlanes;
        materialProperties.numIntersection = parameters.numClipIntersection;
        materialProperties.vertexAlphas = parameters.vertexAlphas;
        materialProperties.vertexTangents = parameters.vertexTangents;
        materialProperties.toneMapping = parameters.toneMapping;
    }
    function setProgram(camera, scene, geometry, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : $0147bee01cff6558$export$7207336e4151a112;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
        const vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
        const morphTargets = !!geometry.morphAttributes.position;
        const morphNormals = !!geometry.morphAttributes.normal;
        const morphTargetsCount = !!geometry.morphAttributes.position ? geometry.morphAttributes.position.length : 0;
        const toneMapping = material.toneMapped ? _this.toneMapping : $0147bee01cff6558$export$9fcb6b4294603b2;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        //
        let needsProgramChange = false;
        if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
            else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
            else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
            else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
            else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
            else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
            else if (materialProperties.envMap !== envMap) needsProgramChange = true;
            else if (material.fog && materialProperties.fog !== fog) needsProgramChange = true;
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
            else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
            else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
            else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
            else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
            else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
            else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
        } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
        }
        //
        let program = materialProperties.currentProgram;
        if (needsProgramChange === true) program = getProgram(material, scene, object);
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
        }
        // skinning and morph target uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone and morph texture must go before other textures
        // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
        if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, "bindMatrix");
            p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
            const skeleton = object.skeleton;
            if (skeleton) {
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                } else p_uniforms.setOptional(_gl, skeleton, "boneMatrices");
            }
        }
        if (!!geometry && (geometry.morphAttributes.position !== undefined || geometry.morphAttributes.normal !== undefined)) morphtargets.update(object, geometry, material, program);
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
            $0147bee01cff6558$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            $0147bee01cff6558$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
        // common matrices
        p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
        p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
        p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
        properties.get(renderTarget.texture).__webglTexture = colorTexture;
        properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__hasExternalTextures = true;
        if (renderTargetProperties.__hasExternalTextures) {
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (renderTarget.useRenderToTexture) {
                    console.warn("render-to-texture extension was disabled because an external texture was provided");
                    renderTarget.useRenderToTexture = false;
                    renderTarget.useRenderbuffer = true;
                }
            }
        }
    };
    this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
        renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        let useDefaultFramebuffer = true;
        if (renderTarget) {
            const renderTargetProperties = properties.get(renderTarget);
            if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                // We need to make sure to rebind the framebuffer.
                state.bindFramebuffer(36160, null);
                useDefaultFramebuffer = false;
            } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
            else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
            textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
        }
        let framebuffer = null;
        let isCube = false;
        let isRenderTarget3D = false;
        if (renderTarget) {
            const texture = renderTarget.texture;
            if (texture.isDataTexture3D || texture.isDataTexture2DArray) isRenderTarget3D = true;
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (renderTarget.useRenderbuffer) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        const framebufferBound = state.bindFramebuffer(36160, framebuffer);
        if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
            const textureProperties = properties.get(renderTarget.texture);
            const layer = activeCubeFace || 0;
            _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
        }
        _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            state.bindFramebuffer(36160, framebuffer);
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== $0147bee01cff6558$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    return;
                }
                const halfFloatSupportedByExt = textureType === $0147bee01cff6558$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                if (textureType !== $0147bee01cff6558$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                !(textureType === $0147bee01cff6558$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    return;
                }
                if (_gl.checkFramebufferStatus(36160) === 36053) // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                {
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } else console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
            } finally{
                // restore framebuffer of current render target if necessary
                const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                state.bindFramebuffer(36160, framebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        if (texture.isFramebufferTexture !== true) {
            console.error("THREE.WebGLRenderer: copyFramebufferToTexture() can only be used with FramebufferTexture.");
            return;
        }
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        textures.setTexture2D(texture, 0);
        _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
        if (_this.isWebGL1Renderer) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
            return;
        }
        const width = sourceBox.max.x - sourceBox.min.x + 1;
        const height = sourceBox.max.y - sourceBox.min.y + 1;
        const depth = sourceBox.max.z - sourceBox.min.z + 1;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        let glTarget;
        if (dstTexture.isDataTexture3D) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = 32879;
        } else if (dstTexture.isDataTexture2DArray) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = 35866;
        } else {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            return;
        }
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        const unpackRowLen = _gl.getParameter(3314);
        const unpackImageHeight = _gl.getParameter(32878);
        const unpackSkipPixels = _gl.getParameter(3316);
        const unpackSkipRows = _gl.getParameter(3315);
        const unpackSkipImages = _gl.getParameter(32877);
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
        _gl.pixelStorei(3314, image.width);
        _gl.pixelStorei(32878, image.height);
        _gl.pixelStorei(3316, sourceBox.min.x);
        _gl.pixelStorei(3315, sourceBox.min.y);
        _gl.pixelStorei(32877, sourceBox.min.z);
        if (srcTexture.isDataTexture || srcTexture.isDataTexture3D) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
        else if (srcTexture.isCompressedTexture) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
            _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
        } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
        _gl.pixelStorei(3314, unpackRowLen);
        _gl.pixelStorei(32878, unpackImageHeight);
        _gl.pixelStorei(3316, unpackSkipPixels);
        _gl.pixelStorei(3315, unpackSkipRows);
        _gl.pixelStorei(32877, unpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    }));
}
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.isWebGLRenderer = true;
class $0147bee01cff6558$export$a2f65229194348f9 extends $0147bee01cff6558$export$f6cc00ef28d7cf97 {
}
$0147bee01cff6558$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $0147bee01cff6558$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.name = "";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $0147bee01cff6558$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
$0147bee01cff6558$export$6f1519f023b8d0f6.prototype.isFogExp2 = true;
class $0147bee01cff6558$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.name = "";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $0147bee01cff6558$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
$0147bee01cff6558$export$3c890837b09508d4.prototype.isFog = true;
class $0147bee01cff6558$export$38af1803e3442a7f extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.autoUpdate = source.autoUpdate;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
}
$0147bee01cff6558$export$38af1803e3442a7f.prototype.isScene = true;
class $0147bee01cff6558$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $0147bee01cff6558$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $0147bee01cff6558$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $0147bee01cff6558$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $0147bee01cff6558$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
$0147bee01cff6558$export$3d5cd879f108f53f.prototype.isInterleavedBuffer = true;
const $0147bee01cff6558$var$_vector$6 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized === true;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $0147bee01cff6558$var$_vector$6.x = this.getX(i);
            $0147bee01cff6558$var$_vector$6.y = this.getY(i);
            $0147bee01cff6558$var$_vector$6.z = this.getZ(i);
            $0147bee01cff6558$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$6.x, $0147bee01cff6558$var$_vector$6.y, $0147bee01cff6558$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$6.x = this.getX(i);
            $0147bee01cff6558$var$_vector$6.y = this.getY(i);
            $0147bee01cff6558$var$_vector$6.z = this.getZ(i);
            $0147bee01cff6558$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$6.x, $0147bee01cff6558$var$_vector$6.y, $0147bee01cff6558$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0147bee01cff6558$var$_vector$6.x = this.getX(i);
            $0147bee01cff6558$var$_vector$6.y = this.getY(i);
            $0147bee01cff6558$var$_vector$6.z = this.getZ(i);
            $0147bee01cff6558$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $0147bee01cff6558$var$_vector$6.x, $0147bee01cff6558$var$_vector$6.y, $0147bee01cff6558$var$_vector$6.z);
        }
        return this;
    }
    setX(index, x) {
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        return this.data.array[index * this.data.stride + this.offset];
    }
    getY(index) {
        return this.data.array[index * this.data.stride + this.offset + 1];
    }
    getZ(index) {
        return this.data.array[index * this.data.stride + this.offset + 2];
    }
    getW(index) {
        return this.data.array[index * this.data.stride + this.offset + 3];
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $0147bee01cff6558$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $0147bee01cff6558$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interlaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
$0147bee01cff6558$export$920b6d07334599c7.prototype.isInterleavedBufferAttribute = true;
/**
 * parameters = {
 *  color: <hex>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *  rotation: <float>,
 *  sizeAttenuation: <bool>
 * }
 */ class $0147bee01cff6558$export$5ec7dd1c6994bf8e extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "SpriteMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        return this;
    }
}
$0147bee01cff6558$export$5ec7dd1c6994bf8e.prototype.isSpriteMaterial = true;
let $0147bee01cff6558$var$_geometry;
const $0147bee01cff6558$var$_intersectPoint = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_worldScale = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_mvPosition = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_alignedPosition = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_rotatedPosition = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_viewWorldMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_vA = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vB = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_vC = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_uvA = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_uvB = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
const $0147bee01cff6558$var$_uvC = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
class $0147bee01cff6558$export$3075603db8e6204c extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.type = "Sprite";
        if ($0147bee01cff6558$var$_geometry === undefined) {
            $0147bee01cff6558$var$_geometry = new $0147bee01cff6558$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $0147bee01cff6558$export$3d5cd879f108f53f(float32Array, 5);
            $0147bee01cff6558$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $0147bee01cff6558$var$_geometry.setAttribute("position", new $0147bee01cff6558$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $0147bee01cff6558$var$_geometry.setAttribute("uv", new $0147bee01cff6558$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $0147bee01cff6558$var$_geometry;
        this.material = material !== undefined ? material : new $0147bee01cff6558$export$5ec7dd1c6994bf8e();
        this.center = new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $0147bee01cff6558$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $0147bee01cff6558$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $0147bee01cff6558$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $0147bee01cff6558$var$_worldScale.multiplyScalar(-$0147bee01cff6558$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $0147bee01cff6558$var$transformVertex($0147bee01cff6558$var$_vA.set(-0.5, -0.5, 0), $0147bee01cff6558$var$_mvPosition, center, $0147bee01cff6558$var$_worldScale, sin, cos);
        $0147bee01cff6558$var$transformVertex($0147bee01cff6558$var$_vB.set(0.5, -0.5, 0), $0147bee01cff6558$var$_mvPosition, center, $0147bee01cff6558$var$_worldScale, sin, cos);
        $0147bee01cff6558$var$transformVertex($0147bee01cff6558$var$_vC.set(0.5, 0.5, 0), $0147bee01cff6558$var$_mvPosition, center, $0147bee01cff6558$var$_worldScale, sin, cos);
        $0147bee01cff6558$var$_uvA.set(0, 0);
        $0147bee01cff6558$var$_uvB.set(1, 0);
        $0147bee01cff6558$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($0147bee01cff6558$var$_vA, $0147bee01cff6558$var$_vB, $0147bee01cff6558$var$_vC, false, $0147bee01cff6558$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $0147bee01cff6558$var$transformVertex($0147bee01cff6558$var$_vB.set(-0.5, 0.5, 0), $0147bee01cff6558$var$_mvPosition, center, $0147bee01cff6558$var$_worldScale, sin, cos);
            $0147bee01cff6558$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($0147bee01cff6558$var$_vA, $0147bee01cff6558$var$_vC, $0147bee01cff6558$var$_vB, false, $0147bee01cff6558$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($0147bee01cff6558$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $0147bee01cff6558$var$_intersectPoint.clone(),
            uv: $0147bee01cff6558$export$5a465592bfe74b48.getUV($0147bee01cff6558$var$_intersectPoint, $0147bee01cff6558$var$_vA, $0147bee01cff6558$var$_vB, $0147bee01cff6558$var$_vC, $0147bee01cff6558$var$_uvA, $0147bee01cff6558$var$_uvB, $0147bee01cff6558$var$_uvC, new $0147bee01cff6558$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source) {
        super.copy(source);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
$0147bee01cff6558$export$3075603db8e6204c.prototype.isSprite = true;
function $0147bee01cff6558$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $0147bee01cff6558$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $0147bee01cff6558$var$_rotatedPosition.x = cos * $0147bee01cff6558$var$_alignedPosition.x - sin * $0147bee01cff6558$var$_alignedPosition.y;
        $0147bee01cff6558$var$_rotatedPosition.y = sin * $0147bee01cff6558$var$_alignedPosition.x + cos * $0147bee01cff6558$var$_alignedPosition.y;
    } else $0147bee01cff6558$var$_rotatedPosition.copy($0147bee01cff6558$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $0147bee01cff6558$var$_rotatedPosition.x;
    vertexPosition.y += $0147bee01cff6558$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($0147bee01cff6558$var$_viewWorldMatrix);
}
const $0147bee01cff6558$var$_v1$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$112e7237be0c5f30 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $0147bee01cff6558$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($0147bee01cff6558$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $0147bee01cff6558$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $0147bee01cff6558$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $0147bee01cff6558$var$_v1$2.distanceTo($0147bee01cff6558$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
}
const $0147bee01cff6558$var$_basePosition = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_skinIndex = /*@__PURE__*/ new $0147bee01cff6558$export$fa7daccca11cdbe3();
const $0147bee01cff6558$var$_skinWeight = /*@__PURE__*/ new $0147bee01cff6558$export$fa7daccca11cdbe3();
const $0147bee01cff6558$var$_vector$5 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_matrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
class $0147bee01cff6558$export$b303577035157ecf extends $0147bee01cff6558$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $0147bee01cff6558$export$2ae72fc923e5eb5();
    }
    copy(source) {
        super.copy(source);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $0147bee01cff6558$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.x = skinWeight.getX(i);
            vector.y = skinWeight.getY(i);
            vector.z = skinWeight.getZ(i);
            vector.w = skinWeight.getW(i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    boneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $0147bee01cff6558$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $0147bee01cff6558$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $0147bee01cff6558$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $0147bee01cff6558$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $0147bee01cff6558$var$_skinIndex.getComponent(i);
                $0147bee01cff6558$var$_matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($0147bee01cff6558$var$_vector$5.copy($0147bee01cff6558$var$_basePosition).applyMatrix4($0147bee01cff6558$var$_matrix), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
$0147bee01cff6558$export$b303577035157ecf.prototype.isSkinnedMesh = true;
class $0147bee01cff6558$export$b127726e56765aa4 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Bone";
    }
}
$0147bee01cff6558$export$b127726e56765aa4.prototype.isBone = true;
class $0147bee01cff6558$export$b691f601014eabe1 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0, minFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
$0147bee01cff6558$export$b691f601014eabe1.prototype.isDataTexture = true;
const $0147bee01cff6558$var$_offsetMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_identityMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
class $0147bee01cff6558$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $0147bee01cff6558$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $0147bee01cff6558$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $0147bee01cff6558$var$_identityMatrix;
            $0147bee01cff6558$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $0147bee01cff6558$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $0147bee01cff6558$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $0147bee01cff6558$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $0147bee01cff6558$export$b691f601014eabe1(boneMatrices, size, size, $0147bee01cff6558$export$3f8bb04b555a363c, $0147bee01cff6558$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $0147bee01cff6558$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $0147bee01cff6558$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $0147bee01cff6558$export$32ea87a8b54d744a extends $0147bee01cff6558$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        if (typeof normalized === "number") {
            meshPerAttribute = normalized;
            normalized = false;
            console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.");
        }
        super(array, itemSize, normalized);
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
$0147bee01cff6558$export$32ea87a8b54d744a.prototype.isInstancedBufferAttribute = true;
const $0147bee01cff6558$var$_instanceLocalMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_instanceWorldMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_instanceIntersects = [];
const $0147bee01cff6558$var$_mesh = /*@__PURE__*/ new $0147bee01cff6558$export$e176487c05830cc5();
class $0147bee01cff6558$export$f3c979c331175ad7 extends $0147bee01cff6558$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.instanceMatrix = new $0147bee01cff6558$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.frustumCulled = false;
    }
    copy(source) {
        super.copy(source);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $0147bee01cff6558$var$_mesh.geometry = this.geometry;
        $0147bee01cff6558$var$_mesh.material = this.material;
        if ($0147bee01cff6558$var$_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $0147bee01cff6558$var$_instanceLocalMatrix);
            $0147bee01cff6558$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $0147bee01cff6558$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $0147bee01cff6558$var$_mesh.matrixWorld = $0147bee01cff6558$var$_instanceWorldMatrix;
            $0147bee01cff6558$var$_mesh.raycast(raycaster, $0147bee01cff6558$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $0147bee01cff6558$var$_instanceIntersects.length; i < l; i++){
                const intersect = $0147bee01cff6558$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $0147bee01cff6558$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $0147bee01cff6558$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$0147bee01cff6558$export$f3c979c331175ad7.prototype.isInstancedMesh = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */ class $0147bee01cff6558$export$fbaaa33907730a0c extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "LineBasicMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        return this;
    }
}
$0147bee01cff6558$export$fbaaa33907730a0c.prototype.isLineBasicMaterial = true;
const $0147bee01cff6558$var$_start$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_end$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_inverseMatrix$1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_ray$1 = /*@__PURE__*/ new $0147bee01cff6558$export$a186db52eed6d40e();
const $0147bee01cff6558$var$_sphere$1 = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
class $0147bee01cff6558$export$17d680238e50603e extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(geometry = new $0147bee01cff6558$export$b7be63a67df8959(), material = new $0147bee01cff6558$export$fbaaa33907730a0c()){
        super();
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [
                    0
                ];
                for(let i = 1, l = positionAttribute.count; i < l; i++){
                    $0147bee01cff6558$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                    $0147bee01cff6558$var$_end$1.fromBufferAttribute(positionAttribute, i);
                    lineDistances[i] = lineDistances[i - 1];
                    lineDistances[i] += $0147bee01cff6558$var$_start$1.distanceTo($0147bee01cff6558$var$_end$1);
                }
                geometry.setAttribute("lineDistance", new $0147bee01cff6558$export$cbe7a62641830ebd(lineDistances, 1));
            } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else if (geometry.isGeometry) console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere$1.copy(geometry.boundingSphere);
        $0147bee01cff6558$var$_sphere$1.applyMatrix4(matrixWorld);
        $0147bee01cff6558$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($0147bee01cff6558$var$_sphere$1) === false) return;
        //
        $0147bee01cff6558$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $0147bee01cff6558$var$_ray$1.copy(raycaster.ray).applyMatrix4($0147bee01cff6558$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $0147bee01cff6558$export$64b5c384219d3699();
        const vEnd = new $0147bee01cff6558$export$64b5c384219d3699();
        const interSegment = new $0147bee01cff6558$export$64b5c384219d3699();
        const interRay = new $0147bee01cff6558$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, l = end - 1; i < l; i += step){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    vStart.fromBufferAttribute(positionAttribute, a);
                    vEnd.fromBufferAttribute(positionAttribute, b);
                    const distSq = $0147bee01cff6558$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            } else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for(let i = start, l = end - 1; i < l; i += step){
                    vStart.fromBufferAttribute(positionAttribute, i);
                    vEnd.fromBufferAttribute(positionAttribute, i + 1);
                    const distSq = $0147bee01cff6558$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
        } else if (geometry.isGeometry) console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
}
$0147bee01cff6558$export$17d680238e50603e.prototype.isLine = true;
const $0147bee01cff6558$var$_start = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_end = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$ff1ed10fedfdd604 extends $0147bee01cff6558$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [];
                for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                    $0147bee01cff6558$var$_start.fromBufferAttribute(positionAttribute, i);
                    $0147bee01cff6558$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                    lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                    lineDistances[i + 1] = lineDistances[i] + $0147bee01cff6558$var$_start.distanceTo($0147bee01cff6558$var$_end);
                }
                geometry.setAttribute("lineDistance", new $0147bee01cff6558$export$cbe7a62641830ebd(lineDistances, 1));
            } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else if (geometry.isGeometry) console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
    }
}
$0147bee01cff6558$export$ff1ed10fedfdd604.prototype.isLineSegments = true;
class $0147bee01cff6558$export$f85a24d745e4f17d extends $0147bee01cff6558$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "LineLoop";
    }
}
$0147bee01cff6558$export$f85a24d745e4f17d.prototype.isLineLoop = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 *
 * }
 */ class $0147bee01cff6558$export$a178c45366ce5d6b extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "PointsMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        return this;
    }
}
$0147bee01cff6558$export$a178c45366ce5d6b.prototype.isPointsMaterial = true;
const $0147bee01cff6558$var$_inverseMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_ray = /*@__PURE__*/ new $0147bee01cff6558$export$a186db52eed6d40e();
const $0147bee01cff6558$var$_sphere = /*@__PURE__*/ new $0147bee01cff6558$export$805e8b72413ccaba();
const $0147bee01cff6558$var$_position$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$1c787534cb11aa3e extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(geometry = new $0147bee01cff6558$export$b7be63a67df8959(), material = new $0147bee01cff6558$export$a178c45366ce5d6b()){
        super();
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0147bee01cff6558$var$_sphere.copy(geometry.boundingSphere);
        $0147bee01cff6558$var$_sphere.applyMatrix4(matrixWorld);
        $0147bee01cff6558$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($0147bee01cff6558$var$_sphere) === false) return;
        //
        $0147bee01cff6558$var$_inverseMatrix.copy(matrixWorld).invert();
        $0147bee01cff6558$var$_ray.copy(raycaster.ray).applyMatrix4($0147bee01cff6558$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i++){
                    const a = index.getX(i);
                    $0147bee01cff6558$var$_position$2.fromBufferAttribute(positionAttribute, a);
                    $0147bee01cff6558$var$testPoint($0147bee01cff6558$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            } else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for(let i = start, l = end; i < l; i++){
                    $0147bee01cff6558$var$_position$2.fromBufferAttribute(positionAttribute, i);
                    $0147bee01cff6558$var$testPoint($0147bee01cff6558$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            }
        } else console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
}
$0147bee01cff6558$export$1c787534cb11aa3e.prototype.isPoints = true;
function $0147bee01cff6558$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $0147bee01cff6558$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $0147bee01cff6558$export$64b5c384219d3699();
        $0147bee01cff6558$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $0147bee01cff6558$export$6e09d1edf8d5a25c extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.minFilter = minFilter !== undefined ? minFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
$0147bee01cff6558$export$6e09d1edf8d5a25c.prototype.isVideoTexture = true;
class $0147bee01cff6558$export$9270d786f73ce6fe extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(width, height, format){
        super({
            width: width,
            height: height
        });
        this.format = format;
        this.magFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.minFilter = $0147bee01cff6558$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
$0147bee01cff6558$export$9270d786f73ce6fe.prototype.isFramebufferTexture = true;
class $0147bee01cff6558$export$3466bac9141a5cc4 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
$0147bee01cff6558$export$3466bac9141a5cc4.prototype.isCompressedTexture = true;
class $0147bee01cff6558$export$f7189e49152d1c13 extends $0147bee01cff6558$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.needsUpdate = true;
    }
}
$0147bee01cff6558$export$f7189e49152d1c13.prototype.isCanvasTexture = true;
class $0147bee01cff6558$export$3f74fe60decf7462 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$3f74fe60decf7462(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$d4345c83207d7c68 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $0147bee01cff6558$export$64b5c384219d3699();
            const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
            const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$d4345c83207d7c68(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$59d971120dc8b6e7 extends $0147bee01cff6558$export$d4345c83207d7c68 {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$59d971120dc8b6e7(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$38789b531813345c extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $0147bee01cff6558$export$64b5c384219d3699();
            const b = new $0147bee01cff6558$export$64b5c384219d3699();
            const c = new $0147bee01cff6558$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $0147bee01cff6558$export$64b5c384219d3699();
            const b = new $0147bee01cff6558$export$64b5c384219d3699();
            const c = new $0147bee01cff6558$export$64b5c384219d3699();
            const centroid = new $0147bee01cff6558$export$64b5c384219d3699();
            const uvA = new $0147bee01cff6558$export$c977b3e384af9ae1();
            const uvB = new $0147bee01cff6558$export$c977b3e384af9ae1();
            const uvC = new $0147bee01cff6558$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$38789b531813345c(data.vertices, data.indices, data.radius, data.details);
    }
}
class $0147bee01cff6558$export$37cd4e52cce48c4c extends $0147bee01cff6558$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$37cd4e52cce48c4c(data.radius, data.detail);
    }
}
const $0147bee01cff6558$var$_v0 = new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v1$1 = new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_normal = new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_triangle = new $0147bee01cff6558$export$5a465592bfe74b48();
class $0147bee01cff6558$export$4730b1542707547f extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($0147bee01cff6558$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $0147bee01cff6558$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $0147bee01cff6558$var$_triangle.getNormal($0147bee01cff6558$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $0147bee01cff6558$var$_triangle[vertKeys[j]];
                    const v1 = $0147bee01cff6558$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($0147bee01cff6558$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $0147bee01cff6558$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $0147bee01cff6558$var$_v0.fromBufferAttribute(positionAttr, index0);
                $0147bee01cff6558$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($0147bee01cff6558$var$_v0.x, $0147bee01cff6558$var$_v0.y, $0147bee01cff6558$var$_v0.z);
                vertices.push($0147bee01cff6558$var$_v1$1.x, $0147bee01cff6558$var$_v1$1.y, $0147bee01cff6558$var$_v1$1.z);
            }
            this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $0147bee01cff6558$export$c977b3e384af9ae1() : new $0147bee01cff6558$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $0147bee01cff6558$export$64b5c384219d3699();
        const mat = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $0147bee01cff6558$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $0147bee01cff6558$export$64b5c384219d3699();
        binormals[0] = new $0147bee01cff6558$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($0147bee01cff6558$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($0147bee01cff6558$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $0147bee01cff6558$export$3f87a931616cde04 extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $0147bee01cff6558$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
$0147bee01cff6558$export$3f87a931616cde04.prototype.isEllipseCurve = true;
class $0147bee01cff6558$export$b1eedc9aab6300e8 extends $0147bee01cff6558$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.type = "ArcCurve";
    }
}
$0147bee01cff6558$export$b1eedc9aab6300e8.prototype.isArcCurve = true;
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $0147bee01cff6558$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $0147bee01cff6558$var$tmp = new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$px = new $0147bee01cff6558$var$CubicPoly(), $0147bee01cff6558$var$py = new $0147bee01cff6558$var$CubicPoly(), $0147bee01cff6558$var$pz = new $0147bee01cff6558$var$CubicPoly();
class $0147bee01cff6558$export$b9146b27c24b744c extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $0147bee01cff6558$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $0147bee01cff6558$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $0147bee01cff6558$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $0147bee01cff6558$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $0147bee01cff6558$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $0147bee01cff6558$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $0147bee01cff6558$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $0147bee01cff6558$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $0147bee01cff6558$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $0147bee01cff6558$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($0147bee01cff6558$var$px.calc(weight), $0147bee01cff6558$var$py.calc(weight), $0147bee01cff6558$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $0147bee01cff6558$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
$0147bee01cff6558$export$b9146b27c24b744c.prototype.isCatmullRomCurve3 = true;
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $0147bee01cff6558$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $0147bee01cff6558$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $0147bee01cff6558$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $0147bee01cff6558$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $0147bee01cff6558$var$QuadraticBezier(t, p0, p1, p2) {
    return $0147bee01cff6558$var$QuadraticBezierP0(t, p0) + $0147bee01cff6558$var$QuadraticBezierP1(t, p1) + $0147bee01cff6558$var$QuadraticBezierP2(t, p2);
}
//
function $0147bee01cff6558$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $0147bee01cff6558$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $0147bee01cff6558$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $0147bee01cff6558$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $0147bee01cff6558$var$CubicBezier(t, p0, p1, p2, p3) {
    return $0147bee01cff6558$var$CubicBezierP0(t, p0) + $0147bee01cff6558$var$CubicBezierP1(t, p1) + $0147bee01cff6558$var$CubicBezierP2(t, p2) + $0147bee01cff6558$var$CubicBezierP3(t, p3);
}
class $0147bee01cff6558$export$e36650d36468bb39 extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v1 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v2 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v3 = new $0147bee01cff6558$export$c977b3e384af9ae1()){
        super();
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($0147bee01cff6558$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $0147bee01cff6558$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
$0147bee01cff6558$export$e36650d36468bb39.prototype.isCubicBezierCurve = true;
class $0147bee01cff6558$export$13d5f1c9525f246c extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0147bee01cff6558$export$64b5c384219d3699(), v1 = new $0147bee01cff6558$export$64b5c384219d3699(), v2 = new $0147bee01cff6558$export$64b5c384219d3699(), v3 = new $0147bee01cff6558$export$64b5c384219d3699()){
        super();
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($0147bee01cff6558$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $0147bee01cff6558$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $0147bee01cff6558$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
$0147bee01cff6558$export$13d5f1c9525f246c.prototype.isCubicBezierCurve3 = true;
class $0147bee01cff6558$export$ab2e07e76531a47e extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v2 = new $0147bee01cff6558$export$c977b3e384af9ae1()){
        super();
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget) {
        const tangent = optionalTarget || new $0147bee01cff6558$export$c977b3e384af9ae1();
        tangent.copy(this.v2).sub(this.v1).normalize();
        return tangent;
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$0147bee01cff6558$export$ab2e07e76531a47e.prototype.isLineCurve = true;
class $0147bee01cff6558$export$1fdfd9d9cf487600 extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $0147bee01cff6558$export$64b5c384219d3699(), v2 = new $0147bee01cff6558$export$64b5c384219d3699()){
        super();
        this.type = "LineCurve3";
        this.isLineCurve3 = true;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0147bee01cff6558$export$5938c4ee491a43ad extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v1 = new $0147bee01cff6558$export$c977b3e384af9ae1(), v2 = new $0147bee01cff6558$export$c977b3e384af9ae1()){
        super();
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($0147bee01cff6558$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $0147bee01cff6558$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$0147bee01cff6558$export$5938c4ee491a43ad.prototype.isQuadraticBezierCurve = true;
class $0147bee01cff6558$export$bf3f4c7e459f90fc extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0147bee01cff6558$export$64b5c384219d3699(), v1 = new $0147bee01cff6558$export$64b5c384219d3699(), v2 = new $0147bee01cff6558$export$64b5c384219d3699()){
        super();
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($0147bee01cff6558$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $0147bee01cff6558$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $0147bee01cff6558$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$0147bee01cff6558$export$bf3f4c7e459f90fc.prototype.isQuadraticBezierCurve3 = true;
class $0147bee01cff6558$export$d3bdd77da77afc1b extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $0147bee01cff6558$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($0147bee01cff6558$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $0147bee01cff6558$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $0147bee01cff6558$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
$0147bee01cff6558$export$d3bdd77da77afc1b.prototype.isSplineCurve = true;
var $0147bee01cff6558$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $0147bee01cff6558$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $0147bee01cff6558$export$b9146b27c24b744c,
    CubicBezierCurve: $0147bee01cff6558$export$e36650d36468bb39,
    CubicBezierCurve3: $0147bee01cff6558$export$13d5f1c9525f246c,
    EllipseCurve: $0147bee01cff6558$export$3f87a931616cde04,
    LineCurve: $0147bee01cff6558$export$ab2e07e76531a47e,
    LineCurve3: $0147bee01cff6558$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $0147bee01cff6558$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $0147bee01cff6558$export$bf3f4c7e459f90fc,
    SplineCurve: $0147bee01cff6558$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $0147bee01cff6558$export$4aaf9b66af1bbf2c extends $0147bee01cff6558$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $0147bee01cff6558$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $0147bee01cff6558$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $0147bee01cff6558$export$4b2950bdac9b6ee9 extends $0147bee01cff6558$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $0147bee01cff6558$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $0147bee01cff6558$export$ab2e07e76531a47e(this.currentPoint.clone(), new $0147bee01cff6558$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $0147bee01cff6558$export$5938c4ee491a43ad(this.currentPoint.clone(), new $0147bee01cff6558$export$c977b3e384af9ae1(aCPx, aCPy), new $0147bee01cff6558$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $0147bee01cff6558$export$e36650d36468bb39(this.currentPoint.clone(), new $0147bee01cff6558$export$c977b3e384af9ae1(aCP1x, aCP1y), new $0147bee01cff6558$export$c977b3e384af9ae1(aCP2x, aCP2y), new $0147bee01cff6558$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $0147bee01cff6558$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $0147bee01cff6558$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $0147bee01cff6558$export$6428a7f2611ef1fa extends $0147bee01cff6558$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $0147bee01cff6558$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $0147bee01cff6558$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const $0147bee01cff6558$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $0147bee01cff6558$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $0147bee01cff6558$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        $0147bee01cff6558$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $0147bee01cff6558$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $0147bee01cff6558$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $0147bee01cff6558$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $0147bee01cff6558$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $0147bee01cff6558$var$equals(last, last.next)) {
        $0147bee01cff6558$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $0147bee01cff6558$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($0147bee01cff6558$var$equals(p, p.next) || $0147bee01cff6558$var$area(p.prev, p, p.next) === 0)) {
            $0147bee01cff6558$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $0147bee01cff6558$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $0147bee01cff6558$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $0147bee01cff6558$var$isEarHashed(ear, minX, minY, invSize) : $0147bee01cff6558$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $0147bee01cff6558$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $0147bee01cff6558$var$earcutLinked($0147bee01cff6558$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $0147bee01cff6558$var$cureLocalIntersections($0147bee01cff6558$var$filterPoints(ear), triangles, dim);
                $0147bee01cff6558$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $0147bee01cff6558$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $0147bee01cff6558$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($0147bee01cff6558$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if ($0147bee01cff6558$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $0147bee01cff6558$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $0147bee01cff6558$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($0147bee01cff6558$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = $0147bee01cff6558$var$zOrder(minTX, minTY, minX, minY, invSize), maxZ = $0147bee01cff6558$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $0147bee01cff6558$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $0147bee01cff6558$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $0147bee01cff6558$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $0147bee01cff6558$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $0147bee01cff6558$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $0147bee01cff6558$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $0147bee01cff6558$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $0147bee01cff6558$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $0147bee01cff6558$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$0147bee01cff6558$var$equals(a, b) && $0147bee01cff6558$var$intersects(a, p, p.next, b) && $0147bee01cff6558$var$locallyInside(a, b) && $0147bee01cff6558$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            $0147bee01cff6558$var$removeNode(p);
            $0147bee01cff6558$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $0147bee01cff6558$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $0147bee01cff6558$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $0147bee01cff6558$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $0147bee01cff6558$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $0147bee01cff6558$var$filterPoints(a, a.next);
                c = $0147bee01cff6558$var$filterPoints(c, c.next);
                // run earcut on each half
                $0147bee01cff6558$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $0147bee01cff6558$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $0147bee01cff6558$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $0147bee01cff6558$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($0147bee01cff6558$var$getLeftmost(list));
    }
    queue.sort($0147bee01cff6558$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $0147bee01cff6558$var$eliminateHole(queue[i], outerNode);
        outerNode = $0147bee01cff6558$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $0147bee01cff6558$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $0147bee01cff6558$var$eliminateHole(hole, outerNode) {
    outerNode = $0147bee01cff6558$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = $0147bee01cff6558$var$splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        $0147bee01cff6558$var$filterPoints(outerNode, outerNode.next);
        $0147bee01cff6558$var$filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $0147bee01cff6558$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $0147bee01cff6558$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($0147bee01cff6558$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $0147bee01cff6558$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $0147bee01cff6558$var$sectorContainsSector(m, p) {
    return $0147bee01cff6558$var$area(m.prev, m, p.prev) < 0 && $0147bee01cff6558$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $0147bee01cff6558$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = $0147bee01cff6558$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $0147bee01cff6558$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $0147bee01cff6558$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $0147bee01cff6558$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $0147bee01cff6558$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $0147bee01cff6558$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $0147bee01cff6558$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$0147bee01cff6558$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($0147bee01cff6558$var$locallyInside(a, b) && $0147bee01cff6558$var$locallyInside(b, a) && $0147bee01cff6558$var$middleInside(a, b) && // locally visible
    ($0147bee01cff6558$var$area(a.prev, a, b.prev) || $0147bee01cff6558$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $0147bee01cff6558$var$equals(a, b) && $0147bee01cff6558$var$area(a.prev, a, a.next) > 0 && $0147bee01cff6558$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $0147bee01cff6558$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $0147bee01cff6558$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $0147bee01cff6558$var$intersects(p1, q1, p2, q2) {
    const o1 = $0147bee01cff6558$var$sign($0147bee01cff6558$var$area(p1, q1, p2));
    const o2 = $0147bee01cff6558$var$sign($0147bee01cff6558$var$area(p1, q1, q2));
    const o3 = $0147bee01cff6558$var$sign($0147bee01cff6558$var$area(p2, q2, p1));
    const o4 = $0147bee01cff6558$var$sign($0147bee01cff6558$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $0147bee01cff6558$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $0147bee01cff6558$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $0147bee01cff6558$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $0147bee01cff6558$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $0147bee01cff6558$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $0147bee01cff6558$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $0147bee01cff6558$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $0147bee01cff6558$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $0147bee01cff6558$var$locallyInside(a, b) {
    return $0147bee01cff6558$var$area(a.prev, a, a.next) < 0 ? $0147bee01cff6558$var$area(a, b, a.next) >= 0 && $0147bee01cff6558$var$area(a, a.prev, b) >= 0 : $0147bee01cff6558$var$area(a, b, a.prev) < 0 || $0147bee01cff6558$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $0147bee01cff6558$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $0147bee01cff6558$var$splitPolygon(a, b) {
    const a2 = new $0147bee01cff6558$var$Node(a.i, a.x, a.y), b2 = new $0147bee01cff6558$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $0147bee01cff6558$var$insertNode(i, x, y, last) {
    const p = new $0147bee01cff6558$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $0147bee01cff6558$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $0147bee01cff6558$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $0147bee01cff6558$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $0147bee01cff6558$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $0147bee01cff6558$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $0147bee01cff6558$var$removeDupEndPts(contour);
        $0147bee01cff6558$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($0147bee01cff6558$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $0147bee01cff6558$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $0147bee01cff6558$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $0147bee01cff6558$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $0147bee01cff6558$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $0147bee01cff6558$export$91836d01b9f75a58 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(shapes = new $0147bee01cff6558$export$6428a7f2611ef1fa([
        new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, 0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(-0.5, 0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(-0.5, -0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            let depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $0147bee01cff6558$var$WorldUVGenerator;
            // deprecated options
            if (options.amount !== undefined) {
                console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth.");
                depth = options.amount;
            }
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $0147bee01cff6558$export$64b5c384219d3699();
                normal = new $0147bee01cff6558$export$64b5c384219d3699();
                position2 = new $0147bee01cff6558$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $0147bee01cff6558$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $0147bee01cff6558$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $0147bee01cff6558$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $0147bee01cff6558$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $0147bee01cff6558$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $0147bee01cff6558$export$91836d01b9f75a58(geometryShapes, data.options);
    }
}
const $0147bee01cff6558$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $0147bee01cff6558$export$c977b3e384af9ae1(a_x, a_y),
            new $0147bee01cff6558$export$c977b3e384af9ae1(b_x, b_y),
            new $0147bee01cff6558$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $0147bee01cff6558$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $0147bee01cff6558$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $0147bee01cff6558$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $0147bee01cff6558$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $0147bee01cff6558$export$731fd4feef063ea2 extends $0147bee01cff6558$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$731fd4feef063ea2(data.radius, data.detail);
    }
}
class $0147bee01cff6558$export$dc3e1273c1dd9240 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(points = [
        new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, 0),
        new $0147bee01cff6558$export$c977b3e384af9ae1(0, -0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $0147bee01cff6558$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        const curNormal = new $0147bee01cff6558$export$64b5c384219d3699();
        const prevNormal = new $0147bee01cff6558$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$dc3e1273c1dd9240(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $0147bee01cff6558$export$8e05fc91596f4752 extends $0147bee01cff6558$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$8e05fc91596f4752(data.radius, data.detail);
    }
}
class $0147bee01cff6558$export$ee8b85b34b7d9cad extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$ee8b85b34b7d9cad(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$233afc324766bed8 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(shapes = new $0147bee01cff6558$export$6428a7f2611ef1fa([
        new $0147bee01cff6558$export$c977b3e384af9ae1(0, 0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(-0.5, -0.5),
        new $0147bee01cff6558$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $0147bee01cff6558$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $0147bee01cff6558$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $0147bee01cff6558$export$233afc324766bed8(geometryShapes, data.curveSegments);
    }
}
function $0147bee01cff6558$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $0147bee01cff6558$export$d5d06a966fec4192 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$d5d06a966fec4192(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $0147bee01cff6558$export$369e08f62a796c65 extends $0147bee01cff6558$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$369e08f62a796c65(data.radius, data.detail);
    }
}
class $0147bee01cff6558$export$19d55f905fa4f2cb extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $0147bee01cff6558$export$64b5c384219d3699();
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$19d55f905fa4f2cb(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $0147bee01cff6558$export$2b32466f4274fe5c extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        const P1 = new $0147bee01cff6558$export$64b5c384219d3699();
        const P2 = new $0147bee01cff6558$export$64b5c384219d3699();
        const B = new $0147bee01cff6558$export$64b5c384219d3699();
        const T = new $0147bee01cff6558$export$64b5c384219d3699();
        const N = new $0147bee01cff6558$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segement
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    static fromJSON(data) {
        return new $0147bee01cff6558$export$2b32466f4274fe5c(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $0147bee01cff6558$export$d97a193ce44e691b extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(path = new $0147bee01cff6558$export$bf3f4c7e459f90fc(new $0147bee01cff6558$export$64b5c384219d3699(-1, -1, 0), new $0147bee01cff6558$export$64b5c384219d3699(-1, 1, 0), new $0147bee01cff6558$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $0147bee01cff6558$export$64b5c384219d3699();
        const normal = new $0147bee01cff6558$export$64b5c384219d3699();
        const uv = new $0147bee01cff6558$export$c977b3e384af9ae1();
        let P = new $0147bee01cff6558$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0147bee01cff6558$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $0147bee01cff6558$export$d97a193ce44e691b(new $0147bee01cff6558$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $0147bee01cff6558$export$4b739da06d24892b extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $0147bee01cff6558$export$64b5c384219d3699();
            const end = new $0147bee01cff6558$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all eges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($0147bee01cff6558$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($0147bee01cff6558$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
function $0147bee01cff6558$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1, hash2);
        return true;
    }
}
var $0147bee01cff6558$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $0147bee01cff6558$export$ab3456a079aa7d80,
    BoxBufferGeometry: $0147bee01cff6558$export$ab3456a079aa7d80,
    CircleGeometry: $0147bee01cff6558$export$3f74fe60decf7462,
    CircleBufferGeometry: $0147bee01cff6558$export$3f74fe60decf7462,
    ConeGeometry: $0147bee01cff6558$export$59d971120dc8b6e7,
    ConeBufferGeometry: $0147bee01cff6558$export$59d971120dc8b6e7,
    CylinderGeometry: $0147bee01cff6558$export$d4345c83207d7c68,
    CylinderBufferGeometry: $0147bee01cff6558$export$d4345c83207d7c68,
    DodecahedronGeometry: $0147bee01cff6558$export$37cd4e52cce48c4c,
    DodecahedronBufferGeometry: $0147bee01cff6558$export$37cd4e52cce48c4c,
    EdgesGeometry: $0147bee01cff6558$export$4730b1542707547f,
    ExtrudeGeometry: $0147bee01cff6558$export$91836d01b9f75a58,
    ExtrudeBufferGeometry: $0147bee01cff6558$export$91836d01b9f75a58,
    IcosahedronGeometry: $0147bee01cff6558$export$731fd4feef063ea2,
    IcosahedronBufferGeometry: $0147bee01cff6558$export$731fd4feef063ea2,
    LatheGeometry: $0147bee01cff6558$export$dc3e1273c1dd9240,
    LatheBufferGeometry: $0147bee01cff6558$export$dc3e1273c1dd9240,
    OctahedronGeometry: $0147bee01cff6558$export$8e05fc91596f4752,
    OctahedronBufferGeometry: $0147bee01cff6558$export$8e05fc91596f4752,
    PlaneGeometry: $0147bee01cff6558$export$e789a11a194ca4e0,
    PlaneBufferGeometry: $0147bee01cff6558$export$e789a11a194ca4e0,
    PolyhedronGeometry: $0147bee01cff6558$export$38789b531813345c,
    PolyhedronBufferGeometry: $0147bee01cff6558$export$38789b531813345c,
    RingGeometry: $0147bee01cff6558$export$ee8b85b34b7d9cad,
    RingBufferGeometry: $0147bee01cff6558$export$ee8b85b34b7d9cad,
    ShapeGeometry: $0147bee01cff6558$export$233afc324766bed8,
    ShapeBufferGeometry: $0147bee01cff6558$export$233afc324766bed8,
    SphereGeometry: $0147bee01cff6558$export$d5d06a966fec4192,
    SphereBufferGeometry: $0147bee01cff6558$export$d5d06a966fec4192,
    TetrahedronGeometry: $0147bee01cff6558$export$369e08f62a796c65,
    TetrahedronBufferGeometry: $0147bee01cff6558$export$369e08f62a796c65,
    TorusGeometry: $0147bee01cff6558$export$19d55f905fa4f2cb,
    TorusBufferGeometry: $0147bee01cff6558$export$19d55f905fa4f2cb,
    TorusKnotGeometry: $0147bee01cff6558$export$2b32466f4274fe5c,
    TorusKnotBufferGeometry: $0147bee01cff6558$export$2b32466f4274fe5c,
    TubeGeometry: $0147bee01cff6558$export$d97a193ce44e691b,
    TubeBufferGeometry: $0147bee01cff6558$export$d97a193ce44e691b,
    WireframeGeometry: $0147bee01cff6558$export$4b739da06d24892b
});
/**
 * parameters = {
 *  color: <THREE.Color>
 * }
 */ class $0147bee01cff6558$export$e8564da406055a3 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "ShadowMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        return this;
    }
}
$0147bee01cff6558$export$e8564da406055a3.prototype.isShadowMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  flatShading: <bool>
 * }
 */ class $0147bee01cff6558$export$f2980790215acccd extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        return this;
    }
}
$0147bee01cff6558$export$f2980790215acccd.prototype.isMeshStandardMaterial = true;
/**
 * parameters = {
 *  clearcoat: <float>,
 *  clearcoatMap: new THREE.Texture( <Image> ),
 *  clearcoatRoughness: <float>,
 *  clearcoatRoughnessMap: new THREE.Texture( <Image> ),
 *  clearcoatNormalScale: <Vector2>,
 *  clearcoatNormalMap: new THREE.Texture( <Image> ),
 *
 *  ior: <float>,
 *  reflectivity: <float>,
 *
 *  sheen: <float>,
 *  sheenColor: <Color>,
 *  sheenColorMap: new THREE.Texture( <Image> ),
 *  sheenRoughness: <float>,
 *  sheenRoughnessMap: new THREE.Texture( <Image> ),
 *
 *  transmission: <float>,
 *  transmissionMap: new THREE.Texture( <Image> ),
 *
 *  thickness: <float>,
 *  thicknessMap: new THREE.Texture( <Image> ),
 *  attenuationDistance: <float>,
 *  attenuationColor: <Color>,
 *
 *  specularIntensity: <float>,
 *  specularIntensityMap: new THREE.Texture( <Image> ),
 *  specularColor: <Color>,
 *  specularColorMap: new THREE.Texture( <Image> )
 * }
 */ class $0147bee01cff6558$export$28d04986c4269c9f extends $0147bee01cff6558$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $0147bee01cff6558$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.sheenColor = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = 0.0;
        this.attenuationColor = new $0147bee01cff6558$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $0147bee01cff6558$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._sheen = 0.0;
        this._clearcoat = 0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
$0147bee01cff6558$export$28d04986c4269c9f.prototype.isMeshPhysicalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.MultiplyOperation,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  flatShading: <bool>
 * }
 */ class $0147bee01cff6558$export$24c72f71cbaf0678 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshPhongMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $0147bee01cff6558$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0147bee01cff6558$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        return this;
    }
}
$0147bee01cff6558$export$24c72f71cbaf0678.prototype.isMeshPhongMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *
 *  map: new THREE.Texture( <Image> ),
 *  gradientMap: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 * }
 */ class $0147bee01cff6558$export$df893cf97e765622 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        return this;
    }
}
$0147bee01cff6558$export$df893cf97e765622.prototype.isMeshToonMaterial = true;
/**
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  flatShading: <bool>
 * }
 */ class $0147bee01cff6558$export$bfe8c0a091f41ae7 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
$0147bee01cff6558$export$bfe8c0a091f41ae7.prototype.isMeshNormalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 * }
 */ class $0147bee01cff6558$export$5023a9a8114806b8 extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshLambertMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0147bee01cff6558$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0147bee01cff6558$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        return this;
    }
}
$0147bee01cff6558$export$5023a9a8114806b8.prototype.isMeshLambertMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  matcap: new THREE.Texture( <Image> ),
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  flatShading: <bool>
 * }
 */ class $0147bee01cff6558$export$6f5fef6235ec12ee extends $0147bee01cff6558$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0147bee01cff6558$export$2852a58ebdac27b8;
        this.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        return this;
    }
}
$0147bee01cff6558$export$6f5fef6235ec12ee.prototype.isMeshMatcapMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */ class $0147bee01cff6558$export$327886a3efaeaebe extends $0147bee01cff6558$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
$0147bee01cff6558$export$327886a3efaeaebe.prototype.isLineDashedMaterial = true;
var $0147bee01cff6558$var$Materials = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ShadowMaterial: $0147bee01cff6558$export$e8564da406055a3,
    SpriteMaterial: $0147bee01cff6558$export$5ec7dd1c6994bf8e,
    RawShaderMaterial: $0147bee01cff6558$export$21c421a2e1df9d22,
    ShaderMaterial: $0147bee01cff6558$export$83c7d75d550a8b0d,
    PointsMaterial: $0147bee01cff6558$export$a178c45366ce5d6b,
    MeshPhysicalMaterial: $0147bee01cff6558$export$28d04986c4269c9f,
    MeshStandardMaterial: $0147bee01cff6558$export$f2980790215acccd,
    MeshPhongMaterial: $0147bee01cff6558$export$24c72f71cbaf0678,
    MeshToonMaterial: $0147bee01cff6558$export$df893cf97e765622,
    MeshNormalMaterial: $0147bee01cff6558$export$bfe8c0a091f41ae7,
    MeshLambertMaterial: $0147bee01cff6558$export$5023a9a8114806b8,
    MeshDepthMaterial: $0147bee01cff6558$export$2698c22ec13825db,
    MeshDistanceMaterial: $0147bee01cff6558$export$33e187ed002f2a19,
    MeshBasicMaterial: $0147bee01cff6558$export$55cbcc9b622fe1f5,
    MeshMatcapMaterial: $0147bee01cff6558$export$6f5fef6235ec12ee,
    LineDashedMaterial: $0147bee01cff6558$export$327886a3efaeaebe,
    LineBasicMaterial: $0147bee01cff6558$export$fbaaa33907730a0c,
    Material: $0147bee01cff6558$export$a2d8b23205c25948
});
const $0147bee01cff6558$export$7ee8caa573e71ad1 = {
    // same as Array.prototype.slice, but also works on typed arrays
    arraySlice: function(array, from, to) {
        if ($0147bee01cff6558$export$7ee8caa573e71ad1.isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
        // but array.subarray(from) or array.subarray(from, len) is correct
        return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
        return array.slice(from, to);
    },
    // converts an array to a specific type
    convertArray: function(array, type, forceClone) {
        if (!array || // let 'undefined' and 'null' pass
        !forceClone && array.constructor === type) return array;
        if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
        return Array.prototype.slice.call(array); // create Array
    },
    isTypedArray: function(object) {
        return ArrayBuffer.isView(object) && !(object instanceof DataView);
    },
    // returns an array by which times and values can be sorted
    getKeyframeOrder: function(times) {
        function compareTime(i, j) {
            return times[i] - times[j];
        }
        const n = times.length;
        const result = new Array(n);
        for(let i = 0; i !== n; ++i)result[i] = i;
        result.sort(compareTime);
        return result;
    },
    // uses the array previously returned by 'getKeyframeOrder' to sort data
    sortedArray: function(values, stride, order) {
        const nValues = values.length;
        const result = new values.constructor(nValues);
        for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
            const srcOffset = order[i] * stride;
            for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
        }
        return result;
    },
    // function for parsing AOS keyframe formats
    flattenJSON: function(jsonKeys, times, values, valuePropertyName) {
        let i = 1, key = jsonKeys[0];
        while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
        if (key === undefined) return; // no data
        let value = key[valuePropertyName];
        if (value === undefined) return; // no data
        if (Array.isArray(value)) do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push.apply(values, value); // push all elements
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else if (value.toArray !== undefined) // ...assume THREE.Math-ish
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                value.toArray(values, values.length);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else // otherwise push as-is
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push(value);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
    },
    subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
        const clip = sourceClip.clone();
        clip.name = name;
        const tracks = [];
        for(let i = 0; i < clip.tracks.length; ++i){
            const track = clip.tracks[i];
            const valueSize = track.getValueSize();
            const times = [];
            const values = [];
            for(let j = 0; j < track.times.length; ++j){
                const frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
            }
            if (times.length === 0) continue;
            track.times = $0147bee01cff6558$export$7ee8caa573e71ad1.convertArray(times, track.times.constructor);
            track.values = $0147bee01cff6558$export$7ee8caa573e71ad1.convertArray(values, track.values.constructor);
            tracks.push(track);
        }
        clip.tracks = tracks;
        // find minimum .times value across all tracks in the trimmed clip
        let minStartTime = Infinity;
        for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
        // shift all tracks such that clip begins at t=0
        for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
        clip.resetDuration();
        return clip;
    },
    makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        if (fps <= 0) fps = 30;
        const numTracks = referenceClip.tracks.length;
        const referenceTime = referenceFrame / fps;
        // Make each track's values relative to the values at the reference frame
        for(let i = 0; i < numTracks; ++i){
            const referenceTrack = referenceClip.tracks[i];
            const referenceTrackType = referenceTrack.ValueTypeName;
            // Skip this track if it's non-numeric
            if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
            // Find the track in the target clip whose name and type matches the reference track
            const targetTrack = targetClip.tracks.find(function(track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
            });
            if (targetTrack === undefined) continue;
            let referenceOffset = 0;
            const referenceValueSize = referenceTrack.getValueSize();
            if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
            let targetOffset = 0;
            const targetValueSize = targetTrack.getValueSize();
            if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
            const lastIndex = referenceTrack.times.length - 1;
            let referenceValue;
            // Find the value to subtract out of the track
            if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                referenceValue = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                const startIndex = lastIndex * referenceValueSize + referenceOffset;
                const endIndex = startIndex + referenceValueSize - referenceOffset;
                referenceValue = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else {
                // Interpolate to the reference value
                const interpolant = referenceTrack.createInterpolant();
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
            }
            // Conjugate the quaternion
            if (referenceTrackType === "quaternion") {
                const referenceQuat = new $0147bee01cff6558$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
            }
            // Subtract the reference value from all of the track values
            const numTimes = targetTrack.times.length;
            for(let j = 0; j < numTimes; ++j){
                const valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
                $0147bee01cff6558$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                else {
                    const valueEnd = targetValueSize - targetOffset * 2;
                    // Subtract each value for all other numeric track types
                    for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
                }
            }
        }
        targetClip.blendMode = $0147bee01cff6558$export$d875e029ef558d3;
        return targetClip;
    }
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.afterEnd_(i1 - 1, t, t0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.beforeStart_(0, t, t1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.beforeStart_(0, t, t1);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.afterEnd_(i1 - 1, t0, t);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
// ALIAS DEFINITIONS
$0147bee01cff6558$export$b558baee9c0f72d3.prototype.beforeStart_ = $0147bee01cff6558$export$b558baee9c0f72d3.prototype.copySampleValue_;
$0147bee01cff6558$export$b558baee9c0f72d3.prototype.afterEnd_ = $0147bee01cff6558$export$b558baee9c0f72d3.prototype.copySampleValue_;
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $0147bee01cff6558$export$3646682e7a3959 extends $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $0147bee01cff6558$export$7f795934b84ab523,
            endingEnd: $0147bee01cff6558$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $0147bee01cff6558$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $0147bee01cff6558$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $0147bee01cff6558$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $0147bee01cff6558$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $0147bee01cff6558$export$a8e6009059f51e1a extends $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 */ class $0147bee01cff6558$export$fb9758ef7ef8d5cc extends $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $0147bee01cff6558$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $0147bee01cff6558$export$7ee8caa573e71ad1.convertArray(times, this.TimeBufferType);
        this.values = $0147bee01cff6558$export$7ee8caa573e71ad1.convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $0147bee01cff6558$export$7ee8caa573e71ad1.convertArray(track.times, Array),
                "values": $0147bee01cff6558$export$7ee8caa573e71ad1.convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $0147bee01cff6558$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $0147bee01cff6558$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $0147bee01cff6558$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $0147bee01cff6558$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $0147bee01cff6558$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $0147bee01cff6558$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $0147bee01cff6558$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $0147bee01cff6558$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $0147bee01cff6558$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(times, from, to);
            this.values = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($0147bee01cff6558$export$7ee8caa573e71ad1.isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(this.times), values = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $0147bee01cff6558$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(times, 0, writeIndex);
            this.values = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(this.times, 0);
        const values = $0147bee01cff6558$export$7ee8caa573e71ad1.arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$0147bee01cff6558$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$0147bee01cff6558$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$0147bee01cff6558$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $0147bee01cff6558$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $0147bee01cff6558$export$d3a344b98cf0b775 extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $0147bee01cff6558$export$995b32462a65e855;
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$0147bee01cff6558$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $0147bee01cff6558$export$83444c5d885347d8 extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $0147bee01cff6558$export$d45f0d1a4d9a9314 extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $0147bee01cff6558$export$2db1cfb7923d931e extends $0147bee01cff6558$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$0147bee01cff6558$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $0147bee01cff6558$export$b8043f12b5aafbd7 extends $0147bee01cff6558$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $0147bee01cff6558$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$0147bee01cff6558$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$0147bee01cff6558$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $0147bee01cff6558$export$30fac1aace31cf4d;
$0147bee01cff6558$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $0147bee01cff6558$export$6ce41d4f3a8df9cd extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $0147bee01cff6558$export$995b32462a65e855;
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$0147bee01cff6558$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $0147bee01cff6558$export$5ce2dcb4cc9f2bff extends $0147bee01cff6558$export$b0e479f45b7006d6 {
}
$0147bee01cff6558$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $0147bee01cff6558$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $0147bee01cff6558$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $0147bee01cff6558$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($0147bee01cff6558$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($0147bee01cff6558$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $0147bee01cff6558$export$7ee8caa573e71ad1.getKeyframeOrder(times);
            times = $0147bee01cff6558$export$7ee8caa573e71ad1.sortedArray(times, 1, order);
            values = $0147bee01cff6558$export$7ee8caa573e71ad1.sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $0147bee01cff6558$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $0147bee01cff6558$export$7ee8caa573e71ad1.flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $0147bee01cff6558$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * (fps || 1.0);
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($0147bee01cff6558$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($0147bee01cff6558$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($0147bee01cff6558$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $0147bee01cff6558$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $0147bee01cff6558$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $0147bee01cff6558$export$5ce2dcb4cc9f2bff;
        case "color":
            return $0147bee01cff6558$export$83444c5d885347d8;
        case "quaternion":
            return $0147bee01cff6558$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $0147bee01cff6558$export$d3a344b98cf0b775;
        case "string":
            return $0147bee01cff6558$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $0147bee01cff6558$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $0147bee01cff6558$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $0147bee01cff6558$export$7ee8caa573e71ad1.flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $0147bee01cff6558$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $0147bee01cff6558$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $0147bee01cff6558$export$b033c3f9a95c6a16 = new $0147bee01cff6558$export$99cc795e99919eed();
class $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $0147bee01cff6558$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $0147bee01cff6558$var$loading = {};
class $0147bee01cff6558$export$98435a25b5cf7b2b extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $0147bee01cff6558$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($0147bee01cff6558$var$loading[url] !== undefined) {
            $0147bee01cff6558$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $0147bee01cff6558$var$loading[url] = [];
        $0147bee01cff6558$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                if (typeof ReadableStream === "undefined" || response.body.getReader === undefined) return response;
                const callbacks = $0147bee01cff6558$var$loading[url];
                const reader = response.body.getReader();
                const contentLength = response.headers.get("Content-Length");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw Error(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $0147bee01cff6558$export$94affb487e701bf2.add(url, data);
            const callbacks = $0147bee01cff6558$var$loading[url];
            delete $0147bee01cff6558$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $0147bee01cff6558$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $0147bee01cff6558$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $0147bee01cff6558$export$29711c7e14f61db extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $0147bee01cff6558$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $0147bee01cff6558$export$bd73ce947a280350 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $0147bee01cff6558$export$3466bac9141a5cc4();
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $0147bee01cff6558$export$8905ce1c7a2464a1 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0147bee01cff6558$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $0147bee01cff6558$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $0147bee01cff6558$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.substr(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $0147bee01cff6558$export$2ec114afc2cf6308 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $0147bee01cff6558$export$ee2e5a18258a4049();
        const loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $0147bee01cff6558$export$792d8a18f2c55855 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $0147bee01cff6558$export$b691f601014eabe1();
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $0147bee01cff6558$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $0147bee01cff6558$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $0147bee01cff6558$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $0147bee01cff6558$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $0147bee01cff6558$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $0147bee01cff6558$export$fd1bfc71f64c538c extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $0147bee01cff6558$export$5431306cf43de24a();
        const loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $0147bee01cff6558$export$6ecadb6ed240d696 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.type = "Light";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
$0147bee01cff6558$export$6ecadb6ed240d696.prototype.isLight = true;
class $0147bee01cff6558$export$8d474f55edbb9624 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.type = "HemisphereLight";
        this.position.copy($0147bee01cff6558$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.groundColor = new $0147bee01cff6558$export$892596cec99bc70e(groundColor);
    }
    copy(source) {
        $0147bee01cff6558$export$6ecadb6ed240d696.prototype.copy.call(this, source);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
$0147bee01cff6558$export$8d474f55edbb9624.prototype.isHemisphereLight = true;
const $0147bee01cff6558$var$_projScreenMatrix$1 = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_lightPositionWorld$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_lookTarget$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $0147bee01cff6558$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $0147bee01cff6558$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $0147bee01cff6558$export$35efe6f4c85463d2();
        this._frameExtents = new $0147bee01cff6558$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $0147bee01cff6558$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($0147bee01cff6558$var$_lightPositionWorld$1);
        $0147bee01cff6558$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($0147bee01cff6558$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $0147bee01cff6558$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($0147bee01cff6558$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $0147bee01cff6558$var$SpotLightShadow extends $0147bee01cff6558$var$LightShadow {
    constructor(){
        super(new $0147bee01cff6558$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $0147bee01cff6558$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
$0147bee01cff6558$var$SpotLightShadow.prototype.isSpotLightShadow = true;
class $0147bee01cff6558$export$81495cbb73897362 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 1){
        super(color, intensity);
        this.type = "SpotLight";
        this.position.copy($0147bee01cff6558$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $0147bee01cff6558$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $0147bee01cff6558$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
$0147bee01cff6558$export$81495cbb73897362.prototype.isSpotLight = true;
const $0147bee01cff6558$var$_projScreenMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_lightPositionWorld = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_lookTarget = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$var$PointLightShadow extends $0147bee01cff6558$var$LightShadow {
    constructor(){
        super(new $0147bee01cff6558$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this._frameExtents = new $0147bee01cff6558$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $0147bee01cff6558$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $0147bee01cff6558$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $0147bee01cff6558$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $0147bee01cff6558$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $0147bee01cff6558$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $0147bee01cff6558$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $0147bee01cff6558$export$64b5c384219d3699(1, 0, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(-1, 0, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 0, -1),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 1, 0),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1),
            new $0147bee01cff6558$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $0147bee01cff6558$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($0147bee01cff6558$var$_lightPositionWorld);
        $0147bee01cff6558$var$_lookTarget.copy(camera.position);
        $0147bee01cff6558$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($0147bee01cff6558$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$0147bee01cff6558$var$_lightPositionWorld.x, -$0147bee01cff6558$var$_lightPositionWorld.y, -$0147bee01cff6558$var$_lightPositionWorld.z);
        $0147bee01cff6558$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($0147bee01cff6558$var$_projScreenMatrix);
    }
}
$0147bee01cff6558$var$PointLightShadow.prototype.isPointLightShadow = true;
class $0147bee01cff6558$export$4c9c1cb3f0b6f455 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 1){
        super(color, intensity);
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $0147bee01cff6558$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
$0147bee01cff6558$export$4c9c1cb3f0b6f455.prototype.isPointLight = true;
class $0147bee01cff6558$var$DirectionalLightShadow extends $0147bee01cff6558$var$LightShadow {
    constructor(){
        super(new $0147bee01cff6558$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
    }
}
$0147bee01cff6558$var$DirectionalLightShadow.prototype.isDirectionalLightShadow = true;
class $0147bee01cff6558$export$3fea33cc9972c868 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.type = "DirectionalLight";
        this.position.copy($0147bee01cff6558$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $0147bee01cff6558$export$e4dd07dff30cc924();
        this.shadow = new $0147bee01cff6558$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
$0147bee01cff6558$export$3fea33cc9972c868.prototype.isDirectionalLight = true;
class $0147bee01cff6558$export$af279bfef9ec2c96 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.type = "AmbientLight";
    }
}
$0147bee01cff6558$export$af279bfef9ec2c96.prototype.isAmbientLight = true;
class $0147bee01cff6558$export$61db2d908bbd2429 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
$0147bee01cff6558$export$61db2d908bbd2429.prototype.isRectAreaLight = true;
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $0147bee01cff6558$export$ba61ce607e1f405a {
    constructor(){
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $0147bee01cff6558$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
$0147bee01cff6558$export$ba61ce607e1f405a.prototype.isSphericalHarmonics3 = true;
class $0147bee01cff6558$export$e7ef036e309b38d2 extends $0147bee01cff6558$export$6ecadb6ed240d696 {
    constructor(sh = new $0147bee01cff6558$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
$0147bee01cff6558$export$e7ef036e309b38d2.prototype.isLightProbe = true;
class $0147bee01cff6558$export$3bd6d323353dcf96 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = new $0147bee01cff6558$var$Materials[json.type]();
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $0147bee01cff6558$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.alphaWrite !== undefined) material.alphaWrite = json.alphaWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $0147bee01cff6558$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $0147bee01cff6558$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $0147bee01cff6558$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $0147bee01cff6558$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $0147bee01cff6558$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $0147bee01cff6558$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // Deprecated
        if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $0147bee01cff6558$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $0147bee01cff6558$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
}
class $0147bee01cff6558$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.substr(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $0147bee01cff6558$export$231f009cbe414146 extends $0147bee01cff6558$export$b7be63a67df8959 {
    constructor(){
        super();
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const data = super.toJSON(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
$0147bee01cff6558$export$231f009cbe414146.prototype.isInstancedBufferGeometry = true;
class $0147bee01cff6558$export$dc275bb96327833a extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $0147bee01cff6558$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $0147bee01cff6558$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $0147bee01cff6558$export$231f009cbe414146() : new $0147bee01cff6558$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $0147bee01cff6558$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $0147bee01cff6558$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $0147bee01cff6558$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $0147bee01cff6558$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $0147bee01cff6558$export$32ea87a8b54d744a : $0147bee01cff6558$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $0147bee01cff6558$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $0147bee01cff6558$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $0147bee01cff6558$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $0147bee01cff6558$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $0147bee01cff6558$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $0147bee01cff6558$export$40110c8505c5ad19 extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $0147bee01cff6558$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $0147bee01cff6558$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid] instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $0147bee01cff6558$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $0147bee01cff6558$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $0147bee01cff6558$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    case "Geometry":
                        console.error("THREE.ObjectLoader: The legacy Geometry type is no longer supported.");
                        break;
                    default:
                        if (data.type in $0147bee01cff6558$var$Geometries) geometry = $0147bee01cff6558$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $0147bee01cff6558$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (data.type === "MultiMaterial") {
                    // Deprecated
                    const array = [];
                    for(let j = 0; j < data.materials.length; j++){
                        const material = data.materials[j];
                        if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                        array.push(cache[material.uuid]);
                    }
                    materials[data.uuid] = array;
                } else {
                    if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                    materials[data.uuid] = cache[data.uuid];
                }
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $0147bee01cff6558$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $0147bee01cff6558$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $0147bee01cff6558$export$99cc795e99919eed(onLoad);
            loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new $0147bee01cff6558$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $0147bee01cff6558$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new $0147bee01cff6558$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            let texture;
            const image = images[data.image];
            if (Array.isArray(image)) {
                texture = new $0147bee01cff6558$export$ee2e5a18258a4049(image);
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $0147bee01cff6558$export$b691f601014eabe1(image.data, image.width, image.height);
                else texture = new $0147bee01cff6558$export$5431306cf43de24a(image);
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $0147bee01cff6558$var$TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $0147bee01cff6558$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $0147bee01cff6558$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $0147bee01cff6558$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $0147bee01cff6558$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $0147bee01cff6558$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $0147bee01cff6558$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $0147bee01cff6558$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $0147bee01cff6558$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                break;
            case "PerspectiveCamera":
                object = new $0147bee01cff6558$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $0147bee01cff6558$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $0147bee01cff6558$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $0147bee01cff6558$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $0147bee01cff6558$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $0147bee01cff6558$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $0147bee01cff6558$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $0147bee01cff6558$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $0147bee01cff6558$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0147bee01cff6558$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0147bee01cff6558$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $0147bee01cff6558$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $0147bee01cff6558$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $0147bee01cff6558$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $0147bee01cff6558$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $0147bee01cff6558$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $0147bee01cff6558$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $0147bee01cff6558$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $0147bee01cff6558$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $0147bee01cff6558$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $0147bee01cff6558$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $0147bee01cff6558$export$b127726e56765aa4();
                break;
            default:
                object = new $0147bee01cff6558$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    /* DEPRECATED */ setTexturePath(value) {
        console.warn("THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().");
        return this.setResourcePath(value);
    }
}
const $0147bee01cff6558$var$TEXTURE_MAPPING = {
    UVMapping: $0147bee01cff6558$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $0147bee01cff6558$export$8759762a6477f2c4,
    CubeRefractionMapping: $0147bee01cff6558$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $0147bee01cff6558$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $0147bee01cff6558$export$ee99d97d46898098,
    CubeUVReflectionMapping: $0147bee01cff6558$export$dbf3e70ff37af79,
    CubeUVRefractionMapping: $0147bee01cff6558$export$76a9f4355364345c
};
const $0147bee01cff6558$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $0147bee01cff6558$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $0147bee01cff6558$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $0147bee01cff6558$export$c7e7c00b14f51a4f
};
const $0147bee01cff6558$var$TEXTURE_FILTER = {
    NearestFilter: $0147bee01cff6558$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $0147bee01cff6558$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $0147bee01cff6558$export$d2327c1afe5bfdf2,
    LinearFilter: $0147bee01cff6558$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $0147bee01cff6558$export$19a719f377145a13,
    LinearMipmapLinearFilter: $0147bee01cff6558$export$5d8599b6a933fb1b
};
class $0147bee01cff6558$export$52286b55c4a9b51f extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0147bee01cff6558$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $0147bee01cff6558$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
$0147bee01cff6558$export$52286b55c4a9b51f.prototype.isImageBitmapLoader = true;
let $0147bee01cff6558$var$_context;
const $0147bee01cff6558$export$fcbc63750ec2a81f = {
    getContext: function() {
        if ($0147bee01cff6558$var$_context === undefined) $0147bee01cff6558$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $0147bee01cff6558$var$_context;
    },
    setContext: function(value) {
        $0147bee01cff6558$var$_context = value;
    }
};
class $0147bee01cff6558$export$d8d5fccfbf47714e extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0147bee01cff6558$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $0147bee01cff6558$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
}
class $0147bee01cff6558$export$2f22dadc8bc42820 extends $0147bee01cff6558$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        const color1 = new $0147bee01cff6558$export$892596cec99bc70e().set(skyColor);
        const color2 = new $0147bee01cff6558$export$892596cec99bc70e().set(groundColor);
        const sky = new $0147bee01cff6558$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $0147bee01cff6558$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
$0147bee01cff6558$export$2f22dadc8bc42820.prototype.isHemisphereLightProbe = true;
class $0147bee01cff6558$export$afe310a21c86023d extends $0147bee01cff6558$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        const color1 = new $0147bee01cff6558$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
$0147bee01cff6558$export$afe310a21c86023d.prototype.isAmbientLightProbe = true;
const $0147bee01cff6558$var$_eyeRight = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_eyeLeft = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_projectionMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
class $0147bee01cff6558$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $0147bee01cff6558$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $0147bee01cff6558$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $0147bee01cff6558$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($0147bee01cff6558$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $0147bee01cff6558$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $0147bee01cff6558$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $0147bee01cff6558$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $0147bee01cff6558$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($0147bee01cff6558$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $0147bee01cff6558$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $0147bee01cff6558$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($0147bee01cff6558$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($0147bee01cff6558$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($0147bee01cff6558$var$_eyeRight);
    }
}
class $0147bee01cff6558$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $0147bee01cff6558$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $0147bee01cff6558$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $0147bee01cff6558$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $0147bee01cff6558$var$_position$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_quaternion$1 = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
const $0147bee01cff6558$var$_scale$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_orientation$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$8a1b810c6fde8951 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $0147bee01cff6558$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $0147bee01cff6558$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($0147bee01cff6558$var$_position$1, $0147bee01cff6558$var$_quaternion$1, $0147bee01cff6558$var$_scale$1);
        $0147bee01cff6558$var$_orientation$1.set(0, 0, -1).applyQuaternion($0147bee01cff6558$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($0147bee01cff6558$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($0147bee01cff6558$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($0147bee01cff6558$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($0147bee01cff6558$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($0147bee01cff6558$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($0147bee01cff6558$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($0147bee01cff6558$var$_position$1.x, $0147bee01cff6558$var$_position$1.y, $0147bee01cff6558$var$_position$1.z);
            listener.setOrientation($0147bee01cff6558$var$_orientation$1.x, $0147bee01cff6558$var$_orientation$1.y, $0147bee01cff6558$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $0147bee01cff6558$export$153755f98d9861de extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $0147bee01cff6558$var$_position = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_quaternion = /*@__PURE__*/ new $0147bee01cff6558$export$23d6a54f0bbc85a3();
const $0147bee01cff6558$var$_scale = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_orientation = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$4b3e397ef1832507 extends $0147bee01cff6558$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($0147bee01cff6558$var$_position, $0147bee01cff6558$var$_quaternion, $0147bee01cff6558$var$_scale);
        $0147bee01cff6558$var$_orientation.set(0, 0, 1).applyQuaternion($0147bee01cff6558$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($0147bee01cff6558$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($0147bee01cff6558$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($0147bee01cff6558$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($0147bee01cff6558$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($0147bee01cff6558$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($0147bee01cff6558$var$_orientation.z, endTime);
        } else {
            panner.setPosition($0147bee01cff6558$var$_position.x, $0147bee01cff6558$var$_position.y, $0147bee01cff6558$var$_position.z);
            panner.setOrientation($0147bee01cff6558$var$_orientation.x, $0147bee01cff6558$var$_orientation.y, $0147bee01cff6558$var$_orientation.z);
        }
    }
}
class $0147bee01cff6558$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $0147bee01cff6558$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $0147bee01cff6558$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $0147bee01cff6558$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $0147bee01cff6558$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $0147bee01cff6558$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $0147bee01cff6558$var$_reservedRe = new RegExp("[" + $0147bee01cff6558$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $0147bee01cff6558$var$_wordChar = "[^" + $0147bee01cff6558$var$_RESERVED_CHARS_RE + "]";
const $0147bee01cff6558$var$_wordCharOrDot = "[^" + $0147bee01cff6558$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $0147bee01cff6558$var$_directoryRe = /((?:WC+[\/:])*)/.source.replace("WC", $0147bee01cff6558$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $0147bee01cff6558$var$_nodeRe = /(WCOD+)?/.source.replace("WCOD", $0147bee01cff6558$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $0147bee01cff6558$var$_objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $0147bee01cff6558$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $0147bee01cff6558$var$_propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $0147bee01cff6558$var$_wordChar);
const $0147bee01cff6558$var$_trackRe = new RegExp("^" + $0147bee01cff6558$var$_directoryRe + $0147bee01cff6558$var$_nodeRe + $0147bee01cff6558$var$_objectRe + $0147bee01cff6558$var$_propertyRe + "$");
const $0147bee01cff6558$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones"
];
class $0147bee01cff6558$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $0147bee01cff6558$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $0147bee01cff6558$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $0147bee01cff6558$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $0147bee01cff6558$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $0147bee01cff6558$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $0147bee01cff6558$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($0147bee01cff6558$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $0147bee01cff6558$var$_trackRe.exec(trackName);
        if (!matches) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($0147bee01cff6558$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (!nodeName || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $0147bee01cff6558$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (targetObject.geometry.isBufferGeometry) {
                    if (!targetObject.geometry.morphAttributes) {
                        console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        return;
                    }
                    if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                } else {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
                    return;
                }
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$0147bee01cff6558$export$7bf70fcf9f891893.Composite = $0147bee01cff6558$var$Composite;
$0147bee01cff6558$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$0147bee01cff6558$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$0147bee01cff6558$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $0147bee01cff6558$export$7bf70fcf9f891893.prototype._getValue_direct,
    $0147bee01cff6558$export$7bf70fcf9f891893.prototype._getValue_array,
    $0147bee01cff6558$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $0147bee01cff6558$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$0147bee01cff6558$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_direct,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_array,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $0147bee01cff6558$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $0147bee01cff6558$export$30619c2afd3f34db {
    constructor(){
        this.uuid = $0147bee01cff6558$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $0147bee01cff6558$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $0147bee01cff6558$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $0147bee01cff6558$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
$0147bee01cff6558$export$30619c2afd3f34db.prototype.isAnimationObjectGroup = true;
class $0147bee01cff6558$var$AnimationAction {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $0147bee01cff6558$export$7f795934b84ab523,
            endingEnd: $0147bee01cff6558$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $0147bee01cff6558$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
            // start
            this._startTime = null; // unschedule
            deltaTime = timeDirection * timeRunning;
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $0147bee01cff6558$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $0147bee01cff6558$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $0147bee01cff6558$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $0147bee01cff6558$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $0147bee01cff6558$export$24a4ccb5099273b5;
            settings.endingEnd = $0147bee01cff6558$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $0147bee01cff6558$export$24a4ccb5099273b5 : $0147bee01cff6558$export$7f795934b84ab523;
            else settings.endingStart = $0147bee01cff6558$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $0147bee01cff6558$export$24a4ccb5099273b5 : $0147bee01cff6558$export$7f795934b84ab523;
            else settings.endingEnd = $0147bee01cff6558$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
class $0147bee01cff6558$export$fbd77e5aefaa0102 extends $0147bee01cff6558$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $0147bee01cff6558$export$dfe0af1ca1acb78a($0147bee01cff6558$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $0147bee01cff6558$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $0147bee01cff6558$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $0147bee01cff6558$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $0147bee01cff6558$var$AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $0147bee01cff6558$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
$0147bee01cff6558$export$fbd77e5aefaa0102.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
class $0147bee01cff6558$export$2947cebfe91c02f8 {
    constructor(value){
        if (typeof value === "string") {
            console.warn("THREE.Uniform: Type parameter is no longer needed.");
            value = arguments[1];
        }
        this.value = value;
    }
    clone() {
        return new $0147bee01cff6558$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
class $0147bee01cff6558$export$25ec0e1af1389358 extends $0147bee01cff6558$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
$0147bee01cff6558$export$25ec0e1af1389358.prototype.isInstancedInterleavedBuffer = true;
class $0147bee01cff6558$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
$0147bee01cff6558$export$6b7339ae8dbddf73.prototype.isGLBufferAttribute = true;
class $0147bee01cff6558$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $0147bee01cff6558$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $0147bee01cff6558$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera && camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera && camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $0147bee01cff6558$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($0147bee01cff6558$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$0147bee01cff6558$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($0147bee01cff6558$var$ascSort);
        return intersects;
    }
}
function $0147bee01cff6558$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $0147bee01cff6558$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$0147bee01cff6558$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $0147bee01cff6558$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be betwee EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($0147bee01cff6558$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $0147bee01cff6558$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0147bee01cff6558$var$_vector$4 = /*@__PURE__*/ new $0147bee01cff6558$export$c977b3e384af9ae1();
class $0147bee01cff6558$export$60f553fa130f08b0 {
    constructor(min = new $0147bee01cff6558$export$c977b3e384af9ae1(Infinity, Infinity), max = new $0147bee01cff6558$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $0147bee01cff6558$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $0147bee01cff6558$var$_vector$4.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
$0147bee01cff6558$export$60f553fa130f08b0.prototype.isBox2 = true;
const $0147bee01cff6558$var$_startP = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_startEnd = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$e0ba6359f1954fd3 {
    constructor(start = new $0147bee01cff6558$export$64b5c384219d3699(), end = new $0147bee01cff6558$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $0147bee01cff6558$var$_startP.subVectors(point, this.start);
        $0147bee01cff6558$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $0147bee01cff6558$var$_startEnd.dot($0147bee01cff6558$var$_startEnd);
        const startEnd_startP = $0147bee01cff6558$var$_startEnd.dot($0147bee01cff6558$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $0147bee01cff6558$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0147bee01cff6558$var$_vector$3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$4b14638ffdd81e68 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(positions, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $0147bee01cff6558$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $0147bee01cff6558$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($0147bee01cff6558$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $0147bee01cff6558$var$_vector$2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_boneMatrix = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
const $0147bee01cff6558$var$_matrixWorldInv = /*@__PURE__*/ new $0147bee01cff6558$export$2ae72fc923e5eb5();
class $0147bee01cff6558$export$5277df3c9e732259 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $0147bee01cff6558$var$getBoneList(object);
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $0147bee01cff6558$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $0147bee01cff6558$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.type = "SkeletonHelper";
        this.isSkeletonHelper = true;
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $0147bee01cff6558$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $0147bee01cff6558$var$_boneMatrix.multiplyMatrices($0147bee01cff6558$var$_matrixWorldInv, bone.matrixWorld);
                $0147bee01cff6558$var$_vector$2.setFromMatrixPosition($0147bee01cff6558$var$_boneMatrix);
                position.setXYZ(j, $0147bee01cff6558$var$_vector$2.x, $0147bee01cff6558$var$_vector$2.y, $0147bee01cff6558$var$_vector$2.z);
                $0147bee01cff6558$var$_boneMatrix.multiplyMatrices($0147bee01cff6558$var$_matrixWorldInv, bone.parent.matrixWorld);
                $0147bee01cff6558$var$_vector$2.setFromMatrixPosition($0147bee01cff6558$var$_boneMatrix);
                position.setXYZ(j + 1, $0147bee01cff6558$var$_vector$2.x, $0147bee01cff6558$var$_vector$2.y, $0147bee01cff6558$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
}
function $0147bee01cff6558$var$getBoneList(object) {
    const boneList = [];
    if (object && object.isBone) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $0147bee01cff6558$var$getBoneList(object.children[i]));
    return boneList;
}
class $0147bee01cff6558$export$9a9291685b9e4023 extends $0147bee01cff6558$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $0147bee01cff6558$export$d5d06a966fec4192(sphereSize, 4, 2);
        const material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronBufferGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $0147bee01cff6558$var$_vector$1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_color1 = /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e();
const $0147bee01cff6558$var$_color2 = /*@__PURE__*/ new $0147bee01cff6558$export$892596cec99bc70e();
class $0147bee01cff6558$export$8dca15f13f4f8172 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $0147bee01cff6558$export$8e05fc91596f4752(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $0147bee01cff6558$export$8dea267bd6bde117(colors, 3));
        this.add(new $0147bee01cff6558$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $0147bee01cff6558$var$_color1.copy(this.light.color);
            $0147bee01cff6558$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $0147bee01cff6558$var$_color1 : $0147bee01cff6558$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt($0147bee01cff6558$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $0147bee01cff6558$export$3875d39926561055 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $0147bee01cff6558$export$892596cec99bc70e(color1);
        color2 = new $0147bee01cff6558$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
}
class $0147bee01cff6558$export$361430a10f533cd3 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $0147bee01cff6558$export$892596cec99bc70e(color1);
        color2 = new $0147bee01cff6558$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the radials
        for(let i = 0; i <= radials; i++){
            const v = i / radials * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(let i = 0; i <= circles; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / circles * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
}
const $0147bee01cff6558$var$_v1 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v2 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_v3 = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
class $0147bee01cff6558$export$f8e434dc14203e7d extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $0147bee01cff6558$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $0147bee01cff6558$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        $0147bee01cff6558$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $0147bee01cff6558$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $0147bee01cff6558$var$_v3.subVectors($0147bee01cff6558$var$_v2, $0147bee01cff6558$var$_v1);
        this.lightPlane.lookAt($0147bee01cff6558$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($0147bee01cff6558$var$_v2);
        this.targetLine.scale.z = $0147bee01cff6558$var$_v3.length();
    }
}
const $0147bee01cff6558$var$_vector = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
const $0147bee01cff6558$var$_camera = /*@__PURE__*/ new $0147bee01cff6558$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $0147bee01cff6558$export$ed8e93f853cd795 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // colors
        const colorFrustum = new $0147bee01cff6558$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $0147bee01cff6558$export$892596cec99bc70e(0xff0000);
        const colorUp = new $0147bee01cff6558$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $0147bee01cff6558$export$892596cec99bc70e(0xffffff);
        const colorCross = new $0147bee01cff6558$export$892596cec99bc70e(0x333333);
        // near
        addLine("n1", "n2", colorFrustum);
        addLine("n2", "n4", colorFrustum);
        addLine("n4", "n3", colorFrustum);
        addLine("n3", "n1", colorFrustum);
        // far
        addLine("f1", "f2", colorFrustum);
        addLine("f2", "f4", colorFrustum);
        addLine("f4", "f3", colorFrustum);
        addLine("f3", "f1", colorFrustum);
        // sides
        addLine("n1", "f1", colorFrustum);
        addLine("n2", "f2", colorFrustum);
        addLine("n3", "f3", colorFrustum);
        addLine("n4", "f4", colorFrustum);
        // cone
        addLine("p", "n1", colorCone);
        addLine("p", "n2", colorCone);
        addLine("p", "n3", colorCone);
        addLine("p", "n4", colorCone);
        // up
        addLine("u1", "u2", colorUp);
        addLine("u2", "u3", colorUp);
        addLine("u3", "u1", colorUp);
        // target
        addLine("c", "t", colorTarget);
        addLine("p", "c", colorCross);
        // cross
        addLine("cn1", "cn2", colorCross);
        addLine("cn3", "cn4", colorCross);
        addLine("cf1", "cf2", colorCross);
        addLine("cf3", "cf4", colorCross);
        function addLine(a, b, color) {
            addPoint(a, color);
            addPoint(b, color);
        }
        function addPoint(id, color) {
            vertices.push(0, 0, 0);
            colors.push(color.r, color.g, color.b);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $0147bee01cff6558$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $0147bee01cff6558$var$setPoint("c", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, 0, -1);
        $0147bee01cff6558$var$setPoint("t", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, 0, 1);
        // near
        $0147bee01cff6558$var$setPoint("n1", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, -h, -1);
        $0147bee01cff6558$var$setPoint("n2", pointMap, geometry, $0147bee01cff6558$var$_camera, w, -h, -1);
        $0147bee01cff6558$var$setPoint("n3", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, h, -1);
        $0147bee01cff6558$var$setPoint("n4", pointMap, geometry, $0147bee01cff6558$var$_camera, w, h, -1);
        // far
        $0147bee01cff6558$var$setPoint("f1", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, -h, 1);
        $0147bee01cff6558$var$setPoint("f2", pointMap, geometry, $0147bee01cff6558$var$_camera, w, -h, 1);
        $0147bee01cff6558$var$setPoint("f3", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, h, 1);
        $0147bee01cff6558$var$setPoint("f4", pointMap, geometry, $0147bee01cff6558$var$_camera, w, h, 1);
        // up
        $0147bee01cff6558$var$setPoint("u1", pointMap, geometry, $0147bee01cff6558$var$_camera, w * 0.7, h * 1.1, -1);
        $0147bee01cff6558$var$setPoint("u2", pointMap, geometry, $0147bee01cff6558$var$_camera, -w * 0.7, h * 1.1, -1);
        $0147bee01cff6558$var$setPoint("u3", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, h * 2, -1);
        // cross
        $0147bee01cff6558$var$setPoint("cf1", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, 0, 1);
        $0147bee01cff6558$var$setPoint("cf2", pointMap, geometry, $0147bee01cff6558$var$_camera, w, 0, 1);
        $0147bee01cff6558$var$setPoint("cf3", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, -h, 1);
        $0147bee01cff6558$var$setPoint("cf4", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, h, 1);
        $0147bee01cff6558$var$setPoint("cn1", pointMap, geometry, $0147bee01cff6558$var$_camera, -w, 0, -1);
        $0147bee01cff6558$var$setPoint("cn2", pointMap, geometry, $0147bee01cff6558$var$_camera, w, 0, -1);
        $0147bee01cff6558$var$setPoint("cn3", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, -h, -1);
        $0147bee01cff6558$var$setPoint("cn4", pointMap, geometry, $0147bee01cff6558$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $0147bee01cff6558$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $0147bee01cff6558$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $0147bee01cff6558$var$_vector.x, $0147bee01cff6558$var$_vector.y, $0147bee01cff6558$var$_vector.z);
    }
}
const $0147bee01cff6558$var$_box = /*@__PURE__*/ new $0147bee01cff6558$export$6f7d5a9418ab2aa3();
class $0147bee01cff6558$export$38a664cc862a6a9d extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setIndex(new $0147bee01cff6558$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $0147bee01cff6558$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $0147bee01cff6558$var$_box.setFromObject(this.object);
        if ($0147bee01cff6558$var$_box.isEmpty()) return;
        const min = $0147bee01cff6558$var$_box.min;
        const max = $0147bee01cff6558$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source) {
        $0147bee01cff6558$export$ff1ed10fedfdd604.prototype.copy.call(this, source);
        this.object = source.object;
        return this;
    }
}
class $0147bee01cff6558$export$ce39f4bb96c9a290 extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setIndex(new $0147bee01cff6558$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
}
class $0147bee01cff6558$export$a34fe8156c66e5d7 extends $0147bee01cff6558$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0
        ];
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1
        ];
        const geometry2 = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $0147bee01cff6558$export$e176487c05830cc5(geometry2, new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        let scale = -this.plane.constant;
        if (Math.abs(scale) < 1e-8) scale = 1e-8; // sign does not matter
        this.scale.set(0.5 * this.size, 0.5 * this.size, scale);
        this.children[0].material.side = scale < 0 ? $0147bee01cff6558$export$d9f0486e75b5ace : $0147bee01cff6558$export$2ede184fc2998901; // renderer flips side when determinant < 0; flipping not wanted here
        this.lookAt(this.plane.normal);
        super.updateMatrixWorld(force);
    }
}
const $0147bee01cff6558$var$_axis = /*@__PURE__*/ new $0147bee01cff6558$export$64b5c384219d3699();
let $0147bee01cff6558$var$_lineGeometry, $0147bee01cff6558$var$_coneGeometry;
class $0147bee01cff6558$export$a3008e7bd8d2cbe7 extends $0147bee01cff6558$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 1), origin = new $0147bee01cff6558$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($0147bee01cff6558$var$_lineGeometry === undefined) {
            $0147bee01cff6558$var$_lineGeometry = new $0147bee01cff6558$export$b7be63a67df8959();
            $0147bee01cff6558$var$_lineGeometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $0147bee01cff6558$var$_coneGeometry = new $0147bee01cff6558$export$d4345c83207d7c68(0, 0.5, 1, 5, 1);
            $0147bee01cff6558$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $0147bee01cff6558$export$17d680238e50603e($0147bee01cff6558$var$_lineGeometry, new $0147bee01cff6558$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $0147bee01cff6558$export$e176487c05830cc5($0147bee01cff6558$var$_coneGeometry, new $0147bee01cff6558$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $0147bee01cff6558$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($0147bee01cff6558$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
}
class $0147bee01cff6558$export$6c8303f35b8578fd extends $0147bee01cff6558$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $0147bee01cff6558$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0147bee01cff6558$export$cbe7a62641830ebd(colors, 3));
        const material = new $0147bee01cff6558$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $0147bee01cff6558$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0147bee01cff6558$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $0147bee01cff6558$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $0147bee01cff6558$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW, noHoles) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $0147bee01cff6558$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $0147bee01cff6558$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        if (noHoles === true) return toShapesNoHoles(subPaths);
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $0147bee01cff6558$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $0147bee01cff6558$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            const toChange = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange.push({
                            froms: sIdx,
                            tos: s2Idx,
                            hole: hIdx
                        });
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            // console.log("ambiguous: ", ambiguous);
            if (toChange.length > 0) // console.log("to change: ", toChange);
            {
                if (!ambiguous) newShapeHoles = betterShapeHoles;
            }
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
const $0147bee01cff6558$var$_floatView = new Float32Array(1);
const $0147bee01cff6558$var$_int32View = new Int32Array($0147bee01cff6558$var$_floatView.buffer);
class $0147bee01cff6558$export$11ce8b759162cc80 {
    // Converts float32 to float16 (stored as uint16 value).
    static toHalfFloat(val) {
        if (val > 65504) {
            console.warn("THREE.DataUtils.toHalfFloat(): value exceeds 65504.");
            val = 65504; // maximum representable value in float16
        }
        // Source: http://gamedev.stackexchange.com/questions/17326/conversion-of-a-number-from-single-precision-floating-point-representation-to-a/17410#17410
        /* This method is faster than the OpenEXR implementation (very often
		* used, eg. in Ogre), with the additional benefit of rounding, inspired
		* by James Tursa?s half-precision code. */ $0147bee01cff6558$var$_floatView[0] = val;
        const x = $0147bee01cff6558$var$_int32View[0];
        let bits = x >> 16 & 0x8000; /* Get the sign */ 
        let m = x >> 12 & 0x07ff; /* Keep one extra bit for rounding */ 
        const e = x >> 23 & 0xff; /* Using int is faster here */ 
        /* If zero, or denormal, or exponent underflows too much for a denormal
			* half, return signed zero. */ if (e < 103) return bits;
        /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */ if (e > 142) {
            bits |= 0x7c00;
            /* If exponent was 0xff and one mantissa bit was set, it means NaN,
						* not Inf, so make sure we set one mantissa bit too. */ bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
            return bits;
        }
        /* If exponent underflows but not too much, return a denormal */ if (e < 113) {
            m |= 0x0800;
            /* Extra rounding may overflow and set mantissa to 0 and exponent
				* to 1, which is OK. */ bits |= (m >> 114 - e) + (m >> 113 - e & 1);
            return bits;
        }
        bits |= e - 112 << 10 | m >> 1;
        /* Extra rounding. An overflow will set mantissa to 0 and increment
			* the exponent, which is OK. */ bits += m & 1;
        return bits;
    }
}
const $0147bee01cff6558$export$195910b613d3dbcb = 0;
const $0147bee01cff6558$export$c8a71586e494fb81 = 1;
const $0147bee01cff6558$export$1a5c46edbdc9a5b7 = 0;
const $0147bee01cff6558$export$617e978cc3201d85 = 1;
const $0147bee01cff6558$export$969ede3d37172881 = 2;
function $0147bee01cff6558$export$8f0d8c869214e38a(materials) {
    console.warn("THREE.MeshFaceMaterial has been removed. Use an Array instead.");
    return materials;
}
function $0147bee01cff6558$export$4f1842f7cdf61f78(materials = []) {
    console.warn("THREE.MultiMaterial has been removed. Use an Array instead.");
    materials.isMultiMaterial = true;
    materials.materials = materials;
    materials.clone = function() {
        return materials.slice();
    };
    return materials;
}
function $0147bee01cff6558$export$5c812f854e08d33d(geometry, material) {
    console.warn("THREE.PointCloud has been renamed to THREE.Points.");
    return new $0147bee01cff6558$export$1c787534cb11aa3e(geometry, material);
}
function $0147bee01cff6558$export$c36c68baa13912a5(material) {
    console.warn("THREE.Particle has been renamed to THREE.Sprite.");
    return new $0147bee01cff6558$export$3075603db8e6204c(material);
}
function $0147bee01cff6558$export$f219b6a0e4bb0b6d(geometry, material) {
    console.warn("THREE.ParticleSystem has been renamed to THREE.Points.");
    return new $0147bee01cff6558$export$1c787534cb11aa3e(geometry, material);
}
function $0147bee01cff6558$export$29121d9ccd2f757a(parameters) {
    console.warn("THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.");
    return new $0147bee01cff6558$export$a178c45366ce5d6b(parameters);
}
function $0147bee01cff6558$export$ffa02580217a1c8(parameters) {
    console.warn("THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.");
    return new $0147bee01cff6558$export$a178c45366ce5d6b(parameters);
}
function $0147bee01cff6558$export$cb1306c614c86e6b(parameters) {
    console.warn("THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.");
    return new $0147bee01cff6558$export$a178c45366ce5d6b(parameters);
}
function $0147bee01cff6558$export$3e8a3cc8713efbec(x, y, z) {
    console.warn("THREE.Vertex has been removed. Use THREE.Vector3 instead.");
    return new $0147bee01cff6558$export$64b5c384219d3699(x, y, z);
}
//
function $0147bee01cff6558$export$189ab5ea9d161e81(array, itemSize) {
    console.warn("THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead.");
    return new $0147bee01cff6558$export$8dea267bd6bde117(array, itemSize).setUsage($0147bee01cff6558$export$8505d14ac8546ca);
}
function $0147bee01cff6558$export$e0ae4f0a1804ea11(array, itemSize) {
    console.warn("THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.");
    return new $0147bee01cff6558$export$f9ff2d6a20248cbf(array, itemSize);
}
function $0147bee01cff6558$export$a0d192e03a5b32f5(array, itemSize) {
    console.warn("THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.");
    return new $0147bee01cff6558$export$cacc90cf35d11cdd(array, itemSize);
}
function $0147bee01cff6558$export$8ca743ab36552bfa(array, itemSize) {
    console.warn("THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.");
    return new $0147bee01cff6558$export$baaa85a1a812c157(array, itemSize);
}
function $0147bee01cff6558$export$5d9757676aad9dab(array, itemSize) {
    console.warn("THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.");
    return new $0147bee01cff6558$export$2b755a102ccdcefe(array, itemSize);
}
function $0147bee01cff6558$export$ed102ffd14092320(array, itemSize) {
    console.warn("THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.");
    return new $0147bee01cff6558$export$640a853f68025f2e(array, itemSize);
}
function $0147bee01cff6558$export$6acc479034658f15(array, itemSize) {
    console.warn("THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.");
    return new $0147bee01cff6558$export$46b369aed2968a0a(array, itemSize);
}
function $0147bee01cff6558$export$53474877d6e539b9(array, itemSize) {
    console.warn("THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.");
    return new $0147bee01cff6558$export$7eb8c9fa25cd5bd6(array, itemSize);
}
function $0147bee01cff6558$export$377af6eadc8006c3(array, itemSize) {
    console.warn("THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.");
    return new $0147bee01cff6558$export$cbe7a62641830ebd(array, itemSize);
}
function $0147bee01cff6558$export$b9212d1a67b6f081(array, itemSize) {
    console.warn("THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.");
    return new $0147bee01cff6558$export$9e0ade74842adbb8(array, itemSize);
}
//
$0147bee01cff6558$export$b0e83c3ef8d2db1.create = function(construct, getPoint) {
    console.log("THREE.Curve.create() has been deprecated");
    construct.prototype = Object.create($0147bee01cff6558$export$b0e83c3ef8d2db1.prototype);
    construct.prototype.constructor = construct;
    construct.prototype.getPoint = getPoint;
    return construct;
};
//
$0147bee01cff6558$export$4b2950bdac9b6ee9.prototype.fromPoints = function(points) {
    console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints().");
    return this.setFromPoints(points);
};
//
function $0147bee01cff6558$export$46c1eaab6b8d1e23(size) {
    console.warn("THREE.AxisHelper has been renamed to THREE.AxesHelper.");
    return new $0147bee01cff6558$export$6c8303f35b8578fd(size);
}
function $0147bee01cff6558$export$3c24c67720a2146c(object, color) {
    console.warn("THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.");
    return new $0147bee01cff6558$export$38a664cc862a6a9d(object, color);
}
function $0147bee01cff6558$export$e341a90264c62d4c(object, hex) {
    console.warn("THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.");
    return new $0147bee01cff6558$export$ff1ed10fedfdd604(new $0147bee01cff6558$export$4730b1542707547f(object.geometry), new $0147bee01cff6558$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
$0147bee01cff6558$export$3875d39926561055.prototype.setColors = function() {
    console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
};
$0147bee01cff6558$export$5277df3c9e732259.prototype.update = function() {
    console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
};
function $0147bee01cff6558$export$72d033539c529f13(object, hex) {
    console.warn("THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.");
    return new $0147bee01cff6558$export$ff1ed10fedfdd604(new $0147bee01cff6558$export$4b739da06d24892b(object.geometry), new $0147bee01cff6558$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
//
$0147bee01cff6558$export$3b0d6d7590275603.prototype.extractUrlBase = function(url) {
    console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.");
    return $0147bee01cff6558$export$b5d2dc08d867e41a.extractUrlBase(url);
};
$0147bee01cff6558$export$3b0d6d7590275603.Handlers = {
    add: function() {
        console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
    },
    get: function() {
        console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
    }
};
function $0147bee01cff6558$export$c8b77178c5db4e0d(manager) {
    console.warn("THREE.XHRLoader has been renamed to THREE.FileLoader.");
    return new $0147bee01cff6558$export$98435a25b5cf7b2b(manager);
}
function $0147bee01cff6558$export$58c7c1107fc658f9(manager) {
    console.warn("THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.");
    return new $0147bee01cff6558$export$792d8a18f2c55855(manager);
}
//
$0147bee01cff6558$export$60f553fa130f08b0.prototype.center = function(optionalTarget) {
    console.warn("THREE.Box2: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
$0147bee01cff6558$export$60f553fa130f08b0.prototype.empty = function() {
    console.warn("THREE.Box2: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
$0147bee01cff6558$export$60f553fa130f08b0.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$0147bee01cff6558$export$60f553fa130f08b0.prototype.size = function(optionalTarget) {
    console.warn("THREE.Box2: .size() has been renamed to .getSize().");
    return this.getSize(optionalTarget);
};
//
$0147bee01cff6558$export$6f7d5a9418ab2aa3.prototype.center = function(optionalTarget) {
    console.warn("THREE.Box3: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
$0147bee01cff6558$export$6f7d5a9418ab2aa3.prototype.empty = function() {
    console.warn("THREE.Box3: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
$0147bee01cff6558$export$6f7d5a9418ab2aa3.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$0147bee01cff6558$export$6f7d5a9418ab2aa3.prototype.isIntersectionSphere = function(sphere) {
    console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().");
    return this.intersectsSphere(sphere);
};
$0147bee01cff6558$export$6f7d5a9418ab2aa3.prototype.size = function(optionalTarget) {
    console.warn("THREE.Box3: .size() has been renamed to .getSize().");
    return this.getSize(optionalTarget);
};
//
$0147bee01cff6558$export$805e8b72413ccaba.prototype.empty = function() {
    console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
//
$0147bee01cff6558$export$35efe6f4c85463d2.prototype.setFromMatrix = function(m) {
    console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().");
    return this.setFromProjectionMatrix(m);
};
//
$0147bee01cff6558$export$e0ba6359f1954fd3.prototype.center = function(optionalTarget) {
    console.warn("THREE.Line3: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
//
$0147bee01cff6558$export$8ff26dafa08918.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
    return this.toArray(array, offset);
};
$0147bee01cff6558$export$8ff26dafa08918.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.");
    return vector.applyMatrix3(this);
};
$0147bee01cff6558$export$8ff26dafa08918.prototype.multiplyVector3Array = function() {
    console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
};
$0147bee01cff6558$export$8ff26dafa08918.prototype.applyToBufferAttribute = function(attribute) {
    console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.");
    return attribute.applyMatrix3(this);
};
$0147bee01cff6558$export$8ff26dafa08918.prototype.applyToVector3Array = function() {
    console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
};
$0147bee01cff6558$export$8ff26dafa08918.prototype.getInverse = function(matrix) {
    console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
    return this.copy(matrix).invert();
};
//
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.extractPosition = function(m) {
    console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().");
    return this.copyPosition(m);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
    return this.toArray(array, offset);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.getPosition = function() {
    console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.");
    return new $0147bee01cff6558$export$64b5c384219d3699().setFromMatrixColumn(this, 3);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.setRotationFromQuaternion = function(q) {
    console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().");
    return this.makeRotationFromQuaternion(q);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.multiplyToArray = function() {
    console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.multiplyVector4 = function(vector) {
    console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.multiplyVector3Array = function() {
    console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.rotateAxis = function(v) {
    console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.");
    v.transformDirection(this);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.crossVector = function(vector) {
    console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.translate = function() {
    console.error("THREE.Matrix4: .translate() has been removed.");
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.rotateX = function() {
    console.error("THREE.Matrix4: .rotateX() has been removed.");
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.rotateY = function() {
    console.error("THREE.Matrix4: .rotateY() has been removed.");
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.rotateZ = function() {
    console.error("THREE.Matrix4: .rotateZ() has been removed.");
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.rotateByAxis = function() {
    console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.applyToBufferAttribute = function(attribute) {
    console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.");
    return attribute.applyMatrix4(this);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.applyToVector3Array = function() {
    console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.makeFrustum = function(left, right, bottom, top, near, far) {
    console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.");
    return this.makePerspective(left, right, top, bottom, near, far);
};
$0147bee01cff6558$export$2ae72fc923e5eb5.prototype.getInverse = function(matrix) {
    console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
    return this.copy(matrix).invert();
};
//
$0147bee01cff6558$export$7ff5ac152ef991b0.prototype.isIntersectionLine = function(line) {
    console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().");
    return this.intersectsLine(line);
};
//
$0147bee01cff6558$export$23d6a54f0bbc85a3.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.");
    return vector.applyQuaternion(this);
};
$0147bee01cff6558$export$23d6a54f0bbc85a3.prototype.inverse = function() {
    console.warn("THREE.Quaternion: .inverse() has been renamed to invert().");
    return this.invert();
};
//
$0147bee01cff6558$export$a186db52eed6d40e.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$0147bee01cff6558$export$a186db52eed6d40e.prototype.isIntersectionPlane = function(plane) {
    console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().");
    return this.intersectsPlane(plane);
};
$0147bee01cff6558$export$a186db52eed6d40e.prototype.isIntersectionSphere = function(sphere) {
    console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().");
    return this.intersectsSphere(sphere);
};
//
$0147bee01cff6558$export$5a465592bfe74b48.prototype.area = function() {
    console.warn("THREE.Triangle: .area() has been renamed to .getArea().");
    return this.getArea();
};
$0147bee01cff6558$export$5a465592bfe74b48.prototype.barycoordFromPoint = function(point, target) {
    console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
    return this.getBarycoord(point, target);
};
$0147bee01cff6558$export$5a465592bfe74b48.prototype.midpoint = function(target) {
    console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint().");
    return this.getMidpoint(target);
};
$0147bee01cff6558$export$5a465592bfe74b48.prototypenormal = function(target) {
    console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
    return this.getNormal(target);
};
$0147bee01cff6558$export$5a465592bfe74b48.prototype.plane = function(target) {
    console.warn("THREE.Triangle: .plane() has been renamed to .getPlane().");
    return this.getPlane(target);
};
$0147bee01cff6558$export$5a465592bfe74b48.barycoordFromPoint = function(point, a, b, c, target) {
    console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
    return $0147bee01cff6558$export$5a465592bfe74b48.getBarycoord(point, a, b, c, target);
};
$0147bee01cff6558$export$5a465592bfe74b48.normal = function(a, b, c, target) {
    console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
    return $0147bee01cff6558$export$5a465592bfe74b48.getNormal(a, b, c, target);
};
//
$0147bee01cff6558$export$6428a7f2611ef1fa.prototype.extractAllPoints = function(divisions) {
    console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.");
    return this.extractPoints(divisions);
};
$0147bee01cff6558$export$6428a7f2611ef1fa.prototype.extrude = function(options) {
    console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.");
    return new $0147bee01cff6558$export$91836d01b9f75a58(this, options);
};
$0147bee01cff6558$export$6428a7f2611ef1fa.prototype.makeGeometry = function(options) {
    console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.");
    return new $0147bee01cff6558$export$233afc324766bed8(this, options);
};
//
$0147bee01cff6558$export$c977b3e384af9ae1.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$0147bee01cff6558$export$c977b3e384af9ae1.prototype.distanceToManhattan = function(v) {
    console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
    return this.manhattanDistanceTo(v);
};
$0147bee01cff6558$export$c977b3e384af9ae1.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$0147bee01cff6558$export$64b5c384219d3699.prototype.setEulerFromRotationMatrix = function() {
    console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
};
$0147bee01cff6558$export$64b5c384219d3699.prototype.setEulerFromQuaternion = function() {
    console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
};
$0147bee01cff6558$export$64b5c384219d3699.prototype.getPositionFromMatrix = function(m) {
    console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().");
    return this.setFromMatrixPosition(m);
};
$0147bee01cff6558$export$64b5c384219d3699.prototype.getScaleFromMatrix = function(m) {
    console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().");
    return this.setFromMatrixScale(m);
};
$0147bee01cff6558$export$64b5c384219d3699.prototype.getColumnFromMatrix = function(index, matrix) {
    console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().");
    return this.setFromMatrixColumn(matrix, index);
};
$0147bee01cff6558$export$64b5c384219d3699.prototype.applyProjection = function(m) {
    console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.");
    return this.applyMatrix4(m);
};
$0147bee01cff6558$export$64b5c384219d3699.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$0147bee01cff6558$export$64b5c384219d3699.prototype.distanceToManhattan = function(v) {
    console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
    return this.manhattanDistanceTo(v);
};
$0147bee01cff6558$export$64b5c384219d3699.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$0147bee01cff6558$export$fa7daccca11cdbe3.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$0147bee01cff6558$export$fa7daccca11cdbe3.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$0147bee01cff6558$export$e4dd07dff30cc924.prototype.getChildByName = function(name) {
    console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().");
    return this.getObjectByName(name);
};
$0147bee01cff6558$export$e4dd07dff30cc924.prototype.renderDepth = function() {
    console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
};
$0147bee01cff6558$export$e4dd07dff30cc924.prototype.translate = function(distance, axis) {
    console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.");
    return this.translateOnAxis(axis, distance);
};
$0147bee01cff6558$export$e4dd07dff30cc924.prototype.getWorldRotation = function() {
    console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
};
$0147bee01cff6558$export$e4dd07dff30cc924.prototype.applyMatrix = function(matrix) {
    console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().");
    return this.applyMatrix4(matrix);
};
Object.defineProperties($0147bee01cff6558$export$e4dd07dff30cc924.prototype, {
    eulerOrder: {
        get: function() {
            console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
            return this.rotation.order;
        },
        set: function(value) {
            console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
            this.rotation.order = value;
        }
    },
    useQuaternion: {
        get: function() {
            console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        },
        set: function() {
            console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        }
    }
});
$0147bee01cff6558$export$e176487c05830cc5.prototype.setDrawMode = function() {
    console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
};
Object.defineProperties($0147bee01cff6558$export$e176487c05830cc5.prototype, {
    drawMode: {
        get: function() {
            console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.");
            return $0147bee01cff6558$export$4c28c87c2dc84758;
        },
        set: function() {
            console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
        }
    }
});
$0147bee01cff6558$export$b303577035157ecf.prototype.initBones = function() {
    console.error("THREE.SkinnedMesh: initBones() has been removed.");
};
//
$0147bee01cff6558$export$74e4ae24825f68d7.prototype.setLens = function(focalLength, filmGauge) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
    if (filmGauge !== undefined) this.filmGauge = filmGauge;
    this.setFocalLength(focalLength);
};
//
Object.defineProperties($0147bee01cff6558$export$6ecadb6ed240d696.prototype, {
    onlyShadow: {
        set: function() {
            console.warn("THREE.Light: .onlyShadow has been removed.");
        }
    },
    shadowCameraFov: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov.");
            this.shadow.camera.fov = value;
        }
    },
    shadowCameraLeft: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left.");
            this.shadow.camera.left = value;
        }
    },
    shadowCameraRight: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right.");
            this.shadow.camera.right = value;
        }
    },
    shadowCameraTop: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top.");
            this.shadow.camera.top = value;
        }
    },
    shadowCameraBottom: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.");
            this.shadow.camera.bottom = value;
        }
    },
    shadowCameraNear: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near.");
            this.shadow.camera.near = value;
        }
    },
    shadowCameraFar: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far.");
            this.shadow.camera.far = value;
        }
    },
    shadowCameraVisible: {
        set: function() {
            console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
        }
    },
    shadowBias: {
        set: function(value) {
            console.warn("THREE.Light: .shadowBias is now .shadow.bias.");
            this.shadow.bias = value;
        }
    },
    shadowDarkness: {
        set: function() {
            console.warn("THREE.Light: .shadowDarkness has been removed.");
        }
    },
    shadowMapWidth: {
        set: function(value) {
            console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.");
            this.shadow.mapSize.width = value;
        }
    },
    shadowMapHeight: {
        set: function(value) {
            console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.");
            this.shadow.mapSize.height = value;
        }
    }
});
//
Object.defineProperties($0147bee01cff6558$export$8dea267bd6bde117.prototype, {
    length: {
        get: function() {
            console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead.");
            return this.array.length;
        }
    },
    dynamic: {
        get: function() {
            console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
            return this.usage === $0147bee01cff6558$export$8505d14ac8546ca;
        },
        set: function() {
            console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
            this.setUsage($0147bee01cff6558$export$8505d14ac8546ca);
        }
    }
});
$0147bee01cff6558$export$8dea267bd6bde117.prototype.setDynamic = function(value) {
    console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.");
    this.setUsage(value === true ? $0147bee01cff6558$export$8505d14ac8546ca : $0147bee01cff6558$export$763e8360f4d7f77d);
    return this;
};
$0147bee01cff6558$export$8dea267bd6bde117.prototype.copyIndicesArray = function() {
    console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, $0147bee01cff6558$export$8dea267bd6bde117.prototype.setArray = function() {
    console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
//
$0147bee01cff6558$export$b7be63a67df8959.prototype.addIndex = function(index) {
    console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().");
    this.setIndex(index);
};
$0147bee01cff6558$export$b7be63a67df8959.prototype.addAttribute = function(name, attribute) {
    console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().");
    if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
        console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).");
        return this.setAttribute(name, new $0147bee01cff6558$export$8dea267bd6bde117(arguments[1], arguments[2]));
    }
    if (name === "index") {
        console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.");
        this.setIndex(attribute);
        return this;
    }
    return this.setAttribute(name, attribute);
};
$0147bee01cff6558$export$b7be63a67df8959.prototype.addDrawCall = function(start, count, indexOffset) {
    if (indexOffset !== undefined) console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.");
    console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup().");
    this.addGroup(start, count);
};
$0147bee01cff6558$export$b7be63a67df8959.prototype.clearDrawCalls = function() {
    console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().");
    this.clearGroups();
};
$0147bee01cff6558$export$b7be63a67df8959.prototype.computeOffsets = function() {
    console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
};
$0147bee01cff6558$export$b7be63a67df8959.prototype.removeAttribute = function(name) {
    console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().");
    return this.deleteAttribute(name);
};
$0147bee01cff6558$export$b7be63a67df8959.prototype.applyMatrix = function(matrix) {
    console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().");
    return this.applyMatrix4(matrix);
};
Object.defineProperties($0147bee01cff6558$export$b7be63a67df8959.prototype, {
    drawcalls: {
        get: function() {
            console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups.");
            return this.groups;
        }
    },
    offsets: {
        get: function() {
            console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups.");
            return this.groups;
        }
    }
});
$0147bee01cff6558$export$3d5cd879f108f53f.prototype.setDynamic = function(value) {
    console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.");
    this.setUsage(value === true ? $0147bee01cff6558$export$8505d14ac8546ca : $0147bee01cff6558$export$763e8360f4d7f77d);
    return this;
};
$0147bee01cff6558$export$3d5cd879f108f53f.prototype.setArray = function() {
    console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
//
$0147bee01cff6558$export$91836d01b9f75a58.prototype.getArrays = function() {
    console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
};
$0147bee01cff6558$export$91836d01b9f75a58.prototype.addShapeList = function() {
    console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
};
$0147bee01cff6558$export$91836d01b9f75a58.prototype.addShape = function() {
    console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
};
//
$0147bee01cff6558$export$38af1803e3442a7f.prototype.dispose = function() {
    console.error("THREE.Scene: .dispose() has been removed.");
};
//
$0147bee01cff6558$export$2947cebfe91c02f8.prototype.onUpdate = function() {
    console.warn("THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.");
    return this;
};
//
Object.defineProperties($0147bee01cff6558$export$a2d8b23205c25948.prototype, {
    wrapAround: {
        get: function() {
            console.warn("THREE.Material: .wrapAround has been removed.");
        },
        set: function() {
            console.warn("THREE.Material: .wrapAround has been removed.");
        }
    },
    overdraw: {
        get: function() {
            console.warn("THREE.Material: .overdraw has been removed.");
        },
        set: function() {
            console.warn("THREE.Material: .overdraw has been removed.");
        }
    },
    wrapRGB: {
        get: function() {
            console.warn("THREE.Material: .wrapRGB has been removed.");
            return new $0147bee01cff6558$export$892596cec99bc70e();
        }
    },
    shading: {
        get: function() {
            console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
        },
        set: function(value) {
            console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
            this.flatShading = value === $0147bee01cff6558$export$a62047d29c96d8ff;
        }
    },
    stencilMask: {
        get: function() {
            console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
            return this.stencilFuncMask;
        },
        set: function(value) {
            console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
            this.stencilFuncMask = value;
        }
    },
    vertexTangents: {
        get: function() {
            console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
        },
        set: function() {
            console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
        }
    }
});
Object.defineProperties($0147bee01cff6558$export$83c7d75d550a8b0d.prototype, {
    derivatives: {
        get: function() {
            console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
            return this.extensions.derivatives;
        },
        set: function(value) {
            console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
            this.extensions.derivatives = value;
        }
    }
});
//
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.clearTarget = function(renderTarget, color, depth, stencil) {
    console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.");
    this.setRenderTarget(renderTarget);
    this.clear(color, depth, stencil);
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.animate = function(callback) {
    console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop().");
    this.setAnimationLoop(callback);
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.getCurrentRenderTarget = function() {
    console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().");
    return this.getRenderTarget();
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.getMaxAnisotropy = function() {
    console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().");
    return this.capabilities.getMaxAnisotropy();
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.getPrecision = function() {
    console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.");
    return this.capabilities.precision;
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.resetGLState = function() {
    console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset().");
    return this.state.reset();
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.supportsFloatTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' ).");
    return this.extensions.get("OES_texture_float");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.supportsHalfFloatTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' ).");
    return this.extensions.get("OES_texture_half_float");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.supportsStandardDerivatives = function() {
    console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' ).");
    return this.extensions.get("OES_standard_derivatives");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.supportsCompressedTextureS3TC = function() {
    console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' ).");
    return this.extensions.get("WEBGL_compressed_texture_s3tc");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.supportsCompressedTexturePVRTC = function() {
    console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' ).");
    return this.extensions.get("WEBGL_compressed_texture_pvrtc");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.supportsBlendMinMax = function() {
    console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' ).");
    return this.extensions.get("EXT_blend_minmax");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.supportsVertexTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.");
    return this.capabilities.vertexTextures;
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.supportsInstancedArrays = function() {
    console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' ).");
    return this.extensions.get("ANGLE_instanced_arrays");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.enableScissorTest = function(boolean) {
    console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().");
    this.setScissorTest(boolean);
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.initMaterial = function() {
    console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.addPrePlugin = function() {
    console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.addPostPlugin = function() {
    console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.updateShadowMap = function() {
    console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.setFaceCulling = function() {
    console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.allocTextureUnit = function() {
    console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.setTexture = function() {
    console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.setTexture2D = function() {
    console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.setTextureCube = function() {
    console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
};
$0147bee01cff6558$export$f6cc00ef28d7cf97.prototype.getActiveMipMapLevel = function() {
    console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().");
    return this.getActiveMipmapLevel();
};
Object.defineProperties($0147bee01cff6558$export$f6cc00ef28d7cf97.prototype, {
    shadowMapEnabled: {
        get: function() {
            return this.shadowMap.enabled;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.");
            this.shadowMap.enabled = value;
        }
    },
    shadowMapType: {
        get: function() {
            return this.shadowMap.type;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.");
            this.shadowMap.type = value;
        }
    },
    shadowMapCullFace: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
        }
    },
    context: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.");
            return this.getContext();
        }
    },
    vr: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr");
            return this.xr;
        }
    },
    gammaInput: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
            return false;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
        }
    },
    gammaOutput: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
            return false;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
            this.outputEncoding = value === true ? $0147bee01cff6558$export$f32388edbb32674 : $0147bee01cff6558$export$7207336e4151a112;
        }
    },
    toneMappingWhitePoint: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
            return 1.0;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
        }
    },
    gammaFactor: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
            return 2;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
        }
    }
});
Object.defineProperties($0147bee01cff6558$var$WebGLShadowMap.prototype, {
    cullFace: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
        }
    },
    renderReverseSided: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
        }
    },
    renderSingleSided: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
        }
    }
});
function $0147bee01cff6558$export$689069929abfa262(width, height, options) {
    console.warn("THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options ).");
    return new $0147bee01cff6558$export$ac386671d651941e(width, options);
}
//
Object.defineProperties($0147bee01cff6558$export$3c052beb2e51e23f.prototype, {
    wrapS: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
            return this.texture.wrapS;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
            this.texture.wrapS = value;
        }
    },
    wrapT: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
            return this.texture.wrapT;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
            this.texture.wrapT = value;
        }
    },
    magFilter: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
            return this.texture.magFilter;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
            this.texture.magFilter = value;
        }
    },
    minFilter: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
            return this.texture.minFilter;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
            this.texture.minFilter = value;
        }
    },
    anisotropy: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
            return this.texture.anisotropy;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
            this.texture.anisotropy = value;
        }
    },
    offset: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
            return this.texture.offset;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
            this.texture.offset = value;
        }
    },
    repeat: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
            return this.texture.repeat;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
            this.texture.repeat = value;
        }
    },
    format: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
            return this.texture.format;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
            this.texture.format = value;
        }
    },
    type: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
            return this.texture.type;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
            this.texture.type = value;
        }
    },
    generateMipmaps: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
            return this.texture.generateMipmaps;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
            this.texture.generateMipmaps = value;
        }
    }
});
//
$0147bee01cff6558$export$153755f98d9861de.prototype.load = function(file) {
    console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
    const scope = this;
    const audioLoader = new $0147bee01cff6558$export$d8d5fccfbf47714e();
    audioLoader.load(file, function(buffer) {
        scope.setBuffer(buffer);
    });
    return this;
};
$0147bee01cff6558$export$d47da1ef3d382827.prototype.getData = function() {
    console.warn("THREE.AudioAnalyser: .getData() is now .getFrequencyData().");
    return this.getFrequencyData();
};
//
$0147bee01cff6558$export$d0cdd0bd804995de.prototype.updateCubeMap = function(renderer, scene) {
    console.warn("THREE.CubeCamera: .updateCubeMap() is now .update().");
    return this.update(renderer, scene);
};
$0147bee01cff6558$export$d0cdd0bd804995de.prototype.clear = function(renderer, color, depth, stencil) {
    console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear().");
    return this.renderTarget.clear(renderer, color, depth, stencil);
};
$0147bee01cff6558$export$698882cf06df44aa.crossOrigin = undefined;
$0147bee01cff6558$export$698882cf06df44aa.loadTexture = function(url, mapping, onLoad, onError) {
    console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
    const loader = new $0147bee01cff6558$export$fd1bfc71f64c538c();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(url, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$0147bee01cff6558$export$698882cf06df44aa.loadTextureCube = function(urls, mapping, onLoad, onError) {
    console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
    const loader = new $0147bee01cff6558$export$2ec114afc2cf6308();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(urls, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$0147bee01cff6558$export$698882cf06df44aa.loadCompressedTexture = function() {
    console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
};
$0147bee01cff6558$export$698882cf06df44aa.loadCompressedTextureCube = function() {
    console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
};
//
function $0147bee01cff6558$export$7adc20298958481a() {
    console.error("THREE.CanvasRenderer has been removed");
}
//
function $0147bee01cff6558$export$8e85bca5826c4696() {
    console.error("THREE.JSONLoader has been removed.");
}
//
const $0147bee01cff6558$export$a8351e0de8b3fd78 = {
    createMultiMaterialObject: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    },
    detach: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    },
    attach: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    }
};
//
function $0147bee01cff6558$export$3f909fba4d49fe3d() {
    console.error("THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js");
}
//
function $0147bee01cff6558$export$8f6f2b4b16d33f() {
    console.error("THREE.ParametricGeometry has been moved to /examples/jsm/geometries/ParametricGeometry.js");
    return new $0147bee01cff6558$export$b7be63a67df8959();
}
function $0147bee01cff6558$export$684b774b4473ba5f() {
    console.error("THREE.TextGeometry has been moved to /examples/jsm/geometries/TextGeometry.js");
    return new $0147bee01cff6558$export$b7be63a67df8959();
}
function $0147bee01cff6558$export$812303d6cad736b3() {
    console.error("THREE.FontLoader has been moved to /examples/jsm/loaders/FontLoader.js");
}
function $0147bee01cff6558$export$89abf52a030e56ee() {
    console.error("THREE.Font has been moved to /examples/jsm/loaders/FontLoader.js");
}
function $0147bee01cff6558$export$960665a8431ecff6() {
    console.error("THREE.ImmediateRenderObject has been removed.");
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $0147bee01cff6558$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $0147bee01cff6558$export$3545e07a80636437;
}


/**
 * SDK version.
 */ const $9ed317250c83dc74$export$a4ad2735b021c132 = "2.1.2";


var $61e0c0f83e511ee0$exports = {};

$parcel$export($61e0c0f83e511ee0$exports, "ImageTracker", function () { return $61e0c0f83e511ee0$export$333222788f3dd075; });
/**
 * A type-safe event handling class that multiple functions to be registered to be called when events are emitted.
 */ class $46abd614147db5d5$export$d61e24a684f9e51 {
    constructor(){
        this._funcs = [];
    }
    /**
     * Bind new handler function.
     * @param f - The callback function to be bound.
     */ bind(f) {
        this._funcs.push(f);
    }
    /**
     * Unbind an existing handler function.
     * @param f - The callback function to be unbound.
     */ unbind(f) {
        const indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    /**
     * Emit an event, calling the bound handler functions.
     */ emit() {
        for(let i = 0, total = this._funcs.length; i < total; i++)this._funcs[i]();
    }
}
class $46abd614147db5d5$export$3371bf92c01fb88b {
    constructor(){
        this._funcs = [];
    }
    /**
     * Bind new handler function.
     * @param f - The callback function to be bound.
    */ bind(f) {
        this._funcs.push(f);
    }
    /**
     * Unbind an existing function.
     * @param f - The callback function to be unbound.
     */ unbind(f) {
        const indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    /**
     * Emit an event.
     *
     * @param a - The argument to pass to handler functions.
     */ emit(a) {
        for(let i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a);
    }
}


var $d5527567a7407cf0$exports = {};

$parcel$export($d5527567a7407cf0$exports, "z", function () { return $d5527567a7407cf0$export$df995fae86a55f06; });
$parcel$export($d5527567a7407cf0$exports, "cameraDefaultDeviceID", function () { return $d5527567a7407cf0$export$5e22cf87be86f6fa; });
$parcel$export($d5527567a7407cf0$exports, "projectionMatrixFromCameraModel", function () { return $d5527567a7407cf0$export$790b3b94a8142dee; });
$parcel$export($d5527567a7407cf0$exports, "loadedPromise", function () { return $d5527567a7407cf0$export$6b6393bedfd195a0; });
var $0c05329758a5f3b0$exports = {};

$parcel$export($0c05329758a5f3b0$exports, "initialize", function () { return $0c05329758a5f3b0$export$2a47f398eeff8b01; });
var $cc08068a96912eec$export$53baafd5596ae7a8;
(function(barcode_format_t) {
    barcode_format_t[barcode_format_t["UNKNOWN"] = 131072] = "UNKNOWN";
    barcode_format_t[barcode_format_t["AZTEC"] = 1] = "AZTEC";
    barcode_format_t[barcode_format_t["CODABAR"] = 2] = "CODABAR";
    barcode_format_t[barcode_format_t["CODE_39"] = 4] = "CODE_39";
    barcode_format_t[barcode_format_t["CODE_93"] = 8] = "CODE_93";
    barcode_format_t[barcode_format_t["CODE_128"] = 16] = "CODE_128";
    barcode_format_t[barcode_format_t["DATA_MATRIX"] = 32] = "DATA_MATRIX";
    barcode_format_t[barcode_format_t["EAN_8"] = 64] = "EAN_8";
    barcode_format_t[barcode_format_t["EAN_13"] = 128] = "EAN_13";
    barcode_format_t[barcode_format_t["ITF"] = 256] = "ITF";
    barcode_format_t[barcode_format_t["MAXICODE"] = 512] = "MAXICODE";
    barcode_format_t[barcode_format_t["PDF_417"] = 1024] = "PDF_417";
    barcode_format_t[barcode_format_t["QR_CODE"] = 2048] = "QR_CODE";
    barcode_format_t[barcode_format_t["RSS_14"] = 4096] = "RSS_14";
    barcode_format_t[barcode_format_t["RSS_EXPANDED"] = 8192] = "RSS_EXPANDED";
    barcode_format_t[barcode_format_t["UPC_A"] = 16384] = "UPC_A";
    barcode_format_t[barcode_format_t["UPC_E"] = 32768] = "UPC_E";
    barcode_format_t[barcode_format_t["UPC_EAN_EXTENSION"] = 65536] = "UPC_EAN_EXTENSION";
    barcode_format_t[barcode_format_t["ALL"] = 131071] = "ALL";
})($cc08068a96912eec$export$53baafd5596ae7a8 || ($cc08068a96912eec$export$53baafd5596ae7a8 = {}));
var $cc08068a96912eec$export$1f0a57b556284af4;
(function(face_landmark_name_t) {
    face_landmark_name_t[face_landmark_name_t["EYE_LEFT"] = 0] = "EYE_LEFT";
    face_landmark_name_t[face_landmark_name_t["EYE_RIGHT"] = 1] = "EYE_RIGHT";
    face_landmark_name_t[face_landmark_name_t["EAR_LEFT"] = 2] = "EAR_LEFT";
    face_landmark_name_t[face_landmark_name_t["EAR_RIGHT"] = 3] = "EAR_RIGHT";
    face_landmark_name_t[face_landmark_name_t["NOSE_BRIDGE"] = 4] = "NOSE_BRIDGE";
    face_landmark_name_t[face_landmark_name_t["NOSE_TIP"] = 5] = "NOSE_TIP";
    face_landmark_name_t[face_landmark_name_t["NOSE_BASE"] = 6] = "NOSE_BASE";
    face_landmark_name_t[face_landmark_name_t["LIP_TOP"] = 7] = "LIP_TOP";
    face_landmark_name_t[face_landmark_name_t["LIP_BOTTOM"] = 8] = "LIP_BOTTOM";
    face_landmark_name_t[face_landmark_name_t["MOUTH_CENTER"] = 9] = "MOUTH_CENTER";
    face_landmark_name_t[face_landmark_name_t["CHIN"] = 10] = "CHIN";
    face_landmark_name_t[face_landmark_name_t["EYEBROW_LEFT"] = 11] = "EYEBROW_LEFT";
    face_landmark_name_t[face_landmark_name_t["EYEBROW_RIGHT"] = 12] = "EYEBROW_RIGHT";
})($cc08068a96912eec$export$1f0a57b556284af4 || ($cc08068a96912eec$export$1f0a57b556284af4 = {}));
var $cc08068a96912eec$export$51221aec55e6c7e6;
(function(instant_world_tracker_transform_orientation_t) {
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["WORLD"] = 3] = "WORLD";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["MINUS_Z_AWAY_FROM_USER"] = 4] = "MINUS_Z_AWAY_FROM_USER";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["MINUS_Z_HEADING"] = 5] = "MINUS_Z_HEADING";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["UNCHANGED"] = 6] = "UNCHANGED";
})($cc08068a96912eec$export$51221aec55e6c7e6 || ($cc08068a96912eec$export$51221aec55e6c7e6 = {}));
var $cc08068a96912eec$export$3c7fce2c49a05698;
(function(log_level_t) {
    log_level_t[log_level_t["LOG_LEVEL_NONE"] = 0] = "LOG_LEVEL_NONE";
    log_level_t[log_level_t["LOG_LEVEL_ERROR"] = 1] = "LOG_LEVEL_ERROR";
    log_level_t[log_level_t["LOG_LEVEL_WARNING"] = 2] = "LOG_LEVEL_WARNING";
    log_level_t[log_level_t["LOG_LEVEL_VERBOSE"] = 3] = "LOG_LEVEL_VERBOSE";
})($cc08068a96912eec$export$3c7fce2c49a05698 || ($cc08068a96912eec$export$3c7fce2c49a05698 = {}));
var $cc08068a96912eec$export$75bacc79ae92a32d;
(function(frame_pixel_format_t) {
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I420"] = 0] = "FRAME_PIXEL_FORMAT_I420";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I420A"] = 1] = "FRAME_PIXEL_FORMAT_I420A";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I422"] = 2] = "FRAME_PIXEL_FORMAT_I422";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I444"] = 3] = "FRAME_PIXEL_FORMAT_I444";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_NV12"] = 4] = "FRAME_PIXEL_FORMAT_NV12";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_RGBA"] = 5] = "FRAME_PIXEL_FORMAT_RGBA";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_BGRA"] = 6] = "FRAME_PIXEL_FORMAT_BGRA";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_Y"] = 7] = "FRAME_PIXEL_FORMAT_Y";
})($cc08068a96912eec$export$75bacc79ae92a32d || ($cc08068a96912eec$export$75bacc79ae92a32d = {}));
var $cc08068a96912eec$export$7f44ab26face7b78;
(function(image_target_type_t) {
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_PLANAR"] = 0] = "IMAGE_TRACKER_TYPE_PLANAR";
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_CYLINDRICAL"] = 1] = "IMAGE_TRACKER_TYPE_CYLINDRICAL";
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_CONICAL"] = 2] = "IMAGE_TRACKER_TYPE_CONICAL";
})($cc08068a96912eec$export$7f44ab26face7b78 || ($cc08068a96912eec$export$7f44ab26face7b78 = {}));




class $5a9b7c0e26766689$export$74925a4979a99f62 {
    constructor(_messageSender){
        this._messageSender = _messageSender;
        this._freeBufferPool = [];
        this._buffer = new ArrayBuffer(16);
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 1;
        this._startOffset = -1;
        this._timeoutSet = false;
        this._appender = {
            int: (i)=>this.int(i),
            bool: (i)=>this.int(i ? 1 : 0),
            float: (i)=>this.float(i),
            string: (i)=>this.string(i),
            dataWithLength: (i)=>this.arrayBuffer(i),
            type: (i)=>this.int(i),
            matrix4x4: (i)=>this.float32ArrayBuffer(i),
            matrix3x3: (i)=>this.float32ArrayBuffer(i),
            identityCoefficients: (i)=>this.float32ArrayBuffer(i),
            expressionCoefficients: (i)=>this.float32ArrayBuffer(i),
            cameraModel: (i)=>this.float32ArrayBuffer(i),
            timestamp: (i)=>this.double(i),
            barcodeFormat: (i)=>this.int(i),
            faceLandmarkName: (i)=>this.int(i),
            instantTrackerTransformOrientation: (i)=>this.int(i),
            logLevel: (i)=>this.int(i)
        };
        this._freeBufferPool.push(new ArrayBuffer(16));
        this._freeBufferPool.push(new ArrayBuffer(16));
    }
    bufferReturn(ab) {
        this._freeBufferPool.push(ab);
    }
    // public copySerializedData(): ArrayBuffer {
    //     let data = this._buffer.slice(0, this._offset * Int32Array.BYTES_PER_ELEMENT);
    //     this._offset = 0;
    //     this._startOffset = -1;
    //     return data;
    // }
    _ensureArrayBuffer(incremental) {
        let requirement = (this._offset + incremental + 8) * 4;
        if (this._buffer && this._buffer.byteLength >= requirement) return;
        let newBuffer = undefined;
        // for (let i = 0; i < this._freeBufferPool.length; i++) {
        //     if (this._freeBufferPool[i].byteLength > requirement) {
        //         newBuffer = this._freeBufferPool[i];
        //         this._freeBufferPool.splice(i, 1);
        //         break;
        //     }
        // }
        if (!newBuffer) {
            let nextPow2 = requirement;
            nextPow2--;
            nextPow2 |= nextPow2 >> 1;
            nextPow2 |= nextPow2 >> 2;
            nextPow2 |= nextPow2 >> 4;
            nextPow2 |= nextPow2 >> 8;
            nextPow2 |= nextPow2 >> 16;
            nextPow2++;
            newBuffer = new ArrayBuffer(nextPow2);
        }
        let oldView = this._buffer ? this._i32View : undefined;
        this._buffer = newBuffer;
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        if (oldView) this._i32View.set(oldView.subarray(0, this._offset));
    // this._offset = 1; // First int is whole length
    // this._startOffset = -1;
    }
    sendMessage(messageId, cb) {
        this._ensureArrayBuffer(4);
        this._startOffset = this._offset;
        this._i32View[this._offset + 1] = messageId;
        this._offset += 2;
        cb(this._appender);
        this._i32View[this._startOffset] = this._offset - this._startOffset;
        this._startOffset = -1;
        this._sendOneTime();
    }
    _sendOneTime() {
        if (this._timeoutSet === false) {
            this._timeoutSet = true;
            setTimeout(()=>{
                this._timeoutSet = false;
                this._send();
            }, 0);
        }
    }
    _send() {
        // Continue filling the current buffer unless have a new buffer to fill
        if (this._freeBufferPool.length === 0) {
            this._sendOneTime();
            return;
        }
        this._i32View[0] = this._offset;
        this._messageSender(this._buffer);
        this._buffer = undefined;
        this._buffer = this._freeBufferPool.pop();
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 1;
        this._startOffset = -1;
    }
    int(arg) {
        this._ensureArrayBuffer(1);
        this._i32View[this._offset] = arg;
        this._offset++;
    }
    double(arg) {
        this._ensureArrayBuffer(2);
        if (this._offset % 2 === 1) this._offset++;
        this._f64View[this._offset / 2] = arg;
        this._offset += 2;
    }
    float(arg) {
        this._ensureArrayBuffer(1);
        this._f32View[this._offset] = arg;
        this._offset++;
    }
    int32Array(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._i32View[this._offset + i] = args[i];
        this._offset += args.length;
    }
    float32Array(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._f32View[this._offset + i] = args[i];
        this._offset += args.length;
    }
    booleanArray(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._i32View[this._offset + i] = args[i] ? 1 : 0;
        this._offset += args.length;
    }
    uint8ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.byteLength;
        this._offset++;
        this._u8View.set(data, this._offset * 4);
        // Update the int32 offset
        this._offset += data.byteLength >> 2;
        if ((data.byteLength & 3) !== 0) this._offset++;
    }
    arrayBuffer(data) {
        let view = new Uint8Array(data);
        this.uint8ArrayBuffer(view);
    }
    uint8ClampedArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.byteLength;
        this._offset++;
        this._u8cView.set(data, this._offset * 4);
        // Update the int32 offset
        this._offset += data.byteLength >> 2;
        if ((data.byteLength & 3) !== 0) this._offset++;
    }
    float32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._f32View.set(data, this._offset);
        this._offset += data.length;
    }
    uint16ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        let u16Offset = this._offset * 2;
        this._u16View.set(data, u16Offset);
        // Update the int32 offset
        this._offset += data.length >> 1;
        if ((data.length & 1) !== 0) this._offset++;
    }
    int32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._i32View.set(data, this._offset);
        this._offset += data.length;
    }
    uint32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._u32View.set(data, this._offset);
        this._offset += data.length;
    }
    string(data) {
        let encoder = new TextEncoder();
        let res = encoder.encode(data);
        this._ensureArrayBuffer(res.byteLength / 4);
        this._i32View[this._offset] = res.byteLength;
        this._offset++;
        this._u8View.set(res, this._offset * 4);
        // Update the int32 offset
        this._offset += res.byteLength >> 2;
        if ((res.byteLength & 3) !== 0) this._offset++;
    }
}


class $e8ca8cd82f37239a$export$16c5ab9fb870b6bb {
    constructor(){
        this._buffer = new ArrayBuffer(0);
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 0;
        this._length = 0;
        this._startOffset = -1;
        this._processor = {
            int: ()=>this._i32View[this._startOffset++],
            bool: ()=>this._i32View[this._startOffset++] === 1,
            type: ()=>this._i32View[this._startOffset++],
            float: ()=>this._f32View[this._startOffset++],
            timestamp: ()=>{
                if (this._startOffset % 2 === 1) this._startOffset++;
                let ret = this._f64View[this._startOffset / 2];
                this._startOffset += 2;
                return ret;
            },
            string: ()=>{
                let len = this._i32View[this._startOffset++];
                let decoder = new TextDecoder();
                let res = decoder.decode(new Uint8Array(this._buffer, this._startOffset * 4, len));
                this._startOffset += len >> 2;
                if ((len & 3) !== 0) this._startOffset++;
                return res;
            },
            dataWithLength: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Uint8Array(len);
                ret.set(this._u8View.subarray(this._startOffset * 4, this._startOffset * 4 + len));
                this._startOffset += ret.byteLength >> 2;
                if ((ret.byteLength & 3) !== 0) this._startOffset++;
                return ret.buffer;
            },
            matrix4x4: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 16));
                this._startOffset += len;
                return ret;
            },
            matrix3x3: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 9));
                this._startOffset += len;
                return ret;
            },
            identityCoefficients: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 50));
                this._startOffset += len;
                return ret;
            },
            expressionCoefficients: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 29));
                this._startOffset += len;
                return ret;
            },
            cameraModel: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 6));
                this._startOffset += len;
                return ret;
            },
            barcodeFormat: ()=>this._i32View[this._startOffset++],
            faceLandmarkName: ()=>this._i32View[this._startOffset++],
            instantTrackerTransformOrientation: ()=>this._i32View[this._startOffset++],
            logLevel: ()=>this._i32View[this._startOffset++]
        };
    }
    setData(data) {
        this._buffer = data;
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 0;
        this._length = 0;
        if (data.byteLength >= 4) {
            this._offset = 1;
            this._length = this._i32View[0];
        }
        this._startOffset = -1;
    }
    hasMessage() {
        return this._offset + 1 < this._length;
    }
    forMessages(cb) {
        while(this.hasMessage()){
            let len = this._i32View[this._offset];
            let messageId = this._i32View[this._offset + 1];
            this._startOffset = this._offset + 2;
            this._offset += len;
            cb(messageId, this._processor);
        }
    }
}


class $fd7d2daf873ace75$export$ada9decabe1e7aa7 {
    constructor(_messageSender){
        this._messageSender = _messageSender;
        this._globalState = {
            log_level: 1
        };
        this.serializer = new (0, $5a9b7c0e26766689$export$74925a4979a99f62)((ab)=>{
            this._messageSender(ab);
        });
        this.deserializer = new (0, $e8ca8cd82f37239a$export$16c5ab9fb870b6bb)();
        this._latestId = 1;
        this._pipeline_state_by_instance = new Map();
        this._camera_source_state_by_instance = new Map();
        this._sequence_source_state_by_instance = new Map();
        this._image_tracker_state_by_instance = new Map();
        this._face_tracker_state_by_instance = new Map();
        this._face_mesh_state_by_instance = new Map();
        this._face_landmark_state_by_instance = new Map();
        this._barcode_finder_state_by_instance = new Map();
        this._instant_world_tracker_state_by_instance = new Map();
        this.impl = {
            log_level: ()=>{
                return this._globalState.log_level;
            },
            log_level_set: (level)=>{
                this.serializer.sendMessage(34, (m)=>{
                    m.logLevel(level);
                });
            },
            analytics_project_id_set: (id)=>{
                this.serializer.sendMessage(31, (m)=>{
                    m.string(id);
                });
            },
            // #### pipeline ####
            pipeline_create: ()=>{
                let newId = this._latestId++;
                let s = {
                    current_frame_user_data: 0,
                    camera_model: new Float32Array([
                        300,
                        300,
                        160,
                        120,
                        0,
                        0
                    ]),
                    camera_pose: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    camera_frame_camera_attitude: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    camera_frame_device_attitude: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    frame_number: 0
                };
                this._pipeline_state_by_instance.set(newId, s);
                this.serializer.sendMessage(27, (m)=>{
                    m.type(newId);
                });
                return newId;
            },
            pipeline_destroy: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._pipeline_state_by_instance.delete(o);
                this.serializer.sendMessage(28, (m)=>{
                    m.type(o);
                });
            },
            pipeline_frame_update: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(9, (m)=>{
                    m.type(o);
                });
            },
            pipeline_frame_number: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.frame_number;
            },
            pipeline_camera_model: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_model;
            },
            pipeline_camera_frame_user_data: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.current_frame_user_data;
            },
            pipeline_camera_frame_submit: (o, data, width, height, user_data, camera_to_device_transform, camera_model, user_facing)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(8, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                    m.int(width);
                    m.int(height);
                    m.int(user_data);
                    m.matrix4x4(camera_to_device_transform);
                    m.cameraModel(camera_model);
                    m.bool(user_facing);
                });
            },
            pipeline_camera_frame_submit_raw_pointer: (o, data, dataLength, format, width, height, user_data, camera_to_device_transform, rotation, camera_model, user_facing)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
            },
            pipeline_camera_frame_camera_attitude: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_frame_camera_attitude;
            },
            pipeline_camera_frame_device_attitude: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_frame_device_attitude;
            },
            pipeline_motion_accelerometer_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(10, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_rotation_rate_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(11, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_attitude_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(12, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_attitude_matrix_submit: (o, mat)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(13, (m)=>{
                    m.type(o);
                    m.matrix4x4(mat);
                });
            },
            // #### camera_source ####
            camera_source_create: (pipeline, device_id)=>{
                let newId = this._latestId++;
                let s = {};
                this._camera_source_state_by_instance.set(newId, s);
                this.serializer.sendMessage(29, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                    m.string(device_id);
                });
                return newId;
            },
            camera_source_destroy: (o)=>{
                let s = this._camera_source_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._camera_source_state_by_instance.delete(o);
                this.serializer.sendMessage(30, (m)=>{
                    m.type(o);
                });
            },
            // #### sequence_source ####
            sequence_source_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {};
                this._sequence_source_state_by_instance.set(newId, s);
                this.serializer.sendMessage(35, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            sequence_source_destroy: (o)=>{
                let s = this._sequence_source_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._sequence_source_state_by_instance.delete(o);
                this.serializer.sendMessage(36, (m)=>{
                    m.type(o);
                });
            },
            // #### image_tracker ####
            image_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    target_loaded_version: -1,
                    anchor_count: 0,
                    anchor_id: [],
                    anchor_pose: []
                };
                this._image_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(2, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            image_tracker_destroy: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._image_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(14, (m)=>{
                    m.type(o);
                });
            },
            image_tracker_target_load_from_memory: (o, data)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(4, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                });
            },
            image_tracker_target_loaded_version: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.target_loaded_version;
            },
            image_tracker_enabled: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            image_tracker_enabled_set: (o, enabled)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(3, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            image_tracker_anchor_count: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_count;
            },
            image_tracker_anchor_id: (o, indx)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_id[indx];
            },
            image_tracker_anchor_pose_raw: (o, indx)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_pose[indx];
            },
            // #### face_tracker ####
            face_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    model_loaded: -1,
                    max_faces: 1,
                    anchor_count: 0,
                    anchor_id: [],
                    anchor_pose: [],
                    anchor_identity_coefficients: [],
                    anchor_expression_coefficients: []
                };
                this._face_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(20, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            face_tracker_destroy: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(21, (m)=>{
                    m.type(o);
                });
            },
            face_tracker_model_load_from_memory: (o, data)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(22, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                });
            },
            face_tracker_model_loaded_version: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.model_loaded;
            },
            face_tracker_enabled_set: (o, enabled)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(23, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            face_tracker_enabled: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            face_tracker_max_faces_set: (o, num)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(24, (m)=>{
                    m.type(o);
                    m.int(num);
                });
            },
            face_tracker_max_faces: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.max_faces;
            },
            face_tracker_anchor_count: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_count;
            },
            face_tracker_anchor_id: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_id[indx];
            },
            face_tracker_anchor_pose_raw: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_pose[indx];
            },
            face_tracker_anchor_identity_coefficients: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_identity_coefficients[indx];
            },
            face_tracker_anchor_expression_coefficients: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_expression_coefficients[indx];
            },
            // #### face_mesh ####
            face_mesh_create: ()=>{
                let newId = this._latestId++;
                let s = {};
                this._face_mesh_state_by_instance.set(newId, s);
                this.serializer.sendMessage(25, (m)=>{
                    m.type(newId);
                });
                return newId;
            },
            face_mesh_destroy: (o)=>{
                let s = this._face_mesh_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_mesh_state_by_instance.delete(o);
                this.serializer.sendMessage(26, (m)=>{
                    m.type(o);
                });
            },
            // #### face_landmark ####
            face_landmark_create: (landmark)=>{
                let newId = this._latestId++;
                let s = {};
                this._face_landmark_state_by_instance.set(newId, s);
                this.serializer.sendMessage(32, (m)=>{
                    m.type(newId);
                    m.faceLandmarkName(landmark);
                });
                return newId;
            },
            face_landmark_destroy: (o)=>{
                let s = this._face_landmark_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_landmark_state_by_instance.delete(o);
                this.serializer.sendMessage(33, (m)=>{
                    m.type(o);
                });
            },
            // #### barcode_finder ####
            barcode_finder_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    number_found: 0,
                    found_text: [],
                    found_format: [],
                    formats: 131071
                };
                this._barcode_finder_state_by_instance.set(newId, s);
                this.serializer.sendMessage(16, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            barcode_finder_destroy: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._barcode_finder_state_by_instance.delete(o);
                this.serializer.sendMessage(17, (m)=>{
                    m.type(o);
                });
            },
            barcode_finder_enabled_set: (o, enabled)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(18, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            barcode_finder_enabled: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            barcode_finder_found_number: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.number_found;
            },
            barcode_finder_found_text: (o, indx)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.found_text[indx];
            },
            barcode_finder_found_format: (o, indx)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.found_format[indx];
            },
            barcode_finder_formats: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.formats;
            },
            barcode_finder_formats_set: (o, f)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(19, (m)=>{
                    m.type(o);
                    m.barcodeFormat(f);
                });
            },
            // #### instant_world_tracker ####
            instant_world_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    pose: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ])
                };
                this._instant_world_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(5, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            instant_world_tracker_destroy: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._instant_world_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(15, (m)=>{
                    m.type(o);
                });
            },
            instant_world_tracker_enabled_set: (o, enabled)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(6, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            instant_world_tracker_enabled: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            instant_world_tracker_anchor_pose_raw: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.pose;
            },
            instant_world_tracker_anchor_pose_set_from_camera_offset_raw: (o, x, y, z, orientation)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(7, (m)=>{
                    m.type(o);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                    m.instantTrackerTransformOrientation(orientation);
                });
            }
        };
    }
    processMessages(a) {
        this.deserializer.setData(a);
        this.deserializer.forMessages((messageId, msg)=>{
            switch(messageId){
                case 7:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.frame_number = msg.int();
                        break;
                    }
                case 6:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_model = msg.cameraModel();
                        break;
                    }
                case 5:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.current_frame_user_data = msg.int();
                        break;
                    }
                case 11:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_frame_camera_attitude = msg.matrix4x4();
                        break;
                    }
                case 12:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_frame_device_attitude = msg.matrix4x4();
                        break;
                    }
                case 19:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.target_loaded_version = msg.int();
                        break;
                    }
                case 1:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.anchor_count = msg.int();
                        break;
                    }
                case 2:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_id[indx] = msg.string();
                        break;
                    }
                case 3:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_pose[indx] = msg.matrix4x4();
                        break;
                    }
                case 18:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.model_loaded = msg.int();
                        break;
                    }
                case 13:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.anchor_count = msg.int();
                        break;
                    }
                case 14:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_id[indx] = msg.string();
                        break;
                    }
                case 15:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_pose[indx] = msg.matrix4x4();
                        break;
                    }
                case 16:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_identity_coefficients[indx] = msg.identityCoefficients();
                        break;
                    }
                case 17:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_expression_coefficients[indx] = msg.expressionCoefficients();
                        break;
                    }
                case 8:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.number_found = msg.int();
                        break;
                    }
                case 9:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.found_text[indx] = msg.string();
                        break;
                    }
                case 10:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.found_format[indx] = msg.barcodeFormat();
                        break;
                    }
                case 4:
                    {
                        let handle = msg.type();
                        let inst = this._instant_world_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.pose = msg.matrix4x4();
                        break;
                    }
            }
        });
    }
}


function $93790adeb8d4d945$export$9b5304f4eb007cf0(gl, type, src) {
    let ret = gl.createShader(type);
    if (!ret) throw new Error("Unable to create shader");
    gl.shaderSource(ret, src);
    gl.compileShader(ret);
    let msg = gl.getShaderInfoLog(ret);
    if (msg && msg.trim().length > 0) throw new Error("Shader compile error: " + msg);
    return ret;
}
function $93790adeb8d4d945$export$d879afae78b531a5(gl, prog) {
    gl.linkProgram(prog);
    let msg = gl.getProgramInfoLog(prog);
    if (msg && msg.trim().length > 0) throw new Error("Unable to link: " + msg);
}


let $11023ec155ec8242$var$shader;
let $11023ec155ec8242$var$vbo;
let $11023ec155ec8242$var$uvbo;
let $11023ec155ec8242$var$texturesByUrl = {};
function $11023ec155ec8242$export$5998daa18e8ce5b0() {
    $11023ec155ec8242$var$shader = undefined;
    $11023ec155ec8242$var$vbo = undefined;
    $11023ec155ec8242$var$uvbo = undefined;
    $11023ec155ec8242$var$texturesByUrl = {};
}
function $11023ec155ec8242$var$generate(gl) {
    if ($11023ec155ec8242$var$vbo) return $11023ec155ec8242$var$vbo;
    $11023ec155ec8242$var$vbo = gl.createBuffer();
    if (!$11023ec155ec8242$var$vbo) throw new Error("Unable to create buffer object");
    let coords = [
        -0.5,
        0.125,
        0,
        -0.5,
        -0.125,
        0,
        0.5,
        0.125,
        0,
        0.5,
        -0.125,
        0
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, $11023ec155ec8242$var$vbo);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(coords), gl.STATIC_DRAW);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return $11023ec155ec8242$var$vbo;
}
function $11023ec155ec8242$var$generateUVBO(gl) {
    if ($11023ec155ec8242$var$uvbo) return $11023ec155ec8242$var$uvbo;
    $11023ec155ec8242$var$uvbo = gl.createBuffer();
    if (!$11023ec155ec8242$var$uvbo) throw new Error("Unable to create buffer object");
    let coords = [
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        0
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, $11023ec155ec8242$var$uvbo);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(coords), gl.STATIC_DRAW);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return $11023ec155ec8242$var$uvbo;
}
function $11023ec155ec8242$export$4807f772bfdbc71f(gl, projectionMatrix, cameraMatrix, targetMatrix, textureUrl) {
    let shader = $11023ec155ec8242$var$getShader(gl);
    let v = $11023ec155ec8242$var$generate(gl);
    let uvbo = $11023ec155ec8242$var$generateUVBO(gl);
    gl.disable(gl.DEPTH_TEST);
    gl.useProgram(shader.prog);
    gl.uniformMatrix4fv(shader.unif_proj, false, projectionMatrix);
    gl.uniformMatrix4fv(shader.unif_camera, false, cameraMatrix);
    gl.uniformMatrix4fv(shader.unif_matrix, false, targetMatrix);
    gl.bindBuffer(gl.ARRAY_BUFFER, v);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, $11023ec155ec8242$var$loadTexture(gl, textureUrl));
    gl.uniform1i(shader.unif_skinSampler, 0);
    gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
    gl.enableVertexAttribArray(shader.attr_position);
    gl.bindBuffer(gl.ARRAY_BUFFER, uvbo);
    gl.vertexAttribPointer(shader.attr_textureCoord, 2, gl.FLOAT, false, 8, 0);
    gl.enableVertexAttribArray(shader.attr_textureCoord);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    gl.disableVertexAttribArray(shader.attr_position);
    gl.disableVertexAttribArray(shader.attr_textureCoord);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
}
function $11023ec155ec8242$var$generateLocalMatrix() {
    let position = [
        0,
        0,
        -5
    ];
    return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        position[0],
        position[1],
        position[2],
        1
    ]);
}
let $11023ec155ec8242$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 projMatrix;
uniform mat4 cameraMatrix;
uniform mat4 modelViewMatrix;
attribute vec4 position;
attribute vec2 textureCoord;

varying highp vec2 vTextureCoord;

void main()
{
    gl_Position = projMatrix * cameraMatrix * modelViewMatrix * position;
    vTextureCoord = textureCoord;
}`;
let $11023ec155ec8242$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
uniform sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2D(skinSampler, vTextureCoord);
}`;
function $11023ec155ec8242$var$getShader(gl) {
    if ($11023ec155ec8242$var$shader) return $11023ec155ec8242$var$shader;
    let prog = gl.createProgram();
    if (!prog) throw new Error("Unable to create program");
    let vertexShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $11023ec155ec8242$var$vertexShaderSrc);
    let fragmentShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $11023ec155ec8242$var$fragmentShaderSrc);
    gl.attachShader(prog, vertexShader);
    gl.attachShader(prog, fragmentShader);
    (0, $93790adeb8d4d945$export$d879afae78b531a5)(gl, prog);
    let unif_proj = gl.getUniformLocation(prog, "projMatrix");
    if (!unif_proj) throw new Error("Unable to get uniform location projMatrix");
    let unif_matrix = gl.getUniformLocation(prog, "modelViewMatrix");
    if (!unif_matrix) throw new Error("Unable to get uniform location modelViewMatrix");
    let unif_camera = gl.getUniformLocation(prog, "cameraMatrix");
    if (!unif_camera) throw new Error("Unable to get uniform location cameraMatrix");
    let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
    if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
    $11023ec155ec8242$var$shader = {
        prog: prog,
        unif_matrix: unif_matrix,
        unif_proj: unif_proj,
        unif_camera: unif_camera,
        unif_skinSampler: unif_skinSampler,
        attr_position: gl.getAttribLocation(prog, "position"),
        attr_textureCoord: gl.getAttribLocation(prog, "textureCoord")
    };
    return $11023ec155ec8242$var$shader;
}
function $11023ec155ec8242$var$loadTexture(gl, url) {
    if ($11023ec155ec8242$var$texturesByUrl[url]) return $11023ec155ec8242$var$texturesByUrl[url];
    let texture = gl.createTexture();
    if (!texture) throw new Error("Unable to create texture");
    $11023ec155ec8242$var$texturesByUrl[url] = texture;
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // Because images have to be download over the internet
    // they might take a moment until they are ready.
    // Until then put a single pixel in the texture so we can
    // use it immediately. When the image has finished downloading
    // we'll update the texture with the contents of the image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 1;
    const height = 1;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const pixel = new Uint8Array([
        0,
        0,
        255,
        255
    ]); // opaque blue
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);
    const image = new Image();
    image.onload = function() {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    };
    image.src = url;
    return texture;
}


var $2e616e7f2b93d8b0$exports = {};

$parcel$export($2e616e7f2b93d8b0$exports, "create", function () { return $2e616e7f2b93d8b0$export$185802fd694ee1f5; });
$parcel$export($2e616e7f2b93d8b0$exports, "clone", function () { return $2e616e7f2b93d8b0$export$9cd59f9826255e47; });
$parcel$export($2e616e7f2b93d8b0$exports, "copy", function () { return $2e616e7f2b93d8b0$export$784d13d8ee351f07; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromValues", function () { return $2e616e7f2b93d8b0$export$a82be99ed2a44a7d; });
$parcel$export($2e616e7f2b93d8b0$exports, "set", function () { return $2e616e7f2b93d8b0$export$adaa4cf7ef1b65be; });
$parcel$export($2e616e7f2b93d8b0$exports, "identity", function () { return $2e616e7f2b93d8b0$export$f0954fd7d5368655; });
$parcel$export($2e616e7f2b93d8b0$exports, "transpose", function () { return $2e616e7f2b93d8b0$export$9cb09a71b7d66923; });
$parcel$export($2e616e7f2b93d8b0$exports, "invert", function () { return $2e616e7f2b93d8b0$export$6897c284b6f9f4dc; });
$parcel$export($2e616e7f2b93d8b0$exports, "adjoint", function () { return $2e616e7f2b93d8b0$export$33f3c024b4ae00a1; });
$parcel$export($2e616e7f2b93d8b0$exports, "determinant", function () { return $2e616e7f2b93d8b0$export$a04698f914c55ed9; });
$parcel$export($2e616e7f2b93d8b0$exports, "multiply", function () { return $2e616e7f2b93d8b0$export$2060d2db72cce88f; });
$parcel$export($2e616e7f2b93d8b0$exports, "translate", function () { return $2e616e7f2b93d8b0$export$d73ee8ef04f5226a; });
$parcel$export($2e616e7f2b93d8b0$exports, "scale", function () { return $2e616e7f2b93d8b0$export$dcdf75081b88279d; });
$parcel$export($2e616e7f2b93d8b0$exports, "rotate", function () { return $2e616e7f2b93d8b0$export$bb628a54ab399bc9; });
$parcel$export($2e616e7f2b93d8b0$exports, "rotateX", function () { return $2e616e7f2b93d8b0$export$a59c8716592e09af; });
$parcel$export($2e616e7f2b93d8b0$exports, "rotateY", function () { return $2e616e7f2b93d8b0$export$cf71e4d4ca4d1cfd; });
$parcel$export($2e616e7f2b93d8b0$exports, "rotateZ", function () { return $2e616e7f2b93d8b0$export$ea6eae3365de5b9c; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromTranslation", function () { return $2e616e7f2b93d8b0$export$bc9e79e74e9fddf6; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromScaling", function () { return $2e616e7f2b93d8b0$export$832ca188ffb1955d; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromRotation", function () { return $2e616e7f2b93d8b0$export$926fc125ff3c666c; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromXRotation", function () { return $2e616e7f2b93d8b0$export$dd47cc2f828c32ef; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromYRotation", function () { return $2e616e7f2b93d8b0$export$7dc997d67d2b7f33; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromZRotation", function () { return $2e616e7f2b93d8b0$export$ad5ddaedc8f405df; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromRotationTranslation", function () { return $2e616e7f2b93d8b0$export$9545ac307f2a256b; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromQuat2", function () { return $2e616e7f2b93d8b0$export$ff497f2be31cc6a; });
$parcel$export($2e616e7f2b93d8b0$exports, "getTranslation", function () { return $2e616e7f2b93d8b0$export$202e99f82f7f0395; });
$parcel$export($2e616e7f2b93d8b0$exports, "getScaling", function () { return $2e616e7f2b93d8b0$export$71dc54d92bd04b57; });
$parcel$export($2e616e7f2b93d8b0$exports, "getRotation", function () { return $2e616e7f2b93d8b0$export$df3937d3b537df0a; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromRotationTranslationScale", function () { return $2e616e7f2b93d8b0$export$ddf9c55c9f2be172; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromRotationTranslationScaleOrigin", function () { return $2e616e7f2b93d8b0$export$1def1f860edc4b1f; });
$parcel$export($2e616e7f2b93d8b0$exports, "fromQuat", function () { return $2e616e7f2b93d8b0$export$2ff2bbe382249af7; });
$parcel$export($2e616e7f2b93d8b0$exports, "frustum", function () { return $2e616e7f2b93d8b0$export$89b5708c387cac6c; });
$parcel$export($2e616e7f2b93d8b0$exports, "perspectiveNO", function () { return $2e616e7f2b93d8b0$export$4cf19729ec9a96b8; });
$parcel$export($2e616e7f2b93d8b0$exports, "perspective", function () { return $2e616e7f2b93d8b0$export$541149539f3a4684; });
$parcel$export($2e616e7f2b93d8b0$exports, "perspectiveZO", function () { return $2e616e7f2b93d8b0$export$294bba99a6af0c0c; });
$parcel$export($2e616e7f2b93d8b0$exports, "perspectiveFromFieldOfView", function () { return $2e616e7f2b93d8b0$export$58ae211c788e338f; });
$parcel$export($2e616e7f2b93d8b0$exports, "orthoNO", function () { return $2e616e7f2b93d8b0$export$c5f65ef3eb668f27; });
$parcel$export($2e616e7f2b93d8b0$exports, "ortho", function () { return $2e616e7f2b93d8b0$export$4f2167e613cfc87b; });
$parcel$export($2e616e7f2b93d8b0$exports, "orthoZO", function () { return $2e616e7f2b93d8b0$export$b1d31ea7b4d854e; });
$parcel$export($2e616e7f2b93d8b0$exports, "lookAt", function () { return $2e616e7f2b93d8b0$export$d924e14fd6d9aa66; });
$parcel$export($2e616e7f2b93d8b0$exports, "targetTo", function () { return $2e616e7f2b93d8b0$export$aa67782f4dc9e52c; });
$parcel$export($2e616e7f2b93d8b0$exports, "str", function () { return $2e616e7f2b93d8b0$export$42d51816ce590c93; });
$parcel$export($2e616e7f2b93d8b0$exports, "frob", function () { return $2e616e7f2b93d8b0$export$326827e8268e9cdb; });
$parcel$export($2e616e7f2b93d8b0$exports, "add", function () { return $2e616e7f2b93d8b0$export$e16d8520af44a096; });
$parcel$export($2e616e7f2b93d8b0$exports, "subtract", function () { return $2e616e7f2b93d8b0$export$4e2d2ead65e5f7e3; });
$parcel$export($2e616e7f2b93d8b0$exports, "multiplyScalar", function () { return $2e616e7f2b93d8b0$export$c697bed75648cdb7; });
$parcel$export($2e616e7f2b93d8b0$exports, "multiplyScalarAndAdd", function () { return $2e616e7f2b93d8b0$export$553579f63bdd7137; });
$parcel$export($2e616e7f2b93d8b0$exports, "exactEquals", function () { return $2e616e7f2b93d8b0$export$f2599a5cf1109d8; });
$parcel$export($2e616e7f2b93d8b0$exports, "equals", function () { return $2e616e7f2b93d8b0$export$e9bab7fafb253603; });
$parcel$export($2e616e7f2b93d8b0$exports, "mul", function () { return $2e616e7f2b93d8b0$export$6e3a27864ab166fe; });
$parcel$export($2e616e7f2b93d8b0$exports, "sub", function () { return $2e616e7f2b93d8b0$export$f93b5905241a7cca; });
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $bddce99c0c610ba2$export$fd293b15f47e270 = 0.000001;
var $bddce99c0c610ba2$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $bddce99c0c610ba2$export$5ada478c8a628231 = Math.random;
function $bddce99c0c610ba2$export$cb2c0eb57f5e532c(type) {
    $bddce99c0c610ba2$export$b67359430d3b1b2 = type;
}
var $bddce99c0c610ba2$var$degree = Math.PI / 180;
function $bddce99c0c610ba2$export$408b8ee5959eefd5(a) {
    return a * $bddce99c0c610ba2$var$degree;
}
function $bddce99c0c610ba2$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};


function $2e616e7f2b93d8b0$export$185802fd694ee1f5() {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(16);
    if ($bddce99c0c610ba2$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$9cd59f9826255e47(a) {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2e616e7f2b93d8b0$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2e616e7f2b93d8b0$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $2e616e7f2b93d8b0$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $2e616e7f2b93d8b0$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $2e616e7f2b93d8b0$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $2e616e7f2b93d8b0$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $2e616e7f2b93d8b0$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $2e616e7f2b93d8b0$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $2e616e7f2b93d8b0$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $2e616e7f2b93d8b0$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2e616e7f2b93d8b0$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $bddce99c0c610ba2$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $2e616e7f2b93d8b0$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $2e616e7f2b93d8b0$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $2e616e7f2b93d8b0$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $2e616e7f2b93d8b0$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $bddce99c0c610ba2$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$ff497f2be31cc6a(out, a) {
    var translation = new $bddce99c0c610ba2$export$b67359430d3b1b2(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $2e616e7f2b93d8b0$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $2e616e7f2b93d8b0$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $2e616e7f2b93d8b0$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $2e616e7f2b93d8b0$export$df3937d3b537df0a(out, mat) {
    var scaling = new $bddce99c0c610ba2$export$b67359430d3b1b2(3);
    $2e616e7f2b93d8b0$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $2e616e7f2b93d8b0$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $2e616e7f2b93d8b0$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $2e616e7f2b93d8b0$export$541149539f3a4684 = $2e616e7f2b93d8b0$export$4cf19729ec9a96b8;
function $2e616e7f2b93d8b0$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $2e616e7f2b93d8b0$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $2e616e7f2b93d8b0$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $2e616e7f2b93d8b0$export$4f2167e613cfc87b = $2e616e7f2b93d8b0$export$c5f65ef3eb668f27;
function $2e616e7f2b93d8b0$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $bddce99c0c610ba2$export$fd293b15f47e270 && Math.abs(eyey - centery) < $bddce99c0c610ba2$export$fd293b15f47e270 && Math.abs(eyez - centerz) < $bddce99c0c610ba2$export$fd293b15f47e270) return $2e616e7f2b93d8b0$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $2e616e7f2b93d8b0$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $2e616e7f2b93d8b0$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $2e616e7f2b93d8b0$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $2e616e7f2b93d8b0$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $2e616e7f2b93d8b0$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $2e616e7f2b93d8b0$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $2e616e7f2b93d8b0$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $2e616e7f2b93d8b0$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $2e616e7f2b93d8b0$export$6e3a27864ab166fe = $2e616e7f2b93d8b0$export$2060d2db72cce88f;
var $2e616e7f2b93d8b0$export$f93b5905241a7cca = $2e616e7f2b93d8b0$export$4e2d2ead65e5f7e3;

var $b817ce0f5cdadb29$exports = {};

$parcel$export($b817ce0f5cdadb29$exports, "create", function () { return $b817ce0f5cdadb29$export$185802fd694ee1f5; });
$parcel$export($b817ce0f5cdadb29$exports, "clone", function () { return $b817ce0f5cdadb29$export$9cd59f9826255e47; });
$parcel$export($b817ce0f5cdadb29$exports, "length", function () { return $b817ce0f5cdadb29$export$f24224f1c91d8156; });
$parcel$export($b817ce0f5cdadb29$exports, "fromValues", function () { return $b817ce0f5cdadb29$export$a82be99ed2a44a7d; });
$parcel$export($b817ce0f5cdadb29$exports, "copy", function () { return $b817ce0f5cdadb29$export$784d13d8ee351f07; });
$parcel$export($b817ce0f5cdadb29$exports, "set", function () { return $b817ce0f5cdadb29$export$adaa4cf7ef1b65be; });
$parcel$export($b817ce0f5cdadb29$exports, "add", function () { return $b817ce0f5cdadb29$export$e16d8520af44a096; });
$parcel$export($b817ce0f5cdadb29$exports, "subtract", function () { return $b817ce0f5cdadb29$export$4e2d2ead65e5f7e3; });
$parcel$export($b817ce0f5cdadb29$exports, "multiply", function () { return $b817ce0f5cdadb29$export$2060d2db72cce88f; });
$parcel$export($b817ce0f5cdadb29$exports, "divide", function () { return $b817ce0f5cdadb29$export$cd007d971a5a2143; });
$parcel$export($b817ce0f5cdadb29$exports, "ceil", function () { return $b817ce0f5cdadb29$export$803ce6b71a0a94b2; });
$parcel$export($b817ce0f5cdadb29$exports, "floor", function () { return $b817ce0f5cdadb29$export$a3fe094919f356fd; });
$parcel$export($b817ce0f5cdadb29$exports, "min", function () { return $b817ce0f5cdadb29$export$96ec731ed4dcb222; });
$parcel$export($b817ce0f5cdadb29$exports, "max", function () { return $b817ce0f5cdadb29$export$8960430cfd85939f; });
$parcel$export($b817ce0f5cdadb29$exports, "round", function () { return $b817ce0f5cdadb29$export$2077e0241d6afd3c; });
$parcel$export($b817ce0f5cdadb29$exports, "scale", function () { return $b817ce0f5cdadb29$export$dcdf75081b88279d; });
$parcel$export($b817ce0f5cdadb29$exports, "scaleAndAdd", function () { return $b817ce0f5cdadb29$export$19cedf1da84ba854; });
$parcel$export($b817ce0f5cdadb29$exports, "distance", function () { return $b817ce0f5cdadb29$export$9f17032d917177de; });
$parcel$export($b817ce0f5cdadb29$exports, "squaredDistance", function () { return $b817ce0f5cdadb29$export$88e6ebb4fe54f538; });
$parcel$export($b817ce0f5cdadb29$exports, "squaredLength", function () { return $b817ce0f5cdadb29$export$ab44e1323ffc8376; });
$parcel$export($b817ce0f5cdadb29$exports, "negate", function () { return $b817ce0f5cdadb29$export$aef51622e549b8b0; });
$parcel$export($b817ce0f5cdadb29$exports, "inverse", function () { return $b817ce0f5cdadb29$export$70ae2c07e401031b; });
$parcel$export($b817ce0f5cdadb29$exports, "normalize", function () { return $b817ce0f5cdadb29$export$a3295358bff77e; });
$parcel$export($b817ce0f5cdadb29$exports, "dot", function () { return $b817ce0f5cdadb29$export$94132a0e348806d4; });
$parcel$export($b817ce0f5cdadb29$exports, "cross", function () { return $b817ce0f5cdadb29$export$bb646b20bb93d339; });
$parcel$export($b817ce0f5cdadb29$exports, "lerp", function () { return $b817ce0f5cdadb29$export$3a89f8d6f6bf6c9f; });
$parcel$export($b817ce0f5cdadb29$exports, "hermite", function () { return $b817ce0f5cdadb29$export$ae8865616f30561c; });
$parcel$export($b817ce0f5cdadb29$exports, "bezier", function () { return $b817ce0f5cdadb29$export$b9c5f84610baddaf; });
$parcel$export($b817ce0f5cdadb29$exports, "random", function () { return $b817ce0f5cdadb29$export$4385e60b38654f68; });
$parcel$export($b817ce0f5cdadb29$exports, "transformMat4", function () { return $b817ce0f5cdadb29$export$5ffbd13800309d59; });
$parcel$export($b817ce0f5cdadb29$exports, "transformMat3", function () { return $b817ce0f5cdadb29$export$f0bfa0a0024626ee; });
$parcel$export($b817ce0f5cdadb29$exports, "transformQuat", function () { return $b817ce0f5cdadb29$export$c32adef9e939ce85; });
$parcel$export($b817ce0f5cdadb29$exports, "rotateX", function () { return $b817ce0f5cdadb29$export$a59c8716592e09af; });
$parcel$export($b817ce0f5cdadb29$exports, "rotateY", function () { return $b817ce0f5cdadb29$export$cf71e4d4ca4d1cfd; });
$parcel$export($b817ce0f5cdadb29$exports, "rotateZ", function () { return $b817ce0f5cdadb29$export$ea6eae3365de5b9c; });
$parcel$export($b817ce0f5cdadb29$exports, "angle", function () { return $b817ce0f5cdadb29$export$944b09d2ad10b378; });
$parcel$export($b817ce0f5cdadb29$exports, "zero", function () { return $b817ce0f5cdadb29$export$7f9972325ebfd559; });
$parcel$export($b817ce0f5cdadb29$exports, "str", function () { return $b817ce0f5cdadb29$export$42d51816ce590c93; });
$parcel$export($b817ce0f5cdadb29$exports, "exactEquals", function () { return $b817ce0f5cdadb29$export$f2599a5cf1109d8; });
$parcel$export($b817ce0f5cdadb29$exports, "equals", function () { return $b817ce0f5cdadb29$export$e9bab7fafb253603; });
$parcel$export($b817ce0f5cdadb29$exports, "sub", function () { return $b817ce0f5cdadb29$export$f93b5905241a7cca; });
$parcel$export($b817ce0f5cdadb29$exports, "mul", function () { return $b817ce0f5cdadb29$export$6e3a27864ab166fe; });
$parcel$export($b817ce0f5cdadb29$exports, "div", function () { return $b817ce0f5cdadb29$export$159d9494db57879b; });
$parcel$export($b817ce0f5cdadb29$exports, "dist", function () { return $b817ce0f5cdadb29$export$6c4a311cc157c764; });
$parcel$export($b817ce0f5cdadb29$exports, "sqrDist", function () { return $b817ce0f5cdadb29$export$2422cd6c492a8b3a; });
$parcel$export($b817ce0f5cdadb29$exports, "len", function () { return $b817ce0f5cdadb29$export$fc1400facf92c78; });
$parcel$export($b817ce0f5cdadb29$exports, "sqrLen", function () { return $b817ce0f5cdadb29$export$99d8dd3f32a3435; });
$parcel$export($b817ce0f5cdadb29$exports, "forEach", function () { return $b817ce0f5cdadb29$export$4b80e395e36b5a56; });

function $b817ce0f5cdadb29$export$185802fd694ee1f5() {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(3);
    if ($bddce99c0c610ba2$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $b817ce0f5cdadb29$export$9cd59f9826255e47(a) {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $b817ce0f5cdadb29$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $b817ce0f5cdadb29$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $b817ce0f5cdadb29$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $b817ce0f5cdadb29$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $b817ce0f5cdadb29$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $b817ce0f5cdadb29$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $b817ce0f5cdadb29$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $b817ce0f5cdadb29$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $b817ce0f5cdadb29$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $b817ce0f5cdadb29$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $b817ce0f5cdadb29$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $b817ce0f5cdadb29$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $b817ce0f5cdadb29$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $b817ce0f5cdadb29$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $b817ce0f5cdadb29$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $b817ce0f5cdadb29$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $b817ce0f5cdadb29$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $b817ce0f5cdadb29$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $b817ce0f5cdadb29$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $b817ce0f5cdadb29$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $b817ce0f5cdadb29$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $b817ce0f5cdadb29$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $b817ce0f5cdadb29$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $b817ce0f5cdadb29$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $b817ce0f5cdadb29$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $b817ce0f5cdadb29$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $b817ce0f5cdadb29$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $bddce99c0c610ba2$export$5ada478c8a628231() * 2.0 * Math.PI;
    var z = $bddce99c0c610ba2$export$5ada478c8a628231() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $b817ce0f5cdadb29$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $b817ce0f5cdadb29$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $b817ce0f5cdadb29$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $b817ce0f5cdadb29$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $b817ce0f5cdadb29$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $b817ce0f5cdadb29$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $b817ce0f5cdadb29$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $b817ce0f5cdadb29$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $b817ce0f5cdadb29$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $b817ce0f5cdadb29$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $b817ce0f5cdadb29$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $b817ce0f5cdadb29$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $b817ce0f5cdadb29$export$f93b5905241a7cca = $b817ce0f5cdadb29$export$4e2d2ead65e5f7e3;
var $b817ce0f5cdadb29$export$6e3a27864ab166fe = $b817ce0f5cdadb29$export$2060d2db72cce88f;
var $b817ce0f5cdadb29$export$159d9494db57879b = $b817ce0f5cdadb29$export$cd007d971a5a2143;
var $b817ce0f5cdadb29$export$6c4a311cc157c764 = $b817ce0f5cdadb29$export$9f17032d917177de;
var $b817ce0f5cdadb29$export$2422cd6c492a8b3a = $b817ce0f5cdadb29$export$88e6ebb4fe54f538;
var $b817ce0f5cdadb29$export$fc1400facf92c78 = $b817ce0f5cdadb29$export$f24224f1c91d8156;
var $b817ce0f5cdadb29$export$99d8dd3f32a3435 = $b817ce0f5cdadb29$export$ab44e1323ffc8376;
var $b817ce0f5cdadb29$export$4b80e395e36b5a56 = function() {
    var vec = $b817ce0f5cdadb29$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();


function $ca0d9f3de8343ab7$export$ca7f1c5c0280e0bf(params, screenWidth, screenHeight, near = 0.01, far = 100.0) {
    let cam_x = params[2] * 2;
    let cam_y = params[3] * 2;
    let projection = (0, $2e616e7f2b93d8b0$exports).create();
    (0, $2e616e7f2b93d8b0$exports).frustum(projection, near * (-0.5 - params[2]) / params[0], near * (cam_x - 0.5 - params[2]) / params[0], near * (cam_y - 0.5 - params[3]) / params[1], near * (-0.5 - params[3]) / params[1], near, far);
    // Flip camera y axis (before any other transformations) - converts from
    // the y axis downwards of the  tracking camera models to the y axis upwards
    // of rendering coordinate systems
    projection[4] *= -1;
    projection[5] *= -1;
    projection[6] *= -1;
    projection[7] *= -1;
    let mult = (0, $2e616e7f2b93d8b0$exports).create();
    (0, $2e616e7f2b93d8b0$exports).fromScaling(mult, [
        0.5 * cam_x,
        0.5 * cam_y,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(projection, mult, projection);
    // If it's user facing or not doesn't matter here as long as we apply the same-but-opposite
    // rotation at the end of the function
    (0, $2e616e7f2b93d8b0$exports).fromRotation(mult, $ca0d9f3de8343ab7$export$83fad53f837eba8e(false) * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(projection, mult, projection);
    let vec = (0, $b817ce0f5cdadb29$exports).create();
    vec[0] = cam_x;
    vec[1] = cam_y;
    vec[2] = 0;
    (0, $b817ce0f5cdadb29$exports).transformMat4(vec, vec, mult);
    let absWidth = Math.abs(vec[0]);
    let absHeight = Math.abs(vec[1]);
    let scaleFactor = 1;
    if (absWidth / screenWidth > absHeight / screenHeight) scaleFactor = screenHeight / absHeight;
    else scaleFactor = screenWidth / absWidth;
    (0, $2e616e7f2b93d8b0$exports).fromScaling(mult, [
        scaleFactor,
        scaleFactor,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(projection, mult, projection);
    (0, $2e616e7f2b93d8b0$exports).fromScaling(mult, [
        2 / screenWidth,
        2 / screenHeight,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(projection, mult, projection);
    (0, $2e616e7f2b93d8b0$exports).fromRotation(mult, $ca0d9f3de8343ab7$export$83fad53f837eba8e(false) * Math.PI / -180, [
        0,
        0,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(projection, projection, mult);
    return projection;
}
function $ca0d9f3de8343ab7$export$83fad53f837eba8e(isUserFacing) {
    if (window.screen.orientation) switch(window.screen.orientation.type){
        case "portrait-primary":
            return isUserFacing ? 90 : 270;
        case "landscape-secondary":
            return 180;
        case "portrait-secondary":
            return isUserFacing ? 270 : 90;
        default:
            return 0;
    }
    else if (window.orientation !== undefined) switch(window.orientation){
        case 0:
            return isUserFacing ? 90 : 270;
        case 90:
            return 0;
        case 180:
            return isUserFacing ? 270 : 90;
        case -90:
            return 180;
    }
    return 0;
}



var $4d81e838630131c6$exports = {};

$parcel$export($4d81e838630131c6$exports, "messageManager", function () { return $4d81e838630131c6$export$40ec70640330196f; });
$parcel$export($4d81e838630131c6$exports, "launchWorker", function () { return $4d81e838630131c6$export$11afba88bcfa2040; });
class $5fcf243e09e57ed4$export$d61e24a684f9e51 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit() {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i]();
    }
}
class $5fcf243e09e57ed4$export$3371bf92c01fb88b {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a);
    }
}
class $5fcf243e09e57ed4$export$2432f79a777b511d {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b);
    }
}
class $5fcf243e09e57ed4$export$82c217a001e88885 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b, c) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b, c);
    }
}
class $5fcf243e09e57ed4$export$88bac6eca2b85ca9 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b, c, d, e) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b, c, d, e);
    }
}


class $dd970800b466214b$export$7401c2b3ceaa2a5d {
    constructor(){
        this.onOutgoingMessage = new (0, $5fcf243e09e57ed4$export$d61e24a684f9e51)();
        this.onIncomingMessage = new (0, $5fcf243e09e57ed4$export$3371bf92c01fb88b)();
        this._outgoingMessages = [];
    }
    postIncomingMessage(msg) {
        this.onIncomingMessage.emit(msg);
    }
    postOutgoingMessage(msg, trans) {
        this._outgoingMessages.push({
            msg: msg,
            transferables: trans
        });
        this.onOutgoingMessage.emit();
    }
    getOutgoingMessages() {
        let ret = this._outgoingMessages;
        this._outgoingMessages = [];
        return ret;
    }
}


var $4d81e838630131c6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $4d81e838630131c6$export$40ec70640330196f = new (0, $dd970800b466214b$export$7401c2b3ceaa2a5d)();
var $531bf4af8e5914d2$exports = {};
var $902f5cabe5153acc$exports = {};
"use strict";
$902f5cabe5153acc$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



var $aNJCr = parcelRequire("aNJCr");

let $531bf4af8e5914d2$var$url = $aNJCr.getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("9lG97");
$531bf4af8e5914d2$exports = $902f5cabe5153acc$exports($531bf4af8e5914d2$var$url, $aNJCr.getOrigin($531bf4af8e5914d2$var$url), false);


var $d5c53ef89778e239$exports = {};


$d5c53ef89778e239$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("4noOu");


function $4d81e838630131c6$export$11afba88bcfa2040(worker) {
    return $4d81e838630131c6$var$__awaiter(this, void 0, void 0, function*() {
        if (!worker) worker = new Worker($531bf4af8e5914d2$exports);
        worker.postMessage({
            t: "wasm",
            url: new URL($d5c53ef89778e239$exports).toString()
        });
        yield $4d81e838630131c6$var$waitForLoad(worker);
        function sendOutgoing() {
            let msgs = $4d81e838630131c6$export$40ec70640330196f.getOutgoingMessages();
            for (let msg of msgs)worker.postMessage(msg.msg, msg.transferables);
        }
        $4d81e838630131c6$export$40ec70640330196f.onOutgoingMessage.bind(sendOutgoing);
        sendOutgoing();
        worker.addEventListener("message", (evt)=>{
            $4d81e838630131c6$export$40ec70640330196f.postIncomingMessage(evt.data);
        });
    });
}
function $4d81e838630131c6$var$waitForLoad(w) {
    return new Promise((resolve)=>{
        let listener = (msg)=>{
            if (msg.data === "loaded") {
                w.removeEventListener("message", listener);
                resolve();
            }
        };
        w.addEventListener("message", listener);
    });
}


var $5323009cd6103e45$exports = {};

$parcel$export($5323009cd6103e45$exports, "permissionGrantedCamera", function () { return $5323009cd6103e45$export$4bb09993846e9acf; });
$parcel$export($5323009cd6103e45$exports, "permissionGrantedMotion", function () { return $5323009cd6103e45$export$8ef5e97655361f65; });
$parcel$export($5323009cd6103e45$exports, "permissionDeniedCamera", function () { return $5323009cd6103e45$export$5867d9a17b50afa0; });
$parcel$export($5323009cd6103e45$exports, "permissionDeniedMotion", function () { return $5323009cd6103e45$export$fb47f4fbe41dd949; });
$parcel$export($5323009cd6103e45$exports, "permissionDeniedAny", function () { return $5323009cd6103e45$export$79205252f7c81bd7; });
$parcel$export($5323009cd6103e45$exports, "permissionGrantedAll", function () { return $5323009cd6103e45$export$672567c1c7f186ec; });
$parcel$export($5323009cd6103e45$exports, "permissionRequestAll", function () { return $5323009cd6103e45$export$4366b797ee910129; });
$parcel$export($5323009cd6103e45$exports, "permissionRequestMotion", function () { return $5323009cd6103e45$export$b90d6478d97704f1; });
$parcel$export($5323009cd6103e45$exports, "permissionRequestCamera", function () { return $5323009cd6103e45$export$5115e68f403cb5d9; });
$parcel$export($5323009cd6103e45$exports, "permissionRequestUI", function () { return $5323009cd6103e45$export$447cf121adb7b558; });
$parcel$export($5323009cd6103e45$exports, "permissionDeniedUI", function () { return $5323009cd6103e45$export$2e339b4d51173824; });

var $kSiIs = parcelRequire("kSiIs");
var $4c2fd9e00c19d645$export$caa3e053e76e6c08;
(function(STRINGS) {
    STRINGS[STRINGS["PermissionTitle"] = 0] = "PermissionTitle";
    STRINGS[STRINGS["PermissionDescription"] = 1] = "PermissionDescription";
    STRINGS[STRINGS["PermissionButton"] = 2] = "PermissionButton";
})($4c2fd9e00c19d645$export$caa3e053e76e6c08 || ($4c2fd9e00c19d645$export$caa3e053e76e6c08 = {}));
function $4c2fd9e00c19d645$var$parseLanguage(inp) {
    const [lang, locale] = inp.toLowerCase().split("-");
    return [
        lang,
        locale || ""
    ];
}
const [$4c2fd9e00c19d645$var$lang, $4c2fd9e00c19d645$var$locale] = $4c2fd9e00c19d645$var$parseLanguage(navigator.language);
function $4c2fd9e00c19d645$export$72451b88a72ad9c2(str) {
    switch($4c2fd9e00c19d645$var$lang){
        case "es":
            switch(str){
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionTitle:
                    return "Ya casi...";
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionDescription:
                    return "Para brindar esta experiencia de realidad aumentada, necesitamos acceso a la c\xe1mara y los sensores de movimiento de su dispositivo.";
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionButton:
                    return "Permitir acceso";
            }
            break;
        case "de":
            switch(str){
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionTitle:
                    return "Fast am Ziel..";
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionDescription:
                    return "Um dir dieses Augmented Reality Erlebnis zu liefern, brauchen wir Zugriff auf die Kamera und Bewegungssensoren deines Ger\xe4tes.";
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionButton:
                    return "Gew\xe4hre Zugriff";
            }
            break;
        case "pt":
            switch(str){
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionTitle:
                    return "Est\xe1 quase!";
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionDescription:
                    return "Esta experi\xeancia de realidade aumentada precisa de acesso \xe0 c\xe2mera e aos sensores de movimento deste dispositivo.";
                case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionButton:
                    return "Permitir acesso";
            }
            break;
    }
    switch(str){
        case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionTitle:
            return "Almost there...";
        case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionDescription:
            return "In order to provide this augmented reality experience, we need access to your device's camera and motion sensors.";
        case $4c2fd9e00c19d645$export$caa3e053e76e6c08.PermissionButton:
            return "Grant Access";
    }
    return "";
}


var $5323009cd6103e45$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $5323009cd6103e45$var$parser = new (0, $kSiIs.UAParser)();
let $5323009cd6103e45$var$_permissionGrantedCamera = false;
let $5323009cd6103e45$var$_permissionGrantedMotion = false;
let $5323009cd6103e45$var$_permissionDeniedCamera = false;
let $5323009cd6103e45$var$_permissionDeniedMotion = false;
if (!window.DeviceOrientationEvent || !window.DeviceOrientationEvent.requestPermission) $5323009cd6103e45$var$_permissionGrantedMotion = true;
function $5323009cd6103e45$var$checkForCameraPermission() {
    return $5323009cd6103e45$var$__awaiter(this, void 0, void 0, function*() {
        if (navigator.permissions && navigator.permissions.query) try {
            let res = yield navigator.permissions.query({
                name: "camera"
            });
            $5323009cd6103e45$var$_permissionDeniedCamera = res.state === "denied";
            $5323009cd6103e45$var$_permissionGrantedCamera = res.state === "granted";
        } catch (ex) {}
    });
}
$5323009cd6103e45$var$checkForCameraPermission();
function $5323009cd6103e45$export$4bb09993846e9acf() {
    return $5323009cd6103e45$var$_permissionGrantedCamera;
}
function $5323009cd6103e45$export$8ef5e97655361f65() {
    return $5323009cd6103e45$var$_permissionGrantedMotion;
}
function $5323009cd6103e45$export$5867d9a17b50afa0() {
    return $5323009cd6103e45$var$_permissionDeniedCamera;
}
function $5323009cd6103e45$export$fb47f4fbe41dd949() {
    return $5323009cd6103e45$var$_permissionDeniedMotion;
}
function $5323009cd6103e45$export$79205252f7c81bd7() {
    return $5323009cd6103e45$var$_permissionDeniedCamera || $5323009cd6103e45$var$_permissionDeniedMotion;
}
function $5323009cd6103e45$export$672567c1c7f186ec() {
    return $5323009cd6103e45$var$_permissionGrantedCamera && $5323009cd6103e45$var$_permissionGrantedMotion;
}
function $5323009cd6103e45$export$4366b797ee910129() {
    return $5323009cd6103e45$var$__awaiter(this, void 0, void 0, function*() {
        yield $5323009cd6103e45$export$b90d6478d97704f1();
        yield $5323009cd6103e45$export$5115e68f403cb5d9();
    });
}
function $5323009cd6103e45$export$5115e68f403cb5d9() {
    return $5323009cd6103e45$var$__awaiter(this, void 0, void 0, function*() {
        try {
            let res = yield navigator.mediaDevices.getUserMedia({
                video: true
            });
            let tracks = res.getTracks();
            tracks.forEach((t)=>t.stop());
            $5323009cd6103e45$var$_permissionGrantedCamera = true;
            $5323009cd6103e45$var$_permissionDeniedCamera = false;
        } catch (err) {
            $5323009cd6103e45$var$_permissionGrantedCamera = false;
            $5323009cd6103e45$var$_permissionDeniedCamera = true;
        }
    });
}
function $5323009cd6103e45$export$b90d6478d97704f1() {
    return $5323009cd6103e45$var$__awaiter(this, void 0, void 0, function*() {
        if (window.DeviceOrientationEvent && window.DeviceOrientationEvent.requestPermission) {
            let permissionResult = yield window.DeviceOrientationEvent.requestPermission();
            if (permissionResult !== "granted") {
                $5323009cd6103e45$var$_permissionGrantedMotion = false;
                $5323009cd6103e45$var$_permissionDeniedMotion = true;
                return false;
            }
        }
        // No motion permissions or granted
        $5323009cd6103e45$var$_permissionGrantedMotion = true;
        $5323009cd6103e45$var$_permissionDeniedMotion = false;
    });
}
function $5323009cd6103e45$export$447cf121adb7b558() {
    return $5323009cd6103e45$var$__awaiter(this, void 0, void 0, function*() {
        yield $5323009cd6103e45$var$checkForCameraPermission();
        if ($5323009cd6103e45$export$672567c1c7f186ec()) return true;
        let div = document.createElement("div");
        div.classList.add("zappar-permission-request");
        div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            max-width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">${(0, $4c2fd9e00c19d645$export$72451b88a72ad9c2)((0, $4c2fd9e00c19d645$export$caa3e053e76e6c08).PermissionTitle)}</div>
        <div class="zappar-text">${(0, $4c2fd9e00c19d645$export$72451b88a72ad9c2)((0, $4c2fd9e00c19d645$export$caa3e053e76e6c08).PermissionDescription)}</div>
        <button id="zappar-permission-request-button">${(0, $4c2fd9e00c19d645$export$72451b88a72ad9c2)((0, $4c2fd9e00c19d645$export$caa3e053e76e6c08).PermissionButton)}</button>
    </div>
`;
        document.body.append(div);
        let button = div.querySelector("#zappar-permission-request-button");
        return yield new Promise((resolve)=>{
            button === null || button === void 0 || button.addEventListener("click", ()=>$5323009cd6103e45$var$__awaiter(this, void 0, void 0, function*() {
                    yield $5323009cd6103e45$export$4366b797ee910129();
                    div.remove();
                    while(true){
                        yield $5323009cd6103e45$var$nextFrame();
                        if ($5323009cd6103e45$export$79205252f7c81bd7()) {
                            resolve(false);
                            return;
                        }
                        if ($5323009cd6103e45$export$672567c1c7f186ec()) {
                            resolve(true);
                            return;
                        }
                    }
                }));
        });
    });
}
function $5323009cd6103e45$var$nextFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}
function $5323009cd6103e45$export$2e339b4d51173824() {
    switch($5323009cd6103e45$var$parser.getBrowser().name){
        case "Chrome":
            $5323009cd6103e45$var$permissionDeniedUIChrome();
            break;
        default:
            $5323009cd6103e45$var$permissionDeniedUIIOS();
            break;
    }
}
function $5323009cd6103e45$var$permissionDeniedUIIOS() {
    let div = document.createElement("div");
    div.classList.add("zappar-permission-request");
    div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            max-width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">Permission is Needed</div>
        <div class="zappar-text">Permission to access your device's camera and motion sensors is necessary for this experience. Please reload the page to try again.</div>
        <button id="zappar-permission-reload-button">Reload</button>
    </div>
`;
    document.body.append(div);
    let button = div.querySelector("#zappar-permission-reload-button");
    button === null || button === void 0 || button.addEventListener("click", ()=>window.location.reload());
}
function $5323009cd6103e45$var$permissionDeniedUIChrome() {
    let div = document.createElement("div");
    div.classList.add("zappar-permission-request");
    div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">Permission is Needed</div>
        <div class="zappar-text">Permission to access your device's camera and motion sensors is necessary for this experience.<br/><br/>To grant access, please tap the ! button in the address bar of your browser, then "Site settings", and finally "Clear and reset". You can then reload the page to try again.</div>
        <button id="zappar-permission-reload-button">Reload</button>
    </div>
`;
    document.body.append(div);
    let button = div.querySelector("#zappar-permission-reload-button");
    button === null || button === void 0 || button.addEventListener("click", ()=>window.location.reload());
}




let $7c2568b0d857a09d$var$logLevel = (0, $cc08068a96912eec$export$3c7fce2c49a05698).LOG_LEVEL_ERROR;
function $7c2568b0d857a09d$export$c622e99c0ce7b1c9(l) {
    $7c2568b0d857a09d$var$logLevel = l;
}
function $7c2568b0d857a09d$export$454156e929b28fe7(...args) {
    if ($7c2568b0d857a09d$var$logLevel >= (0, $cc08068a96912eec$export$3c7fce2c49a05698).LOG_LEVEL_VERBOSE) console.log("[Zappar] INFO", ...args);
}
function $7c2568b0d857a09d$export$497c45d0bfe56de1(...args) {
    if ($7c2568b0d857a09d$var$logLevel >= (0, $cc08068a96912eec$export$3c7fce2c49a05698).LOG_LEVEL_ERROR) console.error("[Zappar] ERROR", ...args);
}
function $7c2568b0d857a09d$export$79a36c979e81230e(...args) {
    if ($7c2568b0d857a09d$var$logLevel >= (0, $cc08068a96912eec$export$3c7fce2c49a05698).LOG_LEVEL_VERBOSE) console.log("[Zappar] WARN", ...args);
}


let $c07c3eb0118aafe9$var$latestFaceMesh = 1;
let $c07c3eb0118aafe9$var$faceMeshById = new Map();
function $c07c3eb0118aafe9$export$3a09cf4ac8b68494() {
    let ret = $c07c3eb0118aafe9$var$latestFaceMesh++;
    $c07c3eb0118aafe9$var$faceMeshById.set(ret, new $c07c3eb0118aafe9$export$1238420da3a0b20c());
    (0, $7c2568b0d857a09d$export$454156e929b28fe7)("face_mesh_t initialized");
    return ret;
}
function $c07c3eb0118aafe9$export$eed3c787ca5a1447(m) {
    $c07c3eb0118aafe9$var$faceMeshById.delete(m);
}
function $c07c3eb0118aafe9$export$139ac0d2bb1e45ec(m) {
    return $c07c3eb0118aafe9$var$faceMeshById.get(m);
}
class $c07c3eb0118aafe9$export$1238420da3a0b20c {
    constructor(){
        this.render_mean_ = new Float32Array();
        this.render_identity_ = new Float32Array(50);
        this.render_expression_ = new Float32Array(29);
        this.render_uvs_ = new Float32Array();
        this.render_indices_ = new Uint16Array();
        this.vertices_ = new Float32Array();
        this.normals_ = new Float32Array();
        this.normalsCalculated_ = false;
        this.modelVersion_ = -1;
        this.mirrored_ = false;
    }
    loadFromMemory(ab, fillMouth, fillEyeL, fillEyeR, fillNeck) {
        let offset = 0;
        let uint16View = new Uint16Array(ab);
        let intView = new Int32Array(ab);
        let floatView = new Float32Array(ab);
        let readMatrix = ()=>{
            let nr = intView[offset++];
            let nc = intView[offset++];
            let size = nr * nc;
            let ret = floatView.subarray(offset, offset + size);
            offset += size;
            return ret;
        };
        let readShortVector = ()=>{
            let size = intView[offset++];
            let ret = uint16View.subarray(offset * 2, offset * 2 + size);
            offset += size / 2;
            return ret;
        };
        this.render_mean_ = readMatrix();
        this.render_identity_ = readMatrix();
        this.render_expression_ = readMatrix();
        this.render_uvs_ = readMatrix();
        let baseIndices = readShortVector();
        let mouthIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let leftEyeIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let rightEyeIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let neckIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        if (!fillMouth && !fillEyeL && !fillEyeR && !fillNeck) this.render_indices_ = baseIndices;
        else {
            let sizeRequired = baseIndices.length;
            if (fillMouth) sizeRequired += mouthIndices.length;
            if (fillEyeL) sizeRequired += leftEyeIndices.length;
            if (fillEyeR) sizeRequired += rightEyeIndices.length;
            if (fillNeck) sizeRequired += neckIndices.length;
            this.render_indices_ = new Uint16Array(sizeRequired);
            this.render_indices_.set(baseIndices, 0);
            let indx = baseIndices.length;
            if (fillMouth) {
                this.render_indices_.set(mouthIndices, indx);
                indx += mouthIndices.length;
            }
            if (fillEyeL) {
                this.render_indices_.set(leftEyeIndices, indx);
                indx += leftEyeIndices.length;
            }
            if (fillEyeR) {
                this.render_indices_.set(rightEyeIndices, indx);
                indx += rightEyeIndices.length;
            }
            if (fillNeck) {
                this.render_indices_.set(neckIndices, indx);
                indx += neckIndices.length;
            }
        }
        this.vertices_ = new Float32Array(this.render_mean_);
        this.normals_ = new Float32Array(this.vertices_.length);
        this.modelVersion_++;
    }
    getVertices() {
        return this.vertices_;
    }
    getUVs() {
        return this.render_uvs_;
    }
    getIndices() {
        if (this.mirrored_) {
            if (!this.render_indices_reversed) {
                this.render_indices_reversed = new Uint16Array(this.render_indices_.length);
                for(let i = 0; i < this.render_indices_.length; i += 3){
                    this.render_indices_reversed[i] = this.render_indices_[i + 2];
                    this.render_indices_reversed[i + 1] = this.render_indices_[i + 1];
                    this.render_indices_reversed[i + 2] = this.render_indices_[i];
                }
            }
            return this.render_indices_reversed;
        }
        return this.render_indices_;
    }
    getNormals() {
        if (!this.normalsCalculated_) this.calculateNormals();
        return this.normals_;
    }
    getModelVersion() {
        return this.modelVersion_;
    }
    getLandmarkDataForVertex(v) {
        let mean = [
            this.render_mean_[v * 3],
            this.render_mean_[v * 3 + 1],
            this.render_mean_[v * 3 + 2]
        ];
        let identity = [];
        for(let i = 0; i < 50; i++)identity.push(this.render_identity_[v * 150 + i]), identity.push(this.render_identity_[(v * 3 + 1) * 50 + i]), identity.push(this.render_identity_[(v * 3 + 2) * 50 + i]);
        let expression = [];
        for(let i = 0; i < 29; i++)expression.push(this.render_expression_[v * 87 + i]), expression.push(this.render_expression_[(v * 3 + 1) * 29 + i]), expression.push(this.render_expression_[(v * 3 + 2) * 29 + i]);
        return {
            mean: mean,
            identity: identity,
            expression: expression
        };
    }
    update(identity, expression, mirrored) {
        if (this.render_mean_.length === 0) return;
        if (this.render_identity_.length === 0) return;
        if (this.render_expression_.length === 0) return;
        this.mirrored_ = mirrored;
        this.vertices_.set(this.render_mean_);
        for(let i = 0; i < identity.length; i++)for(let j = 0; j < this.vertices_.length; j++)this.vertices_[j] += identity[i] * this.render_identity_[j * identity.length + i];
        for(let i = 0; i < expression.length; i++)for(let j = 0; j < this.vertices_.length; j++)this.vertices_[j] += expression[i] * this.render_expression_[j * expression.length + i];
        if (mirrored) for(let j = 0; j < this.vertices_.length; j += 3)this.vertices_[j] *= -1;
        this.normalsCalculated_ = false;
    }
    calculateNormals() {
        let indices = this.getIndices();
        let vertices = this.vertices_;
        let faceNormals = new Float32Array(indices.length);
        if (!vertices) return;
        let size = indices.length;
        let normals = this.normals_;
        let v = new Float32Array([
            0,
            0,
            0
        ]);
        let w = new Float32Array([
            0,
            0,
            0
        ]);
        let out = new Float32Array([
            0,
            0,
            0
        ]);
        for(let i = 0; i < size; i += 3){
            let vertexStart0 = indices[i] * 3;
            let vertexStart1 = indices[i + 1] * 3;
            let vertexStart2 = indices[i + 2] * 3;
            v[0] = vertices[vertexStart1] - vertices[vertexStart0];
            v[1] = vertices[vertexStart1 + 1] - vertices[vertexStart0 + 1];
            v[2] = vertices[vertexStart1 + 2] - vertices[vertexStart0 + 2];
            w[0] = vertices[vertexStart2] - vertices[vertexStart0];
            w[1] = vertices[vertexStart2 + 1] - vertices[vertexStart0 + 1];
            w[2] = vertices[vertexStart2 + 2] - vertices[vertexStart0 + 2];
            (0, $b817ce0f5cdadb29$exports).cross(out, v, w);
            let length = (0, $b817ce0f5cdadb29$exports).length(out);
            faceNormals[i] = out[0] / length;
            faceNormals[i + 1] = out[1] / length;
            faceNormals[i + 2] = out[2] / length;
        }
        normals.fill(0);
        for(let i = 0; i < size; i += 3){
            let vertexStart0 = indices[i] * 3;
            let vertexStart1 = indices[i + 1] * 3;
            let vertexStart2 = indices[i + 2] * 3;
            normals[vertexStart0] += faceNormals[i];
            normals[vertexStart0 + 1] += faceNormals[i + 1];
            normals[vertexStart0 + 2] += faceNormals[i + 2];
            normals[vertexStart1] += faceNormals[i];
            normals[vertexStart1 + 1] += faceNormals[i + 1];
            normals[vertexStart1 + 2] += faceNormals[i + 2];
            normals[vertexStart2] += faceNormals[i];
            normals[vertexStart2 + 1] += faceNormals[i + 1];
            normals[vertexStart2 + 2] += faceNormals[i + 2];
        }
        let numberNormals = normals.length / 3;
        for(let i = 0; i < numberNormals; i++){
            let indx = i * 3;
            v[0] = normals[indx];
            v[1] = normals[indx + 1];
            v[2] = normals[indx + 2];
            (0, $b817ce0f5cdadb29$exports).normalize(w, v);
            normals[indx] = w[0];
            normals[indx + 1] = w[1];
            normals[indx + 2] = w[2];
        }
        this.normalsCalculated_ = true;
    }
}




let $aabe8846ae41ae5f$var$identity = (0, $2e616e7f2b93d8b0$exports).create();
class $aabe8846ae41ae5f$export$65ee3277a9a1612d {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        this._vbo = undefined;
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._shader = undefined;
    }
    _generate(gl, i) {
        if (this._vbo) return this._vbo;
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        let vboData = new Float32Array([
            -1,
            -1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            1,
            1,
            -1,
            0,
            1,
            0,
            1,
            -1,
            0,
            1,
            0,
            -1,
            1,
            0,
            0,
            1,
            1,
            1,
            0,
            1,
            1
        ]);
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vboData), gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    drawCameraFrame(screenWidth, screenHeight, i, mirror) {
        if (!i.texture) return;
        let gl = this._gl;
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.BLEND);
        let shader = this._getCameraShader(gl);
        let vbo = this._generate(gl, i);
        gl.activeTexture(gl.TEXTURE0);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_skinTexTransform, false, $aabe8846ae41ae5f$export$3da067886124f338(i.dataWidth, i.dataHeight, screenWidth, screenHeight, i.uvTransform || $aabe8846ae41ae5f$var$identity, mirror));
        gl.uniform1i(shader.unif_skinSampler, 0);
        gl.bindTexture(gl.TEXTURE_2D, i.texture);
        gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 20, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.vertexAttribPointer(shader.attr_texCoord, 2, gl.FLOAT, false, 20, 12);
        gl.enableVertexAttribArray(shader.attr_texCoord);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_texCoord);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.useProgram(null);
    }
    _getCameraShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $aabe8846ae41ae5f$var$vertexShaderSrc);
        let fragmentShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $aabe8846ae41ae5f$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $93790adeb8d4d945$export$d879afae78b531a5)(gl, prog);
        let unif_skinTexTransform = gl.getUniformLocation(prog, "skinTexTransform");
        if (!unif_skinTexTransform) throw new Error("Unable to get uniform location skinTexTransform");
        let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
        if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
        this._shader = {
            prog: prog,
            unif_skinTexTransform: unif_skinTexTransform,
            unif_skinSampler: unif_skinSampler,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_texCoord: gl.getAttribLocation(prog, "texCoord")
        };
        return this._shader;
    }
}
let $aabe8846ae41ae5f$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

attribute vec4 position;
attribute vec4 texCoord;
varying vec4 skinTexVarying;
uniform mat4 skinTexTransform;

void main()
{
    gl_Position = position;
    skinTexVarying = skinTexTransform * texCoord;
}`;
let $aabe8846ae41ae5f$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying vec4 skinTexVarying;
uniform lowp sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2DProj(skinSampler, skinTexVarying);
}`;
function $aabe8846ae41ae5f$var$cameraRotationForScreenOrientation() {
    if (window.screen.orientation) switch(window.screen.orientation.type){
        case "portrait-primary":
            return 270;
        case "landscape-secondary":
            return 180;
        case "portrait-secondary":
            return 90;
        default:
            return 0;
    }
    else if (window.orientation !== undefined) switch(window.orientation){
        case 0:
            return 270;
        case 90:
            return 0;
        case 180:
            return 90;
        case -90:
            return 180;
    }
    return 0;
}
function $aabe8846ae41ae5f$export$3da067886124f338(frameWidth, frameHeight, screenWidth, screenHeight, uvMatrix, mirror) {
    let ret = (0, $2e616e7f2b93d8b0$exports).create();
    let trans = (0, $2e616e7f2b93d8b0$exports).create();
    // Translate to centre UV coords
    (0, $2e616e7f2b93d8b0$exports).fromTranslation(trans, [
        -0.5,
        -0.5,
        0
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(ret, trans, ret);
    if (mirror) {
        (0, $2e616e7f2b93d8b0$exports).fromScaling(trans, [
            -1,
            1,
            1
        ]);
        (0, $2e616e7f2b93d8b0$exports).multiply(ret, trans, ret);
    }
    // Apply rotation back into ZCV's landscape space
    (0, $2e616e7f2b93d8b0$exports).fromRotation(trans, -1 * $aabe8846ae41ae5f$var$cameraRotationForScreenOrientation() * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(ret, trans, ret);
    // Get our screenWidth and screenHeight into that same space
    let vec = (0, $b817ce0f5cdadb29$exports).create();
    vec[0] = screenWidth;
    vec[1] = screenHeight;
    vec[2] = 0;
    (0, $b817ce0f5cdadb29$exports).transformMat4(vec, vec, trans);
    let absScreenX = Math.abs(vec[0]);
    let absScreenY = Math.abs(vec[1]);
    // Apply a flip since the texture is upside-down
    (0, $2e616e7f2b93d8b0$exports).fromScaling(trans, [
        1,
        -1,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(ret, trans, ret);
    // Apply cropping
    let screenAspect = absScreenX / absScreenY;
    let frameAspect = frameWidth / frameHeight;
    if (screenAspect > frameAspect) (0, $2e616e7f2b93d8b0$exports).fromScaling(trans, [
        1,
        frameAspect / screenAspect,
        1
    ]);
    else (0, $2e616e7f2b93d8b0$exports).fromScaling(trans, [
        screenAspect / frameAspect,
        1,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(ret, trans, ret);
    // Translate back to UV coords
    (0, $2e616e7f2b93d8b0$exports).fromTranslation(trans, [
        0.5,
        0.5,
        0
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(ret, trans, ret);
    // Apply the camera frame's UV matrix
    (0, $2e616e7f2b93d8b0$exports).multiply(ret, uvMatrix, ret);
    return ret;
}





class $fa190eaedae2f1f6$export$884fb66b30975d12 {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._normalbo) this._gl.deleteBuffer(this._normalbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._normalbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateNormalBO(face, gl) {
        if (!this._normalbo) this._normalbo = gl.createBuffer();
        if (!this._normalbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._normalbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._normalbo;
    }
    drawFace(matrix, o) {
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(o.getVertices(), gl);
        let n = this._generateNormalBO(o.getNormals(), gl);
        let i = this._generateIBO(o.getIndices(), gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, n);
        gl.vertexAttribPointer(shader.attr_normal, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_normal);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, o.getIndices().length, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_normal);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $fa190eaedae2f1f6$var$vertexShaderSrc);
        let fragmentShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $fa190eaedae2f1f6$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $93790adeb8d4d945$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location mattrix");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_normal: gl.getAttribLocation(prog, "normal")
        };
        return this._shader;
    }
}
let $fa190eaedae2f1f6$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
attribute vec4 position;
attribute vec3 normal;
varying highp vec3 vnormal;

void main()
{
    gl_Position = matrix * position;
    vnormal = normal;
}`;
let $fa190eaedae2f1f6$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying vec4 skinTexVarying;
varying highp vec3 vnormal;
uniform lowp sampler2D skinSampler;

void main()
{
    vec3 normal2 = 0.5 * vnormal + 0.5;
    gl_FragColor = vec4(normal2.x , normal2.y, normal2.z, 1.0);
}`;



class $e6e018fe0325b7a1$export$626d5c7c1d8c587c {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._uvbo) this._gl.deleteBuffer(this._uvbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._uvbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateUVBO(face, gl) {
        if (!this._uvbo) this._uvbo = gl.createBuffer();
        if (!this._uvbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._uvbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._uvbo;
    }
    drawFace(matrix, vertices, uvMatrix, uvs, indices, texture) {
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(vertices, gl);
        let u = this._generateUVBO(uvs, gl);
        let i = this._generateIBO(indices, gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        // gl.enable(gl.BLEND);
        // gl.blendFunc(gl.ONE, gl.ONE);
        // gl.blendEquation(gl.FUNC_SUBTRACT);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.uniformMatrix4fv(shader.unif_uvmatrix, false, uvMatrix);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.uniform1i(shader.unif_sampler, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, u);
        gl.vertexAttribPointer(shader.attr_uv, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_uv);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, 6912, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_uv);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $e6e018fe0325b7a1$var$vertexShaderSrc);
        let fragmentShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $e6e018fe0325b7a1$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $93790adeb8d4d945$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location matrix");
        let unif_uvmatrix = gl.getUniformLocation(prog, "uvmatrix");
        if (!unif_uvmatrix) throw new Error("Unable to get uniform location matrix");
        let unif_sampler = gl.getUniformLocation(prog, "uSampler");
        if (!unif_sampler) throw new Error("Unable to get uniform location sampler");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            unif_sampler: unif_sampler,
            unif_uvmatrix: unif_uvmatrix,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_uv: gl.getAttribLocation(prog, "uv"),
            attr_texturecoord: gl.getAttribLocation(prog, "aTextureCoord")
        };
        return this._shader;
    }
}
let $e6e018fe0325b7a1$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
uniform mat4 uvmatrix;
attribute vec4 position;
attribute vec3 normal;
attribute vec3 uv;

// varying highp vec3 vnormal;

varying highp vec2 vTextureCoord;
varying highp float vAlpha;

void main()
{
    gl_Position = matrix * position;
    vec4 ret = uvmatrix * vec4(uv.x, uv.y, uv.z, 1.0);
    ret.x /= ret.w * 2.0;
    ret.y /= ret.w * 2.0;
    ret.x += 0.5;
    ret.y += 0.0;
    vAlpha = 1.0;
    vTextureCoord = ret.xy;
}`;
let $e6e018fe0325b7a1$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
varying highp vec3 vnormal;
varying highp float vAlpha;
uniform lowp sampler2D uSampler;

void main()
{
    // vec3 normal2 = 0.5 * vnormal + 0.5;
    vec4 p = texture2D(uSampler, vTextureCoord);
    p.a = vAlpha;
    gl_FragColor = p; // vec4(normal2.x , normal2.y, normal2.z, 1.0);
}`;






var $aa0232c24471fede$export$b970cf2e1a7b7c7b;
(function(SequenceRecorderPacketType) {
    SequenceRecorderPacketType[SequenceRecorderPacketType["CAMERA_FRAME"] = 0] = "CAMERA_FRAME";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ACCELEROMETER"] = 1] = "ACCELEROMETER";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ROTATION_RATE"] = 2] = "ROTATION_RATE";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ATTITUDE"] = 3] = "ATTITUDE";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ATTITUDE_MATRIX"] = 4] = "ATTITUDE_MATRIX";
})($aa0232c24471fede$export$b970cf2e1a7b7c7b || ($aa0232c24471fede$export$b970cf2e1a7b7c7b = {}));
class $aa0232c24471fede$export$a9d7f366c6e802ee {
    constructor(estimatedFrames){
        this._insertionByte = 0;
        this._numberPackets = 0;
        this._started = false;
        this._hasLoggedUnsuppored = false;
        this._data = new ArrayBuffer(this._estimatedSize(estimatedFrames, 320, 240));
        this._dataView = new DataView(this._data);
        this._dataUint8 = new Uint8Array(this._data);
        this._dataFloat32 = new Float32Array(this._data);
    }
    _estimatedSize(frames, cameraFrameWidth, cameraFrameHeight) {
        return $aa0232c24471fede$export$a9d7f366c6e802ee.headerSizeBytes + ($aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType + $aa0232c24471fede$export$a9d7f366c6e802ee.cameraPacketSizeBytes + cameraFrameWidth * cameraFrameHeight) * frames;
    }
    start() {
        this._started = true;
        this._insertionByte = 0;
        this._numberPackets = 0;
        this._growArrayBuffer($aa0232c24471fede$export$a9d7f366c6e802ee.headerSizeBytes);
        let enc = new TextEncoder();
        let headerData = enc.encode("UAR1");
        this._dataUint8.set(headerData);
        this._dataView.setUint32(4, 0, true);
        this._insertionByte += 8;
    }
    stop() {
        this._started = false;
        let trimmed = this._data.slice(0, this._insertionByte);
        this._data = trimmed;
        this._dataUint8 = new Uint8Array(this._data);
        this._dataFloat32 = new Float32Array(this._data);
        this._dataView = new DataView(this._data);
    }
    data() {
        return this._dataUint8;
    }
    appendCameraFrame(c) {
        if (!this._started) return;
        if (!c.data) {
            if (this._hasLoggedUnsuppored) return;
            this._hasLoggedUnsuppored = true;
            (0, $7c2568b0d857a09d$export$497c45d0bfe56de1)("Unable to record frames from this camera source");
            return;
        }
        if (c.data.byteLength !== c.dataWidth * c.dataHeight) {
            (0, $7c2568b0d857a09d$export$497c45d0bfe56de1)("Unable to record frame to sequence: greyscale array doesn't match dimensions");
            return;
        }
        let increment = $aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType + $aa0232c24471fede$export$a9d7f366c6e802ee.cameraPacketSizeBytes + c.dataWidth * c.dataHeight;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, $aa0232c24471fede$export$b970cf2e1a7b7c7b.CAMERA_FRAME, true);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType;
        this._dataView.setUint32(this._insertionByte, c.dataWidth, true);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraFrameWidth;
        this._dataView.setUint32(this._insertionByte, c.dataHeight, true);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraFrameHeight;
        this._dataFloat32.set(c.cameraToDevice, this._insertionByte / 4);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraToDeviceTransform;
        this._dataFloat32.set(c.cameraModel, this._insertionByte / 4);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraModel;
        this._dataView.setUint32(this._insertionByte, c.userFacing ? 1 : 0, true);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.psbFlags;
        this._dataUint8.set(new Uint8Array(c.data), this._insertionByte);
        this._insertionByte += c.data.byteLength;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    appendAccelerometer(t, x, y, z) {
        this._appendTimestampedVec3($aa0232c24471fede$export$b970cf2e1a7b7c7b.ACCELEROMETER, t, x, y, z);
    }
    appendRotationRate(t, x, y, z) {
        this._appendTimestampedVec3($aa0232c24471fede$export$b970cf2e1a7b7c7b.ROTATION_RATE, t, x, y, z);
    }
    appendAttitude(t, x, y, z) {
        this._appendTimestampedVec3($aa0232c24471fede$export$b970cf2e1a7b7c7b.ATTITUDE, t, x, y, z);
    }
    _appendTimestampedVec3(type, t, x, y, z) {
        if (!this._started) return;
        let increment = $aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType + $aa0232c24471fede$export$a9d7f366c6e802ee.accelerometerPacketSizeBytes;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, type, true);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType;
        this._dataView.setUint32(this._insertionByte, t, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, x, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, y, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, z, true);
        this._insertionByte += 4;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    appendAttitudeMatrix(m) {
        if (!this._started) return;
        let increment = $aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType + $aa0232c24471fede$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, $aa0232c24471fede$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX, true);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType;
        this._dataFloat32.set(m, this._insertionByte / 4);
        this._insertionByte += $aa0232c24471fede$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    _growArrayBuffer(requiredIncrement) {
        while(this._insertionByte + requiredIncrement > this._data.byteLength){
            let newSize = Math.max(this._data.byteLength * 2, this._estimatedSize(50, 320, 240));
            let newData = new ArrayBuffer(newSize);
            let newDataUint8 = new Uint8Array(newData);
            newDataUint8.set(this._dataUint8);
            this._data = newData;
            this._dataUint8 = newDataUint8;
            this._dataFloat32 = new Float32Array(this._data);
            this._dataView = new DataView(this._data);
        }
    }
}
// Header (8 bytes): "UAR1" + number of frames (uint32)
$aa0232c24471fede$export$a9d7f366c6e802ee.headerSizeBytes = 8;
// Per-frame packet byte sizes
$aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType = 4;
// Camera frames
$aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraFrameWidth = 4;
$aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraFrameHeight = 4;
$aa0232c24471fede$export$a9d7f366c6e802ee.psbFlags = 4;
$aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraToDeviceTransform = 64;
$aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraModel = 24;
$aa0232c24471fede$export$a9d7f366c6e802ee.cameraPacketSizeBytes = $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraFrameWidth + $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraFrameHeight + $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraToDeviceTransform + $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraModel + $aa0232c24471fede$export$a9d7f366c6e802ee.psbFlags;
// Accelerometer
$aa0232c24471fede$export$a9d7f366c6e802ee.accelerometerPacketSizeBytes = 16; // t, x, y, z
// Rotation rate
$aa0232c24471fede$export$a9d7f366c6e802ee.rotationRatePacketSizeBytes = 16; // t, x, y, z
// Attitude
$aa0232c24471fede$export$a9d7f366c6e802ee.attitudePacketSizeBytes = 16; // t, x, y, z
// Attitude matrix
$aa0232c24471fede$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes = 64;
class $aa0232c24471fede$export$20801e67610bf5d8 {
    constructor(_data){
        this._data = _data;
        this.dataByPacket = new Map();
        this.dataByCameraFrame = new Map();
        this.numberPackets = 0;
        this.numberCameraFrames = 0;
        this.numberAccelerometerPackets = 0;
        this.numberRotationRatePackets = 0;
        this.numberAttitudePackets = 0;
        this.numberAttitudeMatrixPackets = 0;
        let dec = new TextDecoder();
        let txt = "";
        try {
            txt = dec.decode(this._data.slice(0, 4));
        } catch (err) {
            throw new Error("Unable to decode header - perhaps this isn't a sequence file?");
        }
        if (txt !== "UAR1") throw new Error(`Invalid - perhaps this isn't a sequence file: ${txt}`);
        let readPoint = 0;
        let dataView = new DataView(this._data);
        this.numberPackets = dataView.getUint32(4, true);
        readPoint += $aa0232c24471fede$export$a9d7f366c6e802ee.headerSizeBytes;
        for(let i = 0; i < this.numberPackets; i++){
            let type = dataView.getUint32(readPoint, true);
            readPoint += $aa0232c24471fede$export$a9d7f366c6e802ee.psbPacketType;
            switch(type){
                case $aa0232c24471fede$export$b970cf2e1a7b7c7b.CAMERA_FRAME:
                    {
                        let width = dataView.getUint32(readPoint, true);
                        readPoint += $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraFrameWidth;
                        let height = dataView.getUint32(readPoint, true);
                        readPoint += $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraFrameHeight;
                        let cameraToDevice = new Float32Array(this._data, readPoint, $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraToDeviceTransform / 4);
                        readPoint += $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraToDeviceTransform;
                        let cameraModel = new Float32Array(this._data, readPoint, $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraModel / 4);
                        readPoint += $aa0232c24471fede$export$a9d7f366c6e802ee.psbCameraModel;
                        let flags = dataView.getUint32(readPoint, true);
                        readPoint += $aa0232c24471fede$export$a9d7f366c6e802ee.psbFlags;
                        let userFacing = flags === 1;
                        let greyscale = new Uint8Array(this._data, readPoint, width * height);
                        readPoint += width * height;
                        let d = {
                            type: $aa0232c24471fede$export$b970cf2e1a7b7c7b.CAMERA_FRAME,
                            width: width,
                            height: height,
                            cameraToDevice: cameraToDevice,
                            cameraModel: cameraModel,
                            userFacing: userFacing,
                            greyscale: greyscale
                        };
                        this.dataByPacket.set(i, d);
                        this.dataByCameraFrame.set(this.numberCameraFrames, d);
                        this.numberCameraFrames++;
                        break;
                    }
                case $aa0232c24471fede$export$b970cf2e1a7b7c7b.ACCELEROMETER:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $aa0232c24471fede$export$b970cf2e1a7b7c7b.ACCELEROMETER,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberAccelerometerPackets++;
                        break;
                    }
                case $aa0232c24471fede$export$b970cf2e1a7b7c7b.ROTATION_RATE:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $aa0232c24471fede$export$b970cf2e1a7b7c7b.ROTATION_RATE,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberRotationRatePackets++;
                        break;
                    }
                case $aa0232c24471fede$export$b970cf2e1a7b7c7b.ATTITUDE:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $aa0232c24471fede$export$b970cf2e1a7b7c7b.ATTITUDE,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberAttitudePackets++;
                        break;
                    }
                case $aa0232c24471fede$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX:
                    {
                        let attitude = new Float32Array(this._data, readPoint, $aa0232c24471fede$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes / 4);
                        readPoint += $aa0232c24471fede$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
                        this.dataByPacket.set(i, {
                            type: $aa0232c24471fede$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX,
                            attitude: attitude
                        });
                        this.numberAttitudeMatrixPackets++;
                        break;
                    }
            }
        }
    }
}


var $3e93c4f9b3b7cc91$exports = {};

$parcel$export($3e93c4f9b3b7cc91$exports, "CameraSource", function () { return $3e93c4f9b3b7cc91$export$9a93ce53f488cb2e; });

class $be50c7577dd5f005$export$1d2df86270c81ecb {
}



var $kSiIs = parcelRequire("kSiIs");
var $39bd774a309e57d6$export$59a354bcfe78fe8;
(function(EmbeddedVideoImplementation) {
    EmbeddedVideoImplementation[EmbeddedVideoImplementation["OBJECT_URL"] = 0] = "OBJECT_URL";
    EmbeddedVideoImplementation[EmbeddedVideoImplementation["SRC_OBJECT"] = 1] = "SRC_OBJECT";
})($39bd774a309e57d6$export$59a354bcfe78fe8 || ($39bd774a309e57d6$export$59a354bcfe78fe8 = {}));
let $39bd774a309e57d6$export$4882ae973e0491e = {
    deviceMotionMutliplier: -1,
    blacklisted: false,
    showGyroPermissionsWarningIfNecessary: false,
    showSafariPermissionsResetIfNecessary: false,
    requestHighFrameRate: false,
    videoWidth: 640,
    videoHeight: 480,
    dataWidth: 320,
    dataHeight: 240,
    videoElementInDOM: false,
    preferMediaStreamTrackProcessorCamera: false,
    preferImageBitmapCamera: false,
    ios164CameraSelection: false
};
if (typeof window !== "undefined") {
    window["zeeProfile"] = $39bd774a309e57d6$export$4882ae973e0491e;
    if (window.location.href.indexOf("_mstppipeline") >= 0) {
        console.log("Configuring for MSTP camera pipeline (if supported)");
        $39bd774a309e57d6$export$4882ae973e0491e.preferMediaStreamTrackProcessorCamera = true;
    }
    if (window.location.href.indexOf("_imagebitmappipeline") >= 0) {
        console.log("Configuring for ImageBitmap camera pipeline (if supported)");
        $39bd774a309e57d6$export$4882ae973e0491e.preferImageBitmapCamera = true;
    }
}
let $39bd774a309e57d6$var$agent = new $kSiIs.UAParser();
let $39bd774a309e57d6$var$os = ($39bd774a309e57d6$var$agent.getOS().name || "unknown").toLowerCase();
let $39bd774a309e57d6$var$engine = ($39bd774a309e57d6$var$agent.getEngine().name || "unknown").toLowerCase();
if ($39bd774a309e57d6$var$engine === "webkit" && $39bd774a309e57d6$var$os !== "ios") {
    $39bd774a309e57d6$export$4882ae973e0491e.deviceMotionMutliplier = 1.0;
    if (typeof window !== "undefined" && window.orientation !== undefined) // iPad
    $39bd774a309e57d6$var$iDevice("15.0");
}
if ($39bd774a309e57d6$var$engine === "webkit" && $39bd774a309e57d6$var$os === "ios") {
    $39bd774a309e57d6$export$4882ae973e0491e.deviceMotionMutliplier = 1.0;
    const version = $39bd774a309e57d6$var$agent.getOS().version || "15.0";
    $39bd774a309e57d6$var$iDevice(version);
}
function $39bd774a309e57d6$var$iDevice(version) {
    let versionParts = version.split(".");
    if (versionParts.length >= 2) {
        const majorVersion = parseInt(versionParts[0]);
        const minorVersion = parseInt(versionParts[1]);
        if (majorVersion < 11 || majorVersion === 11 && minorVersion < 3) $39bd774a309e57d6$export$4882ae973e0491e.blacklisted = true;
        if (majorVersion < 12 || majorVersion === 12 && minorVersion < 2) $39bd774a309e57d6$export$4882ae973e0491e.videoElementInDOM = true;
        if (majorVersion === 12 && minorVersion >= 2 || majorVersion >= 13) $39bd774a309e57d6$export$4882ae973e0491e.showGyroPermissionsWarningIfNecessary = true;
        if (majorVersion >= 13) $39bd774a309e57d6$export$4882ae973e0491e.showSafariPermissionsResetIfNecessary = true;
        if ((majorVersion >= 12 && minorVersion > 1 || majorVersion >= 13) && navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().frameRate) {
            $39bd774a309e57d6$export$4882ae973e0491e.requestHighFrameRate = true;
            if (majorVersion < 14) {
                // Avoid bug where iOS letterboxes 16:9 into 4:3 for high fps
                // Doesn't seem needed with newer versions of iOS, tested on 14.8.1 and 15.2
                $39bd774a309e57d6$export$4882ae973e0491e.videoHeight = 360;
                $39bd774a309e57d6$export$4882ae973e0491e.dataHeight = 180;
            }
        }
        if (majorVersion === 16 && minorVersion >= 4 || majorVersion > 16) $39bd774a309e57d6$export$4882ae973e0491e.ios164CameraSelection = true;
    }
}





const $d497099a9dd0a3eb$var$managers = new Map();
class $d497099a9dd0a3eb$export$6d8a7545b2cb2a7e {
    constructor(_gl){
        this._gl = _gl;
        this._viewports = [];
        this._underlyingViewport = this._gl.viewport;
        this._viewports.push(this._gl.getParameter(this._gl.VIEWPORT));
        this._gl.viewport = (x, y, width, height)=>{
            this._viewports[this._viewports.length - 1] = [
                x,
                y,
                width,
                height
            ];
            this._underlyingViewport.call(this._gl, x, y, width, height);
        };
    }
    static get(gl) {
        let existing = $d497099a9dd0a3eb$var$managers.get(gl);
        if (!existing) {
            existing = new $d497099a9dd0a3eb$export$6d8a7545b2cb2a7e(gl);
            $d497099a9dd0a3eb$var$managers.set(gl, existing);
        }
        return existing;
    }
    push() {
        this._viewports.push(this._viewports[this._viewports.length - 1]);
    }
    pop() {
        const current = this._viewports.pop();
        const prev = this._viewports[this._viewports.length - 1];
        if (!current || current[0] !== prev[0] || current[1] !== prev[1] || current[2] !== prev[2] || current[3] !== prev[3]) this._underlyingViewport.call(this._gl, prev[0], prev[1], prev[2], prev[3]);
    }
}




class $a56b00358b836b2e$export$f9b0f8dc7af3bf20 {
    constructor(_gl){
        this._gl = _gl;
        this._isPaused = true;
        this._hadFrames = false;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._isUploadFrame = true;
        this._computedTransformRotation = -1;
        this._computedFrontCameraRotation = false;
        this._cameraUvTransform = (0, $2e616e7f2b93d8b0$exports).create();
        this._framebufferWidth = 0;
        this._framebufferHeight = 0;
        this._framebufferId = null;
        this._renderTexture = null;
        this._isWebGL2 = false;
        this._isWebGL2 = _gl.getParameter(_gl.VERSION).indexOf("WebGL 2") >= 0;
        if (!this._isWebGL2) this._instancedArraysExtension = this._gl.getExtension("ANGLE_instanced_arrays");
    }
    resetGLContext() {
        this._framebufferId = null;
        this._renderTexture = null;
        this._vertexBuffer = undefined;
        this._indexBuffer = undefined;
        this._greyscaleShader = undefined;
    }
    destroy() {
        this.resetGLContext();
    }
    uploadFrame(texture, img, rotation, fc) {
        let gl = this._gl;
        const glStateManager = (0, $d497099a9dd0a3eb$export$6d8a7545b2cb2a7e).get(gl);
        glStateManager.push();
        const reenableScissorTest = gl.isEnabled(gl.SCISSOR_TEST);
        const reenableDepthTest = gl.isEnabled(gl.DEPTH_TEST);
        const reenableBlend = gl.isEnabled(gl.BLEND);
        const reenableCullFace = gl.isEnabled(gl.CULL_FACE);
        const reenableStencilTest = gl.isEnabled(gl.STENCIL_TEST);
        const previousActiveTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
        const previousUnpackFlip = gl.getParameter(gl.UNPACK_FLIP_Y_WEBGL);
        const previousProgram = gl.getParameter(gl.CURRENT_PROGRAM);
        gl.activeTexture(gl.TEXTURE0);
        const previousBoundTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
        const previousBoundFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
        const previousBoundArrayBuffer = gl.getParameter(gl.ARRAY_BUFFER_BINDING);
        const previousBoundElementArrayBuffer = gl.getParameter(gl.ELEMENT_ARRAY_BUFFER_BINDING);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.STENCIL_TEST);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const level = 0;
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, img);
        let videoWidth = 0;
        let videoHeight = 0;
        if (typeof HTMLVideoElement !== "undefined" && img instanceof HTMLVideoElement) {
            videoWidth = img.videoWidth;
            videoHeight = img.videoHeight;
        } else {
            videoWidth = img.width;
            videoHeight = img.height;
        }
        if (videoHeight > videoWidth) videoHeight = [
            videoWidth,
            videoWidth = videoHeight
        ][0];
        this._updateTransforms(rotation, fc);
        let framebuffer = this._getFramebuffer(gl, (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth / 4, (0, $39bd774a309e57d6$export$4882ae973e0491e).dataHeight);
        let vbo = this._getVertexBuffer(gl);
        let ibo = this._getIndexBuffer(gl);
        let shader = this._getGreyscaleShader(gl);
        const previousVertexAttribSize = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_SIZE);
        const previousVertexAttribType = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_TYPE);
        const previousVertexAttribNormalized = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_NORMALIZED);
        const previousVertexAttribStride = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_STRIDE);
        const previousVertexAttribOffset = gl.getVertexAttribOffset(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_POINTER);
        const previousVertexAttribEnabled = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
        const previousVertexAttribBufferBinding = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING);
        const previousTextureAttribSize = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_SIZE);
        const previousTextureAttribType = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_TYPE);
        const previousTextureAttribNormalized = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_NORMALIZED);
        const previousTextureAttribStride = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_STRIDE);
        const previousTextureAttribOffset = gl.getVertexAttribOffset(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_POINTER);
        const previousTextureAttribBufferBinding = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING);
        const previousTextureAttribEnabled = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
        let previousVertexAttribDivisor = 0;
        let previousTextureAttribDivisor = 0;
        if (this._isWebGL2) {
            previousVertexAttribDivisor = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_DIVISOR);
            previousTextureAttribDivisor = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_DIVISOR);
            gl.vertexAttribDivisor(shader.aVertexPositionLoc, 0);
            gl.vertexAttribDivisor(shader.aTextureCoordLoc, 0);
        } else if (this._instancedArraysExtension) {
            previousVertexAttribDivisor = gl.getVertexAttrib(shader.aVertexPositionLoc, this._instancedArraysExtension.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
            previousTextureAttribDivisor = gl.getVertexAttrib(shader.aTextureCoordLoc, this._instancedArraysExtension.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aVertexPositionLoc, 0);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aTextureCoordLoc, 0);
        }
        // Rendering to the greyscale conversion buffer - bind the framebuffer
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.viewport(0, 0, this._framebufferWidth, this._framebufferHeight);
        // We'll be replacing all the content - clear is a good hint for this on mobile
        gl.clear(gl.COLOR_BUFFER_BIT);
        // Set up bindings for vertex attributes
        gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
        gl.vertexAttribPointer(shader.aVertexPositionLoc, 2, gl.FLOAT, false, 16, 0);
        gl.enableVertexAttribArray(shader.aVertexPositionLoc);
        gl.vertexAttribPointer(shader.aTextureCoordLoc, 2, gl.FLOAT, false, 16, 8);
        gl.enableVertexAttribArray(shader.aTextureCoordLoc);
        // Bind the index buffer
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ibo);
        // Tell WebGL to use our program when drawing
        gl.useProgram(shader.program);
        // Specify greyscale width for the correct offsets, and the uv transform
        gl.uniform1f(shader.uTexWidthLoc, (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth);
        gl.uniformMatrix4fv(shader.uUvTransformLoc, false, this._cameraUvTransform);
        gl.activeTexture(gl.TEXTURE0);
        // Bind the texture to texture unit 0
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // Tell the shader we bound the texture to texture unit 0
        gl.uniform1i(shader.uSamplerLoc, 0);
        // Do the drawing...
        gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousVertexAttribBufferBinding);
        gl.vertexAttribPointer(shader.aVertexPositionLoc, previousVertexAttribSize, previousVertexAttribType, previousVertexAttribNormalized, previousVertexAttribStride, previousVertexAttribOffset);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousTextureAttribBufferBinding);
        gl.vertexAttribPointer(shader.aTextureCoordLoc, previousTextureAttribSize, previousTextureAttribType, previousTextureAttribNormalized, previousTextureAttribStride, previousTextureAttribOffset);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousBoundArrayBuffer);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, previousBoundElementArrayBuffer);
        if (!previousVertexAttribEnabled) gl.disableVertexAttribArray(shader.aVertexPositionLoc);
        if (!previousTextureAttribEnabled) gl.disableVertexAttribArray(shader.aTextureCoordLoc);
        if (this._isWebGL2) {
            gl.vertexAttribDivisor(shader.aVertexPositionLoc, previousVertexAttribDivisor);
            gl.vertexAttribDivisor(shader.aTextureCoordLoc, previousTextureAttribDivisor);
        } else if (this._instancedArraysExtension) {
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aVertexPositionLoc, previousVertexAttribDivisor);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aTextureCoordLoc, previousTextureAttribDivisor);
        }
        gl.bindFramebuffer(gl.FRAMEBUFFER, previousBoundFramebuffer);
        gl.useProgram(previousProgram);
        gl.bindTexture(gl.TEXTURE_2D, previousBoundTexture);
        gl.activeTexture(previousActiveTexture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, previousUnpackFlip);
        glStateManager.pop();
        if (reenableBlend) gl.enable(gl.BLEND);
        if (reenableCullFace) gl.enable(gl.CULL_FACE);
        if (reenableDepthTest) gl.enable(gl.DEPTH_TEST);
        if (reenableScissorTest) gl.enable(gl.SCISSOR_TEST);
        if (reenableStencilTest) gl.enable(gl.STENCIL_TEST);
    }
    readFrame(texture, pixels) {
        let gl = this._gl;
        let pixelsView = new Uint8Array(pixels);
        const previousBoundFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
        let framebuffer = this._getFramebuffer(gl, (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth / 4, (0, $39bd774a309e57d6$export$4882ae973e0491e).dataHeight);
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.readPixels(0, 0, this._framebufferWidth, this._framebufferHeight, gl.RGBA, gl.UNSIGNED_BYTE, pixelsView);
        gl.bindFramebuffer(gl.FRAMEBUFFER, previousBoundFramebuffer);
        return {
            uvTransform: this._cameraUvTransform,
            data: pixels,
            texture: texture,
            dataWidth: (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth,
            dataHeight: (0, $39bd774a309e57d6$export$4882ae973e0491e).dataHeight,
            userFacing: this._computedFrontCameraRotation
        };
    }
    _updateTransforms(rot, fc) {
        if (rot == this._computedTransformRotation && fc == this._computedFrontCameraRotation) return;
        this._computedTransformRotation = rot;
        this._computedFrontCameraRotation = fc;
        this._cameraUvTransform = this._getCameraUvTransform();
    }
    _getCameraUvTransform() {
        switch(this._computedTransformRotation){
            case 270:
                return new Float32Array([
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    1
                ]);
            case 180:
                return new Float32Array([
                    -1,
                    0,
                    0,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1
                ]);
            case 90:
                return new Float32Array([
                    0,
                    -1,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    1,
                    0,
                    1
                ]);
        }
        return new Float32Array([
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    _getFramebuffer(gl, fbWidth, fbHeight) {
        if (this._framebufferWidth === fbWidth && this._framebufferHeight === fbHeight && this._framebufferId) return this._framebufferId;
        if (this._framebufferId) {
            gl.deleteFramebuffer(this._framebufferId);
            this._framebufferId = null;
        }
        if (this._renderTexture) {
            gl.deleteTexture(this._renderTexture);
            this._renderTexture = null;
        }
        this._framebufferId = gl.createFramebuffer();
        if (!this._framebufferId) throw new Error("Unable to create framebuffer");
        gl.bindFramebuffer(gl.FRAMEBUFFER, this._framebufferId);
        this._renderTexture = gl.createTexture();
        if (!this._renderTexture) throw new Error("Unable to create render texture");
        gl.activeTexture(gl.TEXTURE0);
        const previousBoundTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
        gl.bindTexture(gl.TEXTURE_2D, this._renderTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, fbWidth, fbHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this._renderTexture, 0);
        let fbStatus = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
        if (fbStatus !== gl.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer not complete: " + fbStatus.toString());
        this._framebufferWidth = fbWidth;
        this._framebufferHeight = fbHeight;
        gl.bindTexture(gl.TEXTURE_2D, previousBoundTexture);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        return this._framebufferId;
    }
    _getVertexBuffer(gl) {
        if (this._vertexBuffer) return this._vertexBuffer;
        this._vertexBuffer = gl.createBuffer();
        if (!this._vertexBuffer) throw new Error("Unable to create vertex buffer");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vertexBuffer);
        let buffer = new Float32Array([
            -1,
            -1,
            0.0,
            0.0,
            -1,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            -1,
            1.0,
            0.0
        ]);
        gl.bufferData(gl.ARRAY_BUFFER, buffer, gl.STATIC_DRAW);
        return this._vertexBuffer;
    }
    _getIndexBuffer(gl) {
        if (this._indexBuffer) return this._indexBuffer;
        this._indexBuffer = gl.createBuffer();
        if (!this._indexBuffer) throw new Error("Unable to create index buffer");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._indexBuffer);
        let buffer = new Uint16Array([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, buffer, gl.STATIC_DRAW);
        return this._indexBuffer;
    }
    _getGreyscaleShader(gl) {
        if (this._greyscaleShader) return this._greyscaleShader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $a56b00358b836b2e$var$greyscaleVsSource);
        let fragmentShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $a56b00358b836b2e$var$greyscaleFsSource);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $93790adeb8d4d945$export$d879afae78b531a5)(gl, prog);
        let uTexWidthLoc = gl.getUniformLocation(prog, "uTexWidth");
        if (!uTexWidthLoc) throw new Error("Unable to get uniform location uTexWidth");
        let uUvTransformLoc = gl.getUniformLocation(prog, "uUvTransform");
        if (!uUvTransformLoc) throw new Error("Unable to get uniform location uUvTransform");
        let uSamplerLoc = gl.getUniformLocation(prog, "uSampler");
        if (!uSamplerLoc) throw new Error("Unable to get uniform location uSampler");
        this._greyscaleShader = {
            program: prog,
            aVertexPositionLoc: gl.getAttribLocation(prog, "aVertexPosition"),
            aTextureCoordLoc: gl.getAttribLocation(prog, "aTextureCoord"),
            uTexWidthLoc: uTexWidthLoc,
            uUvTransformLoc: uUvTransformLoc,
            uSamplerLoc: uSamplerLoc
        };
        return this._greyscaleShader;
    }
}
let $a56b00358b836b2e$var$greyscaleVsSource = `
    attribute vec4 aVertexPosition;
    attribute vec2 aTextureCoord;

    varying highp vec2 vTextureCoord1;
    varying highp vec2 vTextureCoord2;
    varying highp vec2 vTextureCoord3;
    varying highp vec2 vTextureCoord4;

    uniform float uTexWidth;
	uniform mat4 uUvTransform;

    void main(void) {
      highp vec2 offset1 = vec2(1.5 / uTexWidth, 0);
      highp vec2 offset2 = vec2(0.5 / uTexWidth, 0);

      gl_Position = aVertexPosition;
      vTextureCoord1 = (uUvTransform * vec4(aTextureCoord - offset1, 0, 1)).xy;
      vTextureCoord2 = (uUvTransform * vec4(aTextureCoord - offset2, 0, 1)).xy;
      vTextureCoord3 = (uUvTransform * vec4(aTextureCoord + offset2, 0, 1)).xy;
      vTextureCoord4 = (uUvTransform * vec4(aTextureCoord + offset1, 0, 1)).xy;
    }
`;
// Fragment shader program
let $a56b00358b836b2e$var$greyscaleFsSource = `
  varying highp vec2 vTextureCoord1;
  varying highp vec2 vTextureCoord2;
  varying highp vec2 vTextureCoord3;
  varying highp vec2 vTextureCoord4;

  uniform sampler2D uSampler;

  const lowp vec3 colorWeights = vec3(77.0 / 256.0, 150.0 / 256.0, 29.0 / 256.0);

  void main(void) {
    lowp vec4 outpx;

    outpx.r = dot(colorWeights, texture2D(uSampler, vTextureCoord1).xyz);
    outpx.g = dot(colorWeights, texture2D(uSampler, vTextureCoord2).xyz);
    outpx.b = dot(colorWeights, texture2D(uSampler, vTextureCoord3).xyz);
    outpx.a = dot(colorWeights, texture2D(uSampler, vTextureCoord4).xyz);

    gl_FragColor = outpx;
  }
`;


let $8d04bf3660676376$var$latest = 1;
let $8d04bf3660676376$var$byId = new Map();
class $8d04bf3660676376$export$bbfb48c500076b66 extends (0, $be50c7577dd5f005$export$1d2df86270c81ecb) {
    constructor(_video, _pipeline){
        super();
        this._video = _video;
        this._pipeline = _pipeline;
        this._isPaused = true;
        this._hadFrames = false;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._isUploadFrame = true;
        this._cameraToDeviceTransform = (0, $2e616e7f2b93d8b0$exports).create();
        this._cameraToDeviceTransformUserFacing = (0, $2e616e7f2b93d8b0$exports).create();
        this._cameraModel = new Float32Array([
            300,
            300,
            160,
            120,
            0,
            0
        ]);
        (0, $2e616e7f2b93d8b0$exports).fromScaling(this._cameraToDeviceTransformUserFacing, [
            -1,
            1,
            -1
        ]);
        let video = this._video;
        if (this._video instanceof HTMLVideoElement) video.addEventListener("loadedmetadata", ()=>{
            this._hadFrames = true;
        });
        else this._hadFrames = true;
        this._resetGLContext = this._resetGLContext.bind(this);
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p) p.onGLContextReset.bind(this._resetGLContext);
    }
    static createVideoElementSource(p, element) {
        let ret = $8d04bf3660676376$var$latest++;
        $8d04bf3660676376$var$byId.set(ret, new $8d04bf3660676376$export$bbfb48c500076b66(element, p));
        (0, $7c2568b0d857a09d$export$454156e929b28fe7)("html_element_source_t initialized");
        return ret;
    }
    static getVideoElementSource(m) {
        return $8d04bf3660676376$var$byId.get(m);
    }
    _resetGLContext() {
        var _a, _b;
        this._currentVideoTexture = undefined;
        (_b = (_a = this._imageProcessor) === null || _a === void 0 ? void 0 : _a.resetGLContext) === null || _b === void 0 || _b.call(_a);
    }
    destroy() {
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p) p.onGLContextReset.unbind(this._resetGLContext);
        this.pause();
        this._resetGLContext();
    }
    pause() {
        this._isPaused = true;
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
    }
    start() {
        var _a;
        if (this._isPaused) {
            this._isUploadFrame = true;
            if (this._video instanceof HTMLVideoElement) this._hadFrames = false;
        }
        this._isPaused = false;
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
    }
    getFrame(currentlyProcessing) {
        let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let gl = pipeline.glContext;
        if (!gl) return;
        if (this._isPaused) return;
        if (!this._hadFrames) return;
        try {
            let info = this._processFrame(gl, this._cameraToScreenRotation, currentlyProcessing);
            if (info) {
                let token = pipeline.registerToken(info);
                pipeline.sendDataToWorker(info.data || new ArrayBuffer(0), token, info.dataWidth, info.dataHeight, info.userFacing, info.cameraToDevice, info.cameraModel);
            }
        } catch (ex) {
            console.log("Unable to process frame");
        }
        return;
    }
    _processFrame(gl, rotation, currentlyProcessing) {
        let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return undefined;
        if (!this._imageProcessor) this._imageProcessor = new (0, $a56b00358b836b2e$export$f9b0f8dc7af3bf20)(gl);
        if (this._isUploadFrame) {
            if (!this._currentVideoTexture) this._currentVideoTexture = pipeline.getVideoTexture();
            if (!this._currentVideoTexture) return undefined;
            this._imageProcessor.uploadFrame(this._currentVideoTexture, this._video, rotation, this._isUserFacing);
            this._isUploadFrame = !this._isUploadFrame;
            return undefined;
        }
        if (currentlyProcessing || !this._currentVideoTexture) return undefined;
        this._isUploadFrame = !this._isUploadFrame;
        let greySize = (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth * (0, $39bd774a309e57d6$export$4882ae973e0491e).dataHeight;
        let pixels = pipeline.cameraPixelArrays.pop();
        while(pixels){
            if (pixels.byteLength === greySize) break;
            pixels = pipeline.cameraPixelArrays.pop();
        }
        if (!pixels) pixels = new ArrayBuffer(greySize);
        let tex = this._currentVideoTexture;
        this._currentVideoTexture = undefined;
        let focalLength = 300.0 * (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth / 320.0;
        this._cameraModel[0] = focalLength;
        this._cameraModel[1] = focalLength;
        this._cameraModel[2] = (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth * 0.5;
        this._cameraModel[3] = (0, $39bd774a309e57d6$export$4882ae973e0491e).dataHeight * 0.5;
        return Object.assign(Object.assign({}, this._imageProcessor.readFrame(tex, pixels)), {
            cameraModel: this._cameraModel,
            cameraSource: this,
            cameraToDevice: this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform
        });
    }
    uploadGL() {
    // No-op as already uploaded
    }
}







var $3e93c4f9b3b7cc91$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $3e93c4f9b3b7cc91$var$_videoSingleton = document.createElement("video");
$3e93c4f9b3b7cc91$var$_videoSingleton.setAttribute("playsinline", "");
$3e93c4f9b3b7cc91$var$_videoSingleton.setAttribute("webkit-playsinline", "");
if ((0, $39bd774a309e57d6$export$4882ae973e0491e).videoElementInDOM) {
    $3e93c4f9b3b7cc91$var$_videoSingleton.style.width = "0px";
    $3e93c4f9b3b7cc91$var$_videoSingleton.style.height = "0px";
    document.body.appendChild($3e93c4f9b3b7cc91$var$_videoSingleton);
}
class $3e93c4f9b3b7cc91$export$9a93ce53f488cb2e extends (0, $8d04bf3660676376$export$bbfb48c500076b66) {
    constructor(_impl, pipeline, _deviceId){
        super($3e93c4f9b3b7cc91$var$_videoSingleton, pipeline);
        this._impl = _impl;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
    }
    destroy() {
        (0, $89fa42ee9de7dcc1$export$55d101622faac174)(this._impl);
        super.destroy();
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        super.pause();
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        super.start();
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $3e93c4f9b3b7cc91$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $3e93c4f9b3b7cc91$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID && this._deviceId !== $3e93c4f9b3b7cc91$export$9a93ce53f488cb2e.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else {
                facingMode = this._deviceId === $3e93c4f9b3b7cc91$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID ? "environment" : "user";
                if ((0, $39bd774a309e57d6$export$4882ae973e0491e).ios164CameraSelection) {
                    if (!this._explicitEnvironmentCameraId || !this._explicitUserCameraId) {
                        const stream = yield navigator.mediaDevices.getUserMedia({
                            audio: false,
                            video: {
                                facingMode: facingMode
                            }
                        });
                        let tracks = stream.getTracks();
                        tracks.forEach((t)=>t.stop());
                        let devices = yield navigator.mediaDevices.enumerateDevices();
                        devices = devices.filter((val)=>val.kind === "videoinput");
                        if (devices.length >= 2) {
                            this._explicitUserCameraId = devices[0].deviceId;
                            this._explicitEnvironmentCameraId = devices[1].deviceId;
                        }
                    }
                    deviceId = facingMode === "environment" ? this._explicitEnvironmentCameraId : this._explicitUserCameraId;
                }
            }
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $39bd774a309e57d6$export$4882ae973e0491e).videoWidth,
                    height: (0, $39bd774a309e57d6$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $39bd774a309e57d6$export$4882ae973e0491e).requestHighFrameRate ? 60 : undefined,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $7c2568b0d857a09d$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(allowRead) {
        this._cameraToScreenRotation = (0, $ca0d9f3de8343ab7$export$83fad53f837eba8e)(false);
        super.getFrame(allowRead);
    }
    _getUserMedia() {
        return $3e93c4f9b3b7cc91$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $3e93c4f9b3b7cc91$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                }
                if (!(this._video instanceof HTMLVideoElement)) return;
                this._video.src = "";
                this._video.loop = false;
                this._video.muted = true;
                this._video.srcObject = this._currentStream;
                this._video.play();
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        this._deviceOrientationListener = (ev)=>{
            let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        };
        window.addEventListener("deviceorientation", this._deviceOrientationListener);
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
        if (this._deviceOrientationListener) window.removeEventListener("deviceorientation", this._deviceOrientationListener);
    }
}
$3e93c4f9b3b7cc91$export$9a93ce53f488cb2e.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$3e93c4f9b3b7cc91$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";


var $da80d4579a61be88$exports = {};

$parcel$export($da80d4579a61be88$exports, "ImageBitmapCameraSource", function () { return $da80d4579a61be88$export$26291a750254acd7; });







var $da80d4579a61be88$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $da80d4579a61be88$export$26291a750254acd7 extends (0, $be50c7577dd5f005$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline, _deviceId){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._isPaused = true;
        this._isUserFacing = false;
        this._hadFrames = false;
        this._canvas = new OffscreenCanvas(640, 480);
        this._context = this._canvas.getContext("2d");
        this._lastFrameTime = -1;
        this._video = document.createElement("video");
        this._cameraToDeviceTransform = (0, $2e616e7f2b93d8b0$exports).create();
        this._cameraToDeviceTransformUserFacing = (0, $2e616e7f2b93d8b0$exports).create();
        this._cameraModel = new Float32Array([
            300,
            300,
            160,
            120,
            0,
            0
        ]);
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
        (0, $7c2568b0d857a09d$export$454156e929b28fe7)("Using ImageBitmap camera source");
        (0, $2e616e7f2b93d8b0$exports).fromScaling(this._cameraToDeviceTransformUserFacing, [
            -1,
            1,
            -1
        ]);
        this._video.muted = true;
        this._video.setAttribute("playsinline", "");
        this._video.setAttribute("webkit-playsinline", "");
        if ((0, $39bd774a309e57d6$export$4882ae973e0491e).videoElementInDOM) {
            this._video.style.width = "0px";
            this._video.style.height = "0px";
            document.body.appendChild(this._video);
        }
        this._video.addEventListener("loadedmetadata", ()=>{
            this._hadFrames = true;
        });
    }
    destroy() {
        this.pause();
        (0, $89fa42ee9de7dcc1$export$55d101622faac174)(this._impl);
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        this._isPaused = true;
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        var _a;
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
        this._isPaused = false;
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $da80d4579a61be88$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $da80d4579a61be88$export$26291a750254acd7.DEFAULT_DEVICE_ID && this._deviceId !== $da80d4579a61be88$export$26291a750254acd7.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else facingMode = this._deviceId === $da80d4579a61be88$export$26291a750254acd7.DEFAULT_DEVICE_ID ? "environment" : "user";
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $39bd774a309e57d6$export$4882ae973e0491e).videoWidth,
                    height: (0, $39bd774a309e57d6$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $39bd774a309e57d6$export$4882ae973e0491e).requestHighFrameRate ? 60 : undefined,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $7c2568b0d857a09d$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(currentlyProcessing) {
        var _a, _b;
        if (!this._context) return;
        if (!this._hadFrames) return;
        if (currentlyProcessing) return;
        let currentTime = performance.now();
        if (currentTime < this._lastFrameTime + 25) return;
        this._lastFrameTime = currentTime;
        if (this._canvas.width !== this._video.videoWidth) this._canvas.width = this._video.videoWidth;
        if (this._canvas.height !== this._video.videoHeight) this._canvas.height = this._video.videoHeight;
        this._context.drawImage(this._video, 0, 0);
        const imageBitmap = this._canvas.transferToImageBitmap();
        let rotation = (0, $ca0d9f3de8343ab7$export$83fad53f837eba8e)(false);
        let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let focalLength = 300.0 * (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth / 320.0;
        this._cameraModel[0] = focalLength;
        this._cameraModel[1] = focalLength;
        this._cameraModel[2] = (0, $39bd774a309e57d6$export$4882ae973e0491e).dataWidth * 0.5;
        this._cameraModel[3] = (0, $39bd774a309e57d6$export$4882ae973e0491e).dataHeight * 0.5;
        let token = pipeline.registerToken({
            dataWidth: this._canvas.width,
            dataHeight: this._canvas.height,
            texture: undefined,
            userFacing: this._isUserFacing,
            cameraSource: this,
            cameraModel: this._cameraModel.slice(),
            cameraToDevice: this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform
        });
        (_b = (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline)) === null || _a === void 0 ? void 0 : _a.sendImageBitmapToWorker) === null || _b === void 0 || _b.call(_a, imageBitmap, rotation, this._isUserFacing, token, this._cameraModel, this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform);
        return;
    }
    _getUserMedia() {
        return $da80d4579a61be88$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $da80d4579a61be88$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                }
                this._video.src = "";
                this._video.loop = false;
                this._video.muted = true;
                this._video.srcObject = this._currentStream;
                this._video.play();
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        window.addEventListener("deviceorientation", (ev)=>{
            let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        });
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
    }
    uploadGL(info) {
        const pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        const gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!info || info.texture || !info.frame || !pipeline || !gl) return;
        let texture = pipeline.getVideoTexture();
        if (!texture) return;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, info.frame);
        gl.bindTexture(gl.TEXTURE_2D, null);
        info.texture = texture;
        info.frame.close();
        delete info.frame;
    }
}
$da80d4579a61be88$export$26291a750254acd7.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$da80d4579a61be88$export$26291a750254acd7.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";



var $28cf100213194c4c$exports = {};

$parcel$export($28cf100213194c4c$exports, "MSTPCameraSource", function () { return $28cf100213194c4c$export$e29bc47e63d4ca88; });






var $28cf100213194c4c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $28cf100213194c4c$export$e29bc47e63d4ca88 extends (0, $be50c7577dd5f005$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline, _deviceId){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._isPaused = true;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $39bd774a309e57d6$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
        (0, $7c2568b0d857a09d$export$454156e929b28fe7)("Using MSTP camera source");
    }
    destroy() {
        this.pause();
        (0, $89fa42ee9de7dcc1$export$55d101622faac174)(this._impl);
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        this._isPaused = true;
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        var _a;
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
        this._isPaused = false;
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $28cf100213194c4c$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $28cf100213194c4c$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID && this._deviceId !== $28cf100213194c4c$export$e29bc47e63d4ca88.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else facingMode = this._deviceId === $28cf100213194c4c$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID ? "environment" : "user";
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $39bd774a309e57d6$export$4882ae973e0491e).videoWidth,
                    height: (0, $39bd774a309e57d6$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $39bd774a309e57d6$export$4882ae973e0491e).requestHighFrameRate ? 60 : 30,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $7c2568b0d857a09d$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(allowRead) {
        var _a, _b;
        let rotation = (0, $ca0d9f3de8343ab7$export$83fad53f837eba8e)(false);
        if (rotation != this._cameraToScreenRotation) {
            (_b = (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline)) === null || _a === void 0 ? void 0 : _a.sendCameraToScreenRotationToWorker) === null || _b === void 0 || _b.call(_a, rotation);
            this._cameraToScreenRotation = rotation;
        }
        return;
    }
    _getUserMedia() {
        return $28cf100213194c4c$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $28cf100213194c4c$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) {
                        this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                        let processor = new MediaStreamTrackProcessor({
                            track: videoTracks[0]
                        });
                        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
                        if (p) p.sendCameraStreamToWorker(this._impl, processor.readable, this._isUserFacing);
                    }
                }
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        window.addEventListener("deviceorientation", (ev)=>{
            let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        });
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
    }
    uploadGL(info) {
        const pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        const gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!info || info.texture || !info.frame || !pipeline || !gl) return;
        let texture = pipeline.getVideoTexture();
        if (!texture) return;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, info.frame);
        gl.bindTexture(gl.TEXTURE_2D, null);
        info.texture = texture;
        info.frame.close();
        delete info.frame;
    }
}
$28cf100213194c4c$export$e29bc47e63d4ca88.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$28cf100213194c4c$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";



let $89fa42ee9de7dcc1$var$latest = 1;
let $89fa42ee9de7dcc1$var$byId = new Map();
function $89fa42ee9de7dcc1$export$1c7b58c7f8b1da4() {
    return $89fa42ee9de7dcc1$var$latest++;
}
function $89fa42ee9de7dcc1$export$9c2853b8b7906172(id, c) {
    $89fa42ee9de7dcc1$var$byId.set(id, c);
}
function $89fa42ee9de7dcc1$export$cf42922f9ae76ed1(id) {
    return $89fa42ee9de7dcc1$var$byId.get(id);
}
function $89fa42ee9de7dcc1$export$55d101622faac174(id) {
    $89fa42ee9de7dcc1$var$byId.delete(id);
}
function $89fa42ee9de7dcc1$export$3612a413b5e57058(p, deviceId) {
    let ret = $89fa42ee9de7dcc1$export$1c7b58c7f8b1da4();
    if ((0, $39bd774a309e57d6$export$4882ae973e0491e).preferMediaStreamTrackProcessorCamera && "MediaStreamTrackProcessor" in window && "MediaStreamTrackGenerator" in window) $89fa42ee9de7dcc1$export$9c2853b8b7906172(ret, new (0, $28cf100213194c4c$exports.MSTPCameraSource)(ret, p, deviceId));
    else if ((0, $39bd774a309e57d6$export$4882ae973e0491e).preferImageBitmapCamera && typeof OffscreenCanvas !== "undefined") $89fa42ee9de7dcc1$export$9c2853b8b7906172(ret, new (0, $da80d4579a61be88$exports.ImageBitmapCameraSource)(ret, p, deviceId));
    else $89fa42ee9de7dcc1$export$9c2853b8b7906172(ret, new (0, $3e93c4f9b3b7cc91$exports.CameraSource)(ret, p, deviceId));
    (0, $7c2568b0d857a09d$export$454156e929b28fe7)("camera_source_t initialized");
    return ret;
}



class $8041d977647cb086$export$2a06d804567c3ad8 {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._uvbo) this._gl.deleteBuffer(this._uvbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._uvbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateUVBO(face, gl) {
        if (!this._uvbo) this._uvbo = gl.createBuffer();
        if (!this._uvbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._uvbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._uvbo;
    }
    draw(matrix, tracker, indx) {
        var _a;
        const o = tracker.getPreviewMesh(indx);
        const image = (_a = tracker.getTargetInfo(indx).preview) === null || _a === void 0 ? void 0 : _a.image;
        if (!o || !image) return;
        if (!image.complete) return;
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(o.vertices, gl);
        let n = this._generateUVBO(o.uvs, gl);
        let i = this._generateIBO(o.indices, gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, $8041d977647cb086$var$loadTexture(gl, image));
        gl.uniform1i(shader.unif_skinSampler, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, n);
        gl.vertexAttribPointer(shader.attr_textureCoord, 2, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(shader.attr_textureCoord);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, o.indices.length, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_textureCoord);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $8041d977647cb086$var$vertexShaderSrc);
        let fragmentShader = (0, $93790adeb8d4d945$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $8041d977647cb086$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $93790adeb8d4d945$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location mattrix");
        let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
        if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            unif_skinSampler: unif_skinSampler,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_textureCoord: gl.getAttribLocation(prog, "textureCoord")
        };
        return this._shader;
    }
}
const $8041d977647cb086$var$texturesByElement = new Map();
function $8041d977647cb086$var$loadTexture(gl, elm) {
    let existing = $8041d977647cb086$var$texturesByElement.get(elm);
    if (existing) return existing;
    existing = gl.createTexture() || undefined;
    if (!existing) throw new Error("Unable to create texture");
    $8041d977647cb086$var$texturesByElement.set(elm, existing);
    gl.bindTexture(gl.TEXTURE_2D, existing);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    // Because images have to be download over the internet
    // they might take a moment until they are ready.
    // Until then put a single pixel in the texture so we can
    // use it immediately. When the image has finished downloading
    // we'll update the texture with the contents of the image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, elm);
    elm.addEventListener("load", ()=>{
        if (!existing) return;
        gl.bindTexture(gl.TEXTURE_2D, existing);
        const level = 0;
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, elm);
    });
    return existing;
}
let $8041d977647cb086$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
attribute vec4 position;
attribute vec2 textureCoord;

varying highp vec2 vTextureCoord;

void main()
{
    gl_Position = matrix * position;
    vTextureCoord = textureCoord;
}`;
let $8041d977647cb086$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
uniform sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2D(skinSampler, vTextureCoord);
}`;


let $f8ed8326d2f24395$var$byId = new Map();
let $f8ed8326d2f24395$var$identity = (0, $2e616e7f2b93d8b0$exports).create();
class $f8ed8326d2f24395$export$abd47b564b6c9ce2 {
    constructor(_client, _impl, _mgr){
        this._client = _client;
        this._impl = _impl;
        this._mgr = _mgr;
        this.pendingMessages = [];
        this.cameraTokens = new Map();
        this.nextCameraToken = 1;
        this.tokensInFlight = 0;
        this.videoTextures = [];
        this.cameraPixelArrays = [];
        this._sequenceRecordDeviceAttitudeMatrices = true;
        this._sequenceRecorderFirstCameraToken = 0;
        this.onGLContextReset = new (0, $5fcf243e09e57ed4$export$d61e24a684f9e51)();
    }
    static create(client, mgr) {
        let ret = client.pipeline_create();
        $f8ed8326d2f24395$var$byId.set(ret, new $f8ed8326d2f24395$export$abd47b564b6c9ce2(client, ret, mgr));
        return ret;
    }
    static get(p) {
        return $f8ed8326d2f24395$var$byId.get(p);
    }
    frameUpdate(client) {
        for (let msg of this.pendingMessages){
            client.processMessages(msg);
            this._mgr.postOutgoingMessage({
                t: "buf",
                p: this._impl,
                d: msg
            }, [
                msg
            ]);
        }
        this.pendingMessages = [];
        this.cleanOldFrames();
    }
    cleanOldFrames() {
        var _a, _b;
        let currentToken = this._client.pipeline_camera_frame_user_data(this._impl);
        if (!currentToken) return;
        for (let t of this.cameraTokens)if (t[0] < currentToken) {
            if (t[1].texture) this.videoTextures.push(t[1].texture);
            (_b = (_a = t[1].frame) === null || _a === void 0 ? void 0 : _a.close) === null || _b === void 0 || _b.call(_a);
            this.cameraTokens.delete(t[0]);
        }
    }
    cameraTokenReturn(msg) {
        if (this._sequenceRecorder && this._sequenceRecordDeviceAttitudeMatrices && msg.token >= this._sequenceRecorderFirstCameraToken) {
            let info = this.cameraTokens.get(msg.token);
            if (info) {
                if (msg.att) this._sequenceRecorder.appendAttitudeMatrix(msg.att);
                info.data = msg.d;
                this._sequenceRecorder.appendCameraFrame(info);
            }
        }
        this.cameraPixelArrays.push(msg.d);
        this.tokensInFlight--;
    }
    sequenceRecordStart(expectedFrames) {
        if (!this._sequenceRecorder) this._sequenceRecorder = new (0, $aa0232c24471fede$export$a9d7f366c6e802ee)(expectedFrames);
        this._sequenceRecorder.start();
        this._sequenceRecorderFirstCameraToken = this.nextCameraToken;
    }
    sequenceRecordStop() {
        var _a;
        (_a = this._sequenceRecorder) === null || _a === void 0 || _a.stop();
    }
    sequenceRecordData() {
        var _a;
        return ((_a = this._sequenceRecorder) === null || _a === void 0 ? void 0 : _a.data()) || new Uint8Array(0);
    }
    sequenceRecordClear() {
        delete this._sequenceRecorder;
    }
    sequenceRecordDeviceAttitudeMatrices(v) {
        this._sequenceRecordDeviceAttitudeMatrices = v;
    }
    getVideoTexture() {
        return this.videoTextures.pop();
    }
    destroy() {
        this._client.pipeline_destroy(this._impl);
        $f8ed8326d2f24395$var$byId.delete(this._impl);
    }
    getCurrentCameraInfo() {
        let currentToken = this._client.pipeline_camera_frame_user_data(this._impl);
        if (!currentToken) return undefined;
        return this.cameraTokens.get(currentToken);
    }
    cameraFrameDrawGL(screenWidth, screenHeight, mirror) {
        if (!this.glContext) return;
        let token = this.getCurrentCameraInfo();
        if (!token) return;
        if (!this._cameraDraw) this._cameraDraw = new (0, $aabe8846ae41ae5f$export$65ee3277a9a1612d)(this.glContext);
        this._cameraDraw.drawCameraFrame(screenWidth, screenHeight, token, mirror === true);
    }
    glContextLost() {
        if (this._cameraDraw) this._cameraDraw.dispose();
        if (this._faceDraw) this._faceDraw.dispose();
        if (this._imageTargetPreviewDraw) this._imageTargetPreviewDraw.dispose();
        if (this._faceProjectDraw) this._faceProjectDraw.dispose();
        delete this._cameraDraw;
        delete this._faceDraw;
        delete this._imageTargetPreviewDraw;
        delete this._faceProjectDraw;
        (0, $11023ec155ec8242$export$5998daa18e8ce5b0)();
        this.onGLContextReset.emit();
        for (let tex of this.videoTextures)if (this.glContext) this.glContext.deleteTexture(tex);
        this.videoTextures = [];
        for (let info of this.cameraTokens){
            if (this.glContext && info[1].texture) this.glContext.deleteTexture(info[1].texture);
            info[1].texture = undefined;
        }
        this.glContext = undefined;
    }
    glContextSet(gl, texturePool) {
        this.glContextLost();
        this.glContext = gl;
        texturePool = texturePool || [];
        for(let i = 0; i < 4; i++){
            let tex = texturePool[i] || gl.createTexture();
            if (tex) {
                gl.bindTexture(gl.TEXTURE_2D, tex);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                this.videoTextures.push(tex);
            }
        }
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    drawFace(projectionMatrix, cameraMatrix, targetMatrix, o) {
        if (!this.glContext) return;
        if (!this._faceDraw) this._faceDraw = new (0, $fa190eaedae2f1f6$export$884fb66b30975d12)(this.glContext);
        let mat = (0, $2e616e7f2b93d8b0$exports).create();
        (0, $2e616e7f2b93d8b0$exports).multiply(mat, projectionMatrix, cameraMatrix);
        (0, $2e616e7f2b93d8b0$exports).multiply(mat, mat, targetMatrix);
        this._faceDraw.drawFace(mat, o);
    }
    drawImageTargetPreview(projectionMatrix, cameraMatrix, targetMatrix, indx, o) {
        if (!this.glContext) return;
        if (!this._imageTargetPreviewDraw) this._imageTargetPreviewDraw = new (0, $8041d977647cb086$export$2a06d804567c3ad8)(this.glContext);
        let mat = (0, $2e616e7f2b93d8b0$exports).create();
        (0, $2e616e7f2b93d8b0$exports).multiply(mat, projectionMatrix, cameraMatrix);
        (0, $2e616e7f2b93d8b0$exports).multiply(mat, mat, targetMatrix);
        this._imageTargetPreviewDraw.draw(mat, o, indx);
    }
    drawFaceProject(matrix, vertices, uvMatrix, uvs, indices, texture) {
        if (!this.glContext) return;
        if (!this._faceProjectDraw) this._faceProjectDraw = new (0, $e6e018fe0325b7a1$export$626d5c7c1d8c587c)(this.glContext);
        this._faceProjectDraw.drawFace(matrix, vertices, uvMatrix, uvs, indices, texture);
    }
    cameraFrameTexture() {
        var _a;
        return (_a = this.getCurrentCameraInfo()) === null || _a === void 0 ? void 0 : _a.texture;
    }
    cameraFrameTextureMatrix(sw, sh, mirror) {
        let info = this.getCurrentCameraInfo();
        if (!info) return (0, $2e616e7f2b93d8b0$exports).create();
        return (0, $aabe8846ae41ae5f$export$3da067886124f338)(info.dataWidth, info.dataHeight, sw, sh, info.uvTransform || $f8ed8326d2f24395$var$identity, mirror);
    }
    cameraFrameUserFacing() {
        var _a;
        return ((_a = this.getCurrentCameraInfo()) === null || _a === void 0 ? void 0 : _a.userFacing) || false;
    }
    cameraPoseWithAttitude(mirror) {
        let res = $f8ed8326d2f24395$export$9e7b3df2d144a412(this.getCurrentCameraInfo(), this._client.pipeline_camera_frame_camera_attitude(this._impl));
        if (mirror) {
            let scale = (0, $2e616e7f2b93d8b0$exports).create();
            (0, $2e616e7f2b93d8b0$exports).fromScaling(scale, [
                -1,
                1,
                1
            ]);
            (0, $2e616e7f2b93d8b0$exports).multiply(res, scale, res);
            (0, $2e616e7f2b93d8b0$exports).multiply(res, res, scale);
        }
        (0, $2e616e7f2b93d8b0$exports).invert(res, res);
        return res;
    }
    videoFrameFromWorker(msg) {
        let tokenId = this.nextCameraToken++;
        const cameraSource = (0, $89fa42ee9de7dcc1$export$cf42922f9ae76ed1)(msg.source);
        if (!cameraSource) return;
        this.cameraTokens.set(tokenId, {
            dataWidth: msg.w,
            dataHeight: msg.h,
            texture: undefined,
            frame: msg.d,
            userFacing: msg.userFacing,
            uvTransform: msg.uvTransform,
            cameraModel: msg.cameraModel,
            cameraToDevice: msg.cameraToDevice,
            cameraSource: cameraSource
        });
        this.cleanOldFrames();
    }
    imageBitmapFromWorker(msg) {
        let data = this.cameraTokens.get(msg.tokenId);
        if (!data) return;
        data.dataWidth = msg.dataWidth;
        data.dataHeight = msg.dataHeight;
        data.frame = msg.frame;
        data.userFacing = msg.userFacing;
        data.uvTransform = msg.uvTransform;
        this.tokensInFlight--;
        this.cleanOldFrames();
    }
    uploadGL() {
        var _a, _b;
        let info = this.getCurrentCameraInfo();
        (_b = (_a = info === null || info === void 0 ? void 0 : info.cameraSource) === null || _a === void 0 ? void 0 : _a.uploadGL) === null || _b === void 0 || _b.call(_a, info);
    }
    registerToken(info) {
        let tokenId = this.nextCameraToken++;
        this.cameraTokens.set(tokenId, info);
        this.tokensInFlight++;
        return tokenId;
    }
    processGL() {
        if (!this.glContext) {
            (0, $7c2568b0d857a09d$export$497c45d0bfe56de1)("no GL context for camera frames - please call pipeline_gl_context_set");
            return;
        }
        if (!this.currentCameraSource) return;
        if (this.tokensInFlight > 0) {
            this.currentCameraSource.getFrame(true);
            return;
        }
        this.currentCameraSource.getFrame(false);
    }
    motionAccelerometerSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendAccelerometer(timestamp, x, y, z);
        this._client.pipeline_motion_accelerometer_submit(this._impl, timestamp, x, y, z);
    }
    motionRotationRateSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendRotationRate(timestamp, x, y, z);
        this._client.pipeline_motion_rotation_rate_submit(this._impl, timestamp, x, y, z);
    }
    motionAttitudeSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendAttitude(timestamp, x, y, z);
        this._client.pipeline_motion_attitude_submit(this._impl, timestamp, x, y, z);
    }
    motionAttitudeMatrix(m) {
        // This doesn't need to be added to the sequence since that's done on frame update instead
        this._client.pipeline_motion_attitude_matrix_submit(this._impl, m);
    }
    sendCameraStreamToWorker(source, stream, userFacing) {
        let msg = {
            t: "streamC2S",
            p: this._impl,
            s: stream,
            userFacing: userFacing,
            source: source
        };
        this._mgr.postOutgoingMessage(msg, [
            msg.s
        ]);
    }
    sendCameraToScreenRotationToWorker(rot) {
        let msg = {
            p: this._impl,
            t: "cameraToScreenC2S",
            r: rot
        };
        this._mgr.postOutgoingMessage(msg, []);
    }
    sendImageBitmapToWorker(img, rot, userFacing, tokenId, cameraModel, cameraToDevice) {
        let msg = {
            p: this._impl,
            t: "imageBitmapC2S",
            i: img,
            r: rot,
            tokenId: tokenId,
            userFacing: userFacing,
            cameraModel: cameraModel,
            cameraToDevice: cameraToDevice
        };
        this._mgr.postOutgoingMessage(msg, [
            img
        ]);
    }
    sendDataToWorker(data, token, width, height, userFacing, cameraToDevice, cameraModel) {
        let msg = {
            d: data,
            p: this._impl,
            width: width,
            height: height,
            token: token,
            userFacing: userFacing,
            c2d: cameraToDevice,
            cm: cameraModel,
            t: "cameraFrameC2S"
        };
        this._mgr.postOutgoingMessage(msg, [
            data
        ]);
    }
}
function $f8ed8326d2f24395$export$9e7b3df2d144a412(info, inp) {
    let userFacing = false;
    userFacing = info ? info.userFacing : false;
    let mult = (0, $2e616e7f2b93d8b0$exports).create();
    (0, $2e616e7f2b93d8b0$exports).fromRotation(mult, (0, $ca0d9f3de8343ab7$export$83fad53f837eba8e)(userFacing) * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2e616e7f2b93d8b0$exports).multiply(mult, mult, inp);
    return mult;
}





const $215a4d5c79d52ee6$export$bc05bfbdf8a2824 = {
    0: [
        {
            mean: [
                0.235,
                0.2344,
                0.7305
            ],
            identity: [
                0.008,
                0.0087,
                0.0024,
                -0.0026,
                0.0006,
                -0.0022,
                0.0005,
                0.0033,
                0.0026,
                0.0017,
                -0.0055,
                -0.0008,
                0.0011,
                0.0059,
                0,
                0.0002,
                0.001,
                -0.001,
                -0.0044,
                -0.0011,
                -0.0001,
                0.0024,
                0.0019,
                -0.0009,
                0.0004,
                -0.0015,
                0,
                0.0038,
                0.0013,
                0.0003,
                0.002,
                -0.0021,
                0.0018,
                0.0023,
                0.0011,
                0.0012,
                -0.0011,
                -0.0017,
                0.0009,
                -0.0012,
                -0.0008,
                0.0007,
                -0.0017,
                0.0029,
                -0.0029,
                0.0008,
                -0.0027,
                0.0008,
                -0.0017,
                0.0004,
                0.0009,
                -0.001,
                -0.0003,
                0.0008,
                -0.0016,
                -0.0003,
                -0.0007,
                0.0016,
                -0.0009,
                0.0021,
                -0.0005,
                0.0011,
                -0.0024,
                -0.0001,
                0.0006,
                0.0001,
                -0.0026,
                -0.0004,
                -0.0003,
                -0.0009,
                0.0005,
                0.0003,
                -0.0008,
                -0.001,
                -0.0004,
                -0.0008,
                0.0022,
                -0.0014,
                -0.0001,
                -0.0023,
                0,
                -0.0018,
                0.0007,
                -0.0036,
                0.0017,
                0.0017,
                -0.0018,
                -0.0002,
                -0.0004,
                -0.0009,
                -0.0008,
                0.0003,
                0.0012,
                0.0009,
                -0.0004,
                -0.0016,
                0.0005,
                -0.0013,
                0.0011,
                0.0023,
                0.0029,
                0.0024,
                0.0017,
                -0.0027,
                -0.0004,
                -0.001,
                -0.0018,
                -0.0015,
                -0.001,
                0.001,
                -0.0013,
                -0.0001,
                -0.0002,
                0.0007,
                0.0003,
                0.0003,
                -0.0016,
                0.0009,
                -0.0021,
                0.0004,
                0.0014,
                0.002,
                -0.0007,
                -0.0004,
                0.0002,
                -0.0004,
                -0.0006,
                -0.0009,
                0.0015,
                0.0004,
                -0.0004,
                0.0005,
                -0.0015,
                0.0009,
                0.0003,
                0.0003,
                -0.0002,
                -0.0008,
                -0.0009,
                0.0023,
                0.0004,
                0.0001,
                -0.0004,
                -0.0001,
                0.0007,
                0.0002,
                0.001,
                0.0001,
                -0.0029,
                -0.0005
            ],
            expression: [
                0,
                0.0003,
                0.0052,
                -0.0007,
                -0.0051,
                -0.0103,
                0,
                0.0019,
                0.0027,
                -0.0054,
                0.0135,
                0.035,
                -0.0005,
                -0.0006,
                0.0025,
                -0.0045,
                -0.0557,
                -0.003,
                -0.0191,
                -0.1199,
                0.0548,
                -0.0036,
                -0.0682,
                -0.0167,
                0.0002,
                -0.0085,
                -0.0085,
                0.0044,
                0.0041,
                -0.0568,
                0.0044,
                0.179,
                0.0065,
                -0.0017,
                -0.1006,
                0.0036,
                -0.0267,
                -0.3279,
                0.0301,
                -0.0011,
                -0.0173,
                -0.001,
                0.0046,
                0.2808,
                0.0207,
                0.0162,
                0.238,
                -0.0225,
                0.0017,
                0.1041,
                0.0203,
                0.0005,
                0.0161,
                0.0031,
                -0.0436,
                0.6504,
                0.0873,
                -0.0099,
                0.1039,
                0.0048,
                -0.0254,
                0.2534,
                -0.0042,
                0.003,
                -0.0106,
                -0.0153,
                -0.0118,
                0.0252,
                0.0009,
                -0.0071,
                0.0099,
                0.007,
                -0.0724,
                0.0461,
                -0.0235,
                0.0833,
                0.004,
                0.0141,
                -0.0219,
                0.0132,
                -0.0042,
                -0.0179,
                0.0045,
                -0.0215,
                0.3638,
                0.0054,
                -0.0445
            ]
        },
        {
            mean: [
                0.2358,
                0.1466,
                0.7183
            ],
            identity: [
                0.0077,
                0.0093,
                0.0001,
                -0.0022,
                0,
                -0.0041,
                0.0005,
                0.0022,
                0.0028,
                0.0018,
                -0.0038,
                -0.0013,
                0.001,
                0.0044,
                -0.0002,
                0,
                0.0017,
                -0.0016,
                -0.0043,
                -0.0002,
                -0.0001,
                0.0023,
                0.0009,
                0.0005,
                -0.0007,
                -0.0004,
                -0.0017,
                0.003,
                0.0007,
                0.0006,
                0.0011,
                -0.0018,
                0.0005,
                0.0018,
                -0.0008,
                0.0004,
                -0.0023,
                -0.0006,
                -0.0003,
                -0.0015,
                -0.0014,
                -0.0001,
                -0.0018,
                0.0027,
                -0.0026,
                0.0003,
                -0.0031,
                0.0011,
                -0.0026,
                -0.0011,
                0.0012,
                -0.0013,
                -0.0002,
                0.0007,
                -0.0021,
                0.0021,
                0.0004,
                0.0012,
                -0.001,
                0.002,
                -0.0003,
                0.0002,
                -0.0026,
                -0.0003,
                0.001,
                0.0001,
                -0.0018,
                -0.001,
                0.0009,
                -0.0011,
                0.001,
                0.0004,
                -0.0008,
                -0.0007,
                -0.001,
                -0.0003,
                0.0007,
                -0.0005,
                -0.0006,
                -0.0019,
                -0.0005,
                -0.002,
                0.0007,
                -0.0027,
                0.0014,
                0.0013,
                0.0006,
                -0.0005,
                -0.0003,
                -0.0003,
                -0.001,
                0,
                0.0019,
                0.0001,
                0.0006,
                -0.0012,
                0.0004,
                -0.0009,
                0.0004,
                0.0025,
                0.0003,
                0.0024,
                0.0017,
                -0.0009,
                -0.0015,
                -0.0015,
                -0.001,
                -0.0023,
                -0.001,
                -0.0005,
                -0.0004,
                0.0008,
                0.0009,
                0.0007,
                0.0002,
                0.0007,
                -0.0009,
                0.0009,
                -0.0013,
                0.0001,
                0.0009,
                0.0002,
                0.0006,
                -0.0006,
                -0.0008,
                -0.0004,
                -0.0007,
                0.0008,
                0.0019,
                0.0003,
                0.0015,
                0.0002,
                -0.0015,
                -0.0003,
                0,
                0.0006,
                0.0003,
                0.0006,
                -0.0006,
                0.0002,
                0.0005,
                -0.0004,
                0.0012,
                -0.0004,
                0.0002,
                -0.0008,
                0.0006,
                -0.0004,
                0.0002,
                -0.0021
            ],
            expression: [
                -0.0034,
                0.0054,
                0.0069,
                0.004,
                0.0006,
                -0.0104,
                -0.0003,
                0.0036,
                0.0025,
                0.0065,
                0.0296,
                0.0208,
                -0.0009,
                0.0154,
                0.0029,
                -0.0167,
                0.0124,
                0.004,
                -0.0102,
                0.0351,
                0.028,
                -0.019,
                0.0146,
                -0.0035,
                -0.0023,
                -0.0069,
                -0.0051,
                -0.01,
                0.0262,
                -0.028,
                0.0112,
                0.082,
                0.023,
                -0.0019,
                -0.066,
                -0.0104,
                -0.0408,
                0.0164,
                0.0075,
                -0.0074,
                0.0367,
                0.0041,
                0.0517,
                -0.0207,
                0.0045,
                0.0291,
                -0.0672,
                -0.0129,
                0.0345,
                -0.1558,
                -0.0106,
                0.0037,
                -0.0437,
                -0.0021,
                0.0854,
                -0.1121,
                0.0187,
                0.0041,
                0.0072,
                0.0011,
                0.0193,
                -0.0143,
                -0.0119,
                0.005,
                -0.02,
                -0.0122,
                -0.008,
                0.0527,
                0.0036,
                -0.006,
                0.0222,
                0.007,
                -0.0429,
                0.046,
                -0.0046,
                0.0226,
                -0.0059,
                0.0202,
                -0.0173,
                0.0087,
                0,
                -0.0067,
                -0.0095,
                -0.0153,
                0.1506,
                -0.0017,
                0.0021
            ]
        }
    ],
    1: [
        {
            mean: [
                -0.2271,
                0.2323,
                0.7319
            ],
            identity: [
                -0.0084,
                0.0097,
                0.0018,
                0.0041,
                0.0002,
                -0.002,
                -0.0012,
                0.0036,
                0.0019,
                -0.0009,
                -0.0063,
                -0.001,
                -0.0003,
                0.0053,
                0.0006,
                0.0001,
                0.0005,
                -0.0015,
                0.0044,
                -0.0025,
                -0.0015,
                -0.002,
                0.0016,
                -0.0006,
                0.0002,
                -0.0013,
                0,
                -0.0022,
                0.0002,
                0.0002,
                -0.0025,
                -0.0014,
                0.0015,
                0.0008,
                0.0002,
                0.0012,
                0.0006,
                -0.0006,
                0.0017,
                0,
                0.0003,
                -0.0001,
                0.0024,
                0.0025,
                -0.0029,
                -0.0015,
                -0.0015,
                0.0001,
                0.0031,
                -0.0016,
                0.0007,
                0.0019,
                0.0006,
                0.002,
                0.0009,
                0.001,
                -0.0014,
                -0.002,
                -0.0015,
                0.0029,
                0.0001,
                0.0005,
                -0.0023,
                0.0008,
                -0.0011,
                0.0019,
                0.0017,
                -0.0003,
                -0.0011,
                -0.0003,
                0.0011,
                -0.0008,
                0.0019,
                -0.0022,
                0.0001,
                0.0015,
                0.0017,
                -0.0008,
                -0.0011,
                -0.0022,
                0.0003,
                0.0022,
                0.0006,
                -0.003,
                -0.0002,
                0,
                -0.0017,
                -0.0002,
                0,
                0.0001,
                0.0004,
                0.0012,
                0.0019,
                -0.0014,
                0.0004,
                -0.0017,
                -0.0012,
                -0.0011,
                0.0021,
                -0.0029,
                0.0026,
                0.0018,
                -0.0023,
                -0.0029,
                0.0001,
                0.0014,
                -0.0019,
                -0.0004,
                -0.0004,
                0.0023,
                -0.0016,
                0,
                -0.0009,
                0.0014,
                -0.0015,
                0.0015,
                -0.0016,
                -0.0011,
                -0.0022,
                0.0001,
                -0.0018,
                0.0027,
                -0.0013,
                0.0004,
                -0.0001,
                -0.0005,
                0.0011,
                -0.0002,
                0.0015,
                0.0005,
                -0.0009,
                -0.0001,
                0.0029,
                0.0006,
                0,
                -0.0003,
                0.0007,
                -0.0008,
                -0.0005,
                0.0025,
                0.0003,
                0.0002,
                -0.0008,
                -0.0001,
                0.0003,
                0,
                0.0014,
                0.0002,
                -0.0024,
                0.0001
            ],
            expression: [
                -0.0025,
                -0.0009,
                0.006,
                0.004,
                -0.0027,
                -0.0113,
                -0.0008,
                0.001,
                0.0031,
                -0.0016,
                0.0144,
                0.0382,
                -0.0003,
                -0.0005,
                0.0035,
                -0.0044,
                -0.0511,
                -0.0014,
                -0.0007,
                -0.1007,
                0.0582,
                -0.0006,
                -0.0606,
                -0.0165,
                0.0005,
                -0.0087,
                -0.0093,
                0.0036,
                0.0057,
                -0.0576,
                -0.0039,
                0.1488,
                0.0127,
                0.0016,
                -0.0666,
                -0.0009,
                -0.0153,
                0.3162,
                -0.0445,
                -0.0021,
                0.0023,
                0.0043,
                -0.0033,
                0.2382,
                0.0063,
                -0.0217,
                0.167,
                -0.039,
                0.0097,
                -0.1144,
                -0.0189,
                -0.0145,
                0.6831,
                0.0632,
                -0.0012,
                -0.1959,
                -0.0133,
                0.0004,
                0.1108,
                -0.0003,
                0.0062,
                0.2593,
                -0.0161,
                -0.0018,
                -0.0051,
                -0.012,
                0.0162,
                0.016,
                -0.0022,
                -0.0052,
                -0.0201,
                0.0101,
                0.0115,
                0.0365,
                -0.024,
                -0.0059,
                0.0188,
                -0.0336,
                0.0352,
                0.0224,
                -0.0229,
                0.0146,
                0.0086,
                -0.0273,
                -0.0032,
                0.0103,
                -0.0112
            ]
        },
        {
            mean: [
                -0.2288,
                0.1541,
                0.7202
            ],
            identity: [
                -0.0082,
                0.0101,
                0.0002,
                0.0036,
                -0.0007,
                -0.0037,
                -0.0008,
                0.0024,
                0.0022,
                -0.0013,
                -0.0045,
                -0.0013,
                -0.0006,
                0.0045,
                -0.0004,
                0.0004,
                0.0012,
                -0.0014,
                0.0042,
                -0.001,
                -0.0007,
                -0.0019,
                0.0003,
                -0.0002,
                0.0012,
                -0.0004,
                -0.0012,
                -0.0018,
                -0.0004,
                -0.0001,
                -0.0014,
                -0.0012,
                0.0001,
                0.0001,
                -0.0017,
                0.001,
                0.0015,
                -0.0001,
                0.0006,
                0.0001,
                0,
                -0.0006,
                0.0028,
                0.0021,
                -0.0025,
                -0.002,
                -0.0015,
                0.0007,
                0.0028,
                -0.0023,
                0.0009,
                0.0013,
                0.0001,
                0.0016,
                0.0012,
                0.0032,
                -0.0006,
                -0.0013,
                -0.0011,
                0.0021,
                0.0003,
                -0.0005,
                -0.0024,
                0.0004,
                -0.0004,
                0.0014,
                0.0015,
                -0.0008,
                -0.0003,
                0.0003,
                0.0017,
                -0.0006,
                0.002,
                -0.0018,
                -0.0003,
                0.0009,
                0.0001,
                0.0002,
                -0.0006,
                -0.0015,
                -0.0004,
                0.0022,
                0.0007,
                -0.0023,
                0,
                -0.0002,
                -0.0002,
                -0.0003,
                -0.0001,
                0.0006,
                -0.0002,
                0.0006,
                0.0022,
                -0.0003,
                0.0013,
                -0.0014,
                -0.0005,
                -0.0003,
                0.0013,
                -0.0027,
                0.0006,
                0.0025,
                -0.0023,
                -0.0008,
                -0.0013,
                0.0017,
                -0.0009,
                -0.0019,
                0.0001,
                0.0008,
                -0.0007,
                -0.0004,
                0,
                0.001,
                -0.001,
                0.0019,
                -0.0008,
                -0.0015,
                -0.0006,
                -0.0002,
                -0.0011,
                0.0008,
                0.0001,
                0.0009,
                -0.0008,
                -0.0004,
                0.0006,
                0.0007,
                0.0021,
                -0.0004,
                0.0007,
                -0.0005,
                0.0021,
                -0.0007,
                -0.0004,
                -0.0009,
                0.0008,
                0.0003,
                0.0001,
                0.0003,
                0.0001,
                0.0009,
                0.001,
                -0.0005,
                0.0005,
                -0.001,
                0.001,
                0.0004,
                -0.0005,
                -0.0012
            ],
            expression: [
                0.0008,
                0.0037,
                0.0078,
                -0.0004,
                0.0005,
                -0.012,
                -0.0002,
                -0.0046,
                0.0033,
                -0.0089,
                0.0295,
                0.0221,
                -0.0024,
                -0.0084,
                0.0013,
                0.0057,
                0.0125,
                0.0049,
                -0.0036,
                0.0373,
                0.0285,
                0.0115,
                0.0135,
                -0.0035,
                0.0048,
                0.0108,
                -0.0033,
                0.0106,
                0.0281,
                -0.0301,
                -0.0082,
                0.0803,
                0.0244,
                -0.0007,
                -0.0725,
                -0.0105,
                -0.0247,
                -0.0036,
                -0.0143,
                -0.0045,
                -0.029,
                0.0002,
                -0.0303,
                0.0093,
                -0.0021,
                -0.0196,
                -0.0754,
                -0.0211,
                0.0326,
                0.1246,
                0.006,
                -0.0804,
                -0.1499,
                0.0109,
                0.0182,
                -0.0029,
                -0.0014,
                -0.0035,
                0.0072,
                -0.0008,
                -0.0152,
                -0.0108,
                -0.0166,
                -0.0073,
                -0.0144,
                -0.0095,
                0.0101,
                0.047,
                -0.0018,
                -0.004,
                -0.0189,
                0.0027,
                0.0104,
                0.0298,
                -0.0042,
                -0.0096,
                0.0191,
                -0.0217,
                0.0228,
                0.0226,
                -0.0105,
                0.0047,
                -0.0048,
                -0.0172,
                0.0061,
                -0.0043,
                -0.0016
            ]
        }
    ],
    2: {
        mean: [
            0.5396,
            0.2028,
            0.2496
        ],
        identity: [
            0.0204,
            0.0146,
            -0.0182,
            -0.0052,
            0.0158,
            -0.0038,
            -0.0025,
            -0.0108,
            -0.006,
            0.0085,
            -0.0044,
            0.0029,
            0.0042,
            0.001,
            0.0095,
            0.0015,
            -0.0034,
            -0.0064,
            -0.0057,
            0.0007,
            0.0026,
            0.0007,
            0.0037,
            -0.0006,
            0.0037,
            0.0026,
            0.0024,
            0.0005,
            -0.0019,
            -0.0013,
            0.003,
            -0.0028,
            0.0018,
            -0.0009,
            0.002,
            -0.0047,
            0.004,
            -0.003,
            0.0031,
            -0.0027,
            -0.0026,
            -0.0017,
            0.0016,
            0.0014,
            -0.0004,
            0.0021,
            -0.002,
            0,
            0.0017,
            0.0007,
            -0.0004,
            -0.0007,
            -0.0018,
            -0.0009,
            0.0002,
            -0.0012,
            0.0001,
            -0.0005,
            -0.0011,
            0.0004,
            0.0002,
            0.0011,
            0.0001,
            0.0008,
            0.0017,
            -0.0013,
            0.0025,
            0.0017,
            0.001,
            0.0002,
            0.0003,
            0.0005,
            -0.0004,
            -0.0001,
            -0.0005,
            0.0007,
            -0.0022,
            -0.0029,
            0.0006,
            -0.0008,
            -0.0006,
            0.0006,
            -0.0005,
            0.0005,
            0.0013,
            0.0003,
            -0.0005,
            -0.003,
            0.0007,
            0.0002,
            0.0016,
            -0.0004,
            0,
            0,
            0.0004,
            0.0001,
            0.0014,
            0.0012,
            0.0001,
            0.0004,
            -0.0001,
            0.0008,
            0.0009,
            0.0004,
            -0.0004,
            0.0009,
            -0.0002,
            0.001,
            0.0009,
            0.0004,
            0.0001,
            0.0007,
            0.0007,
            0.001,
            -0.0017,
            -0.0008,
            0.0002,
            0.0017,
            -0.0003,
            -0.0001,
            0.0004,
            0.0005,
            0.0007,
            0.0005,
            -0.0001,
            -0.0006,
            -0.0001,
            0.0001,
            -0.0003,
            -0.0007,
            -0.0002,
            -0.0005,
            0,
            -0.0003,
            0.0003,
            0.0008,
            -0.0002,
            -0.0003,
            0.0005,
            0.0001,
            -0.0007,
            -0.001,
            -0.0002,
            0.0003,
            0.0004,
            -0.0001,
            0.0007,
            0,
            0.0004,
            0.0004
        ],
        expression: [
            0.0001,
            -0.0004,
            0.0001,
            0,
            0.0005,
            0.0002,
            0,
            0,
            0.0003,
            -0.0002,
            0.0003,
            0.0005,
            -0.0001,
            0.0002,
            0.0008,
            0.0001,
            -0.0002,
            -0.0005,
            -0.0003,
            0.0006,
            0.0005,
            0,
            0.0001,
            0.0002,
            0.0001,
            -0.0001,
            -0.0006,
            -0.0002,
            0.0005,
            0,
            -0.0004,
            0.0004,
            0.0016,
            0.0004,
            -0.0004,
            -0.0015,
            0,
            0.0001,
            0.0001,
            -0.0003,
            0.0003,
            0.0019,
            -0.0002,
            0.0007,
            0.0004,
            0.0004,
            -0.0008,
            -0.0015,
            0.0013,
            -0.0016,
            -0.0069,
            0.0004,
            -0.0006,
            -0.0019,
            0,
            -0.0001,
            0.0005,
            -0.0003,
            0.0002,
            0.0014,
            -0.0003,
            0.0006,
            0.0011,
            0.0004,
            -0.0003,
            -0.0032,
            -0.0006,
            0.0008,
            0.0025,
            -0.0003,
            0.0003,
            0.0015,
            -0.0001,
            0.0001,
            0.0003,
            -0.0001,
            0,
            0,
            -0.0003,
            0.0004,
            0.0019,
            0.0001,
            0,
            -0.0008,
            -0.0001,
            0.0001,
            0.0005
        ]
    },
    3: {
        mean: [
            -0.5464,
            0.2141,
            0.26
        ],
        identity: [
            -0.0207,
            0.0172,
            -0.0176,
            0.0068,
            0.0148,
            -0.0051,
            0.0042,
            -0.0101,
            -0.0058,
            -0.0087,
            -0.0059,
            0.0045,
            -0.0056,
            0.0017,
            0.0097,
            -0.0048,
            -0.004,
            -0.0044,
            0.0019,
            0.0002,
            0.0041,
            -0.0052,
            0.0041,
            0.0002,
            -0.0027,
            0.0006,
            0.002,
            -0.0027,
            -0.0033,
            -0.0006,
            -0.004,
            0.0009,
            -0.0012,
            -0.0001,
            -0.0026,
            0.0021,
            -0.003,
            -0.0025,
            0.0052,
            0.0025,
            0.0022,
            -0.0001,
            -0.0008,
            0.0013,
            0.001,
            0.0004,
            0.0018,
            0.0014,
            0.0006,
            -0.0005,
            -0.0015,
            -0.0039,
            0.0014,
            -0.0001,
            0.0008,
            -0.0002,
            0.0006,
            -0.0005,
            -0.0038,
            -0.0012,
            -0.0018,
            -0.0003,
            0.001,
            0.0009,
            0.0012,
            0.0024,
            -0.0024,
            -0.0007,
            -0.0016,
            -0.0016,
            0.0003,
            -0.001,
            -0.0014,
            -0.0014,
            0.001,
            -0.0003,
            -0.0007,
            -0.0012,
            0.0003,
            0.0006,
            0.0003,
            -0.0005,
            0.0003,
            0.0012,
            0.0006,
            -0.0008,
            0.0004,
            0.0004,
            0.0008,
            -0.0002,
            -0.0014,
            0.0003,
            0,
            0.0023,
            -0.0003,
            -0.0012,
            -0.0013,
            0.0011,
            -0.0002,
            -0.0014,
            -0.0001,
            0.0014,
            0,
            0.0003,
            0.0003,
            -0.0008,
            -0.0005,
            -0.0007,
            -0.0007,
            -0.0002,
            0.0003,
            0.0005,
            0.0002,
            -0.0001,
            0.0011,
            -0.0014,
            0.0001,
            -0.0015,
            -0.0001,
            -0.0003,
            0,
            -0.001,
            -0.0001,
            -0.0008,
            0.0008,
            -0.0008,
            -0.0002,
            -0.0011,
            -0.0003,
            -0.0004,
            0.0001,
            -0.0002,
            0.0003,
            -0.0007,
            0,
            0.0003,
            0.0001,
            -0.0008,
            0.0005,
            0.0001,
            0.0004,
            0.0014,
            -0.0006,
            -0.001,
            -0.0003,
            -0.0002,
            0.0001,
            -0.0001,
            -0.0001,
            0.0007
        ],
        expression: [
            -0.0003,
            -0.0001,
            0.0006,
            0.0004,
            0,
            -0.0007,
            0,
            -0.0003,
            -0.0002,
            -0.0004,
            0.0012,
            0.0008,
            0.0001,
            -0.0005,
            -0.0007,
            -0.0004,
            0,
            0.0001,
            -0.0004,
            0.0017,
            0.0007,
            0,
            0.0001,
            0.0003,
            0,
            0.0004,
            0.0004,
            0.0005,
            0.0001,
            -0.001,
            -0.0007,
            0.0022,
            0.0026,
            0.0005,
            -0.0024,
            -0.0023,
            0,
            0.0001,
            0.0003,
            0,
            -0.0013,
            -0.0015,
            0.0006,
            0.0014,
            0.0008,
            -0.0002,
            -0.0025,
            -0.0023,
            -0.0003,
            0.0049,
            0.006,
            -0.0002,
            -0.0007,
            -0.0002,
            0,
            -0.0019,
            -0.0018,
            -0.0002,
            0.0017,
            0.0017,
            0.0003,
            0.0015,
            0.0007,
            0.0001,
            -0.0023,
            -0.0036,
            0.0002,
            0.0023,
            0.0017,
            0,
            -0.0005,
            -0.0003,
            -0.0003,
            0.0004,
            0.0002,
            -0.0001,
            -0.0003,
            -0.0005,
            0.0001,
            0.0018,
            0.0025,
            0.0001,
            -0.0006,
            -0.0011,
            0,
            0.0001,
            0.0001
        ]
    },
    4: {
        mean: [
            0.0018,
            0.1864,
            0.853
        ],
        identity: [
            -0.0011,
            0.0134,
            0.0085,
            0.0009,
            -0.0025,
            -0.0007,
            -0.0003,
            0.0033,
            0.0004,
            -0.0005,
            -0.0047,
            -0.002,
            0.0007,
            0.0026,
            -0.0069,
            -0.0001,
            0.0036,
            0.0072,
            0.0005,
            -0.0008,
            -0.0047,
            0.0004,
            -0.0008,
            -0.001,
            0,
            0.0002,
            -0.0036,
            -0.0002,
            -0.001,
            -0.0048,
            -0.0001,
            0.0018,
            0.0044,
            -0.0007,
            -0.0002,
            0.0043,
            0.0003,
            0.002,
            -0.0031,
            0,
            -0.0007,
            0.0013,
            0,
            0.0037,
            0.0033,
            -0.0016,
            -0.0012,
            0.002,
            -0.0001,
            -0.0027,
            0.0051,
            0.0005,
            0.0008,
            0.0007,
            -0.0017,
            0.0054,
            0.0023,
            -0.0003,
            0.0032,
            0.0001,
            0,
            0.0007,
            -0.0005,
            -0.0011,
            0.0002,
            0.0008,
            0,
            -0.0033,
            -0.0008,
            -0.0007,
            0.0007,
            0.0033,
            0.0005,
            -0.0003,
            0.0029,
            -0.0001,
            -0.0024,
            -0.0011,
            -0.002,
            -0.0015,
            -0.0019,
            0.0002,
            0.0007,
            0.0031,
            0.0006,
            0.0012,
            0,
            0,
            -0.0021,
            0,
            -0.0009,
            -0.0011,
            -0.0011,
            -0.0002,
            0.0015,
            0.001,
            0.0013,
            0.0008,
            0.001,
            -0.0003,
            0.0009,
            0.0027,
            -0.0002,
            -0.0011,
            -0.0011,
            0.0006,
            0.0007,
            0.0002,
            0.0001,
            -0.0005,
            -0.0022,
            0.0011,
            -0.0014,
            0.0009,
            0.0003,
            0.0002,
            0,
            -0.0006,
            -0.0004,
            -0.0011,
            -0.0007,
            0.001,
            -0.0012,
            0.0006,
            -0.0012,
            -0.0015,
            0.0003,
            -0.0009,
            -0.0013,
            -0.0013,
            0.0007,
            0.001,
            -0.0011,
            -0.0013,
            0.0015,
            0.0004,
            0.0001,
            0.0004,
            -0.0001,
            -0.0016,
            -0.0016,
            0.0009,
            -0.0007,
            -0.0024,
            0.0005,
            -0.0001,
            -0.0017,
            -0.0002,
            0.0003,
            -0.0009
        ],
        expression: [
            -0.0017,
            0.0019,
            0.0097,
            0.003,
            -0.0103,
            -0.0093,
            0.0009,
            0.0006,
            0.0023,
            -0.0017,
            -0.0204,
            0.0376,
            0.0033,
            -0.0034,
            0.0033,
            -0.0026,
            -0.0322,
            0.0396,
            -0.0032,
            -0.0947,
            0.0942,
            -0.0007,
            -0.0175,
            0.0266,
            -0.001,
            -0.0006,
            0.0016,
            0.0025,
            0.0157,
            -0.0142,
            -0.0022,
            0.037,
            0.015,
            0.0021,
            -0.0102,
            -0.0107,
            0.0036,
            0.0055,
            -0.0051,
            0.0021,
            0.0003,
            -0.0003,
            0.0004,
            -0.0177,
            0.0074,
            -0.0006,
            -0.0357,
            0.0149,
            -0.0066,
            0.0009,
            0.0013,
            -0.0031,
            0.0016,
            0.0095,
            0.002,
            0.0052,
            0.0035,
            -0.0003,
            0.0053,
            -0.0082,
            0.002,
            0.0022,
            -0.0071,
            -0.0011,
            0.0005,
            0.0055,
            0.0011,
            0.0003,
            -0.0126,
            -0.0004,
            0.0003,
            -0.0023,
            -0.0015,
            0.0059,
            0.0063,
            -0.0042,
            -0.0023,
            0.0055,
            0.0019,
            0.0017,
            -0.0075,
            0.0006,
            -0.0008,
            0.0018,
            0.0012,
            0.0012,
            -0.0005
        ]
    },
    5: {
        mean: [
            -0.002,
            -0.0469,
            1.0039
        ],
        identity: [
            -0.0017,
            0.0018,
            0.0156,
            0.0006,
            -0.0038,
            0.0005,
            0.0004,
            0.0013,
            0.002,
            -0.0004,
            -0.0015,
            -0.0051,
            0.0005,
            -0.0007,
            -0.0055,
            -0.0001,
            -0.0009,
            0.008,
            -0.0002,
            0.0036,
            -0.0053,
            0.0004,
            -0.0026,
            -0.0016,
            0.0007,
            0.0009,
            -0.009,
            -0.0003,
            0.0007,
            -0.0084,
            0.0015,
            0.0021,
            0.0032,
            -0.0015,
            0.0018,
            0.0046,
            -0.0003,
            -0.0004,
            -0.0001,
            0.0008,
            -0.0044,
            -0.0007,
            -0.0008,
            0.0007,
            0.0048,
            -0.0024,
            -0.0003,
            0.0024,
            0.0002,
            -0.0051,
            0.0058,
            -0.0006,
            0.0028,
            0.0018,
            -0.0021,
            0.0035,
            0.0057,
            0.0011,
            0.0065,
            0,
            -0.0002,
            0.0011,
            0.003,
            -0.0027,
            0.0008,
            0.0007,
            0.0003,
            -0.0039,
            -0.002,
            -0.0002,
            -0.0015,
            0.0034,
            0.0012,
            -0.0025,
            0.0024,
            -0.0002,
            0.0004,
            -0.0042,
            -0.0024,
            -0.001,
            -0.0023,
            0.0016,
            -0.0007,
            0.0039,
            0.0001,
            -0.0005,
            0.0018,
            0.0003,
            -0.0002,
            -0.0009,
            -0.0015,
            0.0003,
            -0.0007,
            -0.0001,
            -0.0002,
            0.0023,
            0.0032,
            0.002,
            -0.0013,
            0.0013,
            -0.0038,
            0.0045,
            0.0001,
            -0.0031,
            0.0001,
            0.0019,
            -0.0001,
            0.0016,
            0.0013,
            0,
            -0.002,
            0.0023,
            0.0002,
            0.0011,
            0.0018,
            -0.0024,
            0.0006,
            -0.0017,
            0.002,
            -0.0008,
            -0.0021,
            0.0007,
            0.0011,
            0.0008,
            0.0004,
            -0.001,
            0.0012,
            0.0002,
            -0.0006,
            -0.0027,
            -0.0005,
            0.001,
            -0.0009,
            0.0001,
            -0.0001,
            0.0008,
            -0.0011,
            0.0022,
            -0.001,
            -0.0005,
            -0.0011,
            0.0016,
            -0.0015,
            0.0008,
            -0.0003,
            0.0009,
            0.0013,
            -0.0007,
            -0.0007,
            -0.0002
        ],
        expression: [
            -0.0018,
            -0.0168,
            0.0088,
            0.0389,
            0.1026,
            0.0414,
            0.2201,
            -0.0262,
            -0.0016,
            -0.0017,
            0.0612,
            -0.0298,
            -0.0323,
            0.0093,
            0.0013,
            -0.005,
            0.2207,
            0.1315,
            -0.0004,
            0.0858,
            -0.0303,
            -0.0133,
            0.015,
            -0.008,
            0.1454,
            0.0114,
            0.0177,
            -0.0077,
            0.1022,
            0.0356,
            -0.0023,
            0.1088,
            0.0232,
            0.003,
            -0.0706,
            0.0347,
            -0.0001,
            0.004,
            -0.0011,
            0.0397,
            -0.0096,
            -0.0033,
            0.0029,
            -0.01,
            -0.0083,
            -0.0006,
            -0.0135,
            0.0016,
            -0.0087,
            -0.0019,
            0.0022,
            -0.004,
            -0.0087,
            0.0105,
            0.0008,
            -0.005,
            0.0069,
            0.0028,
            0.0409,
            -0.0391,
            0.003,
            0.0103,
            0.0051,
            0.0026,
            0.0776,
            -0.0083,
            -0.0062,
            -0.0567,
            0.0268,
            0.0175,
            0.0017,
            0.0156,
            -0.0043,
            0.0299,
            -0.0395,
            -0.0015,
            0.0051,
            -0.0148,
            0.0125,
            0.0035,
            0.0603,
            0.0109,
            -0.0645,
            -0.0257,
            0.002,
            0.0006,
            -0.0008
        ]
    },
    6: {
        mean: [
            -0.0006,
            -0.1542,
            0.8789
        ],
        identity: [
            -0.0007,
            -0.0032,
            0.01,
            0,
            -0.0027,
            0.0031,
            0.0006,
            0.0005,
            -0.0006,
            -0.0003,
            0.0013,
            -0.0049,
            -0.0002,
            -0.002,
            -0.0046,
            0.0008,
            -0.0011,
            0.0054,
            0.0002,
            0.0043,
            -0.0027,
            0.0003,
            -0.0022,
            -0.0019,
            0.0008,
            0.0032,
            -0.0069,
            0,
            0.0004,
            -0.0071,
            0.0016,
            0.0027,
            0.0039,
            -0.0017,
            0.0009,
            0.0031,
            -0.0001,
            -0.0005,
            -0.0004,
            0.0007,
            -0.0026,
            -0.0012,
            -0.0005,
            0.0006,
            0.0002,
            -0.0014,
            -0.0013,
            0.0019,
            -0.0002,
            -0.0053,
            0.0031,
            -0.0006,
            0.0016,
            0.0023,
            -0.0013,
            0.0021,
            0.0029,
            0.0008,
            0.0052,
            0,
            0.0004,
            0,
            0.0037,
            -0.0026,
            0.0003,
            0.002,
            -0.0002,
            -0.0024,
            0.0004,
            -0.0004,
            -0.0012,
            0.0008,
            0.0007,
            -0.0023,
            0.0005,
            0,
            0.0014,
            -0.0022,
            -0.0016,
            0,
            -0.0012,
            0.0008,
            -0.0007,
            0.0014,
            -0.0006,
            -0.0012,
            -0.0003,
            0.0002,
            0.0012,
            -0.0003,
            -0.002,
            -0.0001,
            0.0001,
            -0.0002,
            -0.0016,
            0.0009,
            0.002,
            0.0019,
            0,
            0.0006,
            -0.0022,
            0.0016,
            0.0001,
            -0.0017,
            -0.0013,
            0.001,
            0.0009,
            -0.0001,
            0.0011,
            0.0003,
            -0.0007,
            0.0014,
            0.0008,
            0.0013,
            0.0011,
            -0.002,
            0,
            -0.0015,
            0.0014,
            0.001,
            -0.0015,
            0.0007,
            0.0003,
            0.001,
            -0.0001,
            0.0012,
            0.0007,
            0.0006,
            -0.0004,
            -0.0013,
            -0.0012,
            -0.0009,
            -0.0011,
            0.0002,
            -0.0005,
            0.0005,
            0.0004,
            0.0002,
            0.0001,
            0,
            0.0005,
            0.0005,
            -0.0014,
            0.0015,
            -0.0009,
            0.0005,
            0.0014,
            -0.0008,
            -0.0008,
            0.0012
        ],
        expression: [
            0.0008,
            0.0481,
            0.1653,
            0.0784,
            0.1008,
            -0.3992,
            0.5088,
            -0.02,
            0.0542,
            0.001,
            0.3723,
            -0.0151,
            -0.0986,
            0.0283,
            -0.0033,
            -0.0121,
            0.2634,
            0.1202,
            0.0036,
            -0.0529,
            -0.0245,
            -0.0297,
            -0.1085,
            0.0495,
            0.3264,
            0.0083,
            0.0004,
            -0.0314,
            0.1459,
            -0.1142,
            -0.003,
            0.0001,
            0.1154,
            -0.0035,
            -0.0285,
            -0.0184,
            -0.0001,
            0.0012,
            0.0035,
            0.079,
            -0.0103,
            0.0043,
            0.011,
            -0.004,
            -0.0774,
            -0.0047,
            -0.023,
            0.0284,
            -0.0048,
            -0.001,
            0.0149,
            -0.0039,
            0.0046,
            0.0528,
            -0.0006,
            0.0063,
            0.0376,
            0.0096,
            0.0558,
            -0.0295,
            0,
            -0.0311,
            -0.0634,
            0.0062,
            0.0176,
            -0.0154,
            -0.0109,
            -0.1149,
            0.0192,
            0.0326,
            0.0121,
            0.0237,
            0.0034,
            0.0262,
            -0.0778,
            0.0014,
            -0.0045,
            -0.0203,
            0.0077,
            0.0588,
            0.0575,
            0.008,
            -0.0557,
            -0.0095,
            0.0032,
            0.0054,
            -0.0042
        ]
    },
    7: {
        mean: [
            0.0038,
            -0.2927,
            0.833
        ],
        identity: [
            0.0006,
            -0.0109,
            0.0073,
            -0.0006,
            -0.0044,
            0.0017,
            -0.0001,
            -0.0022,
            -0.0006,
            -0.0003,
            0.0065,
            -0.0014,
            -0.0006,
            -0.0051,
            -0.0046,
            0.0003,
            -0.0029,
            0.003,
            0.0002,
            0.0038,
            -0.0006,
            0,
            -0.0012,
            0.0006,
            -0.0004,
            0.0053,
            -0.0075,
            -0.0002,
            -0.0007,
            -0.0063,
            0.0014,
            0.0026,
            0.0019,
            -0.0022,
            0.0018,
            0.0028,
            -0.0001,
            -0.0012,
            0.0011,
            0.0009,
            0.0019,
            -0.0019,
            -0.0001,
            0.0012,
            -0.0022,
            -0.0003,
            -0.0012,
            0.0004,
            -0.0008,
            0.0003,
            -0.0003,
            0,
            0.0017,
            0.0021,
            -0.0004,
            0.0012,
            0.0022,
            -0.0003,
            0.0026,
            -0.0003,
            0.0004,
            -0.0026,
            0.0032,
            -0.0019,
            0.0003,
            0.0015,
            0.0001,
            -0.0015,
            0.0013,
            -0.0001,
            0.0001,
            -0.0029,
            0,
            -0.0002,
            -0.0028,
            -0.0007,
            0.0019,
            -0.0003,
            -0.0002,
            0.0012,
            0.0009,
            0.0004,
            -0.001,
            -0.002,
            -0.0016,
            0.0011,
            -0.0001,
            0.0003,
            0.0021,
            0.0002,
            -0.0014,
            -0.0009,
            -0.0001,
            0,
            -0.0002,
            -0.001,
            0.0015,
            0.0018,
            0.0001,
            0.0007,
            0.0008,
            0.0017,
            0.001,
            -0.0009,
            0.0001,
            0.0004,
            0.0023,
            -0.0001,
            0.0012,
            0.0001,
            -0.0008,
            0.0002,
            0.0018,
            0.0006,
            0.0003,
            0.0001,
            0.0012,
            -0.0003,
            0.002,
            -0.0006,
            0,
            -0.0001,
            -0.0022,
            0.0004,
            0.0005,
            0.0011,
            0.0002,
            -0.0013,
            -0.0023,
            0.0006,
            0.0006,
            -0.0005,
            -0.0005,
            0.0009,
            0.0002,
            0.0002,
            0.0011,
            -0.0003,
            0.0011,
            0.0015,
            0.0011,
            0.0003,
            0.0002,
            0.0008,
            -0.0004,
            -0.0008,
            0.0003,
            0,
            0.0012,
            -0.0001
        ],
        expression: [
            0.026,
            0.1107,
            0.3257,
            0.1917,
            0.3206,
            -1.1348,
            1.0791,
            -0.035,
            0.1549,
            -0.0103,
            0.6953,
            0.0001,
            -0.3262,
            0.068,
            0.0219,
            -0.0044,
            0.3643,
            0.2178,
            0.0168,
            -0.2478,
            -0.1321,
            -0.0414,
            -0.3782,
            -0.0617,
            0.5088,
            -0.0031,
            -0.0311,
            -0.0497,
            0.0948,
            -0.385,
            0.0148,
            -0.2224,
            -0.1415,
            -0.0074,
            0.0863,
            -0.203,
            0.0003,
            -0.0081,
            0.0057,
            0.1164,
            -0.0039,
            0.0015,
            -0.0024,
            0.0505,
            0.1532,
            0.0039,
            -0.0148,
            -0.0753,
            0.0163,
            0.0058,
            -0.0339,
            0.0036,
            0.0252,
            -0.0569,
            -0.0041,
            0.0163,
            -0.0361,
            0.0035,
            -0.018,
            0.1266,
            0,
            -0.0163,
            -0.0046,
            0.0133,
            -0.1656,
            0.2134,
            0.0191,
            0.0057,
            0.0734,
            0.0681,
            0.0039,
            -0.0144,
            0.029,
            -0.074,
            -0.046,
            0.0122,
            0.0072,
            -0.0162,
            -0.0349,
            -0.1234,
            0.0212,
            -0.0355,
            0.0535,
            0.1218,
            0.0043,
            -0.024,
            0.0016
        ]
    },
    8: {
        mean: [
            -0.0018,
            -0.3037,
            0.8491
        ],
        identity: [
            0.0002,
            -0.0112,
            0.0077,
            -0.0004,
            -0.0044,
            0.0024,
            0.0001,
            -0.0021,
            -0.0004,
            -0.0004,
            0.0066,
            -0.002,
            -0.0004,
            -0.0052,
            -0.0044,
            0.0003,
            -0.0032,
            0.0039,
            0.0004,
            0.0042,
            -0.0003,
            0.0002,
            -0.0012,
            -0.0002,
            -0.0002,
            0.0052,
            -0.0083,
            -0.0001,
            -0.0008,
            -0.0056,
            0.0017,
            0.0024,
            0.0019,
            -0.0023,
            0.002,
            0.0027,
            -0.0002,
            -0.0013,
            0.002,
            0.0009,
            0.0017,
            -0.0028,
            -0.0002,
            0.0012,
            -0.0026,
            0,
            -0.0016,
            0.0002,
            -0.0005,
            0.0003,
            -0.001,
            -0.0001,
            0.0016,
            0.0016,
            -0.0003,
            0.0012,
            0.0012,
            -0.0003,
            0.0027,
            -0.0003,
            0.0003,
            -0.0026,
            0.0037,
            -0.0017,
            0.0001,
            0.0016,
            0.0001,
            -0.0015,
            0.0024,
            0.0001,
            0.0002,
            -0.0039,
            0,
            -0.0003,
            -0.0033,
            -0.0006,
            0.0017,
            -0.0004,
            -0.0004,
            0.0012,
            0.0018,
            0.0002,
            -0.0012,
            -0.002,
            -0.0017,
            0.0013,
            -0.001,
            0.0003,
            0.0021,
            0.0004,
            -0.0012,
            -0.0006,
            -0.0002,
            0,
            -0.0004,
            -0.0009,
            0.0016,
            0.0017,
            0.0004,
            0.0007,
            0.0007,
            0.001,
            0.0009,
            -0.0008,
            0.0005,
            0.0005,
            0.0023,
            0.001,
            0.0013,
            0.0002,
            -0.0004,
            0.0002,
            0.0017,
            0.0008,
            0.0003,
            -0.0001,
            0.0009,
            -0.0004,
            0.0019,
            -0.0005,
            0.0003,
            0,
            -0.0025,
            0.0003,
            0.0003,
            0.0011,
            0.0001,
            -0.0015,
            -0.001,
            0.0007,
            0.0007,
            -0.0007,
            -0.0007,
            0.0008,
            0,
            0.0001,
            0.0013,
            -0.0004,
            0.0012,
            0.0014,
            0.0017,
            0.0004,
            0.0002,
            0.0003,
            -0.0003,
            -0.0009,
            0.0001,
            0,
            0.001,
            -0.0004
        ],
        expression: [
            -0.0092,
            2.8809,
            1.416,
            0.2018,
            1.1982,
            -0.9351,
            1.4492,
            -0.1902,
            0.1749,
            0.0305,
            -0.167,
            -0.1572,
            -0.7354,
            -0.0492,
            0.0115,
            0.0608,
            0.2971,
            0.1179,
            0.0046,
            -0.0997,
            -0.0041,
            -0.0104,
            0.3379,
            -0.1854,
            0.009,
            0.0366,
            -0.0583,
            0.0269,
            -0.0029,
            -0.4175,
            -0.0008,
            0.1794,
            0.0752,
            -0.0135,
            0.1158,
            0.1234,
            0.0005,
            0.003,
            -0.0032,
            0.1034,
            -0.0504,
            -0.0055,
            -0.0076,
            -0.0772,
            0.224,
            0.0047,
            0.0229,
            -0.1044,
            0.0162,
            -0.0161,
            -0.0241,
            -0.0083,
            -0.1388,
            -0.0434,
            -0.0125,
            -0.0997,
            -0.0327,
            -0.0111,
            0.1576,
            -0.3911,
            0.0199,
            0.2522,
            0.142,
            0.0059,
            -0.0721,
            -0.0045,
            0.031,
            -0.1136,
            -0.1685,
            0.0641,
            0.0142,
            0.0312,
            0.0426,
            -0.1366,
            0.1011,
            0.0101,
            -0.0157,
            0.0018,
            -0.0103,
            -0.0344,
            0.0907,
            0.0016,
            0.1168,
            -0.0806,
            0.0104,
            -0.0057,
            0.0111
        ]
    },
    9: [
        {
            mean: [
                0.0038,
                -0.2927,
                0.833
            ],
            identity: [
                0.0006,
                -0.0109,
                0.0073,
                -0.0006,
                -0.0044,
                0.0017,
                -0.0001,
                -0.0022,
                -0.0006,
                -0.0003,
                0.0065,
                -0.0014,
                -0.0006,
                -0.0051,
                -0.0046,
                0.0003,
                -0.0029,
                0.003,
                0.0002,
                0.0038,
                -0.0006,
                0,
                -0.0012,
                0.0006,
                -0.0004,
                0.0053,
                -0.0075,
                -0.0002,
                -0.0007,
                -0.0063,
                0.0014,
                0.0026,
                0.0019,
                -0.0022,
                0.0018,
                0.0028,
                -0.0001,
                -0.0012,
                0.0011,
                0.0009,
                0.0019,
                -0.0019,
                -0.0001,
                0.0012,
                -0.0022,
                -0.0003,
                -0.0012,
                0.0004,
                -0.0008,
                0.0003,
                -0.0003,
                0,
                0.0017,
                0.0021,
                -0.0004,
                0.0012,
                0.0022,
                -0.0003,
                0.0026,
                -0.0003,
                0.0004,
                -0.0026,
                0.0032,
                -0.0019,
                0.0003,
                0.0015,
                0.0001,
                -0.0015,
                0.0013,
                -0.0001,
                0.0001,
                -0.0029,
                0,
                -0.0002,
                -0.0028,
                -0.0007,
                0.0019,
                -0.0003,
                -0.0002,
                0.0012,
                0.0009,
                0.0004,
                -0.001,
                -0.002,
                -0.0016,
                0.0011,
                -0.0001,
                0.0003,
                0.0021,
                0.0002,
                -0.0014,
                -0.0009,
                -0.0001,
                0,
                -0.0002,
                -0.001,
                0.0015,
                0.0018,
                0.0001,
                0.0007,
                0.0008,
                0.0017,
                0.001,
                -0.0009,
                0.0001,
                0.0004,
                0.0023,
                -0.0001,
                0.0012,
                0.0001,
                -0.0008,
                0.0002,
                0.0018,
                0.0006,
                0.0003,
                0.0001,
                0.0012,
                -0.0003,
                0.002,
                -0.0006,
                0,
                -0.0001,
                -0.0022,
                0.0004,
                0.0005,
                0.0011,
                0.0002,
                -0.0013,
                -0.0023,
                0.0006,
                0.0006,
                -0.0005,
                -0.0005,
                0.0009,
                0.0002,
                0.0002,
                0.0011,
                -0.0003,
                0.0011,
                0.0015,
                0.0011,
                0.0003,
                0.0002,
                0.0008,
                -0.0004,
                -0.0008,
                0.0003,
                0,
                0.0012,
                -0.0001
            ],
            expression: [
                0.026,
                0.1107,
                0.3257,
                0.1917,
                0.3206,
                -1.1348,
                1.0791,
                -0.035,
                0.1549,
                -0.0103,
                0.6953,
                0.0001,
                -0.3262,
                0.068,
                0.0219,
                -0.0044,
                0.3643,
                0.2178,
                0.0168,
                -0.2478,
                -0.1321,
                -0.0414,
                -0.3782,
                -0.0617,
                0.5088,
                -0.0031,
                -0.0311,
                -0.0497,
                0.0948,
                -0.385,
                0.0148,
                -0.2224,
                -0.1415,
                -0.0074,
                0.0863,
                -0.203,
                0.0003,
                -0.0081,
                0.0057,
                0.1164,
                -0.0039,
                0.0015,
                -0.0024,
                0.0505,
                0.1532,
                0.0039,
                -0.0148,
                -0.0753,
                0.0163,
                0.0058,
                -0.0339,
                0.0036,
                0.0252,
                -0.0569,
                -0.0041,
                0.0163,
                -0.0361,
                0.0035,
                -0.018,
                0.1266,
                0,
                -0.0163,
                -0.0046,
                0.0133,
                -0.1656,
                0.2134,
                0.0191,
                0.0057,
                0.0734,
                0.0681,
                0.0039,
                -0.0144,
                0.029,
                -0.074,
                -0.046,
                0.0122,
                0.0072,
                -0.0162,
                -0.0349,
                -0.1234,
                0.0212,
                -0.0355,
                0.0535,
                0.1218,
                0.0043,
                -0.024,
                0.0016
            ]
        },
        {
            mean: [
                -0.0018,
                -0.3037,
                0.8491
            ],
            identity: [
                0.0002,
                -0.0112,
                0.0077,
                -0.0004,
                -0.0044,
                0.0024,
                0.0001,
                -0.0021,
                -0.0004,
                -0.0004,
                0.0066,
                -0.002,
                -0.0004,
                -0.0052,
                -0.0044,
                0.0003,
                -0.0032,
                0.0039,
                0.0004,
                0.0042,
                -0.0003,
                0.0002,
                -0.0012,
                -0.0002,
                -0.0002,
                0.0052,
                -0.0083,
                -0.0001,
                -0.0008,
                -0.0056,
                0.0017,
                0.0024,
                0.0019,
                -0.0023,
                0.002,
                0.0027,
                -0.0002,
                -0.0013,
                0.002,
                0.0009,
                0.0017,
                -0.0028,
                -0.0002,
                0.0012,
                -0.0026,
                0,
                -0.0016,
                0.0002,
                -0.0005,
                0.0003,
                -0.001,
                -0.0001,
                0.0016,
                0.0016,
                -0.0003,
                0.0012,
                0.0012,
                -0.0003,
                0.0027,
                -0.0003,
                0.0003,
                -0.0026,
                0.0037,
                -0.0017,
                0.0001,
                0.0016,
                0.0001,
                -0.0015,
                0.0024,
                0.0001,
                0.0002,
                -0.0039,
                0,
                -0.0003,
                -0.0033,
                -0.0006,
                0.0017,
                -0.0004,
                -0.0004,
                0.0012,
                0.0018,
                0.0002,
                -0.0012,
                -0.002,
                -0.0017,
                0.0013,
                -0.001,
                0.0003,
                0.0021,
                0.0004,
                -0.0012,
                -0.0006,
                -0.0002,
                0,
                -0.0004,
                -0.0009,
                0.0016,
                0.0017,
                0.0004,
                0.0007,
                0.0007,
                0.001,
                0.0009,
                -0.0008,
                0.0005,
                0.0005,
                0.0023,
                0.001,
                0.0013,
                0.0002,
                -0.0004,
                0.0002,
                0.0017,
                0.0008,
                0.0003,
                -0.0001,
                0.0009,
                -0.0004,
                0.0019,
                -0.0005,
                0.0003,
                0,
                -0.0025,
                0.0003,
                0.0003,
                0.0011,
                0.0001,
                -0.0015,
                -0.001,
                0.0007,
                0.0007,
                -0.0007,
                -0.0007,
                0.0008,
                0,
                0.0001,
                0.0013,
                -0.0004,
                0.0012,
                0.0014,
                0.0017,
                0.0004,
                0.0002,
                0.0003,
                -0.0003,
                -0.0009,
                0.0001,
                0,
                0.001,
                -0.0004
            ],
            expression: [
                -0.0092,
                2.8809,
                1.416,
                0.2018,
                1.1982,
                -0.9351,
                1.4492,
                -0.1902,
                0.1749,
                0.0305,
                -0.167,
                -0.1572,
                -0.7354,
                -0.0492,
                0.0115,
                0.0608,
                0.2971,
                0.1179,
                0.0046,
                -0.0997,
                -0.0041,
                -0.0104,
                0.3379,
                -0.1854,
                0.009,
                0.0366,
                -0.0583,
                0.0269,
                -0.0029,
                -0.4175,
                -0.0008,
                0.1794,
                0.0752,
                -0.0135,
                0.1158,
                0.1234,
                0.0005,
                0.003,
                -0.0032,
                0.1034,
                -0.0504,
                -0.0055,
                -0.0076,
                -0.0772,
                0.224,
                0.0047,
                0.0229,
                -0.1044,
                0.0162,
                -0.0161,
                -0.0241,
                -0.0083,
                -0.1388,
                -0.0434,
                -0.0125,
                -0.0997,
                -0.0327,
                -0.0111,
                0.1576,
                -0.3911,
                0.0199,
                0.2522,
                0.142,
                0.0059,
                -0.0721,
                -0.0045,
                0.031,
                -0.1136,
                -0.1685,
                0.0641,
                0.0142,
                0.0312,
                0.0426,
                -0.1366,
                0.1011,
                0.0101,
                -0.0157,
                0.0018,
                -0.0103,
                -0.0344,
                0.0907,
                0.0016,
                0.1168,
                -0.0806,
                0.0104,
                -0.0057,
                0.0111
            ]
        }
    ],
    10: {
        mean: [
            -0.007,
            -0.6338,
            0.7695
        ],
        identity: [
            0.0001,
            -0.0296,
            0.0089,
            -0.0006,
            -0.0073,
            -0.0065,
            -0.0001,
            -0.0029,
            -0.0031,
            -0.0002,
            0.0128,
            0.0065,
            0,
            -0.0116,
            -0.014,
            -0.0001,
            -0.0037,
            -0.0052,
            -0.0005,
            0.0028,
            0.003,
            -0.0004,
            0.0041,
            0.0015,
            0.0006,
            0.0088,
            -0.0076,
            -0.0011,
            -0.0015,
            -0.0073,
            0.0007,
            -0.0011,
            0.0019,
            -0.0011,
            -0.0005,
            0.0031,
            -0.0001,
            -0.0018,
            0.0009,
            0.0018,
            0.0038,
            0.0068,
            -0.0004,
            -0.0001,
            0.0061,
            0.0024,
            0.0024,
            -0.0066,
            -0.0006,
            0.0051,
            0.0014,
            0.002,
            0.005,
            -0.0035,
            0.0001,
            -0.0034,
            -0.004,
            -0.0007,
            0.001,
            -0.0008,
            0.0001,
            -0.0005,
            -0.0021,
            0.0002,
            0.0045,
            -0.0043,
            -0.0012,
            -0.0024,
            -0.0014,
            0.0006,
            0.0034,
            0.0027,
            -0.0008,
            -0.0053,
            0.0014,
            0.0001,
            0.0013,
            -0.0018,
            0.0006,
            -0.0015,
            0.0029,
            -0.0002,
            -0.0035,
            0.0001,
            -0.002,
            0.0012,
            0.0048,
            0.0011,
            0.0001,
            -0.0002,
            -0.0003,
            -0.0012,
            0.0033,
            0.0006,
            0.002,
            -0.0033,
            0.0004,
            0.0028,
            0.0002,
            0.0008,
            -0.0001,
            -0.0018,
            0.0008,
            0.0017,
            0.0001,
            0.0009,
            0.0008,
            0.0003,
            0.0019,
            -0.001,
            0.001,
            -0.0007,
            -0.0013,
            0,
            0.0001,
            0.0032,
            -0.0001,
            0.0001,
            0.0011,
            -0.0004,
            0.0005,
            -0.0007,
            0.0018,
            -0.0003,
            0.0002,
            0.0007,
            0.0008,
            -0.0014,
            0.0007,
            0.0015,
            -0.0006,
            -0.0001,
            -0.0004,
            0.0019,
            -0.0009,
            -0.0006,
            -0.0006,
            -0.0012,
            0.0002,
            -0.0012,
            -0.0008,
            0.0004,
            0.0006,
            -0.0011,
            0.0003,
            0.0009,
            -0.0004,
            0.0006,
            -0.0007,
            -0.0004
        ],
        expression: [
            -0.0603,
            2.0527,
            1.9014,
            0.1025,
            0.6143,
            0.3804,
            0.7881,
            -0.1023,
            -0.0764,
            0.0454,
            -0.2487,
            -0.5073,
            -0.6704,
            -0.031,
            -0.0181,
            0.0466,
            0.0651,
            -0.0726,
            -0.0033,
            -0.0022,
            0.2944,
            0.0101,
            0.1669,
            -0.5225,
            -0.4685,
            0.0236,
            0.0079,
            0.011,
            0.2173,
            0.4529,
            0.0121,
            -0.2104,
            -0.0673,
            0.0225,
            -0.4023,
            0.0317,
            -0.0009,
            0.0076,
            -0.0032,
            0.0333,
            0.0523,
            0.0129,
            -0.001,
            -0.0319,
            -0.0139,
            0.0015,
            -0.0044,
            0.0247,
            -0.0005,
            0.0161,
            0.0061,
            0.0074,
            0.0776,
            -0.0176,
            0.007,
            0.055,
            -0.017,
            0.0052,
            -0.1819,
            0.0294,
            -0.0161,
            -0.0337,
            0.0226,
            -0.008,
            -0.0297,
            0.1967,
            -0.0095,
            0.0383,
            0.2039,
            0.0434,
            0.0271,
            -0.0064,
            -0.0037,
            -0.0294,
            -0.024,
            0.0024,
            -0.0137,
            -0.0209,
            -0.0031,
            0.0628,
            0.1003,
            -0.0126,
            -0.056,
            -0.0097,
            -0.0012,
            -0.0041,
            0.0162
        ]
    },
    11: {
        mean: [
            0.2505,
            0.3833,
            0.7793
        ],
        identity: [
            0.0098,
            0.012,
            0.0077,
            -0.0006,
            -0.0003,
            0,
            0.0001,
            0.0082,
            -0.0007,
            0.0019,
            -0.0036,
            -0.0012,
            0.0002,
            0.0119,
            -0.0039,
            0.001,
            0.0001,
            0.0031,
            -0.0036,
            -0.0059,
            -0.0007,
            0.0026,
            0.0028,
            -0.0011,
            0.0009,
            -0.0032,
            0.0008,
            0.0029,
            0.0043,
            0.0003,
            0.0025,
            -0.0009,
            0.0047,
            0.0016,
            0.0022,
            0.0018,
            -0.001,
            0.0025,
            -0.003,
            -0.001,
            0.0033,
            0.0034,
            0.0004,
            -0.0052,
            0.0024,
            -0.0002,
            0.001,
            -0.0014,
            -0.0006,
            0.0038,
            -0.0015,
            -0.0006,
            -0.001,
            -0.0011,
            -0.0004,
            -0.001,
            0.0004,
            -0.0007,
            0.0036,
            -0.0008,
            -0.0002,
            -0.0019,
            0.0005,
            0.0003,
            -0.0006,
            -0.0024,
            -0.0017,
            -0.0014,
            0.0006,
            -0.0004,
            -0.0031,
            -0.0013,
            -0.0006,
            0.0042,
            0.0002,
            -0.0002,
            -0.002,
            -0.0003,
            0.0008,
            0.0018,
            -0.0005,
            -0.0006,
            -0.0002,
            -0.0006,
            0.0025,
            0.0019,
            0.001,
            0.0008,
            -0.0015,
            -0.0012,
            -0.0001,
            -0.0006,
            -0.0004,
            0.0023,
            -0.001,
            0.0006,
            -0.0002,
            -0.001,
            0,
            -0.0009,
            -0.002,
            -0.0011,
            0.0001,
            0,
            -0.0001,
            0.0005,
            0.0006,
            0.0009,
            -0.0006,
            0.0005,
            0.0008,
            -0.0001,
            -0.0002,
            -0.0017,
            -0.0006,
            -0.0004,
            0.0004,
            -0.0006,
            0.0012,
            0.0004,
            0.0003,
            -0.0007,
            0.0003,
            -0.0002,
            0.0006,
            0.0001,
            0.0005,
            -0.0019,
            -0.0006,
            0.0004,
            0.0007,
            -0.0001,
            0.0001,
            0.0005,
            0.001,
            -0.0006,
            -0.002,
            -0.0007,
            -0.0005,
            0.0005,
            0.0003,
            0.0007,
            0.0014,
            0,
            0.0005,
            -0.0005,
            -0.0002,
            0.0003,
            -0.0006,
            -0.0001
        ],
        expression: [
            -0.0009,
            -0.0003,
            0.0032,
            -0.003,
            -0.0034,
            -0.0031,
            0.0014,
            0,
            0.0004,
            -0.0139,
            -0.0764,
            0.0275,
            -0.002,
            -0.0089,
            0.0031,
            -0.0503,
            -0.0771,
            0.038,
            -0.1323,
            -0.3523,
            0.1368,
            -0.0474,
            -0.0564,
            0.0296,
            -0.0045,
            0.007,
            -0.0013,
            0.0153,
            0.1259,
            -0.0464,
            0.0866,
            0.2175,
            -0.0786,
            -0.0413,
            -0.1248,
            0.0448,
            -0.1777,
            -0.4607,
            0.1782,
            -0.0005,
            -0.005,
            0.0016,
            0.0629,
            0.1506,
            -0.0624,
            0.0545,
            0.2576,
            -0.0864,
            -0.0231,
            -0.0552,
            0.0244,
            -0.0136,
            -0.0359,
            0.0169,
            -0.1158,
            -0.2996,
            0.1214,
            -0.0235,
            -0.0354,
            0.0165,
            -0.0745,
            -0.1079,
            0.0475,
            -0.0116,
            -0.0039,
            0.0012,
            0.0013,
            -0.0108,
            -0.0008,
            0.0044,
            -0.0027,
            -0.0001,
            -0.0694,
            0.0363,
            0.0071,
            0.1462,
            -0.136,
            0.0047,
            0.009,
            -0.0177,
            0.0038,
            -0.0271,
            0.0118,
            0.0011,
            -0.0399,
            -0.0111,
            0.0123
        ]
    },
    12: {
        mean: [
            -0.2981,
            0.3828,
            0.7563
        ],
        identity: [
            -0.0116,
            0.014,
            0.0054,
            0.0018,
            0.0005,
            0,
            -0.0004,
            0.0068,
            -0.0013,
            -0.0019,
            -0.0048,
            -0.0005,
            0.0005,
            0.0108,
            -0.0036,
            -0.0029,
            -0.0018,
            0.0029,
            0.0043,
            -0.0077,
            0.0006,
            -0.0017,
            0.002,
            -0.0011,
            -0.0014,
            -0.0035,
            0.0015,
            -0.0024,
            0.0011,
            0.0004,
            -0.0048,
            0.0002,
            0.0029,
            -0.0001,
            -0.0001,
            0.003,
            0.0019,
            0.0035,
            -0.0016,
            -0.0004,
            0.0039,
            0.0019,
            0.0001,
            -0.0064,
            0.004,
            0.0003,
            0.002,
            -0.0021,
            0.0017,
            0.0011,
            -0.001,
            0.0026,
            0.0025,
            -0.0005,
            0.0002,
            -0.0003,
            -0.0005,
            -0.0007,
            0.0009,
            -0.0004,
            -0.001,
            -0.0022,
            0.001,
            0.0009,
            -0.0014,
            0.0007,
            0.0011,
            -0.001,
            -0.0005,
            -0.0008,
            -0.0017,
            -0.0021,
            0.0009,
            0.0036,
            0.0005,
            0.0004,
            -0.0031,
            0.0006,
            -0.0015,
            0.0027,
            0.0002,
            0.0001,
            -0.0011,
            0.0002,
            -0.0011,
            -0.0018,
            0.0004,
            -0.0013,
            -0.0002,
            0.0007,
            0.0009,
            -0.0003,
            0.001,
            -0.0021,
            0.0008,
            0.0006,
            -0.0009,
            0.0004,
            -0.0007,
            0.0008,
            -0.002,
            -0.0013,
            0,
            0.0007,
            -0.0012,
            -0.0001,
            0.0014,
            0.0014,
            -0.0001,
            0.0013,
            0.0006,
            0.0006,
            -0.0014,
            -0.0015,
            -0.0009,
            0.0001,
            0.0001,
            0.0009,
            0.0007,
            0,
            0.0001,
            -0.001,
            -0.0004,
            0,
            -0.0005,
            0.0001,
            -0.0003,
            0.0004,
            -0.0005,
            -0.0001,
            -0.0011,
            0.0002,
            0,
            0.0001,
            0.0008,
            0.0008,
            0,
            -0.0007,
            -0.0008,
            0,
            0.0002,
            -0.0001,
            0.001,
            0.0003,
            0.0004,
            -0.0002,
            0,
            0.0005,
            0.0018,
            -0.0001
        ],
        expression: [
            0,
            -0.0004,
            0.0028,
            0.0036,
            -0.0008,
            -0.0026,
            -0.0015,
            -0.0008,
            0.0003,
            0.0075,
            -0.0608,
            0.025,
            0.0019,
            -0.0076,
            0.0033,
            0.0379,
            -0.0437,
            0.0335,
            0.0964,
            -0.2452,
            0.1233,
            0.0368,
            -0.0251,
            0.0253,
            0.0033,
            0.0097,
            -0.0021,
            -0.0095,
            0.1171,
            -0.0475,
            -0.064,
            0.1548,
            -0.0718,
            0.0228,
            -0.0831,
            0.0343,
            -0.1924,
            0.6206,
            -0.2771,
            0.0021,
            -0.0143,
            0.0056,
            -0.0705,
            0.2522,
            -0.1116,
            -0.0692,
            0.4229,
            -0.1592,
            -0.0093,
            0.05,
            -0.0185,
            0.0948,
            -0.3196,
            0.1437,
            -0.0184,
            0.0194,
            -0.0131,
            0.0205,
            -0.0353,
            0.0201,
            0.0676,
            -0.135,
            0.0672,
            0.0137,
            -0.0311,
            0.0118,
            0.0003,
            -0.0077,
            -0.0002,
            -0.0151,
            0.0004,
            -0.0058,
            0.029,
            -0.0139,
            0.0163,
            0.1324,
            0.1819,
            -0.0039,
            0.0406,
            0.0501,
            0.0017,
            0.0331,
            0.0161,
            0.0062,
            -0.0235,
            -0.0446,
            0.0047
        ]
    }
};



let $67167d3e1ef18577$var$latestFaceLandmark = 1;
let $67167d3e1ef18577$var$faceLandmarkById = new Map();
function $67167d3e1ef18577$export$36e720c0ee0eafff(n) {
    let ret = $67167d3e1ef18577$var$latestFaceLandmark++;
    $67167d3e1ef18577$var$faceLandmarkById.set(ret, new $67167d3e1ef18577$export$8da7a4c55ed49539(n));
    (0, $7c2568b0d857a09d$export$454156e929b28fe7)("face_landmark_t initialized");
    return ret;
}
function $67167d3e1ef18577$export$4a91c83b2945af9c(m) {
    $67167d3e1ef18577$var$faceLandmarkById.delete(m);
}
function $67167d3e1ef18577$export$2cdf232f18b0ea25(m) {
    return $67167d3e1ef18577$var$faceLandmarkById.get(m);
}
class $67167d3e1ef18577$export$8da7a4c55ed49539 {
    constructor(_name){
        this._name = _name;
        this.anchor_pose = (0, $2e616e7f2b93d8b0$exports).create();
    }
    _getVertex(identity, expression, data) {
        let vert = data.mean.slice();
        for(let i = 0; i < 50; i++){
            vert[0] += identity[i] * data.identity[i * 3 + 0];
            vert[1] += identity[i] * data.identity[i * 3 + 1];
            vert[2] += identity[i] * data.identity[i * 3 + 2];
        }
        for(let i = 0; i < 29; i++){
            vert[0] += expression[i] * data.expression[i * 3 + 0];
            vert[1] += expression[i] * data.expression[i * 3 + 1];
            vert[2] += expression[i] * data.expression[i * 3 + 2];
        }
        return vert;
    }
    update(identity, expression, mirrored) {
        let vert;
        let data = (0, $215a4d5c79d52ee6$export$bc05bfbdf8a2824)[this._name.toString()];
        if (!data) return;
        if (Array.isArray(data)) {
            vert = this._getVertex(identity, expression, data[0]);
            let b = this._getVertex(identity, expression, data[1]);
            vert[0] = 0.5 * (vert[0] + b[0]);
            vert[1] = 0.5 * (vert[1] + b[1]);
            vert[2] = 0.5 * (vert[2] + b[2]);
        } else vert = this._getVertex(identity, expression, data);
        if (mirrored) vert[0] *= -1;
        (0, $2e616e7f2b93d8b0$exports).fromTranslation(this.anchor_pose, vert);
    }
}


function $87049b330e55d4f2$var$getUnsupportedMessage() {
    let ret = document.createElement("div");
    let idealBrowser = "a recent web browser";
    if (navigator.userAgent.match(/Android/i)) {
        idealBrowser = "Chrome for Android";
        window.location.href = "googlechrome://navigate?url=" + encodeURI(window.location.href);
        setTimeout(()=>{
            window.location.href = "samsunginternet://open?url=" + encodeURI(window.location.href);
        }, 2000);
    } else if (navigator.userAgent.match(/iPhone|iPod|iPad/i)) {
        idealBrowser = "Safari";
        ret.classList.add("zee-launcher-browser-safari");
    }
    ret.classList.add("zee-launcher-unsupported");
    ret.innerHTML = `
            <style>.zee-launcher-unsupported {
               display: flex;
               flex-direction: column;
               height: 100%;
               justify-content: center;
               position: absolute;
               width: 100%;
               height: 100%;
               top: 0;
               left: 0;
               align-items: center;
               }
               .zee-launcher-browser-logo {
               background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 210 211' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(-82 -146)' fill-rule='nonzero' stroke='%23ffffff' stroke-width='2'%3E%3Cg transform='translate(83 146.5)'%3E%3Cpath d='m55.146 88.785l-32.039-49.472c19.962-24.947 49.904-38.684 80.517-38.81 17.739-0.12642 35.855 4.4246 52.336 13.99 18.2 10.619 32.039 25.874 40.846 43.404l-86.095-4.5511c-24.365-1.4327-47.556 12.347-55.565 35.439zm13.797 16.224c0 19.468 15.684 35.229 35.059 35.229 19.374 0 35.059-15.76 35.059-35.229 0-19.468-15.684-35.229-35.059-35.229-19.374 0-35.059 15.718-35.059 35.229zm132.06-37.588l-58.585 3.034c15.894 18.668 16.145 45.595 2.7678 66.243l-47.01 72.648c19.5 1.0535 39.588-3.2447 57.788-13.864 45.039-26.126 63.282-80.908 45.039-128.06zm-144.93 57.647l-39.126-77.326c-10.694 16.434-16.942 36.156-16.942 57.267 0 52.253 38.078 95.53 87.856 103.2l26.713-52.59c-24.155 4.5511-47.472-8.765-58.501-30.551z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
               width: 211px;
               height: 211px;
               margin-bottom: 25%;
               margin-top: -60px;
               background-repeat: no-repeat;
               }
               .zee-launcher-browser-safari .zee-launcher-browser-logo {
               background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 211 211' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(-82 -146)' fill-rule='nonzero' stroke='%23ffffff' stroke-width='2'%3E%3Cpath d='m180 251.86c0-4.0385 2.9377-7.855 7.2552-7.855 3.9614 0 7.7448 2.8402 7.7448 7.145 0 4.0385-2.8487 7.855-7.1662 7.855-4.0059 0-7.8338-2.9734-7.8338-7.145zm112-0.35503c0 57.728-46.772 104.5-104.5 104.5s-104.5-46.772-104.5-104.5 46.772-104.5 104.5-104.5 104.5 46.772 104.5 104.5zm-12-1c0-51.649-41.851-93.5-93.5-93.5s-93.5 41.851-93.5 93.5 41.851 93.5 93.5 93.5 93.5-41.851 93.5-93.5zm-30.624 40.983c0 1.5095 5.4495 4.2768 6.8328 5.1154-11.486 17.401-29.26 29.938-49.423 34.928l-1.8444-7.757c-0.12576-1.0482-0.79646-1.174-1.7606-1.174-0.79646 0-1.2576 1.174-1.1737 1.7611l1.8444 7.8828c-5.5753 1.174-11.234 1.7611-16.935 1.7611-15.217 0-30.182-4.2768-43.177-12.202 0.71263-1.174 5.1141-7.5474 5.1141-8.4698 0-0.79666-0.71263-1.5095-1.5091-1.5095-1.6348 0-5.1141 6.9603-6.1621 8.344-17.522-11.615-30.182-29.602-35.044-50.148l8.0066-1.761c0.92222-0.25158 1.1737-0.92246 1.1737-1.7611 0-0.79667-1.1737-1.2579-1.8444-1.174l-7.8389 1.803c-1.048-5.3251-1.6348-10.692-1.6348-16.143 0-15.556 4.4015-30.86 12.66-43.984 1.1737 0.71281 6.749 4.5284 7.6712 4.5284 0.79646 0 1.5091-0.58702 1.5091-1.3837 0-1.6353-6.1621-4.7381-7.5455-5.7024 11.821-17.275 29.805-29.728 50.219-34.34l1.7606 7.757c0.25152 0.92246 0.92222 1.174 1.7606 1.174 0.83838 0 1.2576-1.174 1.1737-1.8449l-1.7606-7.6732c5.1141-0.92246 10.312-1.5095 15.552-1.5095 15.552 0 30.727 4.4026 43.973 12.663-0.79646 1.174-4.5273 6.6249-4.5273 7.5474 0 0.79667 0.58687 1.5095 1.3833 1.5095 1.6348 0 4.7369-6.0379 5.5753-7.4216 17.187 11.615 29.469 29.351 34.248 49.561l-6.4975 1.3837c-1.048 0.25158-1.1737 0.92246-1.1737 1.8449 0 0.79667 1.1737 1.2579 1.7606 1.174l6.6232-1.5095c1.048 5.3251 1.6348 10.776 1.6348 16.227 0 15.221-4.1919 30.189-12.073 43.062-1.1737-0.58702-6.0364-4.0672-6.9586-4.0672-0.8803 0-1.5929 0.71281-1.5929 1.5095zm-14.876-98.483c-5.2178 4.88-53.863 49.48-55.228 51.8l-38.772 64.2c5.0974-4.76 53.863-49.6 55.108-51.72l38.892-64.28z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
               }
               .zee-launcher-unsupported-message {
               text-align: center;
               width: 250px;
               font-family: sans-serif;
               color: #ffffff;
               }
               .zee-launcher-unsupported-message-copy {
               border: 1px solid #ffffff;
               border-radius: 5px;
               margin-top: 10px;
               }
               #zee-launcher-unsupported-message-input {
               border: none;
               padding: 10px;
               border-radius: 0px;
               border-right: 1px solid #344B60;
               height: 40px;
               color: #ffffff;
               background-color: black;
               box-sizing: border-box;
               width: calc(100% - 65px);
               margin-left: 5px;
               }
               #zee-launcher-unsupported-message-button {
               background: none;
               border: none;
               outline: none;
               text-transform: uppercase;
               color: #ffffff;
               height: 40px;
               display: inline-block;
               width: 59px;
               }
               .zee-launcher-unsupported-message-before-copy {
               height: 100px;
               display: flex;
               flex-direction: column;
               justify-content: center;
               margin-top: 20px;
               }
               .zee-launcher-unsupported-message-copied .zee-launcher-unsupported-message-before-copy {
               display: none;
               }
               .zee-launcher-unsupported-message-after-copy {
               display: none;
               }
               .zee-launcher-unsupported-message-copied .zee-launcher-unsupported-message-after-copy {
               height: 100px;
               display: flex;
               flex-direction: column;
               justify-content: center;
               margin-top: 20px;
               }
            </style>
            <div class="zee-launcher-browser-logo"></div>
            <div class="zee-launcher-unsupported-message">Open with ${idealBrowser} to access this content.</div>
            <div class="zee-launcher-unsupported-message-before-copy">
               <div class="zee-launcher-unsupported-message ">Tap below to copy the address for easy pasting into ${idealBrowser}.</div>
               <div class="zee-launcher-unsupported-message-copy"><input id="zee-launcher-unsupported-message-input" type="text/"><button id="zee-launcher-unsupported-message-button">Copy</button></div>
            </div>
            <div class="zee-launcher-unsupported-message zee-launcher-unsupported-message-after-copy">COPIED! Now paste into ${idealBrowser}'s address bar to experience the content.</div>
    `;
    let inpElm = ret.querySelector("#zee-launcher-unsupported-message-input") || document.createElement("input");
    inpElm.value = window.location.href;
    let btnElm = ret.querySelector("#zee-launcher-unsupported-message-button") || document.createElement("button");
    let onCopyPressed = ()=>{
        if (navigator.userAgent.match(/iPhone|iPod|iPad/i)) {
            let r = document.createRange();
            r.selectNodeContents(inpElm);
            let sel = window.getSelection();
            if (!sel) return;
            sel.removeAllRanges();
            sel.addRange(r);
            inpElm.setSelectionRange(0, 999999999);
        } else inpElm.select();
        document.execCommand("copy");
        inpElm.blur();
        ret.classList.toggle("zee-launcher-unsupported-message-copied", true);
    };
    btnElm.addEventListener("click", onCopyPressed);
    inpElm.addEventListener("click", onCopyPressed);
    return ret;
}
const $87049b330e55d4f2$var$incompatibleUI = ()=>{
    const zapparCompatibility = document.createElement("div");
    zapparCompatibility.append($87049b330e55d4f2$var$getUnsupportedMessage());
    Object.assign(zapparCompatibility.style, {
        position: "fixed",
        width: "100%",
        height: "100%",
        top: "0px",
        left: "0px",
        zIndex: 1001,
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        fontFamily: "sans-serif",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    });
    zapparCompatibility.classList.add("zee_launcher_compatibility");
    document.body.append(zapparCompatibility);
};
function $87049b330e55d4f2$var$isSupportedBrowser() {
    if (typeof Promise !== "function") return false;
    if (typeof WebAssembly !== "object") return false;
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices || !navigator.mediaDevices.getUserMedia) return false;
    return true;
}
var $87049b330e55d4f2$export$2e2bcd8739ae039 = {
    incompatible: ()=>!$87049b330e55d4f2$var$isSupportedBrowser(),
    incompatible_ui: $87049b330e55d4f2$var$incompatibleUI
};








let $3865ed6da1bd89a5$var$latest = 1;
let $3865ed6da1bd89a5$var$byId = new Map();
class $3865ed6da1bd89a5$export$9035336025e5be06 extends (0, $be50c7577dd5f005$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._packetNumber = 0;
        this._motionUpdatesQueued = 0;
        this._motionUpdatesSent = 0;
        this._minFrameGapMs = 0;
        this._lastUpdateTime = 0;
    }
    static create(p) {
        let ret = $3865ed6da1bd89a5$var$latest++;
        $3865ed6da1bd89a5$var$byId.set(ret, new $3865ed6da1bd89a5$export$9035336025e5be06(ret, p));
        (0, $7c2568b0d857a09d$export$454156e929b28fe7)("sequence_source_source_t initialized");
        return ret;
    }
    static get(m) {
        return $3865ed6da1bd89a5$var$byId.get(m);
    }
    loadFromMemory(data) {
        try {
            this._decoder = new (0, $aa0232c24471fede$export$20801e67610bf5d8)(data);
            this._packetNumber = 0;
            this._lastUpdateTime = 0;
        } catch (err) {
            (0, $7c2568b0d857a09d$export$497c45d0bfe56de1)("Unable to decode sequence:", err);
        }
    }
    maxPlaybackFpsSet(fps) {
        if (fps <= 0) {
            this._minFrameGapMs = 0;
            return;
        }
        this._minFrameGapMs = 1000.0 / fps;
    }
    setTime(t) {
        if (t < 0) delete this._time;
        else this._time = t;
    }
    getFrame(currentlyProcessing) {
        var _a;
        let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        if (!this._decoder) return;
        this._submitMotionUpdates(pipeline);
        if (this._motionUpdatesQueued > this._motionUpdatesSent) return;
        if (currentlyProcessing) return;
        let curTime = (_a = this._time) !== null && _a !== void 0 ? _a : performance.now();
        if (curTime < this._lastUpdateTime + this._minFrameGapMs) return;
        if (this._packetNumber >= this._decoder.numberPackets) return;
        let packet = this._decoder.dataByPacket.get(this._packetNumber);
        if (packet.type != (0, $aa0232c24471fede$export$b970cf2e1a7b7c7b).CAMERA_FRAME) return;
        this._packetNumber++;
        let pixels = pipeline.cameraPixelArrays.pop();
        while(pixels){
            if (pixels.byteLength === packet.greyscale.byteLength) break;
            pixels = pipeline.cameraPixelArrays.pop();
        }
        if (!pixels) pixels = new ArrayBuffer(packet.greyscale.byteLength);
        new Uint8Array(pixels).set(packet.greyscale);
        this._lastUpdateTime = curTime;
        let info = {
            data: pixels,
            cameraSourceData: packet.greyscale,
            cameraModel: packet.cameraModel,
            cameraToDevice: packet.cameraToDevice,
            dataWidth: packet.width,
            dataHeight: packet.height,
            texture: undefined,
            userFacing: packet.userFacing,
            uvTransform: (0, $2e616e7f2b93d8b0$exports).create(),
            cameraSource: this
        };
        // We can queue the motion updates for the follwing frame immediately
        // as this camera frame will be sent immediately, but the next motion
        // updates will be one frame later
        this._submitMotionUpdates(pipeline);
        const token = pipeline.registerToken(info);
        pipeline.sendDataToWorker(info.data || new ArrayBuffer(0), token, info.dataWidth, info.dataHeight, info.userFacing, info.cameraToDevice, info.cameraModel);
    }
    destroy() {
        $3865ed6da1bd89a5$var$byId.delete(this._impl);
        this.pause();
    }
    start() {
        var _a;
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
    }
    pause() {
        let p = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
    }
    uploadGL(info) {
        let pipeline = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!gl) return;
        if (!info.texture) info.texture = pipeline.getVideoTexture();
        if (!info.texture) return;
        if (!info.cameraSourceData) return;
        gl.bindTexture(gl.TEXTURE_2D, info.texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, info.dataWidth, info.dataHeight, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, new Uint8Array(info.cameraSourceData));
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    _submitMotionUpdates(pipeline) {
        let pendingMotionUpdate = false;
        while(this._packetNumber < this._decoder.numberPackets){
            let packet = this._decoder.dataByPacket.get(this._packetNumber);
            if (packet.type == (0, $aa0232c24471fede$export$b970cf2e1a7b7c7b).CAMERA_FRAME) break;
            switch(packet.type){
                case (0, $aa0232c24471fede$export$b970cf2e1a7b7c7b).ACCELEROMETER:
                    pipeline.motionAccelerometerSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $aa0232c24471fede$export$b970cf2e1a7b7c7b).ROTATION_RATE:
                    pipeline.motionRotationRateSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $aa0232c24471fede$export$b970cf2e1a7b7c7b).ATTITUDE:
                    pipeline.motionAttitudeSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $aa0232c24471fede$export$b970cf2e1a7b7c7b).ATTITUDE_MATRIX:
                    pipeline.motionAttitudeMatrix(packet.attitude);
                    pendingMotionUpdate = true;
                    break;
            }
            this._packetNumber++;
        }
        // If we've submitted motion updates, add a setTimeout to reflect when
        // the message serializer will actually have sent them over to the worker
        if (pendingMotionUpdate) {
            this._motionUpdatesQueued++;
            setTimeout(()=>{
                this._motionUpdatesSent++;
            }, 0);
        }
        return;
    }
}



const $94a9f4415579ac11$export$4cf8838f9102a661 = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="250" height="80.408" viewBox="0 0 250 80.408"><defs><filter id="a" x="0" y="1.182" width="250" height="79.226" filterUnits="userSpaceOnUse"><feOffset dy="3" input="SourceAlpha"/><feGaussianBlur stdDeviation="3" result="b"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="c" x="6.929" y="0" width="111.975" height="40.988" filterUnits="userSpaceOnUse"><feOffset dy="3" input="SourceAlpha"/><feGaussianBlur stdDeviation="3" result="d"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-26.873 -414.029)"><g transform="translate(44 423.332)"><g transform="translate(0 0.635)" style="isolation:isolate"><g transform="translate(0 0)"><g transform="matrix(1, 0, 0, 1, -17.13, -9.94)" filter="url(#a)"><path d="M55.766,44.97V11.8h8.272v2.6h.089a8.258,8.258,0,0,1,7.046-3.357,11.4,11.4,0,0,1,8.5,3.686,12.667,12.667,0,0,1,3.278,8.622,12.509,12.509,0,0,1-3.25,8.57,11.353,11.353,0,0,1-8.429,3.6,9.533,9.533,0,0,1-7.229-2.95V43.378l-8.269,1.594h0Zm8-21.671a4.958,4.958,0,0,0,5.319,5.15A4.957,4.957,0,0,0,74.4,23.3a5.321,5.321,0,0,0-10.638,0ZM16.105,18.412H2.752V11.038H30.9L14.887,37.16H38.22L0,44.534ZM131.469,38.45a.761.761,0,0,1-.484-.166.582.582,0,0,1-.228-.419l-.553-3.586a12.243,12.243,0,0,1-1.782-.721l-2.789,2.084a.718.718,0,0,1-.5.176.688.688,0,0,1-.495-.214,25.864,25.864,0,0,1-3.264-3.274.754.754,0,0,1,.018-.9c.2-.277.543-.713,1.01-1.3.483-.6.832-1.05,1.068-1.374a9.614,9.614,0,0,1-.811-1.929l-3.62-.527a.631.631,0,0,1-.416-.243.728.728,0,0,1-.159-.458V21.283a.743.743,0,0,1,.159-.448.6.6,0,0,1,.376-.253l3.68-.546a9.511,9.511,0,0,1,.772-1.792c-.523-.733-1.235-1.638-2.117-2.69a.731.731,0,0,1-.2-.467.82.82,0,0,1,.178-.449,19.577,19.577,0,0,1,1.949-2.095c.953-.924,1.582-1.393,1.87-1.393a.861.861,0,0,1,.515.195l2.729,2.084a11.551,11.551,0,0,1,1.8-.741,31.446,31.446,0,0,1,.573-3.623.666.666,0,0,1,.712-.546h4.392a.757.757,0,0,1,.485.166.58.58,0,0,1,.228.419l.553,3.584a12.576,12.576,0,0,1,1.782.722l2.809-2.085a.641.641,0,0,1,.475-.176.776.776,0,0,1,.5.195,27.035,27.035,0,0,1,3.264,3.313.625.625,0,0,1,.139.429.742.742,0,0,1-.159.447c-.2.271-.525.7-1.008,1.3-.467.581-.827,1.043-1.069,1.373a11.8,11.8,0,0,1,.812,1.91l3.62.545a.626.626,0,0,1,.416.244.736.736,0,0,1,.158.457v4.325a.755.755,0,0,1-.158.449.6.6,0,0,1-.4.253l-3.66.545a12.692,12.692,0,0,1-.772,1.774c.465.653,1.177,1.559,2.117,2.688a.751.751,0,0,1,.2.488.648.648,0,0,1-.178.448,19.638,19.638,0,0,1-1.958,2.1c-.947.918-1.573,1.384-1.861,1.384a.976.976,0,0,1-.515-.176l-2.731-2.1a11.361,11.361,0,0,1-1.8.741,31.849,31.849,0,0,1-.573,3.625.668.668,0,0,1-.713.546Zm-1.385-18.491a4.935,4.935,0,0,0,0,7.053,5.12,5.12,0,0,0,7.163,0,4.931,4.931,0,0,0,0-7.053,5.117,5.117,0,0,0-7.163,0Zm69.969,14.868a18.523,18.523,0,0,1-4.932-2.073l1.705-6.1A13.441,13.441,0,0,0,200.779,29a12.14,12.14,0,0,0,4.344.818,4.644,4.644,0,0,0,2.351-.482,1.538,1.538,0,0,0,.806-1.4q0-1.5-3.25-2.242-1.061-.246-1.705-.425a12.335,12.335,0,0,1-5.358-2.589,5.5,5.5,0,0,1-1.671-4.157,6.323,6.323,0,0,1,2.547-5.267,10.993,10.993,0,0,1,6.9-1.972,21.351,21.351,0,0,1,4.552.5,25.439,25.439,0,0,1,4.736,1.557l-1.705,5.491a14.244,14.244,0,0,0-3.319-1.636,10.6,10.6,0,0,0-3.364-.561,4.227,4.227,0,0,0-2.121.426,1.357,1.357,0,0,0-.714,1.232q0,1.211,3.227,2.04.737.2,1.106.291,4.264,1.187,5.935,2.79a5.728,5.728,0,0,1,1.67,4.337A6.781,6.781,0,0,1,213,33.37a11.48,11.48,0,0,1-7.259,2.14A22.577,22.577,0,0,1,200.053,34.827ZM30.568,31.834a12.566,12.566,0,0,1-3.292-8.59,12.567,12.567,0,0,1,3.247-8.568,11.3,11.3,0,0,1,8.423-3.638,9.519,9.519,0,0,1,7.217,3V11.8h8.264V34.735H46.163V32.186h-.09c-1.32,2.071-3.951,3.308-7.038,3.308A11.412,11.412,0,0,1,30.568,31.834Zm5.245-8.545a4.95,4.95,0,0,0,5.312,5.141,4.95,4.95,0,0,0,5.312-5.141A5.023,5.023,0,0,0,41.125,18.1,5.023,5.023,0,0,0,35.813,23.289Zm69.2,11.554-3.527-10.452q-.282-.892-.505-1.8t-.412-1.8a30.821,30.821,0,0,1-.917,3.454l-.047.16L96.1,34.842H90.176l-9.925-23.1h8.632l3.552,10.223q.4,1.12.634,1.955t.377,1.635a23.558,23.558,0,0,1,.917-3.179q.093-.274.141-.411l3.528-10.223h5.056l3.5,10.2.07.183a20.724,20.724,0,0,1,.988,3.43q.141-.732.364-1.532t.647-2.058l3.574-10.223h8.678l-9.971,23.1Zm80.154-.092-8.587-9.841v9.841h-7.888V1.5L176.583,0V22.28l8.272-9.665h9.96L184.584,23.266l11.156,11.485Zm-35.09,0V11.782h8.272v3.761h.091a8.131,8.131,0,0,1,7.546-4.074h1.593V19.3a6.8,6.8,0,0,0-3.5-.761c-4.593,0-5.728,3-5.728,6.941v9.268Z" transform="translate(17.13 15.31)"/></g><g transform="matrix(1, 0, 0, 1, -17.13, -9.94)" filter="url(#c)"><path d="M3.576-12.852v-4.3H6.628a2.867,2.867,0,0,1,1.945.55A2.034,2.034,0,0,1,9.188-15a2.06,2.06,0,0,1-.615,1.608,2.784,2.784,0,0,1-1.945.542ZM2.017-18.464V-6.748H3.576v-4.792H7.153a3.569,3.569,0,0,0,2.683-.9A3.478,3.478,0,0,0,10.747-15a3.45,3.45,0,0,0-.911-2.552,3.638,3.638,0,0,0-2.683-.911Zm11.421,7.483a4.221,4.221,0,0,1,.205-1.37,2.957,2.957,0,0,1,.566-1.009,2.411,2.411,0,0,1,.845-.624A2.515,2.515,0,0,1,16.08-14.2a2.515,2.515,0,0,1,1.026.213,2.411,2.411,0,0,1,.845.624,2.957,2.957,0,0,1,.566,1.009,4.221,4.221,0,0,1,.205,1.37,4.221,4.221,0,0,1-.205,1.37,2.867,2.867,0,0,1-.566,1,2.457,2.457,0,0,1-.845.615,2.515,2.515,0,0,1-1.026.213,2.515,2.515,0,0,1-1.026-.213,2.457,2.457,0,0,1-.845-.615,2.867,2.867,0,0,1-.566-1A4.221,4.221,0,0,1,13.438-10.981Zm-1.477,0a5.573,5.573,0,0,0,.263,1.739,3.97,3.97,0,0,0,.788,1.4,3.623,3.623,0,0,0,1.3.935,4.4,4.4,0,0,0,1.772.336A4.381,4.381,0,0,0,17.86-6.9a3.641,3.641,0,0,0,1.288-.935,3.97,3.97,0,0,0,.788-1.4,5.573,5.573,0,0,0,.263-1.739,5.65,5.65,0,0,0-.263-1.748,3.96,3.96,0,0,0-.788-1.411,3.729,3.729,0,0,0-1.288-.944,4.29,4.29,0,0,0-1.78-.345,4.3,4.3,0,0,0-1.772.345,3.71,3.71,0,0,0-1.3.944,3.96,3.96,0,0,0-.788,1.411A5.65,5.65,0,0,0,11.961-10.981Zm18.28,4.234,2.708-8.484H31.5L29.6-8.29h-.033L27.8-15.231H26.27L24.564-8.29h-.033l-1.92-6.941H21.068l2.724,8.484H25.3l1.707-6.744h.033l1.723,6.744ZM40.169-11.8H35.3a2.905,2.905,0,0,1,.213-.927A2.473,2.473,0,0,1,36-13.492a2.255,2.255,0,0,1,.747-.517,2.429,2.429,0,0,1,.976-.189,2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,40.169-11.8Zm1.346,2.363H40.136a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.105,5.105,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,41.515-9.439Zm1.526-5.793v8.484h1.395v-3.774a5.8,5.8,0,0,1,.164-1.452,2.784,2.784,0,0,1,.525-1.075,2.251,2.251,0,0,1,.952-.673,3.945,3.945,0,0,1,1.428-.23v-1.477a3.135,3.135,0,0,0-1.871.459,3.779,3.779,0,0,0-1.247,1.526h-.033v-1.789ZM54.15-11.8H49.276a2.905,2.905,0,0,1,.213-.927,2.473,2.473,0,0,1,.492-.763,2.255,2.255,0,0,1,.747-.517A2.429,2.429,0,0,1,51.7-14.2a2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,54.15-11.8ZM55.5-9.439H54.117a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.1,5.1,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,55.5-9.439Zm2.593-1.477a5.581,5.581,0,0,1,.131-1.214,3.212,3.212,0,0,1,.427-1.05,2.221,2.221,0,0,1,.788-.738,2.4,2.4,0,0,1,1.2-.279,2.589,2.589,0,0,1,1.231.271,2.389,2.389,0,0,1,.829.714,2.985,2.985,0,0,1,.468,1.026,4.889,4.889,0,0,1,.148,1.206,4.919,4.919,0,0,1-.139,1.165,3.053,3.053,0,0,1-.451,1.026,2.4,2.4,0,0,1-.8.73,2.4,2.4,0,0,1-1.2.279,2.491,2.491,0,0,1-1.173-.263,2.332,2.332,0,0,1-.82-.706,3.122,3.122,0,0,1-.476-1.009A4.338,4.338,0,0,1,58.088-10.916Zm6.564,4.168V-18.464H63.257V-14.1h-.033a2.247,2.247,0,0,0-.566-.632,3.216,3.216,0,0,0-.714-.41,3.583,3.583,0,0,0-.755-.222,4.132,4.132,0,0,0-.706-.066,3.861,3.861,0,0,0-1.7.353,3.487,3.487,0,0,0-1.214.952,4.018,4.018,0,0,0-.722,1.4,5.985,5.985,0,0,0-.238,1.707,5.8,5.8,0,0,0,.246,1.707,4.218,4.218,0,0,0,.73,1.411,3.529,3.529,0,0,0,1.214.968,3.827,3.827,0,0,0,1.715.361,4.135,4.135,0,0,0,1.625-.312A2.053,2.053,0,0,0,63.224-7.9h.033v1.149Zm6.761-11.716V-6.748h1.395V-7.88h.033a2.247,2.247,0,0,0,.566.632,2.982,2.982,0,0,0,.714.4,3.874,3.874,0,0,0,.763.213,4.193,4.193,0,0,0,.7.066,3.94,3.94,0,0,0,1.7-.345,3.4,3.4,0,0,0,1.214-.944,4.018,4.018,0,0,0,.722-1.4,5.985,5.985,0,0,0,.238-1.707,5.8,5.8,0,0,0-.246-1.707,4.312,4.312,0,0,0-.73-1.419,3.488,3.488,0,0,0-1.214-.976,3.827,3.827,0,0,0-1.715-.361,4.043,4.043,0,0,0-1.625.32,2.088,2.088,0,0,0-1.083,1.026h-.033v-4.381Zm6.564,7.4a5.581,5.581,0,0,1-.131,1.214,3.212,3.212,0,0,1-.427,1.05,2.243,2.243,0,0,1-.779.738,2.385,2.385,0,0,1-1.206.279A2.589,2.589,0,0,1,74.2-8.052a2.389,2.389,0,0,1-.829-.714,2.985,2.985,0,0,1-.468-1.026A4.889,4.889,0,0,1,72.758-11a4.919,4.919,0,0,1,.139-1.165,3.053,3.053,0,0,1,.451-1.026,2.4,2.4,0,0,1,.8-.73,2.4,2.4,0,0,1,1.2-.279,2.491,2.491,0,0,1,1.173.263,2.332,2.332,0,0,1,.82.706,3.122,3.122,0,0,1,.476,1.009A4.338,4.338,0,0,1,77.976-11.063Zm6.449,5.448a8.871,8.871,0,0,1-.484,1.05,2.871,2.871,0,0,1-.525.7,1.782,1.782,0,0,1-.64.394,2.462,2.462,0,0,1-.812.123,3.721,3.721,0,0,1-.492-.033A2.324,2.324,0,0,1,81-3.5v-1.28a2.342,2.342,0,0,0,.418.139,1.765,1.765,0,0,0,.4.057,1.2,1.2,0,0,0,.714-.205,1.255,1.255,0,0,0,.435-.583L83.539-6.8l-3.364-8.434h1.575L84.228-8.29h.033l2.379-6.941h1.477Z" transform="translate(17.85 28.4)"/></g></g></g><g transform="translate(0 0)"><g transform="translate(0 5.371)"><path d="M11.76,24.456A11.41,11.41,0,0,1,3.292,20.8,12.564,12.564,0,0,1,0,12.206,12.569,12.569,0,0,1,3.246,3.638,11.307,11.307,0,0,1,11.67,0a9.519,9.519,0,0,1,7.217,3V.759h8.264V23.7H18.887V21.148H18.8C17.478,23.219,14.846,24.456,11.76,24.456ZM13.849,7.064A5.023,5.023,0,0,0,8.537,12.25a4.95,4.95,0,0,0,5.312,5.141A4.95,4.95,0,0,0,19.16,12.25,5.023,5.023,0,0,0,13.849,7.064Z" transform="translate(27.277 11.038)" fill="#fff"/><path d="M0,33.931V.758H8.271v2.6H8.36A8.258,8.258,0,0,1,15.406,0,11.4,11.4,0,0,1,23.9,3.686a12.665,12.665,0,0,1,3.278,8.622,12.508,12.508,0,0,1-3.25,8.57,11.351,11.351,0,0,1-8.429,3.6,9.535,9.535,0,0,1-7.229-2.95V32.337L0,33.931ZM13.317,7.07A5.028,5.028,0,0,0,8,12.259a4.957,4.957,0,0,0,5.319,5.15,4.957,4.957,0,0,0,5.319-5.15A5.028,5.028,0,0,0,13.317,7.07Z" transform="translate(55.766 11.041)" fill="#fff"/><path d="M22.836,0l3.5,10.2.07.183a20.748,20.748,0,0,1,.988,3.43q.141-.731.364-1.532t.647-2.058L31.985,0h8.678L30.691,23.1H24.764L21.237,12.647q-.282-.891-.505-1.8t-.412-1.8A30.927,30.927,0,0,1,19.4,12.51l-.047.16L15.851,23.1H9.925L0,0H8.631l3.552,10.223q.4,1.121.635,1.955t.377,1.635a23.522,23.522,0,0,1,.917-3.179q.093-.274.141-.411L17.78,0h5.056" transform="translate(80.251 11.743)" fill="#fff"/><path d="M0,34.75V1.5L7.888,0V22.28l8.272-9.665H26.12L15.889,23.266,27.045,34.75H16.475L7.888,24.91v9.84H0" transform="translate(168.695 0)" fill="#fff"/><path d="M0,21.47l1.705-6.1a13.453,13.453,0,0,0,3.952,2.342A12.145,12.145,0,0,0,10,18.534a4.643,4.643,0,0,0,2.351-.482,1.539,1.539,0,0,0,.807-1.4q0-1.5-3.25-2.241-1.06-.246-1.705-.426A12.325,12.325,0,0,1,2.846,11.4,5.5,5.5,0,0,1,1.176,7.239,6.324,6.324,0,0,1,3.722,1.972,11,11,0,0,1,10.624,0a21.365,21.365,0,0,1,4.551.5,25.45,25.45,0,0,1,4.736,1.558l-1.706,5.49a14.24,14.24,0,0,0-3.319-1.636,10.6,10.6,0,0,0-3.364-.56A4.22,4.22,0,0,0,9.4,5.782a1.356,1.356,0,0,0-.714,1.233q0,1.211,3.227,2.04.737.2,1.106.291,4.264,1.188,5.935,2.79a5.728,5.728,0,0,1,1.671,4.337,6.782,6.782,0,0,1-2.743,5.614,11.478,11.478,0,0,1-7.259,2.14,22.565,22.565,0,0,1-5.693-.683A18.517,18.517,0,0,1,0,21.47" transform="translate(195.121 11.284)" fill="#fff"/><path d="M8.273,4.075h.091A8.13,8.13,0,0,1,15.909,0H17.5V7.834A6.8,6.8,0,0,0,14,7.074c-4.593,0-5.728,3-5.728,6.941v9.268H0V.313H8.273V4.075" transform="translate(150.08 11.469)" fill="#fff"/><path d="M17.392,29.929H13a.76.76,0,0,1-.485-.166.579.579,0,0,1-.227-.419l-.553-3.586a12.3,12.3,0,0,1-1.781-.721L7.163,27.123a.719.719,0,0,1-.495.176.687.687,0,0,1-.495-.214A25.873,25.873,0,0,1,2.91,23.81a.753.753,0,0,1,.019-.9c.2-.277.542-.713,1.009-1.3.483-.6.832-1.05,1.068-1.374a9.591,9.591,0,0,1-.811-1.929l-3.62-.526a.63.63,0,0,1-.416-.243A.729.729,0,0,1,0,17.089V12.762a.746.746,0,0,1,.159-.448.6.6,0,0,1,.376-.253l3.68-.546a9.5,9.5,0,0,1,.772-1.792C4.464,8.991,3.752,8.085,2.87,7.034a.732.732,0,0,1-.2-.468.82.82,0,0,1,.179-.449A19.622,19.622,0,0,1,4.8,4.023C5.751,3.1,6.38,2.631,6.668,2.631a.859.859,0,0,1,.515.194L9.913,4.91a11.536,11.536,0,0,1,1.8-.741A31.372,31.372,0,0,1,12.287.546.665.665,0,0,1,13,0h4.392a.755.755,0,0,1,.485.166.581.581,0,0,1,.229.419l.553,3.584a12.543,12.543,0,0,1,1.781.722L23.25,2.807a.641.641,0,0,1,.475-.176.775.775,0,0,1,.495.194,27.092,27.092,0,0,1,3.264,3.313.625.625,0,0,1,.139.429.745.745,0,0,1-.159.448c-.2.271-.525.695-1.008,1.3-.467.581-.827,1.043-1.069,1.373a11.784,11.784,0,0,1,.812,1.91l3.62.545a.625.625,0,0,1,.416.244.736.736,0,0,1,.157.458v4.325a.754.754,0,0,1-.157.449.606.606,0,0,1-.4.253l-3.66.545a12.628,12.628,0,0,1-.772,1.774c.465.654,1.177,1.559,2.117,2.688a.752.752,0,0,1,.2.488.648.648,0,0,1-.177.448,19.641,19.641,0,0,1-1.959,2.1c-.947.918-1.573,1.384-1.86,1.384a.978.978,0,0,1-.515-.176l-2.731-2.1a11.429,11.429,0,0,1-1.8.741,32.016,32.016,0,0,1-.573,3.624A.668.668,0,0,1,17.392,29.929ZM15.2,9.976a4.938,4.938,0,0,0-3.582,1.463,4.935,4.935,0,0,0,0,7.053,5.12,5.12,0,0,0,7.163,0,4.932,4.932,0,0,0,0-7.053A4.938,4.938,0,0,0,15.2,9.976Z" transform="translate(118.47 8.521)" fill="#fff"/><path d="M0,33.5,16.106,7.374H2.752V0H30.9L14.887,26.122H38.22L0,33.5" transform="translate(0 11.038)" fill="#fff"/></g><path d="M3.576-12.852v-4.3H6.628a2.867,2.867,0,0,1,1.945.55A2.034,2.034,0,0,1,9.188-15a2.06,2.06,0,0,1-.615,1.608,2.784,2.784,0,0,1-1.945.542ZM2.017-18.464V-6.748H3.576v-4.792H7.153a3.569,3.569,0,0,0,2.683-.9A3.478,3.478,0,0,0,10.747-15a3.45,3.45,0,0,0-.911-2.552,3.638,3.638,0,0,0-2.683-.911Zm11.421,7.483a4.221,4.221,0,0,1,.205-1.37,2.957,2.957,0,0,1,.566-1.009,2.411,2.411,0,0,1,.845-.624A2.515,2.515,0,0,1,16.08-14.2a2.515,2.515,0,0,1,1.026.213,2.411,2.411,0,0,1,.845.624,2.957,2.957,0,0,1,.566,1.009,4.221,4.221,0,0,1,.205,1.37,4.221,4.221,0,0,1-.205,1.37,2.867,2.867,0,0,1-.566,1,2.457,2.457,0,0,1-.845.615,2.515,2.515,0,0,1-1.026.213,2.515,2.515,0,0,1-1.026-.213,2.457,2.457,0,0,1-.845-.615,2.867,2.867,0,0,1-.566-1A4.221,4.221,0,0,1,13.438-10.981Zm-1.477,0a5.573,5.573,0,0,0,.263,1.739,3.97,3.97,0,0,0,.788,1.4,3.623,3.623,0,0,0,1.3.935,4.4,4.4,0,0,0,1.772.336A4.381,4.381,0,0,0,17.86-6.9a3.641,3.641,0,0,0,1.288-.935,3.97,3.97,0,0,0,.788-1.4,5.573,5.573,0,0,0,.263-1.739,5.65,5.65,0,0,0-.263-1.748,3.96,3.96,0,0,0-.788-1.411,3.729,3.729,0,0,0-1.288-.944,4.29,4.29,0,0,0-1.78-.345,4.3,4.3,0,0,0-1.772.345,3.71,3.71,0,0,0-1.3.944,3.96,3.96,0,0,0-.788,1.411A5.65,5.65,0,0,0,11.961-10.981Zm18.28,4.234,2.708-8.484H31.5L29.6-8.29h-.033L27.8-15.231H26.27L24.564-8.29h-.033l-1.92-6.941H21.068l2.724,8.484H25.3l1.707-6.744h.033l1.723,6.744ZM40.169-11.8H35.3a2.905,2.905,0,0,1,.213-.927A2.473,2.473,0,0,1,36-13.492a2.255,2.255,0,0,1,.747-.517,2.429,2.429,0,0,1,.976-.189,2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,40.169-11.8Zm1.346,2.363H40.136a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.105,5.105,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,41.515-9.439Zm1.526-5.793v8.484h1.395v-3.774a5.8,5.8,0,0,1,.164-1.452,2.784,2.784,0,0,1,.525-1.075,2.251,2.251,0,0,1,.952-.673,3.945,3.945,0,0,1,1.428-.23v-1.477a3.135,3.135,0,0,0-1.871.459,3.779,3.779,0,0,0-1.247,1.526h-.033v-1.789ZM54.15-11.8H49.276a2.905,2.905,0,0,1,.213-.927,2.473,2.473,0,0,1,.492-.763,2.255,2.255,0,0,1,.747-.517A2.429,2.429,0,0,1,51.7-14.2a2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,54.15-11.8ZM55.5-9.439H54.117a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.1,5.1,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,55.5-9.439Zm2.593-1.477a5.581,5.581,0,0,1,.131-1.214,3.212,3.212,0,0,1,.427-1.05,2.221,2.221,0,0,1,.788-.738,2.4,2.4,0,0,1,1.2-.279,2.589,2.589,0,0,1,1.231.271,2.389,2.389,0,0,1,.829.714,2.985,2.985,0,0,1,.468,1.026,4.889,4.889,0,0,1,.148,1.206,4.919,4.919,0,0,1-.139,1.165,3.053,3.053,0,0,1-.451,1.026,2.4,2.4,0,0,1-.8.73,2.4,2.4,0,0,1-1.2.279,2.491,2.491,0,0,1-1.173-.263,2.332,2.332,0,0,1-.82-.706,3.122,3.122,0,0,1-.476-1.009A4.338,4.338,0,0,1,58.088-10.916Zm6.564,4.168V-18.464H63.257V-14.1h-.033a2.247,2.247,0,0,0-.566-.632,3.216,3.216,0,0,0-.714-.41,3.583,3.583,0,0,0-.755-.222,4.132,4.132,0,0,0-.706-.066,3.861,3.861,0,0,0-1.7.353,3.487,3.487,0,0,0-1.214.952,4.018,4.018,0,0,0-.722,1.4,5.985,5.985,0,0,0-.238,1.707,5.8,5.8,0,0,0,.246,1.707,4.218,4.218,0,0,0,.73,1.411,3.529,3.529,0,0,0,1.214.968,3.827,3.827,0,0,0,1.715.361,4.135,4.135,0,0,0,1.625-.312A2.053,2.053,0,0,0,63.224-7.9h.033v1.149Zm6.761-11.716V-6.748h1.395V-7.88h.033a2.247,2.247,0,0,0,.566.632,2.982,2.982,0,0,0,.714.4,3.874,3.874,0,0,0,.763.213,4.193,4.193,0,0,0,.7.066,3.94,3.94,0,0,0,1.7-.345,3.4,3.4,0,0,0,1.214-.944,4.018,4.018,0,0,0,.722-1.4,5.985,5.985,0,0,0,.238-1.707,5.8,5.8,0,0,0-.246-1.707,4.312,4.312,0,0,0-.73-1.419,3.488,3.488,0,0,0-1.214-.976,3.827,3.827,0,0,0-1.715-.361,4.043,4.043,0,0,0-1.625.32,2.088,2.088,0,0,0-1.083,1.026h-.033v-4.381Zm6.564,7.4a5.581,5.581,0,0,1-.131,1.214,3.212,3.212,0,0,1-.427,1.05,2.243,2.243,0,0,1-.779.738,2.385,2.385,0,0,1-1.206.279A2.589,2.589,0,0,1,74.2-8.052a2.389,2.389,0,0,1-.829-.714,2.985,2.985,0,0,1-.468-1.026A4.889,4.889,0,0,1,72.758-11a4.919,4.919,0,0,1,.139-1.165,3.053,3.053,0,0,1,.451-1.026,2.4,2.4,0,0,1,.8-.73,2.4,2.4,0,0,1,1.2-.279,2.491,2.491,0,0,1,1.173.263,2.332,2.332,0,0,1,.82.706,3.122,3.122,0,0,1,.476,1.009A4.338,4.338,0,0,1,77.976-11.063Zm6.449,5.448a8.871,8.871,0,0,1-.484,1.05,2.871,2.871,0,0,1-.525.7,1.782,1.782,0,0,1-.64.394,2.462,2.462,0,0,1-.812.123,3.721,3.721,0,0,1-.492-.033A2.324,2.324,0,0,1,81-3.5v-1.28a2.342,2.342,0,0,0,.418.139,1.765,1.765,0,0,0,.4.057,1.2,1.2,0,0,0,.714-.205,1.255,1.255,0,0,0,.435-.583L83.539-6.8l-3.364-8.434h1.575L84.228-8.29h.033l2.379-6.941h1.477Z" transform="translate(0.722 18.464)" fill="#fff"/></g></g></g></svg>`;



var $d95d21c0e6d616ef$exports = {};

$parcel$export($d95d21c0e6d616ef$exports, "create", function () { return $d95d21c0e6d616ef$export$185802fd694ee1f5; });
$parcel$export($d95d21c0e6d616ef$exports, "clone", function () { return $d95d21c0e6d616ef$export$9cd59f9826255e47; });
$parcel$export($d95d21c0e6d616ef$exports, "fromValues", function () { return $d95d21c0e6d616ef$export$a82be99ed2a44a7d; });
$parcel$export($d95d21c0e6d616ef$exports, "copy", function () { return $d95d21c0e6d616ef$export$784d13d8ee351f07; });
$parcel$export($d95d21c0e6d616ef$exports, "set", function () { return $d95d21c0e6d616ef$export$adaa4cf7ef1b65be; });
$parcel$export($d95d21c0e6d616ef$exports, "add", function () { return $d95d21c0e6d616ef$export$e16d8520af44a096; });
$parcel$export($d95d21c0e6d616ef$exports, "subtract", function () { return $d95d21c0e6d616ef$export$4e2d2ead65e5f7e3; });
$parcel$export($d95d21c0e6d616ef$exports, "multiply", function () { return $d95d21c0e6d616ef$export$2060d2db72cce88f; });
$parcel$export($d95d21c0e6d616ef$exports, "divide", function () { return $d95d21c0e6d616ef$export$cd007d971a5a2143; });
$parcel$export($d95d21c0e6d616ef$exports, "ceil", function () { return $d95d21c0e6d616ef$export$803ce6b71a0a94b2; });
$parcel$export($d95d21c0e6d616ef$exports, "floor", function () { return $d95d21c0e6d616ef$export$a3fe094919f356fd; });
$parcel$export($d95d21c0e6d616ef$exports, "min", function () { return $d95d21c0e6d616ef$export$96ec731ed4dcb222; });
$parcel$export($d95d21c0e6d616ef$exports, "max", function () { return $d95d21c0e6d616ef$export$8960430cfd85939f; });
$parcel$export($d95d21c0e6d616ef$exports, "round", function () { return $d95d21c0e6d616ef$export$2077e0241d6afd3c; });
$parcel$export($d95d21c0e6d616ef$exports, "scale", function () { return $d95d21c0e6d616ef$export$dcdf75081b88279d; });
$parcel$export($d95d21c0e6d616ef$exports, "scaleAndAdd", function () { return $d95d21c0e6d616ef$export$19cedf1da84ba854; });
$parcel$export($d95d21c0e6d616ef$exports, "distance", function () { return $d95d21c0e6d616ef$export$9f17032d917177de; });
$parcel$export($d95d21c0e6d616ef$exports, "squaredDistance", function () { return $d95d21c0e6d616ef$export$88e6ebb4fe54f538; });
$parcel$export($d95d21c0e6d616ef$exports, "length", function () { return $d95d21c0e6d616ef$export$f24224f1c91d8156; });
$parcel$export($d95d21c0e6d616ef$exports, "squaredLength", function () { return $d95d21c0e6d616ef$export$ab44e1323ffc8376; });
$parcel$export($d95d21c0e6d616ef$exports, "negate", function () { return $d95d21c0e6d616ef$export$aef51622e549b8b0; });
$parcel$export($d95d21c0e6d616ef$exports, "inverse", function () { return $d95d21c0e6d616ef$export$70ae2c07e401031b; });
$parcel$export($d95d21c0e6d616ef$exports, "normalize", function () { return $d95d21c0e6d616ef$export$a3295358bff77e; });
$parcel$export($d95d21c0e6d616ef$exports, "dot", function () { return $d95d21c0e6d616ef$export$94132a0e348806d4; });
$parcel$export($d95d21c0e6d616ef$exports, "cross", function () { return $d95d21c0e6d616ef$export$bb646b20bb93d339; });
$parcel$export($d95d21c0e6d616ef$exports, "lerp", function () { return $d95d21c0e6d616ef$export$3a89f8d6f6bf6c9f; });
$parcel$export($d95d21c0e6d616ef$exports, "random", function () { return $d95d21c0e6d616ef$export$4385e60b38654f68; });
$parcel$export($d95d21c0e6d616ef$exports, "transformMat2", function () { return $d95d21c0e6d616ef$export$b732428d73874bfc; });
$parcel$export($d95d21c0e6d616ef$exports, "transformMat2d", function () { return $d95d21c0e6d616ef$export$3e55bc4b3707dfd3; });
$parcel$export($d95d21c0e6d616ef$exports, "transformMat3", function () { return $d95d21c0e6d616ef$export$f0bfa0a0024626ee; });
$parcel$export($d95d21c0e6d616ef$exports, "transformMat4", function () { return $d95d21c0e6d616ef$export$5ffbd13800309d59; });
$parcel$export($d95d21c0e6d616ef$exports, "rotate", function () { return $d95d21c0e6d616ef$export$bb628a54ab399bc9; });
$parcel$export($d95d21c0e6d616ef$exports, "angle", function () { return $d95d21c0e6d616ef$export$944b09d2ad10b378; });
$parcel$export($d95d21c0e6d616ef$exports, "zero", function () { return $d95d21c0e6d616ef$export$7f9972325ebfd559; });
$parcel$export($d95d21c0e6d616ef$exports, "str", function () { return $d95d21c0e6d616ef$export$42d51816ce590c93; });
$parcel$export($d95d21c0e6d616ef$exports, "exactEquals", function () { return $d95d21c0e6d616ef$export$f2599a5cf1109d8; });
$parcel$export($d95d21c0e6d616ef$exports, "equals", function () { return $d95d21c0e6d616ef$export$e9bab7fafb253603; });
$parcel$export($d95d21c0e6d616ef$exports, "len", function () { return $d95d21c0e6d616ef$export$fc1400facf92c78; });
$parcel$export($d95d21c0e6d616ef$exports, "sub", function () { return $d95d21c0e6d616ef$export$f93b5905241a7cca; });
$parcel$export($d95d21c0e6d616ef$exports, "mul", function () { return $d95d21c0e6d616ef$export$6e3a27864ab166fe; });
$parcel$export($d95d21c0e6d616ef$exports, "div", function () { return $d95d21c0e6d616ef$export$159d9494db57879b; });
$parcel$export($d95d21c0e6d616ef$exports, "dist", function () { return $d95d21c0e6d616ef$export$6c4a311cc157c764; });
$parcel$export($d95d21c0e6d616ef$exports, "sqrDist", function () { return $d95d21c0e6d616ef$export$2422cd6c492a8b3a; });
$parcel$export($d95d21c0e6d616ef$exports, "sqrLen", function () { return $d95d21c0e6d616ef$export$99d8dd3f32a3435; });
$parcel$export($d95d21c0e6d616ef$exports, "forEach", function () { return $d95d21c0e6d616ef$export$4b80e395e36b5a56; });

function $d95d21c0e6d616ef$export$185802fd694ee1f5() {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(2);
    if ($bddce99c0c610ba2$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $d95d21c0e6d616ef$export$9cd59f9826255e47(a) {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $d95d21c0e6d616ef$export$a82be99ed2a44a7d(x, y) {
    var out = new $bddce99c0c610ba2$export$b67359430d3b1b2(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $d95d21c0e6d616ef$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $d95d21c0e6d616ef$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $d95d21c0e6d616ef$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $d95d21c0e6d616ef$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $d95d21c0e6d616ef$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $d95d21c0e6d616ef$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $d95d21c0e6d616ef$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $d95d21c0e6d616ef$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $d95d21c0e6d616ef$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $d95d21c0e6d616ef$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $d95d21c0e6d616ef$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $d95d21c0e6d616ef$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $d95d21c0e6d616ef$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $d95d21c0e6d616ef$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $d95d21c0e6d616ef$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $d95d21c0e6d616ef$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $d95d21c0e6d616ef$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $d95d21c0e6d616ef$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $d95d21c0e6d616ef$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $d95d21c0e6d616ef$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $d95d21c0e6d616ef$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $d95d21c0e6d616ef$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $d95d21c0e6d616ef$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $d95d21c0e6d616ef$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $bddce99c0c610ba2$export$5ada478c8a628231() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $d95d21c0e6d616ef$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $d95d21c0e6d616ef$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $d95d21c0e6d616ef$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $d95d21c0e6d616ef$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $d95d21c0e6d616ef$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $d95d21c0e6d616ef$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $d95d21c0e6d616ef$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $d95d21c0e6d616ef$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $d95d21c0e6d616ef$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $d95d21c0e6d616ef$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $bddce99c0c610ba2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $d95d21c0e6d616ef$export$fc1400facf92c78 = $d95d21c0e6d616ef$export$f24224f1c91d8156;
var $d95d21c0e6d616ef$export$f93b5905241a7cca = $d95d21c0e6d616ef$export$4e2d2ead65e5f7e3;
var $d95d21c0e6d616ef$export$6e3a27864ab166fe = $d95d21c0e6d616ef$export$2060d2db72cce88f;
var $d95d21c0e6d616ef$export$159d9494db57879b = $d95d21c0e6d616ef$export$cd007d971a5a2143;
var $d95d21c0e6d616ef$export$6c4a311cc157c764 = $d95d21c0e6d616ef$export$9f17032d917177de;
var $d95d21c0e6d616ef$export$2422cd6c492a8b3a = $d95d21c0e6d616ef$export$88e6ebb4fe54f538;
var $d95d21c0e6d616ef$export$99d8dd3f32a3435 = $d95d21c0e6d616ef$export$ab44e1323ffc8376;
var $d95d21c0e6d616ef$export$4b80e395e36b5a56 = function() {
    var vec = $d95d21c0e6d616ef$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();



function $1212809addac11af$export$ccd5084c909b35f5(info) {
    switch(info.type){
        case (0, $cc08068a96912eec$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR:
            return $1212809addac11af$var$planar(info);
        case (0, $cc08068a96912eec$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CYLINDRICAL:
            return $1212809addac11af$var$cylindrical(info);
        case (0, $cc08068a96912eec$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CONICAL:
            return $1212809addac11af$var$conical(info);
    }
    return $1212809addac11af$var$defaultMesh();
}
function $1212809addac11af$var$planar(info) {
    const aspectRatio = info.trainedWidth / info.trainedHeight;
    if (isNaN(aspectRatio)) return $1212809addac11af$var$defaultMesh();
    const scaling = info.physicalScaleFactor > 0 ? info.physicalScaleFactor : 1;
    const vertices = new Float32Array([
        -1 * aspectRatio * scaling,
        -1 * scaling,
        0,
        -1 * aspectRatio * scaling,
        scaling,
        0,
        aspectRatio * scaling,
        scaling,
        0,
        aspectRatio * scaling,
        -1 * scaling,
        0
    ]);
    const indices = new Uint16Array([
        0,
        2,
        1,
        0,
        3,
        2
    ]);
    const uvs = new Float32Array([
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0
    ]);
    const normals = new Float32Array([
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1
    ]);
    return {
        vertices: vertices,
        indices: indices,
        uvs: uvs,
        normals: normals
    };
}
function $1212809addac11af$var$defaultMesh() {
    return {
        indices: new Uint16Array(0),
        vertices: new Float32Array(0),
        normals: new Float32Array(0),
        uvs: new Float32Array(0)
    };
}
function $1212809addac11af$var$cylindrical(info) {
    const wrap_amount = 2 * info.trainedWidth / (info.trainedHeight * info.topRadius);
    return $1212809addac11af$var$generalConical(info, 2, false, 0, 0, 0, (0, $d95d21c0e6d616ef$exports).create(), info.trainedWidth / info.trainedHeight, wrap_amount, info.physicalScaleFactor);
}
function $1212809addac11af$var$conical(info) {
    const radius_diff = info.topRadius - info.bottomRadius;
    // Prevents divide by zero errors.
    if (radius_diff === 0) {
        console.warn("Conical target has matching radii, using cylindrical preview mesh with a defined image size instead.");
        return $1212809addac11af$var$cylindrical(info);
    }
    const height_3d = Math.sqrt(info.sideLength * info.sideLength - radius_diff * radius_diff);
    const flip = info.bottomRadius > info.topRadius;
    let aspect_ratio = info.trainedWidth / info.trainedHeight;
    if (isNaN(aspect_ratio)) aspect_ratio = 1;
    const cone = !(info.bottomRadius > 0) || !(info.topRadius > 0);
    const wide = info.sideLength < 2 * Math.abs(info.topRadius - info.bottomRadius);
    const top_corner = (0, $d95d21c0e6d616ef$exports).create();
    const bottom_corner = (0, $d95d21c0e6d616ef$exports).create();
    const rotation_center = (0, $d95d21c0e6d616ef$exports).create();
    if (cone) {
        if (wide) {
            if (flip) {
                rotation_center[1] = aspect_ratio - 1;
                const omega = Math.acos((2 - aspect_ratio) / aspect_ratio);
                top_corner[0] = aspect_ratio * Math.sin(omega);
                top_corner[1] = aspect_ratio - 1 + aspect_ratio * Math.cos(omega);
                (0, $d95d21c0e6d616ef$exports).copy(bottom_corner, rotation_center);
            } else {
                rotation_center[1] = 1.0 - aspect_ratio;
                const omega = Math.PI + Math.acos((2 - aspect_ratio) / aspect_ratio);
                top_corner[0] = aspect_ratio * Math.sin(omega);
                top_corner[1] = 1 - aspect_ratio + aspect_ratio * Math.cos(omega);
                (0, $d95d21c0e6d616ef$exports).copy(bottom_corner, rotation_center);
            }
        } else if (flip) {
            rotation_center[1] = 1;
            (0, $d95d21c0e6d616ef$exports).copy(bottom_corner, rotation_center);
            top_corner[0] = aspect_ratio;
            top_corner[1] = 1 - Math.sqrt(4 - Math.pow(aspect_ratio, 2));
        } else {
            rotation_center[1] = -1;
            (0, $d95d21c0e6d616ef$exports).copy(bottom_corner, rotation_center);
            top_corner[0] = -aspect_ratio;
            top_corner[1] = Math.sqrt(4 - Math.pow(aspect_ratio, 2)) - 1;
        }
    } else if (wide) {
        if (flip) {
            rotation_center[1] = aspect_ratio - 1;
            const omega = Math.acos((2 - aspect_ratio) / aspect_ratio);
            top_corner[0] = aspect_ratio * Math.sin(omega);
            top_corner[1] = aspect_ratio - 1 + aspect_ratio * Math.cos(omega);
            bottom_corner[0] = (aspect_ratio - info.sideLength) * Math.sin(omega);
            bottom_corner[1] = aspect_ratio - 1 + (aspect_ratio - info.sideLength) * Math.cos(omega);
        } else {
            rotation_center[1] = 1.0 - aspect_ratio;
            const omega = Math.PI + Math.acos((2 - aspect_ratio) / aspect_ratio);
            top_corner[0] = aspect_ratio * Math.sin(omega);
            top_corner[1] = 1 - aspect_ratio + aspect_ratio * Math.cos(omega);
            bottom_corner[0] = (aspect_ratio - info.sideLength) * Math.sin(omega);
            bottom_corner[1] = 1 - aspect_ratio + (aspect_ratio - info.sideLength) * Math.cos(omega);
        }
    } else {
        const radius_ratio = flip ? info.topRadius / info.bottomRadius : info.bottomRadius / info.topRadius;
        if (flip) {
            bottom_corner[0] = radius_ratio * aspect_ratio;
            bottom_corner[1] = 1;
            top_corner[0] = aspect_ratio;
            top_corner[1] = 1 - Math.sqrt(info.sideLength * info.sideLength - (bottom_corner[0] - top_corner[0]) * (bottom_corner[0] - top_corner[0]));
            rotation_center[1] = top_corner[1] + top_corner[0] / (top_corner[0] - bottom_corner[0]) * (bottom_corner[1] - top_corner[1]);
        } else {
            bottom_corner[0] = -radius_ratio * aspect_ratio;
            bottom_corner[1] = -1;
            top_corner[0] = -aspect_ratio;
            top_corner[1] = Math.sqrt(info.sideLength * info.sideLength - (bottom_corner[0] - top_corner[0]) * (bottom_corner[0] - top_corner[0])) - 1;
            rotation_center[1] = top_corner[1] - -top_corner[0] / (bottom_corner[0] - top_corner[0]) * (top_corner[1] - bottom_corner[1]);
        }
    }
    const top_from_center = (0, $d95d21c0e6d616ef$exports).create();
    (0, $d95d21c0e6d616ef$exports).subtract(top_from_center, top_corner, rotation_center);
    const bottom_from_center = (0, $d95d21c0e6d616ef$exports).create();
    (0, $d95d21c0e6d616ef$exports).subtract(bottom_from_center, bottom_corner, rotation_center);
    const top_2d_radius = (0, $d95d21c0e6d616ef$exports).length(top_from_center);
    const bottom_2d_radius = (0, $d95d21c0e6d616ef$exports).length(bottom_from_center);
    let max_angle = 2 * Math.abs(Math.atan(top_from_center[0] / top_from_center[1]));
    if (wide) max_angle = 2 * Math.PI - max_angle;
    let theta_3d = top_2d_radius * max_angle / info.topRadius;
    let theta = Math.abs(Math.atan(top_from_center[0] / top_from_center[1]));
    if (wide) theta = Math.PI - theta;
    return $1212809addac11af$var$generalConical(info, height_3d, flip, theta, bottom_2d_radius, top_2d_radius, rotation_center, aspect_ratio, theta_3d, info.physicalScaleFactor);
}
function $1212809addac11af$var$generalConical(info, height_3d, flip, theta, bottom_2d_radius, top_2d_radius, rotation_center, aspect_ratio, wrap_amount, psf) {
    if (isNaN(aspect_ratio)) aspect_ratio = 1;
    const vertices = [];
    const uvs = [];
    const physical_scale = psf > 0 ? psf : 1;
    const scale_factor = physical_scale * 2.0 / height_3d;
    const subdivisons = 64;
    for(let s = 0; s <= subdivisons; ++s){
        const angle = s * wrap_amount / subdivisons + (2 * Math.PI - wrap_amount) / 2;
        const bx = info.bottomRadius * Math.sin(angle) * scale_factor;
        const bz = info.bottomRadius * Math.cos(angle) * scale_factor;
        const tx = info.topRadius * Math.sin(angle) * scale_factor;
        const tz = info.topRadius * Math.cos(angle) * scale_factor;
        const btm = -1 * physical_scale;
        const top = physical_scale;
        if (flip) {
            vertices.push(bx, btm, bz);
            vertices.push(tx, top, tz);
        } else {
            vertices.push(tx, top, -tz);
            vertices.push(bx, btm, -bz);
        }
    }
    for(let s = 0; s <= subdivisons; ++s)if (info.type == (0, $cc08068a96912eec$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CYLINDRICAL) {
        const offset = 1 - s / subdivisons;
        uvs.push(offset, 1);
        uvs.push(offset, 0);
    } else {
        let angle_2d = -(s / subdivisons - 0.5) * 2 * theta;
        if (flip) {
            angle_2d = -angle_2d + theta;
            if (angle_2d > theta) angle_2d = -theta + (angle_2d - theta);
        }
        const direction = (0, $d95d21c0e6d616ef$exports).create();
        direction[0] = Math.sin(angle_2d);
        direction[1] = Math.cos(angle_2d);
        if (flip) direction[1] *= -1;
        const bottom_px = (0, $d95d21c0e6d616ef$exports).create();
        (0, $d95d21c0e6d616ef$exports).copy(bottom_px, direction);
        (0, $d95d21c0e6d616ef$exports).scale(bottom_px, bottom_px, bottom_2d_radius);
        (0, $d95d21c0e6d616ef$exports).add(bottom_px, rotation_center, bottom_px);
        const top_px = (0, $d95d21c0e6d616ef$exports).create();
        (0, $d95d21c0e6d616ef$exports).copy(top_px, direction);
        (0, $d95d21c0e6d616ef$exports).scale(top_px, top_px, top_2d_radius);
        (0, $d95d21c0e6d616ef$exports).add(top_px, rotation_center, top_px);
        uvs.push((top_px[0] + aspect_ratio) / (2 * aspect_ratio), 1 - (-top_px[1] + 1) / 2);
        uvs.push((bottom_px[0] + aspect_ratio) / (2 * aspect_ratio), 1 - (-bottom_px[1] + 1) / 2);
    }
    const indices = [];
    for(let i = 0; i < subdivisons; ++i){
        const bi = i * 2;
        indices.push(bi + 1, bi + 2, bi + 3);
        indices.push(bi + 0, bi + 2, bi + 1);
    }
    return {
        vertices: new Float32Array(vertices),
        indices: new Uint16Array(indices),
        normals: new Float32Array(0),
        uvs: new Float32Array(uvs)
    };
}


const $7555afd7cafb1008$var$decoder = new TextDecoder();
class $7555afd7cafb1008$export$55f75071f06461bb {
    constructor(_data, _paddingBytes = false){
        this._data = _data;
        this._paddingBytes = _paddingBytes;
        this.truncatedChunks = false;
        this._view = new DataView(this._data);
        this.root = this._parse();
    }
    _parse() {
        const header = $7555afd7cafb1008$var$decoder.decode(this._data.slice(0, 4));
        if (header !== "RIFF") throw new Error("Not a valid ZPT file");
        return this._parseChunk(0);
    }
    _parseChunk(offset) {
        const ident = $7555afd7cafb1008$var$decoder.decode(this._data.slice(offset, offset + 4));
        const length = this._view.getUint32(offset + 4, true);
        const data = new Uint8Array(this._data, offset + 8, length);
        if (data.byteLength !== length) this.truncatedChunks = true;
        let subchunks;
        let subident;
        if (ident === "RIFF" || ident === "LIST") {
            subident = $7555afd7cafb1008$var$decoder.decode(this._data.slice(offset + 8, offset + 12));
            subchunks = [];
            let currentOffset = 4;
            while(currentOffset < data.byteLength - 1){
                const subchunk = this._parseChunk(offset + 8 + currentOffset);
                subchunks.push(subchunk);
                currentOffset += subchunk.data.byteLength + 8;
                if (this._paddingBytes && subchunk.data.byteLength & 0x1) currentOffset++;
            }
        }
        return {
            ident: ident,
            data: data,
            subident: subident,
            subchunks: subchunks
        };
    }
    find(str, inChunk = this.root) {
        if (inChunk.ident === str) return inChunk;
        if (!inChunk.subchunks) return;
        for (let c of inChunk.subchunks){
            const found = this.find(str, c);
            if (found) return found;
        }
    }
    has(str) {
        return this.find(str) !== undefined;
    }
}


let $303a97edb2d5e4e9$var$byId = new Map();
const $303a97edb2d5e4e9$var$decoder = new TextDecoder();
class $303a97edb2d5e4e9$export$333222788f3dd075 {
    constructor(_client, _impl){
        this._client = _client;
        this._impl = _impl;
        this._targets = [];
    }
    static create(pipeline, client) {
        let ret = client.image_tracker_create(pipeline);
        $303a97edb2d5e4e9$var$byId.set(ret, new $303a97edb2d5e4e9$export$333222788f3dd075(client, ret));
        return ret;
    }
    static get(p) {
        return $303a97edb2d5e4e9$var$byId.get(p);
    }
    destroy() {
        this._client.image_tracker_destroy(this._impl);
        $303a97edb2d5e4e9$var$byId.delete(this._impl);
    }
    loadFromMemory(data) {
        this._targets.push({
            data: data
        });
        this._client.image_tracker_target_load_from_memory(this._impl, data);
    }
    targetCount() {
        return this._targets.length;
    }
    getTargetInfo(i) {
        let current = this._targets[i];
        if (current && current.info) return current.info;
        current.info = {
            topRadius: -1,
            bottomRadius: -1,
            sideLength: -1,
            physicalScaleFactor: -1,
            trainedWidth: 0,
            trainedHeight: 0,
            type: (0, $cc08068a96912eec$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR
        };
        try {
            const reader = new (0, $7555afd7cafb1008$export$55f75071f06461bb)(current.data, false);
            const imgChunk = reader.find("IMG ");
            if (imgChunk) {
                let mimeType = "image/png";
                const mimeTypeChunk = reader.find("IMGM");
                if (mimeTypeChunk) mimeType = $303a97edb2d5e4e9$var$decoder.decode(mimeTypeChunk.data);
                current.info.preview = {
                    mimeType: mimeType,
                    compressed: imgChunk.data
                };
            }
            const odleChunk = reader.find("ODLE");
            if (odleChunk) {
                const odle = $303a97edb2d5e4e9$var$decoder.decode(odleChunk.data);
                this._parseOdle(odle, current.info);
            }
        } catch (err) {}
        return current.info;
    }
    _parseOdle(data, info) {
        let currentOffset = 0;
        let version = "0";
        [version, currentOffset] = $303a97edb2d5e4e9$var$readLine(currentOffset, data);
        if (version === "1") return this._parseOdleV1(data, currentOffset, info);
        else if (version === "3") return this._parseOdleV3(data, currentOffset, info);
    }
    _parseOdleV1(data, currentOffset, info) {
        let treeOrFlat = "0";
        [treeOrFlat, currentOffset] = $303a97edb2d5e4e9$var$readLine(currentOffset, data);
        if (treeOrFlat !== "0" && treeOrFlat !== "1") return;
        let emptyLine = "";
        [emptyLine, currentOffset] = $303a97edb2d5e4e9$var$readLine(currentOffset, data);
        if (emptyLine.length !== 0) return;
        let infoLine = "";
        [infoLine, currentOffset] = $303a97edb2d5e4e9$var$readLine(currentOffset, data);
        const infoLineParts = infoLine.split(" ");
        if (infoLineParts.length < 5) return;
        info.trainedWidth = parseInt(infoLineParts[3].replace("[", ""));
        info.trainedHeight = parseInt(infoLineParts[4].replace("]", ""));
    }
    _parseOdleV3(data, currentOffset, info) {
        let treeOrFlat = "0";
        [treeOrFlat, currentOffset] = $303a97edb2d5e4e9$var$readLine(currentOffset, data);
        if (treeOrFlat !== "0" && treeOrFlat !== "1") return;
        let numberTargets = "0";
        [numberTargets, currentOffset] = $303a97edb2d5e4e9$var$readLine(currentOffset, data);
        const parsedTargets = parseInt(numberTargets);
        if (isNaN(parsedTargets) || parsedTargets < 1) return;
        let emptyLine = "";
        [emptyLine, currentOffset] = $303a97edb2d5e4e9$var$readLine(currentOffset, data);
        if (emptyLine.length !== 0) return;
        let infoLine = "";
        [infoLine, currentOffset] = $303a97edb2d5e4e9$var$readLine(currentOffset, data);
        const infoLineParts = infoLine.split(" ");
        if (infoLineParts.length < 6) return;
        const targetType = parseInt(infoLineParts[0]);
        if (targetType === 0 || targetType === 1 || targetType === 2) info.type = targetType;
        info.trainedWidth = parseInt(infoLineParts[4].replace("[", ""));
        info.trainedHeight = parseInt(infoLineParts[5].replace("]", ""));
        if (infoLineParts.length >= 7) {
            info.physicalScaleFactor = parseFloat(infoLineParts[6]);
            if (isNaN(info.physicalScaleFactor)) info.physicalScaleFactor = -1;
        }
        if (infoLineParts.length >= 8) {
            info.topRadius = parseFloat(infoLineParts[7]);
            if (isNaN(info.topRadius)) info.topRadius = -1;
            info.bottomRadius = info.topRadius;
        }
        if (infoLineParts.length >= 9) {
            info.bottomRadius = parseFloat(infoLineParts[8]);
            if (isNaN(info.bottomRadius)) info.bottomRadius = -1;
        }
        if (infoLineParts.length >= 10) {
            info.sideLength = parseFloat(infoLineParts[9]);
            if (isNaN(info.sideLength)) info.sideLength = -1;
        }
    }
    getDecodedPreview(i) {
        const info = this.getTargetInfo(i);
        if (!info.preview) return undefined;
        if (!info.preview.image) {
            const blob = new Blob([
                info.preview.compressed
            ], {
                type: info.preview.mimeType
            });
            info.preview.image = new Image();
            info.preview.image.src = URL.createObjectURL(blob);
        }
        return info.preview.image;
    }
    getPreviewMesh(i) {
        const info = this.getTargetInfo(i);
        if (!info.previewMesh) info.previewMesh = (0, $1212809addac11af$export$ccd5084c909b35f5)(info);
        return info.previewMesh;
    }
}
function $303a97edb2d5e4e9$var$readLine(offset, str) {
    let indx = str.indexOf("\n", offset);
    return [
        str.substring(offset, indx >= 0 ? indx : undefined).replace("\r", ""),
        indx + 1
    ];
}


var $0c05329758a5f3b0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $0c05329758a5f3b0$var$client;
var $088099950f0f112a$exports = {};


$088099950f0f112a$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("kNvxM");



var $d81c1b20e0069481$exports = {};


$d81c1b20e0069481$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("98I7t");


function $0c05329758a5f3b0$export$2a47f398eeff8b01(opts) {
    if ($0c05329758a5f3b0$var$client) return $0c05329758a5f3b0$var$client;
    let loaded = false;
    (0, $4d81e838630131c6$exports.launchWorker)(opts === null || opts === void 0 ? void 0 : opts.worker).then(()=>{
        (0, $7c2568b0d857a09d$export$454156e929b28fe7)("Fully loaded");
        loaded = true;
    });
    let c = new (0, $fd7d2daf873ace75$export$ada9decabe1e7aa7)((ab)=>{
        (0, $4d81e838630131c6$exports.messageManager).postOutgoingMessage({
            t: "zappar",
            d: ab
        }, [
            ab
        ]);
    });
    if (window.location.hostname.toLowerCase().indexOf(".zappar.io") > 0 || window.location.hostname.toLowerCase().indexOf(".webar.run") > 0) {
        let pathParts = window.location.pathname.split("/");
        if (pathParts.length > 1 && pathParts[1].length > 0) c.impl.analytics_project_id_set(".wiz" + pathParts[1]);
    }
    (0, $4d81e838630131c6$exports.messageManager).onIncomingMessage.bind((msg)=>{
        var _a, _b, _c, _d, _e, _f, _g;
        switch(msg.t){
            case "zappar":
                (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(msg.p)) === null || _a === void 0 || _a.pendingMessages.push(msg.d);
                break;
            case "buf":
                c.serializer.bufferReturn(msg.d);
                break;
            case "cameraFrameRecycleS2C":
                {
                    let msgt = msg;
                    (_c = (_b = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(msgt.p)) === null || _b === void 0 ? void 0 : _b.cameraTokenReturn) === null || _c === void 0 || _c.call(_b, msg);
                    break;
                }
            case "videoFrameS2C":
                {
                    let msgt = msg;
                    (_e = (_d = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(msgt.p)) === null || _d === void 0 ? void 0 : _d.videoFrameFromWorker) === null || _e === void 0 || _e.call(_d, msgt);
                    break;
                }
            case "imageBitmapS2C":
                {
                    let msgt = msg;
                    (_g = (_f = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(msgt.p)) === null || _f === void 0 ? void 0 : _f.imageBitmapFromWorker) === null || _g === void 0 || _g.call(_f, msgt);
                    break;
                }
            case "licerr":
                {
                    let div = document.createElement("div");
                    div.innerHTML = "Visit <a href='https://docs.zap.works/universal-ar/licensing/' style='color: white;'>our licensing page</a> to find out about hosting on your own domain.";
                    div.style.position = "absolute";
                    div.style.bottom = "20px";
                    div.style.width = "80%";
                    div.style.backgroundColor = "black";
                    div.style.color = "white";
                    div.style.borderRadius = "10px";
                    div.style.padding = "10px";
                    div.style.fontFamily = "sans-serif";
                    div.style.textAlign = "center";
                    div.style.left = "10%";
                    div.style.zIndex = Number.MAX_SAFE_INTEGER.toString();
                    let span = document.createElement("span");
                    span.innerText = " (30)";
                    div.append(span);
                    let indx = 30;
                    setInterval(function() {
                        indx--;
                        if (indx >= 0) span.innerText = " (" + indx.toString() + ")";
                    }, 1000);
                    document.body.append(div);
                }
            case "gfx":
                {
                    let div = document.createElement("div");
                    div.innerHTML = (0, $94a9f4415579ac11$export$4cf8838f9102a661);
                    div.style.position = "absolute";
                    div.style.bottom = "20px";
                    div.style.width = "250px";
                    div.style.left = "50%";
                    div.style.marginLeft = "-125px";
                    div.style.zIndex = Number.MAX_SAFE_INTEGER.toString();
                    div.style.opacity = "0";
                    div.style.transition = "opacity 0.5s";
                    document.body.append(div);
                    setTimeout(function() {
                        div.style.opacity = "1";
                    }, 500);
                    setTimeout(function() {
                        div.style.opacity = "0";
                    }, 3000);
                    setTimeout(function() {
                        div.remove();
                    }, 4000);
                }
        }
    });
    $0c05329758a5f3b0$var$client = Object.assign(Object.assign({}, c.impl), {
        loaded: ()=>loaded,
        camera_default_device_id: (userFacing)=>userFacing ? (0, $3e93c4f9b3b7cc91$exports.CameraSource).USER_DEFAULT_DEVICE_ID : (0, $3e93c4f9b3b7cc91$exports.CameraSource).DEFAULT_DEVICE_ID,
        camera_source_create: (p, deviceId)=>(0, $89fa42ee9de7dcc1$export$3612a413b5e57058)(p, deviceId),
        camera_source_destroy: (cam)=>{
            var _a;
            return (_a = (0, $89fa42ee9de7dcc1$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        camera_source_pause: (cam)=>{
            var _a;
            return (_a = (0, $89fa42ee9de7dcc1$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        camera_source_start: (cam)=>{
            var _a;
            return (_a = (0, $89fa42ee9de7dcc1$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.start();
        },
        camera_count: ()=>2,
        camera_id: (indx)=>indx === 0 ? (0, $3e93c4f9b3b7cc91$exports.CameraSource).DEFAULT_DEVICE_ID : (0, $3e93c4f9b3b7cc91$exports.CameraSource).USER_DEFAULT_DEVICE_ID,
        camera_name: (indx)=>indx === 0 ? "Rear-facing Camera" : "User-facing Camera",
        camera_user_facing: (indx)=>indx !== 0,
        pipeline_create: ()=>(0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).create(c.impl, (0, $4d81e838630131c6$exports.messageManager)),
        pipeline_frame_update: (p)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.frameUpdate(c);
        },
        pipeline_camera_frame_draw_gl: (pipeline, screenWidth, screenHeight, mirror)=>{
            var _a;
            (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(pipeline)) === null || _a === void 0 || _a.cameraFrameDrawGL(screenWidth, screenHeight, mirror);
        },
        draw_plane: (gl, projectionMatrix, cameraMatrix, targetMatrix, texture)=>{
            (0, $11023ec155ec8242$export$4807f772bfdbc71f)(gl, projectionMatrix, cameraMatrix, targetMatrix, texture);
        },
        pipeline_draw_face: (p, projectionMatrix, cameraMatrix, targetMatrix, o)=>{
            var _a;
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call draw_face on a destroyed zappar_face_mesh_t");
                return new Uint16Array();
            }
            (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawFace(projectionMatrix, cameraMatrix, targetMatrix, obj);
        },
        pipeline_draw_face_project: (p, matrix, vertices, uvMatrix, uvs, indices, texture)=>{
            var _a;
            (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawFaceProject(matrix, vertices, uvMatrix, uvs, indices, texture);
        },
        pipeline_draw_image_target_preview: (p, projectionMatrix, cameraMatrix, targetMatrix, o, indx)=>{
            var _a;
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("image tracker not found");
                return;
            }
            (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawImageTargetPreview(projectionMatrix, cameraMatrix, targetMatrix, indx, obj);
        },
        projection_matrix_from_camera_model: (0, $ca0d9f3de8343ab7$export$ca7f1c5c0280e0bf),
        projection_matrix_from_camera_model_ext: (0, $ca0d9f3de8343ab7$export$ca7f1c5c0280e0bf),
        pipeline_process_gl: (p)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.processGL();
        },
        pipeline_gl_context_set: (p, gl, texturePool)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.glContextSet(gl, texturePool);
        },
        pipeline_gl_context_lost: (p)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.glContextLost();
        },
        pipeline_camera_frame_upload_gl: (p)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.uploadGL();
        },
        pipeline_camera_frame_texture_gl: (p)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameTexture();
        },
        pipeline_camera_frame_texture_matrix: (p, sw, sh, mirror)=>{
            var _a;
            return ((_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameTextureMatrix(sw, sh, mirror)) || (0, $2e616e7f2b93d8b0$exports).create();
        },
        pipeline_camera_frame_user_facing: (p)=>{
            var _a;
            return ((_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameUserFacing()) || false;
        },
        pipeline_camera_pose_default: ()=>(0, $2e616e7f2b93d8b0$exports).create(),
        pipeline_camera_pose_with_attitude: (p, mirror)=>{
            var _a;
            return ((_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraPoseWithAttitude(mirror)) || (0, $2e616e7f2b93d8b0$exports).create();
        },
        pipeline_camera_pose_with_origin: (p, o)=>{
            let res = (0, $2e616e7f2b93d8b0$exports).create();
            (0, $2e616e7f2b93d8b0$exports).invert(res, o);
            return res;
        },
        pipeline_sequence_record_clear: (p)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordClear();
        },
        pipeline_sequence_record_start: (p, expectedFrames)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordStart(expectedFrames);
        },
        pipeline_sequence_record_stop: (p)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordStop();
        },
        pipeline_sequence_record_device_attitude_matrices_set: (p, v)=>{
            var _a;
            return (_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordDeviceAttitudeMatrices(v);
        },
        pipeline_sequence_record_data: (p)=>{
            var _a;
            return ((_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordData()) || new Uint8Array(0);
        },
        pipeline_sequence_record_data_size: (p)=>{
            var _a;
            return ((_a = (0, $f8ed8326d2f24395$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordData().byteLength) || 0;
        },
        instant_world_tracker_anchor_pose_camera_relative: (o, mirror)=>{
            let res = (0, $f8ed8326d2f24395$export$9e7b3df2d144a412)(undefined, c.impl.instant_world_tracker_anchor_pose_raw(o));
            if (mirror) {
                let scale = (0, $2e616e7f2b93d8b0$exports).create();
                (0, $2e616e7f2b93d8b0$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, scale, res);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, res, scale);
            }
            return res;
        },
        instant_world_tracker_anchor_pose: (o, cameraPose, mirror)=>{
            let res = (0, $f8ed8326d2f24395$export$9e7b3df2d144a412)(undefined, c.impl.instant_world_tracker_anchor_pose_raw(o));
            if (mirror) {
                let scale = (0, $2e616e7f2b93d8b0$exports).create();
                (0, $2e616e7f2b93d8b0$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, scale, res);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, res, scale);
            }
            (0, $2e616e7f2b93d8b0$exports).multiply(res, cameraPose, res);
            return res;
        },
        instant_world_tracker_anchor_pose_set_from_camera_offset: (o, x, y, z, orientation)=>{
            // TODO - add an _ext function if we need to support mirrored cameras with an extra param
            // if(mirror) {
            //     x *= -1;
            // }
            // TODO - can we access the appropriate pipeline here to call pipeline_camera_frame_user_facing(p)?
            let userFacing = false;
            let rotation = (0, $ca0d9f3de8343ab7$export$83fad53f837eba8e)(userFacing) * Math.PI / 180.0;
            let rotationMat = (0, $2e616e7f2b93d8b0$exports).create();
            (0, $2e616e7f2b93d8b0$exports).fromRotation(rotationMat, -rotation, [
                0,
                0,
                1
            ]);
            let rawVec = (0, $b817ce0f5cdadb29$exports).create();
            (0, $b817ce0f5cdadb29$exports).transformMat4(rawVec, [
                x,
                y,
                z
            ], rotationMat);
            c.impl.instant_world_tracker_anchor_pose_set_from_camera_offset_raw(o, rawVec[0], rawVec[1], rawVec[2], orientation);
        },
        image_tracker_create: (pipeline)=>(0, $303a97edb2d5e4e9$export$333222788f3dd075).create(pipeline, c.impl),
        image_tracker_destroy: (t)=>{
            var _a;
            return (_a = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        image_tracker_target_type: (t, i)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_type on a destroyed zappar_image_tracker_t");
                return (0, $cc08068a96912eec$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR;
            }
            return obj.getTargetInfo(i).type;
        },
        image_tracker_target_count: (t)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_count on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.targetCount();
        },
        image_tracker_target_load_from_memory: (t, data)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_load_from_memory on a destroyed zappar_image_tracker_t");
                return 0;
            }
            obj.loadFromMemory(data);
        },
        image_tracker_target_preview_compressed: (t, i)=>{
            var _a;
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed on a destroyed zappar_image_tracker_t");
                return new Uint8Array(0);
            }
            return ((_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.compressed) || new Uint8Array(0);
        },
        image_tracker_target_preview_compressed_mimetype: (t, i)=>{
            var _a;
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed_mimetype on a destroyed zappar_image_tracker_t");
                return "";
            }
            return ((_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.mimeType) || "";
        },
        image_tracker_target_preview_compressed_size: (t, i)=>{
            var _a, _b;
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return ((_b = (_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.compressed) === null || _b === void 0 ? void 0 : _b.byteLength) || 0;
        },
        image_tracker_target_physical_scale_factor: (t, i)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_physical_scale_factor on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).physicalScaleFactor;
        },
        image_tracker_target_radius_top: (t, i)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_radius_top on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).topRadius;
        },
        image_tracker_target_radius_bottom: (t, i)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_radius_bottom on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).bottomRadius;
        },
        image_tracker_target_side_length: (t, i)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_side_length on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).sideLength;
        },
        image_tracker_target_image: (t, i)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_image on a destroyed zappar_image_tracker_t");
                return new Image();
            }
            return obj.getDecodedPreview(i);
        },
        image_tracker_anchor_pose_camera_relative: (o, indx, mirror)=>{
            let res = (0, $f8ed8326d2f24395$export$9e7b3df2d144a412)(undefined, c.impl.image_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2e616e7f2b93d8b0$exports).create();
                (0, $2e616e7f2b93d8b0$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, scale, res);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, res, scale);
            }
            return res;
        },
        image_tracker_anchor_pose: (o, indx, cameraPose, mirror)=>{
            let res = (0, $f8ed8326d2f24395$export$9e7b3df2d144a412)(undefined, c.impl.image_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2e616e7f2b93d8b0$exports).create();
                (0, $2e616e7f2b93d8b0$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, scale, res);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, res, scale);
            }
            (0, $2e616e7f2b93d8b0$exports).multiply(res, cameraPose, res);
            return res;
        },
        image_tracker_target_preview_mesh_indices: (o, indx)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_indices on a destroyed zappar_image_tracker_t");
                return new Uint16Array();
            }
            return obj.getPreviewMesh(indx).indices;
        },
        image_tracker_target_preview_mesh_vertices: (o, indx)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_vertices on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).vertices;
        },
        image_tracker_target_preview_mesh_uvs: (o, indx)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_uvs on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).uvs;
        },
        image_tracker_target_preview_mesh_normals: (o, indx)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_normals on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).normals;
        },
        image_tracker_target_preview_mesh_indices_size: (o, indx)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_indices_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).indices.length;
        },
        image_tracker_target_preview_mesh_vertices_size: (o, indx)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_vertices_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).vertices.length;
        },
        image_tracker_target_preview_mesh_uvs_size: (o, indx)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_uvs_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).uvs.length;
        },
        image_tracker_target_preview_mesh_normals_size: (o, indx)=>{
            let obj = (0, $303a97edb2d5e4e9$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_normals_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).normals.length;
        },
        face_tracker_anchor_pose_camera_relative: (o, indx, mirror)=>{
            let res = (0, $f8ed8326d2f24395$export$9e7b3df2d144a412)(undefined, c.impl.face_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2e616e7f2b93d8b0$exports).create();
                (0, $2e616e7f2b93d8b0$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, scale, res);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, res, scale);
            }
            return res;
        },
        face_tracker_anchor_pose: (o, indx, cameraPose, mirror)=>{
            let res = (0, $f8ed8326d2f24395$export$9e7b3df2d144a412)(undefined, c.impl.face_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2e616e7f2b93d8b0$exports).create();
                (0, $2e616e7f2b93d8b0$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, scale, res);
                (0, $2e616e7f2b93d8b0$exports).multiply(res, res, scale);
            }
            (0, $2e616e7f2b93d8b0$exports).multiply(res, cameraPose, res);
            return res;
        },
        face_tracker_model_load_default: (o)=>$0c05329758a5f3b0$var$__awaiter(this, void 0, void 0, function*() {
                yield $0c05329758a5f3b0$var$loadDefaultFaceModel(o);
            }),
        face_mesh_create: ()=>{
            return (0, $c07c3eb0118aafe9$export$3a09cf4ac8b68494)();
        },
        face_mesh_destroy: (m)=>{
            (0, $c07c3eb0118aafe9$export$eed3c787ca5a1447)(m);
        },
        face_mesh_indices: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_indices on a destroyed zappar_face_mesh_t");
                return new Uint16Array();
            }
            return obj.getIndices();
        },
        face_mesh_indices_size: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_indices_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getIndices().length;
        },
        face_mesh_uvs: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_uvs on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getUVs();
        },
        face_mesh_uvs_size: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_uvs_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getUVs().length;
        },
        face_mesh_vertices: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_vertices on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getVertices();
        },
        face_mesh_vertices_size: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_vertices_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getVertices().length;
        },
        face_mesh_normals: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_normals on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getNormals();
        },
        face_mesh_normals_size: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_normals_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getNormals().length;
        },
        face_mesh_load_from_memory: (m, ab, fillMouth, fillEyeL, fillEyeR, fillNeck)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_load_from_memory on a destroyed zappar_face_mesh_t");
                return;
            }
            obj.loadFromMemory(ab, fillMouth, fillEyeL, fillEyeR, fillNeck);
        },
        face_mesh_update: (m, identity, expression, mirrored)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_update on a destroyed zappar_face_mesh_t");
                return;
            }
            obj.update(identity, expression, mirrored);
        },
        face_mesh_load_default: (m)=>$0c05329758a5f3b0$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_load_default on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($088099950f0f112a$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), false, false, false, false);
            }),
        face_mesh_load_default_face: (m, fillMouth, fillEyeL, fillEyeR)=>$0c05329758a5f3b0$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_load_default_face on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($088099950f0f112a$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), fillMouth, fillEyeL, fillEyeR, false);
            }),
        face_mesh_load_default_full_head_simplified: (m, fillMouth, fillEyeL, fillEyeR, fillNeck)=>$0c05329758a5f3b0$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_load_default_full_head_simplified on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($d81c1b20e0069481$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), fillMouth, fillEyeL, fillEyeR, fillNeck);
            }),
        face_mesh_loaded_version: (m)=>{
            let obj = (0, $c07c3eb0118aafe9$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_mesh_load_default on a destroyed zappar_face_mesh_t");
                return -1;
            }
            return obj.getModelVersion();
        },
        face_landmark_create: (n)=>{
            return (0, $67167d3e1ef18577$export$36e720c0ee0eafff)(n);
        },
        face_landmark_destroy: (m)=>{
            (0, $67167d3e1ef18577$export$4a91c83b2945af9c)(m);
        },
        face_landmark_update: (m, identity, expression, mirrored)=>{
            let obj = (0, $67167d3e1ef18577$export$2cdf232f18b0ea25)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_landmark_update on a destroyed zappar_face_landmark_t");
                return;
            }
            obj.update(identity, expression, mirrored);
        },
        face_landmark_anchor_pose: (m)=>{
            let obj = (0, $67167d3e1ef18577$export$2cdf232f18b0ea25)(m);
            if (!obj) {
                (0, $7c2568b0d857a09d$export$79a36c979e81230e)("attempting to call face_landmark_anchor_pose on a destroyed zappar_face_landmark_t");
                return (0, $2e616e7f2b93d8b0$exports).create();
            }
            return obj.anchor_pose;
        },
        html_element_source_create: (pipeline, elm)=>(0, $8d04bf3660676376$export$bbfb48c500076b66).createVideoElementSource(pipeline, elm),
        html_element_source_start: (o)=>{
            var _a;
            return (_a = (0, $8d04bf3660676376$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.start();
        },
        html_element_source_pause: (o)=>{
            var _a;
            return (_a = (0, $8d04bf3660676376$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        html_element_source_destroy: (o)=>{
            var _a;
            return (_a = (0, $8d04bf3660676376$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        sequence_source_create: (p)=>(0, $3865ed6da1bd89a5$export$9035336025e5be06).create(p),
        sequence_source_load_from_memory: (o, data)=>{
            var _a;
            return (_a = (0, $3865ed6da1bd89a5$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.loadFromMemory(data);
        },
        sequence_source_pause: (o)=>{
            var _a;
            return (_a = (0, $3865ed6da1bd89a5$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        sequence_source_start: (o)=>{
            var _a;
            return (_a = (0, $3865ed6da1bd89a5$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.start();
        },
        sequence_source_max_playback_fps_set: (o, fps)=>{
            var _a;
            return (_a = (0, $3865ed6da1bd89a5$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.maxPlaybackFpsSet(fps);
        },
        sequence_source_time_set: (o, t)=>{
            var _a;
            return (_a = (0, $3865ed6da1bd89a5$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.setTime(t);
        },
        sequence_source_destroy: (o)=>{
            var _a;
            return (_a = (0, $3865ed6da1bd89a5$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        permission_granted_all: (0, $5323009cd6103e45$exports.permissionGrantedAll),
        permission_granted_camera: (0, $5323009cd6103e45$exports.permissionGrantedCamera),
        permission_granted_motion: (0, $5323009cd6103e45$exports.permissionGrantedMotion),
        permission_denied_any: (0, $5323009cd6103e45$exports.permissionDeniedAny),
        permission_denied_camera: (0, $5323009cd6103e45$exports.permissionDeniedCamera),
        permission_denied_motion: (0, $5323009cd6103e45$exports.permissionDeniedMotion),
        permission_request_motion: (0, $5323009cd6103e45$exports.permissionRequestMotion),
        permission_request_camera: (0, $5323009cd6103e45$exports.permissionRequestCamera),
        permission_request_all: (0, $5323009cd6103e45$exports.permissionRequestAll),
        permission_request_ui: (0, $5323009cd6103e45$exports.permissionRequestUI),
        permission_request_ui_promise: (0, $5323009cd6103e45$exports.permissionRequestUI),
        permission_denied_ui: (0, $5323009cd6103e45$exports.permissionDeniedUI),
        browser_incompatible: (0, $87049b330e55d4f2$export$2e2bcd8739ae039).incompatible,
        browser_incompatible_ui: (0, $87049b330e55d4f2$export$2e2bcd8739ae039).incompatible_ui,
        log_level_set: (l)=>{
            (0, $7c2568b0d857a09d$export$c622e99c0ce7b1c9)(l);
            c.impl.log_level_set(l);
        }
    });
    return $0c05329758a5f3b0$var$client;
}
var $f103445a4640354e$exports = {};


$f103445a4640354e$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("I7W5Q");


function $0c05329758a5f3b0$var$loadDefaultFaceModel(o) {
    return $0c05329758a5f3b0$var$__awaiter(this, void 0, void 0, function*() {
        let url = new URL($f103445a4640354e$exports);
        let data = yield fetch(url.toString());
        let ab = yield data.arrayBuffer();
        $0c05329758a5f3b0$var$client === null || $0c05329758a5f3b0$var$client === void 0 || $0c05329758a5f3b0$var$client.face_tracker_model_load_from_memory(o, ab);
    });
}


const $ae5b55e2c68b845c$export$a4ad2735b021c132 = "2.0.1";



function $bbed30551c417532$export$2a47f398eeff8b01(opts) {
    console.log(`Zappar CV v${(0, $ae5b55e2c68b845c$export$a4ad2735b021c132)}`);
    return (0, $0c05329758a5f3b0$exports.initialize)(opts);
}



/**
  * SDK version.
*/ const $80e05c750c2ba286$export$a4ad2735b021c132 = "2.1.1";


var $d5527567a7407cf0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $d5527567a7407cf0$var$_z;
let $d5527567a7407cf0$var$_options;
function $d5527567a7407cf0$export$add91eafeaeab287(opts) {
    if ($d5527567a7407cf0$var$_z) console.warn("setOptions called after Zappar JS initialization");
    $d5527567a7407cf0$var$_options = opts;
}
function $d5527567a7407cf0$export$df995fae86a55f06() {
    if (!$d5527567a7407cf0$var$_z) {
        console.log(`Zappar JS v${(0, $80e05c750c2ba286$export$a4ad2735b021c132)}`);
        $d5527567a7407cf0$var$_z = (0, $bbed30551c417532$export$2a47f398eeff8b01)($d5527567a7407cf0$var$_options);
    }
    return $d5527567a7407cf0$var$_z;
}
function $d5527567a7407cf0$export$5e22cf87be86f6fa(userFacing) {
    return $d5527567a7407cf0$export$df995fae86a55f06().camera_default_device_id(userFacing || false);
}
function $d5527567a7407cf0$export$6897c284b6f9f4dc(m) {
    const ret = (0, $2e616e7f2b93d8b0$exports).create();
    (0, $2e616e7f2b93d8b0$exports).invert(ret, m);
    return ret;
}
function $d5527567a7407cf0$export$790b3b94a8142dee(model, renderWidth, renderHeight, zNear = 0.1, zFar = 100) {
    return $d5527567a7407cf0$export$df995fae86a55f06().projection_matrix_from_camera_model_ext(model, renderWidth, renderHeight, zNear, zFar);
}
function $d5527567a7407cf0$export$4807f772bfdbc71f(gl, projectionMatrix, cameraMatrix, targetMatrix, texture) {
    $d5527567a7407cf0$export$df995fae86a55f06().draw_plane(gl, projectionMatrix, cameraMatrix, targetMatrix, texture);
}
function $d5527567a7407cf0$export$45d46abc43ff1aac() {
    return $d5527567a7407cf0$export$df995fae86a55f06().browser_incompatible();
}
function $d5527567a7407cf0$export$5485d7c8ccfb3ed0() {
    $d5527567a7407cf0$export$df995fae86a55f06().browser_incompatible_ui();
}
function $d5527567a7407cf0$export$b40fc69c4a2927a1() {
    return $d5527567a7407cf0$export$df995fae86a55f06().loaded();
}
function $d5527567a7407cf0$export$6b6393bedfd195a0() {
    return $d5527567a7407cf0$var$__awaiter(this, void 0, void 0, function*() {
        while(true){
            if ($d5527567a7407cf0$export$b40fc69c4a2927a1()) return;
            yield $d5527567a7407cf0$var$delay(50);
        }
    });
}
function $d5527567a7407cf0$var$delay(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


var $61e0c0f83e511ee0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $61e0c0f83e511ee0$export$333222788f3dd075 {
    /**
     * Constructs a new ImageTracker
     * @param _pipeline - The pipeline that this tracker will operate within.
     * @param targetFile - The .zpt target file from the source image you'd like to track.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
    */ constructor(_pipeline, targetFile){
        this._pipeline = _pipeline;
        /**
        * Emitted when an anchor becomes visible in a camera frame.
        */ this.onVisible = new (0, $46abd614147db5d5$export$3371bf92c01fb88b)();
        /**
        * Emitted when an anchor goes from being visible in the previous camera frame, to not being visible in the current frame.
        */ this.onNotVisible = new (0, $46abd614147db5d5$export$3371bf92c01fb88b)();
        /**
        * Emitted when a new anchor is created by the tracker.
        */ this.onNewAnchor = new (0, $46abd614147db5d5$export$3371bf92c01fb88b)();
        /**
        * The set of currently visible anchors.
        */ this.visible = new Set();
        /**
        * A map of the available image anchors by their respective IDs.
        */ this.anchors = new Map();
        this._visibleLastFrame = new Set();
        this._frameUpdate = ()=>{
            const newAnchors = new Set();
            // Swap the visible and visibleLastFrame so we can avoid a set allocation
            const swap = this.visible;
            this.visible = this._visibleLastFrame;
            this._visibleLastFrame = swap;
            this.visible.clear();
            const num = this._z.image_tracker_anchor_count(this._impl);
            for(let i = 0; i < num; i++){
                const id = this._z.image_tracker_anchor_id(this._impl, i);
                let anchor = this.anchors.get(id);
                let isNew = false; // TODO: declared but never used?
                if (!anchor) {
                    anchor = {
                        onVisible: new (0, $46abd614147db5d5$export$d61e24a684f9e51)(),
                        onNotVisible: new (0, $46abd614147db5d5$export$d61e24a684f9e51)(),
                        id: id,
                        poseCameraRelative: (mirror)=>this._z.image_tracker_anchor_pose_camera_relative(this._impl, i, mirror === true),
                        pose: (cameraPose, mirror)=>this._z.image_tracker_anchor_pose(this._impl, i, cameraPose, mirror === true),
                        visible: true
                    };
                    isNew = true;
                    this.anchors.set(id, anchor);
                    newAnchors.add(anchor);
                }
                anchor.visible = true;
                this.visible.add(anchor);
            }
            // Events
            for (const anchor of newAnchors)this.onNewAnchor.emit(anchor);
            for (const anchor of this.visible)if (!this._visibleLastFrame.has(anchor)) {
                this.onVisible.emit(anchor);
                anchor.onVisible.emit();
            } else this._visibleLastFrame.delete(anchor);
            for (const anchor of this._visibleLastFrame){
                this.onNotVisible.emit(anchor);
                anchor.onNotVisible.emit();
            }
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.image_tracker_create(this._pipeline._getImpl());
        if (targetFile) this.loadTarget(targetFile);
    }
    /**
     * Destroys the image tracker.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this.anchors.clear();
        this.visible.clear();
        this._z.image_tracker_destroy(this._impl);
    }
    /**
     * Loads a target file.
     * @param src - A URL to, or an ArrayBuffer of, the target file from the source image you'd like to track.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
     * @returns A promise that's resolved once the file is downloaded. It may still take a few frames for the tracker to fully initialize and detect images.
    */ loadTarget(src) {
        return $61e0c0f83e511ee0$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._targets = undefined;
            this._z.image_tracker_target_load_from_memory(this._impl, src);
        });
    }
    /**
     * Gets/sets the enabled state of the image tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.image_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.image_tracker_enabled_set(this._impl, e);
    }
    /**
     * An array of information for each of the target images loaded by this tracker.
     */ get targets() {
        if (!this._targets) {
            this._targets = [];
            const count = this._z.image_tracker_target_count(this._impl);
            for(let i = 0; i < count; i++)this._targets.push(new $61e0c0f83e511ee0$export$90139717fc3176c2(this._z, this._impl, i));
        }
        return this._targets;
    }
}
class $61e0c0f83e511ee0$export$90139717fc3176c2 {
    constructor(_z, _impl, _indx){
        this._z = _z;
        this._impl = _impl;
        this._indx = _indx;
        this.physicalScaleFactor = this._z.image_tracker_target_physical_scale_factor(this._impl, this._indx);
        if (this.physicalScaleFactor < 0) this.physicalScaleFactor = undefined;
        this.topRadius = this._z.image_tracker_target_radius_top(this._impl, this._indx);
        if (this.topRadius < 0) this.topRadius = undefined;
        this.bottomRadius = this._z.image_tracker_target_radius_bottom(this._impl, this._indx);
        if (this.bottomRadius < 0) this.bottomRadius = undefined;
        this.sideLength = this._z.image_tracker_target_side_length(this._impl, this._indx);
        if (this.sideLength < 0) this.sideLength = undefined;
    }
    /**
     * An <img> element containing the embedded preview image, or `undefined` if the target file does not contain one.
     */ get image() {
        if (this._image === undefined) this._image = this._z.image_tracker_target_image(this._impl, this._indx) || null;
        return this._image || undefined;
    }
    /**
     * An object containing a mesh that represents this image target.
     */ get preview() {
        if (this._preview === undefined) this._preview = new $61e0c0f83e511ee0$export$ae476155e1d7e629(this._z, this._impl, this._indx);
        return this._preview;
    }
}
class $61e0c0f83e511ee0$export$ae476155e1d7e629 {
    constructor(_z, _impl, _indx){
        this._z = _z;
        this._impl = _impl;
        this._indx = _indx;
        this.vertices = this._z.image_tracker_target_preview_mesh_vertices(this._impl, this._indx);
        this.indices = this._z.image_tracker_target_preview_mesh_indices(this._impl, this._indx);
        this.uvs = this._z.image_tracker_target_preview_mesh_uvs(this._impl, this._indx);
    }
}




class $b0249d9831ada913$export$230d52b81bfab97f {
    /**
     * Constructs a new InstantWorldTracker.
     * @param _pipeline - The pipeline that this tracker will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * The instant world tracking anchor.
        */ this.anchor = {
            poseCameraRelative: (mirror)=>this._anchorPoseCameraRelative(mirror),
            pose: (cameraPose, mirror)=>this._anchorPose(cameraPose, mirror)
        };
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.instant_world_tracker_create(this._pipeline._getImpl());
    }
    /**
     * Destroys the instant tracker.
     */ destroy() {
        this._z.instant_world_tracker_destroy(this._impl);
    }
    _anchorPoseCameraRelative(mirror) {
        return this._z.instant_world_tracker_anchor_pose_camera_relative(this._impl, mirror === true);
    }
    _anchorPose(cameraPose, mirror) {
        return this._z.instant_world_tracker_anchor_pose(this._impl, cameraPose, mirror === true);
    }
    /**
     * Gets/sets the enabled state of the instant world tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.instant_world_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.instant_world_tracker_enabled_set(this._impl, e);
    }
    /**
     * Sets the point in the user's environment that the anchor tracks from.
     *
     * The parameters passed in to this function correspond to the X, Y and Z coordinates (in camera space) of the point to track. Choosing a position with X and Y coordinates of zero, and a negative Z coordinate, will select a point on a surface directly in front of the center of the screen.
     *
     * @param orientation -  The orientation of the point in space.
     */ setAnchorPoseFromCameraOffset(x, y, z, orientation) {
        this._z.instant_world_tracker_anchor_pose_set_from_camera_offset(this._impl, x, y, z, orientation || (0, $cc08068a96912eec$export$51221aec55e6c7e6).MINUS_Z_AWAY_FROM_USER);
    }
}





class $95dd83f26d184eeb$export$441c3cbad541da1b {
    /**
     * Constructs a new BarcodeFinder.
     * @param _pipeline - The pipeline that this BarcodeFinder will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * Emitted when a barcode becomes visible in a camera frame.
        */ this.onDetection = new (0, $46abd614147db5d5$export$3371bf92c01fb88b)();
        this._lastDetected = [];
        this._found = [];
        this._formats = [];
        this._frameUpdate = ()=>{
            this._found = [];
            const num = this._z.barcode_finder_found_number(this._impl);
            for(let i = 0; i < num; i++)this._found.push({
                text: this._z.barcode_finder_found_text(this._impl, i),
                format: this._z.barcode_finder_found_format(this._impl, i)
            });
            if (this._found.length === 0) return;
            outerloop: for (const entry of this._found){
                for (const previous of this._lastDetected){
                    if (previous.text === entry.text) continue outerloop;
                }
                this.onDetection.emit(entry);
            }
            this._lastDetected = this._found;
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.barcode_finder_create(this._pipeline._getImpl());
        this._formats.push.apply(this._formats, [
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).AZTEC,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).CODABAR,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).CODE_39,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).CODE_93,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).CODE_128,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).DATA_MATRIX,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).EAN_8,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).EAN_13,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).ITF,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).MAXICODE,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).PDF_417,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).QR_CODE,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).RSS_14,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).RSS_EXPANDED,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).UPC_A,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).UPC_E,
            (0, $cc08068a96912eec$export$53baafd5596ae7a8).UPC_EAN_EXTENSION
        ]);
    }
    /**
     * Destroys the barcode finder.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this._found = [];
        this._lastDetected = [];
        this._z.barcode_finder_destroy(this._impl);
    }
    /**
      * Returns an array of discovered barcodes
      */ get found() {
        return this._found;
    }
    /**
     * Gets/sets the enabled state of the barcode finder.
     * Disable when not in use to save computational resources during frame processing.
    */ get enabled() {
        return this._z.barcode_finder_enabled(this._impl);
    }
    set enabled(e) {
        this._z.barcode_finder_enabled_set(this._impl, e);
    }
    /**
      * Gets/sets the barcode formats to scan for.
      */ get formats() {
        return this._formats;
    }
    set formats(f) {
        this._formats = f.slice();
        let underlying = 0;
        for (const format of this._formats)underlying |= format;
        this._z.barcode_finder_formats_set(this._impl, underlying);
    }
}


var $088e1200d72f1b4c$exports = {};

$parcel$export($088e1200d72f1b4c$exports, "FaceTracker", function () { return $088e1200d72f1b4c$export$bb2337bd021e3bce; });


var $088e1200d72f1b4c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $088e1200d72f1b4c$export$bb2337bd021e3bce {
    /**
     * Constructs a new FaceTracker
     * @param _pipeline - The pipeline that this tracker will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * Emitted when an anchor becomes visible in a camera frame.
        */ this.onVisible = new (0, $46abd614147db5d5$export$3371bf92c01fb88b)();
        /**
        * Emitted when an anchor goes from being visible in the previous camera frame, to not being visible in the current frame.
        */ this.onNotVisible = new (0, $46abd614147db5d5$export$3371bf92c01fb88b)();
        /**
        * Emitted when a new anchor is created by the tracker.
        */ this.onNewAnchor = new (0, $46abd614147db5d5$export$3371bf92c01fb88b)();
        /**
         * The set of currently visible anchors.
         */ this.visible = new Set();
        /**
        * A map of the available anchors by their respective IDs.
        */ this.anchors = new Map();
        this._visibleLastFrame = new Set();
        this._frameUpdate = ()=>{
            const newAnchors = new Set();
            // Swap the visible and visibleLastFrame so we can avoid a set allocation
            const swap = this.visible;
            this.visible = this._visibleLastFrame;
            this._visibleLastFrame = swap;
            this.visible.clear();
            const num = this._z.face_tracker_anchor_count(this._impl);
            for(let i = 0; i < num; i++){
                const id = this._z.face_tracker_anchor_id(this._impl, i);
                let anchor = this.anchors.get(id);
                let isNew = false;
                if (!anchor) {
                    anchor = {
                        onVisible: new (0, $46abd614147db5d5$export$d61e24a684f9e51)(),
                        onNotVisible: new (0, $46abd614147db5d5$export$d61e24a684f9e51)(),
                        indx: 0,
                        id: id,
                        poseCameraRelative: (mirror)=>this._z.face_tracker_anchor_pose_camera_relative(this._impl, anchor.indx, mirror === true),
                        pose: (cameraPose, mirror)=>this._z.face_tracker_anchor_pose(this._impl, anchor.indx, cameraPose, mirror === true),
                        identity: new Float32Array(50),
                        expression: new Float32Array(29),
                        visible: true
                    };
                    isNew = true;
                    this.anchors.set(id, anchor);
                    newAnchors.add(anchor);
                }
                anchor.indx = i;
                anchor.visible = true;
                anchor.identity = this._z.face_tracker_anchor_identity_coefficients(this._impl, i);
                anchor.expression = this._z.face_tracker_anchor_expression_coefficients(this._impl, i);
                this.visible.add(anchor);
            }
            // Events
            for (const anchor of newAnchors)this.onNewAnchor.emit(anchor);
            for (const anchor of this.visible)if (!this._visibleLastFrame.has(anchor)) {
                this.onVisible.emit(anchor);
                anchor.onVisible.emit();
            } else this._visibleLastFrame.delete(anchor);
            for (const anchor of this._visibleLastFrame){
                this.onNotVisible.emit(anchor);
                anchor.onNotVisible.emit();
            }
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.face_tracker_create(this._pipeline._getImpl());
    }
    /**
      * Destroys the face tracker.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this.anchors.clear();
        this.visible.clear();
        this._z.face_tracker_destroy(this._impl);
    }
    /**
     * Loads face tracking model data.
     * @param src - A URL to, or ArrayBuffer of, model data.
     * @returns A promise that's resolved once the model is loaded. It may still take a few frames for the tracker to fully initialize and detect faces.
    */ loadModel(src) {
        return $088e1200d72f1b4c$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.face_tracker_model_load_from_memory(this._impl, src);
        });
    }
    /**
     * Loads the default face tracking model.
     * @returns A promise that's resolved once the model is loaded. It may still take a few frames for the tracker to fully initialize and detect faces.
    */ loadDefaultModel() {
        return $088e1200d72f1b4c$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_tracker_model_load_default(this._impl);
        });
    }
    /**
     * Gets/sets the enabled state of the face tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.face_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.face_tracker_enabled_set(this._impl, e);
    }
    /**
     * Gets/sets the maximum number of faces to track.
     *
     * By default only one face is tracked in any given frame. Increasing this number may reduce runtime performance.
     */ get maxFaces() {
        return this._z.face_tracker_max_faces(this._impl);
    }
    set maxFaces(m) {
        this._z.face_tracker_max_faces_set(this._impl, m);
    }
}


var $331744928f4ad43b$exports = {};

$parcel$export($331744928f4ad43b$exports, "FaceMesh", function () { return $331744928f4ad43b$export$1238420da3a0b20c; });

var $331744928f4ad43b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $331744928f4ad43b$export$1238420da3a0b20c {
    /**
     * Constructs a new FaceMesh.
     * @see https://docs.zap.works/universal-ar/javascript/face-tracking/
    */ constructor(){
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.face_mesh_create();
    }
    /**
     * Destroys the face mesh.
     */ destroy() {
        this._z.face_mesh_destroy(this._impl);
    }
    /**
     * Loads the data for a face mesh.
     * @param src - A URL or ArrayBuffer of the source mesh data.
     * @param fillMouth - If true, fills this face feature with polygons.
     * @param fillEyeLeft - If true, fills this face feature with polygons.
     * @param fillEyeRight - If true, fills this face feature with polygons.
     * @param fillNeck - If true, fills this face feature with polygons.
     * @returns A promise that's resolved once the data is loaded.
     */ load(src, fillMouth, fillEyeLeft, fillEyeRight, fillNeck) {
        return $331744928f4ad43b$var$__awaiter(this, void 0, void 0, function*() {
            if (!src) {
                this.loadDefault();
                return;
            } else if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.face_mesh_load_from_memory(this._impl, src, fillMouth || false, fillEyeLeft || false, fillEyeRight || false, fillNeck || false);
        });
    }
    /**
      * Loads the default face mesh data.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefault() {
        return $331744928f4ad43b$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default(this._impl);
        });
    }
    /**
      * Loads the default face mesh.
      * @param fillMouth - If true, fills this face feature with polygons.
      * @param fillEyeLeft - If true, fills this face feature with polygons.
      * @param fillEyeRight - If true, fills this face feature with polygons.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefaultFace(fillMouth, fillEyeLeft, fillEyeRight) {
        return $331744928f4ad43b$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default_face(this._impl, fillMouth || false, fillEyeLeft || false, fillEyeRight || false);
        });
    }
    /**
      * The full head simplified mesh covers the whole of the user's head, including some neck.
      * It's ideal for drawing into the depth buffer in order to mask out the back of 3D models placed on the user's head.
      * @param fillMouth - If true, fills this face feature with polygons.
      * @param fillEyeLeft - If true, fills this face feature with polygons.
      * @param fillEyeRight - If true, fills this face feature with polygons.
      * @param fillNeck - If true, fills this face feature with polygons.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefaultFullHeadSimplified(fillMouth, fillEyeLeft, fillEyeRight, fillNeck) {
        return $331744928f4ad43b$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default_full_head_simplified(this._impl, fillMouth || false, fillEyeLeft || false, fillEyeRight || false, fillNeck || false);
        });
    }
    /**
      * Update the face mesh directly from a [[FaceAnchor]].
      * @param f - The face anchor.
      * @param mirror - Pass `true` to mirror the location in the X-axis.
      */ updateFromFaceAnchor(f, mirror) {
        this._z.face_mesh_update(this._impl, f.identity, f.expression, mirror || false);
    }
    /**
      * Updates the face mesh directly from a identity and expression coefficients.
      * @param identity - The identity coefficients.
      * @param expression - The expression coefficients.
      * @param mirror - Pass `true` to mirror the location in the X-axis.
     */ updateFromIdentityExpression(identity, expression, mirror) {
        this._z.face_mesh_update(this._impl, identity, expression, mirror || false);
    }
    /**
     *
     * @returns The vertices of the mesh.
     */ get vertices() {
        return this._z.face_mesh_vertices(this._impl);
    }
    /**
     * @returns The indices of the mesh.
     */ get indices() {
        return this._z.face_mesh_indices(this._impl);
    }
    /**
     * @returns The UVs of the mesh.
     */ get uvs() {
        return this._z.face_mesh_uvs(this._impl);
    }
    /**
     * @returns The normals of the mesh.
     */ get normals() {
        return this._z.face_mesh_normals(this._impl);
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
}



class $2a05cc60824dd816$export$9a93ce53f488cb2e {
    /**
     * Constructs a new CameraSource.
     * @param _pipeline - The pipeline that this tracker will operate within.
     * @param deviceId - The camera device ID which will be used as the source.
     * @see https://docs.zap.works/universal-ar/javascript/pipelines-and-camera-processing/
    */ constructor(pipeline, deviceId){
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.camera_source_create(pipeline._getImpl(), deviceId);
    }
    /**
    * Destroys the camera source.
    */ destroy() {
        this._z.camera_source_destroy(this._impl);
    }
    /**
    * Starts the camera source.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.camera_source_start(this._impl);
    }
    /**
    * Pauses the camera source.
    */ pause() {
        this._z.camera_source_pause(this._impl);
    }
}



class $4fcd7dcae9b5cd10$export$bbfb48c500076b66 {
    /**
     * Constructs a new HTMLElementSource.
     * @param pipeline - The pipeline that this tracker will operate within.
     * @param element -  The HTML source element.
    */ constructor(pipeline, element){
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.html_element_source_create(pipeline._getImpl(), element);
    }
    /**
    * Destroys the source.
    */ destroy() {
        this._z.html_element_source_destroy(this._impl);
    }
    /**
    * Starts the source sending frames into the pipeline.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.html_element_source_start(this._impl);
    }
    /**
    * Pauses the source.
    */ pause() {
        this._z.html_element_source_pause(this._impl);
    }
}


var $231c1b986b297792$exports = {};

var $231c1b986b297792$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $231c1b986b297792$export$9035336025e5be06 {
    /**
     * Constructs a new SequenceSource.
     * @param _pipeline - The pipeline that this source will operate within.
    */ constructor(pipeline){
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.sequence_source_create(pipeline._getImpl());
    }
    /**
    * Destroys the sequence source.
    */ destroy() {
        this._z.sequence_source_destroy(this._impl);
    }
    /**
    * Starts the sequence source.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.sequence_source_start(this._impl);
    }
    /**
    * Pauses the sequence source.
    */ pause() {
        this._z.sequence_source_pause(this._impl);
    }
    /**
     * Loads sequence data.
     * @param src - A URL to, or an ArrayBuffer of, the sequence data you'd like to play back.
     * @returns A promise that's resolved once the data is downloaded.
    */ load(src) {
        return $231c1b986b297792$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.sequence_source_load_from_memory(this._impl, src);
        });
    }
    /**
     * Manually set the current time for the sequence.
     * @param t The time in ms, or `undefined` to use the system time.
     */ setTime(t) {
        this._z.sequence_source_time_set(this._impl, t !== null && t !== void 0 ? t : -1);
    }
}




class $b235e14258fd5458$export$abd47b564b6c9ce2 {
    /**
     * Constructs a new Pipeline.
    */ constructor(){
        /**
         * Emitted when the frame is updated.
        */ this.onFrameUpdate = new (0, $46abd614147db5d5$export$d61e24a684f9e51)();
        /**
         * @ignore
        */ this._onFrameUpdateInternal = new (0, $46abd614147db5d5$export$d61e24a684f9e51)();
        this._lastFrameNumber = -1;
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.pipeline_create();
    }
    /**
     * Destroys the pipeline.
     */ destroy() {
        this._z.pipeline_destroy(this._impl);
    }
    /**
     * Updates the pipeline and trackers to expose tracking data from the most recently processed camera frame.
     */ frameUpdate() {
        this._z.pipeline_frame_update(this._impl);
        const frameNumber = this._z.pipeline_frame_number(this._impl);
        if (frameNumber !== this._lastFrameNumber) {
            this._lastFrameNumber = frameNumber;
            this._onFrameUpdateInternal.emit();
            this.onFrameUpdate.emit();
        }
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
    /**
     * Sets the WebGL context used for the processing and upload of camera textures.
     * @param gl - The WebGL context.
    */ glContextSet(gl) {
        this._z.pipeline_gl_context_set(this._impl, gl);
    }
    /**
     * Informs the pipeline that the GL context is lost and should not be used.
    */ glContextLost() {
        this._z.pipeline_gl_context_lost(this._impl);
    }
    /**
     * Returns the most recent camera frame texture.
    */ cameraFrameTextureGL() {
        return this._z.pipeline_camera_frame_texture_gl(this._impl);
    }
    /**
     * Returns a matrix that you can use to transform the UV coordinates of the following full-screen quad in order to render the camera texture:
     *
     * Vertex 0: `-1, -1, 0`
     *
     * UV 0: `0, 0`
     *
     * Vertex 1: `-1, 1, 0`
     *
     * UV 1: `0, 1`
     *
     * Vertex 2: `1, -1, 0`
     *
     * UV 1: `1, 0`
     *
     * Vertex 3: `1, 1, 0`
     *
     * UV 1: `1, 1`
     *
     * @param renderWidth - The width of the canvas.
     * @param renderHeight - The height of the canvas.
     * @param mirror - Pass `true` to mirror the camera image in the X-axis.
     * @returns A 4x4 column-major transformation matrix.
    */ cameraFrameTextureMatrix(renderWidth, renderHeight, mirror) {
        return this._z.pipeline_camera_frame_texture_matrix(this._impl, renderWidth, renderHeight, mirror === true);
    }
    /**
    * Draw the camera to the screen as a full screen quad.
    *
    * Please note this function modifies some GL state during its operation so you may need to reset the following GL state if you use it:
    * - The currently bound texture 2D is set to `null` (e.g. `gl.bindTexture(gl.TEXTURE_2D, null)`)
    * - The currently bound array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ARRAY_BUFFER, null);`)
    * - The currently bound program is set to `null` (e.g. `gl.useProgram(null)`)
    * - The currently active texture is set to `gl.TEXTURE0` (e.g. `gl.activeTexture(gl.TEXTURE0)`)
    * - These features are disabled: `gl.SCISSOR_TEST`, `gl.DEPTH_TEST`, `gl.BLEND`, `gl.CULL_FACE`
    * @param renderWidth - The width of the canvas.
    * @param renderHeight - The height of the canvas.
    * @param mirror - Pass `true` to mirror the camera image in the X-axis.
   */ cameraFrameDrawGL(renderWidth, renderHeight, mirror) {
        this._z.pipeline_camera_frame_draw_gl(this._impl, renderWidth, renderHeight, mirror);
    }
    /**
     * Uploads the current camera frame to a WebGL texture.
    */ cameraFrameUploadGL() {
        this._z.pipeline_camera_frame_upload_gl(this._impl);
    }
    /**
     * Prepares camera frames for processing.
     *
     * Call this function on your pipeline once an animation frame (e.g. during your `requestAnimationFrame` function) in order to process incoming camera frames.
     *
     * Please note this function modifies some GL state during its operation so you may need to reset the following GL state if you use it:
     * - The currently bound framebuffer is set to `null` (e.g. `gl.bindFramebuffer(gl.FRAMEBUFFER, null)`)
     * - The currently bound texture 2D is set to `null` (e.g. `gl.bindTexture(gl.TEXTURE_2D, null)`)
     * - The currently bound array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ARRAY_BUFFER, null);`)
     * - The currently bound element array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null)`)
     * - The currently bound program is set to `null` (e.g. `gl.useProgram(null)`)
     * - The currently active texture is set to `gl.TEXTURE0` (e.g. `gl.activeTexture(gl.TEXTURE0)`)
     * - These features are disabled: `gl.SCISSOR_TEST`, `gl.DEPTH_TEST`, `gl.BLEND`, `gl.CULL_FACE`
     * - The pixel store flip-Y mode is disabled (e.g. `gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false)`)
     * - The viewport is changed (e.g. `gl.viewport(...)`)
     * - The clear color is changed (e.g. `gl.clearColor(...)`)
    */ processGL() {
        this._z.pipeline_process_gl(this._impl);
    }
    /**
     * Returns the camera model (i.e. the intrinsic camera parameters) for the current frame.
    */ cameraModel() {
        return this._z.pipeline_camera_model(this._impl);
    }
    /**
     * Returns a transformation where the camera sits, stationary, at the origin of world space, and points down the negative Z axis.
     *
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     *
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseDefault() {
        return this._z.pipeline_camera_pose_default(this._impl);
    }
    /**
     * Returns a transformation where the camera sits at the origin of world space, but rotates as the user rotates the physical device.
     *
     * When the Zappar library initializes, the negative Z axis of world space points forward in front of the user.
     *
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     *
     * @param mirror -  Pass `true` to mirror the location in the X-axis.
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseWithAttitude(mirror) {
        return this._z.pipeline_camera_pose_with_attitude(this._impl, mirror || false);
    }
    /**
     * Returns a transformation with the (camera-relative) origin specified by the supplied parameter.
     *
     * This is used with the `poseCameraRelative(...) : Float32Array` functions provided by the various anchor types to allow a given anchor (e.g. a tracked image or face) to be the origin of world space.
     *
     * In this case the camera moves and rotates in world space around the anchor at the origin.
     *
     * @param o - The origin matrix.
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseWithOrigin(o) {
        return this._z.pipeline_camera_pose_with_origin(this._impl, o);
    }
    /**
      * Returns true if the current camera frame came from a user-facing camera
     */ cameraFrameUserFacing() {
        return this._z.pipeline_camera_frame_user_facing(this._impl);
    }
    /**
      * @ignore
     */ drawFace(projectionMatrix, cameraMatrix, targetMatrix, m) {
        this._z.pipeline_draw_face(this._impl, projectionMatrix, cameraMatrix, targetMatrix, m._getImpl());
    }
    /**
      * Returns the number of the current frame.
     */ frameNumber() {
        return this._z.pipeline_frame_number(this._impl);
    }
    /**
     * Start recording camera and motion data into memory. This data can then used with SequenceSource to replay the sequence.
     *
     * @param expectedFrames - The number of camera frames you expect to capture. If supplied, memory will be pre-allocated to improve performance
     */ sequenceRecordStart(expectedFrames) {
        if (expectedFrames === undefined) expectedFrames = 150; // 5 second default
        this._z.pipeline_sequence_record_start(this._impl, expectedFrames);
    }
    /**
     * Stop recording camera and motion data.
     */ sequenceRecordStop() {
        this._z.pipeline_sequence_record_stop(this._impl);
    }
    /**
     * Remove any camera and motion data currently stored in memory.
     */ sequenceRecordClear() {
        this._z.pipeline_sequence_record_clear(this._impl);
    }
    /**
     * Get the data captured by sequence recording.
     *
     * @returns A Uint8Array of packed camera and motion data
     */ sequenceRecordData() {
        return this._z.pipeline_sequence_record_data(this._impl);
    }
}





class $6f3fc8bf948b2428$export$8da7a4c55ed49539 {
    /**
     * Constructs a new FaceLanmdmark.
     * @param _name - The name of the landmark to track.
     * @see https://docs.zap.works/universal-ar/javascript/face-tracking/
    */ constructor(_name){
        this._name = _name;
        /**
         * The most recent pose of this landmark, relative to the [[FaceAnchor]] used to update it.
         * A 4x4 column-major transformation matrix.
         */ this.pose = (0, $2e616e7f2b93d8b0$exports).create();
        this._z = (0, $d5527567a7407cf0$exports.z)();
        this._impl = this._z.face_landmark_create(this._name);
    }
    /**
     * Destroys the face landmark.
     */ destroy() {
        this._z.face_landmark_destroy(this._impl);
    }
    /**
     * Updates pose directly from the expression and identity in a [[FaceAnchor]].
     * @param f - The anchor to derive the expression and identity from.
     * @param mirror - Pass `true` to mirror the location in the X-axis.
    */ updateFromFaceAnchor(f, mirror) {
        this._z.face_landmark_update(this._impl, f.identity, f.expression, mirror || false);
        this.pose = this._z.face_landmark_anchor_pose(this._impl);
    }
    /**
     * Updates pose directly from identity and expression coefficients.
     * @param identity  - The identity coefficients.
     * @param expression - The expression coefficients.
     * @param mirror - Pass `true` to mirror the location in the X-axis.
    */ updateFromIdentityExpression(identity, expression, mirror) {
        this._z.face_landmark_update(this._impl, identity, expression, mirror || false);
        this.pose = this._z.face_landmark_anchor_pose(this._impl);
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
}


var $db79f51b538a4157$exports = {};

$parcel$export($db79f51b538a4157$exports, "Permission", function () { return $db79f51b538a4157$export$a461eaf23bef603e; });
$parcel$export($db79f51b538a4157$exports, "permissionRequest", function () { return $db79f51b538a4157$export$d303ff031c4d4b58; });
$parcel$export($db79f51b538a4157$exports, "permissionDeniedUI", function () { return $db79f51b538a4157$export$2e339b4d51173824; });

var $db79f51b538a4157$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $db79f51b538a4157$export$a461eaf23bef603e;
(function(Permission) {
    /**
    * Permission to access camera images.
    */ Permission[Permission["CAMERA"] = 0] = "CAMERA";
    /**
     * Permission to access device motion data (e.g. accelerometer and gyro). Some tracking algorithms require this data to operate.
     */ Permission[Permission["MOTION"] = 1] = "MOTION";
})($db79f51b538a4157$export$a461eaf23bef603e || ($db79f51b538a4157$export$a461eaf23bef603e = {}));
function $db79f51b538a4157$export$f568f2f64377aed0(onlyPermsission) {
    switch(onlyPermsission){
        case $db79f51b538a4157$export$a461eaf23bef603e.CAMERA:
            return (0, $d5527567a7407cf0$exports.z)().permission_granted_camera();
        case $db79f51b538a4157$export$a461eaf23bef603e.MOTION:
            return (0, $d5527567a7407cf0$exports.z)().permission_granted_motion();
        default:
            return (0, $d5527567a7407cf0$exports.z)().permission_granted_all();
    }
}
function $db79f51b538a4157$export$a188bf2e0d7eb5c7(onlyPermission) {
    switch(onlyPermission){
        case $db79f51b538a4157$export$a461eaf23bef603e.CAMERA:
            return (0, $d5527567a7407cf0$exports.z)().permission_denied_camera();
        case $db79f51b538a4157$export$a461eaf23bef603e.MOTION:
            return (0, $d5527567a7407cf0$exports.z)().permission_denied_motion();
        default:
            return (0, $d5527567a7407cf0$exports.z)().permission_denied_any();
    }
}
function $db79f51b538a4157$export$d303ff031c4d4b58(onlyPermission) {
    switch(onlyPermission){
        case $db79f51b538a4157$export$a461eaf23bef603e.CAMERA:
            (0, $d5527567a7407cf0$exports.z)().permission_request_camera();
            break;
        case $db79f51b538a4157$export$a461eaf23bef603e.MOTION:
            (0, $d5527567a7407cf0$exports.z)().permission_request_motion();
            break;
        default:
            (0, $d5527567a7407cf0$exports.z)().permission_request_all();
            break;
    }
    // eslint-disable-next-line no-async-promise-executor
    return new Promise((resolve)=>$db79f51b538a4157$var$__awaiter(this, void 0, void 0, function*() {
            // eslint-disable-next-line no-constant-condition
            while(true){
                yield $db79f51b538a4157$var$_nextFrame();
                switch(onlyPermission){
                    case $db79f51b538a4157$export$a461eaf23bef603e.CAMERA:
                        if ((0, $d5527567a7407cf0$exports.z)().permission_granted_camera()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $d5527567a7407cf0$exports.z)().permission_denied_camera()) {
                            resolve(false);
                            return;
                        }
                        break;
                    case $db79f51b538a4157$export$a461eaf23bef603e.MOTION:
                        if ((0, $d5527567a7407cf0$exports.z)().permission_granted_motion()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $d5527567a7407cf0$exports.z)().permission_denied_motion()) {
                            resolve(false);
                            return;
                        }
                        break;
                    default:
                        if ((0, $d5527567a7407cf0$exports.z)().permission_granted_camera() && (0, $d5527567a7407cf0$exports.z)().permission_granted_motion()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $d5527567a7407cf0$exports.z)().permission_denied_camera() || (0, $d5527567a7407cf0$exports.z)().permission_denied_motion()) {
                            resolve(false);
                            return;
                        }
                        break;
                }
            }
        }));
}
function $db79f51b538a4157$export$447cf121adb7b558() {
    return $db79f51b538a4157$var$__awaiter(this, void 0, void 0, function*() {
        return yield (0, $d5527567a7407cf0$exports.z)().permission_request_ui_promise();
    });
}
function $db79f51b538a4157$export$2e339b4d51173824() {
    return (0, $d5527567a7407cf0$exports.z)().permission_denied_ui();
}
function $db79f51b538a4157$var$_nextFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}




function $b9a53a58e8143762$export$b564441c22aac826() {
    return (0, $d5527567a7407cf0$exports.z)().log_level();
}
function $b9a53a58e8143762$export$c622e99c0ce7b1c9(l) {
    (0, $d5527567a7407cf0$exports.z)().log_level_set(l);
}






/* eslint-disable tsdoc/syntax */ // eslint-disable-next-line no-restricted-imports

const $b22c529ae3c9a1be$export$80ed8c37bba391f3 = $0147bee01cff6558$exports;




let $e48612378252951b$var$defaultPipeline;
const $e48612378252951b$export$129b224e7efc1ade = new (0, $46abd614147db5d5$export$d61e24a684f9e51)();
function $e48612378252951b$export$aaa5f5f072ab70d() {
    if (!$e48612378252951b$var$defaultPipeline) {
        $e48612378252951b$var$defaultPipeline = new $b235e14258fd5458$export$abd47b564b6c9ce2();
        $e48612378252951b$var$defaultPipeline.onFrameUpdate.bind(()=>$e48612378252951b$export$129b224e7efc1ade.emit());
    }
    return $e48612378252951b$var$defaultPipeline;
}
class $e48612378252951b$export$333222788f3dd075 extends $61e0c0f83e511ee0$exports.ImageTracker {
    /**
     * Constructs a new ImageTracker.
     * @param targetFile - The .zpt target file from the source image you'd like to track.
     * @param pipeline - The pipeline that this tracker will operate within.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
     */ constructor(targetFile, pipeline){
        super(pipeline || $e48612378252951b$export$aaa5f5f072ab70d(), targetFile);
    }
}
class $e48612378252951b$export$441c3cbad541da1b extends $95dd83f26d184eeb$export$441c3cbad541da1b {
    /**
     * Constructs a new BarcodeFinder.
     * @param pipeline - The pipeline that this tracker will operate within.
     */ constructor(pipeline){
        super(pipeline || $e48612378252951b$export$aaa5f5f072ab70d());
    }
}
class $e48612378252951b$export$bb2337bd021e3bce extends $088e1200d72f1b4c$exports.FaceTracker {
    /**
     * Constructs a new FaceTracker.
     * @param _pipeline - The pipeline that this tracker will operate within.
     */ constructor(pipeline){
        super(pipeline || $e48612378252951b$export$aaa5f5f072ab70d());
    }
}
class $e48612378252951b$export$230d52b81bfab97f extends $b0249d9831ada913$export$230d52b81bfab97f {
    /**
     * Constructs a new InstantWorldTracker.
     * @param _pipeline - The pipeline that this tracker will operate within.
     */ constructor(pipeline){
        super(pipeline || $e48612378252951b$export$aaa5f5f072ab70d());
    }
}
class $e48612378252951b$export$9a93ce53f488cb2e extends $2a05cc60824dd816$export$9a93ce53f488cb2e {
    /**
     * Constructs a new CameraSource.
     * @param _pipeline - The pipeline that this source will operate within.
     * @param deviceId - The camera device ID which will be used as the source.
     * @see https://docs.zap.works/universal-ar/javascript/pipelines-and-camera-processing/
     */ constructor(deviceId, pipeline){
        super(pipeline || $e48612378252951b$export$aaa5f5f072ab70d(), deviceId);
    }
}
class $e48612378252951b$export$bbfb48c500076b66 extends $4fcd7dcae9b5cd10$export$bbfb48c500076b66 {
    /**
     * Constructs a new HTMLElementSource.
     * @param element -  The HTML source element.
     * @param pipeline - The pipeline that this tracker will operate within.
     */ constructor(element, pipeline){
        super(pipeline || $e48612378252951b$export$aaa5f5f072ab70d(), element);
    }
}
function $e48612378252951b$export$efb561eaedf42055(gl) {
    $e48612378252951b$export$aaa5f5f072ab70d().glContextSet(gl);
}
function $e48612378252951b$export$3ca78aa2d472f506() {
    $e48612378252951b$export$aaa5f5f072ab70d().glContextLost();
}




class $13bb5595f2246ccd$export$6516fe1fcd178d63 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Texture {
    constructor(){
        super(...arguments);
        this.MirrorMode = (0, $fc46da155223dbe8$export$974403070558317).None;
        this.isVideoTexture = true;
    }
    /**
     * Override three.js update function since we update the camera texture ourselves.
     */ update() {}
    /**
     * Processes camera frames and updates the texture.
     * @param renderer - The Three.js WebGL renderer.
     * @param pipeline - A ZapparThree Pipeline.
     */ updateFromPipeline(renderer, pipeline) {
        this.encoding = renderer.outputEncoding;
        pipeline.cameraFrameUploadGL();
        const texture = pipeline.cameraFrameTextureGL();
        if (!texture) return;
        // Update the underlying WebGL texture of the ThreeJS texture object
        // to the one provided by the Zappar library
        const properties = renderer.properties.get(this);
        // eslint-disable-next-line no-underscore-dangle
        properties.__webglTexture = texture;
        // eslint-disable-next-line no-underscore-dangle
        properties.__webglInit = true;
        // The Zappar library provides a 4x4 UV matrix to display the camera
        // texture on a fullscreen quad with 0,0 -> 1,1 UV coordinates
        const view = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Matrix4();
        view.fromArray(pipeline.cameraFrameTextureMatrix(renderer.domElement.width, renderer.domElement.height, this.MirrorMode === (0, $fc46da155223dbe8$export$974403070558317).Poses));
        // ThreeJS's Texture object uses a 3x3 matrix, so convert from our 4x4 matrix
        const textureMatrix3 = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Matrix3();
        textureMatrix3.setFromMatrix4(view);
        // eslint-disable-next-line prefer-destructuring
        textureMatrix3.elements[6] = view.elements[12];
        // eslint-disable-next-line prefer-destructuring
        textureMatrix3.elements[7] = view.elements[13];
        textureMatrix3.elements[8] = 1;
        // The typings for ThreeJS's Texture object does not include the matrix properties
        // so we have a custom type here
        this.matrixAutoUpdate = false;
        this.matrix = textureMatrix3;
    }
}


var $fc46da155223dbe8$export$3a3d770f890a3a97;
(function(CameraPoseMode) {
    /**
     * The camera sits, stationary, at the origin of world space, and points down the negative Z axis.
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     */ CameraPoseMode[CameraPoseMode["Default"] = 0] = "Default";
    /**
     * The camera sits at the origin of world space, but rotates as the user rotates the physical device.
     *
     * When the Zappar library initializes, the negative Z axis of world space points forward in front of the user.
     *
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     */ CameraPoseMode[CameraPoseMode["Attitude"] = 1] = "Attitude";
    /**
     * In this case the camera moves and rotates in world space around the anchor at the origin.
     */ CameraPoseMode[CameraPoseMode["AnchorOrigin"] = 2] = "AnchorOrigin";
})($fc46da155223dbe8$export$3a3d770f890a3a97 || ($fc46da155223dbe8$export$3a3d770f890a3a97 = {}));
var $fc46da155223dbe8$export$974403070558317;
(function(CameraMirrorMode) {
    /**
     * No mirroring.
     */ CameraMirrorMode[CameraMirrorMode["None"] = 0] = "None";
    /**
     * This mode mirrors the background camera texture and ensures content still appears correctly tracked.
     * In this mode your content itself isn't flipped, so any text in your tracked content doesn't appear mirrored.
     * This is the default mode for the user-facing camera.
     */ CameraMirrorMode[CameraMirrorMode["Poses"] = 1] = "Poses";
    /**
     * In this mode, the Zappar camera applies a scaleX(-1) CSS transform to your whole canvas.
     * This way both the camera and your content appear mirrored.
     */ CameraMirrorMode[CameraMirrorMode["CSS"] = 2] = "CSS";
})($fc46da155223dbe8$export$974403070558317 || ($fc46da155223dbe8$export$974403070558317 = {}));
/**
 * The directions that the camera can face.
 */ var $fc46da155223dbe8$var$CameraDirection;
(function(CameraDirection) {
    /** The camera is not running.
     * This is the default mode for the camera.
     */ CameraDirection[CameraDirection["None"] = 0] = "None";
    /** In this mode, the camera is always facing the user. */ CameraDirection[CameraDirection["User"] = 1] = "User";
    /** In this mode, the camera is always facing away from the user. */ CameraDirection[CameraDirection["Rear"] = 2] = "Rear";
})($fc46da155223dbe8$var$CameraDirection || ($fc46da155223dbe8$var$CameraDirection = {}));
class $fc46da155223dbe8$export$79f141de891a5fed extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Camera {
    /**
     * Constructs a new Camera.
     * @param pipeline - The pipeline that this tracker will operate within.
     * @property pipeline - The pipeline that this tracker will operate within.
     * @property zNear - The near clipping plane.
     * @property zFar - The far clipping plane.
     * @property rearCameraSource? - The camera source which will be used for the rear camera.
     * @property userCameraSource? - The camera source which will be used for the user camera.
     */ constructor(opts){
        super();
        /**
         * The pose mode that determines how the camera moves in the scene.
         */ this.poseMode = $fc46da155223dbe8$export$3a3d770f890a3a97.Default;
        /**
         * The mirror mode that is used for the rear camera.
         */ this.rearCameraMirrorMode = $fc46da155223dbe8$export$974403070558317.None;
        /**
         * The mirror mode that is used for the user camera.
         */ this.userCameraMirrorMode = $fc46da155223dbe8$export$974403070558317.Poses;
        this._currentMirrorMode = $fc46da155223dbe8$export$974403070558317.None;
        /**
         * @ignore
         * Needed for raycasters to work.
         */ this.isPerspectiveCamera = true;
        this.cameraDirection = $fc46da155223dbe8$var$CameraDirection.None;
        this.hasSetCSSScaleX = false;
        this.renderWidth = 0;
        this.renderHeight = 0;
        this.pipeline = opts instanceof $b235e14258fd5458$export$abd47b564b6c9ce2 ? opts : (opts === null || opts === void 0 ? void 0 : opts.pipeline) || (0, $e48612378252951b$export$aaa5f5f072ab70d)();
        this.rawPose = this.pipeline.cameraPoseDefault();
        if (opts && !(opts instanceof $b235e14258fd5458$export$abd47b564b6c9ce2)) {
            this.zNear = opts.zNear ? opts.zNear : 0.1;
            this.zFar = opts.zFar ? opts.zFar : 100;
            this.rearCameraSource = this.cameraSourceFromOpts(opts.rearCameraSource);
            this.userCameraSource = this.cameraSourceFromOpts(opts.userCameraSource, true);
            this.backgroundTexture = opts.backgroundTexture ? opts.backgroundTexture : new (0, $13bb5595f2246ccd$export$6516fe1fcd178d63)();
        } else {
            this.rearCameraSource = new (0, $e48612378252951b$export$9a93ce53f488cb2e)($d5527567a7407cf0$exports.cameraDefaultDeviceID(), this.pipeline);
            this.userCameraSource = new (0, $e48612378252951b$export$9a93ce53f488cb2e)($d5527567a7407cf0$exports.cameraDefaultDeviceID(true), this.pipeline);
            this.backgroundTexture = new (0, $13bb5595f2246ccd$export$6516fe1fcd178d63)();
        }
        this.matrixAutoUpdate = false;
        document.addEventListener("visibilitychange", ()=>{
            document.visibilityState === "visible" ? this.resume() : this.pause();
        });
    }
    /**
     * Constructs a new CameraSource or HTMLElementSource based on parameters passed in.
     * @param cameraSource - HTML element or camera device ID which will be used as a source
     * @returns CameraSource if cameraSource param is undefined or string, otherwise HTMLElementSource.
     */ cameraSourceFromOpts(cameraSource, frontFacing = false) {
        return cameraSource instanceof Element ? new $4fcd7dcae9b5cd10$export$bbfb48c500076b66(this.pipeline, cameraSource) : new (0, $e48612378252951b$export$9a93ce53f488cb2e)(cameraSource || $d5527567a7407cf0$exports.cameraDefaultDeviceID(frontFacing), this.pipeline);
    }
    /**
     * Pauses the camera source.
     */ pause() {
        this.userCameraSource.pause();
        this.rearCameraSource.pause();
    }
    /**
     * Starts the camera source.
     *
     * Starting a given source pauses any other sources within the same pipeline.
     */ resume() {
        switch(this.cameraDirection){
            case $fc46da155223dbe8$var$CameraDirection.User:
                this.userCameraSource.start();
                break;
            case $fc46da155223dbe8$var$CameraDirection.Rear:
                this.rearCameraSource.start();
                break;
            default:
                break;
        }
    }
    /**
     * Starts the camera source.
     * @param userFacing - If true, starts the user facing camera. (i.e selfie).
     */ start(userFacing) {
        this.cameraDirection = userFacing ? $fc46da155223dbe8$var$CameraDirection.User : $fc46da155223dbe8$var$CameraDirection.Rear;
        this.resume();
    }
    /**
     * Stops the camera source.
     */ stop() {
        this.cameraDirection = $fc46da155223dbe8$var$CameraDirection.None;
        this.pause();
    }
    /**
     * Sets the pose mode to 'Anchor Origin'.
     *
     * In this case the camera moves and rotates in world space around the anchor at the origin.
     * @param anchor - The anchor that defines the origin.
     */ setPoseModeAnchorOrigin(anchor) {
        this.poseAnchorOrigin = anchor;
        this.poseMode = $fc46da155223dbe8$export$3a3d770f890a3a97.AnchorOrigin;
    }
    /**
     * Gets the current mirror mode.
     */ get currentMirrorMode() {
        // eslint-disable-next-line no-underscore-dangle
        return this._currentMirrorMode;
    }
    /**
     * Processes camera frames and updates `backgroundTexture`.
     * Call this function on your pipeline once an animation frame (e.g. during your `requestAnimationFrame` function).
     * @param renderer - The Three.js WebGL renderer.
     */ updateFrame(renderer) {
        this.pipeline.processGL();
        // Update to using the latest tracking frame data
        this.pipeline.frameUpdate();
        // eslint-disable-next-line no-underscore-dangle
        this._currentMirrorMode = this.pipeline.cameraFrameUserFacing() ? this.userCameraMirrorMode : this.rearCameraMirrorMode;
        const { domElement: domElement } = renderer;
        if (this.currentMirrorMode !== $fc46da155223dbe8$export$974403070558317.CSS && this.hasSetCSSScaleX) {
            domElement.style.transform = "";
            this.hasSetCSSScaleX = false;
        } else if (this.currentMirrorMode === $fc46da155223dbe8$export$974403070558317.CSS && !this.hasSetCSSScaleX) {
            domElement.style.transform = "scaleX(-1)";
            this.hasSetCSSScaleX = true;
        }
        this.renderWidth = renderer.domElement.width;
        this.renderHeight = renderer.domElement.height;
        // eslint-disable-next-line no-underscore-dangle
        this._updateProjectionMatrix();
        // Get the pose of the camera from the Zappar library
        switch(this.poseMode){
            case $fc46da155223dbe8$export$3a3d770f890a3a97.Default:
                this.rawPose = this.pipeline.cameraPoseDefault();
                break;
            case $fc46da155223dbe8$export$3a3d770f890a3a97.Attitude:
                this.rawPose = this.pipeline.cameraPoseWithAttitude(this.currentMirrorMode === $fc46da155223dbe8$export$974403070558317.Poses);
                break;
            case $fc46da155223dbe8$export$3a3d770f890a3a97.AnchorOrigin:
                this.rawPose = this.poseAnchorOrigin ? this.getOriginPose() : this.pipeline.cameraPoseDefault();
                break;
            default:
                this.rawPose = this.pipeline.cameraPoseDefault();
                break;
        }
        this.matrixWorldNeedsUpdate = true;
        this.backgroundTexture.MirrorMode = this.currentMirrorMode;
        this.backgroundTexture.updateFromPipeline(renderer, this.pipeline);
    }
    // eslint-disable-next-line no-underscore-dangle
    _updateProjectionMatrix() {
        // Get the projection matrix for the camera from the Zappar library
        const model = this.pipeline.cameraModel();
        const projection = $d5527567a7407cf0$exports.projectionMatrixFromCameraModel(model, this.renderWidth, this.renderHeight, this.zNear, this.zFar);
        this.projectionMatrix.fromArray(projection);
        if (typeof this.projectionMatrixInverse.invert === "function") this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
        else this.projectionMatrixInverse.getInverse(this.projectionMatrix);
    }
    updateMatrixWorld(force) {
        this.matrix.fromArray(this.rawPose);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
        super.updateMatrixWorld(force);
    }
    getOriginPose() {
        if (!this.poseAnchorOrigin) return this.pipeline.cameraPoseDefault();
        return this.pipeline.cameraPoseWithOrigin(this.poseAnchorOrigin.poseCameraRelative(this.currentMirrorMode === $fc46da155223dbe8$export$974403070558317.Poses));
    }
    /**
     * Destroys the camera sources.
     */ dispose() {
        this.rearCameraSource.destroy();
        this.userCameraSource.destroy();
    }
}




class $1b501b5db76c99e4$export$b3062829607710c9 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Group {
    /**
     * Constructs a new ImageAnchorGroup.
     * @param camera - A ZapparThree.Camera.
     * @param imageTracker - The image tracker which will be used.
     * @param anchorId - Specify this to limit the group to tracking an anchor with the provided ID.
     */ constructor(camera, imageTracker, anchorId){
        super();
        this.camera = camera;
        this.imageTracker = imageTracker;
        this.anchorId = anchorId;
        /**
         * @ignore
         */ this.isReady = false;
        // We'll be updating this Group's matrix ourselves from the Zappar library
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        if (!this.currentAnchor || !this.imageTracker.visible.has(this.currentAnchor)) {
            // No current anchor, or current anchor isn't visible
            if (this.anchorId) this.currentAnchor = this.imageTracker.anchors.get(this.anchorId);
            else this.currentAnchor = this.imageTracker.visible.values().next().value;
        }
        if (this.currentAnchor) {
            this.matrix.fromArray(this.currentAnchor.pose(this.camera.rawPose, this.camera.currentMirrorMode === (0, $fc46da155223dbe8$export$974403070558317).Poses));
            this.matrix.decompose(this.position, this.quaternion, this.scale);
        }
        super.updateMatrixWorld(force);
    }
}


/* eslint-disable class-methods-use-this */ 

class $72cfbe60c317b85c$export$476589aa8292412e extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Loader {
    /**
     * Loads an image tracker.
     * @param zpt - A URL to, or ArrayBuffer of, an image target file.
     * @param onLoad - Callback which returns the imageTracker once it's loaded.
     * @param onError - Callback which is called if there's an error loading the target file.
     * @returns The ImageTracker.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
     */ load(zpt, onLoad, onProgress, onError) {
        const trk = new (0, $e48612378252951b$export$333222788f3dd075)();
        trk.loadTarget(zpt).then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(zpt);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(zpt);
            this.manager.itemEnd(zpt);
        });
        return trk;
    }
    /**
     * @ignore
     */ parse() {}
}




class $6bfbc3f523f831ef$export$d205f0b92721f194 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Group {
    /**
     * Constructs a new InstantWorldAnchorGroup.
     * @param camera - A ZapparThree.Camera.
     * @param instantTracker - The instant world tracker which will be used.
     */ constructor(camera, instantTracker){
        super();
        this.camera = camera;
        this.instantTracker = instantTracker;
        // We'll be updating this Group's matrix ourselves from the Zappar library
        this.matrixAutoUpdate = false;
    }
    /**
     * Sets the point in the user's environment that the anchor tracks from.
     *
     * The parameters passed in to this function correspond to the X, Y and Z coordinates (in camera space) of the point to track.
     * Choosing a position with X and Y coordinates of zero, and a negative Z coordinate,
     * will select a point on a surface directly in front of the center of the screen.
     *
     * @param orientation -  The orientation of the point in space.
     */ setAnchorPoseFromCameraOffset(x, y, z, orientation) {
        this.instantTracker.setAnchorPoseFromCameraOffset(x, y, z, orientation);
    }
    updateMatrixWorld(force) {
        this.matrix.fromArray(this.instantTracker.anchor.pose(this.camera.rawPose, this.camera.currentMirrorMode === (0, $fc46da155223dbe8$export$974403070558317).Poses));
        this.matrix.decompose(this.position, this.quaternion, this.scale);
        super.updateMatrixWorld(force);
    }
}




class $d41b711c32111773$export$c7a2c06edb4f910d extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Group {
    /**
     * Constructs a new FaceAnchorGroup.
     * @param camera - A ZapparThree.Camera.
     * @param faceTracker - The face tracker which will be used.
     * @param anchorId - Specify this to limit the group to tracking an anchor with the provided ID.
     */ constructor(camera, faceTracker, anchorId){
        super();
        this.camera = camera;
        this.faceTracker = faceTracker;
        this.anchorId = anchorId;
        /**
         * @ignore
         */ this.isReady = false;
        // We'll be updating this Group's matrix ourselves from the Zappar library
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        if (!this.currentAnchor || !this.faceTracker.visible.has(this.currentAnchor)) {
            // No current anchor, or current anchor isn't visible
            if (this.anchorId) this.currentAnchor = this.faceTracker.anchors.get(this.anchorId);
            else this.currentAnchor = this.faceTracker.visible.values().next().value;
        }
        if (this.currentAnchor) {
            this.matrix.fromArray(this.currentAnchor.pose(this.camera.rawPose, this.camera.currentMirrorMode === (0, $fc46da155223dbe8$export$974403070558317).Poses));
            this.matrix.decompose(this.position, this.quaternion, this.scale);
        }
        super.updateMatrixWorld(force);
    }
}






class $00016796c98d4f0e$export$2b6da85a49cb7391 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Group {
    /**
     * Constructs a new FaceLandmarkGroup.
     * @param camera - A ZapparThree.Camera.
     * @param faceTracker - The face tracker which will be used.
     * @param landmark - The landmark to which the group will be anchored.
     */ constructor(camera, faceTracker, landmark){
        super();
        this.camera = camera;
        this.faceTracker = faceTracker;
        this.pose = (0, $2e616e7f2b93d8b0$exports).create();
        this.landmark = new (0, $6f3fc8bf948b2428$export$8da7a4c55ed49539)(landmark);
        // We'll be updating this Group's matrix ourselves from the Zappar library
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        if (!this.currentAnchor || !this.faceTracker.visible.has(this.currentAnchor)) // No current anchor, or current anchor isn't visible
        this.currentAnchor = this.faceTracker.visible.values().next().value;
        if (this.currentAnchor) {
            this.landmark.updateFromFaceAnchor(this.currentAnchor, this.camera.currentMirrorMode === (0, $fc46da155223dbe8$export$974403070558317).Poses);
            (0, $2e616e7f2b93d8b0$exports).multiply(this.pose, this.currentAnchor.pose(this.camera.rawPose, this.camera.currentMirrorMode === (0, $fc46da155223dbe8$export$974403070558317).Poses), this.landmark.pose);
            this.matrix.fromArray(this.pose);
            this.matrix.decompose(this.position, this.quaternion, this.scale);
        }
        super.updateMatrixWorld(force);
    }
    /**
     * Destroys the face landmark.
     */ dispose() {
        this.landmark.destroy();
    }
}


/* eslint-disable class-methods-use-this */ 

class $083766edec89eee5$export$6477c3a8ab843fd9 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Loader {
    /**
     * Loads face tracking model data.
     * @param customModel - A URL to, or ArrayBuffer of, model data.
     * @param options - A URL or ArrayBuffer of the source mesh data or defines if some face features should be filled with polygons.
     * @param onLoad - Callback which returns the FaceMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The FaceTracker.
     */ load(customModel, onLoad, onProgress, onError) {
        const trk = new (0, $e48612378252951b$export$bb2337bd021e3bce)();
        const p = customModel ? trk.loadModel(customModel) : trk.loadDefaultModel();
        const itemFilename = typeof customModel === "string" ? customModel : "__zappar_threejs_face_tracker_default";
        p.then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(itemFilename);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(itemFilename);
            this.manager.itemEnd(itemFilename);
        });
        return trk;
    }
    /**
     * @ignore
     */ parse() {}
}



/* eslint-disable class-methods-use-this */ 

class $801dc7388b6f6080$export$866c7932b77a7aa1 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Loader {
    /**
     * Loads the data for a face mesh.
     * @param options - A URL or ArrayBuffer of the source mesh data or defines if some face features should be filled with polygons.
     * @param onLoad - Callback which returns the FaceMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The FaceMesh.
     */ load(options, onLoad, onProgress, onError) {
        const trk = new (0, $331744928f4ad43b$exports.FaceMesh)();
        let p;
        const itemFilename = `__zappar_threejs_face_mesh_${JSON.stringify(options || "default")}`;
        this.manager.itemStart(itemFilename);
        if (options) {
            if (typeof options === "string") p = trk.load(options);
            else if (options.customModel) p = trk.load(options.customModel, options.fillMouth, options.fillEyeLeft, options.fillEyeRight, options.fillNeck);
            else p = trk.loadDefaultFace(options.fillMouth, options.fillEyeLeft, options.fillEyeRight);
        } else p = trk.loadDefaultFace();
        p.then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(itemFilename);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(itemFilename);
            this.manager.itemEnd(itemFilename);
        });
        return trk;
    }
    /**
     * Loads the default face mesh.
     * @param options - Defines if some face features should be filled with polygons.
     * @param onLoad - Callback which returns the FaceMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The FaceMesh.
     */ loadFace(options, onLoad, onProgress, onError) {
        const trk = new (0, $331744928f4ad43b$exports.FaceMesh)();
        let p;
        const itemFilename = `__zappar_threejs_face_mesh_face_${JSON.stringify(options || "default")}`;
        if (options) {
            if (options.customModel) p = trk.load(options.customModel, options.fillMouth, options.fillEyeLeft, options.fillEyeRight, options.fillNeck);
            else p = trk.loadDefaultFace(options.fillMouth, options.fillEyeLeft, options.fillEyeRight);
        } else p = trk.loadDefaultFace();
        p.then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(itemFilename);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(itemFilename);
            this.manager.itemEnd(itemFilename);
        });
        return trk;
    }
    /**
     * Loads the full head simplified mesh which covers the whole of the user's head, including some neck.
     * It's ideal for drawing into the depth buffer in order to mask out the back of 3D models placed on the user's head.
     * @param options - Defines if some face features should be filled with polygons.
     * @param onLoad - Callback which returns the FaceMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The FaceMesh.
     */ loadFullHeadSimplified(options, onLoad, onProgress, onError) {
        const trk = new (0, $331744928f4ad43b$exports.FaceMesh)();
        let p;
        const itemFilename = `__zappar_threejs_face_mesh_full_head_${JSON.stringify(options || "default")}`;
        if (options) {
            if (options.customModel) p = trk.load(options.customModel, options.fillMouth, options.fillEyeLeft, options.fillEyeRight, options.fillNeck);
            else p = trk.loadDefaultFullHeadSimplified(options.fillMouth, options.fillEyeLeft, options.fillEyeRight, options.fillNeck);
        } else p = trk.loadDefaultFullHeadSimplified();
        p.then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(itemFilename);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(itemFilename);
            this.manager.itemEnd(itemFilename);
        });
        return trk;
    }
    /**
     * @ignore
     */ parse() {}
}


let $b6780fa216190c37$var$faceMeshSingleton;
class $b6780fa216190c37$export$ba2edb9dcb012875 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).BufferGeometry {
    /**
     * Constructs a new FaceBufferGeometry.
     * @param faceMesh - The face mesh which will be used. If not specified, the default face mesh will be loaded.
     */ constructor(faceMesh){
        super();
        this.hasSetIndices = false;
        this.hasSetUVs = false;
        this.recalculateNormals = true;
        this.setIndex([]);
        this.setAttribute("position", new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Float32BufferAttribute([], 3));
        this.setAttribute("normal", new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Float32BufferAttribute([], 3));
        this.setAttribute("uv", new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Float32BufferAttribute([], 2));
        if (!faceMesh) {
            if (!$b6780fa216190c37$var$faceMeshSingleton) $b6780fa216190c37$var$faceMeshSingleton = new (0, $801dc7388b6f6080$export$866c7932b77a7aa1)().load();
            // eslint-disable-next-line no-param-reassign
            faceMesh = $b6780fa216190c37$var$faceMeshSingleton;
        }
        this._faceMesh = faceMesh;
    }
    _updateIndices() {
        if (this.hasSetIndices) return;
        if (this._faceMesh.indices.length === 0) return;
        this.setIndex(new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Uint16BufferAttribute(this._faceMesh.indices, 1));
        this.hasSetIndices = true;
    }
    _updateUVs() {
        if (this.hasSetUVs) return;
        if (this._faceMesh.uvs.length === 0) return;
        this.setAttribute("uv", new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).BufferAttribute(this._faceMesh.uvs, 2));
        this.hasSetUVs = true;
    }
    /**
     * @ignore
     */ get calculateNormals() {
        return this.recalculateNormals;
    }
    /**
     * @ignore
     */ set calculateNormals(b) {
        this.recalculateNormals = b;
        if (!this.recalculateNormals) {
            if (typeof this.removeAttribute === "function") this.removeAttribute("normal");
            delete this.normals;
        }
    }
    /**
     * Updates the geometry to the most recent identity and expression output from a face anchor group.
     * @param f - The face anchor group which will be used to update the geometry.
     */ updateFromFaceAnchorGroup(f) {
        if (this._faceMesh.vertices.length === 0) return;
        if (!f.currentAnchor) return;
        this.updateFromFaceAnchor(f.currentAnchor);
    }
    /**
     * Updates the geometry to the most recent identity and expression output from a face anchor.
     * @param f - The face anchor which will be used to update the geometry.
     */ updateFromFaceAnchor(f) {
        this.updateFromIdentityExpression(f.identity, f.expression);
    }
    /**
     * Updates the geometry to the provided identity and expression coefficients.
     * @param identity  - The identity coefficients.
     * @param expression - The expression coefficients.
     */ updateFromIdentityExpression(identity, expression) {
        if (this._faceMesh.vertices.length === 0) return;
        this._updateIndices();
        this._updateUVs();
        this._faceMesh.updateFromIdentityExpression(identity, expression);
        if (!this.vertices) {
            this.vertices = new Float32Array(this._faceMesh.vertices.length);
            this.verticesAttribute = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).BufferAttribute(this.vertices, 3);
            this.setAttribute("position", this.verticesAttribute);
        }
        this.vertices.set(this._faceMesh.vertices);
        if (this.verticesAttribute) this.verticesAttribute.needsUpdate = true;
        this.computeBoundingSphere();
        if (!this.calculateNormals) return;
        if (!this.normals) {
            this.normals = new Float32Array(this._faceMesh.normals.length);
            this.normalsAttribute = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).BufferAttribute(this.normals, 3);
            this.setAttribute("normal", this.normalsAttribute);
        }
        this.normals.set(this._faceMesh.normals);
        if (this.normalsAttribute) this.normalsAttribute.needsUpdate = true;
    }
}






class $f71204d54974f67d$export$a961155be7c87c3 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Mesh {
    /**
     * Constructs a new head mask mesh.
     * @param onLoad - Callback function which runs when the mesh is loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     */ constructor(onLoad, onError){
        super();
        this.onLoad = onLoad;
        this.onError = onError;
        this.faceMesh = new $331744928f4ad43b$exports.FaceMesh();
        this.faceBufferGeometry = new (0, $b6780fa216190c37$export$ba2edb9dcb012875)(this.faceMesh);
        this.geometry = this.faceBufferGeometry;
        this.material = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).MeshBasicMaterial({
            colorWrite: false
        });
        this.faceMesh.loadDefaultFullHeadSimplified(true, true, true, true).then(()=>{
            var _a;
            return (_a = this.onLoad) === null || _a === void 0 ? void 0 : _a.call(this);
        }).catch(()=>{
            var _a;
            return (_a = this.onError) === null || _a === void 0 ? void 0 : _a.call(this);
        });
        this.renderOrder = Number.MIN_SAFE_INTEGER;
    }
    /**
     * Updates pose directly from the [[FaceAnchorGroup]] anchor.
     * @param f - The anchor to derive the expression and identity from.
     */ updateFromFaceAnchorGroup(f) {
        this.faceBufferGeometry.updateFromFaceAnchorGroup(f);
    }
    /**
     * Updates pose directly from the expression and identity in a [[FaceAnchor]].
     * @param f - The anchor to derive the expression and identity from.
     */ updateFromFaceAnchor(f) {
        this.faceBufferGeometry.updateFromFaceAnchor(f);
    }
    /**
     * Updates pose directly from identity and expression coefficients.
     * @param identity  - The identity coefficients.
     * @param expression - The expression coefficients.
     */ updateFromIdentityExpression(identity, expression) {
        this.faceBufferGeometry.updateFromIdentityExpression(identity, expression);
    }
    /**
     * Destroys the face mesh and disposes of resources.
     */ dispose() {
        this.faceMesh.destroy();
        this.faceBufferGeometry.dispose();
    }
}


/* eslint-disable class-methods-use-this */ 

const $3a31215383e50cea$var$itemFilename = "__zappar_threejs_head_mask_mesh";
class $3a31215383e50cea$export$78438eeac3ca8f03 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Loader {
    /**
     * Loads a HeadMaskMesh.
     * @param onLoad - Callback which returns the HeadMaskMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The HeadMaskMesh.
     */ load(onLoad, onProgress, onError) {
        this.manager.itemStart($3a31215383e50cea$var$itemFilename);
        return new (0, $f71204d54974f67d$export$a961155be7c87c3)(()=>{
            onLoad === null || onLoad === void 0 || onLoad();
            this.manager.itemEnd($3a31215383e50cea$var$itemFilename);
        }, ()=>{
            onError === null || onError === void 0 || onError();
            this.manager.itemError($3a31215383e50cea$var$itemFilename);
            this.manager.itemEnd($3a31215383e50cea$var$itemFilename);
        });
    }
    /**
     * @ignore
     */ parse() {}
}


/* eslint-disable class-methods-use-this */ 

const $58cbad245e1e29d6$var$itemFilename = "__zappar_threejs_library";
class $58cbad245e1e29d6$export$6ed2c5ca64bd5225 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Loader {
    /**
     * Resolves once the library is loaded and ready to process data.
     * @param onLoad - Callback which runs once the library is fully loaded.
     * @param onError - Callback which is called if there's an error loading library.
     */ load(onLoad, onProgress, onError) {
        this.manager.itemStart($58cbad245e1e29d6$var$itemFilename);
        (0, $d5527567a7407cf0$exports.loadedPromise)().then(()=>{
            onLoad === null || onLoad === void 0 || onLoad();
            this.manager.itemEnd($58cbad245e1e29d6$var$itemFilename);
        }).catch((err)=>{
            onError === null || onError === void 0 || onError();
            this.manager.itemError($58cbad245e1e29d6$var$itemFilename);
            this.manager.itemEnd($58cbad245e1e29d6$var$itemFilename);
        });
    }
    /**
     * @ignore
     */ parse() {}
}


/* eslint-disable guard-for-in */ 

class $3774234b4aa1020d$var$UI {
    constructor(style){
        this.lastLoadPercentage = 0;
        this.divs = {
            inner: document.createElement("div"),
            title: document.createElement("div"),
            progress: document.createElement("div"),
            progressValue: document.createElement("div")
        };
        this.css = {
            container: {
                position: "fixed",
                width: "100%",
                height: "100%",
                top: "0px",
                left: "0px",
                zIndex: "10000",
                backgroundColor: "rgba(0,0,0,0.8)",
                fontFamily: "sans-serif",
                color: "rgba(255,255,255,1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "opacity 500ms"
            },
            inner: {
                maxWidth: "400px",
                textAlign: "center"
            },
            title: {
                fontSize: "20px"
            },
            progress: {
                background: "rgba(255,255,255, 0.1)",
                justifyContent: "flex-start",
                borderRadius: "100px",
                alignItems: "center",
                position: "relative",
                padding: "0 5px",
                display: "flex",
                height: "15px",
                width: "250px",
                margin: "15px"
            },
            progressValue: {
                boxShadow: "0 10px 40px -10px #fff",
                borderTopLeftRadius: "100px",
                borderBottomLeftRadius: "100px",
                background: "rgba(255,255,255,1)",
                height: "10px",
                width: "0",
                transition: "width 500ms"
            }
        };
        // update loading bar based on % = (n-loaded / n-total * 100)
        this.updateLoader = (loadPercentage)=>{
            if (loadPercentage < this.lastLoadPercentage) return;
            this.lastLoadPercentage = loadPercentage;
            const elem = document.getElementById("zappar-loader-progressValue");
            elem.style.width = `${loadPercentage}%`;
            elem.style.borderTopRightRadius = `${loadPercentage}px`;
            elem.style.borderBottomRightRadius = `${loadPercentage}px`;
            elem.addEventListener("transitionend", ()=>{
                if (loadPercentage === 100) {
                    this.containerDiv.style.opacity = "0";
                    this.containerDiv.addEventListener("transitionend", (ev)=>{
                        if (ev.propertyName === "opacity") this.dispose();
                    });
                }
            });
        };
        this.dispose = ()=>{
            this.containerDiv.remove();
        };
        this.customStyle = style;
        this.containerDiv = document.createElement("div");
    }
    initialize() {
        // eslint-disable-next-line no-restricted-syntax
        for(const key in this.divs)// eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.divs[key].id = `zappar-loader-${key}`;
        this.refreshStyle();
        this.divs.inner.appendChild(this.divs.title);
        this.divs.inner.appendChild(this.divs.progress);
        this.divs.progress.appendChild(this.divs.progressValue);
        this.containerDiv.appendChild(this.divs.inner);
        this.divs.title.innerHTML = "Loading...";
        document.body.append(this.containerDiv);
    }
    refreshStyle() {
        var _a, _b, _c, _d, _e;
        Object.assign(this.css.container, (_a = this.customStyle) === null || _a === void 0 ? void 0 : _a.container);
        Object.assign(this.css.inner, (_b = this.customStyle) === null || _b === void 0 ? void 0 : _b.inner);
        Object.assign(this.css.title, (_c = this.customStyle) === null || _c === void 0 ? void 0 : _c.title);
        Object.assign(this.css.progress, (_d = this.customStyle) === null || _d === void 0 ? void 0 : _d.progress);
        Object.assign(this.css.progressValue, (_e = this.customStyle) === null || _e === void 0 ? void 0 : _e.progressValue);
        Object.assign(this.containerDiv.style, this.css.container);
        Object.assign(this.divs.inner.style, this.css.inner);
        Object.assign(this.divs.title.style, this.css.title);
        Object.assign(this.divs.progress.style, this.css.progress);
        Object.assign(this.divs.progressValue.style, this.css.progressValue);
    }
}
class $3774234b4aa1020d$export$da96ffd6d2c5ddec extends $3774234b4aa1020d$var$UI {
    /**
     * Constructs a new DefaultLoaderUI.
     * @param options - The styling of the UI.
     * @param onload - The callback function to be called when assets are loaded.
     */ constructor(options){
        super(options === null || options === void 0 ? void 0 : options.style);
        (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).DefaultLoadingManager.onStart = ()=>{
            this.initialize();
        };
        (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).DefaultLoadingManager.onLoad = ()=>{
            var _a;
            (_a = options === null || options === void 0 ? void 0 : options.onLoad) === null || _a === void 0 || _a.call(options);
        };
        (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).DefaultLoadingManager.onProgress = (_url, itemsLoaded, itemsTotal)=>{
            this.updateLoader(itemsLoaded / itemsTotal * 100);
        };
    }
}
class $3774234b4aa1020d$export$99cc795e99919eed extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).LoadingManager {
    /**
     * Constructs a new LoadingManager.
     * @param options - Styling may be defined here, as well as any event callbacks.
     */ constructor(options){
        super(()=>{
            var _a;
            return (_a = options === null || options === void 0 ? void 0 : options.onLoad) === null || _a === void 0 ? void 0 : _a.call(options);
        }, (url, loaded, total)=>{
            var _a;
            this.ui.customStyle = options === null || options === void 0 ? void 0 : options.style;
            this.ui.refreshStyle();
            (_a = options === null || options === void 0 ? void 0 : options.onProgress) === null || _a === void 0 || _a.call(options, url, loaded, total);
            this.ui.updateLoader(loaded / total * 100);
        }, options === null || options === void 0 ? void 0 : options.onError);
        this.ui = new $3774234b4aa1020d$var$UI(); // no multiple inheritance (╯°□°)╯︵ ┻━┻
        this.onStartCallback = undefined;
        /**
         * @ignore
         */ this.onStart = ()=>{
            this.ui.initialize();
            if (this.onStartCallback) this.onStartCallback();
        };
        /**
         * Calls provided function when loading begins.
         * @param callback - Function that is called when loading starts.
         */ this._onStart = (callback)=>{
            this.onStartCallback = callback;
        };
        /**
         * Destroys the UI.
         */ this.dispose = ()=>{
            this.ui.dispose();
        };
        new (0, $58cbad245e1e29d6$export$6ed2c5ca64bd5225)(this).load();
    }
}



class $91c3e1f5dcc713f6$export$770c0a160afa3ffb {
    /**
     * Constructs a new Camera Environment Map.
     */ constructor(){
        this.cubeMapScene = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Scene();
        this.renderTarget = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).WebGLCubeRenderTarget(256, {
            format: (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).RGBAFormat,
            generateMipmaps: true,
            minFilter: (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).LinearMipmapLinearFilter
        });
        this.cubeCamera = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).CubeCamera(0.1, 1000, this.renderTarget);
        this.sphereMaterial = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).MeshBasicMaterial({
            side: (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).DoubleSide
        });
        this.sphereGroup = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Group();
        /**
         * The resulting map texture. Set this as your `scene.environment` or as a material's `envMap`.
         */ this.environmentMap = this.renderTarget.texture;
        this.cubeMapScene.add(this.cubeCamera);
        const sphere = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Mesh(new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).SphereGeometry(10, 16, 12), this.sphereMaterial);
        sphere.rotation.set(0, -0.5 * Math.PI, 0);
        this.sphereGroup.add(sphere);
        this.cubeMapScene.add(this.sphereGroup);
    }
    /**
     * Destroy the resources held by this object.
     */ dispose() {
        this.renderTarget.dispose();
        this.sphereMaterial.dispose();
    }
    /**
     * Update the contents of the environment map with the latest texture from the camera.
     *
     * Call this each frame after you call `update` on your Zappar camera, but before you render the scene.
     * @param renderer - Your renderer object
     * @param zapparCamera - The Zappar camera you're using to render your scene
     */ update(renderer, zapparCamera) {
        this.environmentMap.encoding = renderer.outputEncoding;
        this.sphereMaterial.map = zapparCamera.backgroundTexture;
        this.sphereGroup.quaternion.copy(zapparCamera.quaternion);
        this.cubeCamera.update(renderer, this.cubeMapScene);
    }
}



class $6f6dcd5e54fca3f7$export$8162c4b53657ac03 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).BufferGeometry {
    /**
     * Constructs a new TargetImagePreviewBufferGeometry.
     * @param imageTarget - The image target which will be used.
     */ constructor(imageTarget){
        var _a;
        super();
        this.imageTarget = imageTarget;
        this.hasSetIndices = false;
        this.hasSetUVs = false;
        this.recalculateNormals = true;
        this.setIndex([]);
        this.setAttribute("position", new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Float32BufferAttribute([], 3));
        this.setAttribute("normal", new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Float32BufferAttribute([], 3));
        this.setAttribute("uv", new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Float32BufferAttribute([], 2));
        if (this.imageTarget.preview.vertices.length === 0) throw new Error("No vertices found in the image target.");
        this._updateIndices();
        this._updateUVs();
        if (!this.vertices) {
            this.vertices = new Float32Array((_a = this.imageTarget) === null || _a === void 0 ? void 0 : _a.preview.vertices.length);
            this.verticesAttribute = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).BufferAttribute(this.vertices, 3);
            this.setAttribute("position", this.verticesAttribute);
        }
        this.vertices.set(this.imageTarget.preview.vertices);
        if (this.verticesAttribute) this.verticesAttribute.needsUpdate = true;
        this.computeBoundingSphere();
    }
    /**
     * @ignore
     */ _updateIndices() {
        var _a;
        if (this.hasSetIndices) return;
        if (((_a = this.imageTarget) === null || _a === void 0 ? void 0 : _a.preview.indices.length) === 0) return;
        this.setIndex(new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Uint16BufferAttribute(this.imageTarget.preview.indices, 1));
        this.hasSetIndices = true;
    }
    /**
     * @ignore
     */ _updateUVs() {
        if (this.hasSetUVs) return;
        if (this.imageTarget.preview.uvs.length === 0) return;
        this.setAttribute("uv", new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).BufferAttribute(this.imageTarget.preview.uvs, 2));
        this.hasSetUVs = true;
    }
    /**
     * @ignore
     */ get calculateNormals() {
        return this.recalculateNormals;
    }
}




class $9f06dff4929eeb66$export$bde4320e74a4f4c8 extends (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).Mesh {
    constructor(target, material = new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).MeshBasicMaterial({
        map: new (0, $b22c529ae3c9a1be$export$80ed8c37bba391f3).TextureLoader().load(target.image.src)
    })){
        super(new (0, $6f6dcd5e54fca3f7$export$8162c4b53657ac03)(target), material);
    }
}




console.log(`Zappar for ThreeJS v${(0, $9ed317250c83dc74$export$a4ad2735b021c132)}`);



var $a995c707ba21a538$exports = {};


$a995c707ba21a538$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("hq0mX");


var $e73da23a2fc0076c$exports = {};


$e73da23a2fc0076c$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("femmd");


var $330276b3ee057af3$exports = {};


$330276b3ee057af3$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("bbV0l");


var $2b1952ed3a89aa46$exports = {};


$2b1952ed3a89aa46$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("5Swzl");


var $7467383b6cd7ad2d$exports = {};


$7467383b6cd7ad2d$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("kD5ss");


var $12b9e81553494f49$exports = {};


$12b9e81553494f49$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("99VnP");


var $9018eea99106fd7d$exports = {};


$9018eea99106fd7d$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("f3Yyz");


var $dc773e070c186446$exports = {};


$dc773e070c186446$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("anoQy");


var $36e71f658f78359d$exports = {};


$36e71f658f78359d$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("3aUHn");


var $fad7e8f858cf51e7$exports = {};


$fad7e8f858cf51e7$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("wadZo");


var $fa736bf3625277c1$exports = {};


$fa736bf3625277c1$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("9vMEj");


var $a2b930e50935d768$exports = {};


$a2b930e50935d768$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("7nwIx");


var $7843ecba74ccbb6e$exports = {};


$7843ecba74ccbb6e$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("6ob2k");


var $7303d83e69bc5774$exports = {};


$7303d83e69bc5774$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("3nQMt");


var $f75c704ae79abc13$exports = {};


$f75c704ae79abc13$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("goKD6");


var $9fc0dbeec3059a17$exports = {};


$9fc0dbeec3059a17$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("kzspj");


var $15724f6d8be8e922$exports = {};


$15724f6d8be8e922$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("c706f");


var $d638feaf7fdc0bb0$exports = {};


$d638feaf7fdc0bb0$exports = (parcelRequire("aNJCr")).getBundleURL("eEdY6") + (parcelRequire("iE7OH")).resolve("jMzmp");


var $2ea84fdbd3aded2c$export$2e2bcd8739ae039 = {
    textures: {
        bluenoise: (/*@__PURE__*/$parcel$interopDefault($330276b3ee057af3$exports)),
        camouflage1: (/*@__PURE__*/$parcel$interopDefault($2b1952ed3a89aa46$exports)),
        camouflage2: (/*@__PURE__*/$parcel$interopDefault($7467383b6cd7ad2d$exports)),
        camouflage3: (/*@__PURE__*/$parcel$interopDefault($12b9e81553494f49$exports)),
        camouflage4: (/*@__PURE__*/$parcel$interopDefault($9018eea99106fd7d$exports)),
        camouflage5: (/*@__PURE__*/$parcel$interopDefault($dc773e070c186446$exports)),
        tunnel1: (/*@__PURE__*/$parcel$interopDefault($36e71f658f78359d$exports)),
        tunnel2: (/*@__PURE__*/$parcel$interopDefault($fad7e8f858cf51e7$exports)),
        tunnel3: (/*@__PURE__*/$parcel$interopDefault($fa736bf3625277c1$exports)),
        tunnel4: (/*@__PURE__*/$parcel$interopDefault($a2b930e50935d768$exports)),
        tunnel5: (/*@__PURE__*/$parcel$interopDefault($7843ecba74ccbb6e$exports)),
        glaucoma1: (/*@__PURE__*/$parcel$interopDefault($7303d83e69bc5774$exports)),
        glaucoma2: (/*@__PURE__*/$parcel$interopDefault($f75c704ae79abc13$exports)),
        glaucoma3: (/*@__PURE__*/$parcel$interopDefault($9fc0dbeec3059a17$exports)),
        glaucoma4: (/*@__PURE__*/$parcel$interopDefault($15724f6d8be8e922$exports)),
        glaucoma5: (/*@__PURE__*/$parcel$interopDefault($d638feaf7fdc0bb0$exports)),
        macula: (/*@__PURE__*/$parcel$interopDefault($a995c707ba21a538$exports)),
        cataracts: (/*@__PURE__*/$parcel$interopDefault($e73da23a2fc0076c$exports))
    }
};



const $711555eabecedb8b$var$pro = [
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0.856167,
    0.182038,
    -0.038205,
    0.029342,
    0.955115,
    0.015544,
    -0.00288,
    -0.001563,
    1.004443,
    0.734766,
    0.334872,
    -0.069637,
    0.05184,
    0.919198,
    0.028963,
    -0.004928,
    -0.004209,
    1.009137,
    0.630323,
    0.465641,
    -0.095964,
    0.069181,
    0.890046,
    0.040773,
    -0.006308,
    -0.007724,
    1.014032,
    0.539009,
    0.579343,
    -0.118352,
    0.082546,
    0.866121,
    0.051332,
    -0.007136,
    -0.011959,
    1.019095,
    0.458064,
    0.679578,
    -0.137642,
    0.092785,
    0.846313,
    0.060902,
    -0.007494,
    -0.016807,
    1.024301,
    0.38545,
    0.769005,
    -0.154455,
    0.100526,
    0.829802,
    0.069673,
    -0.007442,
    -0.02219,
    1.029632,
    0.319627,
    0.849633,
    -0.169261,
    0.106241,
    0.815969,
    0.07779,
    -0.007025,
    -0.028051,
    1.035076,
    0.259411,
    0.923008,
    -0.18242,
    0.110296,
    0.80434,
    0.085364,
    -0.006276,
    -0.034346,
    1.040622,
    0.203876,
    0.990338,
    -0.194214,
    0.112975,
    0.794542,
    0.092483,
    -0.005222,
    -0.041043,
    1.046265,
    0.152286,
    1.052583,
    -0.204868,
    0.114503,
    0.786281,
    0.099216,
    -0.003882,
    -0.048116,
    1.051998
];
const $711555eabecedb8b$var$deu = [
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0.866435,
    0.177704,
    -0.044139,
    0.049567,
    0.939063,
    0.01137,
    -0.003453,
    7233e-6,
    0.99622,
    0.760729,
    0.319078,
    -0.079807,
    0.090568,
    0.889315,
    0.020117,
    -0.006027,
    0.013325,
    0.992702,
    0.675425,
    0.43385,
    -0.109275,
    0.125303,
    0.847755,
    0.026942,
    -0.00795,
    0.018572,
    0.989378,
    0.605511,
    0.52856,
    -0.134071,
    0.155318,
    0.812366,
    0.032316,
    -0.009376,
    0.023176,
    0.9862,
    0.547494,
    0.607765,
    -0.155259,
    0.181692,
    0.781742,
    0.036566,
    -0.01041,
    0.027275,
    0.983136,
    0.498864,
    0.674741,
    -0.173604,
    0.205199,
    0.754872,
    0.039929,
    -0.011131,
    0.030969,
    0.980162,
    0.457771,
    0.731899,
    -0.18967,
    0.226409,
    0.731012,
    0.042579,
    -0.011595,
    0.034333,
    0.977261,
    0.422823,
    0.781057,
    -0.203881,
    0.245752,
    0.709602,
    0.044646,
    -0.011843,
    0.037423,
    0.974421,
    0.392952,
    0.82361,
    -0.216562,
    0.263559,
    0.69021,
    0.046232,
    -0.01191,
    0.040281,
    0.97163,
    0.367322,
    0.860646,
    -0.227968,
    0.280085,
    0.672501,
    0.047413,
    -0.01182,
    0.04294,
    0.968881
];
const $711555eabecedb8b$var$tri = [
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0.92667,
    0.092514,
    -0.019184,
    0.021191,
    0.964503,
    0.014306,
    8437e-6,
    0.054813,
    0.93675,
    0.89572,
    0.13333,
    -0.02905,
    0.029997,
    0.9454,
    0.024603,
    0.013027,
    0.104707,
    0.882266,
    0.905871,
    0.127791,
    -0.033662,
    0.026856,
    0.941251,
    0.031893,
    0.01341,
    0.148296,
    0.838294,
    0.948035,
    0.08949,
    -0.037526,
    0.014364,
    0.946792,
    0.038844,
    0.010853,
    0.193991,
    0.795156,
    1.017277,
    0.027029,
    -0.044306,
    -0.006113,
    0.958479,
    0.047634,
    6379e-6,
    0.248708,
    0.744913,
    1.104996,
    -0.046633,
    -0.058363,
    -0.032137,
    0.971635,
    0.060503,
    1336e-6,
    0.317922,
    0.680742,
    1.193214,
    -0.109812,
    -0.083402,
    -0.058496,
    0.97941,
    0.079086,
    -0.002346,
    0.403492,
    0.598854,
    1.257728,
    -0.139648,
    -0.118081,
    -0.078003,
    0.975409,
    0.102594,
    -0.003316,
    0.501214,
    0.502102,
    1.278864,
    -0.125333,
    -0.153531,
    -0.084748,
    0.957674,
    0.127074,
    -0.000989,
    0.601151,
    0.399838,
    1.255528,
    -0.076749,
    -0.178779,
    -0.078411,
    0.930809,
    0.147602,
    4733e-6,
    0.691367,
    0.3039
];
const $711555eabecedb8b$var$machado = {
    pro: $711555eabecedb8b$var$pro,
    deu: $711555eabecedb8b$var$deu,
    tri: $711555eabecedb8b$var$tri
};
let $711555eabecedb8b$var$hotShaderMaterials = [];
window.__on_glsl_hmr_update = function(source2) {
    console.log("XXX");
    for (let mat of $711555eabecedb8b$var$hotShaderMaterials){
        console.log(mat.name);
        if (mat.name == source2.id) {
            mat.vertexShader = $711555eabecedb8b$var$getStageSource(source2, "vertex");
            mat.fragmentShader = $711555eabecedb8b$var$getStageSource(source2, "fragment");
            mat.needsUpdate = true;
            console.log("HMR:", mat.name);
        }
    }
};
function $711555eabecedb8b$var$getStageSource(source2, stage) {
    let section = source2.sections.find((s)=>s.stage == stage);
    return section ? section.text : null;
}
class $711555eabecedb8b$var$HotShaderMaterial extends $0147bee01cff6558$export$21c421a2e1df9d22 {
    constructor({ source: source2, ...parameters }){
        super({
            ...parameters,
            name: source2.id,
            vertexShader: $711555eabecedb8b$var$getStageSource(source2, "vertex"),
            fragmentShader: $711555eabecedb8b$var$getStageSource(source2, "fragment")
        });
        $711555eabecedb8b$var$hotShaderMaterials.push(this);
    }
}
function $711555eabecedb8b$var$range(...args) {
    let lo, hi, step;
    if (args.length === 1) {
        lo = 0;
        hi = args[0];
        step = 1;
    } else if (args.length === 2) {
        lo = args[0];
        hi = args[1];
        step = 1;
    } else if (args.length === 3) {
        lo = args[0];
        hi = args[1];
        step = args[2];
    }
    const out = [];
    if (lo < hi && step > 0 || lo > hi && step < 0) for(let i = lo; step < 0 ? i > hi : i < hi; i += step)out.push(i);
    return out;
}
let $711555eabecedb8b$var$source$8 = {
    "id": "src/shaders/three/cvd.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\nuniform mat3 uMatTexCamera;\nvoid main() {\n    gl_Position = vec4(position, 1.0);\n    vCoord = (uMatTexCamera * vec3(uv, 1.0)).xy;\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "uniform mat3 uMatTexCamera;",
                "void main() {",
                "    gl_Position = vec4(position, 1.0);",
                "    vCoord = (uMatTexCamera * vec3(uv, 1.0)).xy;",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 51,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexCamera;\nuniform mat3 uMatCVD;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nvoid main() {\n    vec2 uv = vCoord;\n    if (uv.x < 0.0 || uv.x > 1.0 ||\n        uv.y < 0.0 || uv.y > 1.0)\n    {\n        discard;\n    }\n\n    vec3 C = texture2D(uTexCamera, uv).rgb;\n    C = linearFromSRGB(C);\n    C *= uMatCVD;\n    C = sRGBFromLinear(C);\n    //C += vec3(uv, 0.0);\n    gl_FragColor = vec4(C, 1.0);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexCamera;",
                "uniform mat3 uMatCVD;",
                "",
                "float linearFromSRGB(float s) {",
                "    if (s < 0.04045) {",
                "        return s / 12.92;",
                "    } else {",
                "        return pow((s + 0.055) / 1.055, 2.4);",
                "    }",
                "}",
                "",
                "float sRGBFromLinear(float l) {",
                "    if (l < 0.0031308) {",
                "        return l * 12.92;",
                "    } else {",
                "        return 1.055 * pow(l, 1.0/2.4) - 0.055;",
                "    }",
                "}",
                "",
                "vec3 linearFromSRGB(vec3 sRGB) {",
                "    return vec3(",
                "        linearFromSRGB(sRGB[0]),",
                "        linearFromSRGB(sRGB[1]),",
                "        linearFromSRGB(sRGB[2]));",
                "}",
                "",
                "vec3 sRGBFromLinear(vec3 linear) {",
                "    return vec3(",
                "        sRGBFromLinear(linear[0]),",
                "        sRGBFromLinear(linear[1]),",
                "        sRGBFromLinear(linear[2]));",
                "}",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "    if (uv.x < 0.0 || uv.x > 1.0 ||",
                "        uv.y < 0.0 || uv.y > 1.0)",
                "    {",
                "        discard;",
                "    }",
                "",
                "    vec3 C = texture2D(uTexCamera, uv).rgb;",
                "    C = linearFromSRGB(C);",
                "    C *= uMatCVD;",
                "    C = sRGBFromLinear(C);",
                "    //C += vec3(uv, 0.0);",
                "    gl_FragColor = vec4(C, 1.0);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$7 = {
    "id": "src/shaders/three/blur.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 21,
            "text": "attribute vec3 position;\nattribute vec2 uv;\n\nvarying vec2 vCoord0;\nvarying vec4 vCoord1, vCoord2;\n\nuniform vec2 uSampleDelta;\n\nvoid main() {\n    const float o1 = 1.38462, o2 = 3.22702;\n    vCoord0 = uv;\n    vCoord1 = vec4(\n        uv - o1 * uSampleDelta,\n        uv + o1 * uSampleDelta);\n    vCoord2 = vec4(\n        uv - o2 * uSampleDelta,\n        uv + o2 * uSampleDelta);\n    //gl_Position = vec4(2.*(position - .5), 0., 1.);\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "",
                "varying vec2 vCoord0;",
                "varying vec4 vCoord1, vCoord2;",
                "",
                "uniform vec2 uSampleDelta;",
                "",
                "void main() {",
                "    const float o1 = 1.38462, o2 = 3.22702;",
                "    vCoord0 = uv;",
                "    vCoord1 = vec4(",
                "        uv - o1 * uSampleDelta,",
                "        uv + o1 * uSampleDelta);",
                "    vCoord2 = vec4(",
                "        uv - o2 * uSampleDelta,",
                "        uv + o2 * uSampleDelta);",
                "    //gl_Position = vec4(2.*(position - .5), 0., 1.);",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 24,
            "count": 33,
            "text": "precision highp float;\nvarying vec2 vCoord0;\nvarying vec4 vCoord1, vCoord2;\nuniform sampler2D uTexSource;\nuniform vec2 uNoiseShift;\n\nfloat random(vec3 c) {\n    float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));\n    return fract(512.0*j + 0.123);\n}\n\nfloat rand(vec2 n) { \n    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);\n}\n\nvoid main() {\n    const float w0 = 0.22702, w1 = 0.31622, w2 = 0.07027;\n    gl_FragColor = (\n        w0 * texture2D(uTexSource, vCoord0) +\n        w1 * (\n            texture2D(uTexSource, vCoord1.xy) +\n            texture2D(uTexSource, vCoord1.zw)) +\n        w2 * (\n            texture2D(uTexSource, vCoord2.xy) +\n            texture2D(uTexSource, vCoord2.zw)));\n\n#ifdef USE_NOISE\n    vec2 uv = gl_FragCoord.xy + uNoiseShift;\n    float n = 0.020 * (rand(uv) - 0.5);\n    gl_FragColor.rgb += vec3(n);\n#endif\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord0;",
                "varying vec4 vCoord1, vCoord2;",
                "uniform sampler2D uTexSource;",
                "uniform vec2 uNoiseShift;",
                "",
                "float random(vec3 c) {",
                "    float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));",
                "    return fract(512.0*j + 0.123);",
                "}",
                "",
                "float rand(vec2 n) { ",
                "    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);",
                "}",
                "",
                "void main() {",
                "    const float w0 = 0.22702, w1 = 0.31622, w2 = 0.07027;",
                "    gl_FragColor = (",
                "        w0 * texture2D(uTexSource, vCoord0) +",
                "        w1 * (",
                "            texture2D(uTexSource, vCoord1.xy) +",
                "            texture2D(uTexSource, vCoord1.zw)) +",
                "        w2 * (",
                "            texture2D(uTexSource, vCoord2.xy) +",
                "            texture2D(uTexSource, vCoord2.zw)));",
                "",
                "#ifdef USE_NOISE",
                "    vec2 uv = gl_FragCoord.xy + uNoiseShift;",
                "    float n = 0.020 * (rand(uv) - 0.5);",
                "    gl_FragColor.rgb += vec3(n);",
                "#endif",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$6 = {
    "id": "src/shaders/three/armd.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 83,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\n\nuniform mat3 uMatCVD;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    // scale around center by severity (splodge larger as severity -> 1)\n    vec2 Suv = mix(3.0, 1.5, uSeverity) * (uv - 0.5) + 0.5;\n    vec4 S = sampleSplodge(Suv);\n\n    // caclc distortion\n    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);\n    float x = clamp(3.0 * S.r, 0.0, 1.0);\n\n    // sample and blur by severity\n    vec3 C0 = mix(\n        texture2D(uTexSource0, uv + Duv).rgb,\n        texture2D(uTexSource2, uv + Duv).rgb,\n        uSeverity);\n\n    // blur again\n    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;\n    vec3 C = mix(C0, C1, x);\n\n    // blend to grey\n    float grey = mix(0.5, 0.0, uSeverity * uSeverity);\n    C = mix(C, vec3(grey), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));\n\n    // apply CVD\n    C = sRGBFromLinear(uMatCVD * linearFromSRGB(C));\n\n    gl_FragColor = vec4(C, 1.0);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "",
                "uniform mat3 uMatCVD;",
                "",
                "float linearFromSRGB(float s) {",
                "    if (s < 0.04045) {",
                "        return s / 12.92;",
                "    } else {",
                "        return pow((s + 0.055) / 1.055, 2.4);",
                "    }",
                "}",
                "",
                "float sRGBFromLinear(float l) {",
                "    if (l < 0.0031308) {",
                "        return l * 12.92;",
                "    } else {",
                "        return 1.055 * pow(l, 1.0/2.4) - 0.055;",
                "    }",
                "}",
                "",
                "vec3 linearFromSRGB(vec3 sRGB) {",
                "    return vec3(",
                "        linearFromSRGB(sRGB[0]),",
                "        linearFromSRGB(sRGB[1]),",
                "        linearFromSRGB(sRGB[2]));",
                "}",
                "",
                "vec3 sRGBFromLinear(vec3 linear) {",
                "    return vec3(",
                "        sRGBFromLinear(linear[0]),",
                "        sRGBFromLinear(linear[1]),",
                "        sRGBFromLinear(linear[2]));",
                "}",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "",
                "    // scale around center by severity (splodge larger as severity -> 1)",
                "    vec2 Suv = mix(3.0, 1.5, uSeverity) * (uv - 0.5) + 0.5;",
                "    vec4 S = sampleSplodge(Suv);",
                "",
                "    // caclc distortion",
                "    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);",
                "    float x = clamp(3.0 * S.r, 0.0, 1.0);",
                "",
                "    // sample and blur by severity",
                "    vec3 C0 = mix(",
                "        texture2D(uTexSource0, uv + Duv).rgb,",
                "        texture2D(uTexSource2, uv + Duv).rgb,",
                "        uSeverity);",
                "",
                "    // blur again",
                "    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;",
                "    vec3 C = mix(C0, C1, x);",
                "",
                "    // blend to grey",
                "    float grey = mix(0.5, 0.0, uSeverity * uSeverity);",
                "    C = mix(C, vec3(grey), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));",
                "",
                "    // apply CVD",
                "    C = sRGBFromLinear(uMatCVD * linearFromSRGB(C));",
                "",
                "    gl_FragColor = vec4(C, 1.0);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$5 = {
    "id": "src/shaders/three/hemianopia.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 65,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\n\nuniform sampler2D uTexNoise;\n\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\n\nfloat blend(float x, float m, float h) {\n    return smoothstep(m - h, m + h, x);\n}\n\nfloat rand(vec2 n) { \n    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);\n}\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    //vec3 C1 = texture2D(uTexSource5, uv).rgb;\n    vec3 C;\n\n    {\n        float h = 0.1;\n        float m = 0.55;\n        float x = blend(vCoord.x, m, h);\n        vec3 gray = vec3(0.0);\n        \n        {\n            //vec2 uv = gl_FragCoord.xy * 0.002;\n            //gray += 0.005 * texture2D(uTexNoise, uv).rgb;\n        }\n        //gray += 0.05 * (rand(39.2*vCoord) - 0.5);\n\n        C = mix(C0, gray, blend(vCoord.x, 0.5, 0.010));\n        //C = mix(C0, C1, blend(vCoord.x, 0.9, 0.1));\n        //C = mix(C, gray, blend(vCoord.x, 0.4, 0.4));\n\n        /*\n        {\n            // spare central\n            float aspect = uResolution[0] / uResolution[1];\n            float h = mix(0.30, 0.00, uSeverity);\n            float m = mix(1.0, 0.0, sqrt(uSeverity));\n            vec2 uv = vCoord;\n            uv.x += 0.05;\n            float y = 0.0;\n            if (h > 0.0) {\n                y = 1.0 - smoothstep(-h, h, length((uv - 0.5) * vec2(aspect, 1.0)) - m);\n            }\n            C = mix(C, C0, y);\n        }\n        */\n    }\n\n    gl_FragColor = vec4(C, 1.0);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "",
                "uniform sampler2D uTexNoise;",
                "",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "",
                "float blend(float x, float m, float h) {",
                "    return smoothstep(m - h, m + h, x);",
                "}",
                "",
                "float rand(vec2 n) { ",
                "    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);",
                "}",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "    //vec3 C1 = texture2D(uTexSource5, uv).rgb;",
                "    vec3 C;",
                "",
                "    {",
                "        float h = 0.1;",
                "        float m = 0.55;",
                "        float x = blend(vCoord.x, m, h);",
                "        vec3 gray = vec3(0.0);",
                "        ",
                "        {",
                "            //vec2 uv = gl_FragCoord.xy * 0.002;",
                "            //gray += 0.005 * texture2D(uTexNoise, uv).rgb;",
                "        }",
                "        //gray += 0.05 * (rand(39.2*vCoord) - 0.5);",
                "",
                "        C = mix(C0, gray, blend(vCoord.x, 0.5, 0.010));",
                "        //C = mix(C0, C1, blend(vCoord.x, 0.9, 0.1));",
                "        //C = mix(C, gray, blend(vCoord.x, 0.4, 0.4));",
                "",
                "        /*",
                "        {",
                "            // spare central",
                "            float aspect = uResolution[0] / uResolution[1];",
                "            float h = mix(0.30, 0.00, uSeverity);",
                "            float m = mix(1.0, 0.0, sqrt(uSeverity));",
                "            vec2 uv = vCoord;",
                "            uv.x += 0.05;",
                "            float y = 0.0;",
                "            if (h > 0.0) {",
                "                y = 1.0 - smoothstep(-h, h, length((uv - 0.5) * vec2(aspect, 1.0)) - m);",
                "            }",
                "            C = mix(C, C0, y);",
                "        }",
                "        */",
                "    }",
                "",
                "    gl_FragColor = vec4(C, 1.0);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$4 = {
    "id": "src/shaders/three/cataracts.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 67,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    vec3 C1 = texture2D(uTexSource5, uv).rgb;\n    vec3 C;\n\n    {\n        float aspect = uResolution[0] / uResolution[1];\n        float scale = 0.8;\n        uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;\n\n        vec2 d = vec2(1.0) / 512.0;\n\n        vec4 S = sampleSplodge(uv);\n\n        float x = S.r;\n\n        float blur = 1.0;\n        float glare = x;\n        float darken = 1.0;\n\n        x = clamp(2.0 * x * x, 0.9*uSeverity, 1.0);\n        //gl_FragColor = vec4(x); return;\n        C = mix(C0, C1, blur * x);\n        C *= mix(1.0, 0.8, darken * x);\n\n        // distort\n        float distort = 0.4 * uSeverity;\n        vec2 G = 0.2 * (S.gb - 0.5);\n        uv = vCoord + distort * G;\n        C = mix(\n            texture2D(uTexSource1, uv).rgb,\n            texture2D(uTexSource5, uv).rgb,\n            blur * x);\n\n        C += glare * mix(0.1, 1.0, x) * texture2D(uTexSource5, uv).rgb;\n\n        float decontrast = 0.9 * uSeverity;\n        C = mix(C, 1.2 * vec3(0.5, 0.45, 0.35), decontrast * x);\n        C = mix(C, vec3(0.55, 0.50, 0.48), 0.05);\n    }\n\n    gl_FragColor = vec4(C, 1.0);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "    vec3 C1 = texture2D(uTexSource5, uv).rgb;",
                "    vec3 C;",
                "",
                "    {",
                "        float aspect = uResolution[0] / uResolution[1];",
                "        float scale = 0.8;",
                "        uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;",
                "",
                "        vec2 d = vec2(1.0) / 512.0;",
                "",
                "        vec4 S = sampleSplodge(uv);",
                "",
                "        float x = S.r;",
                "",
                "        float blur = 1.0;",
                "        float glare = x;",
                "        float darken = 1.0;",
                "",
                "        x = clamp(2.0 * x * x, 0.9*uSeverity, 1.0);",
                "        //gl_FragColor = vec4(x); return;",
                "        C = mix(C0, C1, blur * x);",
                "        C *= mix(1.0, 0.8, darken * x);",
                "",
                "        // distort",
                "        float distort = 0.4 * uSeverity;",
                "        vec2 G = 0.2 * (S.gb - 0.5);",
                "        uv = vCoord + distort * G;",
                "        C = mix(",
                "            texture2D(uTexSource1, uv).rgb,",
                "            texture2D(uTexSource5, uv).rgb,",
                "            blur * x);",
                "",
                "        C += glare * mix(0.1, 1.0, x) * texture2D(uTexSource5, uv).rgb;",
                "",
                "        float decontrast = 0.9 * uSeverity;",
                "        C = mix(C, 1.2 * vec3(0.5, 0.45, 0.35), decontrast * x);",
                "        C = mix(C, vec3(0.55, 0.50, 0.48), 0.05);",
                "    }",
                "",
                "    gl_FragColor = vec4(C, 1.0);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$3 = {
    "id": "src/shaders/three/glaucoma.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 59,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec4 S;\n\n    {\n        vec2 uv2 = uv;\n        if (uEye == 1)\n            uv2.x = 1.0 - uv2.x;\n        S = sampleSplodge(uv2);\n    }\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n\n    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);\n    vec3 C1 = texture2D(uTexSource5, uv2).rgb;\n    vec3 C;\n\n    C1 = mix(C1, vec3(0.45), mix(0.15, 0.80, uSeverity));\n\n    {\n        //float aspect = uResolution[0] / uResolution[1];\n        //float scale = 0.8;\n        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;\n        //vec2 d = vec2(1.0) / 512.0;\n        //vec4 S = texture2D(uTexSplodge, uv);\n        float scale = 2.2;\n        float x = min(1.0, S.r * scale);\n\n        vec2 d = uv - 0.5;\n        //x = max(x, uSeverity * length(d));\n        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));\n        C = mix(C0, C1, x);\n    }\n\n    gl_FragColor = vec4(C, 1.0);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "uniform int uEye;",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "    vec4 S;",
                "",
                "    {",
                "        vec2 uv2 = uv;",
                "        if (uEye == 1)",
                "            uv2.x = 1.0 - uv2.x;",
                "        S = sampleSplodge(uv2);",
                "    }",
                "",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "",
                "    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);",
                "    vec3 C1 = texture2D(uTexSource5, uv2).rgb;",
                "    vec3 C;",
                "",
                "    C1 = mix(C1, vec3(0.45), mix(0.15, 0.80, uSeverity));",
                "",
                "    {",
                "        //float aspect = uResolution[0] / uResolution[1];",
                "        //float scale = 0.8;",
                "        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;",
                "        //vec2 d = vec2(1.0) / 512.0;",
                "        //vec4 S = texture2D(uTexSplodge, uv);",
                "        float scale = 2.2;",
                "        float x = min(1.0, S.r * scale);",
                "",
                "        vec2 d = uv - 0.5;",
                "        //x = max(x, uSeverity * length(d));",
                "        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));",
                "        C = mix(C0, C1, x);",
                "    }",
                "",
                "    gl_FragColor = vec4(C, 1.0);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$2 = {
    "id": "src/shaders/three/achromatopsia.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 99,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\n\nvec3 scotopic(vec3 C) {\n    C = linearFromSRGB(C);\n\n    // convert to XYZ\n    vec3 XYZ = vec3(\n        0.5149 * C[0] + 0.3244 * C[1] + 0.1607 * C[2],\n        0.2654 * C[0] + 0.6704 * C[1] + 0.0642 * C[2],\n        0.0248 * C[0] + 0.1248 * C[1] + 0.8504 * C[2]);\n\n    // scotopic luminance (Larson et al)\n    float Ls = XYZ[1] * (\n        1.33 * (1.0 + (XYZ[1] + XYZ[2]) / XYZ[0]) - 1.68);\n\n    // regular luminance\n    //Ls = dot(C, vec3(0.2126, 0.7152, 0.0722));\n\n    vec3 blue = mix(vec3(1), vec3(.62, .6, 1.0), 0.5);\n    //C = Ls * 0.5 * vec3(1.0 - blue, 1.0 - blue, 1.0);\n    C = blue * vec3(Ls);\n    //C = mix(C0, C, 0.0);\n    C = sRGBFromLinear(C);\n    return C;\n}\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    {\n        // nystagmus\n        float u = fract(3.0 * uTime);\n        float x = u < 0.8 ?\n            smoothstep(0.0, 0.9, u) : \n            smoothstep(1.0, 0.9, u);\n        //uv.x += 0.01 * sin(30.0 * uTime);\n        float travel = 0.03 * smoothstep(0.7, 1.0, uSeverity);\n        vec2 d = travel * normalize(vec2(1.0, 0.1));\n        //uv += d * mix(-1.0, 1.0, x);\n    }\n\n    vec3 Cblur = texture2D(uTexSource4, uv).rgb;\n    vec3 Csharp = texture2D(uTexSource3, uv).rgb;\n\n    Cblur = scotopic(Cblur);\n    Csharp = scotopic(Csharp);\n\n    vec3 diff = Csharp - Cblur;\n\n    //float gamma = mix(1.25, 1.1, smoothstep(0.9, 1.0, uSeverity));\n    float gamma = 1.25;\n    vec3 C = sign(diff) * pow(abs(diff), vec3(1.0/gamma));\n    C = Cblur + C;\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    C = mix(C0, C, smoothstep(0.0, 0.5, uSeverity));\n    gl_FragColor = vec4(C, 1.0);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "",
                "float linearFromSRGB(float s) {",
                "    if (s < 0.04045) {",
                "        return s / 12.92;",
                "    } else {",
                "        return pow((s + 0.055) / 1.055, 2.4);",
                "    }",
                "}",
                "",
                "float sRGBFromLinear(float l) {",
                "    if (l < 0.0031308) {",
                "        return l * 12.92;",
                "    } else {",
                "        return 1.055 * pow(l, 1.0/2.4) - 0.055;",
                "    }",
                "}",
                "",
                "vec3 linearFromSRGB(vec3 sRGB) {",
                "    return vec3(",
                "        linearFromSRGB(sRGB[0]),",
                "        linearFromSRGB(sRGB[1]),",
                "        linearFromSRGB(sRGB[2]));",
                "}",
                "",
                "vec3 sRGBFromLinear(vec3 linear) {",
                "    return vec3(",
                "        sRGBFromLinear(linear[0]),",
                "        sRGBFromLinear(linear[1]),",
                "        sRGBFromLinear(linear[2]));",
                "}",
                "",
                "",
                "vec3 scotopic(vec3 C) {",
                "    C = linearFromSRGB(C);",
                "",
                "    // convert to XYZ",
                "    vec3 XYZ = vec3(",
                "        0.5149 * C[0] + 0.3244 * C[1] + 0.1607 * C[2],",
                "        0.2654 * C[0] + 0.6704 * C[1] + 0.0642 * C[2],",
                "        0.0248 * C[0] + 0.1248 * C[1] + 0.8504 * C[2]);",
                "",
                "    // scotopic luminance (Larson et al)",
                "    float Ls = XYZ[1] * (",
                "        1.33 * (1.0 + (XYZ[1] + XYZ[2]) / XYZ[0]) - 1.68);",
                "",
                "    // regular luminance",
                "    //Ls = dot(C, vec3(0.2126, 0.7152, 0.0722));",
                "",
                "    vec3 blue = mix(vec3(1), vec3(.62, .6, 1.0), 0.5);",
                "    //C = Ls * 0.5 * vec3(1.0 - blue, 1.0 - blue, 1.0);",
                "    C = blue * vec3(Ls);",
                "    //C = mix(C0, C, 0.0);",
                "    C = sRGBFromLinear(C);",
                "    return C;",
                "}",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "",
                "    {",
                "        // nystagmus",
                "        float u = fract(3.0 * uTime);",
                "        float x = u < 0.8 ?",
                "            smoothstep(0.0, 0.9, u) : ",
                "            smoothstep(1.0, 0.9, u);",
                "        //uv.x += 0.01 * sin(30.0 * uTime);",
                "        float travel = 0.03 * smoothstep(0.7, 1.0, uSeverity);",
                "        vec2 d = travel * normalize(vec2(1.0, 0.1));",
                "        //uv += d * mix(-1.0, 1.0, x);",
                "    }",
                "",
                "    vec3 Cblur = texture2D(uTexSource4, uv).rgb;",
                "    vec3 Csharp = texture2D(uTexSource3, uv).rgb;",
                "",
                "    Cblur = scotopic(Cblur);",
                "    Csharp = scotopic(Csharp);",
                "",
                "    vec3 diff = Csharp - Cblur;",
                "",
                "    //float gamma = mix(1.25, 1.1, smoothstep(0.9, 1.0, uSeverity));",
                "    float gamma = 1.25;",
                "    vec3 C = sign(diff) * pow(abs(diff), vec3(1.0/gamma));",
                "    C = Cblur + C;",
                "",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "    C = mix(C0, C, smoothstep(0.0, 0.5, uSeverity));",
                "    gl_FragColor = vec4(C, 1.0);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$1 = {
    "id": "src/shaders/three/retinitis_pigmentosa.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 82,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec4 S;\n    {\n        //float scale = mix(0.0, 3.0, uSeverity * uSeverity * uSeverity);\n        //vec2 uv2 = scale * (uv - 0.5) + 0.5;\n        S = sampleSplodge(uv);\n    }\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    vec3 C1 = texture2D(uTexSource5, uv).rgb;\n\n    //float d = min(1.0, length(uv - 0.5) * mix(0.1, 2.8, uSeverity));\n    //C1 = mix(C1, vec3(0.45), d);\n\n    vec3 C = C0;\n    float x = 1.0 - S.g;\n\n    C = mix(C0, C1, 1.0 - S.r);\n    C = mix(C, vec3(0.0), 1.0 - S.g);\n\n    gl_FragColor = vec4(C, 1.0);\n\n    /*\n    vec2 uv = vCoord;\n    vec4 S;\n\n    {\n        vec2 uv2 = uv;\n        if (uEye == 1)\n            uv2.x = 1.0 - uv2.x;\n        S = texture2D(uTexSplodge, uv2);\n    }\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n\n    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);\n    vec3 C1 = texture2D(uTexSource5, uv2).rgb;\n    vec3 C;\n\n    C1 = mix(C1, vec3(0.45), mix(0.75, 0.98, uSeverity));\n\n    {\n        //float aspect = uResolution[0] / uResolution[1];\n        //float scale = 0.8;\n        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;\n        //vec2 d = vec2(1.0) / 512.0;\n        //vec4 S = texture2D(uTexSplodge, uv);\n        float scale = 2.2;\n        float x = min(1.0, S.r * scale);\n\n        vec2 d = uv - 0.5;\n        //x = max(x, uSeverity * length(d));\n        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));\n        C = mix(C0, C1, x);\n    }\n\n    gl_FragColor = vec4(C, 1.0);\n    */\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "uniform int uEye;",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "    vec4 S;",
                "    {",
                "        //float scale = mix(0.0, 3.0, uSeverity * uSeverity * uSeverity);",
                "        //vec2 uv2 = scale * (uv - 0.5) + 0.5;",
                "        S = sampleSplodge(uv);",
                "    }",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "    vec3 C1 = texture2D(uTexSource5, uv).rgb;",
                "",
                "    //float d = min(1.0, length(uv - 0.5) * mix(0.1, 2.8, uSeverity));",
                "    //C1 = mix(C1, vec3(0.45), d);",
                "",
                "    vec3 C = C0;",
                "    float x = 1.0 - S.g;",
                "",
                "    C = mix(C0, C1, 1.0 - S.r);",
                "    C = mix(C, vec3(0.0), 1.0 - S.g);",
                "",
                "    gl_FragColor = vec4(C, 1.0);",
                "",
                "    /*",
                "    vec2 uv = vCoord;",
                "    vec4 S;",
                "",
                "    {",
                "        vec2 uv2 = uv;",
                "        if (uEye == 1)",
                "            uv2.x = 1.0 - uv2.x;",
                "        S = texture2D(uTexSplodge, uv2);",
                "    }",
                "",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "",
                "    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);",
                "    vec3 C1 = texture2D(uTexSource5, uv2).rgb;",
                "    vec3 C;",
                "",
                "    C1 = mix(C1, vec3(0.45), mix(0.75, 0.98, uSeverity));",
                "",
                "    {",
                "        //float aspect = uResolution[0] / uResolution[1];",
                "        //float scale = 0.8;",
                "        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;",
                "        //vec2 d = vec2(1.0) / 512.0;",
                "        //vec4 S = texture2D(uTexSplodge, uv);",
                "        float scale = 2.2;",
                "        float x = min(1.0, S.r * scale);",
                "",
                "        vec2 d = uv - 0.5;",
                "        //x = max(x, uSeverity * length(d));",
                "        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));",
                "        C = mix(C0, C1, x);",
                "    }",
                "",
                "    gl_FragColor = vec4(C, 1.0);",
                "    */",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source = {
    "id": "src/shaders/three/diabetic_retinopathy.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 122,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform mat3 uMatCVD;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    {\n        //vec4 S = texture2D(uTexSplodge, uv);\n        //gl_FragColor = vec4(vec3(S.r), 1.0);\n\n        //vec3 C = texture2D(uTexSource4, uv).rgb;\n        //gl_FragColor = vec4(C, 1.0);\n\n        //return;\n    }\n\n    vec4 S = sampleSplodge(uv);\n\n    // calc distortion\n    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);\n    float x = clamp(S.r, 0.0, 1.0);\n\n    // sample and blur by severity\n    vec3 C0 = mix(\n        texture2D(uTexSource0, uv + Duv).rgb,\n        texture2D(uTexSource2, uv + Duv).rgb,\n        uSeverity);\n\n    // blur again\n    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;\n    vec3 C = mix(C0, C1, x);\n\n    // blend to grey\n    float g = 1.0 - max(0.95*S.r, max(S.g, S.b));\n    C = mix(C, vec3(g), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));\n\n    //vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);\n    //float x = clamp(3.0 * S.r, 0.0, 1.0);\n    //vec2 Duv = 0.1 * (S.gb - 0.5);\n\n    /*\n    vec3 C0 = mix(\n        texture2D(uTexSource0, uv).rgb,\n        texture2D(uTexSource3, uv + Duv).rgb,\n        uSeverity);\n\n    vec3 C1 = mix(\n        texture2D(uTexSource5, uv + Duv).rgb,\n        vec3(0.05),\n        uSeverity*uSeverity);\n        */\n\n    //float x = clamp(1.5 * S.r, 0.0, 1.0);\n    //vec3 C = mix(C0, C1, x);\n\n    //C = linearFromSRGB(C);\n    //C = uMatCVD * C;\n    //C = sRGBFromLinear(C);\n\n    //float d = min(1.0, length(uv - 0.5) * mix(0.1, 2.8, uSeverity));\n    //C1 = mix(C1, vec3(0.45), d);\n\n    //vec3 C = C0;\n    //float x = 1.0 - S.g;\n\n    //C = mix(C0, C1, 1.0 - S.r);\n    //C = mix(C, vec3(0.5), 1.0 - S.g);\n\n    gl_FragColor = vec4(C, 1.0);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "uniform int uEye;",
                "",
                "uniform mat3 uMatCVD;",
                "",
                "float linearFromSRGB(float s) {",
                "    if (s < 0.04045) {",
                "        return s / 12.92;",
                "    } else {",
                "        return pow((s + 0.055) / 1.055, 2.4);",
                "    }",
                "}",
                "",
                "float sRGBFromLinear(float l) {",
                "    if (l < 0.0031308) {",
                "        return l * 12.92;",
                "    } else {",
                "        return 1.055 * pow(l, 1.0/2.4) - 0.055;",
                "    }",
                "}",
                "",
                "vec3 linearFromSRGB(vec3 sRGB) {",
                "    return vec3(",
                "        linearFromSRGB(sRGB[0]),",
                "        linearFromSRGB(sRGB[1]),",
                "        linearFromSRGB(sRGB[2]));",
                "}",
                "",
                "vec3 sRGBFromLinear(vec3 linear) {",
                "    return vec3(",
                "        sRGBFromLinear(linear[0]),",
                "        sRGBFromLinear(linear[1]),",
                "        sRGBFromLinear(linear[2]));",
                "}",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "",
                "    {",
                "        //vec4 S = texture2D(uTexSplodge, uv);",
                "        //gl_FragColor = vec4(vec3(S.r), 1.0);",
                "",
                "        //vec3 C = texture2D(uTexSource4, uv).rgb;",
                "        //gl_FragColor = vec4(C, 1.0);",
                "",
                "        //return;",
                "    }",
                "",
                "    vec4 S = sampleSplodge(uv);",
                "",
                "    // calc distortion",
                "    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);",
                "    float x = clamp(S.r, 0.0, 1.0);",
                "",
                "    // sample and blur by severity",
                "    vec3 C0 = mix(",
                "        texture2D(uTexSource0, uv + Duv).rgb,",
                "        texture2D(uTexSource2, uv + Duv).rgb,",
                "        uSeverity);",
                "",
                "    // blur again",
                "    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;",
                "    vec3 C = mix(C0, C1, x);",
                "",
                "    // blend to grey",
                "    float g = 1.0 - max(0.95*S.r, max(S.g, S.b));",
                "    C = mix(C, vec3(g), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));",
                "",
                "    //vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);",
                "    //float x = clamp(3.0 * S.r, 0.0, 1.0);",
                "    //vec2 Duv = 0.1 * (S.gb - 0.5);",
                "",
                "    /*",
                "    vec3 C0 = mix(",
                "        texture2D(uTexSource0, uv).rgb,",
                "        texture2D(uTexSource3, uv + Duv).rgb,",
                "        uSeverity);",
                "",
                "    vec3 C1 = mix(",
                "        texture2D(uTexSource5, uv + Duv).rgb,",
                "        vec3(0.05),",
                "        uSeverity*uSeverity);",
                "        */",
                "",
                "    //float x = clamp(1.5 * S.r, 0.0, 1.0);",
                "    //vec3 C = mix(C0, C1, x);",
                "",
                "    //C = linearFromSRGB(C);",
                "    //C = uMatCVD * C;",
                "    //C = sRGBFromLinear(C);",
                "",
                "    //float d = min(1.0, length(uv - 0.5) * mix(0.1, 2.8, uSeverity));",
                "    //C1 = mix(C1, vec3(0.45), d);",
                "",
                "    //vec3 C = C0;",
                "    //float x = 1.0 - S.g;",
                "",
                "    //C = mix(C0, C1, 1.0 - S.r);",
                "    //C = mix(C, vec3(0.5), 1.0 - S.g);",
                "",
                "    gl_FragColor = vec4(C, 1.0);",
                "}",
                ""
            ]
        }
    ]
};
class $711555eabecedb8b$var$MyTextureLoader extends $0147bee01cff6558$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        let texture = new $0147bee01cff6558$export$5431306cf43de24a();
        let loader = new $0147bee01cff6558$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let callback = (image)=>{
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad) onLoad({
                texture: texture,
                image: image
            });
        };
        loader.load(url, callback, onProgress, onError);
        return texture;
    }
}
const $711555eabecedb8b$var$lerp = (a, b, u)=>a + u * (b - a);
function $711555eabecedb8b$var$getCvdMatrix(out, type, amount) {
    if (type == "none") {
        out.identity();
        return;
    }
    let numKeys = 11;
    let u = amount * (numKeys - 1);
    let i0 = Math.floor(u);
    let i1 = Math.min(numKeys - 1, i0 + 1);
    let uu = u - i0;
    let name = type.substr(0, 3);
    let src = $711555eabecedb8b$var$machado[name];
    let sp0 = 9 * i0;
    let sp1 = 9 * i1;
    let matCVD = out.elements;
    for(let i = 0; i < 9; ++i)matCVD[i] = $711555eabecedb8b$var$lerp(src[sp0 + i], src[sp1 + i], uu);
}
function $711555eabecedb8b$var$createFullScreenQuad(material) {
    let geom = new $0147bee01cff6558$export$b7be63a67df8959();
    geom.setAttribute("position", new $0147bee01cff6558$export$cbe7a62641830ebd([
        -1,
        3,
        0,
        -1,
        -1,
        0,
        3,
        -1,
        0
    ], 3));
    geom.setAttribute("uv", new $0147bee01cff6558$export$cbe7a62641830ebd([
        0,
        2,
        0,
        0,
        2,
        0
    ], 2));
    return new $0147bee01cff6558$export$e176487c05830cc5(geom, material);
}
function $711555eabecedb8b$var$createTarget(w, h) {
    return new $0147bee01cff6558$export$3c052beb2e51e23f(w, h, {
        depthBuffer: false
    });
}
function $711555eabecedb8b$export$2e2bcd8739ae039({ assets: assets }) {
    let rtBase = $711555eabecedb8b$var$createTarget();
    let rtComp = $711555eabecedb8b$var$createTarget();
    let textureLoader = new $711555eabecedb8b$var$MyTextureLoader();
    let loadTexture = (name, options)=>{
        let url = assets.textures[name];
        let texture = textureLoader.load(url, ({ texture: texture2, image: image })=>{
            texture2.aspect = image.width / image.height;
        }, void 0, (err)=>{
            console.warn('EyewareEffects: error loading: "%s"', url);
        });
        if (options && options.repeat) texture.wrapS = texture.wrapT = $0147bee01cff6558$export$533346c8e8dac0f5;
        return texture;
    };
    let textures = {
        macula: loadTexture("macula"),
        cataracts: loadTexture("cataracts"),
        glaucoma: $711555eabecedb8b$var$range(5).map((i)=>loadTexture(`glaucoma${i + 1}`)),
        tunnel: $711555eabecedb8b$var$range(5).map((i)=>loadTexture(`tunnel${i + 1}`)),
        camouflage: $711555eabecedb8b$var$range(5).map((i)=>loadTexture(`camouflage${i + 1}`)),
        noise: loadTexture("bluenoise", {
            repeat: true
        })
    };
    function createConditionMaterial({ source: source2, uniforms: uniforms }) {
        return new $711555eabecedb8b$var$HotShaderMaterial({
            source: source2,
            uniforms: {
                uTexSource0: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uTexSource1: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uTexSource2: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uTexSource3: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uTexSource4: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uTexSource5: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uTexSplodge: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uTime: {
                    value: 0
                },
                uSeverity: {
                    value: 0
                },
                uResolution: {
                    value: new $0147bee01cff6558$export$c977b3e384af9ae1()
                },
                uEye: {
                    value: 0
                },
                uMatCVD: {
                    value: new $0147bee01cff6558$export$8ff26dafa08918()
                },
                uMatSplodge: {
                    value: new $0147bee01cff6558$export$8ff26dafa08918()
                },
                ...uniforms
            }
        });
    }
    let materials = {
        cvd: new $711555eabecedb8b$var$HotShaderMaterial({
            source: $711555eabecedb8b$var$source$8,
            uniforms: {
                uTexCamera: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uMatTexCamera: {
                    value: new $0147bee01cff6558$export$8ff26dafa08918()
                },
                uMatCVD: {
                    value: new $0147bee01cff6558$export$8ff26dafa08918()
                }
            }
        }),
        blur: new $711555eabecedb8b$var$HotShaderMaterial({
            source: $711555eabecedb8b$var$source$7,
            uniforms: {
                uTexSource: {
                    value: new $0147bee01cff6558$export$5431306cf43de24a()
                },
                uSampleDelta: {
                    value: new $0147bee01cff6558$export$c977b3e384af9ae1()
                },
                uNoiseShift: {
                    value: new $0147bee01cff6558$export$c977b3e384af9ae1()
                }
            },
            defines: {
            }
        }),
        armd: createConditionMaterial({
            source: $711555eabecedb8b$var$source$6
        }),
        cataracts: createConditionMaterial({
            source: $711555eabecedb8b$var$source$4
        }),
        glaucoma: createConditionMaterial({
            source: $711555eabecedb8b$var$source$3
        }),
        "diabetic-retinopathy": createConditionMaterial({
            source: $711555eabecedb8b$var$source
        }),
        "retinitis-pigmentosa": createConditionMaterial({
            source: $711555eabecedb8b$var$source$1
        }),
        hemianopia: createConditionMaterial({
            source: $711555eabecedb8b$var$source$5
        }),
        achromatopsia: createConditionMaterial({
            source: $711555eabecedb8b$var$source$2
        })
    };
    let quadMesh = $711555eabecedb8b$var$createFullScreenQuad();
    let quadCamera = new $0147bee01cff6558$export$9ebf355ee4ed261b(-1, 1, 1, -1, 0, 1);
    let cameraMatrix4 = new $0147bee01cff6558$export$2ae72fc923e5eb5();
    function renderQuad(renderer, material) {
        quadMesh.material = material;
        renderer.render(quadMesh, quadCamera);
    }
    function Level(index) {
        this.index = index;
        this.targets = [
            $711555eabecedb8b$var$createTarget(),
            $711555eabecedb8b$var$createTarget()
        ];
    }
    let numLevels = 5;
    let levels = $711555eabecedb8b$var$range(numLevels).map((index)=>new Level(index));
    new $0147bee01cff6558$export$c977b3e384af9ae1();
    let time0;
    let targetAspect = 1;
    function reallocTargets(renderer, mode) {
        let { width: width, height: height } = renderer.domElement;
        if (mode == "stereo") width /= 2;
        width = Math.floor(width);
        height = Math.floor(height);
        targetAspect = width / height;
        if (rtBase && rtBase.width === width && rtBase.height === height) return;
        console.log("realloc[%d]: %dx%d", 0, width, height);
        rtBase.setSize(width, height);
        rtComp.setSize(width, height);
        const baseShift = 1;
        levels.forEach((level, i)=>{
            let shift = baseShift + i;
            let w = width >> shift;
            let h = height >> shift;
            level.targets.forEach((target)=>target.setSize(w, h));
            console.log("realloc[%d]: %dx%d", 1 + i, w, h);
        });
    }
    function getBlurTexture(index) {
        if (index === 0) return rtBase.texture;
        else return levels[index - 1].targets[1].texture;
    }
    function renderBlur(renderer, sourceTexture) {
        let writeTarget, readTarget;
        {
            let { cvd: material } = materials;
            material.uniforms.uTexCamera.value = sourceTexture;
            material.uniforms.uMatTexCamera.value.copy(sourceTexture.matrix);
            material.uniforms.uMatCVD.value.identity();
            material.uniformsNeedUpdate = true;
            renderer.setRenderTarget(rtBase);
            renderQuad(renderer, material);
            writeTarget = levels[0].targets[1];
            renderer.setRenderTarget(writeTarget);
            renderQuad(renderer, material);
        }
        {
            let { blur: material } = materials;
            readTarget = writeTarget;
            for(let i = 0; i < numLevels; ++i){
                let level = levels[i];
                for(let j = 0; j < 2; ++j){
                    let horz = j === 0 ? 1 : 0;
                    let vert = 1 - horz;
                    material.uniforms.uSampleDelta.value.set(horz / (readTarget.width - 1), vert / (readTarget.height - 1));
                    material.uniforms.uNoiseShift.value.set(Math.random(), Math.random());
                    material.uniforms.uTexSource.value = readTarget.texture;
                    material.uniformsNeedUpdate = true;
                    writeTarget = level.targets[j];
                    renderer.setRenderTarget(writeTarget);
                    renderQuad(renderer, material);
                    readTarget = writeTarget;
                }
            }
        }
    }
    function timeNow() {
        return performance.now() * 1e-3;
    }
    function updateTime() {
        if (time0 === void 0) time0 = timeNow();
        return timeNow - time0;
    }
    let validConditions = [
        "none",
        "protanopia",
        "deuteranopia",
        "tritanopia",
        "achromatopsia",
        "hemianopia",
        "cataracts",
        "glaucoma",
        "retinitis-pigmentosa",
        "armd",
        "diabetic-retinopathy"
    ];
    function render({ renderer: renderer, camera: camera, condition: condition = "none", severity: severity = 5, mode: mode = "mono", scale: scale = [
        1,
        1
    ], blur: blur = 0 }) {
        let time = updateTime();
        reallocTargets(renderer, mode);
        if (!validConditions.includes(condition)) {
            console.warn('EyewareEffects: bad condition "%s"', condition);
            return;
        }
        severity = Math.floor(severity);
        if (severity < 1 || severity > 5) {
            console.warn('EyewareEffects: bad severity "%d"', severity);
            return;
        }
        let cameraTexture = camera.backgroundTexture;
        {
            cameraMatrix4.fromArray(camera.pipeline.cameraFrameTextureMatrix(rtComp.width, rtComp.height, false));
            let { matrix: matrix } = cameraTexture;
            matrix.setFromMatrix4(cameraMatrix4);
            matrix.elements[6] = cameraMatrix4.elements[12];
            matrix.elements[7] = cameraMatrix4.elements[13];
            matrix.elements[8] = 1;
        }
        renderBlur(renderer, cameraTexture);
        if (condition == "protanopia" || condition == "deuteranopia" || condition == "tritanopia" || condition == "none") {
            let material = materials.cvd;
            if (condition == "none") material.uniforms.uMatCVD.value.identity();
            else $711555eabecedb8b$var$getCvdMatrix(material.uniforms.uMatCVD.value, condition, severity / 5);
            material.uniforms.uTexCamera.value = getBlurTexture(0);
            material.uniforms.uMatTexCamera.value.identity();
            material.uniformsNeedUpdate = true;
            renderer.setRenderTarget(rtComp);
            renderQuad(renderer, material);
        } else {
            let material = materials[condition];
            material.uniforms.uMatCVD.value.identity();
            let splodge;
            if (condition == "cataracts") splodge = textures.cataracts;
            else if (condition == "glaucoma") splodge = textures.glaucoma[severity - 1];
            else if (condition == "retinitis-pigmentosa") splodge = textures.tunnel[severity - 1];
            else if (condition == "armd") {
                splodge = textures.macula;
                $711555eabecedb8b$var$getCvdMatrix(material.uniforms.uMatCVD.value, "tritanopia", 0.5 * severity / 5);
            } else if (condition == "diabetic-retinopathy") {
                splodge = textures.camouflage[severity - 1];
                $711555eabecedb8b$var$getCvdMatrix(material.uniforms.uMatCVD.value, "tritanopia", 0.5 * severity / 5);
            }
            if (splodge) {
                material.uniforms.uTexSplodge.value = splodge;
                let e = material.uniforms.uMatSplodge.value.elements;
                let sourceAspect = splodge.aspect ?? 1;
                let vScale = sourceAspect / targetAspect;
                e[4] = vScale;
                e[7] = 0.5 * (1 - vScale);
            }
            for(let i = 0; i < 6; ++i){
                let name = `uTexSource${i}`;
                material.uniforms[name].value = getBlurTexture(i);
            }
            material.uniforms.uTime.value = time;
            material.uniforms.uSeverity.value = severity / 5;
            material.uniforms.uResolution.value.set(rtComp.width, rtComp.height);
            material.uniforms.uEye.value = 0;
            renderer.setRenderTarget(rtComp);
            renderQuad(renderer, material);
        }
        renderer.setRenderTarget(null);
    }
    return Object.assign(new.target ? this : {}, {
        render: render,
        get texture () {
            return rtComp.texture;
        }
    });
}



class $5efca1fa0818cea8$export$2e2bcd8739ae039 extends (0, $0147bee01cff6558$export$f6cc00ef28d7cf97) {
    sizeVector = new (0, $0147bee01cff6558$export$c977b3e384af9ae1)();
    currentPixelRatio = Math.max(window.devicePixelRatio, 2);
    constructor(){
        super({
            powerPreference: "high-performance",
            preserveDrawingBuffer: true
        });
        document.body.appendChild(this.domElement);
        this.setPixelRatio(this.currentPixelRatio);
        this.setSize(window.innerWidth, window.innerHeight);
        this.setupListeners();
    }
    setupListeners = ()=>{
        window.addEventListener("resize", ()=>{
            this.setSize(window.innerWidth, window.innerHeight);
            this.setPixelRatio(this.currentPixelRatio);
        });
    };
    mainRender = (scene, camera, backgroundTexture)=>{
        scene.background = backgroundTexture;
        this.render(scene, camera);
    };
}


class $8d0b21abaa4a342c$export$2e2bcd8739ae039 {
    renderer;
    scene = new $0147bee01cff6558$export$38af1803e3442a7f();
    camera;
    zapparCamera;
    eyeConditionType;
    severityLevel;
    eyewareEffects;
    constructor(){
        this.eyeConditionType = "none";
        this.severityLevel = 1;
        this.camera = new $0147bee01cff6558$export$74e4ae24825f68d7(75, window.innerWidth / window.innerHeight, 0.1, 1000);
        this.renderer = new (0, $5efca1fa0818cea8$export$2e2bcd8739ae039)();
        // The Zappar library needs the WebGL context to process camera images
        // Use this function to set your context
        $e48612378252951b$export$efb561eaedf42055(this.renderer.getContext());
        // Create a camera and set the scene background to the camera's backgroundTexture
        this.zapparCamera = new $fc46da155223dbe8$export$79f141de891a5fed();
        this.zapparCamera.backgroundTexture.encoding = $0147bee01cff6558$export$f32388edbb32674;
        this.eyewareEffects = new (0, $711555eabecedb8b$export$2e2bcd8739ae039)({
            assets: (0, $2ea84fdbd3aded2c$export$2e2bcd8739ae039)
        });
        this.eventListeners();
    }
    async getPermissions() {
        const granted = await $db79f51b538a4157$exports.permissionRequest((0, $db79f51b538a4157$exports.Permission).CAMERA);
        if (granted) {
            this.zapparCamera.start();
            setTimeout(()=>{
                this.zapparCamera.start();
                setTimeout(()=>{
                    this.zapparCamera.start();
                }, 500);
            }, 500);
        } else // User denied the permissions so show Zappar's built-in 'permission denied' UI
        $db79f51b538a4157$exports.permissionDeniedUI();
        return granted;
    }
    animate = ()=>{
        // The Zappar camera should have updateFrame called every frame
        this.zapparCamera.updateFrame(this.renderer);
        // effects passes
        this.eyewareEffects.render({
            renderer: this.renderer,
            camera: this.zapparCamera,
            condition: this.eyeConditionType,
            severity: this.severityLevel,
            mode: "mono"
        });
        this.camera.updateWorldMatrix(true, true);
        this.renderer.mainRender(this.scene, this.camera, this.eyewareEffects.texture);
        // Ask the browser to call this function again next frame
        requestAnimationFrame(this.animate);
    };
    startScene() {
        const homepageElement = document.querySelector("#homepage");
        if (!homepageElement) return;
        homepageElement.classList.add("active");
        // Ask the browser to call this function again next frame
        requestAnimationFrame(this.animate);
    }
    eventListeners() {
        document.addEventListener("rnib:condition", (e)=>{
            let condition = e.detail.condition;
            if (condition.startsWith("armd-")) condition = "armd";
            this.eyeConditionType = condition;
            this.severityLevel = e.detail.severity;
        });
    }
}


class $083eeca896bb252c$var$Analytics {
    debugMode = true;
    constructor(){
        //@ts-expect-error
        if (!window.dataLayer) console.warn("Analytics not initialised");
        else console.log("\uD83D\uDCCA Analytics are on");
    }
    pushEvent = (ev)=>{
        this.debugMode && console.log("[ANALYTICS EVENT PUSH]", ev);
        //@ts-expect-error
        window.dataLayer && window.dataLayer.push(ev);
    };
    allowCameraAccess = (granted)=>this.pushEvent({
            event: "allow_camera",
            parameter: "permission_status",
            parameterValue: granted ? "allowed" : "denied"
        });
}
var $083eeca896bb252c$export$2e2bcd8739ae039 = new $083eeca896bb252c$var$Analytics();



const $34af371bd6ba8c73$var$config = {
    apiKey: (0, $fcd1c60f8fc0ad60$export$5fc3fe49cf93aaa9),
    product: "PRO",
    optionalCookies: [
        {
            name: "analytics",
            label: "Analytical Cookies",
            description: "Analytical cookies help us to impove our site by collecting and reporting information on its usage.",
            cookies: [
                "_ga",
                "_ga_*"
            ],
            lawfulBasis: "legitimate interest",
            onAccept: function() {
                //@ts-expect-error
                window.dataLayer?.push("consent", "update", {
                    analytics_storage: "granted"
                });
            },
            onRevoke: function() {
                //@ts-expect-error
                window.dataLayer?.push("consent", "update", {
                    analytics_storage: "denied"
                });
            }
        }
    ],
    initialState: "open",
    text: {
        title: "Welcome to Eyeware Lite. Before we start, this site uses cookies...",
        intro: "Some of these cookies are essential, while others help us to improve your experience by providing insights into how the site is being used. This site does NOT track user data which could be used for advertising or third party data brokers.",
        rejectSettings: "Reject all non essential cookies",
        acceptSettings: "Accept Cookies"
    },
    statement: {
        description: "For more detailed information on the cookies we use, please check our",
        name: "Privacy Policy",
        url: "https://www.rnib.org.uk/privacy-policy/",
        updated: "04/10/2021"
    },
    layout: "popup",
    closeStyle: "icon",
    necessaryCookies: [
        "rnibTCsConsent",
        "rnibCurrentState"
    ],
    notifyDismissControl: false,
    notifyDismissButton: false,
    branding: {
        fontSize: "1.7vh",
        fontSizeTitle: "1em",
        fontSizeHeaders: "1em",
        backgroundColor: "black",
        acceptBackground: "var(--rnib-pink)",
        rejectBackground: "#464646",
        toggleBackground: "#464646",
        toggleColor: "var(--rnib-pink)",
        acceptText: "white",
        rejectText: "white",
        removeAbout: true,
        removeIcon: true
    },
    onLoad: ()=>console.log("\uD83C\uDF6A Cookies module loaded")
};
const $34af371bd6ba8c73$export$7401ffbbc9e13226 = ()=>{
    CookieControl;
    CookieControl.load($34af371bd6ba8c73$var$config);
    return {
        setItem (key, value) {
            CookieControl.saveCookie(key, value, 90);
        },
        getItem (key) {
            return CookieControl.getCookie(key) || null;
        }
    };
};


const $640e111f3d87fcc0$var$writeStateToLocalStorage = (storage)=>(obj)=>storage.setItem("rnibCurrentState", JSON.stringify(obj));
const $640e111f3d87fcc0$var$retrieveStateFromLocalStorage = (storage)=>()=>JSON.parse(storage.getItem("rnibCurrentState")); // Let silently fail
const $640e111f3d87fcc0$var$writeTCsConsentToLocalStorage = (storage)=>(consent)=>{
        storage.setItem("rnibTCsConsent", `${consent}`);
    };
const $640e111f3d87fcc0$var$readTCsConsentFromLocalStorage = (storage)=>()=>{
        const value = storage.getItem("rnibTCsConsent");
        if (!value || !/true|false/.test(value)) return null;
        else return JSON.parse(value);
    };
const $640e111f3d87fcc0$export$6f29ef0938b12d87 = (cookiesJar)=>{
    const storage = cookiesJar !== undefined ? cookiesJar : {
        getItem: localStorage.getItem,
        setItem: localStorage.setItem
    };
    return {
        writeTCsConsentToStorage: $640e111f3d87fcc0$var$writeTCsConsentToLocalStorage(storage),
        readTCsConsentFromStorage: $640e111f3d87fcc0$var$readTCsConsentFromLocalStorage(storage),
        writeStateToStorage: $640e111f3d87fcc0$var$writeStateToLocalStorage(storage),
        retrieveStateFromStorage: $640e111f3d87fcc0$var$retrieveStateFromLocalStorage(storage)
    };
};


const $6e8d62862e42bd7e$var$introductionPage = document.querySelector(".introduction");
const $6e8d62862e42bd7e$var$heading = $6e8d62862e42bd7e$var$introductionPage?.querySelector(".introduction__body--heading");
const $6e8d62862e42bd7e$var$subheading = $6e8d62862e42bd7e$var$introductionPage?.querySelector(".introduction__body--subheading");
const $6e8d62862e42bd7e$var$permissionsPage = document?.querySelector(".permissions");
const $6e8d62862e42bd7e$var$permissionsBackButton = document?.querySelector("#permissions_back-Button");
const $6e8d62862e42bd7e$var$introductionInfo = document.querySelector(".introduction__body_information");
const $6e8d62862e42bd7e$var$introductionTCs = document.querySelector(".introduction__body_terms");
const $6e8d62862e42bd7e$var$introductionBtnsContainer = document.querySelector(".introduction__button-container");
const $6e8d62862e42bd7e$var$continueButton = $6e8d62862e42bd7e$var$introductionPage?.querySelector("#continue-button");
const $6e8d62862e42bd7e$var$permissionsContinueButton = document?.querySelector("#permissions__continue-button");
const $6e8d62862e42bd7e$var$splashScreen = document.querySelector("#splash_screen");
const $6e8d62862e42bd7e$var$mainUI = document.querySelector(".ui");
const $6e8d62862e42bd7e$var$tcsAccept = document.querySelector(".introduction_terms__buttons .button.accept");
const $6e8d62862e42bd7e$var$tcsReject = document.querySelector(".introduction_terms__buttons .button.reject");
const $6e8d62862e42bd7e$var$tcsNext = document.querySelector(".introduction__body_terms .button.next");
const $6e8d62862e42bd7e$var$tcsWarning = document.querySelector(".introduction_terms__buttons > .warning");
const $6e8d62862e42bd7e$var$setupTCsScreen = (accept)=>{
    const scrollContainer = $6e8d62862e42bd7e$var$introductionBtnsContainer.parentElement;
    scrollContainer.classList.add("overflow-scroll");
    let scrollAmount = scrollContainer.getBoundingClientRect().height * 0.9;
    let currentOffset = 0;
    let isScrolling = false;
    let warningOn = false;
    scrollContainer.addEventListener("scroll", ()=>{
        isScrolling = false;
    });
    $6e8d62862e42bd7e$var$tcsNext?.addEventListener("click", ()=>{
        if (isScrolling) return;
        isScrolling = true;
        currentOffset += scrollAmount;
        scrollContainer.scrollTo({
            top: currentOffset,
            behavior: "smooth"
        });
    });
    $6e8d62862e42bd7e$var$tcsReject?.addEventListener("click", ()=>{
        if (warningOn) window.location.reload();
        else {
            warningOn = true;
            $6e8d62862e42bd7e$var$tcsWarning?.classList.remove("hidden");
        }
    });
    $6e8d62862e42bd7e$var$tcsAccept?.addEventListener("click", ()=>{
        scrollContainer.classList.remove("overflow-scroll");
        accept();
    });
};
function $6e8d62862e42bd7e$export$2e2bcd8739ae039() {
    let experience = new (0, $8d0b21abaa4a342c$export$2e2bcd8739ae039)();
    /* Functions */ $6e8d62862e42bd7e$var$mainUI?.classList.add("hidden");
    document.body.style.padding = "var(--sat) var(--sar) var(--sab) var(--sal)";
    const storage = (0, $34af371bd6ba8c73$export$7401ffbbc9e13226)();
    const { readTCsConsentFromStorage: readTCsConsentFromStorage, writeTCsConsentToStorage: writeTCsConsentToStorage } = (0, $640e111f3d87fcc0$export$6f29ef0938b12d87)(storage);
    if (readTCsConsentFromStorage()) navigateToPage(3);
    else $6e8d62862e42bd7e$var$setupTCsScreen(()=>{
        writeTCsConsentToStorage(true);
        navigateToPage(3);
    });
    setTimeout(()=>{
        if (!$6e8d62862e42bd7e$var$splashScreen) return;
        $6e8d62862e42bd7e$var$splashScreen?.classList.add("hidden");
        $6e8d62862e42bd7e$var$splashScreen?.setAttribute("aria-hidden", "true");
    }, 500);
    function navigateToPage(pageIndex) {
        if (!$6e8d62862e42bd7e$var$heading || !$6e8d62862e42bd7e$var$subheading || !$6e8d62862e42bd7e$var$continueButton || !$6e8d62862e42bd7e$var$permissionsPage) return;
        switch(pageIndex){
            case 0:
                $6e8d62862e42bd7e$var$introductionPage?.classList.remove("hidden");
                $6e8d62862e42bd7e$var$permissionsPage?.classList.add("hidden");
                break;
            case 1:
                $6e8d62862e42bd7e$var$introductionPage?.classList.add("hidden");
                $6e8d62862e42bd7e$var$permissionsPage.style.display = "flex";
                break;
            case 2:
                $6e8d62862e42bd7e$var$permissionsPage?.classList.add("hidden");
                document.body.removeAttribute("style");
                $6e8d62862e42bd7e$var$mainUI?.classList.remove("hidden");
                (0, $a642add612de9339$export$2e2bcd8739ae039)();
                experience.startScene();
                break;
            case 3:
                $6e8d62862e42bd7e$var$introductionInfo?.classList.remove("hidden");
                $6e8d62862e42bd7e$var$introductionBtnsContainer?.classList.remove("hidden");
                $6e8d62862e42bd7e$var$introductionTCs?.classList.add("hidden");
        }
    }
    $6e8d62862e42bd7e$var$continueButton?.addEventListener("click", ()=>{
        navigateToPage(1);
    });
    $6e8d62862e42bd7e$var$permissionsBackButton?.addEventListener("click", ()=>{
        navigateToPage(0);
    });
    $6e8d62862e42bd7e$var$permissionsContinueButton?.addEventListener("click", ()=>{
        experience.getPermissions().then((0, $083eeca896bb252c$export$2e2bcd8739ae039).allowCameraAccess);
        $6e8d62862e42bd7e$var$permissionsPage.style.display = "none";
        navigateToPage(2);
    });
}


const $0656ff799c64aac2$export$5c7363e8472f2e24 = (css)=>{
    return css.match(/[0-9.]+/gi);
};
const $0656ff799c64aac2$export$66313c302b2ea154 = (errorMessage)=>{
    throw new Error(errorMessage);
};
const $0656ff799c64aac2$export$6a645c07cf2dc9cc = (val, min, max)=>min <= val && max >= val;
const $0656ff799c64aac2$export$1e4fed98bcaa1d82 = "ontouchstart" in document.documentElement ? false : true;


const $582dd4427e556d43$var$desktopPage = document?.querySelector(".desktopPage");
function $582dd4427e556d43$export$29fa9822ad4984b() {
    $582dd4427e556d43$var$desktopPage.style.display = "flex";
}


if (0, $0656ff799c64aac2$export$1e4fed98bcaa1d82) (0, $582dd4427e556d43$export$29fa9822ad4984b)();
else (0, $6e8d62862e42bd7e$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.a40cfe3e.js.map
